import { defineComponent, h, getCurrentInstance, effectScope, inject, onMounted, onUnmounted, shallowRef, ref, computed, onBeforeMount, watch, Fragment, isRef, createVNode, Text, resolveComponent, TransitionGroup, nextTick, resolveDirective, withDirectives, openBlock, createElementBlock, normalizeStyle, createBlock, normalizeClass, createSlots, withCtx, renderSlot, createCommentVNode, createTextVNode, toDisplayString as toDisplayString$1, createElementVNode, defineAsyncComponent, renderList, mergeProps, withModifiers, vShow, resolveDynamicComponent, useCssVars, toHandlers } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
var normalize = "";
/*!
  * shared v9.10.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const inBrowser = typeof window !== "undefined";
const makeSymbol = (name, shareable = false) => !shareable ? Symbol(name) : Symbol.for(name);
const generateFormatCacheKey = (locale, key, source2) => friendlyJSONstringify({ l: locale, k: key, s: source2 });
const friendlyJSONstringify = (json) => JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
const isNumber$2 = (val) => typeof val === "number" && isFinite(val);
const isDate$1 = (val) => toTypeString(val) === "[object Date]";
const isRegExp = (val) => toTypeString(val) === "[object RegExp]";
const isEmptyObject = (val) => isPlainObject$2(val) && Object.keys(val).length === 0;
const assign$2 = Object.assign;
let _globalThis;
const getGlobalThis = () => {
  return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
function escapeHtml(rawText) {
  return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty$1.call(obj, key);
}
const isArray$1 = Array.isArray;
const isFunction$2 = (val) => typeof val === "function";
const isString$3 = (val) => typeof val === "string";
const isBoolean = (val) => typeof val === "boolean";
const isObject$3 = (val) => val !== null && typeof val === "object";
const isPromise = (val) => {
  return isObject$3(val) && isFunction$2(val.then) && isFunction$2(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value) => objectToString.call(value);
const isPlainObject$2 = (val) => {
  if (!isObject$3(val))
    return false;
  const proto = Object.getPrototypeOf(val);
  return proto === null || proto.constructor === Object;
};
const toDisplayString = (val) => {
  return val == null ? "" : isArray$1(val) || isPlainObject$2(val) && val.toString === objectToString ? JSON.stringify(val, null, 2) : String(val);
};
function join$1(items, separator = "") {
  return items.reduce((str, item, index2) => index2 === 0 ? str + item : str + separator + item, "");
}
function incrementer(code2) {
  let current = code2;
  return () => ++current;
}
function warn(msg, err) {
  if (typeof console !== "undefined") {
    console.warn(`[intlify] ` + msg);
    if (err) {
      console.warn(err.stack);
    }
  }
}
const isNotObjectOrIsArray = (val) => !isObject$3(val) || isArray$1(val);
function deepCopy(src, des) {
  if (isNotObjectOrIsArray(src) || isNotObjectOrIsArray(des)) {
    throw new Error("Invalid value");
  }
  const stack = [{ src, des }];
  while (stack.length) {
    const { src: src2, des: des2 } = stack.pop();
    Object.keys(src2).forEach((key) => {
      if (isNotObjectOrIsArray(src2[key]) || isNotObjectOrIsArray(des2[key])) {
        des2[key] = src2[key];
      } else {
        stack.push({ src: src2[key], des: des2[key] });
      }
    });
  }
}
/*!
  * message-compiler v9.10.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function createPosition(line, column, offset) {
  return { line, column, offset };
}
function createLocation(start, end, source2) {
  const loc = { start, end };
  if (source2 != null) {
    loc.source = source2;
  }
  return loc;
}
const RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
function format$1(message, ...args) {
  if (args.length === 1 && isObject$2(args[0])) {
    args = args[0];
  }
  if (!args || !args.hasOwnProperty) {
    args = {};
  }
  return message.replace(RE_ARGS, (match, identifier) => {
    return args.hasOwnProperty(identifier) ? args[identifier] : "";
  });
}
const assign$1 = Object.assign;
const isString$2 = (val) => typeof val === "string";
const isObject$2 = (val) => val !== null && typeof val === "object";
function join(items, separator = "") {
  return items.reduce((str, item, index2) => index2 === 0 ? str + item : str + separator + item, "");
}
const CompileErrorCodes = {
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  __EXTEND_POINT__: 17
};
const errorMessages = {
  [CompileErrorCodes.EXPECTED_TOKEN]: `Expected token: '{0}'`,
  [CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
  [CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
  [CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
  [CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
  [CompileErrorCodes.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
  [CompileErrorCodes.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
  [CompileErrorCodes.EMPTY_PLACEHOLDER]: `Empty placeholder`,
  [CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
  [CompileErrorCodes.INVALID_LINKED_FORMAT]: `Invalid linked format`,
  [CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
  [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
  [CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
  [CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`,
  [CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE]: `unhandled codegen node type: '{0}'`,
  [CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE]: `unhandled mimifier node type: '{0}'`
};
function createCompileError(code2, loc, options = {}) {
  const { domain, messages, args } = options;
  const msg = format$1((messages || errorMessages)[code2] || "", ...args || []);
  const error = new SyntaxError(String(msg));
  error.code = code2;
  if (loc) {
    error.location = loc;
  }
  error.domain = domain;
  return error;
}
function defaultOnError(error) {
  throw error;
}
const CHAR_SP = " ";
const CHAR_CR = "\r";
const CHAR_LF = "\n";
const CHAR_LS = String.fromCharCode(8232);
const CHAR_PS = String.fromCharCode(8233);
function createScanner(str) {
  const _buf = str;
  let _index = 0;
  let _line = 1;
  let _column = 1;
  let _peekOffset = 0;
  const isCRLF = (index3) => _buf[index3] === CHAR_CR && _buf[index3 + 1] === CHAR_LF;
  const isLF = (index3) => _buf[index3] === CHAR_LF;
  const isPS = (index3) => _buf[index3] === CHAR_PS;
  const isLS = (index3) => _buf[index3] === CHAR_LS;
  const isLineEnd = (index3) => isCRLF(index3) || isLF(index3) || isPS(index3) || isLS(index3);
  const index2 = () => _index;
  const line = () => _line;
  const column = () => _column;
  const peekOffset = () => _peekOffset;
  const charAt = (offset) => isCRLF(offset) || isPS(offset) || isLS(offset) ? CHAR_LF : _buf[offset];
  const currentChar = () => charAt(_index);
  const currentPeek = () => charAt(_index + _peekOffset);
  function next2() {
    _peekOffset = 0;
    if (isLineEnd(_index)) {
      _line++;
      _column = 0;
    }
    if (isCRLF(_index)) {
      _index++;
    }
    _index++;
    _column++;
    return _buf[_index];
  }
  function peek() {
    if (isCRLF(_index + _peekOffset)) {
      _peekOffset++;
    }
    _peekOffset++;
    return _buf[_index + _peekOffset];
  }
  function reset2() {
    _index = 0;
    _line = 1;
    _column = 1;
    _peekOffset = 0;
  }
  function resetPeek(offset = 0) {
    _peekOffset = offset;
  }
  function skipToPeek() {
    const target = _index + _peekOffset;
    while (target !== _index) {
      next2();
    }
    _peekOffset = 0;
  }
  return {
    index: index2,
    line,
    column,
    peekOffset,
    charAt,
    currentChar,
    currentPeek,
    next: next2,
    peek,
    reset: reset2,
    resetPeek,
    skipToPeek
  };
}
const EOF = void 0;
const DOT = ".";
const LITERAL_DELIMITER = "'";
const ERROR_DOMAIN$3 = "tokenizer";
function createTokenizer(source2, options = {}) {
  const location = options.location !== false;
  const _scnr = createScanner(source2);
  const currentOffset = () => _scnr.index();
  const currentPosition = () => createPosition(_scnr.line(), _scnr.column(), _scnr.index());
  const _initLoc = currentPosition();
  const _initOffset = currentOffset();
  const _context = {
    currentType: 14,
    offset: _initOffset,
    startLoc: _initLoc,
    endLoc: _initLoc,
    lastType: 14,
    lastOffset: _initOffset,
    lastStartLoc: _initLoc,
    lastEndLoc: _initLoc,
    braceNest: 0,
    inLinked: false,
    text: ""
  };
  const context = () => _context;
  const { onError } = options;
  function emitError(code2, pos, offset, ...args) {
    const ctx = context();
    pos.column += offset;
    pos.offset += offset;
    if (onError) {
      const loc = location ? createLocation(ctx.startLoc, pos) : null;
      const err = createCompileError(code2, loc, {
        domain: ERROR_DOMAIN$3,
        args
      });
      onError(err);
    }
  }
  function getToken(context2, type, value) {
    context2.endLoc = currentPosition();
    context2.currentType = type;
    const token = { type };
    if (location) {
      token.loc = createLocation(context2.startLoc, context2.endLoc);
    }
    if (value != null) {
      token.value = value;
    }
    return token;
  }
  const getEndToken = (context2) => getToken(context2, 14);
  function eat(scnr, ch) {
    if (scnr.currentChar() === ch) {
      scnr.next();
      return ch;
    } else {
      emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
      return "";
    }
  }
  function peekSpaces(scnr) {
    let buf = "";
    while (scnr.currentPeek() === CHAR_SP || scnr.currentPeek() === CHAR_LF) {
      buf += scnr.currentPeek();
      scnr.peek();
    }
    return buf;
  }
  function skipSpaces(scnr) {
    const buf = peekSpaces(scnr);
    scnr.skipToPeek();
    return buf;
  }
  function isIdentifierStart(ch) {
    if (ch === EOF) {
      return false;
    }
    const cc = ch.charCodeAt(0);
    return cc >= 97 && cc <= 122 || cc >= 65 && cc <= 90 || cc === 95;
  }
  function isNumberStart(ch) {
    if (ch === EOF) {
      return false;
    }
    const cc = ch.charCodeAt(0);
    return cc >= 48 && cc <= 57;
  }
  function isNamedIdentifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2) {
      return false;
    }
    peekSpaces(scnr);
    const ret = isIdentifierStart(scnr.currentPeek());
    scnr.resetPeek();
    return ret;
  }
  function isListIdentifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2) {
      return false;
    }
    peekSpaces(scnr);
    const ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
    const ret = isNumberStart(ch);
    scnr.resetPeek();
    return ret;
  }
  function isLiteralStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 2) {
      return false;
    }
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === LITERAL_DELIMITER;
    scnr.resetPeek();
    return ret;
  }
  function isLinkedDotStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 8) {
      return false;
    }
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === ".";
    scnr.resetPeek();
    return ret;
  }
  function isLinkedModifierStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 9) {
      return false;
    }
    peekSpaces(scnr);
    const ret = isIdentifierStart(scnr.currentPeek());
    scnr.resetPeek();
    return ret;
  }
  function isLinkedDelimiterStart(scnr, context2) {
    const { currentType } = context2;
    if (!(currentType === 8 || currentType === 12)) {
      return false;
    }
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === ":";
    scnr.resetPeek();
    return ret;
  }
  function isLinkedReferStart(scnr, context2) {
    const { currentType } = context2;
    if (currentType !== 10) {
      return false;
    }
    const fn = () => {
      const ch = scnr.currentPeek();
      if (ch === "{") {
        return isIdentifierStart(scnr.peek());
      } else if (ch === "@" || ch === "%" || ch === "|" || ch === ":" || ch === "." || ch === CHAR_SP || !ch) {
        return false;
      } else if (ch === CHAR_LF) {
        scnr.peek();
        return fn();
      } else {
        return isIdentifierStart(ch);
      }
    };
    const ret = fn();
    scnr.resetPeek();
    return ret;
  }
  function isPluralStart(scnr) {
    peekSpaces(scnr);
    const ret = scnr.currentPeek() === "|";
    scnr.resetPeek();
    return ret;
  }
  function detectModuloStart(scnr) {
    const spaces = peekSpaces(scnr);
    const ret = scnr.currentPeek() === "%" && scnr.peek() === "{";
    scnr.resetPeek();
    return {
      isModulo: ret,
      hasSpace: spaces.length > 0
    };
  }
  function isTextStart(scnr, reset2 = true) {
    const fn = (hasSpace = false, prev2 = "", detectModulo = false) => {
      const ch = scnr.currentPeek();
      if (ch === "{") {
        return prev2 === "%" ? false : hasSpace;
      } else if (ch === "@" || !ch) {
        return prev2 === "%" ? true : hasSpace;
      } else if (ch === "%") {
        scnr.peek();
        return fn(hasSpace, "%", true);
      } else if (ch === "|") {
        return prev2 === "%" || detectModulo ? true : !(prev2 === CHAR_SP || prev2 === CHAR_LF);
      } else if (ch === CHAR_SP) {
        scnr.peek();
        return fn(true, CHAR_SP, detectModulo);
      } else if (ch === CHAR_LF) {
        scnr.peek();
        return fn(true, CHAR_LF, detectModulo);
      } else {
        return true;
      }
    };
    const ret = fn();
    reset2 && scnr.resetPeek();
    return ret;
  }
  function takeChar(scnr, fn) {
    const ch = scnr.currentChar();
    if (ch === EOF) {
      return EOF;
    }
    if (fn(ch)) {
      scnr.next();
      return ch;
    }
    return null;
  }
  function takeIdentifierChar(scnr) {
    const closure = (ch) => {
      const cc = ch.charCodeAt(0);
      return cc >= 97 && cc <= 122 || cc >= 65 && cc <= 90 || cc >= 48 && cc <= 57 || cc === 95 || cc === 36;
    };
    return takeChar(scnr, closure);
  }
  function takeDigit(scnr) {
    const closure = (ch) => {
      const cc = ch.charCodeAt(0);
      return cc >= 48 && cc <= 57;
    };
    return takeChar(scnr, closure);
  }
  function takeHexDigit(scnr) {
    const closure = (ch) => {
      const cc = ch.charCodeAt(0);
      return cc >= 48 && cc <= 57 || cc >= 65 && cc <= 70 || cc >= 97 && cc <= 102;
    };
    return takeChar(scnr, closure);
  }
  function getDigits(scnr) {
    let ch = "";
    let num = "";
    while (ch = takeDigit(scnr)) {
      num += ch;
    }
    return num;
  }
  function readModulo(scnr) {
    skipSpaces(scnr);
    const ch = scnr.currentChar();
    if (ch !== "%") {
      emitError(CompileErrorCodes.EXPECTED_TOKEN, currentPosition(), 0, ch);
    }
    scnr.next();
    return "%";
  }
  function readText(scnr) {
    let buf = "";
    while (true) {
      const ch = scnr.currentChar();
      if (ch === "{" || ch === "}" || ch === "@" || ch === "|" || !ch) {
        break;
      } else if (ch === "%") {
        if (isTextStart(scnr)) {
          buf += ch;
          scnr.next();
        } else {
          break;
        }
      } else if (ch === CHAR_SP || ch === CHAR_LF) {
        if (isTextStart(scnr)) {
          buf += ch;
          scnr.next();
        } else if (isPluralStart(scnr)) {
          break;
        } else {
          buf += ch;
          scnr.next();
        }
      } else {
        buf += ch;
        scnr.next();
      }
    }
    return buf;
  }
  function readNamedIdentifier(scnr) {
    skipSpaces(scnr);
    let ch = "";
    let name = "";
    while (ch = takeIdentifierChar(scnr)) {
      name += ch;
    }
    if (scnr.currentChar() === EOF) {
      emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
    }
    return name;
  }
  function readListIdentifier(scnr) {
    skipSpaces(scnr);
    let value = "";
    if (scnr.currentChar() === "-") {
      scnr.next();
      value += `-${getDigits(scnr)}`;
    } else {
      value += getDigits(scnr);
    }
    if (scnr.currentChar() === EOF) {
      emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
    }
    return value;
  }
  function readLiteral(scnr) {
    skipSpaces(scnr);
    eat(scnr, `'`);
    let ch = "";
    let literal = "";
    const fn = (x) => x !== LITERAL_DELIMITER && x !== CHAR_LF;
    while (ch = takeChar(scnr, fn)) {
      if (ch === "\\") {
        literal += readEscapeSequence(scnr);
      } else {
        literal += ch;
      }
    }
    const current = scnr.currentChar();
    if (current === CHAR_LF || current === EOF) {
      emitError(CompileErrorCodes.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
      if (current === CHAR_LF) {
        scnr.next();
        eat(scnr, `'`);
      }
      return literal;
    }
    eat(scnr, `'`);
    return literal;
  }
  function readEscapeSequence(scnr) {
    const ch = scnr.currentChar();
    switch (ch) {
      case "\\":
      case `'`:
        scnr.next();
        return `\\${ch}`;
      case "u":
        return readUnicodeEscapeSequence(scnr, ch, 4);
      case "U":
        return readUnicodeEscapeSequence(scnr, ch, 6);
      default:
        emitError(CompileErrorCodes.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
        return "";
    }
  }
  function readUnicodeEscapeSequence(scnr, unicode, digits) {
    eat(scnr, unicode);
    let sequence = "";
    for (let i = 0; i < digits; i++) {
      const ch = takeHexDigit(scnr);
      if (!ch) {
        emitError(CompileErrorCodes.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
        break;
      }
      sequence += ch;
    }
    return `\\${unicode}${sequence}`;
  }
  function readInvalidIdentifier(scnr) {
    skipSpaces(scnr);
    let ch = "";
    let identifiers = "";
    const closure = (ch2) => ch2 !== "{" && ch2 !== "}" && ch2 !== CHAR_SP && ch2 !== CHAR_LF;
    while (ch = takeChar(scnr, closure)) {
      identifiers += ch;
    }
    return identifiers;
  }
  function readLinkedModifier(scnr) {
    let ch = "";
    let name = "";
    while (ch = takeIdentifierChar(scnr)) {
      name += ch;
    }
    return name;
  }
  function readLinkedRefer(scnr) {
    const fn = (detect = false, buf) => {
      const ch = scnr.currentChar();
      if (ch === "{" || ch === "%" || ch === "@" || ch === "|" || ch === "(" || ch === ")" || !ch) {
        return buf;
      } else if (ch === CHAR_SP) {
        return buf;
      } else if (ch === CHAR_LF || ch === DOT) {
        buf += ch;
        scnr.next();
        return fn(detect, buf);
      } else {
        buf += ch;
        scnr.next();
        return fn(true, buf);
      }
    };
    return fn(false, "");
  }
  function readPlural(scnr) {
    skipSpaces(scnr);
    const plural = eat(scnr, "|");
    skipSpaces(scnr);
    return plural;
  }
  function readTokenInPlaceholder(scnr, context2) {
    let token = null;
    const ch = scnr.currentChar();
    switch (ch) {
      case "{":
        if (context2.braceNest >= 1) {
          emitError(CompileErrorCodes.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
        }
        scnr.next();
        token = getToken(context2, 2, "{");
        skipSpaces(scnr);
        context2.braceNest++;
        return token;
      case "}":
        if (context2.braceNest > 0 && context2.currentType === 2) {
          emitError(CompileErrorCodes.EMPTY_PLACEHOLDER, currentPosition(), 0);
        }
        scnr.next();
        token = getToken(context2, 3, "}");
        context2.braceNest--;
        context2.braceNest > 0 && skipSpaces(scnr);
        if (context2.inLinked && context2.braceNest === 0) {
          context2.inLinked = false;
        }
        return token;
      case "@":
        if (context2.braceNest > 0) {
          emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        }
        token = readTokenInLinked(scnr, context2) || getEndToken(context2);
        context2.braceNest = 0;
        return token;
      default: {
        let validNamedIdentifier = true;
        let validListIdentifier = true;
        let validLiteral = true;
        if (isPluralStart(scnr)) {
          if (context2.braceNest > 0) {
            emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
          }
          token = getToken(context2, 1, readPlural(scnr));
          context2.braceNest = 0;
          context2.inLinked = false;
          return token;
        }
        if (context2.braceNest > 0 && (context2.currentType === 5 || context2.currentType === 6 || context2.currentType === 7)) {
          emitError(CompileErrorCodes.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
          context2.braceNest = 0;
          return readToken(scnr, context2);
        }
        if (validNamedIdentifier = isNamedIdentifierStart(scnr, context2)) {
          token = getToken(context2, 5, readNamedIdentifier(scnr));
          skipSpaces(scnr);
          return token;
        }
        if (validListIdentifier = isListIdentifierStart(scnr, context2)) {
          token = getToken(context2, 6, readListIdentifier(scnr));
          skipSpaces(scnr);
          return token;
        }
        if (validLiteral = isLiteralStart(scnr, context2)) {
          token = getToken(context2, 7, readLiteral(scnr));
          skipSpaces(scnr);
          return token;
        }
        if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
          token = getToken(context2, 13, readInvalidIdentifier(scnr));
          emitError(CompileErrorCodes.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
          skipSpaces(scnr);
          return token;
        }
        break;
      }
    }
    return token;
  }
  function readTokenInLinked(scnr, context2) {
    const { currentType } = context2;
    let token = null;
    const ch = scnr.currentChar();
    if ((currentType === 8 || currentType === 9 || currentType === 12 || currentType === 10) && (ch === CHAR_LF || ch === CHAR_SP)) {
      emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
    }
    switch (ch) {
      case "@":
        scnr.next();
        token = getToken(context2, 8, "@");
        context2.inLinked = true;
        return token;
      case ".":
        skipSpaces(scnr);
        scnr.next();
        return getToken(context2, 9, ".");
      case ":":
        skipSpaces(scnr);
        scnr.next();
        return getToken(context2, 10, ":");
      default:
        if (isPluralStart(scnr)) {
          token = getToken(context2, 1, readPlural(scnr));
          context2.braceNest = 0;
          context2.inLinked = false;
          return token;
        }
        if (isLinkedDotStart(scnr, context2) || isLinkedDelimiterStart(scnr, context2)) {
          skipSpaces(scnr);
          return readTokenInLinked(scnr, context2);
        }
        if (isLinkedModifierStart(scnr, context2)) {
          skipSpaces(scnr);
          return getToken(context2, 12, readLinkedModifier(scnr));
        }
        if (isLinkedReferStart(scnr, context2)) {
          skipSpaces(scnr);
          if (ch === "{") {
            return readTokenInPlaceholder(scnr, context2) || token;
          } else {
            return getToken(context2, 11, readLinkedRefer(scnr));
          }
        }
        if (currentType === 8) {
          emitError(CompileErrorCodes.INVALID_LINKED_FORMAT, currentPosition(), 0);
        }
        context2.braceNest = 0;
        context2.inLinked = false;
        return readToken(scnr, context2);
    }
  }
  function readToken(scnr, context2) {
    let token = { type: 14 };
    if (context2.braceNest > 0) {
      return readTokenInPlaceholder(scnr, context2) || getEndToken(context2);
    }
    if (context2.inLinked) {
      return readTokenInLinked(scnr, context2) || getEndToken(context2);
    }
    const ch = scnr.currentChar();
    switch (ch) {
      case "{":
        return readTokenInPlaceholder(scnr, context2) || getEndToken(context2);
      case "}":
        emitError(CompileErrorCodes.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
        scnr.next();
        return getToken(context2, 3, "}");
      case "@":
        return readTokenInLinked(scnr, context2) || getEndToken(context2);
      default: {
        if (isPluralStart(scnr)) {
          token = getToken(context2, 1, readPlural(scnr));
          context2.braceNest = 0;
          context2.inLinked = false;
          return token;
        }
        const { isModulo, hasSpace } = detectModuloStart(scnr);
        if (isModulo) {
          return hasSpace ? getToken(context2, 0, readText(scnr)) : getToken(context2, 4, readModulo(scnr));
        }
        if (isTextStart(scnr)) {
          return getToken(context2, 0, readText(scnr));
        }
        break;
      }
    }
    return token;
  }
  function nextToken() {
    const { currentType, offset, startLoc, endLoc } = _context;
    _context.lastType = currentType;
    _context.lastOffset = offset;
    _context.lastStartLoc = startLoc;
    _context.lastEndLoc = endLoc;
    _context.offset = currentOffset();
    _context.startLoc = currentPosition();
    if (_scnr.currentChar() === EOF) {
      return getToken(_context, 14);
    }
    return readToken(_scnr, _context);
  }
  return {
    nextToken,
    currentOffset,
    currentPosition,
    context
  };
}
const ERROR_DOMAIN$2 = "parser";
const KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function fromEscapeSequence(match, codePoint4, codePoint6) {
  switch (match) {
    case `\\\\`:
      return `\\`;
    case `\\'`:
      return `'`;
    default: {
      const codePoint = parseInt(codePoint4 || codePoint6, 16);
      if (codePoint <= 55295 || codePoint >= 57344) {
        return String.fromCodePoint(codePoint);
      }
      return "\uFFFD";
    }
  }
}
function createParser(options = {}) {
  const location = options.location !== false;
  const { onError } = options;
  function emitError(tokenzer, code2, start, offset, ...args) {
    const end = tokenzer.currentPosition();
    end.offset += offset;
    end.column += offset;
    if (onError) {
      const loc = location ? createLocation(start, end) : null;
      const err = createCompileError(code2, loc, {
        domain: ERROR_DOMAIN$2,
        args
      });
      onError(err);
    }
  }
  function startNode(type, offset, loc) {
    const node = { type };
    if (location) {
      node.start = offset;
      node.end = offset;
      node.loc = { start: loc, end: loc };
    }
    return node;
  }
  function endNode(node, offset, pos, type) {
    if (type) {
      node.type = type;
    }
    if (location) {
      node.end = offset;
      if (node.loc) {
        node.loc.end = pos;
      }
    }
  }
  function parseText(tokenizer, value) {
    const context = tokenizer.context();
    const node = startNode(3, context.offset, context.startLoc);
    node.value = value;
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseList(tokenizer, index2) {
    const context = tokenizer.context();
    const { lastOffset: offset, lastStartLoc: loc } = context;
    const node = startNode(5, offset, loc);
    node.index = parseInt(index2, 10);
    tokenizer.nextToken();
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseNamed(tokenizer, key) {
    const context = tokenizer.context();
    const { lastOffset: offset, lastStartLoc: loc } = context;
    const node = startNode(4, offset, loc);
    node.key = key;
    tokenizer.nextToken();
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseLiteral(tokenizer, value) {
    const context = tokenizer.context();
    const { lastOffset: offset, lastStartLoc: loc } = context;
    const node = startNode(9, offset, loc);
    node.value = value.replace(KNOWN_ESCAPES, fromEscapeSequence);
    tokenizer.nextToken();
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseLinkedModifier(tokenizer) {
    const token = tokenizer.nextToken();
    const context = tokenizer.context();
    const { lastOffset: offset, lastStartLoc: loc } = context;
    const node = startNode(8, offset, loc);
    if (token.type !== 12) {
      emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
      node.value = "";
      endNode(node, offset, loc);
      return {
        nextConsumeToken: token,
        node
      };
    }
    if (token.value == null) {
      emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
    }
    node.value = token.value || "";
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return {
      node
    };
  }
  function parseLinkedKey(tokenizer, value) {
    const context = tokenizer.context();
    const node = startNode(7, context.offset, context.startLoc);
    node.value = value;
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseLinked(tokenizer) {
    const context = tokenizer.context();
    const linkedNode = startNode(6, context.offset, context.startLoc);
    let token = tokenizer.nextToken();
    if (token.type === 9) {
      const parsed = parseLinkedModifier(tokenizer);
      linkedNode.modifier = parsed.node;
      token = parsed.nextConsumeToken || tokenizer.nextToken();
    }
    if (token.type !== 10) {
      emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
    }
    token = tokenizer.nextToken();
    if (token.type === 2) {
      token = tokenizer.nextToken();
    }
    switch (token.type) {
      case 11:
        if (token.value == null) {
          emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
        break;
      case 5:
        if (token.value == null) {
          emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        linkedNode.key = parseNamed(tokenizer, token.value || "");
        break;
      case 6:
        if (token.value == null) {
          emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        linkedNode.key = parseList(tokenizer, token.value || "");
        break;
      case 7:
        if (token.value == null) {
          emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
        }
        linkedNode.key = parseLiteral(tokenizer, token.value || "");
        break;
      default: {
        emitError(tokenizer, CompileErrorCodes.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
        const nextContext = tokenizer.context();
        const emptyLinkedKeyNode = startNode(7, nextContext.offset, nextContext.startLoc);
        emptyLinkedKeyNode.value = "";
        endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
        linkedNode.key = emptyLinkedKeyNode;
        endNode(linkedNode, nextContext.offset, nextContext.startLoc);
        return {
          nextConsumeToken: token,
          node: linkedNode
        };
      }
    }
    endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
    return {
      node: linkedNode
    };
  }
  function parseMessage(tokenizer) {
    const context = tokenizer.context();
    const startOffset = context.currentType === 1 ? tokenizer.currentOffset() : context.offset;
    const startLoc = context.currentType === 1 ? context.endLoc : context.startLoc;
    const node = startNode(2, startOffset, startLoc);
    node.items = [];
    let nextToken = null;
    do {
      const token = nextToken || tokenizer.nextToken();
      nextToken = null;
      switch (token.type) {
        case 0:
          if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
          }
          node.items.push(parseText(tokenizer, token.value || ""));
          break;
        case 6:
          if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
          }
          node.items.push(parseList(tokenizer, token.value || ""));
          break;
        case 5:
          if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
          }
          node.items.push(parseNamed(tokenizer, token.value || ""));
          break;
        case 7:
          if (token.value == null) {
            emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, getTokenCaption(token));
          }
          node.items.push(parseLiteral(tokenizer, token.value || ""));
          break;
        case 8: {
          const parsed = parseLinked(tokenizer);
          node.items.push(parsed.node);
          nextToken = parsed.nextConsumeToken || null;
          break;
        }
      }
    } while (context.currentType !== 14 && context.currentType !== 1);
    const endOffset = context.currentType === 1 ? context.lastOffset : tokenizer.currentOffset();
    const endLoc = context.currentType === 1 ? context.lastEndLoc : tokenizer.currentPosition();
    endNode(node, endOffset, endLoc);
    return node;
  }
  function parsePlural(tokenizer, offset, loc, msgNode) {
    const context = tokenizer.context();
    let hasEmptyMessage = msgNode.items.length === 0;
    const node = startNode(1, offset, loc);
    node.cases = [];
    node.cases.push(msgNode);
    do {
      const msg = parseMessage(tokenizer);
      if (!hasEmptyMessage) {
        hasEmptyMessage = msg.items.length === 0;
      }
      node.cases.push(msg);
    } while (context.currentType !== 14);
    if (hasEmptyMessage) {
      emitError(tokenizer, CompileErrorCodes.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
    }
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  function parseResource(tokenizer) {
    const context = tokenizer.context();
    const { offset, startLoc } = context;
    const msgNode = parseMessage(tokenizer);
    if (context.currentType === 14) {
      return msgNode;
    } else {
      return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
  }
  function parse2(source2) {
    const tokenizer = createTokenizer(source2, assign$1({}, options));
    const context = tokenizer.context();
    const node = startNode(0, context.offset, context.startLoc);
    if (location && node.loc) {
      node.loc.source = source2;
    }
    node.body = parseResource(tokenizer);
    if (options.onCacheKey) {
      node.cacheKey = options.onCacheKey(source2);
    }
    if (context.currentType !== 14) {
      emitError(tokenizer, CompileErrorCodes.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source2[context.offset] || "");
    }
    endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
    return node;
  }
  return { parse: parse2 };
}
function getTokenCaption(token) {
  if (token.type === 14) {
    return "EOF";
  }
  const name = (token.value || "").replace(/\r?\n/gu, "\\n");
  return name.length > 10 ? name.slice(0, 9) + "\u2026" : name;
}
function createTransformer(ast, options = {}) {
  const _context = {
    ast,
    helpers: /* @__PURE__ */ new Set()
  };
  const context = () => _context;
  const helper = (name) => {
    _context.helpers.add(name);
    return name;
  };
  return { context, helper };
}
function traverseNodes(nodes, transformer) {
  for (let i = 0; i < nodes.length; i++) {
    traverseNode(nodes[i], transformer);
  }
}
function traverseNode(node, transformer) {
  switch (node.type) {
    case 1:
      traverseNodes(node.cases, transformer);
      transformer.helper("plural");
      break;
    case 2:
      traverseNodes(node.items, transformer);
      break;
    case 6: {
      const linked = node;
      traverseNode(linked.key, transformer);
      transformer.helper("linked");
      transformer.helper("type");
      break;
    }
    case 5:
      transformer.helper("interpolate");
      transformer.helper("list");
      break;
    case 4:
      transformer.helper("interpolate");
      transformer.helper("named");
      break;
  }
}
function transform(ast, options = {}) {
  const transformer = createTransformer(ast);
  transformer.helper("normalize");
  ast.body && traverseNode(ast.body, transformer);
  const context = transformer.context();
  ast.helpers = Array.from(context.helpers);
}
function optimize(ast) {
  const body = ast.body;
  if (body.type === 2) {
    optimizeMessageNode(body);
  } else {
    body.cases.forEach((c) => optimizeMessageNode(c));
  }
  return ast;
}
function optimizeMessageNode(message) {
  if (message.items.length === 1) {
    const item = message.items[0];
    if (item.type === 3 || item.type === 9) {
      message.static = item.value;
      delete item.value;
    }
  } else {
    const values = [];
    for (let i = 0; i < message.items.length; i++) {
      const item = message.items[i];
      if (!(item.type === 3 || item.type === 9)) {
        break;
      }
      if (item.value == null) {
        break;
      }
      values.push(item.value);
    }
    if (values.length === message.items.length) {
      message.static = join(values);
      for (let i = 0; i < message.items.length; i++) {
        const item = message.items[i];
        if (item.type === 3 || item.type === 9) {
          delete item.value;
        }
      }
    }
  }
}
const ERROR_DOMAIN$1 = "minifier";
function minify(node) {
  node.t = node.type;
  switch (node.type) {
    case 0: {
      const resource = node;
      minify(resource.body);
      resource.b = resource.body;
      delete resource.body;
      break;
    }
    case 1: {
      const plural = node;
      const cases = plural.cases;
      for (let i = 0; i < cases.length; i++) {
        minify(cases[i]);
      }
      plural.c = cases;
      delete plural.cases;
      break;
    }
    case 2: {
      const message = node;
      const items = message.items;
      for (let i = 0; i < items.length; i++) {
        minify(items[i]);
      }
      message.i = items;
      delete message.items;
      if (message.static) {
        message.s = message.static;
        delete message.static;
      }
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const valueNode = node;
      if (valueNode.value) {
        valueNode.v = valueNode.value;
        delete valueNode.value;
      }
      break;
    }
    case 6: {
      const linked = node;
      minify(linked.key);
      linked.k = linked.key;
      delete linked.key;
      if (linked.modifier) {
        minify(linked.modifier);
        linked.m = linked.modifier;
        delete linked.modifier;
      }
      break;
    }
    case 5: {
      const list = node;
      list.i = list.index;
      delete list.index;
      break;
    }
    case 4: {
      const named = node;
      named.k = named.key;
      delete named.key;
      break;
    }
    default: {
      throw createCompileError(CompileErrorCodes.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: ERROR_DOMAIN$1,
        args: [node.type]
      });
    }
  }
  delete node.type;
}
const ERROR_DOMAIN = "parser";
function createCodeGenerator(ast, options) {
  const { sourceMap, filename, breakLineCode, needIndent: _needIndent } = options;
  const location = options.location !== false;
  const _context = {
    filename,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode,
    needIndent: _needIndent,
    indentLevel: 0
  };
  if (location && ast.loc) {
    _context.source = ast.loc.source;
  }
  const context = () => _context;
  function push(code2, node) {
    _context.code += code2;
  }
  function _newline(n, withBreakLine = true) {
    const _breakLineCode = withBreakLine ? breakLineCode : "";
    push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
  }
  function indent(withNewLine = true) {
    const level = ++_context.indentLevel;
    withNewLine && _newline(level);
  }
  function deindent(withNewLine = true) {
    const level = --_context.indentLevel;
    withNewLine && _newline(level);
  }
  function newline() {
    _newline(_context.indentLevel);
  }
  const helper = (key) => `_${key}`;
  const needIndent = () => _context.needIndent;
  return {
    context,
    push,
    indent,
    deindent,
    newline,
    helper,
    needIndent
  };
}
function generateLinkedNode(generator, node) {
  const { helper } = generator;
  generator.push(`${helper("linked")}(`);
  generateNode(generator, node.key);
  if (node.modifier) {
    generator.push(`, `);
    generateNode(generator, node.modifier);
    generator.push(`, _type`);
  } else {
    generator.push(`, undefined, _type`);
  }
  generator.push(`)`);
}
function generateMessageNode(generator, node) {
  const { helper, needIndent } = generator;
  generator.push(`${helper("normalize")}([`);
  generator.indent(needIndent());
  const length = node.items.length;
  for (let i = 0; i < length; i++) {
    generateNode(generator, node.items[i]);
    if (i === length - 1) {
      break;
    }
    generator.push(", ");
  }
  generator.deindent(needIndent());
  generator.push("])");
}
function generatePluralNode(generator, node) {
  const { helper, needIndent } = generator;
  if (node.cases.length > 1) {
    generator.push(`${helper("plural")}([`);
    generator.indent(needIndent());
    const length = node.cases.length;
    for (let i = 0; i < length; i++) {
      generateNode(generator, node.cases[i]);
      if (i === length - 1) {
        break;
      }
      generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push(`])`);
  }
}
function generateResource(generator, node) {
  if (node.body) {
    generateNode(generator, node.body);
  } else {
    generator.push("null");
  }
}
function generateNode(generator, node) {
  const { helper } = generator;
  switch (node.type) {
    case 0:
      generateResource(generator, node);
      break;
    case 1:
      generatePluralNode(generator, node);
      break;
    case 2:
      generateMessageNode(generator, node);
      break;
    case 6:
      generateLinkedNode(generator, node);
      break;
    case 8:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 7:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 5:
      generator.push(`${helper("interpolate")}(${helper("list")}(${node.index}))`, node);
      break;
    case 4:
      generator.push(`${helper("interpolate")}(${helper("named")}(${JSON.stringify(node.key)}))`, node);
      break;
    case 9:
      generator.push(JSON.stringify(node.value), node);
      break;
    case 3:
      generator.push(JSON.stringify(node.value), node);
      break;
    default: {
      throw createCompileError(CompileErrorCodes.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: ERROR_DOMAIN,
        args: [node.type]
      });
    }
  }
}
const generate = (ast, options = {}) => {
  const mode = isString$2(options.mode) ? options.mode : "normal";
  const filename = isString$2(options.filename) ? options.filename : "message.intl";
  const sourceMap = !!options.sourceMap;
  const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
  const needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
  const helpers = ast.helpers || [];
  const generator = createCodeGenerator(ast, {
    mode,
    filename,
    sourceMap,
    breakLineCode,
    needIndent
  });
  generator.push(mode === "normal" ? `function __msg__ (ctx) {` : `(ctx) => {`);
  generator.indent(needIndent);
  if (helpers.length > 0) {
    generator.push(`const { ${join(helpers.map((s) => `${s}: _${s}`), ", ")} } = ctx`);
    generator.newline();
  }
  generator.push(`return `);
  generateNode(generator, ast);
  generator.deindent(needIndent);
  generator.push(`}`);
  delete ast.helpers;
  const { code: code2, map } = generator.context();
  return {
    ast,
    code: code2,
    map: map ? map.toJSON() : void 0
  };
};
function baseCompile$1(source2, options = {}) {
  const assignedOptions = assign$1({}, options);
  const jit = !!assignedOptions.jit;
  const enalbeMinify = !!assignedOptions.minify;
  const enambeOptimize = assignedOptions.optimize == null ? true : assignedOptions.optimize;
  const parser = createParser(assignedOptions);
  const ast = parser.parse(source2);
  if (!jit) {
    transform(ast, assignedOptions);
    return generate(ast, assignedOptions);
  } else {
    enambeOptimize && optimize(ast);
    enalbeMinify && minify(ast);
    return { ast, code: "" };
  }
}
/*!
  * core-base v9.10.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function initFeatureFlags$1() {
  if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") {
    getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
  }
  if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") {
    getGlobalThis().__INTLIFY_JIT_COMPILATION__ = false;
  }
  if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") {
    getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
  }
}
const pathStateMachine = [];
pathStateMachine[0] = {
  ["w"]: [0],
  ["i"]: [3, 0],
  ["["]: [4],
  ["o"]: [7]
};
pathStateMachine[1] = {
  ["w"]: [1],
  ["."]: [2],
  ["["]: [4],
  ["o"]: [7]
};
pathStateMachine[2] = {
  ["w"]: [2],
  ["i"]: [3, 0],
  ["0"]: [3, 0]
};
pathStateMachine[3] = {
  ["i"]: [3, 0],
  ["0"]: [3, 0],
  ["w"]: [1, 1],
  ["."]: [2, 1],
  ["["]: [4, 1],
  ["o"]: [7, 1]
};
pathStateMachine[4] = {
  ["'"]: [5, 0],
  ['"']: [6, 0],
  ["["]: [
    4,
    2
  ],
  ["]"]: [1, 3],
  ["o"]: 8,
  ["l"]: [4, 0]
};
pathStateMachine[5] = {
  ["'"]: [4, 0],
  ["o"]: 8,
  ["l"]: [5, 0]
};
pathStateMachine[6] = {
  ['"']: [4, 0],
  ["o"]: 8,
  ["l"]: [6, 0]
};
const literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral(exp) {
  return literalValueRE.test(exp);
}
function stripQuotes(str) {
  const a = str.charCodeAt(0);
  const b = str.charCodeAt(str.length - 1);
  return a === b && (a === 34 || a === 39) ? str.slice(1, -1) : str;
}
function getPathCharType(ch) {
  if (ch === void 0 || ch === null) {
    return "o";
  }
  const code2 = ch.charCodeAt(0);
  switch (code2) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return ch;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function formatSubPath(path) {
  const trimmed = path.trim();
  if (path.charAt(0) === "0" && isNaN(parseInt(path))) {
    return false;
  }
  return isLiteral(trimmed) ? stripQuotes(trimmed) : "*" + trimmed;
}
function parse(path) {
  const keys = [];
  let index2 = -1;
  let mode = 0;
  let subPathDepth = 0;
  let c;
  let key;
  let newChar;
  let type;
  let transition;
  let action;
  let typeMap;
  const actions = [];
  actions[0] = () => {
    if (key === void 0) {
      key = newChar;
    } else {
      key += newChar;
    }
  };
  actions[1] = () => {
    if (key !== void 0) {
      keys.push(key);
      key = void 0;
    }
  };
  actions[2] = () => {
    actions[0]();
    subPathDepth++;
  };
  actions[3] = () => {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = 4;
      actions[0]();
    } else {
      subPathDepth = 0;
      if (key === void 0) {
        return false;
      }
      key = formatSubPath(key);
      if (key === false) {
        return false;
      } else {
        actions[1]();
      }
    }
  };
  function maybeUnescapeQuote() {
    const nextChar = path[index2 + 1];
    if (mode === 5 && nextChar === "'" || mode === 6 && nextChar === '"') {
      index2++;
      newChar = "\\" + nextChar;
      actions[0]();
      return true;
    }
  }
  while (mode !== null) {
    index2++;
    c = path[index2];
    if (c === "\\" && maybeUnescapeQuote()) {
      continue;
    }
    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap["l"] || 8;
    if (transition === 8) {
      return;
    }
    mode = transition[0];
    if (transition[1] !== void 0) {
      action = actions[transition[1]];
      if (action) {
        newChar = c;
        if (action() === false) {
          return;
        }
      }
    }
    if (mode === 7) {
      return keys;
    }
  }
}
const cache = /* @__PURE__ */ new Map();
function resolveWithKeyValue(obj, path) {
  return isObject$3(obj) ? obj[path] : null;
}
function resolveValue(obj, path) {
  if (!isObject$3(obj)) {
    return null;
  }
  let hit = cache.get(path);
  if (!hit) {
    hit = parse(path);
    if (hit) {
      cache.set(path, hit);
    }
  }
  if (!hit) {
    return null;
  }
  const len = hit.length;
  let last = obj;
  let i = 0;
  while (i < len) {
    const val = last[hit[i]];
    if (val === void 0) {
      return null;
    }
    if (isFunction$2(last)) {
      return null;
    }
    last = val;
    i++;
  }
  return last;
}
const DEFAULT_MODIFIER = (str) => str;
const DEFAULT_MESSAGE = (ctx) => "";
const DEFAULT_MESSAGE_DATA_TYPE = "text";
const DEFAULT_NORMALIZE = (values) => values.length === 0 ? "" : join$1(values);
const DEFAULT_INTERPOLATE = toDisplayString;
function pluralDefault(choice, choicesLength) {
  choice = Math.abs(choice);
  if (choicesLength === 2) {
    return choice ? choice > 1 ? 1 : 0 : 1;
  }
  return choice ? Math.min(choice, 2) : 0;
}
function getPluralIndex(options) {
  const index2 = isNumber$2(options.pluralIndex) ? options.pluralIndex : -1;
  return options.named && (isNumber$2(options.named.count) || isNumber$2(options.named.n)) ? isNumber$2(options.named.count) ? options.named.count : isNumber$2(options.named.n) ? options.named.n : index2 : index2;
}
function normalizeNamed(pluralIndex, props2) {
  if (!props2.count) {
    props2.count = pluralIndex;
  }
  if (!props2.n) {
    props2.n = pluralIndex;
  }
}
function createMessageContext(options = {}) {
  const locale = options.locale;
  const pluralIndex = getPluralIndex(options);
  const pluralRule = isObject$3(options.pluralRules) && isString$3(locale) && isFunction$2(options.pluralRules[locale]) ? options.pluralRules[locale] : pluralDefault;
  const orgPluralRule = isObject$3(options.pluralRules) && isString$3(locale) && isFunction$2(options.pluralRules[locale]) ? pluralDefault : void 0;
  const plural = (messages) => {
    return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
  };
  const _list = options.list || [];
  const list = (index2) => _list[index2];
  const _named = options.named || {};
  isNumber$2(options.pluralIndex) && normalizeNamed(pluralIndex, _named);
  const named = (key) => _named[key];
  function message(key) {
    const msg = isFunction$2(options.messages) ? options.messages(key) : isObject$3(options.messages) ? options.messages[key] : false;
    return !msg ? options.parent ? options.parent.message(key) : DEFAULT_MESSAGE : msg;
  }
  const _modifier = (name) => options.modifiers ? options.modifiers[name] : DEFAULT_MODIFIER;
  const normalize2 = isPlainObject$2(options.processor) && isFunction$2(options.processor.normalize) ? options.processor.normalize : DEFAULT_NORMALIZE;
  const interpolate = isPlainObject$2(options.processor) && isFunction$2(options.processor.interpolate) ? options.processor.interpolate : DEFAULT_INTERPOLATE;
  const type = isPlainObject$2(options.processor) && isString$3(options.processor.type) ? options.processor.type : DEFAULT_MESSAGE_DATA_TYPE;
  const linked = (key, ...args) => {
    const [arg1, arg2] = args;
    let type2 = "text";
    let modifier = "";
    if (args.length === 1) {
      if (isObject$3(arg1)) {
        modifier = arg1.modifier || modifier;
        type2 = arg1.type || type2;
      } else if (isString$3(arg1)) {
        modifier = arg1 || modifier;
      }
    } else if (args.length === 2) {
      if (isString$3(arg1)) {
        modifier = arg1 || modifier;
      }
      if (isString$3(arg2)) {
        type2 = arg2 || type2;
      }
    }
    const ret = message(key)(ctx);
    const msg = type2 === "vnode" && isArray$1(ret) && modifier ? ret[0] : ret;
    return modifier ? _modifier(modifier)(msg, type2) : msg;
  };
  const ctx = {
    ["list"]: list,
    ["named"]: named,
    ["plural"]: plural,
    ["linked"]: linked,
    ["message"]: message,
    ["type"]: type,
    ["interpolate"]: interpolate,
    ["normalize"]: normalize2,
    ["values"]: assign$2({}, _list, _named)
  };
  return ctx;
}
let devtools = null;
function setDevToolsHook(hook) {
  devtools = hook;
}
function initI18nDevTools(i18n, version2, meta) {
  devtools && devtools.emit("i18n:init", {
    timestamp: Date.now(),
    i18n,
    version: version2,
    meta
  });
}
const translateDevTools = /* @__PURE__ */ createDevToolsHook("function:translate");
function createDevToolsHook(hook) {
  return (payloads) => devtools && devtools.emit(hook, payloads);
}
const CoreWarnCodes = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
};
const code$2 = CompileErrorCodes.__EXTEND_POINT__;
const inc$2 = incrementer(code$2);
const CoreErrorCodes = {
  INVALID_ARGUMENT: code$2,
  INVALID_DATE_ARGUMENT: inc$2(),
  INVALID_ISO_DATE_ARGUMENT: inc$2(),
  NOT_SUPPORT_NON_STRING_MESSAGE: inc$2(),
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: inc$2(),
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: inc$2(),
  NOT_SUPPORT_LOCALE_TYPE: inc$2(),
  __EXTEND_POINT__: inc$2()
};
function createCoreError(code2) {
  return createCompileError(code2, null, void 0);
}
function getLocale(context, options) {
  return options.locale != null ? resolveLocale(options.locale) : resolveLocale(context.locale);
}
let _resolveLocale;
function resolveLocale(locale) {
  if (isString$3(locale)) {
    return locale;
  } else {
    if (isFunction$2(locale)) {
      if (locale.resolvedOnce && _resolveLocale != null) {
        return _resolveLocale;
      } else if (locale.constructor.name === "Function") {
        const resolve = locale();
        if (isPromise(resolve)) {
          throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
        }
        return _resolveLocale = resolve;
      } else {
        throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
      }
    } else {
      throw createCoreError(CoreErrorCodes.NOT_SUPPORT_LOCALE_TYPE);
    }
  }
}
function fallbackWithSimple(ctx, fallback, start) {
  return [.../* @__PURE__ */ new Set([
    start,
    ...isArray$1(fallback) ? fallback : isObject$3(fallback) ? Object.keys(fallback) : isString$3(fallback) ? [fallback] : [start]
  ])];
}
function fallbackWithLocaleChain(ctx, fallback, start) {
  const startLocale = isString$3(start) ? start : DEFAULT_LOCALE;
  const context = ctx;
  if (!context.__localeChainCache) {
    context.__localeChainCache = /* @__PURE__ */ new Map();
  }
  let chain = context.__localeChainCache.get(startLocale);
  if (!chain) {
    chain = [];
    let block = [start];
    while (isArray$1(block)) {
      block = appendBlockToChain(chain, block, fallback);
    }
    const defaults2 = isArray$1(fallback) || !isPlainObject$2(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
    block = isString$3(defaults2) ? [defaults2] : defaults2;
    if (isArray$1(block)) {
      appendBlockToChain(chain, block, false);
    }
    context.__localeChainCache.set(startLocale, chain);
  }
  return chain;
}
function appendBlockToChain(chain, block, blocks) {
  let follow = true;
  for (let i = 0; i < block.length && isBoolean(follow); i++) {
    const locale = block[i];
    if (isString$3(locale)) {
      follow = appendLocaleToChain(chain, block[i], blocks);
    }
  }
  return follow;
}
function appendLocaleToChain(chain, locale, blocks) {
  let follow;
  const tokens = locale.split("-");
  do {
    const target = tokens.join("-");
    follow = appendItemToChain(chain, target, blocks);
    tokens.splice(-1, 1);
  } while (tokens.length && follow === true);
  return follow;
}
function appendItemToChain(chain, target, blocks) {
  let follow = false;
  if (!chain.includes(target)) {
    follow = true;
    if (target) {
      follow = target[target.length - 1] !== "!";
      const locale = target.replace(/!/g, "");
      chain.push(locale);
      if ((isArray$1(blocks) || isPlainObject$2(blocks)) && blocks[locale]) {
        follow = blocks[locale];
      }
    }
  }
  return follow;
}
const VERSION$2 = "9.10.2";
const NOT_REOSLVED = -1;
const DEFAULT_LOCALE = "en-US";
const MISSING_RESOLVE_VALUE = "";
const capitalize = (str) => `${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function getDefaultLinkedModifiers() {
  return {
    upper: (val, type) => {
      return type === "text" && isString$3(val) ? val.toUpperCase() : type === "vnode" && isObject$3(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val;
    },
    lower: (val, type) => {
      return type === "text" && isString$3(val) ? val.toLowerCase() : type === "vnode" && isObject$3(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val;
    },
    capitalize: (val, type) => {
      return type === "text" && isString$3(val) ? capitalize(val) : type === "vnode" && isObject$3(val) && "__v_isVNode" in val ? capitalize(val.children) : val;
    }
  };
}
let _compiler;
function registerMessageCompiler(compiler) {
  _compiler = compiler;
}
let _resolver;
function registerMessageResolver(resolver) {
  _resolver = resolver;
}
let _fallbacker;
function registerLocaleFallbacker(fallbacker) {
  _fallbacker = fallbacker;
}
let _additionalMeta = null;
const setAdditionalMeta = (meta) => {
  _additionalMeta = meta;
};
const getAdditionalMeta = () => _additionalMeta;
let _fallbackContext = null;
const setFallbackContext = (context) => {
  _fallbackContext = context;
};
const getFallbackContext = () => _fallbackContext;
let _cid = 0;
function createCoreContext(options = {}) {
  const onWarn = isFunction$2(options.onWarn) ? options.onWarn : warn;
  const version2 = isString$3(options.version) ? options.version : VERSION$2;
  const locale = isString$3(options.locale) || isFunction$2(options.locale) ? options.locale : DEFAULT_LOCALE;
  const _locale = isFunction$2(locale) ? DEFAULT_LOCALE : locale;
  const fallbackLocale = isArray$1(options.fallbackLocale) || isPlainObject$2(options.fallbackLocale) || isString$3(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale;
  const messages = isPlainObject$2(options.messages) ? options.messages : { [_locale]: {} };
  const datetimeFormats = isPlainObject$2(options.datetimeFormats) ? options.datetimeFormats : { [_locale]: {} };
  const numberFormats = isPlainObject$2(options.numberFormats) ? options.numberFormats : { [_locale]: {} };
  const modifiers = assign$2({}, options.modifiers || {}, getDefaultLinkedModifiers());
  const pluralRules = options.pluralRules || {};
  const missing = isFunction$2(options.missing) ? options.missing : null;
  const missingWarn = isBoolean(options.missingWarn) || isRegExp(options.missingWarn) ? options.missingWarn : true;
  const fallbackWarn = isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn) ? options.fallbackWarn : true;
  const fallbackFormat = !!options.fallbackFormat;
  const unresolving = !!options.unresolving;
  const postTranslation = isFunction$2(options.postTranslation) ? options.postTranslation : null;
  const processor = isPlainObject$2(options.processor) ? options.processor : null;
  const warnHtmlMessage = isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
  const escapeParameter = !!options.escapeParameter;
  const messageCompiler = isFunction$2(options.messageCompiler) ? options.messageCompiler : _compiler;
  const messageResolver = isFunction$2(options.messageResolver) ? options.messageResolver : _resolver || resolveWithKeyValue;
  const localeFallbacker = isFunction$2(options.localeFallbacker) ? options.localeFallbacker : _fallbacker || fallbackWithSimple;
  const fallbackContext = isObject$3(options.fallbackContext) ? options.fallbackContext : void 0;
  const internalOptions = options;
  const __datetimeFormatters = isObject$3(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : /* @__PURE__ */ new Map();
  const __numberFormatters = isObject$3(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : /* @__PURE__ */ new Map();
  const __meta = isObject$3(internalOptions.__meta) ? internalOptions.__meta : {};
  _cid++;
  const context = {
    version: version2,
    cid: _cid,
    locale,
    fallbackLocale,
    messages,
    modifiers,
    pluralRules,
    missing,
    missingWarn,
    fallbackWarn,
    fallbackFormat,
    unresolving,
    postTranslation,
    processor,
    warnHtmlMessage,
    escapeParameter,
    messageCompiler,
    messageResolver,
    localeFallbacker,
    fallbackContext,
    onWarn,
    __meta
  };
  {
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
  }
  if (__INTLIFY_PROD_DEVTOOLS__) {
    initI18nDevTools(context, version2, __meta);
  }
  return context;
}
function handleMissing(context, key, locale, missingWarn, type) {
  const { missing, onWarn } = context;
  if (missing !== null) {
    const ret = missing(context, locale, key, type);
    return isString$3(ret) ? ret : key;
  } else {
    return key;
  }
}
function updateFallbackLocale(ctx, locale, fallback) {
  const context = ctx;
  context.__localeChainCache = /* @__PURE__ */ new Map();
  ctx.localeFallbacker(ctx, fallback, locale);
}
function format(ast) {
  const msg = (ctx) => formatParts(ctx, ast);
  return msg;
}
function formatParts(ctx, ast) {
  const body = ast.b || ast.body;
  if ((body.t || body.type) === 1) {
    const plural = body;
    const cases = plural.c || plural.cases;
    return ctx.plural(cases.reduce((messages, c) => [
      ...messages,
      formatMessageParts(ctx, c)
    ], []));
  } else {
    return formatMessageParts(ctx, body);
  }
}
function formatMessageParts(ctx, node) {
  const _static = node.s || node.static;
  if (_static) {
    return ctx.type === "text" ? _static : ctx.normalize([_static]);
  } else {
    const messages = (node.i || node.items).reduce((acm, c) => [...acm, formatMessagePart(ctx, c)], []);
    return ctx.normalize(messages);
  }
}
function formatMessagePart(ctx, node) {
  const type = node.t || node.type;
  switch (type) {
    case 3: {
      const text = node;
      return text.v || text.value;
    }
    case 9: {
      const literal = node;
      return literal.v || literal.value;
    }
    case 4: {
      const named = node;
      return ctx.interpolate(ctx.named(named.k || named.key));
    }
    case 5: {
      const list = node;
      return ctx.interpolate(ctx.list(list.i != null ? list.i : list.index));
    }
    case 6: {
      const linked = node;
      const modifier = linked.m || linked.modifier;
      return ctx.linked(formatMessagePart(ctx, linked.k || linked.key), modifier ? formatMessagePart(ctx, modifier) : void 0, ctx.type);
    }
    case 7: {
      const linkedKey = node;
      return linkedKey.v || linkedKey.value;
    }
    case 8: {
      const linkedModifier = node;
      return linkedModifier.v || linkedModifier.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${type}`);
  }
}
const defaultOnCacheKey = (message) => message;
let compileCache = /* @__PURE__ */ Object.create(null);
const isMessageAST = (val) => isObject$3(val) && (val.t === 0 || val.type === 0) && ("b" in val || "body" in val);
function baseCompile(message, options = {}) {
  let detectError = false;
  const onError = options.onError || defaultOnError;
  options.onError = (err) => {
    detectError = true;
    onError(err);
  };
  return { ...baseCompile$1(message, options), detectError };
}
const compileToFunction = (message, context) => {
  if (!isString$3(message)) {
    throw createCoreError(CoreErrorCodes.NOT_SUPPORT_NON_STRING_MESSAGE);
  }
  {
    isBoolean(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
    const onCacheKey = context.onCacheKey || defaultOnCacheKey;
    const cacheKey = onCacheKey(message);
    const cached2 = compileCache[cacheKey];
    if (cached2) {
      return cached2;
    }
    const { code: code2, detectError } = baseCompile(message, context);
    const msg = new Function(`return ${code2}`)();
    return !detectError ? compileCache[cacheKey] = msg : msg;
  }
};
function compile(message, context) {
  if (__INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && isString$3(message)) {
    isBoolean(context.warnHtmlMessage) ? context.warnHtmlMessage : true;
    const onCacheKey = context.onCacheKey || defaultOnCacheKey;
    const cacheKey = onCacheKey(message);
    const cached2 = compileCache[cacheKey];
    if (cached2) {
      return cached2;
    }
    const { ast, detectError } = baseCompile(message, {
      ...context,
      location: false,
      jit: true
    });
    const msg = format(ast);
    return !detectError ? compileCache[cacheKey] = msg : msg;
  } else {
    const cacheKey = message.cacheKey;
    if (cacheKey) {
      const cached2 = compileCache[cacheKey];
      if (cached2) {
        return cached2;
      }
      return compileCache[cacheKey] = format(message);
    } else {
      return format(message);
    }
  }
}
const NOOP_MESSAGE_FUNCTION = () => "";
const isMessageFunction = (val) => isFunction$2(val);
function translate(context, ...args) {
  const { fallbackFormat, postTranslation, unresolving, messageCompiler, fallbackLocale, messages } = context;
  const [key, options] = parseTranslateArgs(...args);
  const missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn;
  const fallbackWarn = isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
  const escapeParameter = isBoolean(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
  const resolvedMessage = !!options.resolvedMessage;
  const defaultMsgOrKey = isString$3(options.default) || isBoolean(options.default) ? !isBoolean(options.default) ? options.default : !messageCompiler ? () => key : key : fallbackFormat ? !messageCompiler ? () => key : key : "";
  const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
  const locale = getLocale(context, options);
  escapeParameter && escapeParams(options);
  let [formatScope, targetLocale, message] = !resolvedMessage ? resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
    key,
    locale,
    messages[locale] || {}
  ];
  let format2 = formatScope;
  let cacheBaseKey = key;
  if (!resolvedMessage && !(isString$3(format2) || isMessageAST(format2) || isMessageFunction(format2))) {
    if (enableDefaultMsg) {
      format2 = defaultMsgOrKey;
      cacheBaseKey = format2;
    }
  }
  if (!resolvedMessage && (!(isString$3(format2) || isMessageAST(format2) || isMessageFunction(format2)) || !isString$3(targetLocale))) {
    return unresolving ? NOT_REOSLVED : key;
  }
  let occurred = false;
  const onError = () => {
    occurred = true;
  };
  const msg = !isMessageFunction(format2) ? compileMessageFormat(context, key, targetLocale, format2, cacheBaseKey, onError) : format2;
  if (occurred) {
    return format2;
  }
  const ctxOptions = getMessageContextOptions(context, targetLocale, message, options);
  const msgContext = createMessageContext(ctxOptions);
  const messaged = evaluateMessage(context, msg, msgContext);
  const ret = postTranslation ? postTranslation(messaged, key) : messaged;
  if (__INTLIFY_PROD_DEVTOOLS__) {
    const payloads = {
      timestamp: Date.now(),
      key: isString$3(key) ? key : isMessageFunction(format2) ? format2.key : "",
      locale: targetLocale || (isMessageFunction(format2) ? format2.locale : ""),
      format: isString$3(format2) ? format2 : isMessageFunction(format2) ? format2.source : "",
      message: ret
    };
    payloads.meta = assign$2({}, context.__meta, getAdditionalMeta() || {});
    translateDevTools(payloads);
  }
  return ret;
}
function escapeParams(options) {
  if (isArray$1(options.list)) {
    options.list = options.list.map((item) => isString$3(item) ? escapeHtml(item) : item);
  } else if (isObject$3(options.named)) {
    Object.keys(options.named).forEach((key) => {
      if (isString$3(options.named[key])) {
        options.named[key] = escapeHtml(options.named[key]);
      }
    });
  }
}
function resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
  const { messages, onWarn, messageResolver: resolveValue2, localeFallbacker } = context;
  const locales = localeFallbacker(context, fallbackLocale, locale);
  let message = {};
  let targetLocale;
  let format2 = null;
  const type = "translate";
  for (let i = 0; i < locales.length; i++) {
    targetLocale = locales[i];
    message = messages[targetLocale] || {};
    if ((format2 = resolveValue2(message, key)) === null) {
      format2 = message[key];
    }
    if (isString$3(format2) || isMessageAST(format2) || isMessageFunction(format2)) {
      break;
    }
    const missingRet = handleMissing(
      context,
      key,
      targetLocale,
      missingWarn,
      type
    );
    if (missingRet !== key) {
      format2 = missingRet;
    }
  }
  return [format2, targetLocale, message];
}
function compileMessageFormat(context, key, targetLocale, format2, cacheBaseKey, onError) {
  const { messageCompiler, warnHtmlMessage } = context;
  if (isMessageFunction(format2)) {
    const msg2 = format2;
    msg2.locale = msg2.locale || targetLocale;
    msg2.key = msg2.key || key;
    return msg2;
  }
  if (messageCompiler == null) {
    const msg2 = () => format2;
    msg2.locale = targetLocale;
    msg2.key = key;
    return msg2;
  }
  const msg = messageCompiler(format2, getCompileContext(context, targetLocale, cacheBaseKey, format2, warnHtmlMessage, onError));
  msg.locale = targetLocale;
  msg.key = key;
  msg.source = format2;
  return msg;
}
function evaluateMessage(context, msg, msgCtx) {
  const messaged = msg(msgCtx);
  return messaged;
}
function parseTranslateArgs(...args) {
  const [arg1, arg2, arg3] = args;
  const options = {};
  if (!isString$3(arg1) && !isNumber$2(arg1) && !isMessageFunction(arg1) && !isMessageAST(arg1)) {
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  }
  const key = isNumber$2(arg1) ? String(arg1) : isMessageFunction(arg1) ? arg1 : arg1;
  if (isNumber$2(arg2)) {
    options.plural = arg2;
  } else if (isString$3(arg2)) {
    options.default = arg2;
  } else if (isPlainObject$2(arg2) && !isEmptyObject(arg2)) {
    options.named = arg2;
  } else if (isArray$1(arg2)) {
    options.list = arg2;
  }
  if (isNumber$2(arg3)) {
    options.plural = arg3;
  } else if (isString$3(arg3)) {
    options.default = arg3;
  } else if (isPlainObject$2(arg3)) {
    assign$2(options, arg3);
  }
  return [key, options];
}
function getCompileContext(context, locale, key, source2, warnHtmlMessage, onError) {
  return {
    locale,
    key,
    warnHtmlMessage,
    onError: (err) => {
      onError && onError(err);
      {
        throw err;
      }
    },
    onCacheKey: (source3) => generateFormatCacheKey(locale, key, source3)
  };
}
function getMessageContextOptions(context, locale, message, options) {
  const { modifiers, pluralRules, messageResolver: resolveValue2, fallbackLocale, fallbackWarn, missingWarn, fallbackContext } = context;
  const resolveMessage = (key) => {
    let val = resolveValue2(message, key);
    if (val == null && fallbackContext) {
      const [, , message2] = resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
      val = resolveValue2(message2, key);
    }
    if (isString$3(val) || isMessageAST(val)) {
      let occurred = false;
      const onError = () => {
        occurred = true;
      };
      const msg = compileMessageFormat(context, key, locale, val, key, onError);
      return !occurred ? msg : NOOP_MESSAGE_FUNCTION;
    } else if (isMessageFunction(val)) {
      return val;
    } else {
      return NOOP_MESSAGE_FUNCTION;
    }
  };
  const ctxOptions = {
    locale,
    modifiers,
    pluralRules,
    messages: resolveMessage
  };
  if (context.processor) {
    ctxOptions.processor = context.processor;
  }
  if (options.list) {
    ctxOptions.list = options.list;
  }
  if (options.named) {
    ctxOptions.named = options.named;
  }
  if (isNumber$2(options.plural)) {
    ctxOptions.pluralIndex = options.plural;
  }
  return ctxOptions;
}
function datetime(context, ...args) {
  const { datetimeFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
  const { __datetimeFormatters } = context;
  const [key, value, options, overrides] = parseDateTimeArgs(...args);
  const missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn;
  isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
  const part = !!options.part;
  const locale = getLocale(context, options);
  const locales = localeFallbacker(
    context,
    fallbackLocale,
    locale
  );
  if (!isString$3(key) || key === "") {
    return new Intl.DateTimeFormat(locale, overrides).format(value);
  }
  let datetimeFormat = {};
  let targetLocale;
  let format2 = null;
  const type = "datetime format";
  for (let i = 0; i < locales.length; i++) {
    targetLocale = locales[i];
    datetimeFormat = datetimeFormats[targetLocale] || {};
    format2 = datetimeFormat[key];
    if (isPlainObject$2(format2))
      break;
    handleMissing(context, key, targetLocale, missingWarn, type);
  }
  if (!isPlainObject$2(format2) || !isString$3(targetLocale)) {
    return unresolving ? NOT_REOSLVED : key;
  }
  let id = `${targetLocale}__${key}`;
  if (!isEmptyObject(overrides)) {
    id = `${id}__${JSON.stringify(overrides)}`;
  }
  let formatter = __datetimeFormatters.get(id);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(targetLocale, assign$2({}, format2, overrides));
    __datetimeFormatters.set(id, formatter);
  }
  return !part ? formatter.format(value) : formatter.formatToParts(value);
}
const DATETIME_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function parseDateTimeArgs(...args) {
  const [arg1, arg2, arg3, arg4] = args;
  const options = {};
  let overrides = {};
  let value;
  if (isString$3(arg1)) {
    const matches2 = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!matches2) {
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    }
    const dateTime = matches2[3] ? matches2[3].trim().startsWith("T") ? `${matches2[1].trim()}${matches2[3].trim()}` : `${matches2[1].trim()}T${matches2[3].trim()}` : matches2[1].trim();
    value = new Date(dateTime);
    try {
      value.toISOString();
    } catch (e) {
      throw createCoreError(CoreErrorCodes.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (isDate$1(arg1)) {
    if (isNaN(arg1.getTime())) {
      throw createCoreError(CoreErrorCodes.INVALID_DATE_ARGUMENT);
    }
    value = arg1;
  } else if (isNumber$2(arg1)) {
    value = arg1;
  } else {
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  }
  if (isString$3(arg2)) {
    options.key = arg2;
  } else if (isPlainObject$2(arg2)) {
    Object.keys(arg2).forEach((key) => {
      if (DATETIME_FORMAT_OPTIONS_KEYS.includes(key)) {
        overrides[key] = arg2[key];
      } else {
        options[key] = arg2[key];
      }
    });
  }
  if (isString$3(arg3)) {
    options.locale = arg3;
  } else if (isPlainObject$2(arg3)) {
    overrides = arg3;
  }
  if (isPlainObject$2(arg4)) {
    overrides = arg4;
  }
  return [options.key || "", value, options, overrides];
}
function clearDateTimeFormat(ctx, locale, format2) {
  const context = ctx;
  for (const key in format2) {
    const id = `${locale}__${key}`;
    if (!context.__datetimeFormatters.has(id)) {
      continue;
    }
    context.__datetimeFormatters.delete(id);
  }
}
function number(context, ...args) {
  const { numberFormats, unresolving, fallbackLocale, onWarn, localeFallbacker } = context;
  const { __numberFormatters } = context;
  const [key, value, options, overrides] = parseNumberArgs(...args);
  const missingWarn = isBoolean(options.missingWarn) ? options.missingWarn : context.missingWarn;
  isBoolean(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
  const part = !!options.part;
  const locale = getLocale(context, options);
  const locales = localeFallbacker(
    context,
    fallbackLocale,
    locale
  );
  if (!isString$3(key) || key === "") {
    return new Intl.NumberFormat(locale, overrides).format(value);
  }
  let numberFormat = {};
  let targetLocale;
  let format2 = null;
  const type = "number format";
  for (let i = 0; i < locales.length; i++) {
    targetLocale = locales[i];
    numberFormat = numberFormats[targetLocale] || {};
    format2 = numberFormat[key];
    if (isPlainObject$2(format2))
      break;
    handleMissing(context, key, targetLocale, missingWarn, type);
  }
  if (!isPlainObject$2(format2) || !isString$3(targetLocale)) {
    return unresolving ? NOT_REOSLVED : key;
  }
  let id = `${targetLocale}__${key}`;
  if (!isEmptyObject(overrides)) {
    id = `${id}__${JSON.stringify(overrides)}`;
  }
  let formatter = __numberFormatters.get(id);
  if (!formatter) {
    formatter = new Intl.NumberFormat(targetLocale, assign$2({}, format2, overrides));
    __numberFormatters.set(id, formatter);
  }
  return !part ? formatter.format(value) : formatter.formatToParts(value);
}
const NUMBER_FORMAT_OPTIONS_KEYS = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function parseNumberArgs(...args) {
  const [arg1, arg2, arg3, arg4] = args;
  const options = {};
  let overrides = {};
  if (!isNumber$2(arg1)) {
    throw createCoreError(CoreErrorCodes.INVALID_ARGUMENT);
  }
  const value = arg1;
  if (isString$3(arg2)) {
    options.key = arg2;
  } else if (isPlainObject$2(arg2)) {
    Object.keys(arg2).forEach((key) => {
      if (NUMBER_FORMAT_OPTIONS_KEYS.includes(key)) {
        overrides[key] = arg2[key];
      } else {
        options[key] = arg2[key];
      }
    });
  }
  if (isString$3(arg3)) {
    options.locale = arg3;
  } else if (isPlainObject$2(arg3)) {
    overrides = arg3;
  }
  if (isPlainObject$2(arg4)) {
    overrides = arg4;
  }
  return [options.key || "", value, options, overrides];
}
function clearNumberFormat(ctx, locale, format2) {
  const context = ctx;
  for (const key in format2) {
    const id = `${locale}__${key}`;
    if (!context.__numberFormatters.has(id)) {
      continue;
    }
    context.__numberFormatters.delete(id);
  }
}
{
  initFeatureFlags$1();
}
/*!
  * vue-i18n v9.10.2
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const VERSION$1 = "9.10.2";
function initFeatureFlags() {
  if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") {
    getGlobalThis().__VUE_I18N_FULL_INSTALL__ = true;
  }
  if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") {
    getGlobalThis().__VUE_I18N_LEGACY_API__ = true;
  }
  if (typeof __INTLIFY_JIT_COMPILATION__ !== "boolean") {
    getGlobalThis().__INTLIFY_JIT_COMPILATION__ = false;
  }
  if (typeof __INTLIFY_DROP_MESSAGE_COMPILER__ !== "boolean") {
    getGlobalThis().__INTLIFY_DROP_MESSAGE_COMPILER__ = false;
  }
  if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") {
    getGlobalThis().__INTLIFY_PROD_DEVTOOLS__ = false;
  }
}
const code$1 = CoreWarnCodes.__EXTEND_POINT__;
const inc$1 = incrementer(code$1);
({
  FALLBACK_TO_ROOT: code$1,
  NOT_SUPPORTED_PRESERVE: inc$1(),
  NOT_SUPPORTED_FORMATTER: inc$1(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: inc$1(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: inc$1(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: inc$1(),
  NOT_FOUND_PARENT_SCOPE: inc$1(),
  IGNORE_OBJ_FLATTEN: inc$1(),
  NOTICE_DROP_ALLOW_COMPOSITION: inc$1(),
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: inc$1()
});
const code = CoreErrorCodes.__EXTEND_POINT__;
const inc = incrementer(code);
const I18nErrorCodes = {
  UNEXPECTED_RETURN_TYPE: code,
  INVALID_ARGUMENT: inc(),
  MUST_BE_CALL_SETUP_TOP: inc(),
  NOT_INSTALLED: inc(),
  NOT_AVAILABLE_IN_LEGACY_MODE: inc(),
  REQUIRED_VALUE: inc(),
  INVALID_VALUE: inc(),
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: inc(),
  NOT_INSTALLED_WITH_PROVIDE: inc(),
  UNEXPECTED_ERROR: inc(),
  NOT_COMPATIBLE_LEGACY_VUE_I18N: inc(),
  BRIDGE_SUPPORT_VUE_2_ONLY: inc(),
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: inc(),
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: inc(),
  __EXTEND_POINT__: inc()
};
function createI18nError(code2, ...args) {
  return createCompileError(code2, null, void 0);
}
const TranslateVNodeSymbol = /* @__PURE__ */ makeSymbol("__translateVNode");
const DatetimePartsSymbol = /* @__PURE__ */ makeSymbol("__datetimeParts");
const NumberPartsSymbol = /* @__PURE__ */ makeSymbol("__numberParts");
const SetPluralRulesSymbol = makeSymbol("__setPluralRules");
makeSymbol("__intlifyMeta");
const InejctWithOptionSymbol = /* @__PURE__ */ makeSymbol("__injectWithOption");
const DisposeSymbol = /* @__PURE__ */ makeSymbol("__dispose");
function handleFlatJson(obj) {
  if (!isObject$3(obj)) {
    return obj;
  }
  for (const key in obj) {
    if (!hasOwn(obj, key)) {
      continue;
    }
    if (!key.includes(".")) {
      if (isObject$3(obj[key])) {
        handleFlatJson(obj[key]);
      }
    } else {
      const subKeys = key.split(".");
      const lastIndex = subKeys.length - 1;
      let currentObj = obj;
      let hasStringValue = false;
      for (let i = 0; i < lastIndex; i++) {
        if (!(subKeys[i] in currentObj)) {
          currentObj[subKeys[i]] = {};
        }
        if (!isObject$3(currentObj[subKeys[i]])) {
          hasStringValue = true;
          break;
        }
        currentObj = currentObj[subKeys[i]];
      }
      if (!hasStringValue) {
        currentObj[subKeys[lastIndex]] = obj[key];
        delete obj[key];
      }
      if (isObject$3(currentObj[subKeys[lastIndex]])) {
        handleFlatJson(currentObj[subKeys[lastIndex]]);
      }
    }
  }
  return obj;
}
function getLocaleMessages(locale, options) {
  const { messages, __i18n, messageResolver, flatJson } = options;
  const ret = isPlainObject$2(messages) ? messages : isArray$1(__i18n) ? {} : { [locale]: {} };
  if (isArray$1(__i18n)) {
    __i18n.forEach((custom) => {
      if ("locale" in custom && "resource" in custom) {
        const { locale: locale2, resource } = custom;
        if (locale2) {
          ret[locale2] = ret[locale2] || {};
          deepCopy(resource, ret[locale2]);
        } else {
          deepCopy(resource, ret);
        }
      } else {
        isString$3(custom) && deepCopy(JSON.parse(custom), ret);
      }
    });
  }
  if (messageResolver == null && flatJson) {
    for (const key in ret) {
      if (hasOwn(ret, key)) {
        handleFlatJson(ret[key]);
      }
    }
  }
  return ret;
}
function getComponentOptions(instance2) {
  return instance2.type;
}
function adjustI18nResources(gl, options, componentOptions) {
  let messages = isObject$3(options.messages) ? options.messages : {};
  if ("__i18nGlobal" in componentOptions) {
    messages = getLocaleMessages(gl.locale.value, {
      messages,
      __i18n: componentOptions.__i18nGlobal
    });
  }
  const locales = Object.keys(messages);
  if (locales.length) {
    locales.forEach((locale) => {
      gl.mergeLocaleMessage(locale, messages[locale]);
    });
  }
  {
    if (isObject$3(options.datetimeFormats)) {
      const locales2 = Object.keys(options.datetimeFormats);
      if (locales2.length) {
        locales2.forEach((locale) => {
          gl.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
      }
    }
    if (isObject$3(options.numberFormats)) {
      const locales2 = Object.keys(options.numberFormats);
      if (locales2.length) {
        locales2.forEach((locale) => {
          gl.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
      }
    }
  }
}
function createTextNode(key) {
  return createVNode(Text, null, key, 0);
}
const DEVTOOLS_META = "__INTLIFY_META__";
const NOOP_RETURN_ARRAY = () => [];
const NOOP_RETURN_FALSE = () => false;
let composerID = 0;
function defineCoreMissingHandler(missing) {
  return (ctx, locale, key, type) => {
    return missing(locale, key, getCurrentInstance() || void 0, type);
  };
}
const getMetaInfo = () => {
  const instance2 = getCurrentInstance();
  let meta = null;
  return instance2 && (meta = getComponentOptions(instance2)[DEVTOOLS_META]) ? { [DEVTOOLS_META]: meta } : null;
};
function createComposer(options = {}, VueI18nLegacy) {
  const { __root, __injectWithOption } = options;
  const _isGlobal = __root === void 0;
  const flatJson = options.flatJson;
  const _ref = inBrowser ? ref : shallowRef;
  const translateExistCompatible = !!options.translateExistCompatible;
  let _inheritLocale = isBoolean(options.inheritLocale) ? options.inheritLocale : true;
  const _locale = _ref(
    __root && _inheritLocale ? __root.locale.value : isString$3(options.locale) ? options.locale : DEFAULT_LOCALE
  );
  const _fallbackLocale = _ref(
    __root && _inheritLocale ? __root.fallbackLocale.value : isString$3(options.fallbackLocale) || isArray$1(options.fallbackLocale) || isPlainObject$2(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value
  );
  const _messages = _ref(getLocaleMessages(_locale.value, options));
  const _datetimeFormats = _ref(isPlainObject$2(options.datetimeFormats) ? options.datetimeFormats : { [_locale.value]: {} });
  const _numberFormats = _ref(isPlainObject$2(options.numberFormats) ? options.numberFormats : { [_locale.value]: {} });
  let _missingWarn = __root ? __root.missingWarn : isBoolean(options.missingWarn) || isRegExp(options.missingWarn) ? options.missingWarn : true;
  let _fallbackWarn = __root ? __root.fallbackWarn : isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn) ? options.fallbackWarn : true;
  let _fallbackRoot = __root ? __root.fallbackRoot : isBoolean(options.fallbackRoot) ? options.fallbackRoot : true;
  let _fallbackFormat = !!options.fallbackFormat;
  let _missing = isFunction$2(options.missing) ? options.missing : null;
  let _runtimeMissing = isFunction$2(options.missing) ? defineCoreMissingHandler(options.missing) : null;
  let _postTranslation = isFunction$2(options.postTranslation) ? options.postTranslation : null;
  let _warnHtmlMessage = __root ? __root.warnHtmlMessage : isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
  let _escapeParameter = !!options.escapeParameter;
  const _modifiers = __root ? __root.modifiers : isPlainObject$2(options.modifiers) ? options.modifiers : {};
  let _pluralRules = options.pluralRules || __root && __root.pluralRules;
  let _context;
  const getCoreContext = () => {
    _isGlobal && setFallbackContext(null);
    const ctxOptions = {
      version: VERSION$1,
      locale: _locale.value,
      fallbackLocale: _fallbackLocale.value,
      messages: _messages.value,
      modifiers: _modifiers,
      pluralRules: _pluralRules,
      missing: _runtimeMissing === null ? void 0 : _runtimeMissing,
      missingWarn: _missingWarn,
      fallbackWarn: _fallbackWarn,
      fallbackFormat: _fallbackFormat,
      unresolving: true,
      postTranslation: _postTranslation === null ? void 0 : _postTranslation,
      warnHtmlMessage: _warnHtmlMessage,
      escapeParameter: _escapeParameter,
      messageResolver: options.messageResolver,
      messageCompiler: options.messageCompiler,
      __meta: { framework: "vue" }
    };
    {
      ctxOptions.datetimeFormats = _datetimeFormats.value;
      ctxOptions.numberFormats = _numberFormats.value;
      ctxOptions.__datetimeFormatters = isPlainObject$2(_context) ? _context.__datetimeFormatters : void 0;
      ctxOptions.__numberFormatters = isPlainObject$2(_context) ? _context.__numberFormatters : void 0;
    }
    const ctx = createCoreContext(ctxOptions);
    _isGlobal && setFallbackContext(ctx);
    return ctx;
  };
  _context = getCoreContext();
  updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
  function trackReactivityValues() {
    return [
      _locale.value,
      _fallbackLocale.value,
      _messages.value,
      _datetimeFormats.value,
      _numberFormats.value
    ];
  }
  const locale = computed({
    get: () => _locale.value,
    set: (val) => {
      _locale.value = val;
      _context.locale = _locale.value;
    }
  });
  const fallbackLocale = computed({
    get: () => _fallbackLocale.value,
    set: (val) => {
      _fallbackLocale.value = val;
      _context.fallbackLocale = _fallbackLocale.value;
      updateFallbackLocale(_context, _locale.value, val);
    }
  });
  const messages = computed(() => _messages.value);
  const datetimeFormats = /* @__PURE__ */ computed(() => _datetimeFormats.value);
  const numberFormats = /* @__PURE__ */ computed(() => _numberFormats.value);
  function getPostTranslationHandler() {
    return isFunction$2(_postTranslation) ? _postTranslation : null;
  }
  function setPostTranslationHandler(handler) {
    _postTranslation = handler;
    _context.postTranslation = handler;
  }
  function getMissingHandler() {
    return _missing;
  }
  function setMissingHandler(handler) {
    if (handler !== null) {
      _runtimeMissing = defineCoreMissingHandler(handler);
    }
    _missing = handler;
    _context.missing = _runtimeMissing;
  }
  const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) => {
    trackReactivityValues();
    let ret;
    try {
      if (__INTLIFY_PROD_DEVTOOLS__) {
        setAdditionalMeta(getMetaInfo());
      }
      if (!_isGlobal) {
        _context.fallbackContext = __root ? getFallbackContext() : void 0;
      }
      ret = fn(_context);
    } finally {
      if (__INTLIFY_PROD_DEVTOOLS__) {
        setAdditionalMeta(null);
      }
      if (!_isGlobal) {
        _context.fallbackContext = void 0;
      }
    }
    if (warnType !== "translate exists" && isNumber$2(ret) && ret === NOT_REOSLVED || warnType === "translate exists" && !ret) {
      const [key, arg2] = argumentParser();
      return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
    } else if (successCondition(ret)) {
      return ret;
    } else {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    }
  };
  function t(...args) {
    return wrapWithDeps((context) => Reflect.apply(translate, null, [context, ...args]), () => parseTranslateArgs(...args), "translate", (root) => Reflect.apply(root.t, root, [...args]), (key) => key, (val) => isString$3(val));
  }
  function rt(...args) {
    const [arg1, arg2, arg3] = args;
    if (arg3 && !isObject$3(arg3)) {
      throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
    }
    return t(...[arg1, arg2, assign$2({ resolvedMessage: true }, arg3 || {})]);
  }
  function d(...args) {
    return wrapWithDeps((context) => Reflect.apply(datetime, null, [context, ...args]), () => parseDateTimeArgs(...args), "datetime format", (root) => Reflect.apply(root.d, root, [...args]), () => MISSING_RESOLVE_VALUE, (val) => isString$3(val));
  }
  function n(...args) {
    return wrapWithDeps((context) => Reflect.apply(number, null, [context, ...args]), () => parseNumberArgs(...args), "number format", (root) => Reflect.apply(root.n, root, [...args]), () => MISSING_RESOLVE_VALUE, (val) => isString$3(val));
  }
  function normalize2(values) {
    return values.map((val) => isString$3(val) || isNumber$2(val) || isBoolean(val) ? createTextNode(String(val)) : val);
  }
  const interpolate = (val) => val;
  const processor = {
    normalize: normalize2,
    interpolate,
    type: "vnode"
  };
  function translateVNode(...args) {
    return wrapWithDeps(
      (context) => {
        let ret;
        const _context2 = context;
        try {
          _context2.processor = processor;
          ret = Reflect.apply(translate, null, [_context2, ...args]);
        } finally {
          _context2.processor = null;
        }
        return ret;
      },
      () => parseTranslateArgs(...args),
      "translate",
      (root) => root[TranslateVNodeSymbol](...args),
      (key) => [createTextNode(key)],
      (val) => isArray$1(val)
    );
  }
  function numberParts(...args) {
    return wrapWithDeps(
      (context) => Reflect.apply(number, null, [context, ...args]),
      () => parseNumberArgs(...args),
      "number format",
      (root) => root[NumberPartsSymbol](...args),
      NOOP_RETURN_ARRAY,
      (val) => isString$3(val) || isArray$1(val)
    );
  }
  function datetimeParts(...args) {
    return wrapWithDeps(
      (context) => Reflect.apply(datetime, null, [context, ...args]),
      () => parseDateTimeArgs(...args),
      "datetime format",
      (root) => root[DatetimePartsSymbol](...args),
      NOOP_RETURN_ARRAY,
      (val) => isString$3(val) || isArray$1(val)
    );
  }
  function setPluralRules(rules2) {
    _pluralRules = rules2;
    _context.pluralRules = _pluralRules;
  }
  function te(key, locale2) {
    return wrapWithDeps(() => {
      if (!key) {
        return false;
      }
      const targetLocale = isString$3(locale2) ? locale2 : _locale.value;
      const message = getLocaleMessage(targetLocale);
      const resolved = _context.messageResolver(message, key);
      return !translateExistCompatible ? isMessageAST(resolved) || isMessageFunction(resolved) || isString$3(resolved) : resolved != null;
    }, () => [key], "translate exists", (root) => {
      return Reflect.apply(root.te, root, [key, locale2]);
    }, NOOP_RETURN_FALSE, (val) => isBoolean(val));
  }
  function resolveMessages(key) {
    let messages2 = null;
    const locales = fallbackWithLocaleChain(_context, _fallbackLocale.value, _locale.value);
    for (let i = 0; i < locales.length; i++) {
      const targetLocaleMessages = _messages.value[locales[i]] || {};
      const messageValue = _context.messageResolver(targetLocaleMessages, key);
      if (messageValue != null) {
        messages2 = messageValue;
        break;
      }
    }
    return messages2;
  }
  function tm(key) {
    const messages2 = resolveMessages(key);
    return messages2 != null ? messages2 : __root ? __root.tm(key) || {} : {};
  }
  function getLocaleMessage(locale2) {
    return _messages.value[locale2] || {};
  }
  function setLocaleMessage(locale2, message) {
    if (flatJson) {
      const _message = { [locale2]: message };
      for (const key in _message) {
        if (hasOwn(_message, key)) {
          handleFlatJson(_message[key]);
        }
      }
      message = _message[locale2];
    }
    _messages.value[locale2] = message;
    _context.messages = _messages.value;
  }
  function mergeLocaleMessage(locale2, message) {
    _messages.value[locale2] = _messages.value[locale2] || {};
    const _message = { [locale2]: message };
    if (flatJson) {
      for (const key in _message) {
        if (hasOwn(_message, key)) {
          handleFlatJson(_message[key]);
        }
      }
    }
    message = _message[locale2];
    deepCopy(message, _messages.value[locale2]);
    _context.messages = _messages.value;
  }
  function getDateTimeFormat(locale2) {
    return _datetimeFormats.value[locale2] || {};
  }
  function setDateTimeFormat(locale2, format2) {
    _datetimeFormats.value[locale2] = format2;
    _context.datetimeFormats = _datetimeFormats.value;
    clearDateTimeFormat(_context, locale2, format2);
  }
  function mergeDateTimeFormat(locale2, format2) {
    _datetimeFormats.value[locale2] = assign$2(_datetimeFormats.value[locale2] || {}, format2);
    _context.datetimeFormats = _datetimeFormats.value;
    clearDateTimeFormat(_context, locale2, format2);
  }
  function getNumberFormat(locale2) {
    return _numberFormats.value[locale2] || {};
  }
  function setNumberFormat(locale2, format2) {
    _numberFormats.value[locale2] = format2;
    _context.numberFormats = _numberFormats.value;
    clearNumberFormat(_context, locale2, format2);
  }
  function mergeNumberFormat(locale2, format2) {
    _numberFormats.value[locale2] = assign$2(_numberFormats.value[locale2] || {}, format2);
    _context.numberFormats = _numberFormats.value;
    clearNumberFormat(_context, locale2, format2);
  }
  composerID++;
  if (__root && inBrowser) {
    watch(__root.locale, (val) => {
      if (_inheritLocale) {
        _locale.value = val;
        _context.locale = val;
        updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
      }
    });
    watch(__root.fallbackLocale, (val) => {
      if (_inheritLocale) {
        _fallbackLocale.value = val;
        _context.fallbackLocale = val;
        updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
      }
    });
  }
  const composer = {
    id: composerID,
    locale,
    fallbackLocale,
    get inheritLocale() {
      return _inheritLocale;
    },
    set inheritLocale(val) {
      _inheritLocale = val;
      if (val && __root) {
        _locale.value = __root.locale.value;
        _fallbackLocale.value = __root.fallbackLocale.value;
        updateFallbackLocale(_context, _locale.value, _fallbackLocale.value);
      }
    },
    get availableLocales() {
      return Object.keys(_messages.value).sort();
    },
    messages,
    get modifiers() {
      return _modifiers;
    },
    get pluralRules() {
      return _pluralRules || {};
    },
    get isGlobal() {
      return _isGlobal;
    },
    get missingWarn() {
      return _missingWarn;
    },
    set missingWarn(val) {
      _missingWarn = val;
      _context.missingWarn = _missingWarn;
    },
    get fallbackWarn() {
      return _fallbackWarn;
    },
    set fallbackWarn(val) {
      _fallbackWarn = val;
      _context.fallbackWarn = _fallbackWarn;
    },
    get fallbackRoot() {
      return _fallbackRoot;
    },
    set fallbackRoot(val) {
      _fallbackRoot = val;
    },
    get fallbackFormat() {
      return _fallbackFormat;
    },
    set fallbackFormat(val) {
      _fallbackFormat = val;
      _context.fallbackFormat = _fallbackFormat;
    },
    get warnHtmlMessage() {
      return _warnHtmlMessage;
    },
    set warnHtmlMessage(val) {
      _warnHtmlMessage = val;
      _context.warnHtmlMessage = val;
    },
    get escapeParameter() {
      return _escapeParameter;
    },
    set escapeParameter(val) {
      _escapeParameter = val;
      _context.escapeParameter = val;
    },
    t,
    getLocaleMessage,
    setLocaleMessage,
    mergeLocaleMessage,
    getPostTranslationHandler,
    setPostTranslationHandler,
    getMissingHandler,
    setMissingHandler,
    [SetPluralRulesSymbol]: setPluralRules
  };
  {
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[InejctWithOptionSymbol] = __injectWithOption;
    composer[TranslateVNodeSymbol] = translateVNode;
    composer[DatetimePartsSymbol] = datetimeParts;
    composer[NumberPartsSymbol] = numberParts;
  }
  return composer;
}
function convertComposerOptions(options) {
  const locale = isString$3(options.locale) ? options.locale : DEFAULT_LOCALE;
  const fallbackLocale = isString$3(options.fallbackLocale) || isArray$1(options.fallbackLocale) || isPlainObject$2(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
  const missing = isFunction$2(options.missing) ? options.missing : void 0;
  const missingWarn = isBoolean(options.silentTranslationWarn) || isRegExp(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
  const fallbackWarn = isBoolean(options.silentFallbackWarn) || isRegExp(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
  const fallbackRoot = isBoolean(options.fallbackRoot) ? options.fallbackRoot : true;
  const fallbackFormat = !!options.formatFallbackMessages;
  const modifiers = isPlainObject$2(options.modifiers) ? options.modifiers : {};
  const pluralizationRules = options.pluralizationRules;
  const postTranslation = isFunction$2(options.postTranslation) ? options.postTranslation : void 0;
  const warnHtmlMessage = isString$3(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
  const escapeParameter = !!options.escapeParameterHtml;
  const inheritLocale = isBoolean(options.sync) ? options.sync : true;
  let messages = options.messages;
  if (isPlainObject$2(options.sharedMessages)) {
    const sharedMessages = options.sharedMessages;
    const locales = Object.keys(sharedMessages);
    messages = locales.reduce((messages2, locale2) => {
      const message = messages2[locale2] || (messages2[locale2] = {});
      assign$2(message, sharedMessages[locale2]);
      return messages2;
    }, messages || {});
  }
  const { __i18n, __root, __injectWithOption } = options;
  const datetimeFormats = options.datetimeFormats;
  const numberFormats = options.numberFormats;
  const flatJson = options.flatJson;
  const translateExistCompatible = options.translateExistCompatible;
  return {
    locale,
    fallbackLocale,
    messages,
    flatJson,
    datetimeFormats,
    numberFormats,
    missing,
    missingWarn,
    fallbackWarn,
    fallbackRoot,
    fallbackFormat,
    modifiers,
    pluralRules: pluralizationRules,
    postTranslation,
    warnHtmlMessage,
    escapeParameter,
    messageResolver: options.messageResolver,
    inheritLocale,
    translateExistCompatible,
    __i18n,
    __root,
    __injectWithOption
  };
}
function createVueI18n(options = {}, VueI18nLegacy) {
  {
    const composer = createComposer(convertComposerOptions(options));
    const { __extender } = options;
    const vueI18n = {
      id: composer.id,
      get locale() {
        return composer.locale.value;
      },
      set locale(val) {
        composer.locale.value = val;
      },
      get fallbackLocale() {
        return composer.fallbackLocale.value;
      },
      set fallbackLocale(val) {
        composer.fallbackLocale.value = val;
      },
      get messages() {
        return composer.messages.value;
      },
      get datetimeFormats() {
        return composer.datetimeFormats.value;
      },
      get numberFormats() {
        return composer.numberFormats.value;
      },
      get availableLocales() {
        return composer.availableLocales;
      },
      get formatter() {
        return {
          interpolate() {
            return [];
          }
        };
      },
      set formatter(val) {
      },
      get missing() {
        return composer.getMissingHandler();
      },
      set missing(handler) {
        composer.setMissingHandler(handler);
      },
      get silentTranslationWarn() {
        return isBoolean(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
      },
      set silentTranslationWarn(val) {
        composer.missingWarn = isBoolean(val) ? !val : val;
      },
      get silentFallbackWarn() {
        return isBoolean(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
      },
      set silentFallbackWarn(val) {
        composer.fallbackWarn = isBoolean(val) ? !val : val;
      },
      get modifiers() {
        return composer.modifiers;
      },
      get formatFallbackMessages() {
        return composer.fallbackFormat;
      },
      set formatFallbackMessages(val) {
        composer.fallbackFormat = val;
      },
      get postTranslation() {
        return composer.getPostTranslationHandler();
      },
      set postTranslation(handler) {
        composer.setPostTranslationHandler(handler);
      },
      get sync() {
        return composer.inheritLocale;
      },
      set sync(val) {
        composer.inheritLocale = val;
      },
      get warnHtmlInMessage() {
        return composer.warnHtmlMessage ? "warn" : "off";
      },
      set warnHtmlInMessage(val) {
        composer.warnHtmlMessage = val !== "off";
      },
      get escapeParameterHtml() {
        return composer.escapeParameter;
      },
      set escapeParameterHtml(val) {
        composer.escapeParameter = val;
      },
      get preserveDirectiveContent() {
        return true;
      },
      set preserveDirectiveContent(val) {
      },
      get pluralizationRules() {
        return composer.pluralRules || {};
      },
      __composer: composer,
      t(...args) {
        const [arg1, arg2, arg3] = args;
        const options2 = {};
        let list = null;
        let named = null;
        if (!isString$3(arg1)) {
          throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        }
        const key = arg1;
        if (isString$3(arg2)) {
          options2.locale = arg2;
        } else if (isArray$1(arg2)) {
          list = arg2;
        } else if (isPlainObject$2(arg2)) {
          named = arg2;
        }
        if (isArray$1(arg3)) {
          list = arg3;
        } else if (isPlainObject$2(arg3)) {
          named = arg3;
        }
        return Reflect.apply(composer.t, composer, [
          key,
          list || named || {},
          options2
        ]);
      },
      rt(...args) {
        return Reflect.apply(composer.rt, composer, [...args]);
      },
      tc(...args) {
        const [arg1, arg2, arg3] = args;
        const options2 = { plural: 1 };
        let list = null;
        let named = null;
        if (!isString$3(arg1)) {
          throw createI18nError(I18nErrorCodes.INVALID_ARGUMENT);
        }
        const key = arg1;
        if (isString$3(arg2)) {
          options2.locale = arg2;
        } else if (isNumber$2(arg2)) {
          options2.plural = arg2;
        } else if (isArray$1(arg2)) {
          list = arg2;
        } else if (isPlainObject$2(arg2)) {
          named = arg2;
        }
        if (isString$3(arg3)) {
          options2.locale = arg3;
        } else if (isArray$1(arg3)) {
          list = arg3;
        } else if (isPlainObject$2(arg3)) {
          named = arg3;
        }
        return Reflect.apply(composer.t, composer, [
          key,
          list || named || {},
          options2
        ]);
      },
      te(key, locale) {
        return composer.te(key, locale);
      },
      tm(key) {
        return composer.tm(key);
      },
      getLocaleMessage(locale) {
        return composer.getLocaleMessage(locale);
      },
      setLocaleMessage(locale, message) {
        composer.setLocaleMessage(locale, message);
      },
      mergeLocaleMessage(locale, message) {
        composer.mergeLocaleMessage(locale, message);
      },
      d(...args) {
        return Reflect.apply(composer.d, composer, [...args]);
      },
      getDateTimeFormat(locale) {
        return composer.getDateTimeFormat(locale);
      },
      setDateTimeFormat(locale, format2) {
        composer.setDateTimeFormat(locale, format2);
      },
      mergeDateTimeFormat(locale, format2) {
        composer.mergeDateTimeFormat(locale, format2);
      },
      n(...args) {
        return Reflect.apply(composer.n, composer, [...args]);
      },
      getNumberFormat(locale) {
        return composer.getNumberFormat(locale);
      },
      setNumberFormat(locale, format2) {
        composer.setNumberFormat(locale, format2);
      },
      mergeNumberFormat(locale, format2) {
        composer.mergeNumberFormat(locale, format2);
      },
      getChoiceIndex(choice, choicesLength) {
        return -1;
      }
    };
    vueI18n.__extender = __extender;
    return vueI18n;
  }
}
const baseFormatProps = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    validator: (val) => val === "parent" || val === "global",
    default: "parent"
  },
  i18n: {
    type: Object
  }
};
function getInterpolateArg({ slots }, keys) {
  if (keys.length === 1 && keys[0] === "default") {
    const ret = slots.default ? slots.default() : [];
    return ret.reduce((slot, current) => {
      return [
        ...slot,
        ...current.type === Fragment ? current.children : [current]
      ];
    }, []);
  } else {
    return keys.reduce((arg, key) => {
      const slot = slots[key];
      if (slot) {
        arg[key] = slot();
      }
      return arg;
    }, {});
  }
}
function getFragmentableTag(tag) {
  return Fragment;
}
const TranslationImpl = /* @__PURE__ */ defineComponent({
  name: "i18n-t",
  props: assign$2({
    keypath: {
      type: String,
      required: true
    },
    plural: {
      type: [Number, String],
      validator: (val) => isNumber$2(val) || !isNaN(val)
    }
  }, baseFormatProps),
  setup(props2, context) {
    const { slots, attrs } = context;
    const i18n = props2.i18n || useI18n({
      useScope: props2.scope,
      __useComponent: true
    });
    return () => {
      const keys = Object.keys(slots).filter((key) => key !== "_");
      const options = {};
      if (props2.locale) {
        options.locale = props2.locale;
      }
      if (props2.plural !== void 0) {
        options.plural = isString$3(props2.plural) ? +props2.plural : props2.plural;
      }
      const arg = getInterpolateArg(context, keys);
      const children = i18n[TranslateVNodeSymbol](props2.keypath, arg, options);
      const assignedAttrs = assign$2({}, attrs);
      const tag = isString$3(props2.tag) || isObject$3(props2.tag) ? props2.tag : getFragmentableTag();
      return h(tag, assignedAttrs, children);
    };
  }
});
const Translation = TranslationImpl;
function isVNode(target) {
  return isArray$1(target) && !isString$3(target[0]);
}
function renderFormatter(props2, context, slotKeys, partFormatter) {
  const { slots, attrs } = context;
  return () => {
    const options = { part: true };
    let overrides = {};
    if (props2.locale) {
      options.locale = props2.locale;
    }
    if (isString$3(props2.format)) {
      options.key = props2.format;
    } else if (isObject$3(props2.format)) {
      if (isString$3(props2.format.key)) {
        options.key = props2.format.key;
      }
      overrides = Object.keys(props2.format).reduce((options2, prop) => {
        return slotKeys.includes(prop) ? assign$2({}, options2, { [prop]: props2.format[prop] }) : options2;
      }, {});
    }
    const parts = partFormatter(...[props2.value, options, overrides]);
    let children = [options.key];
    if (isArray$1(parts)) {
      children = parts.map((part, index2) => {
        const slot = slots[part.type];
        const node = slot ? slot({ [part.type]: part.value, index: index2, parts }) : [part.value];
        if (isVNode(node)) {
          node[0].key = `${part.type}-${index2}`;
        }
        return node;
      });
    } else if (isString$3(parts)) {
      children = [parts];
    }
    const assignedAttrs = assign$2({}, attrs);
    const tag = isString$3(props2.tag) || isObject$3(props2.tag) ? props2.tag : getFragmentableTag();
    return h(tag, assignedAttrs, children);
  };
}
const NumberFormatImpl = /* @__PURE__ */ defineComponent({
  name: "i18n-n",
  props: assign$2({
    value: {
      type: Number,
      required: true
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  setup(props2, context) {
    const i18n = props2.i18n || useI18n({
      useScope: "parent",
      __useComponent: true
    });
    return renderFormatter(props2, context, NUMBER_FORMAT_OPTIONS_KEYS, (...args) => i18n[NumberPartsSymbol](...args));
  }
});
const NumberFormat = NumberFormatImpl;
const DatetimeFormatImpl = /* @__PURE__ */ defineComponent({
  name: "i18n-d",
  props: assign$2({
    value: {
      type: [Number, Date],
      required: true
    },
    format: {
      type: [String, Object]
    }
  }, baseFormatProps),
  setup(props2, context) {
    const i18n = props2.i18n || useI18n({
      useScope: "parent",
      __useComponent: true
    });
    return renderFormatter(props2, context, DATETIME_FORMAT_OPTIONS_KEYS, (...args) => i18n[DatetimePartsSymbol](...args));
  }
});
const DatetimeFormat = DatetimeFormatImpl;
function getComposer$2(i18n, instance2) {
  const i18nInternal = i18n;
  if (i18n.mode === "composition") {
    return i18nInternal.__getInstance(instance2) || i18n.global;
  } else {
    const vueI18n = i18nInternal.__getInstance(instance2);
    return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
  }
}
function vTDirective(i18n) {
  const _process = (binding) => {
    const { instance: instance2, modifiers, value } = binding;
    if (!instance2 || !instance2.$) {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    const composer = getComposer$2(i18n, instance2.$);
    const parsedValue = parseValue(value);
    return [
      Reflect.apply(composer.t, composer, [...makeParams(parsedValue)]),
      composer
    ];
  };
  const register = (el, binding) => {
    const [textContent, composer] = _process(binding);
    if (inBrowser && i18n.global === composer) {
      el.__i18nWatcher = watch(composer.locale, () => {
        binding.instance && binding.instance.$forceUpdate();
      });
    }
    el.__composer = composer;
    el.textContent = textContent;
  };
  const unregister = (el) => {
    if (inBrowser && el.__i18nWatcher) {
      el.__i18nWatcher();
      el.__i18nWatcher = void 0;
      delete el.__i18nWatcher;
    }
    if (el.__composer) {
      el.__composer = void 0;
      delete el.__composer;
    }
  };
  const update2 = (el, { value }) => {
    if (el.__composer) {
      const composer = el.__composer;
      const parsedValue = parseValue(value);
      el.textContent = Reflect.apply(composer.t, composer, [
        ...makeParams(parsedValue)
      ]);
    }
  };
  const getSSRProps = (binding) => {
    const [textContent] = _process(binding);
    return { textContent };
  };
  return {
    created: register,
    unmounted: unregister,
    beforeUpdate: update2,
    getSSRProps
  };
}
function parseValue(value) {
  if (isString$3(value)) {
    return { path: value };
  } else if (isPlainObject$2(value)) {
    if (!("path" in value)) {
      throw createI18nError(I18nErrorCodes.REQUIRED_VALUE, "path");
    }
    return value;
  } else {
    throw createI18nError(I18nErrorCodes.INVALID_VALUE);
  }
}
function makeParams(value) {
  const { path, locale, args, choice, plural } = value;
  const options = {};
  const named = args || {};
  if (isString$3(locale)) {
    options.locale = locale;
  }
  if (isNumber$2(choice)) {
    options.plural = choice;
  }
  if (isNumber$2(plural)) {
    options.plural = plural;
  }
  return [path, named, options];
}
function apply(app, i18n, ...options) {
  const pluginOptions = isPlainObject$2(options[0]) ? options[0] : {};
  const useI18nComponentName = !!pluginOptions.useI18nComponentName;
  const globalInstall = isBoolean(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
  if (globalInstall) {
    [!useI18nComponentName ? Translation.name : "i18n", "I18nT"].forEach((name) => app.component(name, Translation));
    [NumberFormat.name, "I18nN"].forEach((name) => app.component(name, NumberFormat));
    [DatetimeFormat.name, "I18nD"].forEach((name) => app.component(name, DatetimeFormat));
  }
  {
    app.directive("t", vTDirective(i18n));
  }
}
function defineMixin(vuei18n, composer, i18n) {
  return {
    beforeCreate() {
      const instance2 = getCurrentInstance();
      if (!instance2) {
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      }
      const options = this.$options;
      if (options.i18n) {
        const optionsI18n = options.i18n;
        if (options.__i18n) {
          optionsI18n.__i18n = options.__i18n;
        }
        optionsI18n.__root = composer;
        if (this === this.$root) {
          this.$i18n = mergeToGlobal(vuei18n, optionsI18n);
        } else {
          optionsI18n.__injectWithOption = true;
          optionsI18n.__extender = i18n.__vueI18nExtend;
          this.$i18n = createVueI18n(optionsI18n);
          const _vueI18n = this.$i18n;
          if (_vueI18n.__extender) {
            _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
          }
        }
      } else if (options.__i18n) {
        if (this === this.$root) {
          this.$i18n = mergeToGlobal(vuei18n, options);
        } else {
          this.$i18n = createVueI18n({
            __i18n: options.__i18n,
            __injectWithOption: true,
            __extender: i18n.__vueI18nExtend,
            __root: composer
          });
          const _vueI18n = this.$i18n;
          if (_vueI18n.__extender) {
            _vueI18n.__disposer = _vueI18n.__extender(this.$i18n);
          }
        }
      } else {
        this.$i18n = vuei18n;
      }
      if (options.__i18nGlobal) {
        adjustI18nResources(composer, options, options);
      }
      this.$t = (...args) => this.$i18n.t(...args);
      this.$rt = (...args) => this.$i18n.rt(...args);
      this.$tc = (...args) => this.$i18n.tc(...args);
      this.$te = (key, locale) => this.$i18n.te(key, locale);
      this.$d = (...args) => this.$i18n.d(...args);
      this.$n = (...args) => this.$i18n.n(...args);
      this.$tm = (key) => this.$i18n.tm(key);
      i18n.__setInstance(instance2, this.$i18n);
    },
    mounted() {
    },
    unmounted() {
      const instance2 = getCurrentInstance();
      if (!instance2) {
        throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
      }
      const _vueI18n = this.$i18n;
      delete this.$t;
      delete this.$rt;
      delete this.$tc;
      delete this.$te;
      delete this.$d;
      delete this.$n;
      delete this.$tm;
      if (_vueI18n.__disposer) {
        _vueI18n.__disposer();
        delete _vueI18n.__disposer;
        delete _vueI18n.__extender;
      }
      i18n.__deleteInstance(instance2);
      delete this.$i18n;
    }
  };
}
function mergeToGlobal(g, options) {
  g.locale = options.locale || g.locale;
  g.fallbackLocale = options.fallbackLocale || g.fallbackLocale;
  g.missing = options.missing || g.missing;
  g.silentTranslationWarn = options.silentTranslationWarn || g.silentFallbackWarn;
  g.silentFallbackWarn = options.silentFallbackWarn || g.silentFallbackWarn;
  g.formatFallbackMessages = options.formatFallbackMessages || g.formatFallbackMessages;
  g.postTranslation = options.postTranslation || g.postTranslation;
  g.warnHtmlInMessage = options.warnHtmlInMessage || g.warnHtmlInMessage;
  g.escapeParameterHtml = options.escapeParameterHtml || g.escapeParameterHtml;
  g.sync = options.sync || g.sync;
  g.__composer[SetPluralRulesSymbol](options.pluralizationRules || g.pluralizationRules);
  const messages = getLocaleMessages(g.locale, {
    messages: options.messages,
    __i18n: options.__i18n
  });
  Object.keys(messages).forEach((locale) => g.mergeLocaleMessage(locale, messages[locale]));
  if (options.datetimeFormats) {
    Object.keys(options.datetimeFormats).forEach((locale) => g.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
  }
  if (options.numberFormats) {
    Object.keys(options.numberFormats).forEach((locale) => g.mergeNumberFormat(locale, options.numberFormats[locale]));
  }
  return g;
}
const I18nInjectionKey = /* @__PURE__ */ makeSymbol("global-vue-i18n");
function createI18n(options = {}, VueI18nLegacy) {
  const __legacyMode = __VUE_I18N_LEGACY_API__ && isBoolean(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
  const __globalInjection = isBoolean(options.globalInjection) ? options.globalInjection : true;
  const __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
  const __instances = /* @__PURE__ */ new Map();
  const [globalScope, __global] = createGlobal(options, __legacyMode);
  const symbol = /* @__PURE__ */ makeSymbol("");
  function __getInstance(component) {
    return __instances.get(component) || null;
  }
  function __setInstance(component, instance2) {
    __instances.set(component, instance2);
  }
  function __deleteInstance(component) {
    __instances.delete(component);
  }
  {
    const i18n = {
      get mode() {
        return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
      },
      get allowComposition() {
        return __allowComposition;
      },
      async install(app, ...options2) {
        app.__VUE_I18N_SYMBOL__ = symbol;
        app.provide(app.__VUE_I18N_SYMBOL__, i18n);
        if (isPlainObject$2(options2[0])) {
          const opts = options2[0];
          i18n.__composerExtend = opts.__composerExtend;
          i18n.__vueI18nExtend = opts.__vueI18nExtend;
        }
        let globalReleaseHandler = null;
        if (!__legacyMode && __globalInjection) {
          globalReleaseHandler = injectGlobalFields(app, i18n.global);
        }
        if (__VUE_I18N_FULL_INSTALL__) {
          apply(app, i18n, ...options2);
        }
        if (__VUE_I18N_LEGACY_API__ && __legacyMode) {
          app.mixin(defineMixin(__global, __global.__composer, i18n));
        }
        const unmountApp = app.unmount;
        app.unmount = () => {
          globalReleaseHandler && globalReleaseHandler();
          i18n.dispose();
          unmountApp();
        };
      },
      get global() {
        return __global;
      },
      dispose() {
        globalScope.stop();
      },
      __instances,
      __getInstance,
      __setInstance,
      __deleteInstance
    };
    return i18n;
  }
}
function useI18n(options = {}) {
  const instance2 = getCurrentInstance();
  if (instance2 == null) {
    throw createI18nError(I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
  }
  if (!instance2.isCE && instance2.appContext.app != null && !instance2.appContext.app.__VUE_I18N_SYMBOL__) {
    throw createI18nError(I18nErrorCodes.NOT_INSTALLED);
  }
  const i18n = getI18nInstance(instance2);
  const gl = getGlobalComposer(i18n);
  const componentOptions = getComponentOptions(instance2);
  const scope = getScope(options, componentOptions);
  if (__VUE_I18N_LEGACY_API__) {
    if (i18n.mode === "legacy" && !options.__useComponent) {
      if (!i18n.allowComposition) {
        throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
      }
      return useI18nForLegacy(instance2, scope, gl, options);
    }
  }
  if (scope === "global") {
    adjustI18nResources(gl, options, componentOptions);
    return gl;
  }
  if (scope === "parent") {
    let composer2 = getComposer(i18n, instance2, options.__useComponent);
    if (composer2 == null) {
      composer2 = gl;
    }
    return composer2;
  }
  const i18nInternal = i18n;
  let composer = i18nInternal.__getInstance(instance2);
  if (composer == null) {
    const composerOptions = assign$2({}, options);
    if ("__i18n" in componentOptions) {
      composerOptions.__i18n = componentOptions.__i18n;
    }
    if (gl) {
      composerOptions.__root = gl;
    }
    composer = createComposer(composerOptions);
    if (i18nInternal.__composerExtend) {
      composer[DisposeSymbol] = i18nInternal.__composerExtend(composer);
    }
    setupLifeCycle(i18nInternal, instance2, composer);
    i18nInternal.__setInstance(instance2, composer);
  }
  return composer;
}
function createGlobal(options, legacyMode, VueI18nLegacy) {
  const scope = effectScope();
  {
    const obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(() => createVueI18n(options)) : scope.run(() => createComposer(options));
    if (obj == null) {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    return [scope, obj];
  }
}
function getI18nInstance(instance2) {
  {
    const i18n = inject(!instance2.isCE ? instance2.appContext.app.__VUE_I18N_SYMBOL__ : I18nInjectionKey);
    if (!i18n) {
      throw createI18nError(!instance2.isCE ? I18nErrorCodes.UNEXPECTED_ERROR : I18nErrorCodes.NOT_INSTALLED_WITH_PROVIDE);
    }
    return i18n;
  }
}
function getScope(options, componentOptions) {
  return isEmptyObject(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function getGlobalComposer(i18n) {
  return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
function getComposer(i18n, target, useComponent = false) {
  let composer = null;
  const root = target.root;
  let current = getParentComponentInstance(target, useComponent);
  while (current != null) {
    const i18nInternal = i18n;
    if (i18n.mode === "composition") {
      composer = i18nInternal.__getInstance(current);
    } else {
      if (__VUE_I18N_LEGACY_API__) {
        const vueI18n = i18nInternal.__getInstance(current);
        if (vueI18n != null) {
          composer = vueI18n.__composer;
          if (useComponent && composer && !composer[InejctWithOptionSymbol]) {
            composer = null;
          }
        }
      }
    }
    if (composer != null) {
      break;
    }
    if (root === current) {
      break;
    }
    current = current.parent;
  }
  return composer;
}
function getParentComponentInstance(target, useComponent = false) {
  if (target == null) {
    return null;
  }
  {
    return !useComponent ? target.parent : target.vnode.ctx || target.parent;
  }
}
function setupLifeCycle(i18n, target, composer) {
  {
    onMounted(() => {
    }, target);
    onUnmounted(() => {
      const _composer = composer;
      i18n.__deleteInstance(target);
      const dispose = _composer[DisposeSymbol];
      if (dispose) {
        dispose();
        delete _composer[DisposeSymbol];
      }
    }, target);
  }
}
function useI18nForLegacy(instance2, scope, root, options = {}) {
  const isLocalScope = scope === "local";
  const _composer = shallowRef(null);
  if (isLocalScope && instance2.proxy && !(instance2.proxy.$options.i18n || instance2.proxy.$options.__i18n)) {
    throw createI18nError(I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  }
  const _inheritLocale = isBoolean(options.inheritLocale) ? options.inheritLocale : !isString$3(options.locale);
  const _locale = ref(
    !isLocalScope || _inheritLocale ? root.locale.value : isString$3(options.locale) ? options.locale : DEFAULT_LOCALE
  );
  const _fallbackLocale = ref(
    !isLocalScope || _inheritLocale ? root.fallbackLocale.value : isString$3(options.fallbackLocale) || isArray$1(options.fallbackLocale) || isPlainObject$2(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value
  );
  const _messages = ref(getLocaleMessages(_locale.value, options));
  const _datetimeFormats = ref(isPlainObject$2(options.datetimeFormats) ? options.datetimeFormats : { [_locale.value]: {} });
  const _numberFormats = ref(isPlainObject$2(options.numberFormats) ? options.numberFormats : { [_locale.value]: {} });
  const _missingWarn = isLocalScope ? root.missingWarn : isBoolean(options.missingWarn) || isRegExp(options.missingWarn) ? options.missingWarn : true;
  const _fallbackWarn = isLocalScope ? root.fallbackWarn : isBoolean(options.fallbackWarn) || isRegExp(options.fallbackWarn) ? options.fallbackWarn : true;
  const _fallbackRoot = isLocalScope ? root.fallbackRoot : isBoolean(options.fallbackRoot) ? options.fallbackRoot : true;
  const _fallbackFormat = !!options.fallbackFormat;
  const _missing = isFunction$2(options.missing) ? options.missing : null;
  const _postTranslation = isFunction$2(options.postTranslation) ? options.postTranslation : null;
  const _warnHtmlMessage = isLocalScope ? root.warnHtmlMessage : isBoolean(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
  const _escapeParameter = !!options.escapeParameter;
  const _modifiers = isLocalScope ? root.modifiers : isPlainObject$2(options.modifiers) ? options.modifiers : {};
  const _pluralRules = options.pluralRules || isLocalScope && root.pluralRules;
  function trackReactivityValues() {
    return [
      _locale.value,
      _fallbackLocale.value,
      _messages.value,
      _datetimeFormats.value,
      _numberFormats.value
    ];
  }
  const locale = computed({
    get: () => {
      return _composer.value ? _composer.value.locale.value : _locale.value;
    },
    set: (val) => {
      if (_composer.value) {
        _composer.value.locale.value = val;
      }
      _locale.value = val;
    }
  });
  const fallbackLocale = computed({
    get: () => {
      return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
    },
    set: (val) => {
      if (_composer.value) {
        _composer.value.fallbackLocale.value = val;
      }
      _fallbackLocale.value = val;
    }
  });
  const messages = computed(() => {
    if (_composer.value) {
      return _composer.value.messages.value;
    } else {
      return _messages.value;
    }
  });
  const datetimeFormats = computed(() => _datetimeFormats.value);
  const numberFormats = computed(() => _numberFormats.value);
  function getPostTranslationHandler() {
    return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
  }
  function setPostTranslationHandler(handler) {
    if (_composer.value) {
      _composer.value.setPostTranslationHandler(handler);
    }
  }
  function getMissingHandler() {
    return _composer.value ? _composer.value.getMissingHandler() : _missing;
  }
  function setMissingHandler(handler) {
    if (_composer.value) {
      _composer.value.setMissingHandler(handler);
    }
  }
  function warpWithDeps(fn) {
    trackReactivityValues();
    return fn();
  }
  function t(...args) {
    return _composer.value ? warpWithDeps(() => Reflect.apply(_composer.value.t, null, [...args])) : warpWithDeps(() => "");
  }
  function rt(...args) {
    return _composer.value ? Reflect.apply(_composer.value.rt, null, [...args]) : "";
  }
  function d(...args) {
    return _composer.value ? warpWithDeps(() => Reflect.apply(_composer.value.d, null, [...args])) : warpWithDeps(() => "");
  }
  function n(...args) {
    return _composer.value ? warpWithDeps(() => Reflect.apply(_composer.value.n, null, [...args])) : warpWithDeps(() => "");
  }
  function tm(key) {
    return _composer.value ? _composer.value.tm(key) : {};
  }
  function te(key, locale2) {
    return _composer.value ? _composer.value.te(key, locale2) : false;
  }
  function getLocaleMessage(locale2) {
    return _composer.value ? _composer.value.getLocaleMessage(locale2) : {};
  }
  function setLocaleMessage(locale2, message) {
    if (_composer.value) {
      _composer.value.setLocaleMessage(locale2, message);
      _messages.value[locale2] = message;
    }
  }
  function mergeLocaleMessage(locale2, message) {
    if (_composer.value) {
      _composer.value.mergeLocaleMessage(locale2, message);
    }
  }
  function getDateTimeFormat(locale2) {
    return _composer.value ? _composer.value.getDateTimeFormat(locale2) : {};
  }
  function setDateTimeFormat(locale2, format2) {
    if (_composer.value) {
      _composer.value.setDateTimeFormat(locale2, format2);
      _datetimeFormats.value[locale2] = format2;
    }
  }
  function mergeDateTimeFormat(locale2, format2) {
    if (_composer.value) {
      _composer.value.mergeDateTimeFormat(locale2, format2);
    }
  }
  function getNumberFormat(locale2) {
    return _composer.value ? _composer.value.getNumberFormat(locale2) : {};
  }
  function setNumberFormat(locale2, format2) {
    if (_composer.value) {
      _composer.value.setNumberFormat(locale2, format2);
      _numberFormats.value[locale2] = format2;
    }
  }
  function mergeNumberFormat(locale2, format2) {
    if (_composer.value) {
      _composer.value.mergeNumberFormat(locale2, format2);
    }
  }
  const wrapper = {
    get id() {
      return _composer.value ? _composer.value.id : -1;
    },
    locale,
    fallbackLocale,
    messages,
    datetimeFormats,
    numberFormats,
    get inheritLocale() {
      return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
    },
    set inheritLocale(val) {
      if (_composer.value) {
        _composer.value.inheritLocale = val;
      }
    },
    get availableLocales() {
      return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
    },
    get modifiers() {
      return _composer.value ? _composer.value.modifiers : _modifiers;
    },
    get pluralRules() {
      return _composer.value ? _composer.value.pluralRules : _pluralRules;
    },
    get isGlobal() {
      return _composer.value ? _composer.value.isGlobal : false;
    },
    get missingWarn() {
      return _composer.value ? _composer.value.missingWarn : _missingWarn;
    },
    set missingWarn(val) {
      if (_composer.value) {
        _composer.value.missingWarn = val;
      }
    },
    get fallbackWarn() {
      return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
    },
    set fallbackWarn(val) {
      if (_composer.value) {
        _composer.value.missingWarn = val;
      }
    },
    get fallbackRoot() {
      return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
    },
    set fallbackRoot(val) {
      if (_composer.value) {
        _composer.value.fallbackRoot = val;
      }
    },
    get fallbackFormat() {
      return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
    },
    set fallbackFormat(val) {
      if (_composer.value) {
        _composer.value.fallbackFormat = val;
      }
    },
    get warnHtmlMessage() {
      return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
    },
    set warnHtmlMessage(val) {
      if (_composer.value) {
        _composer.value.warnHtmlMessage = val;
      }
    },
    get escapeParameter() {
      return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
    },
    set escapeParameter(val) {
      if (_composer.value) {
        _composer.value.escapeParameter = val;
      }
    },
    t,
    getPostTranslationHandler,
    setPostTranslationHandler,
    getMissingHandler,
    setMissingHandler,
    rt,
    d,
    n,
    tm,
    te,
    getLocaleMessage,
    setLocaleMessage,
    mergeLocaleMessage,
    getDateTimeFormat,
    setDateTimeFormat,
    mergeDateTimeFormat,
    getNumberFormat,
    setNumberFormat,
    mergeNumberFormat
  };
  function sync(composer) {
    composer.locale.value = _locale.value;
    composer.fallbackLocale.value = _fallbackLocale.value;
    Object.keys(_messages.value).forEach((locale2) => {
      composer.mergeLocaleMessage(locale2, _messages.value[locale2]);
    });
    Object.keys(_datetimeFormats.value).forEach((locale2) => {
      composer.mergeDateTimeFormat(locale2, _datetimeFormats.value[locale2]);
    });
    Object.keys(_numberFormats.value).forEach((locale2) => {
      composer.mergeNumberFormat(locale2, _numberFormats.value[locale2]);
    });
    composer.escapeParameter = _escapeParameter;
    composer.fallbackFormat = _fallbackFormat;
    composer.fallbackRoot = _fallbackRoot;
    composer.fallbackWarn = _fallbackWarn;
    composer.missingWarn = _missingWarn;
    composer.warnHtmlMessage = _warnHtmlMessage;
  }
  onBeforeMount(() => {
    if (instance2.proxy == null || instance2.proxy.$i18n == null) {
      throw createI18nError(I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    }
    const composer = _composer.value = instance2.proxy.$i18n.__composer;
    if (scope === "global") {
      _locale.value = composer.locale.value;
      _fallbackLocale.value = composer.fallbackLocale.value;
      _messages.value = composer.messages.value;
      _datetimeFormats.value = composer.datetimeFormats.value;
      _numberFormats.value = composer.numberFormats.value;
    } else if (isLocalScope) {
      sync(composer);
    }
  });
  return wrapper;
}
const globalExportProps = [
  "locale",
  "fallbackLocale",
  "availableLocales"
];
const globalExportMethods = ["t", "rt", "d", "n", "tm", "te"];
function injectGlobalFields(app, composer) {
  const i18n = /* @__PURE__ */ Object.create(null);
  globalExportProps.forEach((prop) => {
    const desc = Object.getOwnPropertyDescriptor(composer, prop);
    if (!desc) {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    const wrap = isRef(desc.value) ? {
      get() {
        return desc.value.value;
      },
      set(val) {
        desc.value.value = val;
      }
    } : {
      get() {
        return desc.get && desc.get();
      }
    };
    Object.defineProperty(i18n, prop, wrap);
  });
  app.config.globalProperties.$i18n = i18n;
  globalExportMethods.forEach((method) => {
    const desc = Object.getOwnPropertyDescriptor(composer, method);
    if (!desc || !desc.value) {
      throw createI18nError(I18nErrorCodes.UNEXPECTED_ERROR);
    }
    Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
  });
  const dispose = () => {
    delete app.config.globalProperties.$i18n;
    globalExportMethods.forEach((method) => {
      delete app.config.globalProperties[`$${method}`];
    });
  };
  return dispose;
}
{
  initFeatureFlags();
}
if (__INTLIFY_JIT_COMPILATION__) {
  registerMessageCompiler(compile);
} else {
  registerMessageCompiler(compileToFunction);
}
registerMessageResolver(resolveValue);
registerLocaleFallbacker(fallbackWithLocaleChain);
if (__INTLIFY_PROD_DEVTOOLS__) {
  const target = getGlobalThis();
  target.__INTLIFY__ = true;
  setDevToolsHook(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source2 = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source2), true).forEach(function(key) {
        _defineProperty$1(target, key, source2[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source2));
    } else {
      ownKeys$1(Object(source2)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source2, key));
      });
    }
  }
  return target;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$1 = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$1(obj);
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source2 = arguments[i];
      for (var key in source2) {
        if (Object.prototype.hasOwnProperty.call(source2, key)) {
          target[key] = source2[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source2, excluded) {
  if (source2 == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source2);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source2[key];
  }
  return target;
}
function _objectWithoutProperties(source2, excluded) {
  if (source2 == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source2, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source2);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source2, key))
        continue;
      target[key] = source2[key];
    }
  }
  return target;
}
var version$1 = "1.14.0";
function userAgent(pattern) {
  if (typeof window !== "undefined" && window.navigator) {
    return !!/* @__PURE__ */ navigator.userAgent.match(pattern);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
  capture: false,
  passive: false
};
function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(el, selector) {
  if (!selector)
    return;
  selector[0] === ">" && (selector = selector.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_2) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(el, selector, ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx)
        break;
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass$1(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? "add" : "remove"](name);
    } else {
      var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
      el.className = (className + (state ? " " + name : "")).replace(R_SPACE, " ");
    }
  }
}
function css(el, prop, val) {
  var style = el && el.style;
  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, "");
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf("webkit") === -1) {
        prop = "-webkit-" + prop;
      }
      style[prop] = val + (typeof val === "string" ? "" : "px");
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = "";
  if (typeof el === "string") {
    appliedTransforms = el;
  } else {
    do {
      var transform2 = css(el, "transform");
      if (transform2 && transform2 !== "none") {
        appliedTransforms = transform2 + " " + appliedTransforms;
      }
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window)
    return;
  var elRect, top, left, bottom, right, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    container = container || el.parentNode;
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
          var containerRect = container.getBoundingClientRect();
          top -= containerRect.top + parseInt(css(container, "border-top-width"));
          left -= containerRect.left + parseInt(css(container, "border-left-width"));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    var elMatrix = matrix(container || el), scaleX2 = elMatrix && elMatrix.a, scaleY2 = elMatrix && elMatrix.d;
    if (elMatrix) {
      top /= scaleY2;
      left /= scaleX2;
      width /= scaleX2;
      height /= scaleY2;
      bottom = top + height;
      right = left + width;
    }
  }
  return {
    top,
    left,
    bottom,
    right,
    width,
    height
  };
}
function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
  while (parent) {
    var parentSideVal = getRect(parent)[parentSide], visible = void 0;
    if (parentSide === "top" || parentSide === "left") {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }
    if (!visible)
      return parent;
    if (parent === getWindowScrollingElement())
      break;
    parent = getParentAutoScrollElement(parent, false);
  }
  return false;
}
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0, i = 0, children = el.children;
  while (i < children.length) {
    if (children[i].style.display !== "none" && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }
      currentChild++;
    }
    i++;
  }
  return null;
}
function lastChild(el, selector) {
  var last = el.lastElementChild;
  while (last && (last === Sortable.ghost || css(last, "display") === "none" || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }
  return last || null;
}
function index$2(el, selector) {
  var index2 = 0;
  if (!el || !el.parentNode) {
    return -1;
  }
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index2++;
    }
  }
  return index2;
}
function getRelativeScrollOffset(el) {
  var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el), scaleX2 = elMatrix.a, scaleY2 = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX2;
      offsetTop += el.scrollTop * scaleY2;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}
function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i))
      continue;
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key])
        return Number(i);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  if (!el || !el.getBoundingClientRect)
    return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
        if (!elem.getBoundingClientRect || elem === document.body)
          return getWindowScrollingElement();
        if (gotSelf || includeSelf)
          return elem;
        gotSelf = true;
      }
    }
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend$1(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
  return function() {
    if (!_throttleTimeout) {
      var args = arguments, _this = this;
      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
var expando = "Sortable" + new Date().getTime();
function AnimationStateManager() {
  var animationStates = [], animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation)
        return;
      var children = [].slice.call(this.el.children);
      children.forEach(function(child) {
        if (css(child, "display") === "none" || child === Sortable.ghost)
          return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2$1({}, animationStates[animationStates.length - 1].rect);
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === "function")
          callback();
        return;
      }
      var animating = false, animationTime = 0;
      animationStates.forEach(function(state) {
        var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
        if (targetMatrix) {
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function() {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === "function")
          callback();
      } else {
        animationCallbackId = setTimeout(function() {
          if (typeof callback === "function")
            callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, "transition", "");
        css(target, "transform", "");
        var elMatrix = matrix(this.el), scaleX2 = elMatrix && elMatrix.a, scaleY2 = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX2 || 1), translateY = (currentRect.top - toRect.top) / (scaleY2 || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
        this.forRepaintDummy = repaint(target);
        css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
        css(target, "transform", "translate3d(0,0,0)");
        typeof target.animated === "number" && clearTimeout(target.animated);
        target.animated = setTimeout(function() {
          css(target, "transition", "");
          css(target, "transform", "");
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults$4 = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    for (var option2 in defaults$4) {
      if (defaults$4.hasOwnProperty(option2) && !(option2 in plugin)) {
        plugin[option2] = defaults$4[option2];
      }
    }
    plugins.forEach(function(p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent2(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function() {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + "Global";
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName])
        return;
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2$1({
          sortable
        }, evt));
      }
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2$1({
          sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
    plugins.forEach(function(plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault)
        return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;
      _extends(defaults2, initialized.defaults);
    });
    for (var option2 in sortable.options) {
      if (!sortable.options.hasOwnProperty(option2))
        continue;
      var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
      if (typeof modified !== "undefined") {
        sortable.options[option2] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function(plugin) {
      if (typeof plugin.eventProperties !== "function")
        return;
      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName])
        return;
      if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};
function dispatchEvent$1(_ref) {
  var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl2 && rootEl2[expando];
  if (!sortable)
    return;
  var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl2;
  evt.from = fromEl || rootEl2;
  evt.item = targetEl || rootEl2;
  evt.clone = cloneEl2;
  evt.oldIndex = oldIndex2;
  evt.newIndex = newIndex2;
  evt.oldDraggableIndex = oldDraggableIndex2;
  evt.newDraggableIndex = newDraggableIndex2;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
  var allEventProperties = _objectSpread2$1(_objectSpread2$1({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
  for (var option2 in allEventProperties) {
    evt[option2] = allEventProperties[option2];
  }
  if (rootEl2) {
    rootEl2.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}
var _excluded = ["evt"];
var pluginEvent = function pluginEvent3(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data2 = _objectWithoutProperties(_ref, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2$1({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable,
        name,
        originalEvent
      });
    }
  }, data2));
};
function _dispatchEvent(info) {
  dispatchEvent$1(_objectSpread2$1({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = false, savedInputChecked = [];
var documentExists = typeof document !== "undefined", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
  if (!documentExists)
    return;
  if (IE11OrLess) {
    return false;
  }
  var el = document.createElement("x");
  el.style.cssText = "pointer-events:auto";
  return el.style.pointerEvents === "auto";
}(), _detectDirection = function _detectDirection2(el, options) {
  var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
  if (elCSS.display === "flex") {
    return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  }
  if (elCSS.display === "grid") {
    return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  }
  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
    var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
    return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
  }
  return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, _detectNearestEmptySortable = function _detectNearestEmptySortable2(x, y) {
  var ret;
  sortables.some(function(sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable))
      return;
    var rect = getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
}, _prepareGroup = function _prepareGroup2(options) {
  function toFn(value, pull) {
    return function(to, from, dragEl2, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
      if (value == null && (pull || sameGroup)) {
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === "clone") {
        return value;
      } else if (typeof value === "function") {
        return toFn(value(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }
  var group = {};
  var originalGroup = options.group;
  if (!originalGroup || _typeof$1(originalGroup) != "object") {
    originalGroup = {
      name: originalGroup
    };
  }
  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "none");
  }
}, _unhideGhostForTarget = function _unhideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "");
  }
};
if (documentExists) {
  document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      var event = {};
      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el;
  this.options = options = _extends({}, options);
  el[expando] = this;
  var defaults2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    invertSwap: false,
    invertedSwapThreshold: null,
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData2(dataTransfer, dragEl2) {
      dataTransfer.setData("Text", dragEl2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults2);
  for (var name in defaults2) {
    !(name in options) && (options[name] = defaults2[name]);
  }
  _prepareGroup(options);
  for (var fn in this) {
    if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
      this[fn] = this[fn].bind(this);
    }
  }
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    this.options.touchStartThreshold = 1;
  }
  if (options.supportPointer) {
    on(el, "pointerdown", this._onTapStart);
  } else {
    on(el, "mousedown", this._onTapStart);
    on(el, "touchstart", this._onTapStart);
  }
  if (this.nativeDraggable) {
    on(el, "dragover", this);
    on(el, "dragenter", this);
  }
  sortables.push(this.el);
  options.store && options.store.get && this.sort(options.store.get(this) || []);
  _extends(this, AnimationStateManager());
}
Sortable.prototype = {
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(evt) {
    if (!evt.cancelable)
      return;
    var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
    _saveInputCheckedState(el);
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return;
    }
    if (originalTarget.isContentEditable) {
      return;
    }
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === "SELECT") {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      return;
    }
    oldIndex = index$2(target);
    oldDraggableIndex = index$2(target, options.draggable);
    if (typeof filter === "function") {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: "filter",
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent("filter", _this, {
          evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    } else if (filter) {
      filter = filter.split(",").some(function(criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: "filter",
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent("filter", _this, {
            evt
          });
          return true;
        }
      });
      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(evt, touch, target) {
    var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style["will-change"] = "all";
      dragStartFn = function dragStartFn2() {
        pluginEvent("delayEnded", _this, {
          evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }
        _this._triggerDragStart(evt, touch);
        _dispatchEvent({
          sortable: _this,
          name: "choose",
          originalEvent: evt
        });
        toggleClass$1(dragEl, options.chosenClass, true);
      };
      options.ignore.split(",").forEach(function(criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mouseup", _this._onDrop);
      on(ownerDocument, "touchend", _this._onDrop);
      on(ownerDocument, "touchcancel", _this._onDrop);
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent("delayStart", this, {
        evt
      });
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        on(ownerDocument, "mouseup", _this._disableDelayedDrag);
        on(ownerDocument, "touchend", _this._disableDelayedDrag);
        on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
        on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
        on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._disableDelayedDrag);
    off(ownerDocument, "touchend", this._disableDelayedDrag);
    off(ownerDocument, "touchcancel", this._disableDelayedDrag);
    off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(evt, touch) {
    touch = touch || evt.pointerType == "touch" && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, "pointermove", this._onTouchMove);
      } else if (touch) {
        on(document, "touchmove", this._onTouchMove);
      } else {
        on(document, "mousemove", this._onTouchMove);
      }
    } else {
      on(dragEl, "dragend", this);
      on(rootEl, "dragstart", this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function() {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {
    }
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent("dragStarted", this, {
        evt
      });
      if (this.nativeDraggable) {
        on(document, "dragover", _checkOutsideTargetEl);
      }
      var options = this.options;
      !fallback && toggleClass$1(dragEl, options.dragClass, false);
      toggleClass$1(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();
      _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent)
          break;
        parent = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target,
              rootEl: parent
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent;
        } while (parent = parent.parentNode);
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(evt) {
    if (tapEvt) {
      var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX2 = ghostEl && ghostMatrix && ghostMatrix.a, scaleY2 = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX2 || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX2 || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY2 || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY2 || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, "webkitTransform", cssMatrix);
        css(ghostEl, "mozTransform", cssMatrix);
        css(ghostEl, "msTransform", cssMatrix);
        css(ghostEl, "transform", cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
      if (PositionGhostAbsolutely) {
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document)
            ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass$1(ghostEl, options.ghostClass, false);
      toggleClass$1(ghostEl, options.fallbackClass, true);
      toggleClass$1(ghostEl, options.dragClass, true);
      css(ghostEl, "transition", "");
      css(ghostEl, "transform", "");
      css(ghostEl, "box-sizing", "border-box");
      css(ghostEl, "margin", 0);
      css(ghostEl, "top", rect.top);
      css(ghostEl, "left", rect.left);
      css(ghostEl, "width", rect.width);
      css(ghostEl, "height", rect.height);
      css(ghostEl, "opacity", "0.8");
      css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
      css(ghostEl, "zIndex", "100000");
      css(ghostEl, "pointerEvents", "none");
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);
      css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(evt, fallback) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent("dragStart", this, {
      evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent("setupClone", this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style["will-change"] = "";
      this._hideClone();
      toggleClass$1(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }
    _this.cloneId = _nextTick(function() {
      pluginEvent("clone", _this);
      if (Sortable.eventCanceled)
        return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: "clone"
      });
    });
    !fallback && toggleClass$1(dragEl, options.dragClass, true);
    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      off(document, "mouseup", _this._onDrop);
      off(document, "touchend", _this._onDrop);
      off(document, "touchcancel", _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = "move";
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on(document, "drop", _this);
      css(dragEl, "transform", "translateZ(0)");
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, "selectstart", _this);
    moved = true;
    if (Safari) {
      css(document.body, "user-select", "none");
    }
  },
  _onDragOver: function _onDragOver(evt) {
    var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
    if (_silent)
      return;
    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread2$1({
        evt,
        isOwner,
        axis: vertical ? "vertical" : "horizontal",
        revert,
        dragRect,
        targetRect,
        canSort,
        fromSortable,
        target,
        completed,
        onMove: function onMove(target2, after2) {
          return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
        },
        changed
      }, extra));
    }
    function capture() {
      dragOverEvent("dragOverAnimationCapture");
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }
    function completed(insertion) {
      dragOverEvent("dragOverCompleted", {
        insertion
      });
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          toggleClass$1(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass$1(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function() {
          dragOverEvent("dragOverAnimationComplete");
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }
    function changed() {
      newIndex = index$2(dragEl);
      newDraggableIndex = index$2(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: "change",
        toEl: el,
        newIndex,
        newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent("dragOver");
    if (Sortable.eventCanceled)
      return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === "vertical";
      dragRect = getRect(dragEl);
      dragOverEvent("dragOverValid");
      if (Sortable.eventCanceled)
        return completedFired;
      if (revert) {
        parentEl = rootEl;
        capture();
        this._hideClone();
        dragOverEvent("revert");
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        if (elLastChild === dragEl) {
          return completed(false);
        }
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction !== 0) {
          var dragIndex = index$2(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
        }
        if (direction === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling, after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode;
          if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, "mousemove", this._onTouchMove);
    off(document, "touchmove", this._onTouchMove);
    off(document, "pointermove", this._onTouchMove);
    off(document, "dragover", nearestEmptyInsertDetectEvent);
    off(document, "mousemove", nearestEmptyInsertDetectEvent);
    off(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._onDrop);
    off(ownerDocument, "touchend", this._onDrop);
    off(ownerDocument, "pointerup", this._onDrop);
    off(ownerDocument, "touchcancel", this._onDrop);
    off(document, "selectstart", this);
  },
  _onDrop: function _onDrop(evt) {
    var el = this.el, options = this.options;
    newIndex = index$2(dragEl);
    newDraggableIndex = index$2(dragEl, options.draggable);
    pluginEvent("drop", this, {
      evt
    });
    parentEl = dragEl && dragEl.parentNode;
    newIndex = index$2(dragEl);
    newDraggableIndex = index$2(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);
    if (this.nativeDraggable) {
      off(document, "drop", this);
      off(el, "dragstart", this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, "user-select", "");
    }
    css(dragEl, "transform", "");
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, "dragend", this);
        }
        _disableDraggable(dragEl);
        dragEl.style["will-change"] = "";
        if (moved && !awaitingDragStarted) {
          toggleClass$1(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass$1(dragEl, this.options.chosenClass, false);
        _dispatchEvent({
          sortable: this,
          name: "unchoose",
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            _dispatchEvent({
              rootEl: parentEl,
              name: "add",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "remove",
              toEl: parentEl,
              originalEvent: evt
            });
            _dispatchEvent({
              rootEl: parentEl,
              name: "sort",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "sort",
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              _dispatchEvent({
                sortable: this,
                name: "update",
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: "sort",
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: "end",
            toEl: parentEl,
            originalEvent: evt
          });
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent("nulling", this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function(el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(evt) {
    switch (evt.type) {
      case "drop":
      case "dragend":
        this._onDrop(evt);
        break;
      case "dragenter":
      case "dragover":
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case "selectstart":
        evt.preventDefault();
        break;
    }
  },
  toArray: function toArray() {
    var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
    for (; i < n; i++) {
      el = children[i];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  sort: function sort(order, useAnimation) {
    var items = {}, rootEl2 = this.el;
    this.toArray().forEach(function(id, i) {
      var el = rootEl2.children[i];
      if (closest(el, this.options.draggable, rootEl2, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function(id) {
      if (items[id]) {
        rootEl2.removeChild(items[id]);
        rootEl2.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },
  option: function option(name, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);
      if (typeof modifiedValue !== "undefined") {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }
      if (name === "group") {
        _prepareGroup(options);
      }
    }
  },
  destroy: function destroy() {
    pluginEvent("destroy", this);
    var el = this.el;
    el[expando] = null;
    off(el, "mousedown", this._onTapStart);
    off(el, "touchstart", this._onTapStart);
    off(el, "pointerdown", this._onTapStart);
    if (this.nativeDraggable) {
      off(el, "dragover", this);
      off(el, "dragenter", this);
    }
    Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
      el2.removeAttribute("draggable");
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent("hideClone", this);
      if (Sortable.eventCanceled)
        return;
      css(cloneEl, "display", "none");
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable2) {
    if (putSortable2.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent("showClone", this);
      if (Sortable.eventCanceled)
        return;
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, "display", "");
      cloneHidden = false;
    }
  }
};
function _globalDragOver(evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = "move";
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent("move", {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent("move", true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl2;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
  if (!invertSwap) {
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}
function _getInsertDirection(target) {
  if (index$2(dragEl) < index$2(target)) {
    return 1;
  } else {
    return -1;
  }
}
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum2 = 0;
  while (i--) {
    sum2 += str.charCodeAt(i);
  }
  return sum2.toString(36);
}
function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName("input");
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn) {
  return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}
if (documentExists) {
  on(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}
Sortable.utils = {
  on,
  off,
  css,
  find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend$1,
  throttle,
  closest,
  toggleClass: toggleClass$1,
  clone,
  index: index$2,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild
};
Sortable.get = function(element) {
  return element[expando];
};
Sortable.mount = function() {
  for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins2[_key] = arguments[_key];
  }
  if (plugins2[0].constructor === Array)
    plugins2 = plugins2[0];
  plugins2.forEach(function(plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils)
      Sortable.utils = _objectSpread2$1(_objectSpread2$1({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
Sortable.create = function(el, options) {
  return new Sortable(el, options);
};
Sortable.version = version$1;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var fn in this) {
      if (fn.charAt(0) === "_" && typeof this[fn] === "function") {
        this[fn] = this[fn].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on(document, "dragover", this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, "pointermove", this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, "touchmove", this._handleFallbackAutoScroll);
        } else {
          on(document, "mousemove", this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop3() {
      if (this.sortable.nativeDraggable) {
        off(document, "dragover", this._handleAutoScroll);
      } else {
        off(document, "pointermove", this._handleFallbackAutoScroll);
        off(document, "touchmove", this._handleFallbackAutoScroll);
        off(document, "mousemove", this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;
      var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt;
      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback);
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          pointerElemChangedInterval = setInterval(function() {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(autoScroll2) {
    clearInterval(autoScroll2.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(evt, options, rootEl2, isFallback) {
  if (!options.scroll)
    return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
  var scrollThisInstance = false, scrollCustomFn;
  if (scrollRootEl !== rootEl2) {
    scrollRootEl = rootEl2;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
    }
    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        autoScrolls[layersOut].pid = setInterval(function() {
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1);
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === "function") {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
  var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent)
    return;
  var toSortable = putSortable2 || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent("spill");
    this.onSpill({
      dragEl: dragEl2,
      putSortable: putSortable2
    });
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex2 = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex2;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable2) {
      putSortable2.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl2, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl2);
    }
    this.sortable.animateAll();
    if (putSortable2) {
      putSortable2.animateAll();
    }
  },
  drop
};
_extends(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function onSpill2(_ref4) {
    var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
    var parentSortable = putSortable2 || this.sortable;
    parentSortable.captureAnimationState();
    dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
    parentSortable.animateAll();
  },
  drop
};
_extends(Remove, {
  pluginName: "removeOnSpill"
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}
function insertNodeAt(fatherNode, node, position) {
  const refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}
function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }
  return global.console;
}
const console$1 = getConsole();
function cached(fn) {
  const cache2 = /* @__PURE__ */ Object.create(null);
  return function cachedFn(str) {
    const hit = cache2[str];
    return hit || (cache2[str] = fn(str));
  };
}
const regex = /-(\w)/g;
const camelize = cached((str) => str.replace(regex, (_2, c) => c.toUpperCase()));
const manageAndEmit$1 = ["Start", "Add", "Remove", "Update", "End"];
const emit$1 = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
const manage$1 = ["Move"];
const eventHandlerNames = [manage$1, manageAndEmit$1, emit$1].flatMap((events2) => events2).map((evt) => `on${evt}`);
const events$1 = {
  manage: manage$1,
  manageAndEmit: manageAndEmit$1,
  emit: emit$1
};
function isReadOnly(eventName) {
  return eventHandlerNames.indexOf(eventName) !== -1;
}
const tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "math",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rb",
  "rp",
  "rt",
  "rtc",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "slot",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "svg",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
];
function isHtmlTag(name) {
  return tags.includes(name);
}
function isTransition(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}
function isHtmlAttribute(value) {
  return ["id", "class", "role", "style"].includes(value) || value.startsWith("data-") || value.startsWith("aria-") || value.startsWith("on");
}
function project(entries) {
  return entries.reduce((res, [key, value]) => {
    res[key] = value;
    return res;
  }, {});
}
function getComponentAttributes({ $attrs, componentData = {} }) {
  const attributes = project(
    Object.entries($attrs).filter(([key, _2]) => isHtmlAttribute(key))
  );
  return {
    ...attributes,
    ...componentData
  };
}
function createSortableOption({ $attrs, callBackBuilder }) {
  const options = project(getValidSortableEntries($attrs));
  Object.entries(callBackBuilder).forEach(([eventType, eventBuilder]) => {
    events$1[eventType].forEach((event) => {
      options[`on${event}`] = eventBuilder(event);
    });
  });
  const draggable = `[data-draggable]${options.draggable || ""}`;
  return {
    ...options,
    draggable
  };
}
function getValidSortableEntries(value) {
  return Object.entries(value).filter(([key, _2]) => !isHtmlAttribute(key)).map(([key, value2]) => [camelize(key), value2]).filter(([key, _2]) => !isReadOnly(key));
}
const getHtmlElementFromNode = ({ el }) => el;
const addContext = (domElement, context) => domElement.__draggable_context = context;
const getContext = (domElement) => domElement.__draggable_context;
class ComponentStructure {
  constructor({
    nodes: { header, default: defaultNodes, footer },
    root,
    realList
  }) {
    this.defaultNodes = defaultNodes;
    this.children = [...header, ...defaultNodes, ...footer];
    this.externalComponent = root.externalComponent;
    this.rootTransition = root.transition;
    this.tag = root.tag;
    this.realList = realList;
  }
  get _isRootComponent() {
    return this.externalComponent || this.rootTransition;
  }
  render(h2, attributes) {
    const { tag, children, _isRootComponent } = this;
    const option2 = !_isRootComponent ? children : { default: () => children };
    return h2(tag, attributes, option2);
  }
  updated() {
    const { defaultNodes, realList } = this;
    defaultNodes.forEach((node, index2) => {
      addContext(getHtmlElementFromNode(node), {
        element: realList[index2],
        index: index2
      });
    });
  }
  getUnderlyingVm(domElement) {
    return getContext(domElement);
  }
  getVmIndexFromDomIndex(domIndex, element) {
    const { defaultNodes } = this;
    const { length } = defaultNodes;
    const domChildren = element.children;
    const domElement = domChildren.item(domIndex);
    if (domElement === null) {
      return length;
    }
    const context = getContext(domElement);
    if (context) {
      return context.index;
    }
    if (length === 0) {
      return 0;
    }
    const firstDomListElement = getHtmlElementFromNode(defaultNodes[0]);
    const indexFirstDomListElement = [...domChildren].findIndex(
      (element2) => element2 === firstDomListElement
    );
    return domIndex < indexFirstDomListElement ? 0 : length;
  }
}
function getSlot(slots, key) {
  const slotValue = slots[key];
  return slotValue ? slotValue() : [];
}
function computeNodes({ $slots, realList, getKey }) {
  const normalizedList = realList || [];
  const [header, footer] = ["header", "footer"].map(
    (name) => getSlot($slots, name)
  );
  const { item } = $slots;
  if (!item) {
    throw new Error("draggable element must have an item slot");
  }
  const defaultNodes = normalizedList.flatMap(
    (element, index2) => item({ element, index: index2 }).map((node) => {
      node.key = getKey(element);
      node.props = { ...node.props || {}, "data-draggable": true };
      return node;
    })
  );
  if (defaultNodes.length !== normalizedList.length) {
    throw new Error("Item slot must have only one child");
  }
  return {
    header,
    footer,
    default: defaultNodes
  };
}
function getRootInformation(tag) {
  const transition = isTransition(tag);
  const externalComponent = !isHtmlTag(tag) && !transition;
  return {
    transition,
    externalComponent,
    tag: externalComponent ? resolveComponent(tag) : transition ? TransitionGroup : tag
  };
}
function computeComponentStructure({ $slots, tag, realList, getKey }) {
  const nodes = computeNodes({ $slots, realList, getKey });
  const root = getRootInformation(tag);
  return new ComponentStructure({ nodes, root, realList });
}
function emit(evtName, evtData) {
  nextTick(() => this.$emit(evtName.toLowerCase(), evtData));
}
function manage(evtName) {
  return (evtData, originalElement) => {
    if (this.realList !== null) {
      return this[`onDrag${evtName}`](evtData, originalElement);
    }
  };
}
function manageAndEmit(evtName) {
  const delegateCallBack = manage.call(this, evtName);
  return (evtData, originalElement) => {
    delegateCallBack.call(this, evtData, originalElement);
    emit.call(this, evtName, evtData);
  };
}
let draggingElement = null;
const props = {
  list: {
    type: Array,
    required: false,
    default: null
  },
  modelValue: {
    type: Array,
    required: false,
    default: null
  },
  itemKey: {
    type: [String, Function],
    required: true
  },
  clone: {
    type: Function,
    default: (original) => {
      return original;
    }
  },
  tag: {
    type: String,
    default: "div"
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
const emits = [
  "update:modelValue",
  "change",
  ...[...events$1.manageAndEmit, ...events$1.emit].map((evt) => evt.toLowerCase())
];
const draggableComponent = defineComponent({
  name: "draggable",
  inheritAttrs: false,
  props,
  emits,
  data() {
    return {
      error: false
    };
  },
  render() {
    try {
      this.error = false;
      const { $slots, $attrs, tag, componentData, realList, getKey } = this;
      const componentStructure = computeComponentStructure({
        $slots,
        tag,
        realList,
        getKey
      });
      this.componentStructure = componentStructure;
      const attributes = getComponentAttributes({ $attrs, componentData });
      return componentStructure.render(h, attributes);
    } catch (err) {
      this.error = true;
      return h("pre", { style: { color: "red" } }, err.stack);
    }
  },
  created() {
    if (this.list !== null && this.modelValue !== null) {
      console$1.error(
        "modelValue and list props are mutually exclusive! Please set one or another."
      );
    }
  },
  mounted() {
    if (this.error) {
      return;
    }
    const { $attrs, $el, componentStructure } = this;
    componentStructure.updated();
    const sortableOptions = createSortableOption({
      $attrs,
      callBackBuilder: {
        manageAndEmit: (event) => manageAndEmit.call(this, event),
        emit: (event) => emit.bind(this, event),
        manage: (event) => manage.call(this, event)
      }
    });
    const targetDomElement = $el.nodeType === 1 ? $el : $el.parentElement;
    this._sortable = new Sortable(targetDomElement, sortableOptions);
    this.targetDomElement = targetDomElement;
    targetDomElement.__draggable_component__ = this;
  },
  updated() {
    this.componentStructure.updated();
  },
  beforeUnmount() {
    if (this._sortable !== void 0)
      this._sortable.destroy();
  },
  computed: {
    realList() {
      const { list } = this;
      return list ? list : this.modelValue;
    },
    getKey() {
      const { itemKey } = this;
      if (typeof itemKey === "function") {
        return itemKey;
      }
      return (element) => element[itemKey];
    }
  },
  watch: {
    $attrs: {
      handler(newOptionValue) {
        const { _sortable } = this;
        if (!_sortable)
          return;
        getValidSortableEntries(newOptionValue).forEach(([key, value]) => {
          _sortable.option(key, value);
        });
      },
      deep: true
    }
  },
  methods: {
    getUnderlyingVm(domElement) {
      return this.componentStructure.getUnderlyingVm(domElement) || null;
    },
    getUnderlyingPotencialDraggableComponent(htmElement) {
      return htmElement.__draggable_component__;
    },
    emitChanges(evt) {
      nextTick(() => this.$emit("change", evt));
    },
    alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }
      const newList = [...this.modelValue];
      onList(newList);
      this.$emit("update:modelValue", newList);
    },
    spliceList() {
      const spliceList = (list) => list.splice(...arguments);
      this.alterList(spliceList);
    },
    updatePosition(oldIndex2, newIndex2) {
      const updatePosition = (list) => list.splice(newIndex2, 0, list.splice(oldIndex2, 1)[0]);
      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent({ to, related }) {
      const component = this.getUnderlyingPotencialDraggableComponent(to);
      if (!component) {
        return { component };
      }
      const list = component.realList;
      const context = { list, component };
      if (to !== related && list) {
        const destination = component.getUnderlyingVm(related) || {};
        return { ...destination, ...context };
      }
      return context;
    },
    getVmIndexFromDomIndex(domIndex) {
      return this.componentStructure.getVmIndexFromDomIndex(
        domIndex,
        this.targetDomElement
      );
    },
    onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd(evt) {
      const element = evt.item._underlying_vm_;
      if (element === void 0) {
        return;
      }
      removeNode(evt.item);
      const newIndex2 = this.getVmIndexFromDomIndex(evt.newIndex);
      this.spliceList(newIndex2, 0, element);
      const added = { element, newIndex: newIndex2 };
      this.emitChanges({ added });
    },
    onDragRemove(evt) {
      insertNodeAt(this.$el, evt.item, evt.oldIndex);
      if (evt.pullMode === "clone") {
        removeNode(evt.clone);
        return;
      }
      const { index: oldIndex2, element } = this.context;
      this.spliceList(oldIndex2, 1);
      const removed = { element, oldIndex: oldIndex2 };
      this.emitChanges({ removed });
    },
    onDragUpdate(evt) {
      removeNode(evt.item);
      insertNodeAt(evt.from, evt.item, evt.oldIndex);
      const oldIndex2 = this.context.index;
      const newIndex2 = this.getVmIndexFromDomIndex(evt.newIndex);
      this.updatePosition(oldIndex2, newIndex2);
      const moved2 = { element: this.context.element, oldIndex: oldIndex2, newIndex: newIndex2 };
      this.emitChanges({ moved: moved2 });
    },
    computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }
      const domChildren = [...evt.to.children].filter(
        (el) => el.style["display"] !== "none"
      );
      const currentDomIndex = domChildren.indexOf(evt.related);
      const currentIndex = relatedContext.component.getVmIndexFromDomIndex(
        currentDomIndex
      );
      const draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove(evt, originalEvent) {
      const { move: move2, realList } = this;
      if (!move2 || !realList) {
        return true;
      }
      const relatedContext = this.getRelatedContextFromMoveEvent(evt);
      const futureIndex = this.computeFutureIndex(relatedContext, evt);
      const draggedContext = {
        ...this.context,
        futureIndex
      };
      const sendEvent = {
        ...evt,
        relatedContext,
        draggedContext
      };
      return move2(sendEvent, originalEvent);
    },
    onDragEnd() {
      draggingElement = null;
    }
  }
});
const loadJs = (url) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = url;
    script.type = "text/javascript";
    document.body.appendChild(script);
    script.onload = () => {
      resolve();
    };
  });
};
const generateKeyToTD = (rows) => {
  for (let i = 0; i < rows.length; i++) {
    for (let j = 0; j < rows[i].columns.length; j++) {
      rows[i].columns[j].key = Math.random().toString(36).slice(-8);
    }
  }
  return rows;
};
const generateKeyToTH = (row) => {
  for (let i = 0; i < row.length; i++) {
    row[i].key = Math.random().toString(36).slice(-8);
  }
  return row;
};
const generateKeyToCol = (columns) => {
  for (let i = 0; i < columns.length; i++) {
    columns[i].key = Math.random().toString(36).slice(-8);
  }
  return columns;
};
const splitStyleSheets = (str) => {
  if (!str) {
    return [];
  }
  let r = /}\s+./;
  let arr = str.split(r).filter((item) => item);
  return arr.map((sty) => {
    sty = sty.trim();
    if (sty[0] !== ".") {
      sty = "." + sty;
    }
    if (sty[sty.length - 1] !== "}") {
      sty = sty + "}";
    }
    return sty;
  });
};
const splitSheetName = (sheets) => {
  return Array.from(new Set(sheets.map((sheet) => {
    let spaceIndex = sheet.indexOf(" ");
    let nameIndex = sheet.indexOf("{");
    let index2 = nameIndex;
    if (spaceIndex > 0 && spaceIndex < nameIndex) {
      index2 = spaceIndex;
    }
    sheet = sheet.substring(1, index2);
    return sheet;
  })));
};
const updateStyleSheets = (sheets, head) => {
  let stylesheets = document.styleSheets[0];
  if (stylesheets.href) {
    let head2 = document.head || document.getElementsByTagName("head")[0];
    let style = document.createElement("style");
    style.type = "text/css";
    head2.appendChild(style);
    stylesheets = style.sheet || style.styleSheet;
  }
  let index2 = 0;
  while (stylesheets.cssRules.length > index2) {
    if (stylesheets.cssRules[index2].selectorText && stylesheets.cssRules[index2].selectorText.indexOf(head) === 0) {
      stylesheets.deleteRule(index2);
    } else {
      index2++;
    }
  }
  for (let i = 0; i < sheets.length; i++) {
    stylesheets.insertRule(head + sheets[i], 0);
  }
};
const clearStyleSheets = (head) => {
  let stylesheets = document.styleSheets[0];
  if (stylesheets.href) {
    return false;
  }
  let index2 = 0;
  while (stylesheets.cssRules.length > index2) {
    if (stylesheets.cssRules[index2].selectorText && stylesheets.cssRules[index2].selectorText.indexOf(head) === 0) {
      stylesheets.deleteRule(index2);
    } else {
      index2++;
    }
  }
};
const fixDraggbleList = (list, newIndex2) => {
  const listIndex = list.findIndex((item) => !item.key);
  if (listIndex >= 0) {
    list.splice(newIndex2, 0, list.splice(listIndex, 1)[0]);
  }
};
const getBindModels = (models, binds) => {
  let resData = {};
  Object.keys(binds).forEach((item) => {
    if (typeof binds[item] === "object" && models[item]) {
      if (Array.isArray(models[item])) {
        resData[item] = models[item].map((mitem) => {
          return getBindModels(mitem, binds[item]);
        });
      } else {
        resData[item] = getBindModels(models[item], binds[item]);
      }
    } else {
      resData[item] = models[item];
    }
  });
  return resData;
};
const addClass$1 = (el, className) => {
  el.classList.add(className);
};
const removeClass$1 = (el, className) => {
  el.classList.remove(className);
};
const consoleError = (msg) => {
  Function(`
    window.console && console.error('[FormMaking error]: ${msg}');
  `)();
};
var index_vue_vue_type_style_index_0_lang$8 = "";
var _export_sfc = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props2) {
    target[key] = val;
  }
  return target;
};
const _sfc_main$15 = {
  name: "code-editor",
  props: {
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    mode: {
      type: String,
      default: "xml"
    },
    modelValue: {
      type: [String, Object, Array]
    },
    fontSize: {
      type: Number,
      default: 13
    },
    wrap: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      id: "code_" + Math.random().toString(36).slice(-8),
      codeValue: this.modelValue,
      loading: true,
      observer: null,
      editor: null
    };
  },
  computed: {
    aceMode() {
      switch (this.mode) {
        case "xml":
          return "ace/mode/xml";
        case "html":
          return "ace/mode/html";
        case "json":
          return "ace/mode/json";
        case "css":
          return "ace/mode/css";
        case "javascript":
          return "ace/mode/javascript";
        case "tsx":
          return "ace/mode/tsx";
        default:
          return "ace/mode/xml";
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (window.ace) {
        this.loadEditor();
      } else {
        loadJs(`${window.FormMaking_OPTIONS.aceurl}/ace.js`).then(() => {
          loadJs(`${window.FormMaking_OPTIONS.aceurl}/ext-language_tools.js`).then(() => {
            this.loadEditor();
          });
        });
      }
      this.observer = new MutationObserver((mutationsList, observer) => {
        this.loadEditor();
      });
      this.observer.observe(document.getElementsByTagName("html")[0], { attributes: true });
    }, 0);
  },
  methods: {
    loadEditor() {
      this.loading = false;
      ace.require("ace/ext/language_tools");
      this.editor = ace.edit(this.$refs[this.id + "Ref"]);
      this.editor.session.setMode(this.aceMode);
      this.editor.setFontSize(this.fontSize);
      this.editor.getSession().setTabSize(2);
      this.editor.setShowPrintMargin(false);
      this.wrap && this.editor.getSession().setUseWrapMode(true);
      if (document.querySelector("html").className.indexOf("dark") > -1) {
        this.editor.setTheme("ace/theme/nord_dark");
      } else {
        this.editor.setTheme("ace/theme/textmate");
      }
      this.editor.setOptions({
        enableSnippets: true,
        enableLiveAutocompletion: true
      });
      this.editor.commands.addCommand({
        name: "myCommand",
        bindKey: { win: "Ctrl-Enter", mac: "Command-Enter" },
        exec: function(editor2) {
          editor2.selection.getCursor();
          editor2.selection.moveCursorLineEnd();
          editor2.selection.moveTo(editor2.selection.getCursor().row, editor2.selection.getCursor().column);
          editor2.session.insert(editor2.getCursorPosition(), "\n");
        }
      });
      this.editor.setValue(typeof this.codeValue === "string" ? this.codeValue : JSON.stringify(this.codeValue, null, "	"), -1);
      this.editor.on("change", (e) => {
        this.codeValue = this.editor.getValue();
      });
      this.editor.on("paste", (e) => {
        this.mode === "json" && setTimeout(() => {
          this.editor.setValue(JSON.stringify(JSON.parse(e.text), null, 2), -1);
        });
      });
    },
    setValue(value) {
      this.editor.setValue(JSON.stringify(JSON.parse(value), null, 2), -1);
    }
  },
  beforeUnmount() {
    var _a2, _b, _c;
    (_a2 = this.observer) == null ? void 0 : _a2.disconnect();
    (_b = this.editor) == null ? void 0 : _b.destroy();
    (_c = this.editor) == null ? void 0 : _c.container.remove();
  },
  watch: {
    modelValue(val) {
      this.codeValue = val;
    },
    codeValue(val) {
      this.$emit("update:modelValue", val);
    }
  }
};
const _hoisted_1$J = ["id"];
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_loading = resolveDirective("loading");
  return withDirectives((openBlock(), createElementBlock("div", {
    id: $data.id,
    class: "fm-code-editor",
    style: normalizeStyle({ width: $props.width, height: $props.height }),
    ref: $data.id + "Ref"
  }, null, 12, _hoisted_1$J)), [
    [_directive_loading, $data.loading]
  ]);
}
var CodeEditor = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["render", _sfc_render$12]]);
var CusDialog_vue_vue_type_style_index_0_lang = "";
const _sfc_main$14 = {
  props: {
    visible: Boolean,
    loadingText: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "600px"
    },
    form: {
      type: Boolean,
      default: true
    },
    action: {
      type: Boolean,
      default: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ""
    },
    beforeClose: Function
  },
  emits: ["on-submit", "on-close"],
  computed: {
    show() {
      if (this.form) {
        return this.showForm;
      } else {
        return true;
      }
    }
  },
  data() {
    return {
      loading: false,
      dialogVisible: this.visible,
      showForm: false
    };
  },
  methods: {
    close() {
      this.dialogVisible = false;
    },
    submit() {
      this.loading = true;
      this.$emit("on-submit");
    },
    end() {
      this.loading = false;
    }
  },
  mounted() {
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.loading = false;
        this.$emit("on-close");
        setTimeout(() => {
          this.showForm = false;
        }, 300);
      } else {
        this.showForm = true;
      }
    },
    visible(val) {
      this.dialogVisible = val;
    }
  }
};
const _hoisted_1$I = { key: 0 };
const _hoisted_2$D = ["element-loading-text"];
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = resolveComponent("el-button");
  const _component_el_dialog = resolveComponent("el-dialog");
  const _directive_loading = resolveDirective("loading");
  return openBlock(), createBlock(_component_el_dialog, {
    class: normalizeClass($props.customClass + " cus-dialog-container fm-dialog"),
    title: $props.title,
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.dialogVisible = $event),
    "close-on-click-modal": $props.closeOnClickModal,
    "close-on-press-escape": $props.closeOnPressEscape,
    "append-to-body": true,
    center: "",
    width: $props.width,
    ref: "elDialog",
    fullscreen: $props.fullscreen,
    top: "10vh",
    draggable: "",
    "destroy-on-close": "",
    "before-close": $props.beforeClose
  }, createSlots({
    default: withCtx(() => [
      $options.show ? (openBlock(), createElementBlock("span", _hoisted_1$I, [
        renderSlot(_ctx.$slots, "default")
      ])) : createCommentVNode("", true)
    ]),
    _: 2
  }, [
    $props.action ? {
      name: "footer",
      fn: withCtx(() => [
        withDirectives((openBlock(), createElementBlock("span", {
          class: "dialog-footer",
          "element-loading-text": $props.loadingText
        }, [
          renderSlot(_ctx.$slots, "action", {}, () => [
            createVNode(_component_el_button, { onClick: $options.close }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.submit
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.confirm")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 8, _hoisted_2$D)), [
          [_directive_loading, $data.loading]
        ])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["class", "title", "modelValue", "close-on-click-modal", "close-on-press-escape", "width", "fullscreen", "before-close"]);
}
var CusDialog = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["render", _sfc_render$11]]);
var CodeDialog_vue_vue_type_style_index_0_lang = "";
const _sfc_main$13 = {
  components: {
    CusDialog,
    CodeEditor
  },
  props: {
    mode: {
      type: String,
      default: "xml"
    },
    title: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "900px"
    },
    codeHeight: {
      type: String,
      default: "460px"
    }
  },
  emits: ["on-confirm"],
  data() {
    return {
      templateVisible: false,
      templ: ""
    };
  },
  methods: {
    handleSubmit() {
      this.$emit("on-confirm", this.templ);
    },
    open(val) {
      this.templ = val;
      this.templateVisible = true;
    },
    close() {
      this.templateVisible = false;
    },
    end() {
      this.$refs["codeDialog"].end();
    },
    handleHelp() {
      window.open(this.help);
    }
  }
};
const _hoisted_1$H = {
  key: 0,
  class: "code-dialog-help"
};
const _hoisted_2$C = /* @__PURE__ */ createElementVNode("i", { class: "el-icon-question el-icon--right" }, null, -1);
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_code_editor = resolveComponent("code-editor");
  const _component_el_button = resolveComponent("el-button");
  const _component_cus_dialog = resolveComponent("cus-dialog");
  return openBlock(), createBlock(_component_cus_dialog, {
    visible: $data.templateVisible,
    onOnClose: _cache[1] || (_cache[1] = ($event) => $data.templateVisible = false),
    ref: "codeDialog",
    width: $props.width,
    title: $props.title,
    onOnSubmit: $options.handleSubmit,
    "custom-class": "code-dialog-container"
  }, {
    default: withCtx(() => [
      createVNode(_component_code_editor, {
        height: $props.codeHeight,
        mode: this.mode,
        modelValue: $data.templ,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.templ = $event)
      }, null, 8, ["height", "mode", "modelValue"]),
      $props.help ? (openBlock(), createElementBlock("div", _hoisted_1$H, [
        createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $options.handleHelp
        }, {
          default: withCtx(() => [
            createTextVNode("\u5E2E\u52A9"),
            _hoisted_2$C
          ]),
          _: 1
        }, 8, ["onClick"])
      ])) : createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "width", "title", "onOnSubmit"]);
}
var CodeDialog = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["render", _sfc_render$10]]);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module, exports) {
  (function() {
    var undefined$1;
    var VERSION2 = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply2(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        var value = array[index2];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (iteratee(array[index2], index2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (comparator(value, array[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index2 < length) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index2 = -1, length = values.length, offset = array.length;
      while (++index2 < length) {
        array[offset + index2] = values[index2];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index2 = -1, length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index2];
      }
      while (++index2 < length) {
        accumulator = iteratee(accumulator, array[index2], index2, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length = array == null ? 0 : array.length;
      while (++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string) {
      return string.split("");
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (comparator(array[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index2 = -1, length = array.length;
      while (++index2 < length) {
        var current = iteratee(array[index2]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n, iteratee) {
      var index2 = -1, result = Array(n);
      while (++index2 < n) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object, props2) {
      return arrayMap(props2, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object, props2) {
      return arrayMap(props2, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache2, key) {
      return cache2.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length = strSymbols.length;
      while (++index2 < length && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array, placeholder) {
      var length = array.length, result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data2, result = [];
      while (!(data2 = iterator.next()).done) {
        result.push(data2.value);
      }
      return result;
    }
    function mapToArray(map) {
      var index2 = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg(func, transform2) {
      return function(arg) {
        return func(transform2(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index2 = -1, length = array.length, resIndex = 0, result = [];
      while (++index2 < length) {
        var value = array[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index2 = fromIndex - 1, length = array.length;
      while (++index2 < length) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index2 = string.length;
      while (index2-- && reWhitespace.test(string.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root : _2.defaults(root.Object(), context, _2.pick(root, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty2 = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root._;
      var reIsNative = RegExp2(
        "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      var Buffer = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap && new WeakMap();
      var realNames = {};
      var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object() {
        }
        return function(proto) {
          if (!isObject2(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result2 = new object();
          object.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        "escape": reEscape,
        "evaluate": reEvaluate,
        "interpolate": reInterpolate,
        "variable": "",
        "imports": {
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view2 = getView(0, arrLength, this.__views__), start = view2.start, end = view2.end, length = end - start, index2 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array[index2];
            while (++iterIndex < iterLength) {
              var data2 = iteratees[iterIndex], iteratee2 = data2.iteratee, type = data2.type, computed2 = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed2;
              } else if (!computed2) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet(key) {
        var data2 = this.__data__;
        if (nativeCreate) {
          var result2 = data2[key];
          return result2 === HASH_UNDEFINED ? undefined$1 : result2;
        }
        return hasOwnProperty2.call(data2, key) ? data2[key] : undefined$1;
      }
      function hashHas(key) {
        var data2 = this.__data__;
        return nativeCreate ? data2[key] !== undefined$1 : hasOwnProperty2.call(data2, key);
      }
      function hashSet(key, value) {
        var data2 = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data2[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data2 = this.__data__, index2 = assocIndexOf(data2, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data2.length - 1;
        if (index2 == lastIndex) {
          data2.pop();
        } else {
          splice.call(data2, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data2 = this.__data__, index2 = assocIndexOf(data2, key);
        return index2 < 0 ? undefined$1 : data2[index2][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data2 = this.__data__, index2 = assocIndexOf(data2, key);
        if (index2 < 0) {
          ++this.size;
          data2.push([key, value]);
        } else {
          data2[index2][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index2 = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result2 = getMapData(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data2 = getMapData(this, key), size2 = data2.size;
        data2.set(key, value);
        this.size += data2.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index2 = -1, length = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index2 < length) {
          this.add(values2[index2]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data2 = this.__data__ = new ListCache(entries);
        this.size = data2.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data2 = this.__data__, result2 = data2["delete"](key);
        this.size = data2.size;
        return result2;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data2 = this.__data__;
        if (data2 instanceof ListCache) {
          var pairs = data2.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data2.size;
            return this;
          }
          data2 = this.__data__ = new MapCache(pairs);
        }
        data2.set(key, value);
        this.size = data2.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer2(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source2) {
        return object && copyObject(source2, keys(source2), object);
      }
      function baseAssignIn(object, source2) {
        return object && copyObject(source2, keysIn(source2), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index2 = -1, length = paths.length, result2 = Array2(length), skip = object == null;
        while (++index2 < length) {
          result2[index2] = skip ? undefined$1 : get(object, paths[index2]);
        }
        return result2;
      }
      function baseClamp(number2, lower, upper) {
        if (number2 === number2) {
          if (upper !== undefined$1) {
            number2 = number2 <= upper ? number2 : upper;
          }
          if (lower !== undefined$1) {
            number2 = number2 >= lower ? number2 : lower;
          }
        }
        return number2;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result2 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result2);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer2(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result2 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props2 = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props2 || value, function(subValue, key2) {
          if (props2) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source2) {
        var props2 = keys(source2);
        return function(object) {
          return baseConformsTo(object, source2, props2);
        };
      }
      function baseConformsTo(object, source2, props2) {
        var length = props2.length;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (length--) {
          var key = props2[length], predicate = source2[key], value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
        if (!length) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed2 = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed2 === computed2) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed2) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values2, computed2, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index2 = -1, length = array.length;
        while (++index2 < length) {
          var value = array[index2], current = iteratee2(value);
          if (current != null && (computed2 === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed2))) {
            var computed2 = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index2 = -1, length = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys);
      }
      function baseFunctions(object, props2) {
        return arrayFilter(props2, function(key) {
          return isFunction2(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index2 = 0, length = path.length;
        while (object != null && index2 < length) {
          object = object[toKey(path[index2++])];
        }
        return index2 && index2 == length ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray2(object) ? result2 : arrayPush(result2, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString2(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty2.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number2, start, end) {
        return number2 >= nativeMin(start, end) && number2 < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length && result2.length < maxLength) {
            var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed2) : includes2(result2, computed2, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache2 = caches[othIndex];
                if (!(cache2 ? cacheHas(cache2, computed2) : includes2(arrays[othIndex], computed2, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed2);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply2(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer2(object)) {
          if (!isBuffer2(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source2, matchData, customizer) {
        var index2 = matchData.length, length = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object2(object);
        while (index2--) {
          var data2 = matchData[index2];
          if (noCustomizer && data2[2] ? data2[1] !== object[data2[0]] : !(data2[0] in object)) {
            return false;
          }
        }
        while (++index2 < length) {
          data2 = matchData[index2];
          var key = data2[0], objValue = object[key], srcValue = data2[1];
          if (noCustomizer && data2[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source2, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject2(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty2.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object) {
        if (!isObject2(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches(source2) {
        var matchData = getMatchData(source2);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source2 || baseIsMatch(object, source2, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source2, srcIndex, customizer, stack) {
        if (object === source2) {
          return;
        }
        baseFor(source2, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject2(srcValue)) {
            baseMergeDeep(object, source2, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source2, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source2, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source2, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source2, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer2(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index2 = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index2 = -1, length = paths.length, result2 = {};
        while (++index2 < length) {
          var path = paths[index2], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result2, castPath(path, object), value);
          }
        }
        return result2;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values2, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length = values2.length, seen = array;
        if (array === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index2 < length) {
          var fromIndex = 0, value = values2[index2], computed2 = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf2(seen, computed2, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0, lastIndex = length - 1;
        while (length--) {
          var index2 = indexes[length];
          if (length == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex(index2)) {
              splice.call(array, index2, 1);
            } else {
              baseUnset(array, index2);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index2 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
        while (length--) {
          result2[fromRight ? length : ++index2] = start;
          start += step;
        }
        return result2;
      }
      function baseRepeat(string, n) {
        var result2 = "";
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result2;
        }
        do {
          if (n % 2) {
            result2 += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);
        return result2;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject2(object)) {
          return object;
        }
        path = castPath(path, object);
        var index2 = -1, length = path.length, lastIndex = length - 1, nested = object;
        while (nested != null && ++index2 < length) {
          var key = toKey(path[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data2) {
        metaMap.set(func, data2);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function(func, string) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start, end) {
        var index2 = -1, length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result2 = Array2(length);
        while (++index2 < length) {
          result2[index2] = array[index2 + start];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed2 = array[mid];
            if (computed2 !== null && !isSymbol(computed2) && (retHighest ? computed2 <= value : computed2 < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed2 = iteratee2(array[mid]), othIsDefined = computed2 !== undefined$1, othIsNull = computed2 === null, othIsReflexive = computed2 === computed2, othIsSymbol = isSymbol(computed2);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed2 <= value : computed2 < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index2 = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq(computed2, seen)) {
            var seen = computed2;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set2 = iteratee2 ? null : createSet(array);
          if (set2) {
            return setToArray(set2);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length) {
            var value = array[index2], computed2 = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed2 === computed2) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed2) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed2);
              }
              result2.push(value);
            } else if (!includes2(seen, computed2, comparator)) {
              if (seen !== result2) {
                seen.push(computed2);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length, index2 = fromRight ? length : -1;
        while ((fromRight ? index2-- : ++index2 < length) && predicate(array[index2], index2, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length);
        while (++index2 < length) {
          var array = arrays[index2], othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props2, values2, assignFunc) {
        var index2 = -1, length = props2.length, valsLength = values2.length, result2 = {};
        while (++index2 < length) {
          var value = index2 < valsLength ? values2[index2] : undefined$1;
          assignFunc(result2, props2[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString3(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order = orders[index2];
            return result2 * (order == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source2, array) {
        var index2 = -1, length = source2.length;
        array || (array = Array2(length));
        while (++index2 < length) {
          array[index2] = source2[index2];
        }
        return array;
      }
      function copyObject(source2, props2, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length = props2.length;
        while (++index2 < length) {
          var key = props2[index2];
          var newValue = customizer ? customizer(object[key], source2[key], key, object, source2) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source2[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source2, object) {
        return copyObject(source2, getSymbols(source2), object);
      }
      function copySymbolsIn(source2, object) {
        return copyObject(source2, getSymbolsIn(source2), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined$1, guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object2(object);
          while (++index2 < length) {
            var source2 = sources[index2];
            if (source2) {
              assigner(object, source2, index2, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length = collection.length, index2 = fromRight ? length : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object), props2 = keysFunc(object), length = props2.length;
          while (length--) {
            var key = props2[fromRight ? length : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString3(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length
            );
          }
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply2(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length, index2 = length, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length;
          while (++index2 < length) {
            func = funcs[index2];
            var funcName = getFuncName(func), data2 = funcName == "wrapper" ? getData2(func) : undefined$1;
            if (data2 && isLaziable(data2[0]) && data2[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data2[4].length && data2[9] == 1) {
              wrapper = wrapper[getFuncName(data2[0])].apply(wrapper, data2[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length ? funcs[index3].apply(this, args) : value;
            while (++index3 < length) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length, args = Array2(length), index2 = length;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary2,
              arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length) {
            args.length = ary2;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply2(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply2(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData2(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number2, precision) {
          number2 = toNumber(number2);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number2)) {
            var pair = (toString3(number2) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString3(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number2);
        };
      }
      var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
        return new Set2(values2);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data2 = isBindKey ? undefined$1 : getData2(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data2) {
          mergeData(newData, data2);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data2 ? baseSetData : setData2;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source2, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject2(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData2 = !metaMap ? noop : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
        while (length--) {
          var data2 = array[length], otherFunc = data2.func;
          if (otherFunc == null || otherFunc == func) {
            return data2.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData(map2, key) {
        var data2 = map2.__data__;
        return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
      }
      function getMatchData(object) {
        var result2 = keys(object), length = result2.length;
        while (length--) {
          var key = result2[length], value = object[key];
          result2[length] = [key, value, isStrictComparable(value)];
        }
        return result2;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {
        }
        var result2 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result2;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result2 = [];
        while (object) {
          arrayPush(result2, getSymbols(object));
          object = getPrototype(object);
        }
        return result2;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function(value) {
          var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result2;
        };
      }
      function getView(start, end, transforms) {
        var index2 = -1, length = transforms.length;
        while (++index2 < length) {
          var data2 = transforms[index2], size2 = data2.size;
          switch (data2.type) {
            case "drop":
              start += size2;
              break;
            case "dropRight":
              end -= size2;
              break;
            case "take":
              end = nativeMin(end, start + size2);
              break;
            case "takeRight":
              start = nativeMax(start, end - size2);
              break;
          }
        }
        return { "start": start, "end": end };
      }
      function getWrapDetails(source2) {
        var match = source2.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index2 = -1, length = path.length, result2 = false;
        while (++index2 < length) {
          var key = toKey(path[index2]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index2 != length) {
          return result2;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray2(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length, result2 = new array.constructor(length);
        if (length && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source2, details) {
        var length = details.length;
        if (!length) {
          return source2;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source2.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
      }
      function isIterateeCall(value, index2, object) {
        if (!isObject2(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
          return eq(object[index2], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data2 = getData2(other);
        return !!data2 && func === data2[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction2 : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto;
      }
      function isStrictComparable(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize(func, function(key) {
          if (cache2.size === MAX_MEMOIZE_SIZE) {
            cache2.clear();
          }
          return key;
        });
        var cache2 = result2.cache;
        return result2;
      }
      function mergeData(data2, source2) {
        var bitmask = data2[1], srcBitmask = source2[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data2[7].length <= source2[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source2[7].length <= source2[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data2;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data2[2] = source2[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source2[3];
        if (value) {
          var partials = data2[3];
          data2[3] = partials ? composeArgs(partials, value, source2[4]) : value;
          data2[4] = partials ? replaceHolders(data2[3], PLACEHOLDER) : source2[4];
        }
        value = source2[5];
        if (value) {
          partials = data2[5];
          data2[5] = partials ? composeArgsRight(partials, value, source2[6]) : value;
          data2[6] = partials ? replaceHolders(data2[5], PLACEHOLDER) : source2[6];
        }
        value = source2[7];
        if (value) {
          data2[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data2[8] = data2[8] == null ? source2[8] : nativeMin(data2[8], source2[8]);
        }
        if (data2[9] == null) {
          data2[9] = source2[9];
        }
        data2[0] = source2[0];
        data2[1] = newBitmask;
        return data2;
      }
      function nativeKeysIn(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString2(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start, transform3) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index2 = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
          while (++index2 < length) {
            array[index2] = args[start + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start + 1);
          while (++index2 < start) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start] = transform3(array);
          return apply2(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
        while (length--) {
          var index2 = indexes[length];
          array[length] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData2 = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source2 = reference + "";
        return setToString(wrapper, insertWrapDetails(source2, updateWrapDetails(getWrapDetails(source2), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index2 = -1, length = array.length, lastIndex = length - 1;
        size2 = size2 === undefined$1 ? length : size2;
        while (++index2 < size2) {
          var rand = baseRandom(index2, lastIndex), value = array[rand];
          array[rand] = array[index2];
          array[index2] = value;
        }
        array.length = size2;
        return array;
      }
      var stringToPath = memoizeCapped(function(string) {
        var result2 = [];
        if (string.charCodeAt(0) === 46) {
          result2.push("");
        }
        string.replace(rePropName, function(match, number2, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match);
        });
        return result2;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {
          }
          try {
            return func + "";
          } catch (e) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array, size2, guard) {
        if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax(toInteger(size2), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size2 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
        while (index2 < length) {
          result2[resIndex++] = baseSlice(array, index2, index2 += size2);
        }
        return result2;
      }
      function compact(array) {
        var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index2 < length) {
          var value = array[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array2(length - 1), array = arguments[0], index2 = length;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop3(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = fromIndex < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax(length + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join2(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index2 = length;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = index2 < 0 ? nativeMax(length + index2, 0) : nativeMin(index2, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
      }
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
      }
      function pullAllBy(array, values2, iteratee2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values2, comparator) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index2) {
          return isIndex(index2, length) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value);
          if (index2 < length && eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index2 = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index2) {
          return arrayMap(array, baseProperty(index2));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap(result2, function(group) {
          return apply2(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props2, values2) {
        return baseZipObject(props2 || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props2, values2) {
        return baseZipObject(props2 || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths);
        };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray2(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone3 = wrapperClone(parent2);
          clone3.__index__ = 0;
          clone3.__values__ = undefined$1;
          if (result2) {
            previous.__wrapped__ = clone3;
          } else {
            result2 = clone3;
          }
          var previous = clone3;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find2 = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee2), depth);
      }
      function forEach3(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply2(path, value, args) : baseInvoke(value, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue(result2, key, value);
      });
      function map(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now = ctxNow || function() {
        return root.Date.now();
      };
      function after(n, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }
      function before(n, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind4 = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind4));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
          if (cache2.has(key)) {
            return cache2.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache2.set(key, result2) || cache2;
          return result2;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index2 = -1, length = nativeMin(args.length, funcsLength);
          while (++index2 < length) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply2(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }
      function spread3(func, start) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function(args) {
          var array = args[start], otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply2(func, this, otherArgs);
        });
      }
      function throttle2(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone2(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source2) {
        return source2 == null || baseConformsTo(object, source2, keys(source2));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer2 = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer2 = nativeIsBuffer || stubFalse;
      var isDate2 = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject2(value);
      }
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer2(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
      }
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
      }
      function isFinite2(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source2) {
        return object === source2 || baseIsMatch(object, source2, getMatchData(source2));
      }
      function isMatchWith(object, source2, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source2, getMatchData(source2), customizer);
      }
      function isNaN2(value) {
        return isNumber2(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber2(value) {
        return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject2(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp2 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString2(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined2(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray2(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString2(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString3(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign3 = createAssigner(function(object, source2) {
        if (isPrototype(source2) || isArrayLike(source2)) {
          copyObject(source2, keys(source2), object);
          return;
        }
        for (var key in source2) {
          if (hasOwnProperty2.call(source2, key)) {
            assignValue(object, key, source2[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source2) {
        copyObject(source2, keysIn(source2), object);
      });
      var assignInWith = createAssigner(function(object, source2, srcIndex, customizer) {
        copyObject(source2, keysIn(source2), object, customizer);
      });
      var assignWith = createAssigner(function(object, source2, srcIndex, customizer) {
        copyObject(source2, keys(source2), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype, properties) {
        var result2 = baseCreate(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults2 = baseRest(function(object, sources) {
        object = Object2(object);
        var index2 = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index2 < length) {
          var source2 = sources[index2];
          var props2 = keysIn(source2);
          var propsIndex = -1;
          var propsLength = props2.length;
          while (++propsIndex < propsLength) {
            var key = props2[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
              object[key] = source2[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply2(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result2 = object == null ? undefined$1 : baseGet(object, path);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result2[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty2.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, iteratee2(value, key, object2), value);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, key, iteratee2(value, key, object2));
        });
        return result2;
      }
      var merge2 = createAssigner(function(object, source2, srcIndex) {
        baseMerge(object, source2, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source2, srcIndex, customizer) {
        baseMerge(object, source2, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result2);
        if (isDeep) {
          result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result2, paths[length]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props2 = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props2, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index2 = -1, length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index2 < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index2])];
          if (value === undefined$1) {
            index2 = length;
            value = defaultValue;
          }
          object = isFunction2(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform2(object, iteratee2, accumulator) {
        var isArr = isArray2(object), isArrLike = isArr || isBuffer2(object) || isTypedArray(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object)) {
            accumulator = isFunction2(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
          return iteratee2(accumulator, value, index2, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update2(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number2, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number2), lower, upper);
      }
      function inRange(number2, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number2 = toNumber(number2);
        return baseInRange(number2, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize2(word) : word);
      });
      function capitalize2(string) {
        return upperFirst(toString3(string).toLowerCase());
      }
      function deburr(string) {
        string = toString3(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string, target, position) {
        string = toString3(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }
      function escape(string) {
        string = toString3(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString3(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string, length, chars) {
        string = toString3(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString3(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString3(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt2(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString3(string).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString3(string), n);
      }
      function replace() {
        var args = arguments, string = toString3(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString3(string);
        if (string && (typeof separator == "string" || separator != null && !isRegExp2(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString3(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString3(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source2 = "__p += '";
        var reDelimiters = RegExp2(
          (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
          "g"
        );
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source2 += string.slice(index2, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source2 += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source2 += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source2 += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset + match.length;
          return match;
        });
        source2 += "';\n";
        var variable = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable) {
          source2 = "with (obj) {\n" + source2 + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source2 = (isEvaluating ? source2.replace(reEmptyStringLeading, "") : source2).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source2 = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source2 + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source2).apply(undefined$1, importsValues);
        });
        result2.source = source2;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString3(value).toLowerCase();
      }
      function toUpper(value) {
        return toString3(value).toUpperCase();
      }
      function trim2(string, chars, guard) {
        string = toString3(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join("");
      }
      function trimEnd(string, chars, guard) {
        string = toString3(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join("");
      }
      function trimStart(string, chars, guard) {
        string = toString3(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, "");
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join("");
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string = toString3(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end += result2.length - end;
        }
        if (isRegExp2(separator)) {
          if (string.slice(end).search(separator)) {
            var match, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString3(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape2(string) {
        string = toString3(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string, pattern, guard) {
        string = toString3(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply2(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error2(e);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind4(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index2 = -1;
          while (++index2 < length) {
            var pair = pairs[index2];
            if (apply2(pair[0], this, args)) {
              return apply2(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source2) {
        return baseConforms(baseClone(source2, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches2(source2) {
        return baseMatches(baseClone(source2, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source2, options) {
        var props2 = keys(source2), methodNames = baseFunctions(source2, props2);
        if (options == null && !(isObject2(source2) && (methodNames.length || !props2.length))) {
          options = source2;
          source2 = object;
          object = this;
          methodNames = baseFunctions(source2, keys(source2));
        }
        var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object);
        arrayEach(methodNames, function(methodName) {
          var func = source2[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop() {
      }
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function(args) {
          return baseNth(args, n);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n, iteratee2) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes(length, iteratee2);
        while (++index2 < n) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString3(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString3(prefix) + id;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum2(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign3;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind4;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce;
      lodash2.defaults = defaults2;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop3;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys;
      lodash2.keysIn = keysIn;
      lodash2.map = map;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches2;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize;
      lodash2.merge = merge2;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick;
      lodash2.pickBy = pickBy;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread3;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle2;
      lodash2.thru = thru;
      lodash2.toArray = toArray2;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform2;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update2;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize2;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone2;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq;
      lodash2.escape = escape;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find2;
      lodash2.findIndex = findIndex;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach3;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer2;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean2;
      lodash2.isBuffer = isBuffer2;
      lodash2.isDate = isDate2;
      lodash2.isElement = isElement;
      lodash2.isEmpty = isEmpty;
      lodash2.isEqual = isEqual;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite2;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber2;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike;
      lodash2.isPlainObject = isPlainObject2;
      lodash2.isRegExp = isRegExp2;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol;
      lodash2.isTypedArray = isTypedArray;
      lodash2.isUndefined = isUndefined2;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join2;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop;
      lodash2.now = now;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace;
      lodash2.result = result;
      lodash2.round = round;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum2;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString3;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim2;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape2;
      lodash2.uniqueId = uniqueId;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach3;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source2 = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source2[methodName] = func;
          }
        });
        return source2;
      }(), { "chain": false });
      lodash2.VERSION = VERSION2;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin(n, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);
        var result2 = this;
        if (result2.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result2);
        }
        if (start < 0) {
          result2 = result2.takeRight(-start);
        } else if (start) {
          result2 = result2.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _2 = runInContext();
    if (freeModule) {
      (freeModule.exports = _2)._ = _2;
      freeExports._ = _2;
    } else {
      root._ = _2;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var _ = lodash.exports;
var index_vue_vue_type_style_index_0_lang$7 = "";
const _sfc_main$12 = {
  components: {
    GenerateElementItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateElementItem$3;
    }))
  },
  props: ["columns", "showControl", "paging", "pageSize", "currentPage", "displayFields", "group", "widget"],
  data() {
    return {
      scrollLeft: 0,
      tableData: _.cloneDeep(this.data)
    };
  },
  emits: ["remove-row", "table-change", "table-item-change"],
  inject: ["formHideFields"],
  mounted() {
    this.$refs["bodyWrapper"].addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    this.$refs["bodyWrapper"].removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    rowWidthCalc() {
      let width = this.showControl ? "50px" : "0px";
      this.columns.forEach((column) => {
        if (this.displayFields[column.model]) {
          width += " + " + (column.options.width || "200px");
        }
      });
      return width;
    },
    rowLeftWidthCalc() {
      let width = "0px";
      this.columns.forEach((column) => {
        if (this.displayFields[column.model] && column.options.fixedColumn && column.options.fixedColumnPosition != "right") {
          width += " + " + (column.options.width || "200px");
        }
      });
      return width;
    },
    rowRightWidthCalc() {
      let width = "0px";
      this.columns.forEach((column) => {
        if (this.displayFields[column.model] && column.options.fixedColumn && column.options.fixedColumnPosition == "right") {
          width += " + " + (column.options.width || "200px");
        }
      });
      return width;
    }
  },
  methods: {
    handleScroll({ scrollLeft, scrollTop }) {
      this.scrollLeft = this.$refs["bodyWrapper"].scrollLeft;
    },
    columnDisplay(model2) {
      if (this.formHideFields.includes(this.group ? `${this.group}.${this.widget.model}.${model2}` : `${this.widget.model}.${model2}`)) {
        return false;
      } else {
        return true;
      }
    }
  }
};
const _hoisted_1$G = { class: "fm-virtual-table" };
const _hoisted_2$B = {
  role: "table",
  class: "fm-virtual-table-main"
};
const _hoisted_3$v = { class: "fm-virtual-table__body" };
const _hoisted_4$u = {
  class: "fm-virtual-table__body-wrapper",
  ref: "bodyWrapper"
};
const _hoisted_5$u = { class: "fm-virtual-table__header" };
const _hoisted_6$q = { class: "fm-virtual-table__header-content" };
const _hoisted_7$p = {
  key: 0,
  class: "fm-virtual-table__header-cell",
  style: {
    width: `50px`
  }
};
const _hoisted_8$i = ["title"];
const _hoisted_9$h = {
  role: "table",
  class: "fm-virtual-table-main fm-virtual-table-main__left"
};
const _hoisted_10$c = { class: "fm-virtual-table__body" };
const _hoisted_11$b = { class: "fm-virtual-table__header" };
const _hoisted_12$b = { class: "fm-virtual-table__header-content" };
const _hoisted_13$8 = { class: "fm-virtual-table__header-row" };
const _hoisted_14$7 = {
  key: 0,
  class: "fm-virtual-table__header-cell",
  style: {
    width: 50 + "px"
  }
};
const _hoisted_15$5 = /* @__PURE__ */ createElementVNode("div", {
  class: "fm-virtual-table__header-cell-text",
  title: "Column"
}, " # ", -1);
const _hoisted_16$4 = [
  _hoisted_15$5
];
const _hoisted_17$3 = ["title"];
const _hoisted_18$2 = {
  role: "table",
  class: "fm-virtual-table-main fm-virtual-table-main__right"
};
const _hoisted_19$2 = { class: "fm-virtual-table__body" };
const _hoisted_20$2 = { class: "fm-virtual-table__header" };
const _hoisted_21$2 = { class: "fm-virtual-table__header-content" };
const _hoisted_22$2 = { class: "fm-virtual-table__header-row" };
const _hoisted_23$2 = ["title"];
function _sfc_render$$(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$G, [
    createElementVNode("div", _hoisted_2$B, [
      createElementVNode("div", _hoisted_3$v, [
        createElementVNode("div", _hoisted_4$u, [
          renderSlot(_ctx.$slots, "default", {
            rowWidthCalc: $options.rowWidthCalc,
            rowLeftWidthCalc: $options.rowLeftWidthCalc,
            rowRightWidthCalc: $options.rowRightWidthCalc
          })
        ], 512)
      ]),
      createElementVNode("div", _hoisted_5$u, [
        createElementVNode("div", _hoisted_6$q, [
          createElementVNode("div", {
            class: "fm-virtual-table__header-row",
            style: normalizeStyle({
              left: -$data.scrollLeft + "px",
              "min-width": `calc(${$options.rowWidthCalc})`,
              width: `calc(${$options.rowWidthCalc})`
            })
          }, [
            $props.showControl ? (openBlock(), createElementBlock("div", _hoisted_7$p)) : createCommentVNode("", true),
            $options.rowLeftWidthCalc != "0px" ? (openBlock(), createElementBlock("div", {
              key: 1,
              class: "fm-virtual-table__header-cell",
              style: normalizeStyle({
                width: `calc(${$options.rowLeftWidthCalc})`
              })
            }, null, 4)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
              return openBlock(), createElementBlock(Fragment, null, [
                $options.columnDisplay(column.model) && !column.options.fixedColumn ? (openBlock(), createElementBlock("div", {
                  class: normalizeClass(["fm-virtual-table__header-cell", {
                    "is-require": column.options.required,
                    [column.options && column.options.customClass]: column.options.customClass ? true : false
                  }]),
                  key: column.key,
                  style: normalizeStyle({
                    width: column.options.width
                  })
                }, [
                  createElementVNode("div", {
                    class: "fm-virtual-table__header-cell-text",
                    title: column.options.hideLabel ? "" : column.name
                  }, toDisplayString$1(column.options.hideLabel ? "" : column.name), 9, _hoisted_8$i)
                ], 6)) : createCommentVNode("", true)
              ], 64);
            }), 256)),
            $options.rowRightWidthCalc != "0px" ? (openBlock(), createElementBlock("div", {
              key: 2,
              class: "fm-virtual-table__header-cell",
              style: normalizeStyle({
                width: `calc(${$options.rowRightWidthCalc})`
              })
            }, null, 4)) : createCommentVNode("", true)
          ], 4)
        ])
      ])
    ]),
    createElementVNode("div", _hoisted_9$h, [
      createElementVNode("div", _hoisted_10$c, [
        createElementVNode("div", null, [
          renderSlot(_ctx.$slots, "left")
        ])
      ]),
      createElementVNode("div", _hoisted_11$b, [
        createElementVNode("div", _hoisted_12$b, [
          createElementVNode("div", _hoisted_13$8, [
            $props.showControl ? (openBlock(), createElementBlock("div", _hoisted_14$7, _hoisted_16$4)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
              return openBlock(), createElementBlock(Fragment, null, [
                $props.displayFields[column.model] && column.options.fixedColumn && column.options.fixedColumnPosition != "right" ? (openBlock(), createElementBlock("div", {
                  class: normalizeClass(["fm-virtual-table__header-cell", {
                    "is-require": column.options.required,
                    [column.options && column.options.customClass]: column.options.customClass ? true : false
                  }]),
                  key: column.key,
                  style: normalizeStyle({
                    width: column.options.width
                  })
                }, [
                  createElementVNode("div", {
                    class: "fm-virtual-table__header-cell-text",
                    title: column.options.hideLabel ? "" : column.name
                  }, toDisplayString$1(column.options.hideLabel ? "" : column.name), 9, _hoisted_17$3)
                ], 6)) : createCommentVNode("", true)
              ], 64);
            }), 256))
          ])
        ])
      ])
    ]),
    createElementVNode("div", _hoisted_18$2, [
      createElementVNode("div", _hoisted_19$2, [
        createElementVNode("div", null, [
          renderSlot(_ctx.$slots, "right")
        ])
      ]),
      createElementVNode("div", _hoisted_20$2, [
        createElementVNode("div", _hoisted_21$2, [
          createElementVNode("div", _hoisted_22$2, [
            (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
              return openBlock(), createElementBlock(Fragment, null, [
                $props.displayFields[column.model] && column.options.fixedColumn && column.options.fixedColumnPosition == "right" ? (openBlock(), createElementBlock("div", {
                  class: normalizeClass(["fm-virtual-table__header-cell", {
                    "is-require": column.options.required,
                    [column.options && column.options.customClass]: column.options.customClass ? true : false
                  }]),
                  key: column.key,
                  style: normalizeStyle({
                    width: column.options.width
                  })
                }, [
                  createElementVNode("div", {
                    class: "fm-virtual-table__header-cell-text",
                    title: column.options.hideLabel ? "" : column.name
                  }, toDisplayString$1(column.options.hideLabel ? "" : column.name), 9, _hoisted_23$2)
                ], 6)) : createCommentVNode("", true)
              ], 64);
            }), 256))
          ])
        ])
      ])
    ])
  ]);
}
var VirtualTable = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["render", _sfc_render$$]]);
const _sfc_main$11 = {
  props: ["rowWidthCalc", "rowIndex", "tableKey"],
  data() {
    return {
      resizeObserver: null,
      eles: [],
      rowHeight: 0
    };
  },
  mounted() {
    this.eles = document.querySelectorAll(`.fm-virtual-table__row.row_${this.rowIndex}>div`);
    this.resizeObserver = new ResizeObserver((mutationList) => {
      this.rowHeight = this.clacRowHeight();
    });
    this.eles.forEach((ele) => {
      this.resizeObserver.observe(ele);
    });
  },
  unmounted() {
    this.eles.forEach((ele) => {
      this.resizeObserver.unobserve(ele);
    });
  },
  methods: {
    handleMouseover() {
      addClass$1(document.querySelectorAll(".fm-virtual-table__row.main.row_" + this.tableKey)[this.rowIndex], "is-hover");
      addClass$1(document.querySelectorAll(".fm-virtual-table__row.left.row_" + this.tableKey)[this.rowIndex], "is-hover");
      addClass$1(document.querySelectorAll(".fm-virtual-table__row.right.row_" + this.tableKey)[this.rowIndex], "is-hover");
    },
    handleMouseout() {
      removeClass$1(document.querySelectorAll(".fm-virtual-table__row.main.row_" + this.tableKey)[this.rowIndex], "is-hover");
      removeClass$1(document.querySelectorAll(".fm-virtual-table__row.left.row_" + this.tableKey)[this.rowIndex], "is-hover");
      removeClass$1(document.querySelectorAll(".fm-virtual-table__row.right.row_" + this.tableKey)[this.rowIndex], "is-hover");
    },
    clacRowHeight() {
      let curHeight = 0;
      this.eles.forEach((ele) => {
        if (curHeight < ele.offsetHeight + 0.5) {
          curHeight = ele.offsetHeight + 0.5;
        }
      });
      return curHeight;
    }
  }
};
function _sfc_render$_(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["fm-virtual-table__row", `row_${$props.rowIndex} row_${$props.tableKey}`]),
    onMouseover: _cache[0] || (_cache[0] = (...args) => $options.handleMouseover && $options.handleMouseover(...args)),
    onMouseout: _cache[1] || (_cache[1] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "tableRow",
    style: normalizeStyle({
      "min-width": `calc(${$props.rowWidthCalc})`,
      "min-height": $data.rowHeight + "px"
    })
  }, [
    renderSlot(_ctx.$slots, "default", { rowHeight: $data.rowHeight })
  ], 38);
}
var VirtualRow = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["render", _sfc_render$_]]);
const _sfc_main$10 = {
  props: ["width", "rowHeight"]
};
function _sfc_render$Z(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: "fm-virtual-table__row-cell",
    style: normalizeStyle({
      width: $props.width,
      "min-height": $props.rowHeight - 0.5 + "px"
    })
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 4);
}
var VirtualCell = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["render", _sfc_render$Z]]);
const updateClassName = (genList, fields, className, updateType) => {
  for (let i = 0; i < genList.length; i++) {
    if (genList[i].type === "grid") {
      genList[i].columns.forEach((item) => {
        updateClassName(item.list, fields, className, updateType);
      });
    } else if (genList[i].type === "tabs") {
      genList[i].tabs.forEach((item) => {
        updateClassName(item.list, fields, className, updateType);
      });
    } else if (genList[i].type === "collapse") {
      genList[i].tabs.forEach((item) => {
        updateClassName(item.list, fields, className, updateType);
      });
    } else if (genList[i].type === "report") {
      genList[i].rows.forEach((row) => {
        row.columns.forEach((column) => {
          updateClassName(column.list, fields, className, updateType);
        });
      });
    } else if (genList[i].type === "inline") {
      updateClassName(genList[i].list, fields, className, updateType);
    } else if (genList[i].type === "card") {
      updateClassName(genList[i].list, fields, className, updateType);
    } else {
      if (fields.length === 1) {
        if (genList[i].model === fields[0]) {
          if (updateType == "add" && !genList[i].options.customClass.split(" ").includes(className)) {
            genList[i].options.customClass = [...genList[i].options.customClass.split(" "), className].join(" ");
          }
          if (updateType == "remove" && genList[i].options.customClass.split(" ").includes(className)) {
            let originArray = genList[i].options.customClass.split(" ");
            originArray.splice(originArray.findIndex((item) => item == className), 1);
            genList[i].options.customClass = originArray.join(" ");
          }
        }
      } else {
        if (genList[i].model === fields[0]) {
          let newFields = [...fields];
          newFields.splice(0, 1);
          if (genList[i].type === "table") {
            updateClassName(genList[i].tableColumns, newFields, className, updateType);
          }
          if (genList[i].type === "subform") {
            updateClassName(genList[i].list, newFields, className, updateType);
          }
          if (genList[i].type === "group") {
            updateClassName(genList[i].list, newFields, className, updateType);
          }
          if (genList[i].type === "dialog") {
            updateClassName(genList[i].list, newFields, className, updateType);
          }
        }
      }
    }
  }
};
var index_vue_vue_type_style_index_0_lang$6 = "";
const _sfc_main$$ = {
  components: {
    VirtualTable,
    VirtualRow,
    VirtualCell,
    GenerateFormItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateFormItem$3;
    })),
    GenerateElementItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateElementItem$3;
    }))
  },
  props: [
    "columns",
    "value",
    "models",
    "remote",
    "blanks",
    "disableddata",
    "rules",
    "name",
    "remoteOption",
    "preview",
    "platform",
    "dataSourceValue",
    "eventFunction",
    "widget",
    "printRead",
    "paging",
    "pageSize",
    "isDelete",
    "isAdd",
    "containerKey",
    "showControl",
    "isDialog",
    "dialogName",
    "group",
    "fieldNode"
  ],
  emits: ["update:value"],
  data() {
    var _a2;
    return {
      tableData: (_a2 = this.value) != null ? _a2 : [],
      displayFields: {},
      disabledFields: {},
      changeItem: {},
      pagingData: [],
      pagingLength: 0,
      currentPage: 1,
      tableHideFields: [],
      tableDisabledFields: [],
      mobileScreen: window.innerWidth < 768,
      tableKey: Math.random().toString(36).slice(-8)
    };
  },
  created() {
    for (let i = 0; i < this.columns.length; i++) {
      this.displayFields[this.columns[i].model] = !this.columns[i].options.hidden;
      this.disabledFields[this.columns[i].model] = this.columns[i].options.disabled;
    }
    this.tableHideFields = this.value ? this.value.map((v) => Object.fromEntries(Object.keys(this.displayFields).map((field) => [field, !this.displayFields[field]]))) : [];
    this.tableDisabledFields = this.value ? this.value.map((v) => Object.fromEntries(Object.keys(this.disabledFields).map((field) => [field, this.disabledFields[field]]))) : [];
    window.addEventListener("resize", this.getMobileScreen);
    this.loadPagingData();
  },
  provide() {
    return {
      "setTableData": this.setTableData
    };
  },
  inject: ["onFormDisabled", "formHideFields", "onFormHide", "onFormDisplay"],
  methods: {
    columnDisplay(model2) {
      if (this.formHideFields.includes(this.group ? `${this.group}.${this.widget.model}.${model2}` : `${this.widget.model}.${model2}`)) {
        return false;
      } else {
        return true;
      }
    },
    getMobileScreen() {
      this.mobileScreen = window.innerWidth < 768;
    },
    setData(rowIndex, value) {
      if (typeof rowIndex !== "number") {
        return new Promise((resolve) => {
          value = rowIndex;
          this.tableData.forEach((_2, index2) => {
            Object.keys(value).forEach((item) => {
              this.setTableData(value[item], index2, item);
            });
          });
          resolve();
        });
      }
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            this.setTableData(value[item], rowIndex, item);
          });
          resolve();
        });
      });
    },
    setTableData(value, rowIndex, field) {
      this.tableData[rowIndex][field] = value;
    },
    handleAddRow() {
      let item = {};
      let hideItem = {};
      let disabledItem = {};
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].type === "blank") {
          item[this.columns[i].model] = this.columns[i].options.defaultType == "String" ? "" : this.columns[i].options.defaultType == "Object" ? {} : [];
        } else if (this.columns[i].type === "component" || this.columns[i].type === "link" || this.columns[i].type === "button") {
          item[this.columns[i].model] = void 0;
        } else {
          item[this.columns[i].model] = _.cloneDeep(this.columns[i].options.defaultValue);
        }
        hideItem[this.columns[i].model] = !this.displayFields[this.columns[i].model];
        disabledItem[this.columns[i].model] = this.disabledFields[this.columns[i].model];
      }
      this.tableData.push(item);
      this.tableHideFields.push(hideItem);
      this.tableDisabledFields.push(disabledItem);
      if (this.widget && this.widget.events && this.widget.events.onRowAdd) {
        let funcKey = this.widget.events.onRowAdd;
        this.eventFunction[funcKey]({
          rowIndex: this.tableData.length - 1,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
      this.changeItem = {};
      if (this.paging) {
        this.$nextTick(() => {
          if (this.tableData.length > this.currentPage * this.pageSize) {
            this.currentPage = parseInt((this.tableData.length - 1) / this.pageSize) + 1;
          }
          this.loadPagingData();
        });
      }
    },
    handleRemove(index2) {
      const removeData = { ...this.tableData[index2] };
      this.tableData.splice(index2, 1);
      if (this.widget && this.widget.events && this.widget.events.onRowRemove) {
        let funcKey = this.widget.events.onRowRemove;
        this.eventFunction[funcKey]({
          removeIndex: index2,
          removeData,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
      this.changeItem = {};
      this.pagingData = [];
      this.pagingLength = 0;
      if (this.paging) {
        this.$nextTick(() => {
          if (this.tableData.length % this.pageSize == 0 && this.currentPage > parseInt(this.tableData.length / this.pageSize)) {
            this.currentPage = parseInt(this.tableData.length / this.pageSize);
          }
          this.loadPagingData();
        });
      }
    },
    hideChild(rowIndex, fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        this.onFormHide(`${this.fieldNode}.${rowIndex}.${item}`);
      });
    },
    displayChild(rowIndex, fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        this.onFormDisplay(`${this.fieldNode}.${rowIndex}.${item}`);
      });
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        this.onFormHide(`${this.fieldNode}.${item}`);
      });
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        this.onFormDisplay(`${this.fieldNode}.${item}`);
      });
    },
    disabledChild(rowIndex, fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.tableDisabledFields[rowIndex][field] = disabled;
        this.onFormDisabled(`${this.fieldNode}.${rowIndex}.${field}`, disabled);
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (fields.indexOf(this.columns[i].model) >= 0) {
          this.columns[i].options.disabled = disabled;
          this.disabledFields[this.columns[i].model] = disabled;
        }
      }
      this.tableData.forEach((_2, index2) => {
        fields.forEach((field) => {
          this.tableDisabledFields[index2][field] = disabled;
        });
      });
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (fields.indexOf(this.columns[i].model) >= 0) {
          Object.keys(options).forEach((key) => {
            this.columns[i].options[key] = options[key];
          });
        }
      }
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.columns, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.columns, item.split("."), className, "remove");
      });
    },
    handleTableChange(value) {
      this.changeItem = value;
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.pagingData = [];
      this.pagingLength = 0;
      this.$nextTick(() => {
        this.loadPagingData();
      });
      if (this.widget && this.widget.events && this.widget.events.onPageChange) {
        let funcKey = this.widget.events.onPageChange;
        this.eventFunction[funcKey]({
          currentPage: val,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
    },
    loadPagingData() {
      let beginIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = beginIndex + this.pageSize;
      this.pagingData = this.tableData.slice(beginIndex, endIndex);
      this.pagingLength = this.pagingData.length;
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.getMobileScreen);
  },
  watch: {
    value(val) {
      var _a2, _b, _c, _d, _e, _f;
      this.tableData = val;
      let hideFields = [];
      let disabledFields = [];
      for (let i = 0; i < this.value.length; i++) {
        let row = this.value[i];
        let rowArray = Object.keys(row);
        let hideRow = {};
        let disabledRow = {};
        for (let f = 0; f < rowArray.length; f++) {
          hideRow[rowArray[f]] = (_c = (_b = (_a2 = this.tableHideFields) == null ? void 0 : _a2[i]) == null ? void 0 : _b[rowArray[f]]) != null ? _c : false;
          disabledRow[rowArray[f]] = (_f = (_e = (_d = this.tableDisabledFields) == null ? void 0 : _d[i]) == null ? void 0 : _e[rowArray[f]]) != null ? _f : false;
        }
        hideFields.push(hideRow);
        disabledFields.push(disabledRow);
      }
      this.tableHideFields = hideFields;
      this.tableDisabledFields = disabledFields;
    },
    "tableData": {
      deep: true,
      handler(val) {
        this.loadPagingData();
        this.$emit("update:value", val);
      }
    }
  }
};
const _hoisted_1$F = { class: "scope-index" };
const _hoisted_2$A = { class: "scope-action" };
const _hoisted_3$u = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-trash",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_4$t = { key: 1 };
const _hoisted_5$t = { class: "scope-index" };
const _hoisted_6$p = { class: "scope-action" };
const _hoisted_7$o = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-trash",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_8$h = { key: 1 };
const _hoisted_9$g = {
  key: 0,
  class: "form-table-mobile-item__top"
};
const _hoisted_10$b = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-trash",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_11$a = { class: "form-table-mobile-item__content" };
const _hoisted_12$a = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
function _sfc_render$Y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = resolveComponent("el-button");
  const _component_el_popconfirm = resolveComponent("el-popconfirm");
  const _component_el_table_column = resolveComponent("el-table-column");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_el_table = resolveComponent("el-table");
  const _component_VirtualCell = resolveComponent("VirtualCell");
  const _component_VirtualRow = resolveComponent("VirtualRow");
  const _component_VirtualTable = resolveComponent("VirtualTable");
  const _component_el_col = resolveComponent("el-col");
  const _component_el_pagination = resolveComponent("el-pagination");
  const _component_el_row = resolveComponent("el-row");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["form-table", { "is-disabled": $props.disableddata }])
  }, [
    $props.preview && $props.platform != "mobile" || !$props.preview && !$data.mobileScreen ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      !$props.widget.options.virtualTable ? (openBlock(), createBlock(_component_el_table, {
        key: 0,
        data: $props.paging ? $data.pagingData : $data.tableData,
        border: "",
        class: normalizeClass({ "form-table-pc": !$props.preview })
      }, {
        default: withCtx(() => [
          $props.showControl ? (openBlock(), createBlock(_component_el_table_column, {
            key: 0,
            label: "#",
            fixed: "",
            width: "50"
          }, {
            default: withCtx((scope) => [
              createElementVNode("div", _hoisted_1$F, [
                createElementVNode("span", null, toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + scope.$index + 1), 1)
              ]),
              createElementVNode("div", _hoisted_2$A, [
                !$props.printRead && $props.isDelete ? (openBlock(), createBlock(_component_el_popconfirm, {
                  key: 0,
                  teleported: true,
                  title: _ctx.$t("fm.description.deleteConfirm"),
                  onConfirm: ($event) => $options.handleRemove(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + scope.$index)
                }, {
                  reference: withCtx(() => [
                    createVNode(_component_el_button, {
                      disabled: $props.disableddata,
                      type: "danger",
                      size: "small",
                      circle: ""
                    }, {
                      default: withCtx(() => [
                        _hoisted_3$u
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 2
                }, 1032, ["title", "onConfirm"])) : createCommentVNode("", true),
                $props.printRead || !$props.isDelete ? (openBlock(), createElementBlock("span", _hoisted_4$t, toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + scope.$index + 1), 1)) : createCommentVNode("", true)
              ])
            ]),
            _: 1
          })) : createCommentVNode("", true),
          $props.columns.length == 0 ? (openBlock(), createBlock(_component_el_table_column, { key: 1 })) : (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList($props.columns, (column) => {
            var _a2;
            return openBlock(), createElementBlock(Fragment, {
              key: column.model
            }, [
              $options.columnDisplay(column.model) ? (openBlock(), createBlock(_component_el_table_column, {
                key: 0,
                label: column.options.hideLabel ? "" : column.name,
                width: column.options.width,
                "label-class-name": column.options.required ? "required" : "",
                "class-name": (_a2 = column.options) == null ? void 0 : _a2.customClass,
                fixed: column.options.fixedColumn ? column.options.fixedColumnPosition || "left" : false,
                "column-key": column.key
              }, {
                default: withCtx((scope) => [
                  createVNode(_component_generate_form_item, {
                    models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + scope.$index],
                    rules: $props.rules,
                    widget: column,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $data.displayFields,
                    "sub-hide-fields": $data.tableHideFields,
                    "sub-disabled-fields": $data.tableDisabledFields,
                    edit: !$props.disableddata,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-table": true,
                    "is-mobile": false,
                    "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + scope.$index,
                    "table-name": $props.name,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": false,
                    group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                    "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + scope.$index}`
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope2) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope2.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "is-dialog", "dialog-name", "group", "field-node"])
                ]),
                _: 2
              }, 1032, ["label", "width", "label-class-name", "class-name", "fixed", "column-key"])) : createCommentVNode("", true)
            ], 64);
          }), 128))
        ]),
        _: 3
      }, 8, ["data", "class"])) : createCommentVNode("", true),
      $props.widget.options.virtualTable ? (openBlock(), createBlock(_component_VirtualTable, {
        key: 1,
        columns: $props.columns,
        showControl: $props.showControl,
        paging: $props.paging,
        pageSize: $props.pageSize,
        currentPage: $data.currentPage,
        displayFields: $data.displayFields,
        group: $props.group,
        widget: $props.widget
      }, {
        default: withCtx(({ rowWidthCalc, rowLeftWidthCalc, rowRightWidthCalc }) => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.tableData, (t, index2) => {
            return openBlock(), createBlock(_component_VirtualRow, {
              rowWidthCalc,
              key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
              "row-index": index2,
              class: "main",
              "table-key": $data.tableKey
            }, {
              default: withCtx(() => [
                $props.showControl ? (openBlock(), createBlock(_component_VirtualCell, {
                  key: 0,
                  width: "50px"
                })) : createCommentVNode("", true),
                rowLeftWidthCalc != "0px" ? (openBlock(), createBlock(_component_VirtualCell, {
                  key: 1,
                  width: `calc(${rowLeftWidthCalc})`
                }, null, 8, ["width"])) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
                  return openBlock(), createElementBlock(Fragment, null, [
                    $options.columnDisplay(column.model) && !column.options.fixedColumn ? (openBlock(), createBlock(_component_VirtualCell, {
                      key: column.key,
                      width: column.options.width
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_generate_form_item, {
                          models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                          rules: $props.rules,
                          widget: column,
                          remote: $props.remote,
                          blanks: $props.blanks,
                          display: $data.displayFields,
                          "sub-hide-fields": $data.tableHideFields,
                          "sub-disabled-fields": $data.tableDisabledFields,
                          edit: !$props.disableddata,
                          "remote-option": $props.remoteOption,
                          platform: $props.platform,
                          preview: $props.preview,
                          "container-key": $props.containerKey,
                          "data-source-value": $props.dataSourceValue,
                          "event-function": $props.eventFunction,
                          "print-read": $props.printRead,
                          "is-table": true,
                          "is-mobile": false,
                          "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                          "table-name": $props.name,
                          "is-dialog": $props.isDialog,
                          "dialog-name": $props.dialogName,
                          "is-group": false,
                          group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                          "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
                        }, createSlots({ _: 2 }, [
                          renderList($props.blanks, (blank) => {
                            return {
                              name: blank.name,
                              fn: withCtx((scope) => [
                                renderSlot(_ctx.$slots, blank.name, {
                                  model: scope.model
                                })
                              ])
                            };
                          })
                        ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "is-dialog", "dialog-name", "group", "field-node"])
                      ]),
                      _: 2
                    }, 1032, ["width"])) : createCommentVNode("", true)
                  ], 64);
                }), 256)),
                rowRightWidthCalc != "0px" ? (openBlock(), createBlock(_component_VirtualCell, {
                  key: 2,
                  width: `calc(${rowRightWidthCalc})`
                }, null, 8, ["width"])) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["rowWidthCalc", "row-index", "table-key"]);
          }), 128))
        ]),
        left: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.tableData, (t, index2) => {
            return openBlock(), createBlock(_component_VirtualRow, {
              key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
              rowIndex: index2,
              class: "left",
              "table-key": $data.tableKey
            }, {
              default: withCtx(() => [
                $props.showControl ? (openBlock(), createBlock(_component_VirtualCell, {
                  key: 0,
                  width: "50px"
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_5$t, [
                      createElementVNode("span", null, toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)
                    ]),
                    createElementVNode("div", _hoisted_6$p, [
                      !$props.printRead && $props.isDelete ? (openBlock(), createBlock(_component_el_popconfirm, {
                        key: 0,
                        teleported: true,
                        title: _ctx.$t("fm.description.deleteConfirm"),
                        onConfirm: ($event) => $options.handleRemove(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2)
                      }, {
                        reference: withCtx(() => [
                          createVNode(_component_el_button, {
                            disabled: $props.disableddata,
                            type: "danger",
                            size: "small",
                            circle: ""
                          }, {
                            default: withCtx(() => [
                              _hoisted_7$o
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 2
                      }, 1032, ["title", "onConfirm"])) : createCommentVNode("", true),
                      $props.printRead || !$props.isDelete ? (openBlock(), createElementBlock("span", _hoisted_8$h, toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)) : createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024)) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
                  return openBlock(), createElementBlock(Fragment, null, [
                    $options.columnDisplay(column.model) && column.options.fixedColumn && column.options.fixedColumnPosition != "right" ? (openBlock(), createBlock(_component_VirtualCell, {
                      key: column.key,
                      width: column.options.width
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_generate_form_item, {
                          models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                          rules: $props.rules,
                          widget: column,
                          remote: $props.remote,
                          blanks: $props.blanks,
                          display: $data.displayFields,
                          "sub-hide-fields": $data.tableHideFields,
                          "sub-disabled-fields": $data.tableDisabledFields,
                          edit: !$props.disableddata,
                          "remote-option": $props.remoteOption,
                          platform: $props.platform,
                          preview: $props.preview,
                          "container-key": $props.containerKey,
                          "data-source-value": $props.dataSourceValue,
                          "event-function": $props.eventFunction,
                          "print-read": $props.printRead,
                          "is-table": true,
                          "is-mobile": false,
                          "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                          "table-name": $props.name,
                          "is-dialog": $props.isDialog,
                          "dialog-name": $props.dialogName,
                          "is-group": false,
                          group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                          "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
                        }, createSlots({ _: 2 }, [
                          renderList($props.blanks, (blank) => {
                            return {
                              name: blank.name,
                              fn: withCtx((scope) => [
                                renderSlot(_ctx.$slots, blank.name, {
                                  model: scope.model
                                })
                              ])
                            };
                          })
                        ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "is-dialog", "dialog-name", "group", "field-node"])
                      ]),
                      _: 2
                    }, 1032, ["width"])) : createCommentVNode("", true)
                  ], 64);
                }), 256))
              ]),
              _: 2
            }, 1032, ["rowIndex", "table-key"]);
          }), 128))
        ]),
        right: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.tableData, (t, index2) => {
            return openBlock(), createBlock(_component_VirtualRow, {
              key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
              rowIndex: index2,
              class: "right",
              "table-key": $data.tableKey
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
                  return openBlock(), createElementBlock(Fragment, null, [
                    $options.columnDisplay(column.model) && column.options.fixedColumn && column.options.fixedColumnPosition == "right" ? (openBlock(), createBlock(_component_VirtualCell, {
                      key: column.key,
                      width: column.options.width
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_generate_form_item, {
                          models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                          rules: $props.rules,
                          widget: column,
                          remote: $props.remote,
                          blanks: $props.blanks,
                          display: $data.displayFields,
                          "sub-hide-fields": $data.tableHideFields,
                          "sub-disabled-fields": $data.tableDisabledFields,
                          edit: !$props.disableddata,
                          "remote-option": $props.remoteOption,
                          platform: $props.platform,
                          preview: $props.preview,
                          "container-key": $props.containerKey,
                          "data-source-value": $props.dataSourceValue,
                          "event-function": $props.eventFunction,
                          "print-read": $props.printRead,
                          "is-table": true,
                          "is-mobile": false,
                          "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                          "table-name": $props.name,
                          "is-dialog": $props.isDialog,
                          "dialog-name": $props.dialogName,
                          "is-group": false,
                          group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                          "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
                        }, createSlots({ _: 2 }, [
                          renderList($props.blanks, (blank) => {
                            return {
                              name: blank.name,
                              fn: withCtx((scope) => [
                                renderSlot(_ctx.$slots, blank.name, {
                                  model: scope.model
                                })
                              ])
                            };
                          })
                        ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "is-dialog", "dialog-name", "group", "field-node"])
                      ]),
                      _: 2
                    }, 1032, ["width"])) : createCommentVNode("", true)
                  ], 64);
                }), 256))
              ]),
              _: 2
            }, 1032, ["rowIndex", "table-key"]);
          }), 128))
        ]),
        _: 3
      }, 8, ["columns", "showControl", "paging", "pageSize", "currentPage", "displayFields", "group", "widget"])) : createCommentVNode("", true)
    ], 64)) : createCommentVNode("", true),
    $props.preview && $props.platform === "mobile" || !$props.preview && $data.mobileScreen ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: "form-table-mobile",
      style: normalizeStyle({ "display": $props.preview && $props.platform === "mobile" ? "block" : "" })
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.tableData, (t, index2) => {
        return openBlock(), createElementBlock("div", {
          class: "form-table-mobile-item",
          key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2
        }, [
          $props.showControl ? (openBlock(), createElementBlock("div", _hoisted_9$g, [
            createElementVNode("span", null, "# " + toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1),
            !$props.printRead && $props.isDelete ? (openBlock(), createBlock(_component_el_popconfirm, {
              key: 0,
              teleported: false,
              title: _ctx.$t("fm.description.deleteConfirm"),
              onConfirm: ($event) => $options.handleRemove(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2)
            }, {
              reference: withCtx(() => [
                createVNode(_component_el_button, {
                  disabled: $props.disableddata,
                  type: "danger",
                  size: "small",
                  circle: ""
                }, {
                  default: withCtx(() => [
                    _hoisted_10$b
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 2
            }, 1032, ["title", "onConfirm"])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_11$a, [
            (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
              return openBlock(), createBlock(_component_generate_form_item, {
                key: column.key,
                models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                widget: column,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.tableHideFields,
                "sub-disabled-fields": $data.tableDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-table": true,
                "is-mobile": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "table-name": $props.name,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "is-dialog", "dialog-name", "group", "field-node"]);
            }), 128))
          ])
        ]);
      }), 128))
    ], 4)) : createCommentVNode("", true),
    createVNode(_component_el_row, null, {
      default: withCtx(() => [
        createVNode(_component_el_col, {
          span: $props.preview && $props.platform != "mobile" || !$props.preview ? 12 : 24,
          xs: 24
        }, {
          default: withCtx(() => [
            !$props.disableddata && $props.isAdd ? (openBlock(), createBlock(_component_el_button, {
              key: 0,
              link: "",
              type: "primary",
              onClick: $options.handleAddRow
            }, {
              default: withCtx(() => [
                _hoisted_12$a,
                createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.add")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["span"]),
        createVNode(_component_el_col, {
          span: ($props.preview && $props.platform != "mobile" || !$props.preview) && !$props.disableddata ? 12 : 24,
          xs: 24
        }, {
          default: withCtx(() => [
            $props.paging && $data.tableData.length ? (openBlock(), createBlock(_component_el_pagination, {
              key: 0,
              style: { "float": "right" },
              layout: "total, prev, pager, next",
              "page-size": $props.pageSize,
              "current-page": $data.currentPage,
              total: $data.tableData.length,
              "pager-count": 5,
              onCurrentChange: $options.handlePageChange
            }, null, 8, ["page-size", "current-page", "total", "onCurrentChange"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    })
  ], 2);
}
var FmFormTable$1 = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["render", _sfc_render$Y]]);
var config_vue_vue_type_style_index_0_lang = "";
const _sfc_main$_ = {
  name: "event-config",
  props: ["events", "eventscripts"],
  emits: ["on-add", "on-remove", "on-edit", "update:events"],
  data() {
    return {
      eventsModel: this.events,
      eventArray: Object.keys(this.events).map((item) => ({
        eventName: item,
        functionKey: this.events[item]
      })).filter((item) => item.functionKey),
      eventEnum: {
        onChange: "onChange \u503C\u53D1\u751F\u53D8\u5316",
        onClick: "onClick \u5355\u51FB",
        onFocus: "onFocus \u83B7\u53D6\u7126\u70B9",
        onBlur: "onBlur \u5931\u53BB\u7126\u70B9",
        onRowAdd: "onRowAdd \u5B50\u8868\u5355\u6DFB\u52A0\u884C",
        onRowRemove: "onRowRemove \u5B50\u8868\u5355\u5220\u9664\u884C",
        onUploadSuccess: "onUploadSuccess \u4E0A\u4F20\u6210\u529F",
        onUploadError: "onUploadError \u4E0A\u4F20\u5931\u8D25",
        onRemove: "onRemove \u79FB\u9664",
        onUploadProgress: "onUploadProgress \u4E0A\u4F20\u4E2D",
        onSelect: "onSelect \u6587\u4EF6\u9009\u62E9",
        onPageChange: "onPageChange \u5F53\u524D\u9875\u6539\u53D8",
        onCancel: "onCancel \u70B9\u51FB\u53D6\u6D88\u6309\u94AE",
        onConfirm: "onConfirm \u70B9\u51FB\u786E\u5B9A\u6309\u94AE"
      }
    };
  },
  methods: {
    handleCommand(command) {
      this.$emit("on-add", command);
    },
    handleRemove(item, index2) {
      this.$emit("on-remove", item.eventName);
    },
    handleCode(item) {
      this.$emit("on-edit", item);
    }
  },
  watch: {
    events: {
      deep: true,
      handler(val) {
        this.eventsModel = val;
        this.eventArray = Object.keys(this.events).map((item) => ({
          eventName: item,
          functionKey: this.events[item]
        })).filter((item) => item.functionKey);
      }
    },
    eventsModel: {
      deep: true,
      handler(val) {
        this.$emit("update:events", val);
      }
    },
    eventArray: {
      deep: true,
      handler(val) {
        for (let i = 0; i < val.length; i++) {
          this.eventsModel[val[i].eventName] = val[i].functionKey;
        }
      }
    }
  }
};
const _hoisted_1$E = { class: "event-panel-config" };
const _hoisted_2$z = { class: "event-panel-item" };
const _hoisted_3$t = ["onClick", "title"];
const _hoisted_4$s = ["onClick", "title"];
const _hoisted_5$s = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
function _sfc_render$X(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  const _component_el_collapse_item = resolveComponent("el-collapse-item");
  const _component_el_collapse = resolveComponent("el-collapse");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_dropdown_item = resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = resolveComponent("el-dropdown");
  return openBlock(), createElementBlock("div", _hoisted_1$E, [
    $data.eventArray.length ? (openBlock(), createBlock(_component_el_collapse, {
      key: 0,
      modelValue: $data.eventArray.map((item) => item.eventName)
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.eventArray, (item, index2) => {
          var _a2;
          return openBlock(), createBlock(_component_el_collapse_item, {
            key: item.eventName,
            name: item.eventName,
            title: _ctx.$i18n.locale == "zh-cn" ? (_a2 = $data.eventEnum[item.eventName]) != null ? _a2 : item.eventName : item.eventName
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_2$z, [
                createVNode(_component_el_select, {
                  size: "default",
                  style: { "width": "100%", "margin-bottom": "5px" },
                  modelValue: item.functionKey,
                  "onUpdate:modelValue": ($event) => item.functionKey = $event
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList($props.eventscripts, (item2) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: item2.value,
                        label: item2.label,
                        value: item2.value
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                createElementVNode("i", {
                  class: "fm-iconfont icon-code",
                  onClick: ($event) => $options.handleCode(item),
                  title: _ctx.$t("fm.eventscript.config.code")
                }, null, 8, _hoisted_3$t),
                createElementVNode("i", {
                  class: "fm-iconfont icon-trash",
                  onClick: ($event) => $options.handleRemove(item, index2),
                  title: _ctx.$t("fm.tooltip.trash")
                }, null, 8, _hoisted_4$s)
              ])
            ]),
            _: 2
          }, 1032, ["name", "title"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])) : createCommentVNode("", true),
    createVNode(_component_el_dropdown, {
      style: { "width": "100%", "margin-top": "5px", "display": "block" },
      trigger: "click",
      onCommand: $options.handleCommand,
      szie: "small"
    }, {
      dropdown: withCtx(() => [
        createVNode(_component_el_dropdown_menu, { style: { "width": "280px" } }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(Object.keys($props.events), (e) => {
              return openBlock(), createElementBlock(Fragment, { key: e }, [
                _ctx.$i18n.locale == "zh-cn" ? (openBlock(), createBlock(_component_el_dropdown_item, {
                  key: 0,
                  disabled: $data.eventArray.filter((item) => item.eventName == e).length != 0,
                  command: e
                }, {
                  default: withCtx(() => {
                    var _a2;
                    return [
                      createTextVNode(toDisplayString$1((_a2 = $data.eventEnum[e]) != null ? _a2 : e), 1)
                    ];
                  }),
                  _: 2
                }, 1032, ["disabled", "command"])) : (openBlock(), createBlock(_component_el_dropdown_item, {
                  key: 1,
                  disabled: $data.eventArray.filter((item) => item.eventName == e).length != 0,
                  command: e
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(e), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "command"]))
              ], 64);
            }), 128))
          ]),
          _: 1
        })
      ]),
      default: withCtx(() => [
        createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          style: { "width": "100%" },
          size: "default"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.eventscript.config.create")), 1),
            _hoisted_5$s
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onCommand"])
  ]);
}
var EventConfig = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["render", _sfc_render$X]]);
const _sfc_main$Z = {
  __name: "index",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    toolbar: { type: Array },
    disabled: { type: Boolean },
    customStyle: { type: Object }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props2 = __props;
    const editorValue = ref(props2.modelValue);
    let newValue = props2.modelValue;
    const emit2 = __emit;
    const quillEditor = ref(null);
    watch(() => props2.modelValue, (val) => {
      if (newValue === val)
        return;
      quillEditor.value.setHTML(val);
      nextTick(() => {
        let q = quillEditor.value.getQuill();
        q.setSelection(val.length, 0, "api");
        q.focus();
      });
    });
    watch(editorValue, (val) => {
      emit2("update:modelValue", val);
      newValue = val;
    });
    return (_ctx, _cache) => {
      const _component_QuillEditor = resolveComponent("QuillEditor");
      return openBlock(), createElementBlock("div", {
        style: normalizeStyle(__props.customStyle)
      }, [
        createVNode(_component_QuillEditor, {
          content: editorValue.value,
          "onUpdate:content": _cache[0] || (_cache[0] = ($event) => editorValue.value = $event),
          toolbar: __props.toolbar,
          enable: !__props.disabled,
          "read-only": __props.disabled,
          "content-type": "html",
          ref_key: "quillEditor",
          ref: quillEditor
        }, null, 8, ["content", "toolbar", "enable", "read-only"])
      ], 4);
    };
  }
};
var tinyEmitter = { exports: {} };
function E$1() {
}
E$1.prototype = {
  on: function(name, callback, ctx) {
    var e = this.e || (this.e = {});
    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx
    });
    return this;
  },
  once: function(name, callback, ctx) {
    var self2 = this;
    function listener() {
      self2.off(name, listener);
      callback.apply(ctx, arguments);
    }
    listener._ = callback;
    return this.on(name, listener, ctx);
  },
  emit: function(name) {
    var data2 = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;
    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data2);
    }
    return this;
  },
  off: function(name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];
    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }
    liveEvents.length ? e[name] = liveEvents : delete e[name];
    return this;
  }
};
tinyEmitter.exports = E$1;
tinyEmitter.exports.TinyEmitter = E$1;
var E = tinyEmitter.exports;
var instance = new E();
const EventBus = {
  $on: (...args) => instance.on(...args),
  $once: (...args) => instance.once(...args),
  $off: (...args) => instance.off(...args),
  $emit: (...args) => instance.emit(...args)
};
const _sfc_main$Y = {
  components: {
    Draggable: draggableComponent,
    CodeEditor,
    CodeDialog,
    CusDialog,
    FmFormTable: FmFormTable$1,
    EventConfig,
    Editor: _sfc_main$Z
  },
  props: ["data", "sheets", "platform", "datasources", "eventscripts", "formKey", "fieldModels"],
  emits: ["on-event-add", "on-event-edit", "on-event-remove"],
  inject: ["getModelNode"],
  data() {
    return {
      validator: {
        type: null,
        required: null,
        pattern: null,
        range: null,
        length: null,
        validator: null
      },
      editorVisible: false,
      editorValue: "",
      tableVisible: false,
      customClassArray: this.data && this.data.options && this.data.options.customClass ? this.data.options.customClass.split(" ").filter((item) => item) : []
    };
  },
  computed: {
    show() {
      if (this.data && Object.keys(this.data).length > 0 && this.data.key && this.data.options) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    this.validateRequired(this.data && this.data.options ? this.data.options.required : false);
    this.validateDataType(this.data && this.data.options ? this.data.options.dataType : "");
    this.valiatePattern(this.data && this.data.options ? this.data.options.pattern : "");
    this.validateCustom(this.data && this.data.options ? this.data.options.validator : "");
  },
  methods: {
    handleCopyField() {
      const textarea = document.createElement("textarea");
      textarea.value = this.getModelNode() + this.data.model;
      document.getElementsByClassName("clipboard-content")[0].appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.getElementsByClassName("clipboard-content")[0].removeChild(textarea);
      ElMessage({
        message: this.$t("fm.message.copySuccess"),
        type: "success"
      });
    },
    handleOptionsRemove(index2) {
      if (this.data.type === "grid") {
        this.data.columns.splice(index2, 1);
      } else if (this.data.type === "tabs" || this.data.type === "collapse") {
        this.data.tabs.splice(index2, 1);
      } else if (this.data.type === "imgupload" || this.data.type === "fileupload") {
        this.data.options.headers.splice(index2, 1);
      } else if (this.data.type === "steps") {
        this.data.options.steps.splice(index2, 1);
      } else if (this.data.type === "transfer") {
        this.data.options.data.splice(index2, 1);
      } else {
        if (!this.data.options.remote && this.data.options.options[index2].value) {
          this.data.options.defaultValue = typeof this.data.options.defaultValue === "string" ? "" : [];
        }
        this.data.options.options.splice(index2, 1);
      }
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleClearSelect() {
      if (this.data.type == "checkbox" || this.data.type == "select" && this.data.options.multiple || this.data.type == "transfer") {
        this.data.options.defaultValue = [];
      } else {
        this.data.options.defaultValue = "";
      }
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleAddData() {
      this.data.options.data.push({
        key: "",
        label: ""
      });
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleAddStep() {
      this.data.options.steps.push({
        title: "New Step",
        description: ""
      });
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleAddOption() {
      if (this.data.options.showLabel) {
        this.data.options.options.push({
          value: this.$t("fm.config.widget.newOption"),
          label: this.$t("fm.config.widget.newOption")
        });
      } else {
        this.data.options.options.push({
          value: this.$t("fm.config.widget.newOption")
        });
      }
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleAddTab() {
      let length = this.data.tabs.length;
      this.data.tabs.push({
        label: this.$t("fm.config.widget.tab") + (length + 1),
        name: "tab_" + Math.random().toString(36).slice(-8),
        list: []
      });
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleAddCollapse() {
      let length = this.data.tabs.length;
      this.data.tabs.push({
        title: this.$t("fm.config.widget.collapse") + (length + 1),
        name: "collapse_" + Math.random().toString(36).slice(-8),
        list: []
      });
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleAddHeader() {
      if ("headers" in this.data.options) {
        this.data.options.headers.push({
          key: "",
          value: ""
        });
      } else {
        this.data.options["headers"] = [{ key: "", value: "" }];
      }
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    generateRule() {
      if (this.data) {
        this.data.rules = [];
        Object.keys(this.validator).forEach((key) => {
          if (this.validator[key]) {
            this.data.rules.push(this.validator[key]);
          }
        });
      }
    },
    handleSelectMuliple(value) {
      if (this.data.type == "select" || this.data.type == "treeselect") {
        if (value) {
          if (this.data.options.defaultValue) {
            this.data.options.defaultValue = [this.data.options.defaultValue];
          } else {
            this.data.options.defaultValue = [];
          }
        } else {
          if (this.data.options.defaultValue.length > 0) {
            this.data.options.defaultValue = this.data.options.defaultValue[0];
          } else {
            this.data.options.defaultValue = "";
          }
        }
      }
    },
    handleSetTemplate() {
      this.$refs.codeDialog.open(this.data.options.template);
    },
    handleTemplateConfirm(value) {
      try {
        this.data.options.template = value;
        this.$refs.codeDialog.close();
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      } catch (e) {
        this.$refs.codeDialog.end();
        ElMessage({
          message: e.message,
          type: "error"
        });
      }
    },
    handleSetEditorValue() {
      this.editorVisible = true;
      this.editorValue = this.data.options.defaultValue;
    },
    handleEditorValueConfirm(value) {
      try {
        this.data.options.defaultValue = this.editorValue;
        this.editorVisible = false;
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      } catch (e) {
        this.editorVisible = false;
        ElMessage({
          message: e.message,
          type: "error"
        });
      }
    },
    handleSetDefaultValue() {
      this.$refs.defaultValueDialog.open(this.data.options.defaultValue);
    },
    handleDefaultValueConfirm(value) {
      try {
        if (typeof value == "string") {
          this.data.options.defaultValue = Function('"use strict";return (' + value + ")")();
        } else {
          this.data.options.defaultValue = value;
        }
        this.$refs.defaultValueDialog.close();
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      } catch (e) {
        this.$refs.defaultValueDialog.end();
        ElMessage({
          message: e.message,
          type: "error"
        });
      }
    },
    handleSetCascader() {
      this.$refs.cascaderDialog.open(this.data.options.options);
    },
    handleCascaderConfirm(value) {
      try {
        if (typeof value == "string") {
          this.data.options.options = Function('"use strict";return (' + value + ")")();
        } else {
          this.data.options.options = value;
        }
        this.$refs.cascaderDialog.close();
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      } catch (e) {
        this.$refs.cascaderDialog.end();
        ElMessage({
          message: e.message,
          type: "error"
        });
      }
    },
    handleSetTree() {
      this.$refs.treeDialog.open(this.data.options.options);
    },
    handleTreeConfirm(value) {
      try {
        if (typeof value == "string") {
          this.data.options.options = Function('"use strict";return (' + value + ")")();
        } else {
          this.data.options.options = value;
        }
        this.$refs.treeDialog.close();
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      } catch (e) {
        this.$refs.treeDialog.end();
        ElMessage({
          message: e.message,
          type: "error"
        });
      }
    },
    handleSetProps() {
      if (!this.data.options.extendProps) {
        this.data.options.extendProps = {};
      }
      this.$refs.extendPropsDialog.open(this.data.options.extendProps);
    },
    handlePropsConfirm(value) {
      try {
        if (typeof value == "string") {
          this.data.options.extendProps = Function('"use strict";return (' + value + ")")();
        } else {
          this.data.options.extendProps = value;
        }
        this.$refs.extendPropsDialog.close();
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      } catch (e) {
        this.$refs.extendPropsDialog.end();
        ElMessage({
          message: e.message,
          type: "error"
        });
      }
    },
    validateRequired(val) {
      if (val) {
        this.validator.required = { required: true, message: this.data.options.requiredMessage ? this.data.options.requiredMessage : `` };
      } else {
        this.validator.required = null;
      }
      this.$nextTick(() => {
        this.generateRule();
      });
    },
    validateDataType(val) {
      if (!this.show) {
        return false;
      }
      if (val && (this.data.options.dataTypeCheck || !Object.keys(this.data.options).includes("dataTypeCheck"))) {
        this.validator.type = { type: val, message: this.data.options.dataTypeMessage ? this.data.options.dataTypeMessage : "" };
      } else {
        this.validator.type = null;
      }
      this.generateRule();
    },
    valiatePattern(val) {
      if (!this.show) {
        return false;
      }
      if (val && (this.data.options.patternCheck || !Object.keys(this.data.options).includes("patternCheck"))) {
        this.validator.pattern = { pattern: val, message: this.data.options.patternMessage ? this.data.options.patternMessage : "" };
      } else {
        this.validator.pattern = null;
      }
      this.generateRule();
    },
    validateCustom(val) {
      if (!this.show) {
        return false;
      }
      if (val && this.data.options.validatorCheck) {
        this.validator.validator = { func: val };
      } else {
        this.validator.validator = null;
      }
      this.generateRule();
    },
    handleEventAdd(name) {
      this.$emit("on-event-add", name);
    },
    handleEventEdit({ eventName, functionKey }) {
      this.$emit("on-event-edit", { eventName, functionKey });
    },
    handleEventRemove(eventName) {
      this.$emit("on-event-remove", eventName);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    setEvent(eventObj) {
      this.data.events[eventObj.type] = eventObj.key;
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleDataSourceChange(value) {
      var _a2;
      let args = (_a2 = this.datasources.find((item) => item.value == value)) == null ? void 0 : _a2.args;
      if (args) {
        this.data.options.remoteArgs = args;
      }
    }
  },
  watch: {
    "data.options.isRange": function(val) {
      if (typeof val !== "undefined") {
        if (val) {
          this.data.options.defaultValue = null;
        } else {
          if (Object.keys(this.data.options).indexOf("defaultValue") >= 0)
            this.data.options.defaultValue = "";
        }
      }
    },
    "data.options.type": function(val) {
      if (this.data.type == "date") {
        if (val == "daterange" || val == "datetimerange" || val == "dates") {
          this.data.options.defaultValue = [];
        } else {
          this.data.options.defaultValue = "";
        }
      }
    },
    "data.options.required": function(val) {
      this.validateRequired(val);
    },
    "data.options.requiredMessage": function(val) {
      this.validateRequired(this.data && this.data.options ? this.data.options.required : false);
    },
    "data.options.dataType": function(val) {
      this.validateDataType(val);
    },
    "data.options.dataTypeCheck": function(val) {
      this.validateDataType(this.data && this.data.options ? this.data.options.dataType : "");
    },
    "data.options.dataTypeMessage": function(val) {
      this.validateDataType(this.data && this.data.options ? this.data.options.dataType : "");
    },
    "data.options.pattern": function(val) {
      this.valiatePattern(val);
    },
    "data.options.patternCheck": function(val) {
      this.valiatePattern(this.data && this.data.options ? this.data.options.pattern : "");
    },
    "data.options.patternMessage": function(val) {
      this.valiatePattern(this.data && this.data.options ? this.data.options.pattern : "");
    },
    "data.options.validator": function(val) {
      this.validateCustom(val);
    },
    "data.options.validatorCheck": function(val) {
      this.validateCustom(this.data && this.data.options ? this.data.options.validator : "");
    },
    "data.options.options": {
      deep: true,
      handler(val) {
        if (this.data.options && typeof this.data.options.defaultValue == "object" && Array.isArray(this.data.options.defaultValue)) {
          this.data.options.defaultValue = this.data.options.defaultValue.filter((item) => val.map((item2) => item2.value).includes(item));
        }
        if (this.data.options && typeof this.data.options.defaultValue == "string") {
          if (typeof val == "object" && !val.map((item) => item.value).includes(this.data.options.defaultValue)) {
            this.data.options.defaultValue = "";
          }
        }
      }
    },
    "data.options.customClass": function(val) {
      this.customClassArray = this.data && this.data.options && this.data.options.customClass ? this.data.options.customClass.split(" ").filter((item) => item) : [];
    },
    "data.options.format": function(val) {
      this.data.options.defaultValue = "";
    },
    customClassArray(val) {
      this.data.options.customClass = val.join(" ");
    }
  }
};
const _hoisted_1$D = ["title"];
const _hoisted_2$y = {
  key: 0,
  style: { "font-size": "13px", "word-break": "break-all", "line-height": "1.2", "color": "#e6a23c", "padding": "0 5px 5px 5px" }
};
const _hoisted_3$s = {
  style: { "display": "flex" },
  class: "clipboard-content"
};
const _hoisted_4$r = { key: 0 };
const _hoisted_5$r = { style: { "width": "30px" } };
const _hoisted_6$o = { style: { "width": "30px" } };
const _hoisted_7$n = { key: 0 };
const _hoisted_8$g = /* @__PURE__ */ createElementVNode("i", {
  class: "drag-item",
  style: { "font-size": "16px", "margin": "0 5px", "cursor": "move" }
}, [
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-icon_bars" })
], -1);
const _hoisted_9$f = ["onClick"];
const _hoisted_10$a = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" }, null, -1);
const _hoisted_11$9 = [
  _hoisted_10$a
];
const _hoisted_12$9 = /* @__PURE__ */ createElementVNode("i", {
  class: "drag-item",
  style: { "font-size": "16px", "margin": "0 5px", "cursor": "move" }
}, [
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-icon_bars" })
], -1);
const _hoisted_13$7 = ["onClick"];
const _hoisted_14$6 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" }, null, -1);
const _hoisted_15$4 = [
  _hoisted_14$6
];
const _hoisted_16$3 = {
  key: 3,
  style: { "margin-left": "22px" }
};
const _hoisted_17$2 = /* @__PURE__ */ createElementVNode("div", { style: { "width": "30px" } }, "Title", -1);
const _hoisted_18$1 = /* @__PURE__ */ createElementVNode("div", { style: { "width": "60px" } }, "Description", -1);
const _hoisted_19$1 = { style: { "display": "inline-block", "vertical-align": "middle" } };
const _hoisted_20$1 = /* @__PURE__ */ createElementVNode("br", null, null, -1);
const _hoisted_21$1 = /* @__PURE__ */ createElementVNode("i", {
  class: "drag-item",
  style: { "font-size": "16px", "margin": "0 5px", "cursor": "move" }
}, [
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-icon_bars" })
], -1);
const _hoisted_22$1 = ["onClick"];
const _hoisted_23$1 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" }, null, -1);
const _hoisted_24$1 = [
  _hoisted_23$1
];
const _hoisted_25$1 = { style: { "margin-left": "5px" } };
const _hoisted_26$1 = /* @__PURE__ */ createElementVNode("div", { style: { "width": "30px" } }, "Key", -1);
const _hoisted_27$1 = /* @__PURE__ */ createElementVNode("div", { style: { "width": "30px" } }, "Label", -1);
const _hoisted_28$1 = /* @__PURE__ */ createElementVNode("div", { style: { "width": "50px" } }, "Disabled", -1);
const _hoisted_29$1 = { style: { "display": "inline-block", "vertical-align": "middle" } };
const _hoisted_30$1 = /* @__PURE__ */ createElementVNode("br", null, null, -1);
const _hoisted_31$1 = /* @__PURE__ */ createElementVNode("i", {
  class: "drag-item",
  style: { "font-size": "16px", "margin": "0 5px", "cursor": "move" }
}, [
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-icon_bars" })
], -1);
const _hoisted_32$1 = ["onClick"];
const _hoisted_33$1 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" }, null, -1);
const _hoisted_34$1 = [
  _hoisted_33$1
];
const _hoisted_35 = { style: { "margin-left": "5px" } };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" }, null, -1);
const _hoisted_38 = [
  _hoisted_37
];
const _hoisted_39 = /* @__PURE__ */ createElementVNode("i", {
  class: "drag-item",
  style: { "font-size": "16px", "margin": "0 5px", "cursor": "move" }
}, [
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-icon_bars" })
], -1);
const _hoisted_40 = ["onClick"];
const _hoisted_41 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" }, null, -1);
const _hoisted_42 = [
  _hoisted_41
];
const _hoisted_43 = { style: { "margin-left": "22px" } };
const _hoisted_44 = /* @__PURE__ */ createElementVNode("i", {
  class: "drag-item",
  style: { "font-size": "16px", "margin": "0 5px", "cursor": "move" }
}, [
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-icon_bars" })
], -1);
const _hoisted_45 = ["onClick"];
const _hoisted_46 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" }, null, -1);
const _hoisted_47 = [
  _hoisted_46
];
const _hoisted_48 = { style: { "margin-left": "22px" } };
const _hoisted_49 = {
  key: 0,
  class: "validate-block"
};
const _hoisted_50 = {
  key: 1,
  class: "validate-block"
};
const _hoisted_51 = {
  key: 2,
  class: "validate-block"
};
const _hoisted_52 = {
  key: 3,
  class: "validate-block"
};
const _hoisted_53 = { key: 0 };
const _hoisted_54 = /* @__PURE__ */ createElementVNode("div", {
  style: { "font-size": "14px", "font-weight": "500" },
  class: "code-line"
}, "(rule, value, callback) => {", -1);
const _hoisted_55 = /* @__PURE__ */ createElementVNode("div", {
  style: { "font-size": "14px", "font-weight": "500" },
  class: "code-line"
}, "}", -1);
const _hoisted_56 = {
  key: 1,
  class: "empty"
};
function _sfc_render$W(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = resolveComponent("el-tag");
  const _component_el_form_item = resolveComponent("el-form-item");
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  const _component_el_input = resolveComponent("el-input");
  const _component_el_checkbox = resolveComponent("el-checkbox");
  const _component_el_input_number = resolveComponent("el-input-number");
  const _component_el_switch = resolveComponent("el-switch");
  const _component_el_radio_button = resolveComponent("el-radio-button");
  const _component_el_radio_group = resolveComponent("el-radio-group");
  const _component_el_radio = resolveComponent("el-radio");
  const _component_code_editor = resolveComponent("code-editor");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_checkbox_group = resolveComponent("el-checkbox-group");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_rate = resolveComponent("el-rate");
  const _component_el_color_picker = resolveComponent("el-color-picker");
  const _component_el_cascader = resolveComponent("el-cascader");
  const _component_el_tree_select = resolveComponent("el-tree-select");
  const _component_el_time_picker = resolveComponent("el-time-picker");
  const _component_el_date_picker = resolveComponent("el-date-picker");
  const _component_event_config = resolveComponent("event-config");
  const _component_el_form = resolveComponent("el-form");
  const _component_code_dialog = resolveComponent("code-dialog");
  const _component_Editor = resolveComponent("Editor");
  const _component_cus_dialog = resolveComponent("cus-dialog");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  return openBlock(), createBlock(_component_el_scrollbar, null, {
    default: withCtx(() => {
      var _a2, _b;
      return [
        createElementVNode("div", null, [
          $options.show ? (openBlock(), createElementBlock("div", {
            key: $props.data.key
          }, [
            createVNode(_component_el_form, {
              "label-position": "top",
              size: "default",
              model: $props.data
            }, {
              default: withCtx(() => [
                createVNode(_component_el_form_item, {
                  label: _ctx.$t("fm.config.widget.widgetType")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_tag, { effect: "plain" }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t(`fm.components.fields.${$props.data.type}`)), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["label"]),
                $props.data.type != "td" && $props.data.type != "th" && $props.data.type != "col" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 0,
                  required: true,
                  prop: "model"
                }, {
                  label: withCtx(() => [
                    createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.model")) + " ", 1),
                    createElementVNode("i", {
                      class: "fm-iconfont icon-copy",
                      title: _ctx.$t("fm.tooltip.copy"),
                      onClick: _cache[0] || (_cache[0] = (...args) => $options.handleCopyField && $options.handleCopyField(...args)),
                      style: { "cursor": "pointer", "font-size": "18px", "padding": "0 5px", "color": "var(--fm-color-primary)" }
                    }, null, 8, _hoisted_1$D)
                  ]),
                  default: withCtx(() => {
                    var _a3;
                    return [
                      $options.getModelNode() ? (openBlock(), createElementBlock("div", _hoisted_2$y, toDisplayString$1($options.getModelNode()), 1)) : createCommentVNode("", true),
                      createElementVNode("div", _hoisted_3$s, [
                        ((_a3 = $props.fieldModels) == null ? void 0 : _a3.length) > 0 ? (openBlock(), createBlock(_component_el_select, {
                          key: 0,
                          modelValue: $props.data.model,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $props.data.model = $event),
                          filterable: "",
                          "allow-create": "",
                          "default-first-option": "",
                          style: { "width": "100%" }
                        }, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList($props.fieldModels, (item) => {
                              var _a4;
                              return openBlock(), createBlock(_component_el_option, {
                                key: item.fieldId,
                                label: (_a4 = item.fieldLabel) != null ? _a4 : item.fieldId,
                                value: item.fieldId
                              }, null, 8, ["label", "value"]);
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])) : (openBlock(), createBlock(_component_el_input, {
                          key: 1,
                          clearable: "",
                          modelValue: $props.data.model,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $props.data.model = $event)
                        }, null, 8, ["modelValue"]))
                      ])
                    ];
                  }),
                  _: 1
                })) : createCommentVNode("", true),
                $props.data.type != "grid" && $props.data.type != "tabs" && $props.data.type != "collapse" && $props.data.type != "report" && $props.data.type != "inline" && $props.data.type != "td" && $props.data.type != "th" && $props.data.type != "col" && $props.data.type != "alert" && $props.data.type != "dialog" && $props.data.type != "card" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 1,
                  label: _ctx.$t("fm.config.widget.name")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: $props.data.name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $props.data.name = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("buttonName") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 2,
                  label: _ctx.$t("fm.config.widget.buttonName")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: $props.data.options.buttonName,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $props.data.options.buttonName = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("linkName") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 3,
                  label: _ctx.$t("fm.config.widget.linkName")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: $props.data.options.linkName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $props.data.options.linkName = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("title") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 4,
                  label: _ctx.$t("fm.config.widget.otitle")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: $props.data.options.title,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $props.data.options.title = $event),
                      type: "textarea",
                      autosize: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("description") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 5,
                  label: _ctx.$t("fm.config.widget.description")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: $props.data.options.description,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => $props.data.options.description = $event),
                      type: "textarea",
                      autosize: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("width") >= 0 && $props.data.type != "td" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 6,
                  label: _ctx.$t("fm.config.widget.width")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: $props.data.options.width,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => $props.data.options.width = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("height") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 7,
                  label: _ctx.$t("fm.config.widget.height")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: $props.data.options.height,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => $props.data.options.height = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type == "imgupload" && Object.keys($props.data.options).indexOf("size") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 8,
                  label: _ctx.$t("fm.config.widget.size")
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.width")) + " ", 1),
                    createVNode(_component_el_input, {
                      clearable: "",
                      style: { "width": "90px" },
                      type: "number",
                      modelValue: $props.data.options.size.width,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $props.data.options.size.width = $event),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"]),
                    createTextVNode(" " + toDisplayString$1(_ctx.$t("fm.config.widget.height")) + " ", 1),
                    createVNode(_component_el_input, {
                      clearable: "",
                      style: { "width": "90px" },
                      type: "number",
                      modelValue: $props.data.options.size.height,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => $props.data.options.size.height = $event),
                      modelModifiers: { number: true }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("labelWidth") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 9,
                  label: _ctx.$t("fm.config.widget.labelWidth")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_checkbox, {
                      modelValue: $props.data.options.isLabelWidth,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => $props.data.options.isLabelWidth = $event),
                      style: { "margin-right": "5px" }
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.custom")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    createVNode(_component_el_input_number, {
                      modelValue: $props.data.options.labelWidth,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => $props.data.options.labelWidth = $event),
                      disabled: !$props.data.options.isLabelWidth,
                      min: 0,
                      max: 99999,
                      step: 10
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type != "grid" && $props.data.type != "tabs" && $props.data.type != "collapse" && $props.data.type != "report" && $props.data.type != "inline" && $props.data.type != "divider" && $props.data.type != "td" && $props.data.type != "th" && $props.data.type != "col" && $props.data.type != "alert" && $props.data.type != "dialog" && $props.data.type != "card" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 10,
                  label: _ctx.$t("fm.config.widget.labelWrap")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.labelWrap,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => $props.data.options.labelWrap = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type != "grid" && $props.data.type != "tabs" && $props.data.type != "collapse" && $props.data.type != "report" && $props.data.type != "inline" && $props.data.type != "divider" && $props.data.type != "td" && $props.data.type != "th" && $props.data.type != "col" && $props.data.type != "alert" && $props.data.type != "dialog" && $props.data.type != "card" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 11,
                  label: _ctx.$t("fm.config.widget.hideLabel")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.hideLabel,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => $props.data.options.hideLabel = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("placeholder") >= 0 && ($props.data.type != "time" && $props.data.type != "date") ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 12,
                  label: _ctx.$t("fm.config.widget.placeholder")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      modelValue: $props.data.options.placeholder,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => $props.data.options.placeholder = $event),
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("tip") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 13,
                  label: _ctx.$t("fm.config.widget.tip")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      type: "textarea",
                      autosize: "",
                      clearable: "",
                      modelValue: $props.data.options.tip,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => $props.data.options.tip = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("inline") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 14,
                  label: _ctx.$t("fm.config.widget.layout")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_group, {
                      modelValue: $props.data.options.inline,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => $props.data.options.inline = $event)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_button, {
                          label: false,
                          value: false
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.block")), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_radio_button, {
                          label: true,
                          value: true
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.inline")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("effect") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 15,
                  label: _ctx.$t("fm.config.widget.effect")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_group, {
                      modelValue: $props.data.options.effect,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => $props.data.options.effect = $event)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_button, {
                          label: "light",
                          value: "light"
                        }, {
                          default: withCtx(() => [
                            createTextVNode("light")
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_radio_button, {
                          label: "dark",
                          value: "dark"
                        }, {
                          default: withCtx(() => [
                            createTextVNode("dark")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("contentPosition") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 16,
                  label: _ctx.$t("fm.config.widget.contentPosition")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_group, {
                      modelValue: $props.data.options.contentPosition,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => $props.data.options.contentPosition = $event)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_button, {
                          label: "left",
                          value: "left"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.left")), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_radio_button, {
                          label: "center",
                          value: "center"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.center")), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_radio_button, {
                          label: "right",
                          value: "right"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.right")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("showInput") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 17,
                  label: _ctx.$t("fm.config.widget.showInput")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.showInput,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => $props.data.options.showInput = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("min") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 18,
                  label: _ctx.$t("fm.config.widget.min")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input_number, {
                      modelValue: $props.data.options.min,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => $props.data.options.min = $event),
                      step: 1
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("max") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 19,
                  label: _ctx.$t("fm.config.widget.max")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input_number, {
                      modelValue: $props.data.options.max,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => $props.data.options.max = $event),
                      step: 1
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("step") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 20,
                  label: _ctx.$t("fm.config.widget.step")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input_number, {
                      modelValue: $props.data.options.step,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => $props.data.options.step = $event),
                      min: -99999,
                      max: 99999,
                      step: 1
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("maxlength") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 21,
                  label: _ctx.$t("fm.config.widget.maxlength")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      modelValue: $props.data.options.maxlength,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => $props.data.options.maxlength = $event),
                      type: "number"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("rows") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 22,
                  label: _ctx.$t("fm.config.widget.rows")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input_number, {
                      modelValue: $props.data.options.rows,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => $props.data.options.rows = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("autosize") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 23,
                  label: _ctx.$t("fm.config.widget.autosize")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.autosize,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => $props.data.options.autosize = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("precision") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 24,
                  label: _ctx.$t("fm.config.widget.precision")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input_number, {
                      modelValue: $props.data.options.precision,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => $props.data.options.precision = $event),
                      min: 0,
                      max: 99999,
                      step: 1
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("controls") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 25,
                  label: _ctx.$t("fm.config.widget.controls")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.controls,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => $props.data.options.controls = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("controlsPosition") >= 0 && $props.data.options.controls ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 26,
                  label: _ctx.$t("fm.config.widget.controlsPosition")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_group, {
                      modelValue: $props.data.options.controlsPosition,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => $props.data.options.controlsPosition = $event)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_button, {
                          label: "",
                          value: ""
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.default")), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_radio_button, {
                          label: "right",
                          value: "right"
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.right")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type == "select" || $props.data.type == "imgupload" || $props.data.type == "fileupload" || $props.data.type == "cascader" || $props.data.type == "treeselect" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 27,
                  label: _ctx.$t("fm.config.widget.multiple")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.multiple,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => $props.data.options.multiple = $event),
                      onChange: $options.handleSelectMuliple
                    }, null, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type == "select" || $props.data.type == "cascader" || $props.data.type == "transfer" || $props.data.type == "treeselect" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 28,
                  label: _ctx.$t("fm.config.widget.filterable")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.filterable,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => $props.data.options.filterable = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("checkStrictly") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 29,
                  label: _ctx.$t("fm.config.widget.checkStrictly")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.checkStrictly,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => $props.data.options.checkStrictly = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("allowHalf") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 30,
                  label: _ctx.$t("fm.config.widget.allowHalf")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.allowHalf,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => $props.data.options.allowHalf = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("showAlpha") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 31,
                  label: _ctx.$t("fm.config.widget.showAlpha")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.showAlpha,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => $props.data.options.showAlpha = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("options") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 32,
                  label: _ctx.$t("fm.config.widget.option")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_group, {
                      modelValue: $props.data.options.remote,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => $props.data.options.remote = $event),
                      style: { "margin-bottom": "10px" }
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_button, {
                          label: false,
                          value: false
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.staticData")), 1)
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_radio_button, {
                          label: true,
                          value: true
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.remoteData")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    $props.data.options.remote ? (openBlock(), createElementBlock("div", _hoisted_4$r, [
                      createVNode(_component_el_radio_group, {
                        modelValue: $props.data.options.remoteType,
                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event) => $props.data.options.remoteType = $event),
                        style: { "margin-bottom": "8px" }
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio, {
                            label: "datasource",
                            value: "datasource"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.datasource.name")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio, {
                            label: "option",
                            value: "option"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.remoteAssigned")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio, {
                            label: "func",
                            value: "func"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.remoteFunc")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      $props.data.options.remoteType == "option" ? (openBlock(), createBlock(_component_el_input, {
                        key: 0,
                        clearable: "",
                        modelValue: $props.data.options.remoteOption,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => $props.data.options.remoteOption = $event),
                        style: { "margin-bottom": "5px" }
                      }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                      $props.data.options.remoteType == "func" ? (openBlock(), createBlock(_component_el_input, {
                        key: 1,
                        clearable: "",
                        modelValue: $props.data.options.remoteFunc,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => $props.data.options.remoteFunc = $event),
                        style: { "margin-bottom": "5px" }
                      }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                      $props.data.options.remoteType == "datasource" ? (openBlock(), createBlock(_component_el_select, {
                        key: 2,
                        style: { "width": "100%", "margin-bottom": "5px" },
                        onChange: $options.handleDataSourceChange,
                        modelValue: $props.data.options.remoteDataSource,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => $props.data.options.remoteDataSource = $event)
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList($props.datasources, (item) => {
                            return openBlock(), createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]);
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onChange", "modelValue"])) : createCommentVNode("", true),
                      $props.data.options.remoteType == "datasource" && $props.data.options.remoteArgs ? (openBlock(), createBlock(_component_code_editor, {
                        key: $props.data.options.remoteDataSource,
                        mode: "json",
                        modelValue: $props.data.options.remoteArgs,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => $props.data.options.remoteArgs = $event),
                        height: "120px",
                        style: { "width": "100%", "margin-bottom": "5px" }
                      }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                      createVNode(_component_el_input, {
                        clearable: "",
                        modelValue: $props.data.options.props.value,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => $props.data.options.props.value = $event)
                      }, {
                        prepend: withCtx(() => [
                          createElementVNode("div", _hoisted_5$r, toDisplayString$1(_ctx.$t("fm.config.widget.value")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      createVNode(_component_el_input, {
                        clearable: "",
                        modelValue: $props.data.options.props.label,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => $props.data.options.props.label = $event)
                      }, {
                        prepend: withCtx(() => [
                          createElementVNode("div", _hoisted_6$o, toDisplayString$1(_ctx.$t("fm.config.widget.label")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      createVNode(_component_el_input, {
                        clearable: "",
                        modelValue: $props.data.options.props.children,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => $props.data.options.props.children = $event)
                      }, {
                        prepend: withCtx(() => [
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.childrenOption")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      Object.keys($props.data.options).indexOf("showLabel") >= 0 ? (openBlock(), createElementBlock("div", _hoisted_7$n, [
                        createVNode(_component_el_checkbox, {
                          modelValue: $props.data.options.showLabel,
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => $props.data.options.showLabel = $event)
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.showLabel")), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])) : createCommentVNode("", true),
                      $props.data.type == "radio" || $props.data.type == "select" && !$props.data.options.multiple ? (openBlock(), createBlock(_component_el_radio_group, {
                        key: 1,
                        modelValue: $props.data.options.defaultValue,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => $props.data.options.defaultValue = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_draggable, mergeProps({
                            tag: "ul",
                            modelValue: $props.data.options.options,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => $props.data.options.options = $event)
                          }, { group: { name: "options" }, ghostClass: "ghost", handle: ".drag-item" }, {
                            handle: ".drag-item",
                            "item-key": "index"
                          }), {
                            item: withCtx(({ element: item, index: index2 }) => [
                              (openBlock(), createElementBlock("li", { key: index2 }, [
                                createVNode(_component_el_radio, {
                                  label: item.value,
                                  value: item.value,
                                  style: { "margin-right": "5px" }
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_el_input, {
                                      clearable: "",
                                      style: normalizeStyle({ "width": $props.data.options.showLabel ? "90px" : "180px" }),
                                      modelValue: item.value,
                                      "onUpdate:modelValue": ($event) => item.value = $event
                                    }, null, 8, ["style", "modelValue", "onUpdate:modelValue"]),
                                    $props.data.options.showLabel ? (openBlock(), createBlock(_component_el_input, {
                                      key: 0,
                                      clearable: "",
                                      style: { "width": "90px" },
                                      modelValue: item.label,
                                      "onUpdate:modelValue": ($event) => item.label = $event
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]),
                                _hoisted_8$g,
                                createElementVNode("i", {
                                  onClick: ($event) => $options.handleOptionsRemove(index2),
                                  style: { "font-size": "16px", "margin": "0 5px", "cursor": "pointer" }
                                }, _hoisted_11$9, 8, _hoisted_9$f)
                              ]))
                            ]),
                            _: 1
                          }, 16, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])) : createCommentVNode("", true),
                      $props.data.type == "checkbox" || $props.data.type == "select" && $props.data.options.multiple ? (openBlock(), createBlock(_component_el_checkbox_group, {
                        key: 2,
                        modelValue: $props.data.options.defaultValue,
                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => $props.data.options.defaultValue = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_draggable, mergeProps({
                            tag: "ul",
                            list: $props.data.options.options
                          }, { group: { name: "options" }, ghostClass: "ghost", handle: ".drag-item" }, {
                            handle: ".drag-item",
                            "item-key": "index"
                          }), {
                            item: withCtx(({ element: item, index: index2 }) => [
                              (openBlock(), createElementBlock("li", { key: index2 }, [
                                createVNode(_component_el_checkbox, {
                                  label: item.value,
                                  value: item.value,
                                  style: { "margin-right": "5px", "margin-bottom": "3px" }
                                }, {
                                  default: withCtx(() => [
                                    createVNode(_component_el_input, {
                                      clearable: "",
                                      style: normalizeStyle({ "width": $props.data.options.showLabel ? "90px" : "180px" }),
                                      modelValue: item.value,
                                      "onUpdate:modelValue": ($event) => item.value = $event
                                    }, null, 8, ["style", "modelValue", "onUpdate:modelValue"]),
                                    $props.data.options.showLabel ? (openBlock(), createBlock(_component_el_input, {
                                      key: 0,
                                      clearable: "",
                                      style: { "width": "90px" },
                                      modelValue: item.label,
                                      "onUpdate:modelValue": ($event) => item.label = $event
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]),
                                _hoisted_12$9,
                                createElementVNode("i", {
                                  onClick: ($event) => $options.handleOptionsRemove(index2),
                                  style: { "font-size": "16px", "margin": "0 5px", "cursor": "pointer" }
                                }, _hoisted_15$4, 8, _hoisted_13$7)
                              ]))
                            ]),
                            _: 1
                          }, 16, ["list"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])) : createCommentVNode("", true),
                      $props.data.type != "cascader" && $props.data.type != "treeselect" ? (openBlock(), createElementBlock("div", _hoisted_16$3, [
                        createVNode(_component_el_button, {
                          link: "",
                          type: "primary",
                          onClick: $options.handleAddOption
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.addOption")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        createVNode(_component_el_button, {
                          link: "",
                          type: "primary",
                          onClick: $options.handleClearSelect
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.clearSelect")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])) : createCommentVNode("", true),
                      $props.data.type == "cascader" ? (openBlock(), createBlock(_component_el_button, {
                        key: 4,
                        style: { "width": "100%" },
                        onClick: $options.handleSetCascader
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])) : createCommentVNode("", true),
                      $props.data.type == "treeselect" ? (openBlock(), createBlock(_component_el_button, {
                        key: 5,
                        style: { "width": "100%" },
                        onClick: $options.handleSetTree
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])) : createCommentVNode("", true)
                    ], 64))
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("steps") >= 0 ? (openBlock(), createElementBlock(Fragment, { key: 33 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.steps")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: $props.data.options.remote,
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event) => $props.data.options.remote = $event),
                        style: { "margin-bottom": "10px" }
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio_button, {
                            label: false,
                            value: false
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.staticData")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: true,
                            value: true
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.datasource.name")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      $props.data.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        createVNode(_component_el_select, {
                          onChange: $options.handleDataSourceChange,
                          style: { "width": "100%", "margin-bottom": "5px" },
                          modelValue: $props.data.options.remoteDataSource,
                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event) => $props.data.options.remoteDataSource = $event)
                        }, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList($props.datasources, (item) => {
                              return openBlock(), createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]);
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["onChange", "modelValue"]),
                        $props.data.options.remote && $props.data.options.remoteArgs ? (openBlock(), createBlock(_component_code_editor, {
                          key: $props.data.options.remoteDataSource,
                          mode: "json",
                          modelValue: $props.data.options.remoteArgs,
                          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event) => $props.data.options.remoteArgs = $event),
                          height: "120px",
                          style: { "width": "100%", "margin-bottom": "5px" }
                        }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                        createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: $props.data.options.props.title,
                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event) => $props.data.options.props.title = $event)
                        }, {
                          prepend: withCtx(() => [
                            _hoisted_17$2
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: $props.data.options.props.description,
                          "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event) => $props.data.options.props.description = $event)
                        }, {
                          prepend: withCtx(() => [
                            _hoisted_18$1
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        createVNode(_component_el_radio_group, {
                          modelValue: $props.data.options.defaultValue,
                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event) => $props.data.options.defaultValue = $event)
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_draggable, mergeProps({
                              tag: "ul",
                              list: $props.data.options.steps
                            }, { group: { name: "options" }, ghostClass: "ghost", handle: ".drag-item" }, {
                              handle: ".drag-item",
                              "item-key": "index"
                            }), {
                              item: withCtx(({ element: item, index: index2 }) => [
                                (openBlock(), createElementBlock("li", {
                                  key: index2,
                                  class: "drag-item-bk",
                                  style: { "padding": "5px", "margin-bottom": "5px", "display": "flex", "align-items": "center" }
                                }, [
                                  createVNode(_component_el_radio, {
                                    label: index2,
                                    value: index2,
                                    style: { "margin-right": "5px", "height": "100%" }
                                  }, {
                                    default: withCtx(() => [
                                      createElementVNode("div", _hoisted_19$1, [
                                        createVNode(_component_el_input, {
                                          placeholder: "Title",
                                          clearable: "",
                                          modelValue: item.title,
                                          "onUpdate:modelValue": ($event) => item.title = $event
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        createTextVNode(),
                                        _hoisted_20$1,
                                        createVNode(_component_el_input, {
                                          placeholder: "Description",
                                          clearable: "",
                                          modelValue: item.description,
                                          "onUpdate:modelValue": ($event) => item.description = $event
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]),
                                  _hoisted_21$1,
                                  createElementVNode("i", {
                                    onClick: ($event) => $options.handleOptionsRemove(index2),
                                    style: { "font-size": "16px", "margin": "0 5px", "cursor": "pointer" }
                                  }, _hoisted_24$1, 8, _hoisted_22$1)
                                ]))
                              ]),
                              _: 1
                            }, 16, ["list"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        createElementVNode("div", _hoisted_25$1, [
                          createVNode(_component_el_button, {
                            link: "",
                            type: "primary",
                            onClick: $options.handleAddStep
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.addOption")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ], 64))
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.space")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        modelValue: $props.data.options.space,
                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event) => $props.data.options.space = $event),
                        min: 0,
                        step: 10
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.direction")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: $props.data.options.direction,
                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event) => $props.data.options.direction = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio_button, {
                            label: "horizontal",
                            value: "horizontal"
                          }, {
                            default: withCtx(() => [
                              createTextVNode("Horizontal")
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: "vertical",
                            value: "vertical"
                          }, {
                            default: withCtx(() => [
                              createTextVNode("Vertical")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.processStatus")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_select, {
                        modelValue: $props.data.options.processStatus,
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event) => $props.data.options.processStatus = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_option, {
                            value: "wait",
                            label: "wait"
                          }),
                          createVNode(_component_el_option, {
                            value: "process",
                            label: "process"
                          }),
                          createVNode(_component_el_option, {
                            value: "finish",
                            label: "finish"
                          }),
                          createVNode(_component_el_option, {
                            value: "error",
                            label: "error"
                          }),
                          createVNode(_component_el_option, {
                            value: "success",
                            label: "success"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.finishStatus")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_select, {
                        modelValue: $props.data.options.finishStatus,
                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event) => $props.data.options.finishStatus = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_option, {
                            value: "wait",
                            label: "wait"
                          }),
                          createVNode(_component_el_option, {
                            value: "process",
                            label: "process"
                          }),
                          createVNode(_component_el_option, {
                            value: "finish",
                            label: "finish"
                          }),
                          createVNode(_component_el_option, {
                            value: "error",
                            label: "error"
                          }),
                          createVNode(_component_el_option, {
                            value: "success",
                            label: "success"
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.alignCenter")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.alignCenter,
                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event) => $props.data.options.alignCenter = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.simple")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.simple,
                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event) => $props.data.options.simple = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "transfer" ? (openBlock(), createElementBlock(Fragment, { key: 34 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.option")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: $props.data.options.remote,
                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event) => $props.data.options.remote = $event),
                        style: { "margin-bottom": "10px" }
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio_button, {
                            label: false,
                            value: false
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.staticData")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: true,
                            value: true
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.datasource.name")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      $props.data.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                        createVNode(_component_el_select, {
                          onChange: $options.handleDataSourceChange,
                          style: { "width": "100%", "margin-bottom": "5px" },
                          modelValue: $props.data.options.remoteDataSource,
                          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event) => $props.data.options.remoteDataSource = $event)
                        }, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList($props.datasources, (item) => {
                              return openBlock(), createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]);
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["onChange", "modelValue"]),
                        $props.data.options.remote && $props.data.options.remoteArgs ? (openBlock(), createBlock(_component_code_editor, {
                          key: $props.data.options.remoteDataSource,
                          mode: "json",
                          modelValue: $props.data.options.remoteArgs,
                          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event) => $props.data.options.remoteArgs = $event),
                          height: "120px",
                          style: { "width": "100%", "margin-bottom": "5px" }
                        }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                        createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: $props.data.options.props.key,
                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event) => $props.data.options.props.key = $event)
                        }, {
                          prepend: withCtx(() => [
                            _hoisted_26$1
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: $props.data.options.props.label,
                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event) => $props.data.options.props.label = $event)
                        }, {
                          prepend: withCtx(() => [
                            _hoisted_27$1
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: $props.data.options.props.disabled,
                          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event) => $props.data.options.props.disabled = $event)
                        }, {
                          prepend: withCtx(() => [
                            _hoisted_28$1
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                        createVNode(_component_el_checkbox_group, {
                          modelValue: $props.data.options.defaultValue,
                          "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event) => $props.data.options.defaultValue = $event)
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_draggable, mergeProps({
                              tag: "ul",
                              list: $props.data.options.data
                            }, { group: { name: "options" }, ghostClass: "ghost", handle: ".drag-item" }, {
                              handle: ".drag-item",
                              "item-key": "index"
                            }), {
                              item: withCtx(({ element: item, index: index2 }) => [
                                (openBlock(), createElementBlock("li", {
                                  key: item.key,
                                  class: "drag-item-bk",
                                  style: { "padding": "5px", "margin-bottom": "5px", "display": "flex", "align-items": "center" }
                                }, [
                                  createVNode(_component_el_checkbox, {
                                    label: item.key,
                                    value: item.value,
                                    style: { "margin-right": "5px", "height": "100%" }
                                  }, {
                                    default: withCtx(() => [
                                      createElementVNode("div", _hoisted_29$1, [
                                        createVNode(_component_el_input, {
                                          placeholder: "Key",
                                          clearable: "",
                                          modelValue: item.key,
                                          "onUpdate:modelValue": ($event) => item.key = $event,
                                          style: { "margin-bottom": "3px" }
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        createTextVNode(),
                                        _hoisted_30$1,
                                        createVNode(_component_el_input, {
                                          placeholder: "Label",
                                          clearable: "",
                                          modelValue: item.label,
                                          "onUpdate:modelValue": ($event) => item.label = $event
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]),
                                  _hoisted_31$1,
                                  createElementVNode("i", {
                                    onClick: ($event) => $options.handleOptionsRemove(index2),
                                    style: { "font-size": "16px", "margin": "0 5px", "cursor": "pointer" }
                                  }, _hoisted_34$1, 8, _hoisted_32$1)
                                ]))
                              ]),
                              _: 1
                            }, 16, ["list"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        createElementVNode("div", _hoisted_35, [
                          createVNode(_component_el_button, {
                            link: "",
                            type: "primary",
                            onClick: $options.handleAddData
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.addOption")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          createVNode(_component_el_button, {
                            link: "",
                            type: "primary",
                            onClick: $options.handleClearSelect
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.clearSelect")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ], 64))
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.titles")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        placeholder: "List 1",
                        modelValue: $props.data.options.titles[0],
                        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event) => $props.data.options.titles[0] = $event),
                        style: { "width": "130px" }
                      }, null, 8, ["modelValue"]),
                      createTextVNode(" - "),
                      createVNode(_component_el_input, {
                        placeholder: "List 2",
                        modelValue: $props.data.options.titles[1],
                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event) => $props.data.options.titles[1] = $event),
                        style: { "width": "130px" }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "alert" ? (openBlock(), createElementBlock(Fragment, { key: 35 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.type")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_select, {
                        modelValue: $props.data.options.type,
                        "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event) => $props.data.options.type = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_option, { value: "success" }),
                          createVNode(_component_el_option, { value: "warning" }),
                          createVNode(_component_el_option, { value: "info" }),
                          createVNode(_component_el_option, { value: "error" })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.closable")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.closable,
                        "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event) => $props.data.options.closable = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.center")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.center,
                        "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event) => $props.data.options.center = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.showIcon")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.showIcon,
                        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event) => $props.data.options.showIcon = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "pagination" ? (openBlock(), createElementBlock(Fragment, { key: 36 }, [
                  Object.keys($props.data.options).indexOf("pageSize") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 0,
                    label: _ctx.$t("fm.config.widget.pageSize")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        modelValue: $props.data.options.pageSize,
                        "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event) => $props.data.options.pageSize = $event),
                        step: 5,
                        min: 1,
                        max: 100
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  Object.keys($props.data.options).indexOf("pagerCount") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 1,
                    label: _ctx.$t("fm.config.widget.pagerCount")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        modelValue: $props.data.options.pagerCount,
                        "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event) => $props.data.options.pagerCount = $event),
                        step: 1,
                        min: 5,
                        max: 21
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  Object.keys($props.data.options).indexOf("total") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 2,
                    label: _ctx.$t("fm.config.widget.total")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        modelValue: $props.data.options.total,
                        "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event) => $props.data.options.total = $event),
                        step: 1,
                        min: 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  Object.keys($props.data.options).indexOf("background") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 3,
                    label: _ctx.$t("fm.config.widget.background")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.background,
                        "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event) => $props.data.options.background = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true)
                ], 64)) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("buttonSize") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 37,
                  label: _ctx.$t("fm.config.widget.buttonSize")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_group, {
                      modelValue: $props.data.options.buttonSize,
                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event) => $props.data.options.buttonSize = $event)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_button, {
                          label: "large",
                          value: "large"
                        }, {
                          default: withCtx(() => [
                            createTextVNode("Large")
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_radio_button, {
                          label: "default",
                          value: "default"
                        }, {
                          default: withCtx(() => [
                            createTextVNode("Default")
                          ]),
                          _: 1
                        }),
                        createVNode(_component_el_radio_button, {
                          label: "small",
                          value: "small"
                        }, {
                          default: withCtx(() => [
                            createTextVNode("Small")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("buttonType") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 38,
                  label: _ctx.$t("fm.config.widget.buttonType")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_select, {
                      modelValue: $props.data.options.buttonType,
                      "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event) => $props.data.options.buttonType = $event),
                      style: { "width": "100%" }
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_option, {
                          value: "",
                          label: "Default"
                        }),
                        createVNode(_component_el_option, {
                          value: "primary",
                          label: "Primary"
                        }),
                        createVNode(_component_el_option, {
                          value: "success",
                          label: "Success"
                        }),
                        createVNode(_component_el_option, {
                          value: "warning",
                          label: "Warning"
                        }),
                        createVNode(_component_el_option, {
                          value: "danger",
                          label: "Danger"
                        }),
                        createVNode(_component_el_option, {
                          value: "info",
                          label: "Info"
                        }),
                        createVNode(_component_el_option, {
                          value: "text",
                          label: "Text"
                        }),
                        createVNode(_component_el_option, {
                          value: "link",
                          label: "Link"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("linkType") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 39,
                  label: _ctx.$t("fm.config.widget.linkType")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_select, {
                      modelValue: $props.data.options.linkType,
                      "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event) => $props.data.options.linkType = $event),
                      style: { "width": "100%" }
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_option, {
                          value: "default",
                          label: "Default"
                        }),
                        createVNode(_component_el_option, {
                          value: "primary",
                          label: "Primary"
                        }),
                        createVNode(_component_el_option, {
                          value: "success",
                          label: "Success"
                        }),
                        createVNode(_component_el_option, {
                          value: "warning",
                          label: "Warning"
                        }),
                        createVNode(_component_el_option, {
                          value: "danger",
                          label: "Danger"
                        }),
                        createVNode(_component_el_option, {
                          value: "info",
                          label: "Info"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("buttonPlain") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 40,
                  label: _ctx.$t("fm.config.widget.buttonPlain")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.buttonPlain,
                      "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event) => $props.data.options.buttonPlain = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("buttonRound") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 41,
                  label: _ctx.$t("fm.config.widget.buttonRound")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.buttonRound,
                      "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event) => $props.data.options.buttonRound = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("buttonCircle") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 42,
                  label: _ctx.$t("fm.config.widget.buttonCircle")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.buttonCircle,
                      "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event) => $props.data.options.buttonCircle = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("href") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 43,
                  label: "href"
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: $props.data.options.href,
                      "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event) => $props.data.options.href = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("underline") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 44,
                  label: _ctx.$t("fm.config.widget.underline")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.underline,
                      "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event) => $props.data.options.underline = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("blank") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 45,
                  label: _ctx.$t("fm.config.widget.isBlank")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.blank,
                      "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event) => $props.data.options.blank = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("paging") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 46,
                  label: _ctx.$t("fm.config.widget.paging")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.paging,
                      "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event) => $props.data.options.paging = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.options.paging && Object.keys($props.data.options).indexOf("pageSize") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 47,
                  label: _ctx.$t("fm.config.widget.pageSize")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input_number, {
                      modelValue: $props.data.options.pageSize,
                      "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event) => $props.data.options.pageSize = $event),
                      step: 5,
                      min: 1
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("showControl") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 48,
                  label: _ctx.$t("fm.config.widget.showControl")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.showControl,
                      "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event) => $props.data.options.showControl = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("virtualTable") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 49,
                  label: _ctx.$t("fm.config.widget.virtualTable")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.virtualTable,
                      "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event) => $props.data.options.virtualTable = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.options.tableColumn ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 50,
                  label: _ctx.$t("fm.config.widget.fixedColumn")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_switch, {
                      modelValue: $props.data.options.fixedColumn,
                      "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event) => $props.data.options.fixedColumn = $event)
                    }, null, 8, ["modelValue"]),
                    $props.data.options.fixedColumn ? (openBlock(), createBlock(_component_el_select, {
                      key: 0,
                      modelValue: $props.data.options.fixedColumnPosition,
                      "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event) => $props.data.options.fixedColumnPosition = $event),
                      placeholder: _ctx.$t("fm.config.widget.fixedColumnSelect"),
                      style: { "margin-left": "10px", "width": "180px" }
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_option, {
                          label: _ctx.$t("fm.config.widget.left"),
                          value: "left"
                        }, null, 8, ["label"]),
                        createVNode(_component_el_option, {
                          label: _ctx.$t("fm.config.widget.right"),
                          value: "right"
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])) : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                Object.keys($props.data.options).indexOf("defaultValue") >= 0 && $props.data.type != "custom" && $props.data.type != "imgupload" && $props.data.type != "fileupload" && $props.data.type != "radio" && $props.data.type != "checkbox" && $props.data.type != "select" && $props.data.type != "date" && $props.data.type != "time" && $props.data.type != "steps" && $props.data.type != "transfer" && $props.data.type != "dialog" && $props.data.type != "card" && $props.data.type != "slider" && $props.data.type != "group" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 51,
                  label: _ctx.$t("fm.config.widget.defaultValue")
                }, {
                  default: withCtx(() => [
                    $props.data.type == "textarea" ? (openBlock(), createBlock(_component_el_input, {
                      key: 0,
                      clearable: "",
                      type: "textarea",
                      rows: $props.data.options.rows,
                      maxlength: $props.data.options.maxlength,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event) => $props.data.options.defaultValue = $event)
                    }, null, 8, ["rows", "maxlength", "modelValue"])) : createCommentVNode("", true),
                    $props.data.type == "input" || $props.data.type == "text" ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      $props.data.options.dataType == "number" || $props.data.options.dataType == "integer" || $props.data.options.dataType == "float" ? (openBlock(), createBlock(_component_el_input, {
                        key: 0,
                        clearable: "",
                        type: "number",
                        modelValue: $props.data.options.defaultValue,
                        "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event) => $props.data.options.defaultValue = $event),
                        modelModifiers: { number: true }
                      }, null, 8, ["modelValue"])) : (openBlock(), createBlock(_component_el_input, {
                        key: 1,
                        clearable: "",
                        modelValue: $props.data.options.defaultValue,
                        "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event) => $props.data.options.defaultValue = $event)
                      }, null, 8, ["modelValue"]))
                    ], 64)) : createCommentVNode("", true),
                    $props.data.type == "rate" ? (openBlock(), createBlock(_component_el_rate, {
                      key: 2,
                      style: { "display": "inline-block", "vertical-align": "middle" },
                      max: $props.data.options.max,
                      "allow-half": $props.data.options.allowHalf,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event) => $props.data.options.defaultValue = $event)
                    }, null, 8, ["max", "allow-half", "modelValue"])) : createCommentVNode("", true),
                    $props.data.type == "rate" ? (openBlock(), createBlock(_component_el_button, {
                      key: 3,
                      link: "",
                      type: "primary",
                      style: { "display": "inline-block", "vertical-align": "middle", "margin-left": "10px" },
                      onClick: _cache[97] || (_cache[97] = ($event) => $props.data.options.defaultValue = 0)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.clear")), 1)
                      ]),
                      _: 1
                    })) : createCommentVNode("", true),
                    $props.data.type == "color" ? (openBlock(), createBlock(_component_el_color_picker, {
                      key: 4,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event) => $props.data.options.defaultValue = $event),
                      "show-alpha": $props.data.options.showAlpha
                    }, null, 8, ["modelValue", "show-alpha"])) : createCommentVNode("", true),
                    $props.data.type == "switch" ? (openBlock(), createBlock(_component_el_switch, {
                      key: 5,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event) => $props.data.options.defaultValue = $event)
                    }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                    $props.data.type == "number" ? (openBlock(), createBlock(_component_el_input_number, {
                      key: 6,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event) => $props.data.options.defaultValue = $event),
                      step: $props.data.options.step,
                      min: $props.data.options.min,
                      max: $props.data.options.max
                    }, null, 8, ["modelValue", "step", "min", "max"])) : createCommentVNode("", true),
                    $props.data.type == "pagination" ? (openBlock(), createBlock(_component_el_input_number, {
                      key: 7,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event) => $props.data.options.defaultValue = $event),
                      step: 1,
                      min: 1
                    }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                    $props.data.type == "html" ? (openBlock(), createBlock(_component_code_editor, {
                      key: $props.data.key,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event) => $props.data.options.defaultValue = $event),
                      height: "200px"
                    }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                    $props.data.type == "cascader" ? (openBlock(), createBlock(_component_el_cascader, {
                      key: 9,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event) => $props.data.options.defaultValue = $event),
                      clearable: "",
                      options: $props.data.options.remote ? [] : $props.data.options.options,
                      style: { "width": "100%" },
                      props: { multiple: $props.data.options.multiple, checkStrictly: $props.data.options.checkStrictly },
                      filterable: $props.data.options.filterable,
                      "collapse-tags": ""
                    }, null, 8, ["modelValue", "options", "props", "filterable"])) : createCommentVNode("", true),
                    $props.data.type == "treeselect" ? (openBlock(), createBlock(_component_el_tree_select, {
                      key: 10,
                      modelValue: $props.data.options.defaultValue,
                      "onUpdate:modelValue": _cache[104] || (_cache[104] = ($event) => $props.data.options.defaultValue = $event),
                      clearable: "",
                      data: $props.data.options.remote ? [] : $props.data.options.options,
                      style: { "width": "100%" },
                      multiple: $props.data.options.multiple,
                      "check-strictly": $props.data.options.checkStrictly,
                      filterable: $props.data.options.filterable
                    }, null, 8, ["modelValue", "data", "multiple", "check-strictly", "filterable"])) : createCommentVNode("", true),
                    $props.data.type == "editor" ? (openBlock(), createBlock(_component_el_button, {
                      key: 11,
                      style: { "width": "100%" },
                      onClick: $options.handleSetEditorValue
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])) : createCommentVNode("", true),
                    $props.data.type == "table" || $props.data.type == "subform" ? (openBlock(), createBlock(_component_el_button, {
                      key: 12,
                      style: { "width": "100%" },
                      onClick: $options.handleSetDefaultValue
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])) : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type == "time" || $props.data.type == "date" ? (openBlock(), createElementBlock(Fragment, { key: 52 }, [
                  $props.data.type == "date" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 0,
                    label: _ctx.$t("fm.config.widget.showType")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_select, {
                        modelValue: $props.data.options.type,
                        "onUpdate:modelValue": _cache[105] || (_cache[105] = ($event) => $props.data.options.type = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_option, { value: "year" }),
                          createVNode(_component_el_option, { value: "month" }),
                          createVNode(_component_el_option, { value: "date" }),
                          createVNode(_component_el_option, { value: "week" }),
                          createVNode(_component_el_option, { value: "dates" }),
                          createVNode(_component_el_option, { value: "datetime" }),
                          createVNode(_component_el_option, { value: "datetimerange" }),
                          createVNode(_component_el_option, { value: "daterange" }),
                          createVNode(_component_el_option, { value: "monthrange" })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  $props.data.type == "time" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 1,
                    label: _ctx.$t("fm.config.widget.isRange")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.isRange,
                        "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event) => $props.data.options.isRange = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  !$props.data.options.isRange && $props.data.type == "time" || $props.data.type != "time" && $props.data.options.type != "datetimerange" && $props.data.options.type != "daterange" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 2,
                    label: _ctx.$t("fm.config.widget.placeholder")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        clearable: "",
                        modelValue: $props.data.options.placeholder,
                        "onUpdate:modelValue": _cache[107] || (_cache[107] = ($event) => $props.data.options.placeholder = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  $props.data.options.isRange || $props.data.options.type == "datetimerange" || $props.data.options.type == "daterange" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 3,
                    label: _ctx.$t("fm.config.widget.startPlaceholder")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        clearable: "",
                        modelValue: $props.data.options.startPlaceholder,
                        "onUpdate:modelValue": _cache[108] || (_cache[108] = ($event) => $props.data.options.startPlaceholder = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  $props.data.options.isRange || $props.data.options.type == "datetimerange" || $props.data.options.type == "daterange" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 4,
                    label: _ctx.$t("fm.config.widget.endPlaceholder")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        clearable: "",
                        modelValue: $props.data.options.endPlaceholder,
                        "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event) => $props.data.options.endPlaceholder = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.format")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        clearable: "",
                        modelValue: $props.data.options.format,
                        "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event) => $props.data.options.format = $event),
                        modelModifiers: { lazy: true }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  $props.data.type == "time" && Object.keys($props.data.options).indexOf("isRange") >= 0 ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 5,
                    label: _ctx.$t("fm.config.widget.defaultValue")
                  }, {
                    default: withCtx(() => [
                      !$props.data.options.isRange ? (openBlock(), createBlock(_component_el_time_picker, {
                        key: "1",
                        style: { "width": "100%" },
                        modelValue: $props.data.options.defaultValue,
                        "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event) => $props.data.options.defaultValue = $event),
                        arrowControl: $props.data.options.arrowControl,
                        "value-format": $props.data.options.format
                      }, null, 8, ["modelValue", "arrowControl", "value-format"])) : createCommentVNode("", true),
                      $props.data.options.isRange ? (openBlock(), createBlock(_component_el_time_picker, {
                        key: "2",
                        style: { "width": "100%" },
                        modelValue: $props.data.options.defaultValue,
                        "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event) => $props.data.options.defaultValue = $event),
                        "is-range": "",
                        arrowControl: $props.data.options.arrowControl,
                        "value-format": $props.data.options.format
                      }, null, 8, ["modelValue", "arrowControl", "value-format"])) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  $props.data.type == "date" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 6,
                    label: _ctx.$t("fm.config.widget.defaultValue")
                  }, {
                    default: withCtx(() => [
                      $props.data.options.type == "datetimerange" || $props.data.options.type == "daterange" ? (openBlock(), createBlock(_component_el_date_picker, {
                        key: "1",
                        modelValue: $props.data.options.defaultValue,
                        "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event) => $props.data.options.defaultValue = $event),
                        type: $props.data.options.type,
                        clearable: true,
                        "value-format": $props.data.options.timestamp ? "timestamp" : $props.data.options.format,
                        format: $props.data.options.format,
                        style: { "width": "100%" }
                      }, null, 8, ["modelValue", "type", "value-format", "format"])) : (openBlock(), createBlock(_component_el_date_picker, {
                        key: "2",
                        modelValue: $props.data.options.defaultValue,
                        "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event) => $props.data.options.defaultValue = $event),
                        type: $props.data.options.type,
                        clearable: true,
                        "value-format": $props.data.options.timestamp ? "timestamp" : $props.data.options.format,
                        format: $props.data.options.format,
                        style: { "width": "100%" }
                      }, null, 8, ["modelValue", "type", "value-format", "format"]))
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true)
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "imgupload" || $props.data.type == "fileupload" ? (openBlock(), createElementBlock(Fragment, { key: 53 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.limit")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        clearable: "",
                        type: "number",
                        modelValue: $props.data.options.limit,
                        "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event) => $props.data.options.limit = $event),
                        modelModifiers: { number: true }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.isQiniu")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.isQiniu,
                        "onUpdate:modelValue": _cache[116] || (_cache[116] = ($event) => $props.data.options.isQiniu = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  $props.data.options.isQiniu ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    createVNode(_component_el_form_item, {
                      label: "Domain",
                      required: true,
                      prop: "options.domain"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: $props.data.options.domain,
                          "onUpdate:modelValue": _cache[117] || (_cache[117] = ($event) => $props.data.options.domain = $event)
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_form_item, {
                      label: _ctx.$t("fm.config.widget.tokenFunc"),
                      required: true,
                      prop: "options.tokenType"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_radio_group, {
                          modelValue: $props.data.options.tokenType,
                          "onUpdate:modelValue": _cache[118] || (_cache[118] = ($event) => $props.data.options.tokenType = $event)
                        }, {
                          default: withCtx(() => [
                            createVNode(_component_el_radio, {
                              label: "datasource",
                              value: "datasource"
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.datasource.name")), 1)
                              ]),
                              _: 1
                            }),
                            createVNode(_component_el_radio, {
                              label: "func",
                              value: "func"
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.remoteFunc")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        $props.data.options.tokenType == "func" ? (openBlock(), createBlock(_component_el_input, {
                          key: 0,
                          clearable: "",
                          modelValue: $props.data.options.tokenFunc,
                          "onUpdate:modelValue": _cache[119] || (_cache[119] = ($event) => $props.data.options.tokenFunc = $event)
                        }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                        $props.data.options.tokenType == "datasource" ? (openBlock(), createBlock(_component_el_select, {
                          key: 1,
                          style: { "width": "100%" },
                          onChange: $options.handleDataSourceChange,
                          modelValue: $props.data.options.tokenDataSource,
                          "onUpdate:modelValue": _cache[120] || (_cache[120] = ($event) => $props.data.options.tokenDataSource = $event)
                        }, {
                          default: withCtx(() => [
                            (openBlock(true), createElementBlock(Fragment, null, renderList($props.datasources, (item) => {
                              return openBlock(), createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]);
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["onChange", "modelValue"])) : createCommentVNode("", true),
                        $props.data.options.tokenType == "datasource" && $props.data.options.remoteArgs ? (openBlock(), createBlock(_component_code_editor, {
                          key: $props.data.options.tokenDataSource,
                          mode: "json",
                          modelValue: $props.data.options.remoteArgs,
                          "onUpdate:modelValue": _cache[121] || (_cache[121] = ($event) => $props.data.options.remoteArgs = $event),
                          height: "120px",
                          style: { "width": "100%", "margin-bottom": "5px" }
                        }, null, 8, ["modelValue"])) : createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createVNode(_component_el_form_item, {
                      label: _ctx.$t("fm.config.widget.action"),
                      required: true,
                      prop: "options.action",
                      trigger: "change"
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: $props.data.options.action,
                          "onUpdate:modelValue": _cache[122] || (_cache[122] = ($event) => $props.data.options.action = $event)
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    createVNode(_component_el_form_item, {
                      label: _ctx.$t("fm.config.widget.headers")
                    }, {
                      default: withCtx(() => [
                        createElementVNode("ul", null, [
                          (openBlock(true), createElementBlock(Fragment, null, renderList($props.data.options.headers, (item, index2) => {
                            return openBlock(), createElementBlock("li", {
                              key: index2,
                              style: { "display": "flex", "align-items": "center" }
                            }, [
                              createVNode(_component_el_input, {
                                type: "textarea",
                                clearable: "",
                                rows: 1,
                                placeholder: "KEY",
                                size: "small",
                                style: { "width": "100px", "margin-right": "5px" },
                                modelValue: item.key,
                                "onUpdate:modelValue": ($event) => item.key = $event
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              createVNode(_component_el_input, {
                                type: "textarea",
                                clearable: "",
                                rows: 1,
                                placeholder: "VALUE",
                                size: "small",
                                style: { "width": "130px" },
                                modelValue: item.value,
                                "onUpdate:modelValue": ($event) => item.value = $event
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              createElementVNode("i", {
                                onClick: ($event) => $options.handleOptionsRemove(index2),
                                style: { "font-size": "16px", "margin": "5px", "cursor": "pointer" }
                              }, _hoisted_38, 8, _hoisted_36)
                            ]);
                          }), 128))
                        ]),
                        createElementVNode("div", null, [
                          createVNode(_component_el_button, {
                            link: "",
                            type: "primary",
                            onClick: $options.handleAddHeader
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.add")), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    createVNode(_component_el_form_item, {
                      label: _ctx.$t("fm.config.widget.withCredentials")
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_switch, {
                          modelValue: $props.data.options.withCredentials,
                          "onUpdate:modelValue": _cache[123] || (_cache[123] = ($event) => $props.data.options.withCredentials = $event)
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ], 64))
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "blank" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 54,
                  label: _ctx.$t("fm.config.widget.defaultType")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_select, {
                      modelValue: $props.data.options.defaultType,
                      "onUpdate:modelValue": _cache[124] || (_cache[124] = ($event) => $props.data.options.defaultType = $event)
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_el_option, {
                          value: "String",
                          label: _ctx.$t("fm.config.widget.string")
                        }, null, 8, ["label"]),
                        createVNode(_component_el_option, {
                          value: "Object",
                          label: _ctx.$t("fm.config.widget.object")
                        }, null, 8, ["label"]),
                        createVNode(_component_el_option, {
                          value: "Array",
                          label: _ctx.$t("fm.config.widget.array")
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type == "component" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 55,
                  label: _ctx.$t("fm.config.widget.customTemplates")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_button, {
                      style: { "width": "100%" },
                      onClick: $options.handleSetTemplate
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type == "inline" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 56,
                  label: _ctx.$t("fm.config.widget.spaceSize")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_input_number, {
                      clearable: "",
                      min: 0,
                      modelValue: $props.data.options.spaceSize,
                      "onUpdate:modelValue": _cache[125] || (_cache[125] = ($event) => $props.data.options.spaceSize = $event)
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type == "grid" ? (openBlock(), createElementBlock(Fragment, { key: 57 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.gutter"),
                    key: "gutter"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        clearable: "",
                        type: "number",
                        modelValue: $props.data.options.gutter,
                        "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event) => $props.data.options.gutter = $event),
                        modelModifiers: { number: true }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.flex"),
                    key: "flex"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.flex,
                        "onUpdate:modelValue": _cache[127] || (_cache[127] = ($event) => $props.data.options.flex = $event),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  $props.data.options.flex ? (openBlock(), createBlock(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.justify"),
                    key: "justify"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_select, {
                        modelValue: $props.data.options.justify,
                        "onUpdate:modelValue": _cache[128] || (_cache[128] = ($event) => $props.data.options.justify = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_option, {
                            value: "start",
                            label: _ctx.$t("fm.config.widget.justifyStart")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "end",
                            label: _ctx.$t("fm.config.widget.justifyEnd")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "center",
                            label: _ctx.$t("fm.config.widget.justifyCenter")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "space-around",
                            label: _ctx.$t("fm.config.widget.justifySpaceAround")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "space-between",
                            label: _ctx.$t("fm.config.widget.justifySpaceBetween")
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true),
                  $props.data.options.flex ? (openBlock(), createBlock(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.align"),
                    key: "align"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_select, {
                        modelValue: $props.data.options.align,
                        "onUpdate:modelValue": _cache[129] || (_cache[129] = ($event) => $props.data.options.align = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_option, {
                            value: "top",
                            label: _ctx.$t("fm.config.widget.alignTop")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "middle",
                            label: _ctx.$t("fm.config.widget.alignMiddle")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "bottom",
                            label: _ctx.$t("fm.config.widget.alignBottom")
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true)
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "col" ? (openBlock(), createElementBlock(Fragment, { key: 58 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.span")
                  }, {
                    default: withCtx(() => [
                      $props.platform == "pc" ? (openBlock(), createBlock(_component_el_input_number, {
                        key: 0,
                        modelValue: $props.data.options.md,
                        "onUpdate:modelValue": _cache[130] || (_cache[130] = ($event) => $props.data.options.md = $event),
                        step: 1,
                        min: 1,
                        max: 24
                      }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                      $props.platform == "pad" ? (openBlock(), createBlock(_component_el_input_number, {
                        key: 1,
                        modelValue: $props.data.options.sm,
                        "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event) => $props.data.options.sm = $event),
                        step: 1,
                        min: 1,
                        max: 24
                      }, null, 8, ["modelValue"])) : createCommentVNode("", true),
                      $props.platform == "mobile" ? (openBlock(), createBlock(_component_el_input_number, {
                        key: 2,
                        modelValue: $props.data.options.xs,
                        "onUpdate:modelValue": _cache[132] || (_cache[132] = ($event) => $props.data.options.xs = $event),
                        step: 1,
                        min: 1,
                        max: 24
                      }, null, 8, ["modelValue"])) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.offset")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        modelValue: $props.data.options.offset,
                        "onUpdate:modelValue": _cache[133] || (_cache[133] = ($event) => $props.data.options.offset = $event),
                        step: 1,
                        min: 0,
                        max: 24
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.push")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        modelValue: $props.data.options.push,
                        "onUpdate:modelValue": _cache[134] || (_cache[134] = ($event) => $props.data.options.push = $event),
                        step: 1,
                        min: 0,
                        max: 24
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.pull")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        modelValue: $props.data.options.pull,
                        "onUpdate:modelValue": _cache[135] || (_cache[135] = ($event) => $props.data.options.pull = $event),
                        step: 1,
                        min: 0,
                        max: 24
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "tabs" ? (openBlock(), createElementBlock(Fragment, { key: 59 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.type")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: $props.data.options.type,
                        "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event) => $props.data.options.type = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio_button, {
                            label: "",
                            value: ""
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.default")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: "card",
                            value: "card"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.card")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: "border-card",
                            value: "border-card"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.borderCard")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.tabPosition")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: $props.data.options.tabPosition,
                        "onUpdate:modelValue": _cache[137] || (_cache[137] = ($event) => $props.data.options.tabPosition = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio_button, {
                            label: "top",
                            value: "top"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.top")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: "left",
                            value: "left"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.left")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: "right",
                            value: "right"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.right")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: "bottom",
                            value: "bottom"
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.bottom")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.tabOption")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_draggable, mergeProps({
                        tag: "ul",
                        list: $props.data.tabs
                      }, { group: { name: "options" }, ghostClass: "ghost", handle: ".drag-item" }, {
                        handle: ".drag-item",
                        "item-key": "index"
                      }), {
                        item: withCtx(({ element: item, index: index2 }) => [
                          (openBlock(), createElementBlock("li", { key: index2 }, [
                            _hoisted_39,
                            createVNode(_component_el_input, {
                              clearable: "",
                              placeholder: _ctx.$t("fm.config.widget.tabName"),
                              style: { "width": "200px", "margin-bottom": "5px" },
                              modelValue: item.label,
                              "onUpdate:modelValue": ($event) => item.label = $event
                            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                            createElementVNode("i", {
                              onClick: ($event) => $options.handleOptionsRemove(index2),
                              style: { "font-size": "16px", "margin": "0 5px", "cursor": "pointer" }
                            }, _hoisted_42, 8, _hoisted_40)
                          ]))
                        ]),
                        _: 1
                      }, 16, ["list"]),
                      createElementVNode("div", _hoisted_43, [
                        createVNode(_component_el_button, {
                          link: "",
                          type: "primary",
                          onClick: $options.handleAddTab
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.addTab")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "collapse" ? (openBlock(), createElementBlock(Fragment, { key: 60 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.collapseOptions")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_draggable, mergeProps({
                        tag: "ul",
                        list: $props.data.tabs
                      }, { group: { name: "options" }, ghostClass: "ghost", handle: ".drag-item" }, {
                        handle: ".drag-item",
                        "item-key": "index"
                      }), {
                        item: withCtx(({ element: item, index: index2 }) => [
                          (openBlock(), createElementBlock("li", { key: index2 }, [
                            _hoisted_44,
                            createVNode(_component_el_input, {
                              clearable: "",
                              placeholder: _ctx.$t("fm.config.widget.collapseTitle"),
                              style: { "width": "200px", "margin-bottom": "5px" },
                              modelValue: item.title,
                              "onUpdate:modelValue": ($event) => item.title = $event
                            }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]),
                            createElementVNode("i", {
                              onClick: ($event) => $options.handleOptionsRemove(index2),
                              style: { "font-size": "16px", "margin": "0 5px", "cursor": "pointer" }
                            }, _hoisted_47, 8, _hoisted_45)
                          ]))
                        ]),
                        _: 1
                      }, 16, ["list"]),
                      createElementVNode("div", _hoisted_48, [
                        createVNode(_component_el_button, {
                          link: "",
                          type: "primary",
                          onClick: $options.handleAddCollapse
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.addCollapse")), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.accordion")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.accordion,
                        "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event) => $props.data.options.accordion = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "report" ? (openBlock(), createElementBlock(Fragment, { key: 61 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.borderWidth")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input_number, {
                        modelValue: $props.data.options.borderWidth,
                        "onUpdate:modelValue": _cache[139] || (_cache[139] = ($event) => $props.data.options.borderWidth = $event),
                        min: 0,
                        step: 1
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.borderColor")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_color_picker, {
                        modelValue: $props.data.options.borderColor,
                        "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event) => $props.data.options.borderColor = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "dialog" ? (openBlock(), createElementBlock(Fragment, { key: 62 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.showDialog")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.visible,
                        "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event) => $props.data.options.visible = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.center")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.center,
                        "onUpdate:modelValue": _cache[142] || (_cache[142] = ($event) => $props.data.options.center = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.showClose")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.showClose,
                        "onUpdate:modelValue": _cache[143] || (_cache[143] = ($event) => $props.data.options.showClose = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.showCancel")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.showCancel,
                        "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event) => $props.data.options.showCancel = $event)
                      }, null, 8, ["modelValue"]),
                      $props.data.options.showCancel ? (openBlock(), createBlock(_component_el_input, {
                        key: 0,
                        modelValue: $props.data.options.cancelText,
                        "onUpdate:modelValue": _cache[145] || (_cache[145] = ($event) => $props.data.options.cancelText = $event)
                      }, {
                        prepend: withCtx(() => [
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.cancelText")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.showOk")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.showOk,
                        "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event) => $props.data.options.showOk = $event)
                      }, null, 8, ["modelValue"]),
                      $props.data.options.showOk ? (openBlock(), createBlock(_component_el_checkbox, {
                        key: 0,
                        modelValue: $props.data.options.confirmLoading,
                        "onUpdate:modelValue": _cache[147] || (_cache[147] = ($event) => $props.data.options.confirmLoading = $event),
                        label: _ctx.$t("fm.config.widget.confirmLoading"),
                        style: { "margin-left": "18px", "vertical-align": "middle" }
                      }, null, 8, ["modelValue", "label"])) : createCommentVNode("", true),
                      $props.data.options.showOk ? (openBlock(), createBlock(_component_el_input, {
                        key: 1,
                        modelValue: $props.data.options.okText,
                        "onUpdate:modelValue": _cache[148] || (_cache[148] = ($event) => $props.data.options.okText = $event)
                      }, {
                        prepend: withCtx(() => [
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.okText")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.marginTop")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        modelValue: $props.data.options.top,
                        "onUpdate:modelValue": _cache[149] || (_cache[149] = ($event) => $props.data.options.top = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                $props.data.type == "card" ? (openBlock(), createElementBlock(Fragment, { key: 63 }, [
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.padding")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        modelValue: $props.data.options.padding,
                        "onUpdate:modelValue": _cache[150] || (_cache[150] = ($event) => $props.data.options.padding = $event),
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.showHeader")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.showHeader,
                        "onUpdate:modelValue": _cache[151] || (_cache[151] = ($event) => $props.data.options.showHeader = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.bordered")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: $props.data.options.bordered,
                        "onUpdate:modelValue": _cache[152] || (_cache[152] = ($event) => $props.data.options.bordered = $event)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  createVNode(_component_el_form_item, {
                    label: _ctx.$t("fm.config.widget.shadow")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: $props.data.options.shadow,
                        "onUpdate:modelValue": _cache[153] || (_cache[153] = ($event) => $props.data.options.shadow = $event)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio_button, {
                            label: "always",
                            value: "always"
                          }, {
                            default: withCtx(() => [
                              createTextVNode("always")
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: "hover",
                            value: "hover"
                          }, {
                            default: withCtx(() => [
                              createTextVNode("hover")
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio_button, {
                            label: "never",
                            value: "never"
                          }, {
                            default: withCtx(() => [
                              createTextVNode("never")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64)) : createCommentVNode("", true),
                Object.keys($props.data.options).includes("customClass") ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 64,
                  label: _ctx.$t("fm.config.widget.customClass")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_select, {
                      style: { "width": "100%" },
                      modelValue: $data.customClassArray,
                      "onUpdate:modelValue": _cache[154] || (_cache[154] = ($event) => $data.customClassArray = $event),
                      multiple: "",
                      filterable: "",
                      "allow-create": "",
                      "default-first-option": ""
                    }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList($props.sheets, (item) => {
                          return openBlock(), createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]);
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.type != "td" && $props.data.type != "th" ? (openBlock(), createBlock(_component_el_form_item, {
                  label: _ctx.$t("fm.config.widget.attribute"),
                  key: "attribute"
                }, {
                  default: withCtx(() => [
                    Object.keys($props.data.options).indexOf("dataBind") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 0,
                      modelValue: $props.data.options.dataBind,
                      "onUpdate:modelValue": _cache[155] || (_cache[155] = ($event) => $props.data.options.dataBind = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.dataBind")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("hidden") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 1,
                      modelValue: $props.data.options.hidden,
                      "onUpdate:modelValue": _cache[156] || (_cache[156] = ($event) => $props.data.options.hidden = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.hidden")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("readonly") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 2,
                      modelValue: $props.data.options.readonly,
                      "onUpdate:modelValue": _cache[157] || (_cache[157] = ($event) => $props.data.options.readonly = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.readonly")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("disabled") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 3,
                      modelValue: $props.data.options.disabled,
                      "onUpdate:modelValue": _cache[158] || (_cache[158] = ($event) => $props.data.options.disabled = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.disabled")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("editable") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 4,
                      modelValue: $props.data.options.editable,
                      "onUpdate:modelValue": _cache[159] || (_cache[159] = ($event) => $props.data.options.editable = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.editable")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("clearable") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 5,
                      modelValue: $props.data.options.clearable,
                      "onUpdate:modelValue": _cache[160] || (_cache[160] = ($event) => $props.data.options.clearable = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.clearable")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("arrowControl") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 6,
                      modelValue: $props.data.options.arrowControl,
                      "onUpdate:modelValue": _cache[161] || (_cache[161] = ($event) => $props.data.options.arrowControl = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.arrowControl")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("isDelete") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 7,
                      modelValue: $props.data.options.isDelete,
                      "onUpdate:modelValue": _cache[162] || (_cache[162] = ($event) => $props.data.options.isDelete = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.isDelete")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("isEdit") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 8,
                      modelValue: $props.data.options.isEdit,
                      "onUpdate:modelValue": _cache[163] || (_cache[163] = ($event) => $props.data.options.isEdit = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.isEdit")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("isAdd") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 9,
                      modelValue: $props.data.options.isAdd,
                      "onUpdate:modelValue": _cache[164] || (_cache[164] = ($event) => $props.data.options.isAdd = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.isAdd")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("showPassword") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 10,
                      modelValue: $props.data.options.showPassword,
                      "onUpdate:modelValue": _cache[165] || (_cache[165] = ($event) => $props.data.options.showPassword = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.showPassword")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("showScore") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 11,
                      modelValue: $props.data.options.showScore,
                      "onUpdate:modelValue": _cache[166] || (_cache[166] = ($event) => $props.data.options.showScore = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.showScore")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("showWordLimit") >= 0 ? (openBlock(), createBlock(_component_el_checkbox, {
                      key: 12,
                      modelValue: $props.data.options.showWordLimit,
                      "onUpdate:modelValue": _cache[167] || (_cache[167] = ($event) => $props.data.options.showWordLimit = $event)
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.showWordLimit")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])) : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.options.customProps ? renderSlot(_ctx.$slots, "widgetconfig", {
                  key: 66,
                  type: $props.data.type,
                  data: $props.data,
                  customProps: $props.data.options.customProps
                }) : createCommentVNode("", true),
                $props.data.type == "custom" ? (openBlock(), createElementBlock(Fragment, { key: 67 }, [
                  Object.keys($props.data.options).includes("extendProps") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 0,
                    label: _ctx.$t("fm.config.widget.extendPropsConfig")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_button, {
                        style: { "width": "100%" },
                        onClick: $options.handleSetProps
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["label"])) : createCommentVNode("", true)
                ], 64)) : createCommentVNode("", true),
                $props.data.type != "grid" && $props.data.type != "tabs" && $props.data.type != "collapse" && $props.data.type != "report" && $props.data.type != "inline" && $props.data.type != "divider" && $props.data.type != "td" && $props.data.type != "th" && $props.data.type != "col" && $props.data.type != "button" && $props.data.type != "link" && $props.data.type != "steps" && $props.data.type != "alert" && $props.data.type != "pagination" && $props.data.type != "dialog" && $props.data.type != "card" ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 68,
                  label: _ctx.$t("fm.config.widget.validate")
                }, {
                  default: withCtx(() => [
                    Object.keys($props.data.options).indexOf("required") >= 0 ? (openBlock(), createElementBlock("div", _hoisted_49, [
                      createVNode(_component_el_checkbox, {
                        modelValue: $props.data.options.required,
                        "onUpdate:modelValue": _cache[168] || (_cache[168] = ($event) => $props.data.options.required = $event)
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.required")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      $props.data.options.required ? (openBlock(), createBlock(_component_el_input, {
                        key: 0,
                        class: "message-input",
                        clearable: "",
                        modelValue: $props.data.options.requiredMessage,
                        "onUpdate:modelValue": _cache[169] || (_cache[169] = ($event) => $props.data.options.requiredMessage = $event),
                        placeholder: _ctx.$t("fm.message.errorTip")
                      }, null, 8, ["modelValue", "placeholder"])) : createCommentVNode("", true)
                    ])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("dataType") >= 0 ? (openBlock(), createElementBlock("div", _hoisted_50, [
                      createVNode(_component_el_checkbox, {
                        modelValue: $props.data.options.dataTypeCheck,
                        "onUpdate:modelValue": _cache[170] || (_cache[170] = ($event) => $props.data.options.dataTypeCheck = $event),
                        style: { "margin-right": "10px" }
                      }, null, 8, ["modelValue"]),
                      Object.keys($props.data.options).indexOf("dataType") >= 0 ? (openBlock(), createBlock(_component_el_select, {
                        key: 0,
                        disabled: !$props.data.options.dataTypeCheck,
                        modelValue: $props.data.options.dataType,
                        "onUpdate:modelValue": _cache[171] || (_cache[171] = ($event) => $props.data.options.dataType = $event),
                        style: { "width": "239px" }
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_option, {
                            value: "string",
                            label: _ctx.$t("fm.config.widget.string")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "url",
                            label: _ctx.$t("fm.config.widget.url")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "email",
                            label: _ctx.$t("fm.config.widget.email")
                          }, null, 8, ["label"]),
                          createVNode(_component_el_option, {
                            value: "hex",
                            label: _ctx.$t("fm.config.widget.hex")
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["disabled", "modelValue"])) : createCommentVNode("", true),
                      $props.data.options.dataTypeCheck ? (openBlock(), createBlock(_component_el_input, {
                        key: 1,
                        class: "message-input",
                        clearable: "",
                        modelValue: $props.data.options.dataTypeMessage,
                        "onUpdate:modelValue": _cache[172] || (_cache[172] = ($event) => $props.data.options.dataTypeMessage = $event),
                        placeholder: _ctx.$t("fm.message.errorTip")
                      }, null, 8, ["modelValue", "placeholder"])) : createCommentVNode("", true)
                    ])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("pattern") >= 0 ? (openBlock(), createElementBlock("div", _hoisted_51, [
                      createVNode(_component_el_checkbox, {
                        modelValue: $props.data.options.patternCheck,
                        "onUpdate:modelValue": _cache[173] || (_cache[173] = ($event) => $props.data.options.patternCheck = $event),
                        style: { "margin-right": "10px" }
                      }, null, 8, ["modelValue"]),
                      createVNode(_component_el_input, {
                        clearable: "",
                        disabled: !$props.data.options.patternCheck,
                        modelValue: $props.data.options.pattern,
                        "onUpdate:modelValue": _cache[174] || (_cache[174] = ($event) => $props.data.options.pattern = $event),
                        modelModifiers: { lazy: true },
                        style: { "width": "239px" },
                        placeholder: _ctx.$t("fm.config.widget.patternPlaceholder")
                      }, null, 8, ["disabled", "modelValue", "placeholder"]),
                      $props.data.options.patternCheck ? (openBlock(), createBlock(_component_el_input, {
                        key: 0,
                        class: "message-input",
                        clearable: "",
                        modelValue: $props.data.options.patternMessage,
                        "onUpdate:modelValue": _cache[175] || (_cache[175] = ($event) => $props.data.options.patternMessage = $event),
                        placeholder: _ctx.$t("fm.message.errorTip")
                      }, null, 8, ["modelValue", "placeholder"])) : createCommentVNode("", true)
                    ])) : createCommentVNode("", true),
                    Object.keys($props.data.options).indexOf("validator") >= 0 ? (openBlock(), createElementBlock("div", _hoisted_52, [
                      createVNode(_component_el_checkbox, {
                        modelValue: $props.data.options.validatorCheck,
                        "onUpdate:modelValue": _cache[176] || (_cache[176] = ($event) => $props.data.options.validatorCheck = $event),
                        style: { "margin-right": "10px" }
                      }, {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.customValidation")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      $props.data.options.validatorCheck ? (openBlock(), createElementBlock("div", _hoisted_53, [
                        _hoisted_54,
                        (openBlock(), createBlock(_component_code_editor, {
                          mode: "javascript",
                          key: $props.data.key,
                          modelValue: $props.data.options.validator,
                          "onUpdate:modelValue": _cache[177] || (_cache[177] = ($event) => $props.data.options.validator = $event),
                          height: "150px"
                        }, null, 8, ["modelValue"])),
                        _hoisted_55
                      ])) : createCommentVNode("", true)
                    ])) : createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true),
                $props.data.events ? (openBlock(), createBlock(_component_el_form_item, {
                  key: 69,
                  label: _ctx.$t("fm.eventscript.config.title")
                }, {
                  default: withCtx(() => [
                    createVNode(_component_event_config, {
                      events: $props.data.events,
                      eventscripts: $props.eventscripts,
                      onOnAdd: $options.handleEventAdd,
                      onOnEdit: $options.handleEventEdit,
                      onOnRemove: $options.handleEventRemove
                    }, null, 8, ["events", "eventscripts", "onOnAdd", "onOnEdit", "onOnRemove"])
                  ]),
                  _: 1
                }, 8, ["label"])) : createCommentVNode("", true)
              ]),
              _: 3
            }, 8, ["model"])
          ])) : (openBlock(), createElementBlock("div", _hoisted_56, toDisplayString$1(_ctx.$t("fm.description.configEmpty")), 1)),
          createVNode(_component_code_dialog, {
            ref: "codeDialog",
            mode: "html",
            title: _ctx.$t("fm.config.widget.customTemplates"),
            help: "https://www.yuque.com/ln7ccx/ntgo8q/zr53m4",
            onOnConfirm: $options.handleTemplateConfirm
          }, null, 8, ["title", "onOnConfirm"]),
          createVNode(_component_code_dialog, {
            ref: "cascaderDialog",
            width: "800px",
            "code-height": "400px",
            mode: "javascript",
            title: _ctx.$t("fm.config.widget.option"),
            onOnConfirm: $options.handleCascaderConfirm
          }, null, 8, ["title", "onOnConfirm"]),
          createVNode(_component_code_dialog, {
            ref: "treeDialog",
            width: "800px",
            "code-height": "400px",
            mode: "javascript",
            title: _ctx.$t("fm.config.widget.option"),
            onOnConfirm: $options.handleTreeConfirm
          }, null, 8, ["title", "onOnConfirm"]),
          createVNode(_component_code_dialog, {
            ref: "extendPropsDialog",
            width: "800px",
            "code-height": "400px",
            mode: "javascript",
            title: _ctx.$t("fm.config.widget.extendPropsConfig"),
            onOnConfirm: $options.handlePropsConfirm
          }, null, 8, ["title", "onOnConfirm"]),
          createVNode(_component_code_dialog, {
            ref: "defaultValueDialog",
            width: "800px",
            "code-height": "400px",
            mode: "javascript",
            title: _ctx.$t("fm.config.widget.defaultValue"),
            onOnConfirm: $options.handleDefaultValueConfirm
          }, null, 8, ["title", "onOnConfirm"]),
          createVNode(_component_cus_dialog, {
            visible: $data.editorVisible,
            onOnClose: _cache[179] || (_cache[179] = ($event) => $data.editorVisible = false),
            width: `calc(${((_b = (_a2 = $props.data) == null ? void 0 : _a2.options) == null ? void 0 : _b.width) || "900px"} + 40px)`,
            form: "",
            title: _ctx.$t("fm.config.widget.defaultValue"),
            onOnSubmit: $options.handleEditorValueConfirm
          }, {
            default: withCtx(() => [
              createVNode(_component_Editor, {
                modelValue: $data.editorValue,
                "onUpdate:modelValue": _cache[178] || (_cache[178] = ($event) => $data.editorValue = $event),
                "custom-style": { width: $props.data.options.width },
                toolbar: $props.data.options.customToolbar,
                class: "fm-editor"
              }, null, 8, ["modelValue", "custom-style", "toolbar"])
            ]),
            _: 1
          }, 8, ["visible", "width", "title", "onOnSubmit"])
        ])
      ];
    }),
    _: 3
  });
}
var WidgetConfig = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["render", _sfc_render$W]]);
var codemirror$1 = { exports: {} };
(function(module, exports) {
  (function(global2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    var userAgent2 = navigator.userAgent;
    var platform = navigator.platform;
    var gecko = /gecko\/\d/i.test(userAgent2);
    var ie_upto10 = /MSIE \d/.test(userAgent2);
    var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent2);
    var edge = /Edge\/(\d+)/.exec(userAgent2);
    var ie = ie_upto10 || ie_11up || edge;
    var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
    var webkit = !edge && /WebKit\//.test(userAgent2);
    var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent2);
    var chrome = !edge && /Chrome\/(\d+)/.exec(userAgent2);
    var chrome_version = chrome && +chrome[1];
    var presto = /Opera\//.test(userAgent2);
    var safari = /Apple Computer/.test(navigator.vendor);
    var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent2);
    var phantom = /PhantomJS/.test(userAgent2);
    var ios = safari && (/Mobile\/\w+/.test(userAgent2) || navigator.maxTouchPoints > 2);
    var android = /Android/.test(userAgent2);
    var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent2);
    var mac = ios || /Mac/.test(platform);
    var chromeOS = /\bCrOS\b/.test(userAgent2);
    var windows = /win/i.test(platform);
    var presto_version = presto && userAgent2.match(/Version\/(\d*\.\d*)/);
    if (presto_version) {
      presto_version = Number(presto_version[1]);
    }
    if (presto_version && presto_version >= 15) {
      presto = false;
      webkit = true;
    }
    var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
    var captureRightClick = gecko || ie && ie_version >= 9;
    function classTest(cls) {
      return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
    }
    var rmClass = function(node, cls) {
      var current = node.className;
      var match = classTest(cls).exec(current);
      if (match) {
        var after = current.slice(match.index + match[0].length);
        node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
      }
    };
    function removeChildren(e) {
      for (var count = e.childNodes.length; count > 0; --count) {
        e.removeChild(e.firstChild);
      }
      return e;
    }
    function removeChildrenAndAdd(parent, e) {
      return removeChildren(parent).appendChild(e);
    }
    function elt(tag, content, className, style) {
      var e = document.createElement(tag);
      if (className) {
        e.className = className;
      }
      if (style) {
        e.style.cssText = style;
      }
      if (typeof content == "string") {
        e.appendChild(document.createTextNode(content));
      } else if (content) {
        for (var i2 = 0; i2 < content.length; ++i2) {
          e.appendChild(content[i2]);
        }
      }
      return e;
    }
    function eltP(tag, content, className, style) {
      var e = elt(tag, content, className, style);
      e.setAttribute("role", "presentation");
      return e;
    }
    var range;
    if (document.createRange) {
      range = function(node, start, end, endNode) {
        var r = document.createRange();
        r.setEnd(endNode || node, end);
        r.setStart(node, start);
        return r;
      };
    } else {
      range = function(node, start, end) {
        var r = document.body.createTextRange();
        try {
          r.moveToElementText(node.parentNode);
        } catch (e) {
          return r;
        }
        r.collapse(true);
        r.moveEnd("character", end);
        r.moveStart("character", start);
        return r;
      };
    }
    function contains(parent, child) {
      if (child.nodeType == 3) {
        child = child.parentNode;
      }
      if (parent.contains) {
        return parent.contains(child);
      }
      do {
        if (child.nodeType == 11) {
          child = child.host;
        }
        if (child == parent) {
          return true;
        }
      } while (child = child.parentNode);
    }
    function activeElt(rootNode2) {
      var doc2 = rootNode2.ownerDocument || rootNode2;
      var activeElement;
      try {
        activeElement = rootNode2.activeElement;
      } catch (e) {
        activeElement = doc2.body || null;
      }
      while (activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement) {
        activeElement = activeElement.shadowRoot.activeElement;
      }
      return activeElement;
    }
    function addClass2(node, cls) {
      var current = node.className;
      if (!classTest(cls).test(current)) {
        node.className += (current ? " " : "") + cls;
      }
    }
    function joinClasses(a, b) {
      var as = a.split(" ");
      for (var i2 = 0; i2 < as.length; i2++) {
        if (as[i2] && !classTest(as[i2]).test(b)) {
          b += " " + as[i2];
        }
      }
      return b;
    }
    var selectInput = function(node) {
      node.select();
    };
    if (ios) {
      selectInput = function(node) {
        node.selectionStart = 0;
        node.selectionEnd = node.value.length;
      };
    } else if (ie) {
      selectInput = function(node) {
        try {
          node.select();
        } catch (_e) {
        }
      };
    }
    function doc(cm) {
      return cm.display.wrapper.ownerDocument;
    }
    function root(cm) {
      return rootNode(cm.display.wrapper);
    }
    function rootNode(element) {
      return element.getRootNode ? element.getRootNode() : element.ownerDocument;
    }
    function win(cm) {
      return doc(cm).defaultView;
    }
    function bind4(f) {
      var args = Array.prototype.slice.call(arguments, 1);
      return function() {
        return f.apply(null, args);
      };
    }
    function copyObj(obj, target, overwrite) {
      if (!target) {
        target = {};
      }
      for (var prop2 in obj) {
        if (obj.hasOwnProperty(prop2) && (overwrite !== false || !target.hasOwnProperty(prop2))) {
          target[prop2] = obj[prop2];
        }
      }
      return target;
    }
    function countColumn(string, end, tabSize, startIndex, startValue) {
      if (end == null) {
        end = string.search(/[^\s\u00a0]/);
        if (end == -1) {
          end = string.length;
        }
      }
      for (var i2 = startIndex || 0, n = startValue || 0; ; ) {
        var nextTab = string.indexOf("	", i2);
        if (nextTab < 0 || nextTab >= end) {
          return n + (end - i2);
        }
        n += nextTab - i2;
        n += tabSize - n % tabSize;
        i2 = nextTab + 1;
      }
    }
    var Delayed = function() {
      this.id = null;
      this.f = null;
      this.time = 0;
      this.handler = bind4(this.onTimeout, this);
    };
    Delayed.prototype.onTimeout = function(self2) {
      self2.id = 0;
      if (self2.time <= +new Date()) {
        self2.f();
      } else {
        setTimeout(self2.handler, self2.time - +new Date());
      }
    };
    Delayed.prototype.set = function(ms, f) {
      this.f = f;
      var time = +new Date() + ms;
      if (!this.id || time < this.time) {
        clearTimeout(this.id);
        this.id = setTimeout(this.handler, ms);
        this.time = time;
      }
    };
    function indexOf(array, elt2) {
      for (var i2 = 0; i2 < array.length; ++i2) {
        if (array[i2] == elt2) {
          return i2;
        }
      }
      return -1;
    }
    var scrollerGap = 50;
    var Pass = { toString: function() {
      return "CodeMirror.Pass";
    } };
    var sel_dontScroll = { scroll: false }, sel_mouse = { origin: "*mouse" }, sel_move = { origin: "+move" };
    function findColumn(string, goal, tabSize) {
      for (var pos = 0, col = 0; ; ) {
        var nextTab = string.indexOf("	", pos);
        if (nextTab == -1) {
          nextTab = string.length;
        }
        var skipped = nextTab - pos;
        if (nextTab == string.length || col + skipped >= goal) {
          return pos + Math.min(skipped, goal - col);
        }
        col += nextTab - pos;
        col += tabSize - col % tabSize;
        pos = nextTab + 1;
        if (col >= goal) {
          return pos;
        }
      }
    }
    var spaceStrs = [""];
    function spaceStr(n) {
      while (spaceStrs.length <= n) {
        spaceStrs.push(lst(spaceStrs) + " ");
      }
      return spaceStrs[n];
    }
    function lst(arr) {
      return arr[arr.length - 1];
    }
    function map(array, f) {
      var out = [];
      for (var i2 = 0; i2 < array.length; i2++) {
        out[i2] = f(array[i2], i2);
      }
      return out;
    }
    function insertSorted(array, value, score) {
      var pos = 0, priority = score(value);
      while (pos < array.length && score(array[pos]) <= priority) {
        pos++;
      }
      array.splice(pos, 0, value);
    }
    function nothing() {
    }
    function createObj(base, props2) {
      var inst;
      if (Object.create) {
        inst = Object.create(base);
      } else {
        nothing.prototype = base;
        inst = new nothing();
      }
      if (props2) {
        copyObj(props2, inst);
      }
      return inst;
    }
    var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
    function isWordCharBasic(ch) {
      return /\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch));
    }
    function isWordChar(ch, helper) {
      if (!helper) {
        return isWordCharBasic(ch);
      }
      if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) {
        return true;
      }
      return helper.test(ch);
    }
    function isEmpty(obj) {
      for (var n in obj) {
        if (obj.hasOwnProperty(n) && obj[n]) {
          return false;
        }
      }
      return true;
    }
    var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
    function isExtendingChar(ch) {
      return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
    }
    function skipExtendingChars(str, pos, dir) {
      while ((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos))) {
        pos += dir;
      }
      return pos;
    }
    function findFirst(pred, from, to) {
      var dir = from > to ? -1 : 1;
      for (; ; ) {
        if (from == to) {
          return from;
        }
        var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
        if (mid == from) {
          return pred(mid) ? from : to;
        }
        if (pred(mid)) {
          to = mid;
        } else {
          from = mid + dir;
        }
      }
    }
    function iterateBidiSections(order, from, to, f) {
      if (!order) {
        return f(from, to, "ltr", 0);
      }
      var found = false;
      for (var i2 = 0; i2 < order.length; ++i2) {
        var part = order[i2];
        if (part.from < to && part.to > from || from == to && part.to == from) {
          f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i2);
          found = true;
        }
      }
      if (!found) {
        f(from, to, "ltr");
      }
    }
    var bidiOther = null;
    function getBidiPartAt(order, ch, sticky) {
      var found;
      bidiOther = null;
      for (var i2 = 0; i2 < order.length; ++i2) {
        var cur = order[i2];
        if (cur.from < ch && cur.to > ch) {
          return i2;
        }
        if (cur.to == ch) {
          if (cur.from != cur.to && sticky == "before") {
            found = i2;
          } else {
            bidiOther = i2;
          }
        }
        if (cur.from == ch) {
          if (cur.from != cur.to && sticky != "before") {
            found = i2;
          } else {
            bidiOther = i2;
          }
        }
      }
      return found != null ? found : bidiOther;
    }
    var bidiOrdering = function() {
      var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
      var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
      function charType(code2) {
        if (code2 <= 247) {
          return lowTypes.charAt(code2);
        } else if (1424 <= code2 && code2 <= 1524) {
          return "R";
        } else if (1536 <= code2 && code2 <= 1785) {
          return arabicTypes.charAt(code2 - 1536);
        } else if (1774 <= code2 && code2 <= 2220) {
          return "r";
        } else if (8192 <= code2 && code2 <= 8203) {
          return "w";
        } else if (code2 == 8204) {
          return "b";
        } else {
          return "L";
        }
      }
      var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
      var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
      function BidiSpan(level, from, to) {
        this.level = level;
        this.from = from;
        this.to = to;
      }
      return function(str, direction) {
        var outerType = direction == "ltr" ? "L" : "R";
        if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) {
          return false;
        }
        var len = str.length, types = [];
        for (var i2 = 0; i2 < len; ++i2) {
          types.push(charType(str.charCodeAt(i2)));
        }
        for (var i$12 = 0, prev2 = outerType; i$12 < len; ++i$12) {
          var type = types[i$12];
          if (type == "m") {
            types[i$12] = prev2;
          } else {
            prev2 = type;
          }
        }
        for (var i$22 = 0, cur = outerType; i$22 < len; ++i$22) {
          var type$1 = types[i$22];
          if (type$1 == "1" && cur == "r") {
            types[i$22] = "n";
          } else if (isStrong.test(type$1)) {
            cur = type$1;
            if (type$1 == "r") {
              types[i$22] = "R";
            }
          }
        }
        for (var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3) {
          var type$2 = types[i$3];
          if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") {
            types[i$3] = "1";
          } else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) {
            types[i$3] = prev$1;
          }
          prev$1 = type$2;
        }
        for (var i$4 = 0; i$4 < len; ++i$4) {
          var type$3 = types[i$4];
          if (type$3 == ",") {
            types[i$4] = "N";
          } else if (type$3 == "%") {
            var end = void 0;
            for (end = i$4 + 1; end < len && types[end] == "%"; ++end) {
            }
            var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
            for (var j = i$4; j < end; ++j) {
              types[j] = replace;
            }
            i$4 = end - 1;
          }
        }
        for (var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5) {
          var type$4 = types[i$5];
          if (cur$1 == "L" && type$4 == "1") {
            types[i$5] = "L";
          } else if (isStrong.test(type$4)) {
            cur$1 = type$4;
          }
        }
        for (var i$6 = 0; i$6 < len; ++i$6) {
          if (isNeutral.test(types[i$6])) {
            var end$1 = void 0;
            for (end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1) {
            }
            var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
            var after = (end$1 < len ? types[end$1] : outerType) == "L";
            var replace$1 = before == after ? before ? "L" : "R" : outerType;
            for (var j$1 = i$6; j$1 < end$1; ++j$1) {
              types[j$1] = replace$1;
            }
            i$6 = end$1 - 1;
          }
        }
        var order = [], m;
        for (var i$7 = 0; i$7 < len; ) {
          if (countsAsLeft.test(types[i$7])) {
            var start = i$7;
            for (++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7) {
            }
            order.push(new BidiSpan(0, start, i$7));
          } else {
            var pos = i$7, at = order.length, isRTL = direction == "rtl" ? 1 : 0;
            for (++i$7; i$7 < len && types[i$7] != "L"; ++i$7) {
            }
            for (var j$2 = pos; j$2 < i$7; ) {
              if (countsAsNum.test(types[j$2])) {
                if (pos < j$2) {
                  order.splice(at, 0, new BidiSpan(1, pos, j$2));
                  at += isRTL;
                }
                var nstart = j$2;
                for (++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2) {
                }
                order.splice(at, 0, new BidiSpan(2, nstart, j$2));
                at += isRTL;
                pos = j$2;
              } else {
                ++j$2;
              }
            }
            if (pos < i$7) {
              order.splice(at, 0, new BidiSpan(1, pos, i$7));
            }
          }
        }
        if (direction == "ltr") {
          if (order[0].level == 1 && (m = str.match(/^\s+/))) {
            order[0].from = m[0].length;
            order.unshift(new BidiSpan(0, 0, m[0].length));
          }
          if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
            lst(order).to -= m[0].length;
            order.push(new BidiSpan(0, len - m[0].length, len));
          }
        }
        return direction == "rtl" ? order.reverse() : order;
      };
    }();
    function getOrder(line, direction) {
      var order = line.order;
      if (order == null) {
        order = line.order = bidiOrdering(line.text, direction);
      }
      return order;
    }
    var noHandlers = [];
    var on2 = function(emitter, type, f) {
      if (emitter.addEventListener) {
        emitter.addEventListener(type, f, false);
      } else if (emitter.attachEvent) {
        emitter.attachEvent("on" + type, f);
      } else {
        var map2 = emitter._handlers || (emitter._handlers = {});
        map2[type] = (map2[type] || noHandlers).concat(f);
      }
    };
    function getHandlers(emitter, type) {
      return emitter._handlers && emitter._handlers[type] || noHandlers;
    }
    function off2(emitter, type, f) {
      if (emitter.removeEventListener) {
        emitter.removeEventListener(type, f, false);
      } else if (emitter.detachEvent) {
        emitter.detachEvent("on" + type, f);
      } else {
        var map2 = emitter._handlers, arr = map2 && map2[type];
        if (arr) {
          var index2 = indexOf(arr, f);
          if (index2 > -1) {
            map2[type] = arr.slice(0, index2).concat(arr.slice(index2 + 1));
          }
        }
      }
    }
    function signal(emitter, type) {
      var handlers2 = getHandlers(emitter, type);
      if (!handlers2.length) {
        return;
      }
      var args = Array.prototype.slice.call(arguments, 2);
      for (var i2 = 0; i2 < handlers2.length; ++i2) {
        handlers2[i2].apply(null, args);
      }
    }
    function signalDOMEvent(cm, e, override) {
      if (typeof e == "string") {
        e = { type: e, preventDefault: function() {
          this.defaultPrevented = true;
        } };
      }
      signal(cm, override || e.type, cm, e);
      return e_defaultPrevented(e) || e.codemirrorIgnore;
    }
    function signalCursorActivity(cm) {
      var arr = cm._handlers && cm._handlers.cursorActivity;
      if (!arr) {
        return;
      }
      var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
      for (var i2 = 0; i2 < arr.length; ++i2) {
        if (indexOf(set, arr[i2]) == -1) {
          set.push(arr[i2]);
        }
      }
    }
    function hasHandler(emitter, type) {
      return getHandlers(emitter, type).length > 0;
    }
    function eventMixin(ctor) {
      ctor.prototype.on = function(type, f) {
        on2(this, type, f);
      };
      ctor.prototype.off = function(type, f) {
        off2(this, type, f);
      };
    }
    function e_preventDefault(e) {
      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }
    }
    function e_stopPropagation(e) {
      if (e.stopPropagation) {
        e.stopPropagation();
      } else {
        e.cancelBubble = true;
      }
    }
    function e_defaultPrevented(e) {
      return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
    }
    function e_stop(e) {
      e_preventDefault(e);
      e_stopPropagation(e);
    }
    function e_target(e) {
      return e.target || e.srcElement;
    }
    function e_button(e) {
      var b = e.which;
      if (b == null) {
        if (e.button & 1) {
          b = 1;
        } else if (e.button & 2) {
          b = 3;
        } else if (e.button & 4) {
          b = 2;
        }
      }
      if (mac && e.ctrlKey && b == 1) {
        b = 3;
      }
      return b;
    }
    var dragAndDrop = function() {
      if (ie && ie_version < 9) {
        return false;
      }
      var div = elt("div");
      return "draggable" in div || "dragDrop" in div;
    }();
    var zwspSupported;
    function zeroWidthElement(measure) {
      if (zwspSupported == null) {
        var test = elt("span", "\u200B");
        removeChildrenAndAdd(measure, elt("span", [test, document.createTextNode("x")]));
        if (measure.firstChild.offsetHeight != 0) {
          zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
        }
      }
      var node = zwspSupported ? elt("span", "\u200B") : elt("span", "\xA0", null, "display: inline-block; width: 1px; margin-right: -1px");
      node.setAttribute("cm-text", "");
      return node;
    }
    var badBidiRects;
    function hasBadBidiRects(measure) {
      if (badBidiRects != null) {
        return badBidiRects;
      }
      var txt = removeChildrenAndAdd(measure, document.createTextNode("A\u062EA"));
      var r0 = range(txt, 0, 1).getBoundingClientRect();
      var r1 = range(txt, 1, 2).getBoundingClientRect();
      removeChildren(measure);
      if (!r0 || r0.left == r0.right) {
        return false;
      }
      return badBidiRects = r1.right - r0.right < 3;
    }
    var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function(string) {
      var pos = 0, result = [], l = string.length;
      while (pos <= l) {
        var nl = string.indexOf("\n", pos);
        if (nl == -1) {
          nl = string.length;
        }
        var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
        var rt = line.indexOf("\r");
        if (rt != -1) {
          result.push(line.slice(0, rt));
          pos += rt + 1;
        } else {
          result.push(line);
          pos = nl + 1;
        }
      }
      return result;
    } : function(string) {
      return string.split(/\r\n?|\n/);
    };
    var hasSelection = window.getSelection ? function(te) {
      try {
        return te.selectionStart != te.selectionEnd;
      } catch (e) {
        return false;
      }
    } : function(te) {
      var range2;
      try {
        range2 = te.ownerDocument.selection.createRange();
      } catch (e) {
      }
      if (!range2 || range2.parentElement() != te) {
        return false;
      }
      return range2.compareEndPoints("StartToEnd", range2) != 0;
    };
    var hasCopyEvent = function() {
      var e = elt("div");
      if ("oncopy" in e) {
        return true;
      }
      e.setAttribute("oncopy", "return;");
      return typeof e.oncopy == "function";
    }();
    var badZoomedRects = null;
    function hasBadZoomedRects(measure) {
      if (badZoomedRects != null) {
        return badZoomedRects;
      }
      var node = removeChildrenAndAdd(measure, elt("span", "x"));
      var normal = node.getBoundingClientRect();
      var fromRange = range(node, 0, 1).getBoundingClientRect();
      return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
    }
    var modes = {}, mimeModes = {};
    function defineMode(name, mode) {
      if (arguments.length > 2) {
        mode.dependencies = Array.prototype.slice.call(arguments, 2);
      }
      modes[name] = mode;
    }
    function defineMIME(mime, spec) {
      mimeModes[mime] = spec;
    }
    function resolveMode(spec) {
      if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) {
        spec = mimeModes[spec];
      } else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
        var found = mimeModes[spec.name];
        if (typeof found == "string") {
          found = { name: found };
        }
        spec = createObj(found, spec);
        spec.name = found.name;
      } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) {
        return resolveMode("application/xml");
      } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) {
        return resolveMode("application/json");
      }
      if (typeof spec == "string") {
        return { name: spec };
      } else {
        return spec || { name: "null" };
      }
    }
    function getMode(options, spec) {
      spec = resolveMode(spec);
      var mfactory = modes[spec.name];
      if (!mfactory) {
        return getMode(options, "text/plain");
      }
      var modeObj = mfactory(options, spec);
      if (modeExtensions.hasOwnProperty(spec.name)) {
        var exts = modeExtensions[spec.name];
        for (var prop2 in exts) {
          if (!exts.hasOwnProperty(prop2)) {
            continue;
          }
          if (modeObj.hasOwnProperty(prop2)) {
            modeObj["_" + prop2] = modeObj[prop2];
          }
          modeObj[prop2] = exts[prop2];
        }
      }
      modeObj.name = spec.name;
      if (spec.helperType) {
        modeObj.helperType = spec.helperType;
      }
      if (spec.modeProps) {
        for (var prop$1 in spec.modeProps) {
          modeObj[prop$1] = spec.modeProps[prop$1];
        }
      }
      return modeObj;
    }
    var modeExtensions = {};
    function extendMode(mode, properties) {
      var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
      copyObj(properties, exts);
    }
    function copyState(mode, state) {
      if (state === true) {
        return state;
      }
      if (mode.copyState) {
        return mode.copyState(state);
      }
      var nstate = {};
      for (var n in state) {
        var val = state[n];
        if (val instanceof Array) {
          val = val.concat([]);
        }
        nstate[n] = val;
      }
      return nstate;
    }
    function innerMode(mode, state) {
      var info;
      while (mode.innerMode) {
        info = mode.innerMode(state);
        if (!info || info.mode == mode) {
          break;
        }
        state = info.state;
        mode = info.mode;
      }
      return info || { mode, state };
    }
    function startState(mode, a1, a2) {
      return mode.startState ? mode.startState(a1, a2) : true;
    }
    var StringStream = function(string, tabSize, lineOracle) {
      this.pos = this.start = 0;
      this.string = string;
      this.tabSize = tabSize || 8;
      this.lastColumnPos = this.lastColumnValue = 0;
      this.lineStart = 0;
      this.lineOracle = lineOracle;
    };
    StringStream.prototype.eol = function() {
      return this.pos >= this.string.length;
    };
    StringStream.prototype.sol = function() {
      return this.pos == this.lineStart;
    };
    StringStream.prototype.peek = function() {
      return this.string.charAt(this.pos) || void 0;
    };
    StringStream.prototype.next = function() {
      if (this.pos < this.string.length) {
        return this.string.charAt(this.pos++);
      }
    };
    StringStream.prototype.eat = function(match) {
      var ch = this.string.charAt(this.pos);
      var ok;
      if (typeof match == "string") {
        ok = ch == match;
      } else {
        ok = ch && (match.test ? match.test(ch) : match(ch));
      }
      if (ok) {
        ++this.pos;
        return ch;
      }
    };
    StringStream.prototype.eatWhile = function(match) {
      var start = this.pos;
      while (this.eat(match)) {
      }
      return this.pos > start;
    };
    StringStream.prototype.eatSpace = function() {
      var start = this.pos;
      while (/[\s\u00a0]/.test(this.string.charAt(this.pos))) {
        ++this.pos;
      }
      return this.pos > start;
    };
    StringStream.prototype.skipToEnd = function() {
      this.pos = this.string.length;
    };
    StringStream.prototype.skipTo = function(ch) {
      var found = this.string.indexOf(ch, this.pos);
      if (found > -1) {
        this.pos = found;
        return true;
      }
    };
    StringStream.prototype.backUp = function(n) {
      this.pos -= n;
    };
    StringStream.prototype.column = function() {
      if (this.lastColumnPos < this.start) {
        this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
        this.lastColumnPos = this.start;
      }
      return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.indentation = function() {
      return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.match = function(pattern, consume, caseInsensitive) {
      if (typeof pattern == "string") {
        var cased = function(str) {
          return caseInsensitive ? str.toLowerCase() : str;
        };
        var substr = this.string.substr(this.pos, pattern.length);
        if (cased(substr) == cased(pattern)) {
          if (consume !== false) {
            this.pos += pattern.length;
          }
          return true;
        }
      } else {
        var match = this.string.slice(this.pos).match(pattern);
        if (match && match.index > 0) {
          return null;
        }
        if (match && consume !== false) {
          this.pos += match[0].length;
        }
        return match;
      }
    };
    StringStream.prototype.current = function() {
      return this.string.slice(this.start, this.pos);
    };
    StringStream.prototype.hideFirstChars = function(n, inner) {
      this.lineStart += n;
      try {
        return inner();
      } finally {
        this.lineStart -= n;
      }
    };
    StringStream.prototype.lookAhead = function(n) {
      var oracle = this.lineOracle;
      return oracle && oracle.lookAhead(n);
    };
    StringStream.prototype.baseToken = function() {
      var oracle = this.lineOracle;
      return oracle && oracle.baseToken(this.pos);
    };
    function getLine(doc2, n) {
      n -= doc2.first;
      if (n < 0 || n >= doc2.size) {
        throw new Error("There is no line " + (n + doc2.first) + " in the document.");
      }
      var chunk = doc2;
      while (!chunk.lines) {
        for (var i2 = 0; ; ++i2) {
          var child = chunk.children[i2], sz = child.chunkSize();
          if (n < sz) {
            chunk = child;
            break;
          }
          n -= sz;
        }
      }
      return chunk.lines[n];
    }
    function getBetween(doc2, start, end) {
      var out = [], n = start.line;
      doc2.iter(start.line, end.line + 1, function(line) {
        var text = line.text;
        if (n == end.line) {
          text = text.slice(0, end.ch);
        }
        if (n == start.line) {
          text = text.slice(start.ch);
        }
        out.push(text);
        ++n;
      });
      return out;
    }
    function getLines(doc2, from, to) {
      var out = [];
      doc2.iter(from, to, function(line) {
        out.push(line.text);
      });
      return out;
    }
    function updateLineHeight(line, height) {
      var diff = height - line.height;
      if (diff) {
        for (var n = line; n; n = n.parent) {
          n.height += diff;
        }
      }
    }
    function lineNo(line) {
      if (line.parent == null) {
        return null;
      }
      var cur = line.parent, no = indexOf(cur.lines, line);
      for (var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent) {
        for (var i2 = 0; ; ++i2) {
          if (chunk.children[i2] == cur) {
            break;
          }
          no += chunk.children[i2].chunkSize();
        }
      }
      return no + cur.first;
    }
    function lineAtHeight(chunk, h2) {
      var n = chunk.first;
      outer:
        do {
          for (var i$12 = 0; i$12 < chunk.children.length; ++i$12) {
            var child = chunk.children[i$12], ch = child.height;
            if (h2 < ch) {
              chunk = child;
              continue outer;
            }
            h2 -= ch;
            n += child.chunkSize();
          }
          return n;
        } while (!chunk.lines);
      var i2 = 0;
      for (; i2 < chunk.lines.length; ++i2) {
        var line = chunk.lines[i2], lh = line.height;
        if (h2 < lh) {
          break;
        }
        h2 -= lh;
      }
      return n + i2;
    }
    function isLine(doc2, l) {
      return l >= doc2.first && l < doc2.first + doc2.size;
    }
    function lineNumberFor(options, i2) {
      return String(options.lineNumberFormatter(i2 + options.firstLineNumber));
    }
    function Pos(line, ch, sticky) {
      if (sticky === void 0)
        sticky = null;
      if (!(this instanceof Pos)) {
        return new Pos(line, ch, sticky);
      }
      this.line = line;
      this.ch = ch;
      this.sticky = sticky;
    }
    function cmp(a, b) {
      return a.line - b.line || a.ch - b.ch;
    }
    function equalCursorPos(a, b) {
      return a.sticky == b.sticky && cmp(a, b) == 0;
    }
    function copyPos(x) {
      return Pos(x.line, x.ch);
    }
    function maxPos(a, b) {
      return cmp(a, b) < 0 ? b : a;
    }
    function minPos(a, b) {
      return cmp(a, b) < 0 ? a : b;
    }
    function clipLine(doc2, n) {
      return Math.max(doc2.first, Math.min(n, doc2.first + doc2.size - 1));
    }
    function clipPos(doc2, pos) {
      if (pos.line < doc2.first) {
        return Pos(doc2.first, 0);
      }
      var last = doc2.first + doc2.size - 1;
      if (pos.line > last) {
        return Pos(last, getLine(doc2, last).text.length);
      }
      return clipToLen(pos, getLine(doc2, pos.line).text.length);
    }
    function clipToLen(pos, linelen) {
      var ch = pos.ch;
      if (ch == null || ch > linelen) {
        return Pos(pos.line, linelen);
      } else if (ch < 0) {
        return Pos(pos.line, 0);
      } else {
        return pos;
      }
    }
    function clipPosArray(doc2, array) {
      var out = [];
      for (var i2 = 0; i2 < array.length; i2++) {
        out[i2] = clipPos(doc2, array[i2]);
      }
      return out;
    }
    var SavedContext = function(state, lookAhead) {
      this.state = state;
      this.lookAhead = lookAhead;
    };
    var Context = function(doc2, state, line, lookAhead) {
      this.state = state;
      this.doc = doc2;
      this.line = line;
      this.maxLookAhead = lookAhead || 0;
      this.baseTokens = null;
      this.baseTokenPos = 1;
    };
    Context.prototype.lookAhead = function(n) {
      var line = this.doc.getLine(this.line + n);
      if (line != null && n > this.maxLookAhead) {
        this.maxLookAhead = n;
      }
      return line;
    };
    Context.prototype.baseToken = function(n) {
      if (!this.baseTokens) {
        return null;
      }
      while (this.baseTokens[this.baseTokenPos] <= n) {
        this.baseTokenPos += 2;
      }
      var type = this.baseTokens[this.baseTokenPos + 1];
      return {
        type: type && type.replace(/( |^)overlay .*/, ""),
        size: this.baseTokens[this.baseTokenPos] - n
      };
    };
    Context.prototype.nextLine = function() {
      this.line++;
      if (this.maxLookAhead > 0) {
        this.maxLookAhead--;
      }
    };
    Context.fromSaved = function(doc2, saved, line) {
      if (saved instanceof SavedContext) {
        return new Context(doc2, copyState(doc2.mode, saved.state), line, saved.lookAhead);
      } else {
        return new Context(doc2, copyState(doc2.mode, saved), line);
      }
    };
    Context.prototype.save = function(copy) {
      var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
      return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
    };
    function highlightLine(cm, line, context, forceToEnd) {
      var st = [cm.state.modeGen], lineClasses = {};
      runMode(
        cm,
        line.text,
        cm.doc.mode,
        context,
        function(end, style) {
          return st.push(end, style);
        },
        lineClasses,
        forceToEnd
      );
      var state = context.state;
      var loop = function(o2) {
        context.baseTokens = st;
        var overlay = cm.state.overlays[o2], i2 = 1, at = 0;
        context.state = true;
        runMode(cm, line.text, overlay.mode, context, function(end, style) {
          var start = i2;
          while (at < end) {
            var i_end = st[i2];
            if (i_end > end) {
              st.splice(i2, 1, end, st[i2 + 1], i_end);
            }
            i2 += 2;
            at = Math.min(end, i_end);
          }
          if (!style) {
            return;
          }
          if (overlay.opaque) {
            st.splice(start, i2 - start, end, "overlay " + style);
            i2 = start + 2;
          } else {
            for (; start < i2; start += 2) {
              var cur = st[start + 1];
              st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
            }
          }
        }, lineClasses);
        context.state = state;
        context.baseTokens = null;
        context.baseTokenPos = 1;
      };
      for (var o = 0; o < cm.state.overlays.length; ++o)
        loop(o);
      return { styles: st, classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null };
    }
    function getLineStyles(cm, line, updateFrontier) {
      if (!line.styles || line.styles[0] != cm.state.modeGen) {
        var context = getContextBefore(cm, lineNo(line));
        var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
        var result = highlightLine(cm, line, context);
        if (resetState) {
          context.state = resetState;
        }
        line.stateAfter = context.save(!resetState);
        line.styles = result.styles;
        if (result.classes) {
          line.styleClasses = result.classes;
        } else if (line.styleClasses) {
          line.styleClasses = null;
        }
        if (updateFrontier === cm.doc.highlightFrontier) {
          cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
        }
      }
      return line.styles;
    }
    function getContextBefore(cm, n, precise) {
      var doc2 = cm.doc, display = cm.display;
      if (!doc2.mode.startState) {
        return new Context(doc2, true, n);
      }
      var start = findStartLine(cm, n, precise);
      var saved = start > doc2.first && getLine(doc2, start - 1).stateAfter;
      var context = saved ? Context.fromSaved(doc2, saved, start) : new Context(doc2, startState(doc2.mode), start);
      doc2.iter(start, n, function(line) {
        processLine(cm, line.text, context);
        var pos = context.line;
        line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
        context.nextLine();
      });
      if (precise) {
        doc2.modeFrontier = context.line;
      }
      return context;
    }
    function processLine(cm, text, context, startAt) {
      var mode = cm.doc.mode;
      var stream = new StringStream(text, cm.options.tabSize, context);
      stream.start = stream.pos = startAt || 0;
      if (text == "") {
        callBlankLine(mode, context.state);
      }
      while (!stream.eol()) {
        readToken(mode, stream, context.state);
        stream.start = stream.pos;
      }
    }
    function callBlankLine(mode, state) {
      if (mode.blankLine) {
        return mode.blankLine(state);
      }
      if (!mode.innerMode) {
        return;
      }
      var inner = innerMode(mode, state);
      if (inner.mode.blankLine) {
        return inner.mode.blankLine(inner.state);
      }
    }
    function readToken(mode, stream, state, inner) {
      for (var i2 = 0; i2 < 10; i2++) {
        if (inner) {
          inner[0] = innerMode(mode, state).mode;
        }
        var style = mode.token(stream, state);
        if (stream.pos > stream.start) {
          return style;
        }
      }
      throw new Error("Mode " + mode.name + " failed to advance stream.");
    }
    var Token = function(stream, type, state) {
      this.start = stream.start;
      this.end = stream.pos;
      this.string = stream.current();
      this.type = type || null;
      this.state = state;
    };
    function takeToken(cm, pos, precise, asArray) {
      var doc2 = cm.doc, mode = doc2.mode, style;
      pos = clipPos(doc2, pos);
      var line = getLine(doc2, pos.line), context = getContextBefore(cm, pos.line, precise);
      var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
      if (asArray) {
        tokens = [];
      }
      while ((asArray || stream.pos < pos.ch) && !stream.eol()) {
        stream.start = stream.pos;
        style = readToken(mode, stream, context.state);
        if (asArray) {
          tokens.push(new Token(stream, style, copyState(doc2.mode, context.state)));
        }
      }
      return asArray ? tokens : new Token(stream, style, context.state);
    }
    function extractLineClasses(type, output) {
      if (type) {
        for (; ; ) {
          var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
          if (!lineClass) {
            break;
          }
          type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
          var prop2 = lineClass[1] ? "bgClass" : "textClass";
          if (output[prop2] == null) {
            output[prop2] = lineClass[2];
          } else if (!new RegExp("(?:^|\\s)" + lineClass[2] + "(?:$|\\s)").test(output[prop2])) {
            output[prop2] += " " + lineClass[2];
          }
        }
      }
      return type;
    }
    function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
      var flattenSpans = mode.flattenSpans;
      if (flattenSpans == null) {
        flattenSpans = cm.options.flattenSpans;
      }
      var curStart = 0, curStyle = null;
      var stream = new StringStream(text, cm.options.tabSize, context), style;
      var inner = cm.options.addModeClass && [null];
      if (text == "") {
        extractLineClasses(callBlankLine(mode, context.state), lineClasses);
      }
      while (!stream.eol()) {
        if (stream.pos > cm.options.maxHighlightLength) {
          flattenSpans = false;
          if (forceToEnd) {
            processLine(cm, text, context, stream.pos);
          }
          stream.pos = text.length;
          style = null;
        } else {
          style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
        }
        if (inner) {
          var mName = inner[0].name;
          if (mName) {
            style = "m-" + (style ? mName + " " + style : mName);
          }
        }
        if (!flattenSpans || curStyle != style) {
          while (curStart < stream.start) {
            curStart = Math.min(stream.start, curStart + 5e3);
            f(curStart, curStyle);
          }
          curStyle = style;
        }
        stream.start = stream.pos;
      }
      while (curStart < stream.pos) {
        var pos = Math.min(stream.pos, curStart + 5e3);
        f(pos, curStyle);
        curStart = pos;
      }
    }
    function findStartLine(cm, n, precise) {
      var minindent, minline, doc2 = cm.doc;
      var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1e3 : 100);
      for (var search = n; search > lim; --search) {
        if (search <= doc2.first) {
          return doc2.first;
        }
        var line = getLine(doc2, search - 1), after = line.stateAfter;
        if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc2.modeFrontier)) {
          return search;
        }
        var indented = countColumn(line.text, null, cm.options.tabSize);
        if (minline == null || minindent > indented) {
          minline = search - 1;
          minindent = indented;
        }
      }
      return minline;
    }
    function retreatFrontier(doc2, n) {
      doc2.modeFrontier = Math.min(doc2.modeFrontier, n);
      if (doc2.highlightFrontier < n - 10) {
        return;
      }
      var start = doc2.first;
      for (var line = n - 1; line > start; line--) {
        var saved = getLine(doc2, line).stateAfter;
        if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
          start = line + 1;
          break;
        }
      }
      doc2.highlightFrontier = Math.min(doc2.highlightFrontier, start);
    }
    var sawReadOnlySpans = false, sawCollapsedSpans = false;
    function seeReadOnlySpans() {
      sawReadOnlySpans = true;
    }
    function seeCollapsedSpans() {
      sawCollapsedSpans = true;
    }
    function MarkedSpan(marker, from, to) {
      this.marker = marker;
      this.from = from;
      this.to = to;
    }
    function getMarkedSpanFor(spans, marker) {
      if (spans) {
        for (var i2 = 0; i2 < spans.length; ++i2) {
          var span = spans[i2];
          if (span.marker == marker) {
            return span;
          }
        }
      }
    }
    function removeMarkedSpan(spans, span) {
      var r;
      for (var i2 = 0; i2 < spans.length; ++i2) {
        if (spans[i2] != span) {
          (r || (r = [])).push(spans[i2]);
        }
      }
      return r;
    }
    function addMarkedSpan(line, span, op) {
      var inThisOp = op && window.WeakSet && (op.markedSpans || (op.markedSpans = /* @__PURE__ */ new WeakSet()));
      if (inThisOp && line.markedSpans && inThisOp.has(line.markedSpans)) {
        line.markedSpans.push(span);
      } else {
        line.markedSpans = line.markedSpans ? line.markedSpans.concat([span]) : [span];
        if (inThisOp) {
          inThisOp.add(line.markedSpans);
        }
      }
      span.marker.attachLine(line);
    }
    function markedSpansBefore(old, startCh, isInsert) {
      var nw;
      if (old) {
        for (var i2 = 0; i2 < old.length; ++i2) {
          var span = old[i2], marker = span.marker;
          var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
          if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
            var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);
            (nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
          }
        }
      }
      return nw;
    }
    function markedSpansAfter(old, endCh, isInsert) {
      var nw;
      if (old) {
        for (var i2 = 0; i2 < old.length; ++i2) {
          var span = old[i2], marker = span.marker;
          var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
          if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
            var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);
            (nw || (nw = [])).push(new MarkedSpan(
              marker,
              startsBefore ? null : span.from - endCh,
              span.to == null ? null : span.to - endCh
            ));
          }
        }
      }
      return nw;
    }
    function stretchSpansOverChange(doc2, change2) {
      if (change2.full) {
        return null;
      }
      var oldFirst = isLine(doc2, change2.from.line) && getLine(doc2, change2.from.line).markedSpans;
      var oldLast = isLine(doc2, change2.to.line) && getLine(doc2, change2.to.line).markedSpans;
      if (!oldFirst && !oldLast) {
        return null;
      }
      var startCh = change2.from.ch, endCh = change2.to.ch, isInsert = cmp(change2.from, change2.to) == 0;
      var first = markedSpansBefore(oldFirst, startCh, isInsert);
      var last = markedSpansAfter(oldLast, endCh, isInsert);
      var sameLine = change2.text.length == 1, offset = lst(change2.text).length + (sameLine ? startCh : 0);
      if (first) {
        for (var i2 = 0; i2 < first.length; ++i2) {
          var span = first[i2];
          if (span.to == null) {
            var found = getMarkedSpanFor(last, span.marker);
            if (!found) {
              span.to = startCh;
            } else if (sameLine) {
              span.to = found.to == null ? null : found.to + offset;
            }
          }
        }
      }
      if (last) {
        for (var i$12 = 0; i$12 < last.length; ++i$12) {
          var span$1 = last[i$12];
          if (span$1.to != null) {
            span$1.to += offset;
          }
          if (span$1.from == null) {
            var found$1 = getMarkedSpanFor(first, span$1.marker);
            if (!found$1) {
              span$1.from = offset;
              if (sameLine) {
                (first || (first = [])).push(span$1);
              }
            }
          } else {
            span$1.from += offset;
            if (sameLine) {
              (first || (first = [])).push(span$1);
            }
          }
        }
      }
      if (first) {
        first = clearEmptySpans(first);
      }
      if (last && last != first) {
        last = clearEmptySpans(last);
      }
      var newMarkers = [first];
      if (!sameLine) {
        var gap = change2.text.length - 2, gapMarkers;
        if (gap > 0 && first) {
          for (var i$22 = 0; i$22 < first.length; ++i$22) {
            if (first[i$22].to == null) {
              (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$22].marker, null, null));
            }
          }
        }
        for (var i$3 = 0; i$3 < gap; ++i$3) {
          newMarkers.push(gapMarkers);
        }
        newMarkers.push(last);
      }
      return newMarkers;
    }
    function clearEmptySpans(spans) {
      for (var i2 = 0; i2 < spans.length; ++i2) {
        var span = spans[i2];
        if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) {
          spans.splice(i2--, 1);
        }
      }
      if (!spans.length) {
        return null;
      }
      return spans;
    }
    function removeReadOnlyRanges(doc2, from, to) {
      var markers = null;
      doc2.iter(from.line, to.line + 1, function(line) {
        if (line.markedSpans) {
          for (var i3 = 0; i3 < line.markedSpans.length; ++i3) {
            var mark = line.markedSpans[i3].marker;
            if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) {
              (markers || (markers = [])).push(mark);
            }
          }
        }
      });
      if (!markers) {
        return null;
      }
      var parts = [{ from, to }];
      for (var i2 = 0; i2 < markers.length; ++i2) {
        var mk = markers[i2], m = mk.find(0);
        for (var j = 0; j < parts.length; ++j) {
          var p = parts[j];
          if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) {
            continue;
          }
          var newParts = [j, 1], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
          if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) {
            newParts.push({ from: p.from, to: m.from });
          }
          if (dto > 0 || !mk.inclusiveRight && !dto) {
            newParts.push({ from: m.to, to: p.to });
          }
          parts.splice.apply(parts, newParts);
          j += newParts.length - 3;
        }
      }
      return parts;
    }
    function detachMarkedSpans(line) {
      var spans = line.markedSpans;
      if (!spans) {
        return;
      }
      for (var i2 = 0; i2 < spans.length; ++i2) {
        spans[i2].marker.detachLine(line);
      }
      line.markedSpans = null;
    }
    function attachMarkedSpans(line, spans) {
      if (!spans) {
        return;
      }
      for (var i2 = 0; i2 < spans.length; ++i2) {
        spans[i2].marker.attachLine(line);
      }
      line.markedSpans = spans;
    }
    function extraLeft(marker) {
      return marker.inclusiveLeft ? -1 : 0;
    }
    function extraRight(marker) {
      return marker.inclusiveRight ? 1 : 0;
    }
    function compareCollapsedMarkers(a, b) {
      var lenDiff = a.lines.length - b.lines.length;
      if (lenDiff != 0) {
        return lenDiff;
      }
      var aPos = a.find(), bPos = b.find();
      var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
      if (fromCmp) {
        return -fromCmp;
      }
      var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
      if (toCmp) {
        return toCmp;
      }
      return b.id - a.id;
    }
    function collapsedSpanAtSide(line, start) {
      var sps = sawCollapsedSpans && line.markedSpans, found;
      if (sps) {
        for (var sp = void 0, i2 = 0; i2 < sps.length; ++i2) {
          sp = sps[i2];
          if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
            found = sp.marker;
          }
        }
      }
      return found;
    }
    function collapsedSpanAtStart(line) {
      return collapsedSpanAtSide(line, true);
    }
    function collapsedSpanAtEnd(line) {
      return collapsedSpanAtSide(line, false);
    }
    function collapsedSpanAround(line, ch) {
      var sps = sawCollapsedSpans && line.markedSpans, found;
      if (sps) {
        for (var i2 = 0; i2 < sps.length; ++i2) {
          var sp = sps[i2];
          if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) {
            found = sp.marker;
          }
        }
      }
      return found;
    }
    function conflictingCollapsedRange(doc2, lineNo2, from, to, marker) {
      var line = getLine(doc2, lineNo2);
      var sps = sawCollapsedSpans && line.markedSpans;
      if (sps) {
        for (var i2 = 0; i2 < sps.length; ++i2) {
          var sp = sps[i2];
          if (!sp.marker.collapsed) {
            continue;
          }
          var found = sp.marker.find(0);
          var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
          var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
          if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) {
            continue;
          }
          if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) {
            return true;
          }
        }
      }
    }
    function visualLine(line) {
      var merged;
      while (merged = collapsedSpanAtStart(line)) {
        line = merged.find(-1, true).line;
      }
      return line;
    }
    function visualLineEnd(line) {
      var merged;
      while (merged = collapsedSpanAtEnd(line)) {
        line = merged.find(1, true).line;
      }
      return line;
    }
    function visualLineContinued(line) {
      var merged, lines;
      while (merged = collapsedSpanAtEnd(line)) {
        line = merged.find(1, true).line;
        (lines || (lines = [])).push(line);
      }
      return lines;
    }
    function visualLineNo(doc2, lineN) {
      var line = getLine(doc2, lineN), vis = visualLine(line);
      if (line == vis) {
        return lineN;
      }
      return lineNo(vis);
    }
    function visualLineEndNo(doc2, lineN) {
      if (lineN > doc2.lastLine()) {
        return lineN;
      }
      var line = getLine(doc2, lineN), merged;
      if (!lineIsHidden(doc2, line)) {
        return lineN;
      }
      while (merged = collapsedSpanAtEnd(line)) {
        line = merged.find(1, true).line;
      }
      return lineNo(line) + 1;
    }
    function lineIsHidden(doc2, line) {
      var sps = sawCollapsedSpans && line.markedSpans;
      if (sps) {
        for (var sp = void 0, i2 = 0; i2 < sps.length; ++i2) {
          sp = sps[i2];
          if (!sp.marker.collapsed) {
            continue;
          }
          if (sp.from == null) {
            return true;
          }
          if (sp.marker.widgetNode) {
            continue;
          }
          if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc2, line, sp)) {
            return true;
          }
        }
      }
    }
    function lineIsHiddenInner(doc2, line, span) {
      if (span.to == null) {
        var end = span.marker.find(1, true);
        return lineIsHiddenInner(doc2, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
      }
      if (span.marker.inclusiveRight && span.to == line.text.length) {
        return true;
      }
      for (var sp = void 0, i2 = 0; i2 < line.markedSpans.length; ++i2) {
        sp = line.markedSpans[i2];
        if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc2, line, sp)) {
          return true;
        }
      }
    }
    function heightAtLine(lineObj) {
      lineObj = visualLine(lineObj);
      var h2 = 0, chunk = lineObj.parent;
      for (var i2 = 0; i2 < chunk.lines.length; ++i2) {
        var line = chunk.lines[i2];
        if (line == lineObj) {
          break;
        } else {
          h2 += line.height;
        }
      }
      for (var p = chunk.parent; p; chunk = p, p = chunk.parent) {
        for (var i$12 = 0; i$12 < p.children.length; ++i$12) {
          var cur = p.children[i$12];
          if (cur == chunk) {
            break;
          } else {
            h2 += cur.height;
          }
        }
      }
      return h2;
    }
    function lineLength(line) {
      if (line.height == 0) {
        return 0;
      }
      var len = line.text.length, merged, cur = line;
      while (merged = collapsedSpanAtStart(cur)) {
        var found = merged.find(0, true);
        cur = found.from.line;
        len += found.from.ch - found.to.ch;
      }
      cur = line;
      while (merged = collapsedSpanAtEnd(cur)) {
        var found$1 = merged.find(0, true);
        len -= cur.text.length - found$1.from.ch;
        cur = found$1.to.line;
        len += cur.text.length - found$1.to.ch;
      }
      return len;
    }
    function findMaxLine(cm) {
      var d = cm.display, doc2 = cm.doc;
      d.maxLine = getLine(doc2, doc2.first);
      d.maxLineLength = lineLength(d.maxLine);
      d.maxLineChanged = true;
      doc2.iter(function(line) {
        var len = lineLength(line);
        if (len > d.maxLineLength) {
          d.maxLineLength = len;
          d.maxLine = line;
        }
      });
    }
    var Line = function(text, markedSpans, estimateHeight2) {
      this.text = text;
      attachMarkedSpans(this, markedSpans);
      this.height = estimateHeight2 ? estimateHeight2(this) : 1;
    };
    Line.prototype.lineNo = function() {
      return lineNo(this);
    };
    eventMixin(Line);
    function updateLine(line, text, markedSpans, estimateHeight2) {
      line.text = text;
      if (line.stateAfter) {
        line.stateAfter = null;
      }
      if (line.styles) {
        line.styles = null;
      }
      if (line.order != null) {
        line.order = null;
      }
      detachMarkedSpans(line);
      attachMarkedSpans(line, markedSpans);
      var estHeight = estimateHeight2 ? estimateHeight2(line) : 1;
      if (estHeight != line.height) {
        updateLineHeight(line, estHeight);
      }
    }
    function cleanUpLine(line) {
      line.parent = null;
      detachMarkedSpans(line);
    }
    var styleToClassCache = {}, styleToClassCacheWithMode = {};
    function interpretTokenStyle(style, options) {
      if (!style || /^\s*$/.test(style)) {
        return null;
      }
      var cache2 = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
      return cache2[style] || (cache2[style] = style.replace(/\S+/g, "cm-$&"));
    }
    function buildLineContent(cm, lineView) {
      var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
      var builder = {
        pre: eltP("pre", [content], "CodeMirror-line"),
        content,
        col: 0,
        pos: 0,
        cm,
        trailingSpace: false,
        splitSpaces: cm.getOption("lineWrapping")
      };
      lineView.measure = {};
      for (var i2 = 0; i2 <= (lineView.rest ? lineView.rest.length : 0); i2++) {
        var line = i2 ? lineView.rest[i2 - 1] : lineView.line, order = void 0;
        builder.pos = 0;
        builder.addToken = buildToken;
        if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) {
          builder.addToken = buildTokenBadBidi(builder.addToken, order);
        }
        builder.map = [];
        var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
        insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
        if (line.styleClasses) {
          if (line.styleClasses.bgClass) {
            builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
          }
          if (line.styleClasses.textClass) {
            builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
          }
        }
        if (builder.map.length == 0) {
          builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
        }
        if (i2 == 0) {
          lineView.measure.map = builder.map;
          lineView.measure.cache = {};
        } else {
          (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);
          (lineView.measure.caches || (lineView.measure.caches = [])).push({});
        }
      }
      if (webkit) {
        var last = builder.content.lastChild;
        if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) {
          builder.content.className = "cm-tab-wrap-hack";
        }
      }
      signal(cm, "renderLine", cm, lineView.line, builder.pre);
      if (builder.pre.className) {
        builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
      }
      return builder;
    }
    function defaultSpecialCharPlaceholder(ch) {
      var token = elt("span", "\u2022", "cm-invalidchar");
      token.title = "\\u" + ch.charCodeAt(0).toString(16);
      token.setAttribute("aria-label", token.title);
      return token;
    }
    function buildToken(builder, text, style, startStyle, endStyle, css2, attributes) {
      if (!text) {
        return;
      }
      var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
      var special = builder.cm.state.specialChars, mustWrap = false;
      var content;
      if (!special.test(text)) {
        builder.col += text.length;
        content = document.createTextNode(displayText);
        builder.map.push(builder.pos, builder.pos + text.length, content);
        if (ie && ie_version < 9) {
          mustWrap = true;
        }
        builder.pos += text.length;
      } else {
        content = document.createDocumentFragment();
        var pos = 0;
        while (true) {
          special.lastIndex = pos;
          var m = special.exec(text);
          var skipped = m ? m.index - pos : text.length - pos;
          if (skipped) {
            var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
            if (ie && ie_version < 9) {
              content.appendChild(elt("span", [txt]));
            } else {
              content.appendChild(txt);
            }
            builder.map.push(builder.pos, builder.pos + skipped, txt);
            builder.col += skipped;
            builder.pos += skipped;
          }
          if (!m) {
            break;
          }
          pos += skipped + 1;
          var txt$1 = void 0;
          if (m[0] == "	") {
            var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
            txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
            txt$1.setAttribute("role", "presentation");
            txt$1.setAttribute("cm-text", "	");
            builder.col += tabWidth;
          } else if (m[0] == "\r" || m[0] == "\n") {
            txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "\u240D" : "\u2424", "cm-invalidchar"));
            txt$1.setAttribute("cm-text", m[0]);
            builder.col += 1;
          } else {
            txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
            txt$1.setAttribute("cm-text", m[0]);
            if (ie && ie_version < 9) {
              content.appendChild(elt("span", [txt$1]));
            } else {
              content.appendChild(txt$1);
            }
            builder.col += 1;
          }
          builder.map.push(builder.pos, builder.pos + 1, txt$1);
          builder.pos++;
        }
      }
      builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
      if (style || startStyle || endStyle || mustWrap || css2 || attributes) {
        var fullStyle = style || "";
        if (startStyle) {
          fullStyle += startStyle;
        }
        if (endStyle) {
          fullStyle += endStyle;
        }
        var token = elt("span", [content], fullStyle, css2);
        if (attributes) {
          for (var attr in attributes) {
            if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") {
              token.setAttribute(attr, attributes[attr]);
            }
          }
        }
        return builder.content.appendChild(token);
      }
      builder.content.appendChild(content);
    }
    function splitSpaces(text, trailingBefore) {
      if (text.length > 1 && !/  /.test(text)) {
        return text;
      }
      var spaceBefore = trailingBefore, result = "";
      for (var i2 = 0; i2 < text.length; i2++) {
        var ch = text.charAt(i2);
        if (ch == " " && spaceBefore && (i2 == text.length - 1 || text.charCodeAt(i2 + 1) == 32)) {
          ch = "\xA0";
        }
        result += ch;
        spaceBefore = ch == " ";
      }
      return result;
    }
    function buildTokenBadBidi(inner, order) {
      return function(builder, text, style, startStyle, endStyle, css2, attributes) {
        style = style ? style + " cm-force-border" : "cm-force-border";
        var start = builder.pos, end = start + text.length;
        for (; ; ) {
          var part = void 0;
          for (var i2 = 0; i2 < order.length; i2++) {
            part = order[i2];
            if (part.to > start && part.from <= start) {
              break;
            }
          }
          if (part.to >= end) {
            return inner(builder, text, style, startStyle, endStyle, css2, attributes);
          }
          inner(builder, text.slice(0, part.to - start), style, startStyle, null, css2, attributes);
          startStyle = null;
          text = text.slice(part.to - start);
          start = part.to;
        }
      };
    }
    function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
      var widget = !ignoreWidget && marker.widgetNode;
      if (widget) {
        builder.map.push(builder.pos, builder.pos + size, widget);
      }
      if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
        if (!widget) {
          widget = builder.content.appendChild(document.createElement("span"));
        }
        widget.setAttribute("cm-marker", marker.id);
      }
      if (widget) {
        builder.cm.display.input.setUneditable(widget);
        builder.content.appendChild(widget);
      }
      builder.pos += size;
      builder.trailingSpace = false;
    }
    function insertLineContent(line, builder, styles) {
      var spans = line.markedSpans, allText = line.text, at = 0;
      if (!spans) {
        for (var i$12 = 1; i$12 < styles.length; i$12 += 2) {
          builder.addToken(builder, allText.slice(at, at = styles[i$12]), interpretTokenStyle(styles[i$12 + 1], builder.cm.options));
        }
        return;
      }
      var len = allText.length, pos = 0, i2 = 1, text = "", style, css2;
      var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
      for (; ; ) {
        if (nextChange == pos) {
          spanStyle = spanEndStyle = spanStartStyle = css2 = "";
          attributes = null;
          collapsed = null;
          nextChange = Infinity;
          var foundBookmarks = [], endStyles = void 0;
          for (var j = 0; j < spans.length; ++j) {
            var sp = spans[j], m = sp.marker;
            if (m.type == "bookmark" && sp.from == pos && m.widgetNode) {
              foundBookmarks.push(m);
            } else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
              if (sp.to != null && sp.to != pos && nextChange > sp.to) {
                nextChange = sp.to;
                spanEndStyle = "";
              }
              if (m.className) {
                spanStyle += " " + m.className;
              }
              if (m.css) {
                css2 = (css2 ? css2 + ";" : "") + m.css;
              }
              if (m.startStyle && sp.from == pos) {
                spanStartStyle += " " + m.startStyle;
              }
              if (m.endStyle && sp.to == nextChange) {
                (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
              }
              if (m.title) {
                (attributes || (attributes = {})).title = m.title;
              }
              if (m.attributes) {
                for (var attr in m.attributes) {
                  (attributes || (attributes = {}))[attr] = m.attributes[attr];
                }
              }
              if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) {
                collapsed = sp;
              }
            } else if (sp.from > pos && nextChange > sp.from) {
              nextChange = sp.from;
            }
          }
          if (endStyles) {
            for (var j$1 = 0; j$1 < endStyles.length; j$1 += 2) {
              if (endStyles[j$1 + 1] == nextChange) {
                spanEndStyle += " " + endStyles[j$1];
              }
            }
          }
          if (!collapsed || collapsed.from == pos) {
            for (var j$2 = 0; j$2 < foundBookmarks.length; ++j$2) {
              buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
            }
          }
          if (collapsed && (collapsed.from || 0) == pos) {
            buildCollapsedSpan(
              builder,
              (collapsed.to == null ? len + 1 : collapsed.to) - pos,
              collapsed.marker,
              collapsed.from == null
            );
            if (collapsed.to == null) {
              return;
            }
            if (collapsed.to == pos) {
              collapsed = false;
            }
          }
        }
        if (pos >= len) {
          break;
        }
        var upto = Math.min(len, nextChange);
        while (true) {
          if (text) {
            var end = pos + text.length;
            if (!collapsed) {
              var tokenText = end > upto ? text.slice(0, upto - pos) : text;
              builder.addToken(
                builder,
                tokenText,
                style ? style + spanStyle : spanStyle,
                spanStartStyle,
                pos + tokenText.length == nextChange ? spanEndStyle : "",
                css2,
                attributes
              );
            }
            if (end >= upto) {
              text = text.slice(upto - pos);
              pos = upto;
              break;
            }
            pos = end;
            spanStartStyle = "";
          }
          text = allText.slice(at, at = styles[i2++]);
          style = interpretTokenStyle(styles[i2++], builder.cm.options);
        }
      }
    }
    function LineView(doc2, line, lineN) {
      this.line = line;
      this.rest = visualLineContinued(line);
      this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
      this.node = this.text = null;
      this.hidden = lineIsHidden(doc2, line);
    }
    function buildViewArray(cm, from, to) {
      var array = [], nextPos;
      for (var pos = from; pos < to; pos = nextPos) {
        var view2 = new LineView(cm.doc, getLine(cm.doc, pos), pos);
        nextPos = pos + view2.size;
        array.push(view2);
      }
      return array;
    }
    var operationGroup = null;
    function pushOperation(op) {
      if (operationGroup) {
        operationGroup.ops.push(op);
      } else {
        op.ownsGroup = operationGroup = {
          ops: [op],
          delayedCallbacks: []
        };
      }
    }
    function fireCallbacksForOps(group) {
      var callbacks = group.delayedCallbacks, i2 = 0;
      do {
        for (; i2 < callbacks.length; i2++) {
          callbacks[i2].call(null);
        }
        for (var j = 0; j < group.ops.length; j++) {
          var op = group.ops[j];
          if (op.cursorActivityHandlers) {
            while (op.cursorActivityCalled < op.cursorActivityHandlers.length) {
              op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
            }
          }
        }
      } while (i2 < callbacks.length);
    }
    function finishOperation(op, endCb) {
      var group = op.ownsGroup;
      if (!group) {
        return;
      }
      try {
        fireCallbacksForOps(group);
      } finally {
        operationGroup = null;
        endCb(group);
      }
    }
    var orphanDelayedCallbacks = null;
    function signalLater(emitter, type) {
      var arr = getHandlers(emitter, type);
      if (!arr.length) {
        return;
      }
      var args = Array.prototype.slice.call(arguments, 2), list;
      if (operationGroup) {
        list = operationGroup.delayedCallbacks;
      } else if (orphanDelayedCallbacks) {
        list = orphanDelayedCallbacks;
      } else {
        list = orphanDelayedCallbacks = [];
        setTimeout(fireOrphanDelayed, 0);
      }
      var loop = function(i3) {
        list.push(function() {
          return arr[i3].apply(null, args);
        });
      };
      for (var i2 = 0; i2 < arr.length; ++i2)
        loop(i2);
    }
    function fireOrphanDelayed() {
      var delayed = orphanDelayedCallbacks;
      orphanDelayedCallbacks = null;
      for (var i2 = 0; i2 < delayed.length; ++i2) {
        delayed[i2]();
      }
    }
    function updateLineForChanges(cm, lineView, lineN, dims) {
      for (var j = 0; j < lineView.changes.length; j++) {
        var type = lineView.changes[j];
        if (type == "text") {
          updateLineText(cm, lineView);
        } else if (type == "gutter") {
          updateLineGutter(cm, lineView, lineN, dims);
        } else if (type == "class") {
          updateLineClasses(cm, lineView);
        } else if (type == "widget") {
          updateLineWidgets(cm, lineView, dims);
        }
      }
      lineView.changes = null;
    }
    function ensureLineWrapped(lineView) {
      if (lineView.node == lineView.text) {
        lineView.node = elt("div", null, null, "position: relative");
        if (lineView.text.parentNode) {
          lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
        }
        lineView.node.appendChild(lineView.text);
        if (ie && ie_version < 8) {
          lineView.node.style.zIndex = 2;
        }
      }
      return lineView.node;
    }
    function updateLineBackground(cm, lineView) {
      var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
      if (cls) {
        cls += " CodeMirror-linebackground";
      }
      if (lineView.background) {
        if (cls) {
          lineView.background.className = cls;
        } else {
          lineView.background.parentNode.removeChild(lineView.background);
          lineView.background = null;
        }
      } else if (cls) {
        var wrap = ensureLineWrapped(lineView);
        lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
        cm.display.input.setUneditable(lineView.background);
      }
    }
    function getLineContent(cm, lineView) {
      var ext = cm.display.externalMeasured;
      if (ext && ext.line == lineView.line) {
        cm.display.externalMeasured = null;
        lineView.measure = ext.measure;
        return ext.built;
      }
      return buildLineContent(cm, lineView);
    }
    function updateLineText(cm, lineView) {
      var cls = lineView.text.className;
      var built = getLineContent(cm, lineView);
      if (lineView.text == lineView.node) {
        lineView.node = built.pre;
      }
      lineView.text.parentNode.replaceChild(built.pre, lineView.text);
      lineView.text = built.pre;
      if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
        lineView.bgClass = built.bgClass;
        lineView.textClass = built.textClass;
        updateLineClasses(cm, lineView);
      } else if (cls) {
        lineView.text.className = cls;
      }
    }
    function updateLineClasses(cm, lineView) {
      updateLineBackground(cm, lineView);
      if (lineView.line.wrapClass) {
        ensureLineWrapped(lineView).className = lineView.line.wrapClass;
      } else if (lineView.node != lineView.text) {
        lineView.node.className = "";
      }
      var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
      lineView.text.className = textClass || "";
    }
    function updateLineGutter(cm, lineView, lineN, dims) {
      if (lineView.gutter) {
        lineView.node.removeChild(lineView.gutter);
        lineView.gutter = null;
      }
      if (lineView.gutterBackground) {
        lineView.node.removeChild(lineView.gutterBackground);
        lineView.gutterBackground = null;
      }
      if (lineView.line.gutterClass) {
        var wrap = ensureLineWrapped(lineView);
        lineView.gutterBackground = elt(
          "div",
          null,
          "CodeMirror-gutter-background " + lineView.line.gutterClass,
          "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px"
        );
        cm.display.input.setUneditable(lineView.gutterBackground);
        wrap.insertBefore(lineView.gutterBackground, lineView.text);
      }
      var markers = lineView.line.gutterMarkers;
      if (cm.options.lineNumbers || markers) {
        var wrap$1 = ensureLineWrapped(lineView);
        var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
        gutterWrap.setAttribute("aria-hidden", "true");
        cm.display.input.setUneditable(gutterWrap);
        wrap$1.insertBefore(gutterWrap, lineView.text);
        if (lineView.line.gutterClass) {
          gutterWrap.className += " " + lineView.line.gutterClass;
        }
        if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) {
          lineView.lineNumber = gutterWrap.appendChild(
            elt(
              "div",
              lineNumberFor(cm.options, lineN),
              "CodeMirror-linenumber CodeMirror-gutter-elt",
              "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"
            )
          );
        }
        if (markers) {
          for (var k = 0; k < cm.display.gutterSpecs.length; ++k) {
            var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
            if (found) {
              gutterWrap.appendChild(elt(
                "div",
                [found],
                "CodeMirror-gutter-elt",
                "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"
              ));
            }
          }
        }
      }
    }
    function updateLineWidgets(cm, lineView, dims) {
      if (lineView.alignable) {
        lineView.alignable = null;
      }
      var isWidget = classTest("CodeMirror-linewidget");
      for (var node = lineView.node.firstChild, next2 = void 0; node; node = next2) {
        next2 = node.nextSibling;
        if (isWidget.test(node.className)) {
          lineView.node.removeChild(node);
        }
      }
      insertLineWidgets(cm, lineView, dims);
    }
    function buildLineElement(cm, lineView, lineN, dims) {
      var built = getLineContent(cm, lineView);
      lineView.text = lineView.node = built.pre;
      if (built.bgClass) {
        lineView.bgClass = built.bgClass;
      }
      if (built.textClass) {
        lineView.textClass = built.textClass;
      }
      updateLineClasses(cm, lineView);
      updateLineGutter(cm, lineView, lineN, dims);
      insertLineWidgets(cm, lineView, dims);
      return lineView.node;
    }
    function insertLineWidgets(cm, lineView, dims) {
      insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
      if (lineView.rest) {
        for (var i2 = 0; i2 < lineView.rest.length; i2++) {
          insertLineWidgetsFor(cm, lineView.rest[i2], lineView, dims, false);
        }
      }
    }
    function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
      if (!line.widgets) {
        return;
      }
      var wrap = ensureLineWrapped(lineView);
      for (var i2 = 0, ws = line.widgets; i2 < ws.length; ++i2) {
        var widget = ws[i2], node = elt("div", [widget.node], "CodeMirror-linewidget" + (widget.className ? " " + widget.className : ""));
        if (!widget.handleMouseEvents) {
          node.setAttribute("cm-ignore-events", "true");
        }
        positionLineWidget(widget, node, lineView, dims);
        cm.display.input.setUneditable(node);
        if (allowAbove && widget.above) {
          wrap.insertBefore(node, lineView.gutter || lineView.text);
        } else {
          wrap.appendChild(node);
        }
        signalLater(widget, "redraw");
      }
    }
    function positionLineWidget(widget, node, lineView, dims) {
      if (widget.noHScroll) {
        (lineView.alignable || (lineView.alignable = [])).push(node);
        var width = dims.wrapperWidth;
        node.style.left = dims.fixedPos + "px";
        if (!widget.coverGutter) {
          width -= dims.gutterTotalWidth;
          node.style.paddingLeft = dims.gutterTotalWidth + "px";
        }
        node.style.width = width + "px";
      }
      if (widget.coverGutter) {
        node.style.zIndex = 5;
        node.style.position = "relative";
        if (!widget.noHScroll) {
          node.style.marginLeft = -dims.gutterTotalWidth + "px";
        }
      }
    }
    function widgetHeight(widget) {
      if (widget.height != null) {
        return widget.height;
      }
      var cm = widget.doc.cm;
      if (!cm) {
        return 0;
      }
      if (!contains(document.body, widget.node)) {
        var parentStyle = "position: relative;";
        if (widget.coverGutter) {
          parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
        }
        if (widget.noHScroll) {
          parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
        }
        removeChildrenAndAdd(cm.display.measure, elt("div", [widget.node], null, parentStyle));
      }
      return widget.height = widget.node.parentNode.offsetHeight;
    }
    function eventInWidget(display, e) {
      for (var n = e_target(e); n != display.wrapper; n = n.parentNode) {
        if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) {
          return true;
        }
      }
    }
    function paddingTop(display) {
      return display.lineSpace.offsetTop;
    }
    function paddingVert(display) {
      return display.mover.offsetHeight - display.lineSpace.offsetHeight;
    }
    function paddingH(display) {
      if (display.cachedPaddingH) {
        return display.cachedPaddingH;
      }
      var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
      var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
      var data2 = { left: parseInt(style.paddingLeft), right: parseInt(style.paddingRight) };
      if (!isNaN(data2.left) && !isNaN(data2.right)) {
        display.cachedPaddingH = data2;
      }
      return data2;
    }
    function scrollGap(cm) {
      return scrollerGap - cm.display.nativeBarWidth;
    }
    function displayWidth(cm) {
      return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
    }
    function displayHeight(cm) {
      return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
    }
    function ensureLineHeights(cm, lineView, rect) {
      var wrapping = cm.options.lineWrapping;
      var curWidth = wrapping && displayWidth(cm);
      if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
        var heights = lineView.measure.heights = [];
        if (wrapping) {
          lineView.measure.width = curWidth;
          var rects = lineView.text.firstChild.getClientRects();
          for (var i2 = 0; i2 < rects.length - 1; i2++) {
            var cur = rects[i2], next2 = rects[i2 + 1];
            if (Math.abs(cur.bottom - next2.bottom) > 2) {
              heights.push((cur.bottom + next2.top) / 2 - rect.top);
            }
          }
        }
        heights.push(rect.bottom - rect.top);
      }
    }
    function mapFromLineView(lineView, line, lineN) {
      if (lineView.line == line) {
        return { map: lineView.measure.map, cache: lineView.measure.cache };
      }
      if (lineView.rest) {
        for (var i2 = 0; i2 < lineView.rest.length; i2++) {
          if (lineView.rest[i2] == line) {
            return { map: lineView.measure.maps[i2], cache: lineView.measure.caches[i2] };
          }
        }
        for (var i$12 = 0; i$12 < lineView.rest.length; i$12++) {
          if (lineNo(lineView.rest[i$12]) > lineN) {
            return { map: lineView.measure.maps[i$12], cache: lineView.measure.caches[i$12], before: true };
          }
        }
      }
    }
    function updateExternalMeasurement(cm, line) {
      line = visualLine(line);
      var lineN = lineNo(line);
      var view2 = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
      view2.lineN = lineN;
      var built = view2.built = buildLineContent(cm, view2);
      view2.text = built.pre;
      removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
      return view2;
    }
    function measureChar(cm, line, ch, bias) {
      return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
    }
    function findViewForLine(cm, lineN) {
      if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) {
        return cm.display.view[findViewIndex(cm, lineN)];
      }
      var ext = cm.display.externalMeasured;
      if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) {
        return ext;
      }
    }
    function prepareMeasureForLine(cm, line) {
      var lineN = lineNo(line);
      var view2 = findViewForLine(cm, lineN);
      if (view2 && !view2.text) {
        view2 = null;
      } else if (view2 && view2.changes) {
        updateLineForChanges(cm, view2, lineN, getDimensions(cm));
        cm.curOp.forceUpdate = true;
      }
      if (!view2) {
        view2 = updateExternalMeasurement(cm, line);
      }
      var info = mapFromLineView(view2, line, lineN);
      return {
        line,
        view: view2,
        rect: null,
        map: info.map,
        cache: info.cache,
        before: info.before,
        hasHeights: false
      };
    }
    function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
      if (prepared.before) {
        ch = -1;
      }
      var key = ch + (bias || ""), found;
      if (prepared.cache.hasOwnProperty(key)) {
        found = prepared.cache[key];
      } else {
        if (!prepared.rect) {
          prepared.rect = prepared.view.text.getBoundingClientRect();
        }
        if (!prepared.hasHeights) {
          ensureLineHeights(cm, prepared.view, prepared.rect);
          prepared.hasHeights = true;
        }
        found = measureCharInner(cm, prepared, ch, bias);
        if (!found.bogus) {
          prepared.cache[key] = found;
        }
      }
      return {
        left: found.left,
        right: found.right,
        top: varHeight ? found.rtop : found.top,
        bottom: varHeight ? found.rbottom : found.bottom
      };
    }
    var nullRect = { left: 0, right: 0, top: 0, bottom: 0 };
    function nodeAndOffsetInLineMap(map2, ch, bias) {
      var node, start, end, collapse, mStart, mEnd;
      for (var i2 = 0; i2 < map2.length; i2 += 3) {
        mStart = map2[i2];
        mEnd = map2[i2 + 1];
        if (ch < mStart) {
          start = 0;
          end = 1;
          collapse = "left";
        } else if (ch < mEnd) {
          start = ch - mStart;
          end = start + 1;
        } else if (i2 == map2.length - 3 || ch == mEnd && map2[i2 + 3] > ch) {
          end = mEnd - mStart;
          start = end - 1;
          if (ch >= mEnd) {
            collapse = "right";
          }
        }
        if (start != null) {
          node = map2[i2 + 2];
          if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) {
            collapse = bias;
          }
          if (bias == "left" && start == 0) {
            while (i2 && map2[i2 - 2] == map2[i2 - 3] && map2[i2 - 1].insertLeft) {
              node = map2[(i2 -= 3) + 2];
              collapse = "left";
            }
          }
          if (bias == "right" && start == mEnd - mStart) {
            while (i2 < map2.length - 3 && map2[i2 + 3] == map2[i2 + 4] && !map2[i2 + 5].insertLeft) {
              node = map2[(i2 += 3) + 2];
              collapse = "right";
            }
          }
          break;
        }
      }
      return { node, start, end, collapse, coverStart: mStart, coverEnd: mEnd };
    }
    function getUsefulRect(rects, bias) {
      var rect = nullRect;
      if (bias == "left") {
        for (var i2 = 0; i2 < rects.length; i2++) {
          if ((rect = rects[i2]).left != rect.right) {
            break;
          }
        }
      } else {
        for (var i$12 = rects.length - 1; i$12 >= 0; i$12--) {
          if ((rect = rects[i$12]).left != rect.right) {
            break;
          }
        }
      }
      return rect;
    }
    function measureCharInner(cm, prepared, ch, bias) {
      var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
      var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
      var rect;
      if (node.nodeType == 3) {
        for (var i$12 = 0; i$12 < 4; i$12++) {
          while (start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start))) {
            --start;
          }
          while (place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end))) {
            ++end;
          }
          if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) {
            rect = node.parentNode.getBoundingClientRect();
          } else {
            rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
          }
          if (rect.left || rect.right || start == 0) {
            break;
          }
          end = start;
          start = start - 1;
          collapse = "right";
        }
        if (ie && ie_version < 11) {
          rect = maybeUpdateRectForZooming(cm.display.measure, rect);
        }
      } else {
        if (start > 0) {
          collapse = bias = "right";
        }
        var rects;
        if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) {
          rect = rects[bias == "right" ? rects.length - 1 : 0];
        } else {
          rect = node.getBoundingClientRect();
        }
      }
      if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
        var rSpan = node.parentNode.getClientRects()[0];
        if (rSpan) {
          rect = { left: rSpan.left, right: rSpan.left + charWidth(cm.display), top: rSpan.top, bottom: rSpan.bottom };
        } else {
          rect = nullRect;
        }
      }
      var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
      var mid = (rtop + rbot) / 2;
      var heights = prepared.view.measure.heights;
      var i2 = 0;
      for (; i2 < heights.length - 1; i2++) {
        if (mid < heights[i2]) {
          break;
        }
      }
      var top = i2 ? heights[i2 - 1] : 0, bot = heights[i2];
      var result = {
        left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
        right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
        top,
        bottom: bot
      };
      if (!rect.left && !rect.right) {
        result.bogus = true;
      }
      if (!cm.options.singleCursorHeightPerLine) {
        result.rtop = rtop;
        result.rbottom = rbot;
      }
      return result;
    }
    function maybeUpdateRectForZooming(measure, rect) {
      if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) {
        return rect;
      }
      var scaleX2 = screen.logicalXDPI / screen.deviceXDPI;
      var scaleY2 = screen.logicalYDPI / screen.deviceYDPI;
      return {
        left: rect.left * scaleX2,
        right: rect.right * scaleX2,
        top: rect.top * scaleY2,
        bottom: rect.bottom * scaleY2
      };
    }
    function clearLineMeasurementCacheFor(lineView) {
      if (lineView.measure) {
        lineView.measure.cache = {};
        lineView.measure.heights = null;
        if (lineView.rest) {
          for (var i2 = 0; i2 < lineView.rest.length; i2++) {
            lineView.measure.caches[i2] = {};
          }
        }
      }
    }
    function clearLineMeasurementCache(cm) {
      cm.display.externalMeasure = null;
      removeChildren(cm.display.lineMeasure);
      for (var i2 = 0; i2 < cm.display.view.length; i2++) {
        clearLineMeasurementCacheFor(cm.display.view[i2]);
      }
    }
    function clearCaches(cm) {
      clearLineMeasurementCache(cm);
      cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
      if (!cm.options.lineWrapping) {
        cm.display.maxLineChanged = true;
      }
      cm.display.lineNumChars = null;
    }
    function pageScrollX(doc2) {
      if (chrome && android) {
        return -(doc2.body.getBoundingClientRect().left - parseInt(getComputedStyle(doc2.body).marginLeft));
      }
      return doc2.defaultView.pageXOffset || (doc2.documentElement || doc2.body).scrollLeft;
    }
    function pageScrollY(doc2) {
      if (chrome && android) {
        return -(doc2.body.getBoundingClientRect().top - parseInt(getComputedStyle(doc2.body).marginTop));
      }
      return doc2.defaultView.pageYOffset || (doc2.documentElement || doc2.body).scrollTop;
    }
    function widgetTopHeight(lineObj) {
      var ref2 = visualLine(lineObj);
      var widgets = ref2.widgets;
      var height = 0;
      if (widgets) {
        for (var i2 = 0; i2 < widgets.length; ++i2) {
          if (widgets[i2].above) {
            height += widgetHeight(widgets[i2]);
          }
        }
      }
      return height;
    }
    function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
      if (!includeWidgets) {
        var height = widgetTopHeight(lineObj);
        rect.top += height;
        rect.bottom += height;
      }
      if (context == "line") {
        return rect;
      }
      if (!context) {
        context = "local";
      }
      var yOff = heightAtLine(lineObj);
      if (context == "local") {
        yOff += paddingTop(cm.display);
      } else {
        yOff -= cm.display.viewOffset;
      }
      if (context == "page" || context == "window") {
        var lOff = cm.display.lineSpace.getBoundingClientRect();
        yOff += lOff.top + (context == "window" ? 0 : pageScrollY(doc(cm)));
        var xOff = lOff.left + (context == "window" ? 0 : pageScrollX(doc(cm)));
        rect.left += xOff;
        rect.right += xOff;
      }
      rect.top += yOff;
      rect.bottom += yOff;
      return rect;
    }
    function fromCoordSystem(cm, coords, context) {
      if (context == "div") {
        return coords;
      }
      var left = coords.left, top = coords.top;
      if (context == "page") {
        left -= pageScrollX(doc(cm));
        top -= pageScrollY(doc(cm));
      } else if (context == "local" || !context) {
        var localBox = cm.display.sizer.getBoundingClientRect();
        left += localBox.left;
        top += localBox.top;
      }
      var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
      return { left: left - lineSpaceBox.left, top: top - lineSpaceBox.top };
    }
    function charCoords(cm, pos, context, lineObj, bias) {
      if (!lineObj) {
        lineObj = getLine(cm.doc, pos.line);
      }
      return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
    }
    function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
      lineObj = lineObj || getLine(cm.doc, pos.line);
      if (!preparedMeasure) {
        preparedMeasure = prepareMeasureForLine(cm, lineObj);
      }
      function get(ch2, right) {
        var m = measureCharPrepared(cm, preparedMeasure, ch2, right ? "right" : "left", varHeight);
        if (right) {
          m.left = m.right;
        } else {
          m.right = m.left;
        }
        return intoCoordSystem(cm, lineObj, m, context);
      }
      var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
      if (ch >= lineObj.text.length) {
        ch = lineObj.text.length;
        sticky = "before";
      } else if (ch <= 0) {
        ch = 0;
        sticky = "after";
      }
      if (!order) {
        return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
      }
      function getBidi(ch2, partPos2, invert) {
        var part = order[partPos2], right = part.level == 1;
        return get(invert ? ch2 - 1 : ch2, right != invert);
      }
      var partPos = getBidiPartAt(order, ch, sticky);
      var other = bidiOther;
      var val = getBidi(ch, partPos, sticky == "before");
      if (other != null) {
        val.other = getBidi(ch, other, sticky != "before");
      }
      return val;
    }
    function estimateCoords(cm, pos) {
      var left = 0;
      pos = clipPos(cm.doc, pos);
      if (!cm.options.lineWrapping) {
        left = charWidth(cm.display) * pos.ch;
      }
      var lineObj = getLine(cm.doc, pos.line);
      var top = heightAtLine(lineObj) + paddingTop(cm.display);
      return { left, right: left, top, bottom: top + lineObj.height };
    }
    function PosWithInfo(line, ch, sticky, outside, xRel) {
      var pos = Pos(line, ch, sticky);
      pos.xRel = xRel;
      if (outside) {
        pos.outside = outside;
      }
      return pos;
    }
    function coordsChar(cm, x, y) {
      var doc2 = cm.doc;
      y += cm.display.viewOffset;
      if (y < 0) {
        return PosWithInfo(doc2.first, 0, null, -1, -1);
      }
      var lineN = lineAtHeight(doc2, y), last = doc2.first + doc2.size - 1;
      if (lineN > last) {
        return PosWithInfo(doc2.first + doc2.size - 1, getLine(doc2, last).text.length, null, 1, 1);
      }
      if (x < 0) {
        x = 0;
      }
      var lineObj = getLine(doc2, lineN);
      for (; ; ) {
        var found = coordsCharInner(cm, lineObj, lineN, x, y);
        var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
        if (!collapsed) {
          return found;
        }
        var rangeEnd = collapsed.find(1);
        if (rangeEnd.line == lineN) {
          return rangeEnd;
        }
        lineObj = getLine(doc2, lineN = rangeEnd.line);
      }
    }
    function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
      y -= widgetTopHeight(lineObj);
      var end = lineObj.text.length;
      var begin = findFirst(function(ch) {
        return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
      }, end, 0);
      end = findFirst(function(ch) {
        return measureCharPrepared(cm, preparedMeasure, ch).top > y;
      }, begin, end);
      return { begin, end };
    }
    function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
      if (!preparedMeasure) {
        preparedMeasure = prepareMeasureForLine(cm, lineObj);
      }
      var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
      return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
    }
    function boxIsAfter(box, x, y, left) {
      return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
    }
    function coordsCharInner(cm, lineObj, lineNo2, x, y) {
      y -= heightAtLine(lineObj);
      var preparedMeasure = prepareMeasureForLine(cm, lineObj);
      var widgetHeight2 = widgetTopHeight(lineObj);
      var begin = 0, end = lineObj.text.length, ltr = true;
      var order = getOrder(lineObj, cm.doc.direction);
      if (order) {
        var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo2, preparedMeasure, order, x, y);
        ltr = part.level != 1;
        begin = ltr ? part.from : part.to - 1;
        end = ltr ? part.to : part.from - 1;
      }
      var chAround = null, boxAround = null;
      var ch = findFirst(function(ch2) {
        var box = measureCharPrepared(cm, preparedMeasure, ch2);
        box.top += widgetHeight2;
        box.bottom += widgetHeight2;
        if (!boxIsAfter(box, x, y, false)) {
          return false;
        }
        if (box.top <= y && box.left <= x) {
          chAround = ch2;
          boxAround = box;
        }
        return true;
      }, begin, end);
      var baseX, sticky, outside = false;
      if (boxAround) {
        var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
        ch = chAround + (atStart ? 0 : 1);
        sticky = atStart ? "after" : "before";
        baseX = atLeft ? boxAround.left : boxAround.right;
      } else {
        if (!ltr && (ch == end || ch == begin)) {
          ch++;
        }
        sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight2 <= y == ltr ? "after" : "before";
        var coords = cursorCoords(cm, Pos(lineNo2, ch, sticky), "line", lineObj, preparedMeasure);
        baseX = coords.left;
        outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
      }
      ch = skipExtendingChars(lineObj.text, ch, 1);
      return PosWithInfo(lineNo2, ch, sticky, outside, x - baseX);
    }
    function coordsBidiPart(cm, lineObj, lineNo2, preparedMeasure, order, x, y) {
      var index2 = findFirst(function(i2) {
        var part2 = order[i2], ltr2 = part2.level != 1;
        return boxIsAfter(cursorCoords(
          cm,
          Pos(lineNo2, ltr2 ? part2.to : part2.from, ltr2 ? "before" : "after"),
          "line",
          lineObj,
          preparedMeasure
        ), x, y, true);
      }, 0, order.length - 1);
      var part = order[index2];
      if (index2 > 0) {
        var ltr = part.level != 1;
        var start = cursorCoords(
          cm,
          Pos(lineNo2, ltr ? part.from : part.to, ltr ? "after" : "before"),
          "line",
          lineObj,
          preparedMeasure
        );
        if (boxIsAfter(start, x, y, true) && start.top > y) {
          part = order[index2 - 1];
        }
      }
      return part;
    }
    function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
      var ref2 = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
      var begin = ref2.begin;
      var end = ref2.end;
      if (/\s/.test(lineObj.text.charAt(end - 1))) {
        end--;
      }
      var part = null, closestDist = null;
      for (var i2 = 0; i2 < order.length; i2++) {
        var p = order[i2];
        if (p.from >= end || p.to <= begin) {
          continue;
        }
        var ltr = p.level != 1;
        var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
        var dist = endX < x ? x - endX + 1e9 : endX - x;
        if (!part || closestDist > dist) {
          part = p;
          closestDist = dist;
        }
      }
      if (!part) {
        part = order[order.length - 1];
      }
      if (part.from < begin) {
        part = { from: begin, to: part.to, level: part.level };
      }
      if (part.to > end) {
        part = { from: part.from, to: end, level: part.level };
      }
      return part;
    }
    var measureText;
    function textHeight(display) {
      if (display.cachedTextHeight != null) {
        return display.cachedTextHeight;
      }
      if (measureText == null) {
        measureText = elt("pre", null, "CodeMirror-line-like");
        for (var i2 = 0; i2 < 49; ++i2) {
          measureText.appendChild(document.createTextNode("x"));
          measureText.appendChild(elt("br"));
        }
        measureText.appendChild(document.createTextNode("x"));
      }
      removeChildrenAndAdd(display.measure, measureText);
      var height = measureText.offsetHeight / 50;
      if (height > 3) {
        display.cachedTextHeight = height;
      }
      removeChildren(display.measure);
      return height || 1;
    }
    function charWidth(display) {
      if (display.cachedCharWidth != null) {
        return display.cachedCharWidth;
      }
      var anchor = elt("span", "xxxxxxxxxx");
      var pre = elt("pre", [anchor], "CodeMirror-line-like");
      removeChildrenAndAdd(display.measure, pre);
      var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
      if (width > 2) {
        display.cachedCharWidth = width;
      }
      return width || 10;
    }
    function getDimensions(cm) {
      var d = cm.display, left = {}, width = {};
      var gutterLeft = d.gutters.clientLeft;
      for (var n = d.gutters.firstChild, i2 = 0; n; n = n.nextSibling, ++i2) {
        var id = cm.display.gutterSpecs[i2].className;
        left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
        width[id] = n.clientWidth;
      }
      return {
        fixedPos: compensateForHScroll(d),
        gutterTotalWidth: d.gutters.offsetWidth,
        gutterLeft: left,
        gutterWidth: width,
        wrapperWidth: d.wrapper.clientWidth
      };
    }
    function compensateForHScroll(display) {
      return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
    }
    function estimateHeight(cm) {
      var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
      var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
      return function(line) {
        if (lineIsHidden(cm.doc, line)) {
          return 0;
        }
        var widgetsHeight = 0;
        if (line.widgets) {
          for (var i2 = 0; i2 < line.widgets.length; i2++) {
            if (line.widgets[i2].height) {
              widgetsHeight += line.widgets[i2].height;
            }
          }
        }
        if (wrapping) {
          return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
        } else {
          return widgetsHeight + th;
        }
      };
    }
    function estimateLineHeights(cm) {
      var doc2 = cm.doc, est = estimateHeight(cm);
      doc2.iter(function(line) {
        var estHeight = est(line);
        if (estHeight != line.height) {
          updateLineHeight(line, estHeight);
        }
      });
    }
    function posFromMouse(cm, e, liberal, forRect) {
      var display = cm.display;
      if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") {
        return null;
      }
      var x, y, space = display.lineSpace.getBoundingClientRect();
      try {
        x = e.clientX - space.left;
        y = e.clientY - space.top;
      } catch (e$1) {
        return null;
      }
      var coords = coordsChar(cm, x, y), line;
      if (forRect && coords.xRel > 0 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
        var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
        coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
      }
      return coords;
    }
    function findViewIndex(cm, n) {
      if (n >= cm.display.viewTo) {
        return null;
      }
      n -= cm.display.viewFrom;
      if (n < 0) {
        return null;
      }
      var view2 = cm.display.view;
      for (var i2 = 0; i2 < view2.length; i2++) {
        n -= view2[i2].size;
        if (n < 0) {
          return i2;
        }
      }
    }
    function regChange(cm, from, to, lendiff) {
      if (from == null) {
        from = cm.doc.first;
      }
      if (to == null) {
        to = cm.doc.first + cm.doc.size;
      }
      if (!lendiff) {
        lendiff = 0;
      }
      var display = cm.display;
      if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) {
        display.updateLineNumbers = from;
      }
      cm.curOp.viewChanged = true;
      if (from >= display.viewTo) {
        if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) {
          resetView(cm);
        }
      } else if (to <= display.viewFrom) {
        if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) {
          resetView(cm);
        } else {
          display.viewFrom += lendiff;
          display.viewTo += lendiff;
        }
      } else if (from <= display.viewFrom && to >= display.viewTo) {
        resetView(cm);
      } else if (from <= display.viewFrom) {
        var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
        if (cut) {
          display.view = display.view.slice(cut.index);
          display.viewFrom = cut.lineN;
          display.viewTo += lendiff;
        } else {
          resetView(cm);
        }
      } else if (to >= display.viewTo) {
        var cut$1 = viewCuttingPoint(cm, from, from, -1);
        if (cut$1) {
          display.view = display.view.slice(0, cut$1.index);
          display.viewTo = cut$1.lineN;
        } else {
          resetView(cm);
        }
      } else {
        var cutTop = viewCuttingPoint(cm, from, from, -1);
        var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
        if (cutTop && cutBot) {
          display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
          display.viewTo += lendiff;
        } else {
          resetView(cm);
        }
      }
      var ext = display.externalMeasured;
      if (ext) {
        if (to < ext.lineN) {
          ext.lineN += lendiff;
        } else if (from < ext.lineN + ext.size) {
          display.externalMeasured = null;
        }
      }
    }
    function regLineChange(cm, line, type) {
      cm.curOp.viewChanged = true;
      var display = cm.display, ext = cm.display.externalMeasured;
      if (ext && line >= ext.lineN && line < ext.lineN + ext.size) {
        display.externalMeasured = null;
      }
      if (line < display.viewFrom || line >= display.viewTo) {
        return;
      }
      var lineView = display.view[findViewIndex(cm, line)];
      if (lineView.node == null) {
        return;
      }
      var arr = lineView.changes || (lineView.changes = []);
      if (indexOf(arr, type) == -1) {
        arr.push(type);
      }
    }
    function resetView(cm) {
      cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
      cm.display.view = [];
      cm.display.viewOffset = 0;
    }
    function viewCuttingPoint(cm, oldN, newN, dir) {
      var index2 = findViewIndex(cm, oldN), diff, view2 = cm.display.view;
      if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) {
        return { index: index2, lineN: newN };
      }
      var n = cm.display.viewFrom;
      for (var i2 = 0; i2 < index2; i2++) {
        n += view2[i2].size;
      }
      if (n != oldN) {
        if (dir > 0) {
          if (index2 == view2.length - 1) {
            return null;
          }
          diff = n + view2[index2].size - oldN;
          index2++;
        } else {
          diff = n - oldN;
        }
        oldN += diff;
        newN += diff;
      }
      while (visualLineNo(cm.doc, newN) != newN) {
        if (index2 == (dir < 0 ? 0 : view2.length - 1)) {
          return null;
        }
        newN += dir * view2[index2 - (dir < 0 ? 1 : 0)].size;
        index2 += dir;
      }
      return { index: index2, lineN: newN };
    }
    function adjustView(cm, from, to) {
      var display = cm.display, view2 = display.view;
      if (view2.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
        display.view = buildViewArray(cm, from, to);
        display.viewFrom = from;
      } else {
        if (display.viewFrom > from) {
          display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
        } else if (display.viewFrom < from) {
          display.view = display.view.slice(findViewIndex(cm, from));
        }
        display.viewFrom = from;
        if (display.viewTo < to) {
          display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
        } else if (display.viewTo > to) {
          display.view = display.view.slice(0, findViewIndex(cm, to));
        }
      }
      display.viewTo = to;
    }
    function countDirtyView(cm) {
      var view2 = cm.display.view, dirty = 0;
      for (var i2 = 0; i2 < view2.length; i2++) {
        var lineView = view2[i2];
        if (!lineView.hidden && (!lineView.node || lineView.changes)) {
          ++dirty;
        }
      }
      return dirty;
    }
    function updateSelection(cm) {
      cm.display.input.showSelection(cm.display.input.prepareSelection());
    }
    function prepareSelection(cm, primary) {
      if (primary === void 0)
        primary = true;
      var doc2 = cm.doc, result = {};
      var curFragment = result.cursors = document.createDocumentFragment();
      var selFragment = result.selection = document.createDocumentFragment();
      var customCursor = cm.options.$customCursor;
      if (customCursor) {
        primary = true;
      }
      for (var i2 = 0; i2 < doc2.sel.ranges.length; i2++) {
        if (!primary && i2 == doc2.sel.primIndex) {
          continue;
        }
        var range2 = doc2.sel.ranges[i2];
        if (range2.from().line >= cm.display.viewTo || range2.to().line < cm.display.viewFrom) {
          continue;
        }
        var collapsed = range2.empty();
        if (customCursor) {
          var head = customCursor(cm, range2);
          if (head) {
            drawSelectionCursor(cm, head, curFragment);
          }
        } else if (collapsed || cm.options.showCursorWhenSelecting) {
          drawSelectionCursor(cm, range2.head, curFragment);
        }
        if (!collapsed) {
          drawSelectionRange(cm, range2, selFragment);
        }
      }
      return result;
    }
    function drawSelectionCursor(cm, head, output) {
      var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
      var cursor = output.appendChild(elt("div", "\xA0", "CodeMirror-cursor"));
      cursor.style.left = pos.left + "px";
      cursor.style.top = pos.top + "px";
      cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
      if (/\bcm-fat-cursor\b/.test(cm.getWrapperElement().className)) {
        var charPos = charCoords(cm, head, "div", null, null);
        var width = charPos.right - charPos.left;
        cursor.style.width = (width > 0 ? width : cm.defaultCharWidth()) + "px";
      }
      if (pos.other) {
        var otherCursor = output.appendChild(elt("div", "\xA0", "CodeMirror-cursor CodeMirror-secondarycursor"));
        otherCursor.style.display = "";
        otherCursor.style.left = pos.other.left + "px";
        otherCursor.style.top = pos.other.top + "px";
        otherCursor.style.height = (pos.other.bottom - pos.other.top) * 0.85 + "px";
      }
    }
    function cmpCoords(a, b) {
      return a.top - b.top || a.left - b.left;
    }
    function drawSelectionRange(cm, range2, output) {
      var display = cm.display, doc2 = cm.doc;
      var fragment = document.createDocumentFragment();
      var padding = paddingH(cm.display), leftSide = padding.left;
      var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
      var docLTR = doc2.direction == "ltr";
      function add(left, top, width, bottom) {
        if (top < 0) {
          top = 0;
        }
        top = Math.round(top);
        bottom = Math.round(bottom);
        fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
      }
      function drawForLine(line, fromArg, toArg) {
        var lineObj = getLine(doc2, line);
        var lineLen = lineObj.text.length;
        var start, end;
        function coords(ch, bias) {
          return charCoords(cm, Pos(line, ch), "div", lineObj, bias);
        }
        function wrapX(pos, dir, side) {
          var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
          var prop2 = dir == "ltr" == (side == "after") ? "left" : "right";
          var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
          return coords(ch, prop2)[prop2];
        }
        var order = getOrder(lineObj, doc2.direction);
        iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function(from, to, dir, i2) {
          var ltr = dir == "ltr";
          var fromPos = coords(from, ltr ? "left" : "right");
          var toPos = coords(to - 1, ltr ? "right" : "left");
          var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
          var first = i2 == 0, last = !order || i2 == order.length - 1;
          if (toPos.top - fromPos.top <= 3) {
            var openLeft = (docLTR ? openStart : openEnd) && first;
            var openRight = (docLTR ? openEnd : openStart) && last;
            var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
            var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
            add(left, fromPos.top, right - left, fromPos.bottom);
          } else {
            var topLeft, topRight, botLeft, botRight;
            if (ltr) {
              topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
              topRight = docLTR ? rightSide : wrapX(from, dir, "before");
              botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
              botRight = docLTR && openEnd && last ? rightSide : toPos.right;
            } else {
              topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
              topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
              botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
              botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
            }
            add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
            if (fromPos.bottom < toPos.top) {
              add(leftSide, fromPos.bottom, null, toPos.top);
            }
            add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
          }
          if (!start || cmpCoords(fromPos, start) < 0) {
            start = fromPos;
          }
          if (cmpCoords(toPos, start) < 0) {
            start = toPos;
          }
          if (!end || cmpCoords(fromPos, end) < 0) {
            end = fromPos;
          }
          if (cmpCoords(toPos, end) < 0) {
            end = toPos;
          }
        });
        return { start, end };
      }
      var sFrom = range2.from(), sTo = range2.to();
      if (sFrom.line == sTo.line) {
        drawForLine(sFrom.line, sFrom.ch, sTo.ch);
      } else {
        var fromLine = getLine(doc2, sFrom.line), toLine = getLine(doc2, sTo.line);
        var singleVLine = visualLine(fromLine) == visualLine(toLine);
        var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
        var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
        if (singleVLine) {
          if (leftEnd.top < rightStart.top - 2) {
            add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
            add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
          } else {
            add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
          }
        }
        if (leftEnd.bottom < rightStart.top) {
          add(leftSide, leftEnd.bottom, null, rightStart.top);
        }
      }
      output.appendChild(fragment);
    }
    function restartBlink(cm) {
      if (!cm.state.focused) {
        return;
      }
      var display = cm.display;
      clearInterval(display.blinker);
      var on3 = true;
      display.cursorDiv.style.visibility = "";
      if (cm.options.cursorBlinkRate > 0) {
        display.blinker = setInterval(function() {
          if (!cm.hasFocus()) {
            onBlur(cm);
          }
          display.cursorDiv.style.visibility = (on3 = !on3) ? "" : "hidden";
        }, cm.options.cursorBlinkRate);
      } else if (cm.options.cursorBlinkRate < 0) {
        display.cursorDiv.style.visibility = "hidden";
      }
    }
    function ensureFocus(cm) {
      if (!cm.hasFocus()) {
        cm.display.input.focus();
        if (!cm.state.focused) {
          onFocus(cm);
        }
      }
    }
    function delayBlurEvent(cm) {
      cm.state.delayingBlurEvent = true;
      setTimeout(function() {
        if (cm.state.delayingBlurEvent) {
          cm.state.delayingBlurEvent = false;
          if (cm.state.focused) {
            onBlur(cm);
          }
        }
      }, 100);
    }
    function onFocus(cm, e) {
      if (cm.state.delayingBlurEvent && !cm.state.draggingText) {
        cm.state.delayingBlurEvent = false;
      }
      if (cm.options.readOnly == "nocursor") {
        return;
      }
      if (!cm.state.focused) {
        signal(cm, "focus", cm, e);
        cm.state.focused = true;
        addClass2(cm.display.wrapper, "CodeMirror-focused");
        if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
          cm.display.input.reset();
          if (webkit) {
            setTimeout(function() {
              return cm.display.input.reset(true);
            }, 20);
          }
        }
        cm.display.input.receivedFocus();
      }
      restartBlink(cm);
    }
    function onBlur(cm, e) {
      if (cm.state.delayingBlurEvent) {
        return;
      }
      if (cm.state.focused) {
        signal(cm, "blur", cm, e);
        cm.state.focused = false;
        rmClass(cm.display.wrapper, "CodeMirror-focused");
      }
      clearInterval(cm.display.blinker);
      setTimeout(function() {
        if (!cm.state.focused) {
          cm.display.shift = false;
        }
      }, 150);
    }
    function updateHeightsInViewport(cm) {
      var display = cm.display;
      var prevBottom = display.lineDiv.offsetTop;
      var viewTop = Math.max(0, display.scroller.getBoundingClientRect().top);
      var oldHeight = display.lineDiv.getBoundingClientRect().top;
      var mustScroll = 0;
      for (var i2 = 0; i2 < display.view.length; i2++) {
        var cur = display.view[i2], wrapping = cm.options.lineWrapping;
        var height = void 0, width = 0;
        if (cur.hidden) {
          continue;
        }
        oldHeight += cur.line.height;
        if (ie && ie_version < 8) {
          var bot = cur.node.offsetTop + cur.node.offsetHeight;
          height = bot - prevBottom;
          prevBottom = bot;
        } else {
          var box = cur.node.getBoundingClientRect();
          height = box.bottom - box.top;
          if (!wrapping && cur.text.firstChild) {
            width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
          }
        }
        var diff = cur.line.height - height;
        if (diff > 5e-3 || diff < -5e-3) {
          if (oldHeight < viewTop) {
            mustScroll -= diff;
          }
          updateLineHeight(cur.line, height);
          updateWidgetHeight(cur.line);
          if (cur.rest) {
            for (var j = 0; j < cur.rest.length; j++) {
              updateWidgetHeight(cur.rest[j]);
            }
          }
        }
        if (width > cm.display.sizerWidth) {
          var chWidth = Math.ceil(width / charWidth(cm.display));
          if (chWidth > cm.display.maxLineLength) {
            cm.display.maxLineLength = chWidth;
            cm.display.maxLine = cur.line;
            cm.display.maxLineChanged = true;
          }
        }
      }
      if (Math.abs(mustScroll) > 2) {
        display.scroller.scrollTop += mustScroll;
      }
    }
    function updateWidgetHeight(line) {
      if (line.widgets) {
        for (var i2 = 0; i2 < line.widgets.length; ++i2) {
          var w = line.widgets[i2], parent = w.node.parentNode;
          if (parent) {
            w.height = parent.offsetHeight;
          }
        }
      }
    }
    function visibleLines(display, doc2, viewport) {
      var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
      top = Math.floor(top - paddingTop(display));
      var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
      var from = lineAtHeight(doc2, top), to = lineAtHeight(doc2, bottom);
      if (viewport && viewport.ensure) {
        var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
        if (ensureFrom < from) {
          from = ensureFrom;
          to = lineAtHeight(doc2, heightAtLine(getLine(doc2, ensureFrom)) + display.wrapper.clientHeight);
        } else if (Math.min(ensureTo, doc2.lastLine()) >= to) {
          from = lineAtHeight(doc2, heightAtLine(getLine(doc2, ensureTo)) - display.wrapper.clientHeight);
          to = ensureTo;
        }
      }
      return { from, to: Math.max(to, from + 1) };
    }
    function maybeScrollWindow(cm, rect) {
      if (signalDOMEvent(cm, "scrollCursorIntoView")) {
        return;
      }
      var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
      var doc2 = display.wrapper.ownerDocument;
      if (rect.top + box.top < 0) {
        doScroll = true;
      } else if (rect.bottom + box.top > (doc2.defaultView.innerHeight || doc2.documentElement.clientHeight)) {
        doScroll = false;
      }
      if (doScroll != null && !phantom) {
        var scrollNode = elt("div", "\u200B", null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
        cm.display.lineSpace.appendChild(scrollNode);
        scrollNode.scrollIntoView(doScroll);
        cm.display.lineSpace.removeChild(scrollNode);
      }
    }
    function scrollPosIntoView(cm, pos, end, margin) {
      if (margin == null) {
        margin = 0;
      }
      var rect;
      if (!cm.options.lineWrapping && pos == end) {
        end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
        pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
      }
      for (var limit = 0; limit < 5; limit++) {
        var changed = false;
        var coords = cursorCoords(cm, pos);
        var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
        rect = {
          left: Math.min(coords.left, endCoords.left),
          top: Math.min(coords.top, endCoords.top) - margin,
          right: Math.max(coords.left, endCoords.left),
          bottom: Math.max(coords.bottom, endCoords.bottom) + margin
        };
        var scrollPos = calculateScrollPos(cm, rect);
        var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
        if (scrollPos.scrollTop != null) {
          updateScrollTop(cm, scrollPos.scrollTop);
          if (Math.abs(cm.doc.scrollTop - startTop) > 1) {
            changed = true;
          }
        }
        if (scrollPos.scrollLeft != null) {
          setScrollLeft(cm, scrollPos.scrollLeft);
          if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) {
            changed = true;
          }
        }
        if (!changed) {
          break;
        }
      }
      return rect;
    }
    function scrollIntoView(cm, rect) {
      var scrollPos = calculateScrollPos(cm, rect);
      if (scrollPos.scrollTop != null) {
        updateScrollTop(cm, scrollPos.scrollTop);
      }
      if (scrollPos.scrollLeft != null) {
        setScrollLeft(cm, scrollPos.scrollLeft);
      }
    }
    function calculateScrollPos(cm, rect) {
      var display = cm.display, snapMargin = textHeight(cm.display);
      if (rect.top < 0) {
        rect.top = 0;
      }
      var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
      var screen2 = displayHeight(cm), result = {};
      if (rect.bottom - rect.top > screen2) {
        rect.bottom = rect.top + screen2;
      }
      var docBottom = cm.doc.height + paddingVert(display);
      var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
      if (rect.top < screentop) {
        result.scrollTop = atTop ? 0 : rect.top;
      } else if (rect.bottom > screentop + screen2) {
        var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen2);
        if (newTop != screentop) {
          result.scrollTop = newTop;
        }
      }
      var gutterSpace = cm.options.fixedGutter ? 0 : display.gutters.offsetWidth;
      var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft - gutterSpace;
      var screenw = displayWidth(cm) - display.gutters.offsetWidth;
      var tooWide = rect.right - rect.left > screenw;
      if (tooWide) {
        rect.right = rect.left + screenw;
      }
      if (rect.left < 10) {
        result.scrollLeft = 0;
      } else if (rect.left < screenleft) {
        result.scrollLeft = Math.max(0, rect.left + gutterSpace - (tooWide ? 0 : 10));
      } else if (rect.right > screenw + screenleft - 3) {
        result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
      }
      return result;
    }
    function addToScrollTop(cm, top) {
      if (top == null) {
        return;
      }
      resolveScrollToPos(cm);
      cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
    }
    function ensureCursorVisible(cm) {
      resolveScrollToPos(cm);
      var cur = cm.getCursor();
      cm.curOp.scrollToPos = { from: cur, to: cur, margin: cm.options.cursorScrollMargin };
    }
    function scrollToCoords(cm, x, y) {
      if (x != null || y != null) {
        resolveScrollToPos(cm);
      }
      if (x != null) {
        cm.curOp.scrollLeft = x;
      }
      if (y != null) {
        cm.curOp.scrollTop = y;
      }
    }
    function scrollToRange(cm, range2) {
      resolveScrollToPos(cm);
      cm.curOp.scrollToPos = range2;
    }
    function resolveScrollToPos(cm) {
      var range2 = cm.curOp.scrollToPos;
      if (range2) {
        cm.curOp.scrollToPos = null;
        var from = estimateCoords(cm, range2.from), to = estimateCoords(cm, range2.to);
        scrollToCoordsRange(cm, from, to, range2.margin);
      }
    }
    function scrollToCoordsRange(cm, from, to, margin) {
      var sPos = calculateScrollPos(cm, {
        left: Math.min(from.left, to.left),
        top: Math.min(from.top, to.top) - margin,
        right: Math.max(from.right, to.right),
        bottom: Math.max(from.bottom, to.bottom) + margin
      });
      scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
    }
    function updateScrollTop(cm, val) {
      if (Math.abs(cm.doc.scrollTop - val) < 2) {
        return;
      }
      if (!gecko) {
        updateDisplaySimple(cm, { top: val });
      }
      setScrollTop(cm, val, true);
      if (gecko) {
        updateDisplaySimple(cm);
      }
      startWorker(cm, 100);
    }
    function setScrollTop(cm, val, forceScroll) {
      val = Math.max(0, Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val));
      if (cm.display.scroller.scrollTop == val && !forceScroll) {
        return;
      }
      cm.doc.scrollTop = val;
      cm.display.scrollbars.setScrollTop(val);
      if (cm.display.scroller.scrollTop != val) {
        cm.display.scroller.scrollTop = val;
      }
    }
    function setScrollLeft(cm, val, isScroller, forceScroll) {
      val = Math.max(0, Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth));
      if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) {
        return;
      }
      cm.doc.scrollLeft = val;
      alignHorizontally(cm);
      if (cm.display.scroller.scrollLeft != val) {
        cm.display.scroller.scrollLeft = val;
      }
      cm.display.scrollbars.setScrollLeft(val);
    }
    function measureForScrollbars(cm) {
      var d = cm.display, gutterW = d.gutters.offsetWidth;
      var docH = Math.round(cm.doc.height + paddingVert(cm.display));
      return {
        clientHeight: d.scroller.clientHeight,
        viewHeight: d.wrapper.clientHeight,
        scrollWidth: d.scroller.scrollWidth,
        clientWidth: d.scroller.clientWidth,
        viewWidth: d.wrapper.clientWidth,
        barLeft: cm.options.fixedGutter ? gutterW : 0,
        docHeight: docH,
        scrollHeight: docH + scrollGap(cm) + d.barHeight,
        nativeBarWidth: d.nativeBarWidth,
        gutterWidth: gutterW
      };
    }
    var NativeScrollbars = function(place, scroll, cm) {
      this.cm = cm;
      var vert = this.vert = elt("div", [elt("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar");
      var horiz = this.horiz = elt("div", [elt("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
      vert.tabIndex = horiz.tabIndex = -1;
      place(vert);
      place(horiz);
      on2(vert, "scroll", function() {
        if (vert.clientHeight) {
          scroll(vert.scrollTop, "vertical");
        }
      });
      on2(horiz, "scroll", function() {
        if (horiz.clientWidth) {
          scroll(horiz.scrollLeft, "horizontal");
        }
      });
      this.checkedZeroWidth = false;
      if (ie && ie_version < 8) {
        this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
      }
    };
    NativeScrollbars.prototype.update = function(measure) {
      var needsH = measure.scrollWidth > measure.clientWidth + 1;
      var needsV = measure.scrollHeight > measure.clientHeight + 1;
      var sWidth = measure.nativeBarWidth;
      if (needsV) {
        this.vert.style.display = "block";
        this.vert.style.bottom = needsH ? sWidth + "px" : "0";
        var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
        this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
      } else {
        this.vert.scrollTop = 0;
        this.vert.style.display = "";
        this.vert.firstChild.style.height = "0";
      }
      if (needsH) {
        this.horiz.style.display = "block";
        this.horiz.style.right = needsV ? sWidth + "px" : "0";
        this.horiz.style.left = measure.barLeft + "px";
        var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
        this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
      } else {
        this.horiz.style.display = "";
        this.horiz.firstChild.style.width = "0";
      }
      if (!this.checkedZeroWidth && measure.clientHeight > 0) {
        if (sWidth == 0) {
          this.zeroWidthHack();
        }
        this.checkedZeroWidth = true;
      }
      return { right: needsV ? sWidth : 0, bottom: needsH ? sWidth : 0 };
    };
    NativeScrollbars.prototype.setScrollLeft = function(pos) {
      if (this.horiz.scrollLeft != pos) {
        this.horiz.scrollLeft = pos;
      }
      if (this.disableHoriz) {
        this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
      }
    };
    NativeScrollbars.prototype.setScrollTop = function(pos) {
      if (this.vert.scrollTop != pos) {
        this.vert.scrollTop = pos;
      }
      if (this.disableVert) {
        this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
      }
    };
    NativeScrollbars.prototype.zeroWidthHack = function() {
      var w = mac && !mac_geMountainLion ? "12px" : "18px";
      this.horiz.style.height = this.vert.style.width = w;
      this.horiz.style.visibility = this.vert.style.visibility = "hidden";
      this.disableHoriz = new Delayed();
      this.disableVert = new Delayed();
    };
    NativeScrollbars.prototype.enableZeroWidthBar = function(bar, delay, type) {
      bar.style.visibility = "";
      function maybeDisable() {
        var box = bar.getBoundingClientRect();
        var elt2 = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
        if (elt2 != bar) {
          bar.style.visibility = "hidden";
        } else {
          delay.set(1e3, maybeDisable);
        }
      }
      delay.set(1e3, maybeDisable);
    };
    NativeScrollbars.prototype.clear = function() {
      var parent = this.horiz.parentNode;
      parent.removeChild(this.horiz);
      parent.removeChild(this.vert);
    };
    var NullScrollbars = function() {
    };
    NullScrollbars.prototype.update = function() {
      return { bottom: 0, right: 0 };
    };
    NullScrollbars.prototype.setScrollLeft = function() {
    };
    NullScrollbars.prototype.setScrollTop = function() {
    };
    NullScrollbars.prototype.clear = function() {
    };
    function updateScrollbars(cm, measure) {
      if (!measure) {
        measure = measureForScrollbars(cm);
      }
      var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
      updateScrollbarsInner(cm, measure);
      for (var i2 = 0; i2 < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i2++) {
        if (startWidth != cm.display.barWidth && cm.options.lineWrapping) {
          updateHeightsInViewport(cm);
        }
        updateScrollbarsInner(cm, measureForScrollbars(cm));
        startWidth = cm.display.barWidth;
        startHeight = cm.display.barHeight;
      }
    }
    function updateScrollbarsInner(cm, measure) {
      var d = cm.display;
      var sizes = d.scrollbars.update(measure);
      d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
      d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
      d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
      if (sizes.right && sizes.bottom) {
        d.scrollbarFiller.style.display = "block";
        d.scrollbarFiller.style.height = sizes.bottom + "px";
        d.scrollbarFiller.style.width = sizes.right + "px";
      } else {
        d.scrollbarFiller.style.display = "";
      }
      if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
        d.gutterFiller.style.display = "block";
        d.gutterFiller.style.height = sizes.bottom + "px";
        d.gutterFiller.style.width = measure.gutterWidth + "px";
      } else {
        d.gutterFiller.style.display = "";
      }
    }
    var scrollbarModel = { "native": NativeScrollbars, "null": NullScrollbars };
    function initScrollbars(cm) {
      if (cm.display.scrollbars) {
        cm.display.scrollbars.clear();
        if (cm.display.scrollbars.addClass) {
          rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
        }
      }
      cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function(node) {
        cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
        on2(node, "mousedown", function() {
          if (cm.state.focused) {
            setTimeout(function() {
              return cm.display.input.focus();
            }, 0);
          }
        });
        node.setAttribute("cm-not-content", "true");
      }, function(pos, axis) {
        if (axis == "horizontal") {
          setScrollLeft(cm, pos);
        } else {
          updateScrollTop(cm, pos);
        }
      }, cm);
      if (cm.display.scrollbars.addClass) {
        addClass2(cm.display.wrapper, cm.display.scrollbars.addClass);
      }
    }
    var nextOpId = 0;
    function startOperation(cm) {
      cm.curOp = {
        cm,
        viewChanged: false,
        startHeight: cm.doc.height,
        forceUpdate: false,
        updateInput: 0,
        typing: false,
        changeObjs: null,
        cursorActivityHandlers: null,
        cursorActivityCalled: 0,
        selectionChanged: false,
        updateMaxLine: false,
        scrollLeft: null,
        scrollTop: null,
        scrollToPos: null,
        focus: false,
        id: ++nextOpId,
        markArrays: null
      };
      pushOperation(cm.curOp);
    }
    function endOperation(cm) {
      var op = cm.curOp;
      if (op) {
        finishOperation(op, function(group) {
          for (var i2 = 0; i2 < group.ops.length; i2++) {
            group.ops[i2].cm.curOp = null;
          }
          endOperations(group);
        });
      }
    }
    function endOperations(group) {
      var ops = group.ops;
      for (var i2 = 0; i2 < ops.length; i2++) {
        endOperation_R1(ops[i2]);
      }
      for (var i$12 = 0; i$12 < ops.length; i$12++) {
        endOperation_W1(ops[i$12]);
      }
      for (var i$22 = 0; i$22 < ops.length; i$22++) {
        endOperation_R2(ops[i$22]);
      }
      for (var i$3 = 0; i$3 < ops.length; i$3++) {
        endOperation_W2(ops[i$3]);
      }
      for (var i$4 = 0; i$4 < ops.length; i$4++) {
        endOperation_finish(ops[i$4]);
      }
    }
    function endOperation_R1(op) {
      var cm = op.cm, display = cm.display;
      maybeClipScrollbars(cm);
      if (op.updateMaxLine) {
        findMaxLine(cm);
      }
      op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
      op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && { top: op.scrollTop, ensure: op.scrollToPos }, op.forceUpdate);
    }
    function endOperation_W1(op) {
      op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
    }
    function endOperation_R2(op) {
      var cm = op.cm, display = cm.display;
      if (op.updatedDisplay) {
        updateHeightsInViewport(cm);
      }
      op.barMeasure = measureForScrollbars(cm);
      if (display.maxLineChanged && !cm.options.lineWrapping) {
        op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
        cm.display.sizerWidth = op.adjustWidthTo;
        op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
        op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
      }
      if (op.updatedDisplay || op.selectionChanged) {
        op.preparedSelection = display.input.prepareSelection();
      }
    }
    function endOperation_W2(op) {
      var cm = op.cm;
      if (op.adjustWidthTo != null) {
        cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
        if (op.maxScrollLeft < cm.doc.scrollLeft) {
          setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
        }
        cm.display.maxLineChanged = false;
      }
      var takeFocus = op.focus && op.focus == activeElt(root(cm));
      if (op.preparedSelection) {
        cm.display.input.showSelection(op.preparedSelection, takeFocus);
      }
      if (op.updatedDisplay || op.startHeight != cm.doc.height) {
        updateScrollbars(cm, op.barMeasure);
      }
      if (op.updatedDisplay) {
        setDocumentHeight(cm, op.barMeasure);
      }
      if (op.selectionChanged) {
        restartBlink(cm);
      }
      if (cm.state.focused && op.updateInput) {
        cm.display.input.reset(op.typing);
      }
      if (takeFocus) {
        ensureFocus(op.cm);
      }
    }
    function endOperation_finish(op) {
      var cm = op.cm, display = cm.display, doc2 = cm.doc;
      if (op.updatedDisplay) {
        postUpdateDisplay(cm, op.update);
      }
      if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) {
        display.wheelStartX = display.wheelStartY = null;
      }
      if (op.scrollTop != null) {
        setScrollTop(cm, op.scrollTop, op.forceScroll);
      }
      if (op.scrollLeft != null) {
        setScrollLeft(cm, op.scrollLeft, true, true);
      }
      if (op.scrollToPos) {
        var rect = scrollPosIntoView(
          cm,
          clipPos(doc2, op.scrollToPos.from),
          clipPos(doc2, op.scrollToPos.to),
          op.scrollToPos.margin
        );
        maybeScrollWindow(cm, rect);
      }
      var hidden2 = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
      if (hidden2) {
        for (var i2 = 0; i2 < hidden2.length; ++i2) {
          if (!hidden2[i2].lines.length) {
            signal(hidden2[i2], "hide");
          }
        }
      }
      if (unhidden) {
        for (var i$12 = 0; i$12 < unhidden.length; ++i$12) {
          if (unhidden[i$12].lines.length) {
            signal(unhidden[i$12], "unhide");
          }
        }
      }
      if (display.wrapper.offsetHeight) {
        doc2.scrollTop = cm.display.scroller.scrollTop;
      }
      if (op.changeObjs) {
        signal(cm, "changes", cm, op.changeObjs);
      }
      if (op.update) {
        op.update.finish();
      }
    }
    function runInOp(cm, f) {
      if (cm.curOp) {
        return f();
      }
      startOperation(cm);
      try {
        return f();
      } finally {
        endOperation(cm);
      }
    }
    function operation(cm, f) {
      return function() {
        if (cm.curOp) {
          return f.apply(cm, arguments);
        }
        startOperation(cm);
        try {
          return f.apply(cm, arguments);
        } finally {
          endOperation(cm);
        }
      };
    }
    function methodOp(f) {
      return function() {
        if (this.curOp) {
          return f.apply(this, arguments);
        }
        startOperation(this);
        try {
          return f.apply(this, arguments);
        } finally {
          endOperation(this);
        }
      };
    }
    function docMethodOp(f) {
      return function() {
        var cm = this.cm;
        if (!cm || cm.curOp) {
          return f.apply(this, arguments);
        }
        startOperation(cm);
        try {
          return f.apply(this, arguments);
        } finally {
          endOperation(cm);
        }
      };
    }
    function startWorker(cm, time) {
      if (cm.doc.highlightFrontier < cm.display.viewTo) {
        cm.state.highlight.set(time, bind4(highlightWorker, cm));
      }
    }
    function highlightWorker(cm) {
      var doc2 = cm.doc;
      if (doc2.highlightFrontier >= cm.display.viewTo) {
        return;
      }
      var end = +new Date() + cm.options.workTime;
      var context = getContextBefore(cm, doc2.highlightFrontier);
      var changedLines = [];
      doc2.iter(context.line, Math.min(doc2.first + doc2.size, cm.display.viewTo + 500), function(line) {
        if (context.line >= cm.display.viewFrom) {
          var oldStyles = line.styles;
          var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc2.mode, context.state) : null;
          var highlighted = highlightLine(cm, line, context, true);
          if (resetState) {
            context.state = resetState;
          }
          line.styles = highlighted.styles;
          var oldCls = line.styleClasses, newCls = highlighted.classes;
          if (newCls) {
            line.styleClasses = newCls;
          } else if (oldCls) {
            line.styleClasses = null;
          }
          var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
          for (var i2 = 0; !ischange && i2 < oldStyles.length; ++i2) {
            ischange = oldStyles[i2] != line.styles[i2];
          }
          if (ischange) {
            changedLines.push(context.line);
          }
          line.stateAfter = context.save();
          context.nextLine();
        } else {
          if (line.text.length <= cm.options.maxHighlightLength) {
            processLine(cm, line.text, context);
          }
          line.stateAfter = context.line % 5 == 0 ? context.save() : null;
          context.nextLine();
        }
        if (+new Date() > end) {
          startWorker(cm, cm.options.workDelay);
          return true;
        }
      });
      doc2.highlightFrontier = context.line;
      doc2.modeFrontier = Math.max(doc2.modeFrontier, context.line);
      if (changedLines.length) {
        runInOp(cm, function() {
          for (var i2 = 0; i2 < changedLines.length; i2++) {
            regLineChange(cm, changedLines[i2], "text");
          }
        });
      }
    }
    var DisplayUpdate = function(cm, viewport, force) {
      var display = cm.display;
      this.viewport = viewport;
      this.visible = visibleLines(display, cm.doc, viewport);
      this.editorIsHidden = !display.wrapper.offsetWidth;
      this.wrapperHeight = display.wrapper.clientHeight;
      this.wrapperWidth = display.wrapper.clientWidth;
      this.oldDisplayWidth = displayWidth(cm);
      this.force = force;
      this.dims = getDimensions(cm);
      this.events = [];
    };
    DisplayUpdate.prototype.signal = function(emitter, type) {
      if (hasHandler(emitter, type)) {
        this.events.push(arguments);
      }
    };
    DisplayUpdate.prototype.finish = function() {
      for (var i2 = 0; i2 < this.events.length; i2++) {
        signal.apply(null, this.events[i2]);
      }
    };
    function maybeClipScrollbars(cm) {
      var display = cm.display;
      if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
        display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
        display.heightForcer.style.height = scrollGap(cm) + "px";
        display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
        display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
        display.scrollbarsClipped = true;
      }
    }
    function selectionSnapshot(cm) {
      if (cm.hasFocus()) {
        return null;
      }
      var active = activeElt(root(cm));
      if (!active || !contains(cm.display.lineDiv, active)) {
        return null;
      }
      var result = { activeElt: active };
      if (window.getSelection) {
        var sel = win(cm).getSelection();
        if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
          result.anchorNode = sel.anchorNode;
          result.anchorOffset = sel.anchorOffset;
          result.focusNode = sel.focusNode;
          result.focusOffset = sel.focusOffset;
        }
      }
      return result;
    }
    function restoreSelection(snapshot) {
      if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt(rootNode(snapshot.activeElt))) {
        return;
      }
      snapshot.activeElt.focus();
      if (!/^(INPUT|TEXTAREA)$/.test(snapshot.activeElt.nodeName) && snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
        var doc2 = snapshot.activeElt.ownerDocument;
        var sel = doc2.defaultView.getSelection(), range2 = doc2.createRange();
        range2.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
        range2.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range2);
        sel.extend(snapshot.focusNode, snapshot.focusOffset);
      }
    }
    function updateDisplayIfNeeded(cm, update2) {
      var display = cm.display, doc2 = cm.doc;
      if (update2.editorIsHidden) {
        resetView(cm);
        return false;
      }
      if (!update2.force && update2.visible.from >= display.viewFrom && update2.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) {
        return false;
      }
      if (maybeUpdateLineNumberWidth(cm)) {
        resetView(cm);
        update2.dims = getDimensions(cm);
      }
      var end = doc2.first + doc2.size;
      var from = Math.max(update2.visible.from - cm.options.viewportMargin, doc2.first);
      var to = Math.min(end, update2.visible.to + cm.options.viewportMargin);
      if (display.viewFrom < from && from - display.viewFrom < 20) {
        from = Math.max(doc2.first, display.viewFrom);
      }
      if (display.viewTo > to && display.viewTo - to < 20) {
        to = Math.min(end, display.viewTo);
      }
      if (sawCollapsedSpans) {
        from = visualLineNo(cm.doc, from);
        to = visualLineEndNo(cm.doc, to);
      }
      var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update2.wrapperHeight || display.lastWrapWidth != update2.wrapperWidth;
      adjustView(cm, from, to);
      display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
      cm.display.mover.style.top = display.viewOffset + "px";
      var toUpdate = countDirtyView(cm);
      if (!different && toUpdate == 0 && !update2.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) {
        return false;
      }
      var selSnapshot = selectionSnapshot(cm);
      if (toUpdate > 4) {
        display.lineDiv.style.display = "none";
      }
      patchDisplay(cm, display.updateLineNumbers, update2.dims);
      if (toUpdate > 4) {
        display.lineDiv.style.display = "";
      }
      display.renderedView = display.view;
      restoreSelection(selSnapshot);
      removeChildren(display.cursorDiv);
      removeChildren(display.selectionDiv);
      display.gutters.style.height = display.sizer.style.minHeight = 0;
      if (different) {
        display.lastWrapHeight = update2.wrapperHeight;
        display.lastWrapWidth = update2.wrapperWidth;
        startWorker(cm, 400);
      }
      display.updateLineNumbers = null;
      return true;
    }
    function postUpdateDisplay(cm, update2) {
      var viewport = update2.viewport;
      for (var first = true; ; first = false) {
        if (!first || !cm.options.lineWrapping || update2.oldDisplayWidth == displayWidth(cm)) {
          if (viewport && viewport.top != null) {
            viewport = { top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top) };
          }
          update2.visible = visibleLines(cm.display, cm.doc, viewport);
          if (update2.visible.from >= cm.display.viewFrom && update2.visible.to <= cm.display.viewTo) {
            break;
          }
        } else if (first) {
          update2.visible = visibleLines(cm.display, cm.doc, viewport);
        }
        if (!updateDisplayIfNeeded(cm, update2)) {
          break;
        }
        updateHeightsInViewport(cm);
        var barMeasure = measureForScrollbars(cm);
        updateSelection(cm);
        updateScrollbars(cm, barMeasure);
        setDocumentHeight(cm, barMeasure);
        update2.force = false;
      }
      update2.signal(cm, "update", cm);
      if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
        update2.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
        cm.display.reportedViewFrom = cm.display.viewFrom;
        cm.display.reportedViewTo = cm.display.viewTo;
      }
    }
    function updateDisplaySimple(cm, viewport) {
      var update2 = new DisplayUpdate(cm, viewport);
      if (updateDisplayIfNeeded(cm, update2)) {
        updateHeightsInViewport(cm);
        postUpdateDisplay(cm, update2);
        var barMeasure = measureForScrollbars(cm);
        updateSelection(cm);
        updateScrollbars(cm, barMeasure);
        setDocumentHeight(cm, barMeasure);
        update2.finish();
      }
    }
    function patchDisplay(cm, updateNumbersFrom, dims) {
      var display = cm.display, lineNumbers = cm.options.lineNumbers;
      var container = display.lineDiv, cur = container.firstChild;
      function rm(node2) {
        var next2 = node2.nextSibling;
        if (webkit && mac && cm.display.currentWheelTarget == node2) {
          node2.style.display = "none";
        } else {
          node2.parentNode.removeChild(node2);
        }
        return next2;
      }
      var view2 = display.view, lineN = display.viewFrom;
      for (var i2 = 0; i2 < view2.length; i2++) {
        var lineView = view2[i2];
        if (lineView.hidden)
          ;
        else if (!lineView.node || lineView.node.parentNode != container) {
          var node = buildLineElement(cm, lineView, lineN, dims);
          container.insertBefore(node, cur);
        } else {
          while (cur != lineView.node) {
            cur = rm(cur);
          }
          var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
          if (lineView.changes) {
            if (indexOf(lineView.changes, "gutter") > -1) {
              updateNumber = false;
            }
            updateLineForChanges(cm, lineView, lineN, dims);
          }
          if (updateNumber) {
            removeChildren(lineView.lineNumber);
            lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
          }
          cur = lineView.node.nextSibling;
        }
        lineN += lineView.size;
      }
      while (cur) {
        cur = rm(cur);
      }
    }
    function updateGutterSpace(display) {
      var width = display.gutters.offsetWidth;
      display.sizer.style.marginLeft = width + "px";
      signalLater(display, "gutterChanged", display);
    }
    function setDocumentHeight(cm, measure) {
      cm.display.sizer.style.minHeight = measure.docHeight + "px";
      cm.display.heightForcer.style.top = measure.docHeight + "px";
      cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
    }
    function alignHorizontally(cm) {
      var display = cm.display, view2 = display.view;
      if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) {
        return;
      }
      var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
      var gutterW = display.gutters.offsetWidth, left = comp + "px";
      for (var i2 = 0; i2 < view2.length; i2++) {
        if (!view2[i2].hidden) {
          if (cm.options.fixedGutter) {
            if (view2[i2].gutter) {
              view2[i2].gutter.style.left = left;
            }
            if (view2[i2].gutterBackground) {
              view2[i2].gutterBackground.style.left = left;
            }
          }
          var align = view2[i2].alignable;
          if (align) {
            for (var j = 0; j < align.length; j++) {
              align[j].style.left = left;
            }
          }
        }
      }
      if (cm.options.fixedGutter) {
        display.gutters.style.left = comp + gutterW + "px";
      }
    }
    function maybeUpdateLineNumberWidth(cm) {
      if (!cm.options.lineNumbers) {
        return false;
      }
      var doc2 = cm.doc, last = lineNumberFor(cm.options, doc2.first + doc2.size - 1), display = cm.display;
      if (last.length != display.lineNumChars) {
        var test = display.measure.appendChild(elt(
          "div",
          [elt("div", last)],
          "CodeMirror-linenumber CodeMirror-gutter-elt"
        ));
        var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
        display.lineGutter.style.width = "";
        display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
        display.lineNumWidth = display.lineNumInnerWidth + padding;
        display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
        display.lineGutter.style.width = display.lineNumWidth + "px";
        updateGutterSpace(cm.display);
        return true;
      }
      return false;
    }
    function getGutters(gutters, lineNumbers) {
      var result = [], sawLineNumbers = false;
      for (var i2 = 0; i2 < gutters.length; i2++) {
        var name = gutters[i2], style = null;
        if (typeof name != "string") {
          style = name.style;
          name = name.className;
        }
        if (name == "CodeMirror-linenumbers") {
          if (!lineNumbers) {
            continue;
          } else {
            sawLineNumbers = true;
          }
        }
        result.push({ className: name, style });
      }
      if (lineNumbers && !sawLineNumbers) {
        result.push({ className: "CodeMirror-linenumbers", style: null });
      }
      return result;
    }
    function renderGutters(display) {
      var gutters = display.gutters, specs = display.gutterSpecs;
      removeChildren(gutters);
      display.lineGutter = null;
      for (var i2 = 0; i2 < specs.length; ++i2) {
        var ref2 = specs[i2];
        var className = ref2.className;
        var style = ref2.style;
        var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
        if (style) {
          gElt.style.cssText = style;
        }
        if (className == "CodeMirror-linenumbers") {
          display.lineGutter = gElt;
          gElt.style.width = (display.lineNumWidth || 1) + "px";
        }
      }
      gutters.style.display = specs.length ? "" : "none";
      updateGutterSpace(display);
    }
    function updateGutters(cm) {
      renderGutters(cm.display);
      regChange(cm);
      alignHorizontally(cm);
    }
    function Display(place, doc2, input, options) {
      var d = this;
      this.input = input;
      d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
      d.scrollbarFiller.setAttribute("cm-not-content", "true");
      d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
      d.gutterFiller.setAttribute("cm-not-content", "true");
      d.lineDiv = eltP("div", null, "CodeMirror-code");
      d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
      d.cursorDiv = elt("div", null, "CodeMirror-cursors");
      d.measure = elt("div", null, "CodeMirror-measure");
      d.lineMeasure = elt("div", null, "CodeMirror-measure");
      d.lineSpace = eltP(
        "div",
        [d.measure, d.lineMeasure, d.selectionDiv, d.cursorDiv, d.lineDiv],
        null,
        "position: relative; outline: none"
      );
      var lines = eltP("div", [d.lineSpace], "CodeMirror-lines");
      d.mover = elt("div", [lines], null, "position: relative");
      d.sizer = elt("div", [d.mover], "CodeMirror-sizer");
      d.sizerWidth = null;
      d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
      d.gutters = elt("div", null, "CodeMirror-gutters");
      d.lineGutter = null;
      d.scroller = elt("div", [d.sizer, d.heightForcer, d.gutters], "CodeMirror-scroll");
      d.scroller.setAttribute("tabIndex", "-1");
      d.wrapper = elt("div", [d.scrollbarFiller, d.gutterFiller, d.scroller], "CodeMirror");
      if (chrome && chrome_version >= 105) {
        d.wrapper.style.clipPath = "inset(0px)";
      }
      d.wrapper.setAttribute("translate", "no");
      if (ie && ie_version < 8) {
        d.gutters.style.zIndex = -1;
        d.scroller.style.paddingRight = 0;
      }
      if (!webkit && !(gecko && mobile)) {
        d.scroller.draggable = true;
      }
      if (place) {
        if (place.appendChild) {
          place.appendChild(d.wrapper);
        } else {
          place(d.wrapper);
        }
      }
      d.viewFrom = d.viewTo = doc2.first;
      d.reportedViewFrom = d.reportedViewTo = doc2.first;
      d.view = [];
      d.renderedView = null;
      d.externalMeasured = null;
      d.viewOffset = 0;
      d.lastWrapHeight = d.lastWrapWidth = 0;
      d.updateLineNumbers = null;
      d.nativeBarWidth = d.barHeight = d.barWidth = 0;
      d.scrollbarsClipped = false;
      d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
      d.alignWidgets = false;
      d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
      d.maxLine = null;
      d.maxLineLength = 0;
      d.maxLineChanged = false;
      d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
      d.shift = false;
      d.selForContextMenu = null;
      d.activeTouch = null;
      d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
      renderGutters(d);
      input.init(d);
    }
    var wheelSamples = 0, wheelPixelsPerUnit = null;
    if (ie) {
      wheelPixelsPerUnit = -0.53;
    } else if (gecko) {
      wheelPixelsPerUnit = 15;
    } else if (chrome) {
      wheelPixelsPerUnit = -0.7;
    } else if (safari) {
      wheelPixelsPerUnit = -1 / 3;
    }
    function wheelEventDelta(e) {
      var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
      if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) {
        dx = e.detail;
      }
      if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) {
        dy = e.detail;
      } else if (dy == null) {
        dy = e.wheelDelta;
      }
      return { x: dx, y: dy };
    }
    function wheelEventPixels(e) {
      var delta = wheelEventDelta(e);
      delta.x *= wheelPixelsPerUnit;
      delta.y *= wheelPixelsPerUnit;
      return delta;
    }
    function onScrollWheel(cm, e) {
      if (chrome && chrome_version == 102) {
        if (cm.display.chromeScrollHack == null) {
          cm.display.sizer.style.pointerEvents = "none";
        } else {
          clearTimeout(cm.display.chromeScrollHack);
        }
        cm.display.chromeScrollHack = setTimeout(function() {
          cm.display.chromeScrollHack = null;
          cm.display.sizer.style.pointerEvents = "";
        }, 100);
      }
      var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
      var pixelsPerUnit = wheelPixelsPerUnit;
      if (e.deltaMode === 0) {
        dx = e.deltaX;
        dy = e.deltaY;
        pixelsPerUnit = 1;
      }
      var display = cm.display, scroll = display.scroller;
      var canScrollX = scroll.scrollWidth > scroll.clientWidth;
      var canScrollY = scroll.scrollHeight > scroll.clientHeight;
      if (!(dx && canScrollX || dy && canScrollY)) {
        return;
      }
      if (dy && mac && webkit) {
        outer:
          for (var cur = e.target, view2 = display.view; cur != scroll; cur = cur.parentNode) {
            for (var i2 = 0; i2 < view2.length; i2++) {
              if (view2[i2].node == cur) {
                cm.display.currentWheelTarget = cur;
                break outer;
              }
            }
          }
      }
      if (dx && !gecko && !presto && pixelsPerUnit != null) {
        if (dy && canScrollY) {
          updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * pixelsPerUnit));
        }
        setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * pixelsPerUnit));
        if (!dy || dy && canScrollY) {
          e_preventDefault(e);
        }
        display.wheelStartX = null;
        return;
      }
      if (dy && pixelsPerUnit != null) {
        var pixels = dy * pixelsPerUnit;
        var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
        if (pixels < 0) {
          top = Math.max(0, top + pixels - 50);
        } else {
          bot = Math.min(cm.doc.height, bot + pixels + 50);
        }
        updateDisplaySimple(cm, { top, bottom: bot });
      }
      if (wheelSamples < 20 && e.deltaMode !== 0) {
        if (display.wheelStartX == null) {
          display.wheelStartX = scroll.scrollLeft;
          display.wheelStartY = scroll.scrollTop;
          display.wheelDX = dx;
          display.wheelDY = dy;
          setTimeout(function() {
            if (display.wheelStartX == null) {
              return;
            }
            var movedX = scroll.scrollLeft - display.wheelStartX;
            var movedY = scroll.scrollTop - display.wheelStartY;
            var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
            display.wheelStartX = display.wheelStartY = null;
            if (!sample) {
              return;
            }
            wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
            ++wheelSamples;
          }, 200);
        } else {
          display.wheelDX += dx;
          display.wheelDY += dy;
        }
      }
    }
    var Selection = function(ranges, primIndex) {
      this.ranges = ranges;
      this.primIndex = primIndex;
    };
    Selection.prototype.primary = function() {
      return this.ranges[this.primIndex];
    };
    Selection.prototype.equals = function(other) {
      if (other == this) {
        return true;
      }
      if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) {
        return false;
      }
      for (var i2 = 0; i2 < this.ranges.length; i2++) {
        var here = this.ranges[i2], there = other.ranges[i2];
        if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) {
          return false;
        }
      }
      return true;
    };
    Selection.prototype.deepCopy = function() {
      var out = [];
      for (var i2 = 0; i2 < this.ranges.length; i2++) {
        out[i2] = new Range(copyPos(this.ranges[i2].anchor), copyPos(this.ranges[i2].head));
      }
      return new Selection(out, this.primIndex);
    };
    Selection.prototype.somethingSelected = function() {
      for (var i2 = 0; i2 < this.ranges.length; i2++) {
        if (!this.ranges[i2].empty()) {
          return true;
        }
      }
      return false;
    };
    Selection.prototype.contains = function(pos, end) {
      if (!end) {
        end = pos;
      }
      for (var i2 = 0; i2 < this.ranges.length; i2++) {
        var range2 = this.ranges[i2];
        if (cmp(end, range2.from()) >= 0 && cmp(pos, range2.to()) <= 0) {
          return i2;
        }
      }
      return -1;
    };
    var Range = function(anchor, head) {
      this.anchor = anchor;
      this.head = head;
    };
    Range.prototype.from = function() {
      return minPos(this.anchor, this.head);
    };
    Range.prototype.to = function() {
      return maxPos(this.anchor, this.head);
    };
    Range.prototype.empty = function() {
      return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
    };
    function normalizeSelection(cm, ranges, primIndex) {
      var mayTouch = cm && cm.options.selectionsMayTouch;
      var prim = ranges[primIndex];
      ranges.sort(function(a, b) {
        return cmp(a.from(), b.from());
      });
      primIndex = indexOf(ranges, prim);
      for (var i2 = 1; i2 < ranges.length; i2++) {
        var cur = ranges[i2], prev2 = ranges[i2 - 1];
        var diff = cmp(prev2.to(), cur.from());
        if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
          var from = minPos(prev2.from(), cur.from()), to = maxPos(prev2.to(), cur.to());
          var inv = prev2.empty() ? cur.from() == cur.head : prev2.from() == prev2.head;
          if (i2 <= primIndex) {
            --primIndex;
          }
          ranges.splice(--i2, 2, new Range(inv ? to : from, inv ? from : to));
        }
      }
      return new Selection(ranges, primIndex);
    }
    function simpleSelection(anchor, head) {
      return new Selection([new Range(anchor, head || anchor)], 0);
    }
    function changeEnd(change2) {
      if (!change2.text) {
        return change2.to;
      }
      return Pos(
        change2.from.line + change2.text.length - 1,
        lst(change2.text).length + (change2.text.length == 1 ? change2.from.ch : 0)
      );
    }
    function adjustForChange(pos, change2) {
      if (cmp(pos, change2.from) < 0) {
        return pos;
      }
      if (cmp(pos, change2.to) <= 0) {
        return changeEnd(change2);
      }
      var line = pos.line + change2.text.length - (change2.to.line - change2.from.line) - 1, ch = pos.ch;
      if (pos.line == change2.to.line) {
        ch += changeEnd(change2).ch - change2.to.ch;
      }
      return Pos(line, ch);
    }
    function computeSelAfterChange(doc2, change2) {
      var out = [];
      for (var i2 = 0; i2 < doc2.sel.ranges.length; i2++) {
        var range2 = doc2.sel.ranges[i2];
        out.push(new Range(
          adjustForChange(range2.anchor, change2),
          adjustForChange(range2.head, change2)
        ));
      }
      return normalizeSelection(doc2.cm, out, doc2.sel.primIndex);
    }
    function offsetPos(pos, old, nw) {
      if (pos.line == old.line) {
        return Pos(nw.line, pos.ch - old.ch + nw.ch);
      } else {
        return Pos(nw.line + (pos.line - old.line), pos.ch);
      }
    }
    function computeReplacedSel(doc2, changes, hint) {
      var out = [];
      var oldPrev = Pos(doc2.first, 0), newPrev = oldPrev;
      for (var i2 = 0; i2 < changes.length; i2++) {
        var change2 = changes[i2];
        var from = offsetPos(change2.from, oldPrev, newPrev);
        var to = offsetPos(changeEnd(change2), oldPrev, newPrev);
        oldPrev = change2.to;
        newPrev = to;
        if (hint == "around") {
          var range2 = doc2.sel.ranges[i2], inv = cmp(range2.head, range2.anchor) < 0;
          out[i2] = new Range(inv ? to : from, inv ? from : to);
        } else {
          out[i2] = new Range(from, from);
        }
      }
      return new Selection(out, doc2.sel.primIndex);
    }
    function loadMode(cm) {
      cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
      resetModeState(cm);
    }
    function resetModeState(cm) {
      cm.doc.iter(function(line) {
        if (line.stateAfter) {
          line.stateAfter = null;
        }
        if (line.styles) {
          line.styles = null;
        }
      });
      cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
      startWorker(cm, 100);
      cm.state.modeGen++;
      if (cm.curOp) {
        regChange(cm);
      }
    }
    function isWholeLineUpdate(doc2, change2) {
      return change2.from.ch == 0 && change2.to.ch == 0 && lst(change2.text) == "" && (!doc2.cm || doc2.cm.options.wholeLineUpdateBefore);
    }
    function updateDoc(doc2, change2, markedSpans, estimateHeight2) {
      function spansFor(n) {
        return markedSpans ? markedSpans[n] : null;
      }
      function update2(line, text2, spans) {
        updateLine(line, text2, spans, estimateHeight2);
        signalLater(line, "change", line, change2);
      }
      function linesFor(start, end) {
        var result = [];
        for (var i2 = start; i2 < end; ++i2) {
          result.push(new Line(text[i2], spansFor(i2), estimateHeight2));
        }
        return result;
      }
      var from = change2.from, to = change2.to, text = change2.text;
      var firstLine = getLine(doc2, from.line), lastLine = getLine(doc2, to.line);
      var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
      if (change2.full) {
        doc2.insert(0, linesFor(0, text.length));
        doc2.remove(text.length, doc2.size - text.length);
      } else if (isWholeLineUpdate(doc2, change2)) {
        var added = linesFor(0, text.length - 1);
        update2(lastLine, lastLine.text, lastSpans);
        if (nlines) {
          doc2.remove(from.line, nlines);
        }
        if (added.length) {
          doc2.insert(from.line, added);
        }
      } else if (firstLine == lastLine) {
        if (text.length == 1) {
          update2(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
        } else {
          var added$1 = linesFor(1, text.length - 1);
          added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight2));
          update2(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
          doc2.insert(from.line + 1, added$1);
        }
      } else if (text.length == 1) {
        update2(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
        doc2.remove(from.line + 1, nlines);
      } else {
        update2(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
        update2(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
        var added$2 = linesFor(1, text.length - 1);
        if (nlines > 1) {
          doc2.remove(from.line + 1, nlines - 1);
        }
        doc2.insert(from.line + 1, added$2);
      }
      signalLater(doc2, "change", doc2, change2);
    }
    function linkedDocs(doc2, f, sharedHistOnly) {
      function propagate(doc3, skip, sharedHist) {
        if (doc3.linked) {
          for (var i2 = 0; i2 < doc3.linked.length; ++i2) {
            var rel = doc3.linked[i2];
            if (rel.doc == skip) {
              continue;
            }
            var shared = sharedHist && rel.sharedHist;
            if (sharedHistOnly && !shared) {
              continue;
            }
            f(rel.doc, shared);
            propagate(rel.doc, doc3, shared);
          }
        }
      }
      propagate(doc2, null, true);
    }
    function attachDoc(cm, doc2) {
      if (doc2.cm) {
        throw new Error("This document is already in use.");
      }
      cm.doc = doc2;
      doc2.cm = cm;
      estimateLineHeights(cm);
      loadMode(cm);
      setDirectionClass(cm);
      cm.options.direction = doc2.direction;
      if (!cm.options.lineWrapping) {
        findMaxLine(cm);
      }
      cm.options.mode = doc2.modeOption;
      regChange(cm);
    }
    function setDirectionClass(cm) {
      (cm.doc.direction == "rtl" ? addClass2 : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
    }
    function directionChanged(cm) {
      runInOp(cm, function() {
        setDirectionClass(cm);
        regChange(cm);
      });
    }
    function History(prev2) {
      this.done = [];
      this.undone = [];
      this.undoDepth = prev2 ? prev2.undoDepth : Infinity;
      this.lastModTime = this.lastSelTime = 0;
      this.lastOp = this.lastSelOp = null;
      this.lastOrigin = this.lastSelOrigin = null;
      this.generation = this.maxGeneration = prev2 ? prev2.maxGeneration : 1;
    }
    function historyChangeFromChange(doc2, change2) {
      var histChange = { from: copyPos(change2.from), to: changeEnd(change2), text: getBetween(doc2, change2.from, change2.to) };
      attachLocalSpans(doc2, histChange, change2.from.line, change2.to.line + 1);
      linkedDocs(doc2, function(doc3) {
        return attachLocalSpans(doc3, histChange, change2.from.line, change2.to.line + 1);
      }, true);
      return histChange;
    }
    function clearSelectionEvents(array) {
      while (array.length) {
        var last = lst(array);
        if (last.ranges) {
          array.pop();
        } else {
          break;
        }
      }
    }
    function lastChangeEvent(hist, force) {
      if (force) {
        clearSelectionEvents(hist.done);
        return lst(hist.done);
      } else if (hist.done.length && !lst(hist.done).ranges) {
        return lst(hist.done);
      } else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
        hist.done.pop();
        return lst(hist.done);
      }
    }
    function addChangeToHistory(doc2, change2, selAfter, opId) {
      var hist = doc2.history;
      hist.undone.length = 0;
      var time = +new Date(), cur;
      var last;
      if ((hist.lastOp == opId || hist.lastOrigin == change2.origin && change2.origin && (change2.origin.charAt(0) == "+" && hist.lastModTime > time - (doc2.cm ? doc2.cm.options.historyEventDelay : 500) || change2.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
        last = lst(cur.changes);
        if (cmp(change2.from, change2.to) == 0 && cmp(change2.from, last.to) == 0) {
          last.to = changeEnd(change2);
        } else {
          cur.changes.push(historyChangeFromChange(doc2, change2));
        }
      } else {
        var before = lst(hist.done);
        if (!before || !before.ranges) {
          pushSelectionToHistory(doc2.sel, hist.done);
        }
        cur = {
          changes: [historyChangeFromChange(doc2, change2)],
          generation: hist.generation
        };
        hist.done.push(cur);
        while (hist.done.length > hist.undoDepth) {
          hist.done.shift();
          if (!hist.done[0].ranges) {
            hist.done.shift();
          }
        }
      }
      hist.done.push(selAfter);
      hist.generation = ++hist.maxGeneration;
      hist.lastModTime = hist.lastSelTime = time;
      hist.lastOp = hist.lastSelOp = opId;
      hist.lastOrigin = hist.lastSelOrigin = change2.origin;
      if (!last) {
        signal(doc2, "historyAdded");
      }
    }
    function selectionEventCanBeMerged(doc2, origin, prev2, sel) {
      var ch = origin.charAt(0);
      return ch == "*" || ch == "+" && prev2.ranges.length == sel.ranges.length && prev2.somethingSelected() == sel.somethingSelected() && new Date() - doc2.history.lastSelTime <= (doc2.cm ? doc2.cm.options.historyEventDelay : 500);
    }
    function addSelectionToHistory(doc2, sel, opId, options) {
      var hist = doc2.history, origin = options && options.origin;
      if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc2, origin, lst(hist.done), sel))) {
        hist.done[hist.done.length - 1] = sel;
      } else {
        pushSelectionToHistory(sel, hist.done);
      }
      hist.lastSelTime = +new Date();
      hist.lastSelOrigin = origin;
      hist.lastSelOp = opId;
      if (options && options.clearRedo !== false) {
        clearSelectionEvents(hist.undone);
      }
    }
    function pushSelectionToHistory(sel, dest) {
      var top = lst(dest);
      if (!(top && top.ranges && top.equals(sel))) {
        dest.push(sel);
      }
    }
    function attachLocalSpans(doc2, change2, from, to) {
      var existing = change2["spans_" + doc2.id], n = 0;
      doc2.iter(Math.max(doc2.first, from), Math.min(doc2.first + doc2.size, to), function(line) {
        if (line.markedSpans) {
          (existing || (existing = change2["spans_" + doc2.id] = {}))[n] = line.markedSpans;
        }
        ++n;
      });
    }
    function removeClearedSpans(spans) {
      if (!spans) {
        return null;
      }
      var out;
      for (var i2 = 0; i2 < spans.length; ++i2) {
        if (spans[i2].marker.explicitlyCleared) {
          if (!out) {
            out = spans.slice(0, i2);
          }
        } else if (out) {
          out.push(spans[i2]);
        }
      }
      return !out ? spans : out.length ? out : null;
    }
    function getOldSpans(doc2, change2) {
      var found = change2["spans_" + doc2.id];
      if (!found) {
        return null;
      }
      var nw = [];
      for (var i2 = 0; i2 < change2.text.length; ++i2) {
        nw.push(removeClearedSpans(found[i2]));
      }
      return nw;
    }
    function mergeOldSpans(doc2, change2) {
      var old = getOldSpans(doc2, change2);
      var stretched = stretchSpansOverChange(doc2, change2);
      if (!old) {
        return stretched;
      }
      if (!stretched) {
        return old;
      }
      for (var i2 = 0; i2 < old.length; ++i2) {
        var oldCur = old[i2], stretchCur = stretched[i2];
        if (oldCur && stretchCur) {
          spans:
            for (var j = 0; j < stretchCur.length; ++j) {
              var span = stretchCur[j];
              for (var k = 0; k < oldCur.length; ++k) {
                if (oldCur[k].marker == span.marker) {
                  continue spans;
                }
              }
              oldCur.push(span);
            }
        } else if (stretchCur) {
          old[i2] = stretchCur;
        }
      }
      return old;
    }
    function copyHistoryArray(events2, newGroup, instantiateSel) {
      var copy = [];
      for (var i2 = 0; i2 < events2.length; ++i2) {
        var event = events2[i2];
        if (event.ranges) {
          copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
          continue;
        }
        var changes = event.changes, newChanges = [];
        copy.push({ changes: newChanges });
        for (var j = 0; j < changes.length; ++j) {
          var change2 = changes[j], m = void 0;
          newChanges.push({ from: change2.from, to: change2.to, text: change2.text });
          if (newGroup) {
            for (var prop2 in change2) {
              if (m = prop2.match(/^spans_(\d+)$/)) {
                if (indexOf(newGroup, Number(m[1])) > -1) {
                  lst(newChanges)[prop2] = change2[prop2];
                  delete change2[prop2];
                }
              }
            }
          }
        }
      }
      return copy;
    }
    function extendRange(range2, head, other, extend2) {
      if (extend2) {
        var anchor = range2.anchor;
        if (other) {
          var posBefore = cmp(head, anchor) < 0;
          if (posBefore != cmp(other, anchor) < 0) {
            anchor = head;
            head = other;
          } else if (posBefore != cmp(head, other) < 0) {
            head = other;
          }
        }
        return new Range(anchor, head);
      } else {
        return new Range(other || head, head);
      }
    }
    function extendSelection(doc2, head, other, options, extend2) {
      if (extend2 == null) {
        extend2 = doc2.cm && (doc2.cm.display.shift || doc2.extend);
      }
      setSelection(doc2, new Selection([extendRange(doc2.sel.primary(), head, other, extend2)], 0), options);
    }
    function extendSelections(doc2, heads, options) {
      var out = [];
      var extend2 = doc2.cm && (doc2.cm.display.shift || doc2.extend);
      for (var i2 = 0; i2 < doc2.sel.ranges.length; i2++) {
        out[i2] = extendRange(doc2.sel.ranges[i2], heads[i2], null, extend2);
      }
      var newSel = normalizeSelection(doc2.cm, out, doc2.sel.primIndex);
      setSelection(doc2, newSel, options);
    }
    function replaceOneSelection(doc2, i2, range2, options) {
      var ranges = doc2.sel.ranges.slice(0);
      ranges[i2] = range2;
      setSelection(doc2, normalizeSelection(doc2.cm, ranges, doc2.sel.primIndex), options);
    }
    function setSimpleSelection(doc2, anchor, head, options) {
      setSelection(doc2, simpleSelection(anchor, head), options);
    }
    function filterSelectionChange(doc2, sel, options) {
      var obj = {
        ranges: sel.ranges,
        update: function(ranges) {
          this.ranges = [];
          for (var i2 = 0; i2 < ranges.length; i2++) {
            this.ranges[i2] = new Range(
              clipPos(doc2, ranges[i2].anchor),
              clipPos(doc2, ranges[i2].head)
            );
          }
        },
        origin: options && options.origin
      };
      signal(doc2, "beforeSelectionChange", doc2, obj);
      if (doc2.cm) {
        signal(doc2.cm, "beforeSelectionChange", doc2.cm, obj);
      }
      if (obj.ranges != sel.ranges) {
        return normalizeSelection(doc2.cm, obj.ranges, obj.ranges.length - 1);
      } else {
        return sel;
      }
    }
    function setSelectionReplaceHistory(doc2, sel, options) {
      var done = doc2.history.done, last = lst(done);
      if (last && last.ranges) {
        done[done.length - 1] = sel;
        setSelectionNoUndo(doc2, sel, options);
      } else {
        setSelection(doc2, sel, options);
      }
    }
    function setSelection(doc2, sel, options) {
      setSelectionNoUndo(doc2, sel, options);
      addSelectionToHistory(doc2, doc2.sel, doc2.cm ? doc2.cm.curOp.id : NaN, options);
    }
    function setSelectionNoUndo(doc2, sel, options) {
      if (hasHandler(doc2, "beforeSelectionChange") || doc2.cm && hasHandler(doc2.cm, "beforeSelectionChange")) {
        sel = filterSelectionChange(doc2, sel, options);
      }
      var bias = options && options.bias || (cmp(sel.primary().head, doc2.sel.primary().head) < 0 ? -1 : 1);
      setSelectionInner(doc2, skipAtomicInSelection(doc2, sel, bias, true));
      if (!(options && options.scroll === false) && doc2.cm && doc2.cm.getOption("readOnly") != "nocursor") {
        ensureCursorVisible(doc2.cm);
      }
    }
    function setSelectionInner(doc2, sel) {
      if (sel.equals(doc2.sel)) {
        return;
      }
      doc2.sel = sel;
      if (doc2.cm) {
        doc2.cm.curOp.updateInput = 1;
        doc2.cm.curOp.selectionChanged = true;
        signalCursorActivity(doc2.cm);
      }
      signalLater(doc2, "cursorActivity", doc2);
    }
    function reCheckSelection(doc2) {
      setSelectionInner(doc2, skipAtomicInSelection(doc2, doc2.sel, null, false));
    }
    function skipAtomicInSelection(doc2, sel, bias, mayClear) {
      var out;
      for (var i2 = 0; i2 < sel.ranges.length; i2++) {
        var range2 = sel.ranges[i2];
        var old = sel.ranges.length == doc2.sel.ranges.length && doc2.sel.ranges[i2];
        var newAnchor = skipAtomic(doc2, range2.anchor, old && old.anchor, bias, mayClear);
        var newHead = range2.head == range2.anchor ? newAnchor : skipAtomic(doc2, range2.head, old && old.head, bias, mayClear);
        if (out || newAnchor != range2.anchor || newHead != range2.head) {
          if (!out) {
            out = sel.ranges.slice(0, i2);
          }
          out[i2] = new Range(newAnchor, newHead);
        }
      }
      return out ? normalizeSelection(doc2.cm, out, sel.primIndex) : sel;
    }
    function skipAtomicInner(doc2, pos, oldPos, dir, mayClear) {
      var line = getLine(doc2, pos.line);
      if (line.markedSpans) {
        for (var i2 = 0; i2 < line.markedSpans.length; ++i2) {
          var sp = line.markedSpans[i2], m = sp.marker;
          var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
          var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
          if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
            if (mayClear) {
              signal(m, "beforeCursorEnter");
              if (m.explicitlyCleared) {
                if (!line.markedSpans) {
                  break;
                } else {
                  --i2;
                  continue;
                }
              }
            }
            if (!m.atomic) {
              continue;
            }
            if (oldPos) {
              var near = m.find(dir < 0 ? 1 : -1), diff = void 0;
              if (dir < 0 ? preventCursorRight : preventCursorLeft) {
                near = movePos(doc2, near, -dir, near && near.line == pos.line ? line : null);
              }
              if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) {
                return skipAtomicInner(doc2, near, pos, dir, mayClear);
              }
            }
            var far = m.find(dir < 0 ? -1 : 1);
            if (dir < 0 ? preventCursorLeft : preventCursorRight) {
              far = movePos(doc2, far, dir, far.line == pos.line ? line : null);
            }
            return far ? skipAtomicInner(doc2, far, pos, dir, mayClear) : null;
          }
        }
      }
      return pos;
    }
    function skipAtomic(doc2, pos, oldPos, bias, mayClear) {
      var dir = bias || 1;
      var found = skipAtomicInner(doc2, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc2, pos, oldPos, dir, true) || skipAtomicInner(doc2, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc2, pos, oldPos, -dir, true);
      if (!found) {
        doc2.cantEdit = true;
        return Pos(doc2.first, 0);
      }
      return found;
    }
    function movePos(doc2, pos, dir, line) {
      if (dir < 0 && pos.ch == 0) {
        if (pos.line > doc2.first) {
          return clipPos(doc2, Pos(pos.line - 1));
        } else {
          return null;
        }
      } else if (dir > 0 && pos.ch == (line || getLine(doc2, pos.line)).text.length) {
        if (pos.line < doc2.first + doc2.size - 1) {
          return Pos(pos.line + 1, 0);
        } else {
          return null;
        }
      } else {
        return new Pos(pos.line, pos.ch + dir);
      }
    }
    function selectAll(cm) {
      cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
    }
    function filterChange(doc2, change2, update2) {
      var obj = {
        canceled: false,
        from: change2.from,
        to: change2.to,
        text: change2.text,
        origin: change2.origin,
        cancel: function() {
          return obj.canceled = true;
        }
      };
      if (update2) {
        obj.update = function(from, to, text, origin) {
          if (from) {
            obj.from = clipPos(doc2, from);
          }
          if (to) {
            obj.to = clipPos(doc2, to);
          }
          if (text) {
            obj.text = text;
          }
          if (origin !== void 0) {
            obj.origin = origin;
          }
        };
      }
      signal(doc2, "beforeChange", doc2, obj);
      if (doc2.cm) {
        signal(doc2.cm, "beforeChange", doc2.cm, obj);
      }
      if (obj.canceled) {
        if (doc2.cm) {
          doc2.cm.curOp.updateInput = 2;
        }
        return null;
      }
      return { from: obj.from, to: obj.to, text: obj.text, origin: obj.origin };
    }
    function makeChange(doc2, change2, ignoreReadOnly) {
      if (doc2.cm) {
        if (!doc2.cm.curOp) {
          return operation(doc2.cm, makeChange)(doc2, change2, ignoreReadOnly);
        }
        if (doc2.cm.state.suppressEdits) {
          return;
        }
      }
      if (hasHandler(doc2, "beforeChange") || doc2.cm && hasHandler(doc2.cm, "beforeChange")) {
        change2 = filterChange(doc2, change2, true);
        if (!change2) {
          return;
        }
      }
      var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc2, change2.from, change2.to);
      if (split) {
        for (var i2 = split.length - 1; i2 >= 0; --i2) {
          makeChangeInner(doc2, { from: split[i2].from, to: split[i2].to, text: i2 ? [""] : change2.text, origin: change2.origin });
        }
      } else {
        makeChangeInner(doc2, change2);
      }
    }
    function makeChangeInner(doc2, change2) {
      if (change2.text.length == 1 && change2.text[0] == "" && cmp(change2.from, change2.to) == 0) {
        return;
      }
      var selAfter = computeSelAfterChange(doc2, change2);
      addChangeToHistory(doc2, change2, selAfter, doc2.cm ? doc2.cm.curOp.id : NaN);
      makeChangeSingleDoc(doc2, change2, selAfter, stretchSpansOverChange(doc2, change2));
      var rebased = [];
      linkedDocs(doc2, function(doc3, sharedHist) {
        if (!sharedHist && indexOf(rebased, doc3.history) == -1) {
          rebaseHist(doc3.history, change2);
          rebased.push(doc3.history);
        }
        makeChangeSingleDoc(doc3, change2, null, stretchSpansOverChange(doc3, change2));
      });
    }
    function makeChangeFromHistory(doc2, type, allowSelectionOnly) {
      var suppress = doc2.cm && doc2.cm.state.suppressEdits;
      if (suppress && !allowSelectionOnly) {
        return;
      }
      var hist = doc2.history, event, selAfter = doc2.sel;
      var source2 = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
      var i2 = 0;
      for (; i2 < source2.length; i2++) {
        event = source2[i2];
        if (allowSelectionOnly ? event.ranges && !event.equals(doc2.sel) : !event.ranges) {
          break;
        }
      }
      if (i2 == source2.length) {
        return;
      }
      hist.lastOrigin = hist.lastSelOrigin = null;
      for (; ; ) {
        event = source2.pop();
        if (event.ranges) {
          pushSelectionToHistory(event, dest);
          if (allowSelectionOnly && !event.equals(doc2.sel)) {
            setSelection(doc2, event, { clearRedo: false });
            return;
          }
          selAfter = event;
        } else if (suppress) {
          source2.push(event);
          return;
        } else {
          break;
        }
      }
      var antiChanges = [];
      pushSelectionToHistory(selAfter, dest);
      dest.push({ changes: antiChanges, generation: hist.generation });
      hist.generation = event.generation || ++hist.maxGeneration;
      var filter = hasHandler(doc2, "beforeChange") || doc2.cm && hasHandler(doc2.cm, "beforeChange");
      var loop = function(i3) {
        var change2 = event.changes[i3];
        change2.origin = type;
        if (filter && !filterChange(doc2, change2, false)) {
          source2.length = 0;
          return {};
        }
        antiChanges.push(historyChangeFromChange(doc2, change2));
        var after = i3 ? computeSelAfterChange(doc2, change2) : lst(source2);
        makeChangeSingleDoc(doc2, change2, after, mergeOldSpans(doc2, change2));
        if (!i3 && doc2.cm) {
          doc2.cm.scrollIntoView({ from: change2.from, to: changeEnd(change2) });
        }
        var rebased = [];
        linkedDocs(doc2, function(doc3, sharedHist) {
          if (!sharedHist && indexOf(rebased, doc3.history) == -1) {
            rebaseHist(doc3.history, change2);
            rebased.push(doc3.history);
          }
          makeChangeSingleDoc(doc3, change2, null, mergeOldSpans(doc3, change2));
        });
      };
      for (var i$12 = event.changes.length - 1; i$12 >= 0; --i$12) {
        var returned = loop(i$12);
        if (returned)
          return returned.v;
      }
    }
    function shiftDoc(doc2, distance) {
      if (distance == 0) {
        return;
      }
      doc2.first += distance;
      doc2.sel = new Selection(map(doc2.sel.ranges, function(range2) {
        return new Range(
          Pos(range2.anchor.line + distance, range2.anchor.ch),
          Pos(range2.head.line + distance, range2.head.ch)
        );
      }), doc2.sel.primIndex);
      if (doc2.cm) {
        regChange(doc2.cm, doc2.first, doc2.first - distance, distance);
        for (var d = doc2.cm.display, l = d.viewFrom; l < d.viewTo; l++) {
          regLineChange(doc2.cm, l, "gutter");
        }
      }
    }
    function makeChangeSingleDoc(doc2, change2, selAfter, spans) {
      if (doc2.cm && !doc2.cm.curOp) {
        return operation(doc2.cm, makeChangeSingleDoc)(doc2, change2, selAfter, spans);
      }
      if (change2.to.line < doc2.first) {
        shiftDoc(doc2, change2.text.length - 1 - (change2.to.line - change2.from.line));
        return;
      }
      if (change2.from.line > doc2.lastLine()) {
        return;
      }
      if (change2.from.line < doc2.first) {
        var shift = change2.text.length - 1 - (doc2.first - change2.from.line);
        shiftDoc(doc2, shift);
        change2 = {
          from: Pos(doc2.first, 0),
          to: Pos(change2.to.line + shift, change2.to.ch),
          text: [lst(change2.text)],
          origin: change2.origin
        };
      }
      var last = doc2.lastLine();
      if (change2.to.line > last) {
        change2 = {
          from: change2.from,
          to: Pos(last, getLine(doc2, last).text.length),
          text: [change2.text[0]],
          origin: change2.origin
        };
      }
      change2.removed = getBetween(doc2, change2.from, change2.to);
      if (!selAfter) {
        selAfter = computeSelAfterChange(doc2, change2);
      }
      if (doc2.cm) {
        makeChangeSingleDocInEditor(doc2.cm, change2, spans);
      } else {
        updateDoc(doc2, change2, spans);
      }
      setSelectionNoUndo(doc2, selAfter, sel_dontScroll);
      if (doc2.cantEdit && skipAtomic(doc2, Pos(doc2.firstLine(), 0))) {
        doc2.cantEdit = false;
      }
    }
    function makeChangeSingleDocInEditor(cm, change2, spans) {
      var doc2 = cm.doc, display = cm.display, from = change2.from, to = change2.to;
      var recomputeMaxLength = false, checkWidthStart = from.line;
      if (!cm.options.lineWrapping) {
        checkWidthStart = lineNo(visualLine(getLine(doc2, from.line)));
        doc2.iter(checkWidthStart, to.line + 1, function(line) {
          if (line == display.maxLine) {
            recomputeMaxLength = true;
            return true;
          }
        });
      }
      if (doc2.sel.contains(change2.from, change2.to) > -1) {
        signalCursorActivity(cm);
      }
      updateDoc(doc2, change2, spans, estimateHeight(cm));
      if (!cm.options.lineWrapping) {
        doc2.iter(checkWidthStart, from.line + change2.text.length, function(line) {
          var len = lineLength(line);
          if (len > display.maxLineLength) {
            display.maxLine = line;
            display.maxLineLength = len;
            display.maxLineChanged = true;
            recomputeMaxLength = false;
          }
        });
        if (recomputeMaxLength) {
          cm.curOp.updateMaxLine = true;
        }
      }
      retreatFrontier(doc2, from.line);
      startWorker(cm, 400);
      var lendiff = change2.text.length - (to.line - from.line) - 1;
      if (change2.full) {
        regChange(cm);
      } else if (from.line == to.line && change2.text.length == 1 && !isWholeLineUpdate(cm.doc, change2)) {
        regLineChange(cm, from.line, "text");
      } else {
        regChange(cm, from.line, to.line + 1, lendiff);
      }
      var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
      if (changeHandler || changesHandler) {
        var obj = {
          from,
          to,
          text: change2.text,
          removed: change2.removed,
          origin: change2.origin
        };
        if (changeHandler) {
          signalLater(cm, "change", cm, obj);
        }
        if (changesHandler) {
          (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
        }
      }
      cm.display.selForContextMenu = null;
    }
    function replaceRange(doc2, code2, from, to, origin) {
      var assign3;
      if (!to) {
        to = from;
      }
      if (cmp(to, from) < 0) {
        assign3 = [to, from], from = assign3[0], to = assign3[1];
      }
      if (typeof code2 == "string") {
        code2 = doc2.splitLines(code2);
      }
      makeChange(doc2, { from, to, text: code2, origin });
    }
    function rebaseHistSelSingle(pos, from, to, diff) {
      if (to < pos.line) {
        pos.line += diff;
      } else if (from < pos.line) {
        pos.line = from;
        pos.ch = 0;
      }
    }
    function rebaseHistArray(array, from, to, diff) {
      for (var i2 = 0; i2 < array.length; ++i2) {
        var sub = array[i2], ok = true;
        if (sub.ranges) {
          if (!sub.copied) {
            sub = array[i2] = sub.deepCopy();
            sub.copied = true;
          }
          for (var j = 0; j < sub.ranges.length; j++) {
            rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
            rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
          }
          continue;
        }
        for (var j$1 = 0; j$1 < sub.changes.length; ++j$1) {
          var cur = sub.changes[j$1];
          if (to < cur.from.line) {
            cur.from = Pos(cur.from.line + diff, cur.from.ch);
            cur.to = Pos(cur.to.line + diff, cur.to.ch);
          } else if (from <= cur.to.line) {
            ok = false;
            break;
          }
        }
        if (!ok) {
          array.splice(0, i2 + 1);
          i2 = 0;
        }
      }
    }
    function rebaseHist(hist, change2) {
      var from = change2.from.line, to = change2.to.line, diff = change2.text.length - (to - from) - 1;
      rebaseHistArray(hist.done, from, to, diff);
      rebaseHistArray(hist.undone, from, to, diff);
    }
    function changeLine(doc2, handle, changeType, op) {
      var no = handle, line = handle;
      if (typeof handle == "number") {
        line = getLine(doc2, clipLine(doc2, handle));
      } else {
        no = lineNo(handle);
      }
      if (no == null) {
        return null;
      }
      if (op(line, no) && doc2.cm) {
        regLineChange(doc2.cm, no, changeType);
      }
      return line;
    }
    function LeafChunk(lines) {
      this.lines = lines;
      this.parent = null;
      var height = 0;
      for (var i2 = 0; i2 < lines.length; ++i2) {
        lines[i2].parent = this;
        height += lines[i2].height;
      }
      this.height = height;
    }
    LeafChunk.prototype = {
      chunkSize: function() {
        return this.lines.length;
      },
      removeInner: function(at, n) {
        for (var i2 = at, e = at + n; i2 < e; ++i2) {
          var line = this.lines[i2];
          this.height -= line.height;
          cleanUpLine(line);
          signalLater(line, "delete");
        }
        this.lines.splice(at, n);
      },
      collapse: function(lines) {
        lines.push.apply(lines, this.lines);
      },
      insertInner: function(at, lines, height) {
        this.height += height;
        this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
        for (var i2 = 0; i2 < lines.length; ++i2) {
          lines[i2].parent = this;
        }
      },
      iterN: function(at, n, op) {
        for (var e = at + n; at < e; ++at) {
          if (op(this.lines[at])) {
            return true;
          }
        }
      }
    };
    function BranchChunk(children) {
      this.children = children;
      var size = 0, height = 0;
      for (var i2 = 0; i2 < children.length; ++i2) {
        var ch = children[i2];
        size += ch.chunkSize();
        height += ch.height;
        ch.parent = this;
      }
      this.size = size;
      this.height = height;
      this.parent = null;
    }
    BranchChunk.prototype = {
      chunkSize: function() {
        return this.size;
      },
      removeInner: function(at, n) {
        this.size -= n;
        for (var i2 = 0; i2 < this.children.length; ++i2) {
          var child = this.children[i2], sz = child.chunkSize();
          if (at < sz) {
            var rm = Math.min(n, sz - at), oldHeight = child.height;
            child.removeInner(at, rm);
            this.height -= oldHeight - child.height;
            if (sz == rm) {
              this.children.splice(i2--, 1);
              child.parent = null;
            }
            if ((n -= rm) == 0) {
              break;
            }
            at = 0;
          } else {
            at -= sz;
          }
        }
        if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
          var lines = [];
          this.collapse(lines);
          this.children = [new LeafChunk(lines)];
          this.children[0].parent = this;
        }
      },
      collapse: function(lines) {
        for (var i2 = 0; i2 < this.children.length; ++i2) {
          this.children[i2].collapse(lines);
        }
      },
      insertInner: function(at, lines, height) {
        this.size += lines.length;
        this.height += height;
        for (var i2 = 0; i2 < this.children.length; ++i2) {
          var child = this.children[i2], sz = child.chunkSize();
          if (at <= sz) {
            child.insertInner(at, lines, height);
            if (child.lines && child.lines.length > 50) {
              var remaining = child.lines.length % 25 + 25;
              for (var pos = remaining; pos < child.lines.length; ) {
                var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
                child.height -= leaf.height;
                this.children.splice(++i2, 0, leaf);
                leaf.parent = this;
              }
              child.lines = child.lines.slice(0, remaining);
              this.maybeSpill();
            }
            break;
          }
          at -= sz;
        }
      },
      maybeSpill: function() {
        if (this.children.length <= 10) {
          return;
        }
        var me = this;
        do {
          var spilled = me.children.splice(me.children.length - 5, 5);
          var sibling = new BranchChunk(spilled);
          if (!me.parent) {
            var copy = new BranchChunk(me.children);
            copy.parent = me;
            me.children = [copy, sibling];
            me = copy;
          } else {
            me.size -= sibling.size;
            me.height -= sibling.height;
            var myIndex = indexOf(me.parent.children, me);
            me.parent.children.splice(myIndex + 1, 0, sibling);
          }
          sibling.parent = me.parent;
        } while (me.children.length > 10);
        me.parent.maybeSpill();
      },
      iterN: function(at, n, op) {
        for (var i2 = 0; i2 < this.children.length; ++i2) {
          var child = this.children[i2], sz = child.chunkSize();
          if (at < sz) {
            var used = Math.min(n, sz - at);
            if (child.iterN(at, used, op)) {
              return true;
            }
            if ((n -= used) == 0) {
              break;
            }
            at = 0;
          } else {
            at -= sz;
          }
        }
      }
    };
    var LineWidget = function(doc2, node, options) {
      if (options) {
        for (var opt in options) {
          if (options.hasOwnProperty(opt)) {
            this[opt] = options[opt];
          }
        }
      }
      this.doc = doc2;
      this.node = node;
    };
    LineWidget.prototype.clear = function() {
      var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
      if (no == null || !ws) {
        return;
      }
      for (var i2 = 0; i2 < ws.length; ++i2) {
        if (ws[i2] == this) {
          ws.splice(i2--, 1);
        }
      }
      if (!ws.length) {
        line.widgets = null;
      }
      var height = widgetHeight(this);
      updateLineHeight(line, Math.max(0, line.height - height));
      if (cm) {
        runInOp(cm, function() {
          adjustScrollWhenAboveVisible(cm, line, -height);
          regLineChange(cm, no, "widget");
        });
        signalLater(cm, "lineWidgetCleared", cm, this, no);
      }
    };
    LineWidget.prototype.changed = function() {
      var this$1$1 = this;
      var oldH = this.height, cm = this.doc.cm, line = this.line;
      this.height = null;
      var diff = widgetHeight(this) - oldH;
      if (!diff) {
        return;
      }
      if (!lineIsHidden(this.doc, line)) {
        updateLineHeight(line, line.height + diff);
      }
      if (cm) {
        runInOp(cm, function() {
          cm.curOp.forceUpdate = true;
          adjustScrollWhenAboveVisible(cm, line, diff);
          signalLater(cm, "lineWidgetChanged", cm, this$1$1, lineNo(line));
        });
      }
    };
    eventMixin(LineWidget);
    function adjustScrollWhenAboveVisible(cm, line, diff) {
      if (heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) {
        addToScrollTop(cm, diff);
      }
    }
    function addLineWidget(doc2, handle, node, options) {
      var widget = new LineWidget(doc2, node, options);
      var cm = doc2.cm;
      if (cm && widget.noHScroll) {
        cm.display.alignWidgets = true;
      }
      changeLine(doc2, handle, "widget", function(line) {
        var widgets = line.widgets || (line.widgets = []);
        if (widget.insertAt == null) {
          widgets.push(widget);
        } else {
          widgets.splice(Math.min(widgets.length, Math.max(0, widget.insertAt)), 0, widget);
        }
        widget.line = line;
        if (cm && !lineIsHidden(doc2, line)) {
          var aboveVisible = heightAtLine(line) < doc2.scrollTop;
          updateLineHeight(line, line.height + widgetHeight(widget));
          if (aboveVisible) {
            addToScrollTop(cm, widget.height);
          }
          cm.curOp.forceUpdate = true;
        }
        return true;
      });
      if (cm) {
        signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
      }
      return widget;
    }
    var nextMarkerId = 0;
    var TextMarker = function(doc2, type) {
      this.lines = [];
      this.type = type;
      this.doc = doc2;
      this.id = ++nextMarkerId;
    };
    TextMarker.prototype.clear = function() {
      if (this.explicitlyCleared) {
        return;
      }
      var cm = this.doc.cm, withOp = cm && !cm.curOp;
      if (withOp) {
        startOperation(cm);
      }
      if (hasHandler(this, "clear")) {
        var found = this.find();
        if (found) {
          signalLater(this, "clear", found.from, found.to);
        }
      }
      var min = null, max = null;
      for (var i2 = 0; i2 < this.lines.length; ++i2) {
        var line = this.lines[i2];
        var span = getMarkedSpanFor(line.markedSpans, this);
        if (cm && !this.collapsed) {
          regLineChange(cm, lineNo(line), "text");
        } else if (cm) {
          if (span.to != null) {
            max = lineNo(line);
          }
          if (span.from != null) {
            min = lineNo(line);
          }
        }
        line.markedSpans = removeMarkedSpan(line.markedSpans, span);
        if (span.from == null && this.collapsed && !lineIsHidden(this.doc, line) && cm) {
          updateLineHeight(line, textHeight(cm.display));
        }
      }
      if (cm && this.collapsed && !cm.options.lineWrapping) {
        for (var i$12 = 0; i$12 < this.lines.length; ++i$12) {
          var visual = visualLine(this.lines[i$12]), len = lineLength(visual);
          if (len > cm.display.maxLineLength) {
            cm.display.maxLine = visual;
            cm.display.maxLineLength = len;
            cm.display.maxLineChanged = true;
          }
        }
      }
      if (min != null && cm && this.collapsed) {
        regChange(cm, min, max + 1);
      }
      this.lines.length = 0;
      this.explicitlyCleared = true;
      if (this.atomic && this.doc.cantEdit) {
        this.doc.cantEdit = false;
        if (cm) {
          reCheckSelection(cm.doc);
        }
      }
      if (cm) {
        signalLater(cm, "markerCleared", cm, this, min, max);
      }
      if (withOp) {
        endOperation(cm);
      }
      if (this.parent) {
        this.parent.clear();
      }
    };
    TextMarker.prototype.find = function(side, lineObj) {
      if (side == null && this.type == "bookmark") {
        side = 1;
      }
      var from, to;
      for (var i2 = 0; i2 < this.lines.length; ++i2) {
        var line = this.lines[i2];
        var span = getMarkedSpanFor(line.markedSpans, this);
        if (span.from != null) {
          from = Pos(lineObj ? line : lineNo(line), span.from);
          if (side == -1) {
            return from;
          }
        }
        if (span.to != null) {
          to = Pos(lineObj ? line : lineNo(line), span.to);
          if (side == 1) {
            return to;
          }
        }
      }
      return from && { from, to };
    };
    TextMarker.prototype.changed = function() {
      var this$1$1 = this;
      var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
      if (!pos || !cm) {
        return;
      }
      runInOp(cm, function() {
        var line = pos.line, lineN = lineNo(pos.line);
        var view2 = findViewForLine(cm, lineN);
        if (view2) {
          clearLineMeasurementCacheFor(view2);
          cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
        }
        cm.curOp.updateMaxLine = true;
        if (!lineIsHidden(widget.doc, line) && widget.height != null) {
          var oldHeight = widget.height;
          widget.height = null;
          var dHeight = widgetHeight(widget) - oldHeight;
          if (dHeight) {
            updateLineHeight(line, line.height + dHeight);
          }
        }
        signalLater(cm, "markerChanged", cm, this$1$1);
      });
    };
    TextMarker.prototype.attachLine = function(line) {
      if (!this.lines.length && this.doc.cm) {
        var op = this.doc.cm.curOp;
        if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) {
          (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
        }
      }
      this.lines.push(line);
    };
    TextMarker.prototype.detachLine = function(line) {
      this.lines.splice(indexOf(this.lines, line), 1);
      if (!this.lines.length && this.doc.cm) {
        var op = this.doc.cm.curOp;
        (op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
      }
    };
    eventMixin(TextMarker);
    function markText(doc2, from, to, options, type) {
      if (options && options.shared) {
        return markTextShared(doc2, from, to, options, type);
      }
      if (doc2.cm && !doc2.cm.curOp) {
        return operation(doc2.cm, markText)(doc2, from, to, options, type);
      }
      var marker = new TextMarker(doc2, type), diff = cmp(from, to);
      if (options) {
        copyObj(options, marker, false);
      }
      if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) {
        return marker;
      }
      if (marker.replacedWith) {
        marker.collapsed = true;
        marker.widgetNode = eltP("span", [marker.replacedWith], "CodeMirror-widget");
        if (!options.handleMouseEvents) {
          marker.widgetNode.setAttribute("cm-ignore-events", "true");
        }
        if (options.insertLeft) {
          marker.widgetNode.insertLeft = true;
        }
      }
      if (marker.collapsed) {
        if (conflictingCollapsedRange(doc2, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc2, to.line, from, to, marker)) {
          throw new Error("Inserting collapsed marker partially overlapping an existing one");
        }
        seeCollapsedSpans();
      }
      if (marker.addToHistory) {
        addChangeToHistory(doc2, { from, to, origin: "markText" }, doc2.sel, NaN);
      }
      var curLine = from.line, cm = doc2.cm, updateMaxLine;
      doc2.iter(curLine, to.line + 1, function(line) {
        if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) {
          updateMaxLine = true;
        }
        if (marker.collapsed && curLine != from.line) {
          updateLineHeight(line, 0);
        }
        addMarkedSpan(line, new MarkedSpan(
          marker,
          curLine == from.line ? from.ch : null,
          curLine == to.line ? to.ch : null
        ), doc2.cm && doc2.cm.curOp);
        ++curLine;
      });
      if (marker.collapsed) {
        doc2.iter(from.line, to.line + 1, function(line) {
          if (lineIsHidden(doc2, line)) {
            updateLineHeight(line, 0);
          }
        });
      }
      if (marker.clearOnEnter) {
        on2(marker, "beforeCursorEnter", function() {
          return marker.clear();
        });
      }
      if (marker.readOnly) {
        seeReadOnlySpans();
        if (doc2.history.done.length || doc2.history.undone.length) {
          doc2.clearHistory();
        }
      }
      if (marker.collapsed) {
        marker.id = ++nextMarkerId;
        marker.atomic = true;
      }
      if (cm) {
        if (updateMaxLine) {
          cm.curOp.updateMaxLine = true;
        }
        if (marker.collapsed) {
          regChange(cm, from.line, to.line + 1);
        } else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) {
          for (var i2 = from.line; i2 <= to.line; i2++) {
            regLineChange(cm, i2, "text");
          }
        }
        if (marker.atomic) {
          reCheckSelection(cm.doc);
        }
        signalLater(cm, "markerAdded", cm, marker);
      }
      return marker;
    }
    var SharedTextMarker = function(markers, primary) {
      this.markers = markers;
      this.primary = primary;
      for (var i2 = 0; i2 < markers.length; ++i2) {
        markers[i2].parent = this;
      }
    };
    SharedTextMarker.prototype.clear = function() {
      if (this.explicitlyCleared) {
        return;
      }
      this.explicitlyCleared = true;
      for (var i2 = 0; i2 < this.markers.length; ++i2) {
        this.markers[i2].clear();
      }
      signalLater(this, "clear");
    };
    SharedTextMarker.prototype.find = function(side, lineObj) {
      return this.primary.find(side, lineObj);
    };
    eventMixin(SharedTextMarker);
    function markTextShared(doc2, from, to, options, type) {
      options = copyObj(options);
      options.shared = false;
      var markers = [markText(doc2, from, to, options, type)], primary = markers[0];
      var widget = options.widgetNode;
      linkedDocs(doc2, function(doc3) {
        if (widget) {
          options.widgetNode = widget.cloneNode(true);
        }
        markers.push(markText(doc3, clipPos(doc3, from), clipPos(doc3, to), options, type));
        for (var i2 = 0; i2 < doc3.linked.length; ++i2) {
          if (doc3.linked[i2].isParent) {
            return;
          }
        }
        primary = lst(markers);
      });
      return new SharedTextMarker(markers, primary);
    }
    function findSharedMarkers(doc2) {
      return doc2.findMarks(Pos(doc2.first, 0), doc2.clipPos(Pos(doc2.lastLine())), function(m) {
        return m.parent;
      });
    }
    function copySharedMarkers(doc2, markers) {
      for (var i2 = 0; i2 < markers.length; i2++) {
        var marker = markers[i2], pos = marker.find();
        var mFrom = doc2.clipPos(pos.from), mTo = doc2.clipPos(pos.to);
        if (cmp(mFrom, mTo)) {
          var subMark = markText(doc2, mFrom, mTo, marker.primary, marker.primary.type);
          marker.markers.push(subMark);
          subMark.parent = marker;
        }
      }
    }
    function detachSharedMarkers(markers) {
      var loop = function(i3) {
        var marker = markers[i3], linked = [marker.primary.doc];
        linkedDocs(marker.primary.doc, function(d) {
          return linked.push(d);
        });
        for (var j = 0; j < marker.markers.length; j++) {
          var subMarker = marker.markers[j];
          if (indexOf(linked, subMarker.doc) == -1) {
            subMarker.parent = null;
            marker.markers.splice(j--, 1);
          }
        }
      };
      for (var i2 = 0; i2 < markers.length; i2++)
        loop(i2);
    }
    var nextDocId = 0;
    var Doc = function(text, mode, firstLine, lineSep, direction) {
      if (!(this instanceof Doc)) {
        return new Doc(text, mode, firstLine, lineSep, direction);
      }
      if (firstLine == null) {
        firstLine = 0;
      }
      BranchChunk.call(this, [new LeafChunk([new Line("", null)])]);
      this.first = firstLine;
      this.scrollTop = this.scrollLeft = 0;
      this.cantEdit = false;
      this.cleanGeneration = 1;
      this.modeFrontier = this.highlightFrontier = firstLine;
      var start = Pos(firstLine, 0);
      this.sel = simpleSelection(start);
      this.history = new History(null);
      this.id = ++nextDocId;
      this.modeOption = mode;
      this.lineSep = lineSep;
      this.direction = direction == "rtl" ? "rtl" : "ltr";
      this.extend = false;
      if (typeof text == "string") {
        text = this.splitLines(text);
      }
      updateDoc(this, { from: start, to: start, text });
      setSelection(this, simpleSelection(start), sel_dontScroll);
    };
    Doc.prototype = createObj(BranchChunk.prototype, {
      constructor: Doc,
      iter: function(from, to, op) {
        if (op) {
          this.iterN(from - this.first, to - from, op);
        } else {
          this.iterN(this.first, this.first + this.size, from);
        }
      },
      insert: function(at, lines) {
        var height = 0;
        for (var i2 = 0; i2 < lines.length; ++i2) {
          height += lines[i2].height;
        }
        this.insertInner(at - this.first, lines, height);
      },
      remove: function(at, n) {
        this.removeInner(at - this.first, n);
      },
      getValue: function(lineSep) {
        var lines = getLines(this, this.first, this.first + this.size);
        if (lineSep === false) {
          return lines;
        }
        return lines.join(lineSep || this.lineSeparator());
      },
      setValue: docMethodOp(function(code2) {
        var top = Pos(this.first, 0), last = this.first + this.size - 1;
        makeChange(this, {
          from: top,
          to: Pos(last, getLine(this, last).text.length),
          text: this.splitLines(code2),
          origin: "setValue",
          full: true
        }, true);
        if (this.cm) {
          scrollToCoords(this.cm, 0, 0);
        }
        setSelection(this, simpleSelection(top), sel_dontScroll);
      }),
      replaceRange: function(code2, from, to, origin) {
        from = clipPos(this, from);
        to = to ? clipPos(this, to) : from;
        replaceRange(this, code2, from, to, origin);
      },
      getRange: function(from, to, lineSep) {
        var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
        if (lineSep === false) {
          return lines;
        }
        if (lineSep === "") {
          return lines.join("");
        }
        return lines.join(lineSep || this.lineSeparator());
      },
      getLine: function(line) {
        var l = this.getLineHandle(line);
        return l && l.text;
      },
      getLineHandle: function(line) {
        if (isLine(this, line)) {
          return getLine(this, line);
        }
      },
      getLineNumber: function(line) {
        return lineNo(line);
      },
      getLineHandleVisualStart: function(line) {
        if (typeof line == "number") {
          line = getLine(this, line);
        }
        return visualLine(line);
      },
      lineCount: function() {
        return this.size;
      },
      firstLine: function() {
        return this.first;
      },
      lastLine: function() {
        return this.first + this.size - 1;
      },
      clipPos: function(pos) {
        return clipPos(this, pos);
      },
      getCursor: function(start) {
        var range2 = this.sel.primary(), pos;
        if (start == null || start == "head") {
          pos = range2.head;
        } else if (start == "anchor") {
          pos = range2.anchor;
        } else if (start == "end" || start == "to" || start === false) {
          pos = range2.to();
        } else {
          pos = range2.from();
        }
        return pos;
      },
      listSelections: function() {
        return this.sel.ranges;
      },
      somethingSelected: function() {
        return this.sel.somethingSelected();
      },
      setCursor: docMethodOp(function(line, ch, options) {
        setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
      }),
      setSelection: docMethodOp(function(anchor, head, options) {
        setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
      }),
      extendSelection: docMethodOp(function(head, other, options) {
        extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
      }),
      extendSelections: docMethodOp(function(heads, options) {
        extendSelections(this, clipPosArray(this, heads), options);
      }),
      extendSelectionsBy: docMethodOp(function(f, options) {
        var heads = map(this.sel.ranges, f);
        extendSelections(this, clipPosArray(this, heads), options);
      }),
      setSelections: docMethodOp(function(ranges, primary, options) {
        if (!ranges.length) {
          return;
        }
        var out = [];
        for (var i2 = 0; i2 < ranges.length; i2++) {
          out[i2] = new Range(
            clipPos(this, ranges[i2].anchor),
            clipPos(this, ranges[i2].head || ranges[i2].anchor)
          );
        }
        if (primary == null) {
          primary = Math.min(ranges.length - 1, this.sel.primIndex);
        }
        setSelection(this, normalizeSelection(this.cm, out, primary), options);
      }),
      addSelection: docMethodOp(function(anchor, head, options) {
        var ranges = this.sel.ranges.slice(0);
        ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
        setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
      }),
      getSelection: function(lineSep) {
        var ranges = this.sel.ranges, lines;
        for (var i2 = 0; i2 < ranges.length; i2++) {
          var sel = getBetween(this, ranges[i2].from(), ranges[i2].to());
          lines = lines ? lines.concat(sel) : sel;
        }
        if (lineSep === false) {
          return lines;
        } else {
          return lines.join(lineSep || this.lineSeparator());
        }
      },
      getSelections: function(lineSep) {
        var parts = [], ranges = this.sel.ranges;
        for (var i2 = 0; i2 < ranges.length; i2++) {
          var sel = getBetween(this, ranges[i2].from(), ranges[i2].to());
          if (lineSep !== false) {
            sel = sel.join(lineSep || this.lineSeparator());
          }
          parts[i2] = sel;
        }
        return parts;
      },
      replaceSelection: function(code2, collapse, origin) {
        var dup = [];
        for (var i2 = 0; i2 < this.sel.ranges.length; i2++) {
          dup[i2] = code2;
        }
        this.replaceSelections(dup, collapse, origin || "+input");
      },
      replaceSelections: docMethodOp(function(code2, collapse, origin) {
        var changes = [], sel = this.sel;
        for (var i2 = 0; i2 < sel.ranges.length; i2++) {
          var range2 = sel.ranges[i2];
          changes[i2] = { from: range2.from(), to: range2.to(), text: this.splitLines(code2[i2]), origin };
        }
        var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
        for (var i$12 = changes.length - 1; i$12 >= 0; i$12--) {
          makeChange(this, changes[i$12]);
        }
        if (newSel) {
          setSelectionReplaceHistory(this, newSel);
        } else if (this.cm) {
          ensureCursorVisible(this.cm);
        }
      }),
      undo: docMethodOp(function() {
        makeChangeFromHistory(this, "undo");
      }),
      redo: docMethodOp(function() {
        makeChangeFromHistory(this, "redo");
      }),
      undoSelection: docMethodOp(function() {
        makeChangeFromHistory(this, "undo", true);
      }),
      redoSelection: docMethodOp(function() {
        makeChangeFromHistory(this, "redo", true);
      }),
      setExtending: function(val) {
        this.extend = val;
      },
      getExtending: function() {
        return this.extend;
      },
      historySize: function() {
        var hist = this.history, done = 0, undone = 0;
        for (var i2 = 0; i2 < hist.done.length; i2++) {
          if (!hist.done[i2].ranges) {
            ++done;
          }
        }
        for (var i$12 = 0; i$12 < hist.undone.length; i$12++) {
          if (!hist.undone[i$12].ranges) {
            ++undone;
          }
        }
        return { undo: done, redo: undone };
      },
      clearHistory: function() {
        var this$1$1 = this;
        this.history = new History(this.history);
        linkedDocs(this, function(doc2) {
          return doc2.history = this$1$1.history;
        }, true);
      },
      markClean: function() {
        this.cleanGeneration = this.changeGeneration(true);
      },
      changeGeneration: function(forceSplit) {
        if (forceSplit) {
          this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
        }
        return this.history.generation;
      },
      isClean: function(gen) {
        return this.history.generation == (gen || this.cleanGeneration);
      },
      getHistory: function() {
        return {
          done: copyHistoryArray(this.history.done),
          undone: copyHistoryArray(this.history.undone)
        };
      },
      setHistory: function(histData) {
        var hist = this.history = new History(this.history);
        hist.done = copyHistoryArray(histData.done.slice(0), null, true);
        hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
      },
      setGutterMarker: docMethodOp(function(line, gutterID, value) {
        return changeLine(this, line, "gutter", function(line2) {
          var markers = line2.gutterMarkers || (line2.gutterMarkers = {});
          markers[gutterID] = value;
          if (!value && isEmpty(markers)) {
            line2.gutterMarkers = null;
          }
          return true;
        });
      }),
      clearGutter: docMethodOp(function(gutterID) {
        var this$1$1 = this;
        this.iter(function(line) {
          if (line.gutterMarkers && line.gutterMarkers[gutterID]) {
            changeLine(this$1$1, line, "gutter", function() {
              line.gutterMarkers[gutterID] = null;
              if (isEmpty(line.gutterMarkers)) {
                line.gutterMarkers = null;
              }
              return true;
            });
          }
        });
      }),
      lineInfo: function(line) {
        var n;
        if (typeof line == "number") {
          if (!isLine(this, line)) {
            return null;
          }
          n = line;
          line = getLine(this, line);
          if (!line) {
            return null;
          }
        } else {
          n = lineNo(line);
          if (n == null) {
            return null;
          }
        }
        return {
          line: n,
          handle: line,
          text: line.text,
          gutterMarkers: line.gutterMarkers,
          textClass: line.textClass,
          bgClass: line.bgClass,
          wrapClass: line.wrapClass,
          widgets: line.widgets
        };
      },
      addLineClass: docMethodOp(function(handle, where, cls) {
        return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
          var prop2 = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
          if (!line[prop2]) {
            line[prop2] = cls;
          } else if (classTest(cls).test(line[prop2])) {
            return false;
          } else {
            line[prop2] += " " + cls;
          }
          return true;
        });
      }),
      removeLineClass: docMethodOp(function(handle, where, cls) {
        return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
          var prop2 = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
          var cur = line[prop2];
          if (!cur) {
            return false;
          } else if (cls == null) {
            line[prop2] = null;
          } else {
            var found = cur.match(classTest(cls));
            if (!found) {
              return false;
            }
            var end = found.index + found[0].length;
            line[prop2] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
          }
          return true;
        });
      }),
      addLineWidget: docMethodOp(function(handle, node, options) {
        return addLineWidget(this, handle, node, options);
      }),
      removeLineWidget: function(widget) {
        widget.clear();
      },
      markText: function(from, to, options) {
        return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range");
      },
      setBookmark: function(pos, options) {
        var realOpts = {
          replacedWith: options && (options.nodeType == null ? options.widget : options),
          insertLeft: options && options.insertLeft,
          clearWhenEmpty: false,
          shared: options && options.shared,
          handleMouseEvents: options && options.handleMouseEvents
        };
        pos = clipPos(this, pos);
        return markText(this, pos, pos, realOpts, "bookmark");
      },
      findMarksAt: function(pos) {
        pos = clipPos(this, pos);
        var markers = [], spans = getLine(this, pos.line).markedSpans;
        if (spans) {
          for (var i2 = 0; i2 < spans.length; ++i2) {
            var span = spans[i2];
            if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) {
              markers.push(span.marker.parent || span.marker);
            }
          }
        }
        return markers;
      },
      findMarks: function(from, to, filter) {
        from = clipPos(this, from);
        to = clipPos(this, to);
        var found = [], lineNo2 = from.line;
        this.iter(from.line, to.line + 1, function(line) {
          var spans = line.markedSpans;
          if (spans) {
            for (var i2 = 0; i2 < spans.length; i2++) {
              var span = spans[i2];
              if (!(span.to != null && lineNo2 == from.line && from.ch >= span.to || span.from == null && lineNo2 != from.line || span.from != null && lineNo2 == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) {
                found.push(span.marker.parent || span.marker);
              }
            }
          }
          ++lineNo2;
        });
        return found;
      },
      getAllMarks: function() {
        var markers = [];
        this.iter(function(line) {
          var sps = line.markedSpans;
          if (sps) {
            for (var i2 = 0; i2 < sps.length; ++i2) {
              if (sps[i2].from != null) {
                markers.push(sps[i2].marker);
              }
            }
          }
        });
        return markers;
      },
      posFromIndex: function(off3) {
        var ch, lineNo2 = this.first, sepSize = this.lineSeparator().length;
        this.iter(function(line) {
          var sz = line.text.length + sepSize;
          if (sz > off3) {
            ch = off3;
            return true;
          }
          off3 -= sz;
          ++lineNo2;
        });
        return clipPos(this, Pos(lineNo2, ch));
      },
      indexFromPos: function(coords) {
        coords = clipPos(this, coords);
        var index2 = coords.ch;
        if (coords.line < this.first || coords.ch < 0) {
          return 0;
        }
        var sepSize = this.lineSeparator().length;
        this.iter(this.first, coords.line, function(line) {
          index2 += line.text.length + sepSize;
        });
        return index2;
      },
      copy: function(copyHistory) {
        var doc2 = new Doc(
          getLines(this, this.first, this.first + this.size),
          this.modeOption,
          this.first,
          this.lineSep,
          this.direction
        );
        doc2.scrollTop = this.scrollTop;
        doc2.scrollLeft = this.scrollLeft;
        doc2.sel = this.sel;
        doc2.extend = false;
        if (copyHistory) {
          doc2.history.undoDepth = this.history.undoDepth;
          doc2.setHistory(this.getHistory());
        }
        return doc2;
      },
      linkedDoc: function(options) {
        if (!options) {
          options = {};
        }
        var from = this.first, to = this.first + this.size;
        if (options.from != null && options.from > from) {
          from = options.from;
        }
        if (options.to != null && options.to < to) {
          to = options.to;
        }
        var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
        if (options.sharedHist) {
          copy.history = this.history;
        }
        (this.linked || (this.linked = [])).push({ doc: copy, sharedHist: options.sharedHist });
        copy.linked = [{ doc: this, isParent: true, sharedHist: options.sharedHist }];
        copySharedMarkers(copy, findSharedMarkers(this));
        return copy;
      },
      unlinkDoc: function(other) {
        if (other instanceof CodeMirror2) {
          other = other.doc;
        }
        if (this.linked) {
          for (var i2 = 0; i2 < this.linked.length; ++i2) {
            var link = this.linked[i2];
            if (link.doc != other) {
              continue;
            }
            this.linked.splice(i2, 1);
            other.unlinkDoc(this);
            detachSharedMarkers(findSharedMarkers(this));
            break;
          }
        }
        if (other.history == this.history) {
          var splitIds = [other.id];
          linkedDocs(other, function(doc2) {
            return splitIds.push(doc2.id);
          }, true);
          other.history = new History(null);
          other.history.done = copyHistoryArray(this.history.done, splitIds);
          other.history.undone = copyHistoryArray(this.history.undone, splitIds);
        }
      },
      iterLinkedDocs: function(f) {
        linkedDocs(this, f);
      },
      getMode: function() {
        return this.mode;
      },
      getEditor: function() {
        return this.cm;
      },
      splitLines: function(str) {
        if (this.lineSep) {
          return str.split(this.lineSep);
        }
        return splitLinesAuto(str);
      },
      lineSeparator: function() {
        return this.lineSep || "\n";
      },
      setDirection: docMethodOp(function(dir) {
        if (dir != "rtl") {
          dir = "ltr";
        }
        if (dir == this.direction) {
          return;
        }
        this.direction = dir;
        this.iter(function(line) {
          return line.order = null;
        });
        if (this.cm) {
          directionChanged(this.cm);
        }
      })
    });
    Doc.prototype.eachLine = Doc.prototype.iter;
    var lastDrop = 0;
    function onDrop(e) {
      var cm = this;
      clearDragCursor(cm);
      if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
        return;
      }
      e_preventDefault(e);
      if (ie) {
        lastDrop = +new Date();
      }
      var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
      if (!pos || cm.isReadOnly()) {
        return;
      }
      if (files && files.length && window.FileReader && window.File) {
        var n = files.length, text = Array(n), read = 0;
        var markAsReadAndPasteIfAllFilesAreRead = function() {
          if (++read == n) {
            operation(cm, function() {
              pos = clipPos(cm.doc, pos);
              var change2 = {
                from: pos,
                to: pos,
                text: cm.doc.splitLines(
                  text.filter(function(t) {
                    return t != null;
                  }).join(cm.doc.lineSeparator())
                ),
                origin: "paste"
              };
              makeChange(cm.doc, change2);
              setSelectionReplaceHistory(cm.doc, simpleSelection(clipPos(cm.doc, pos), clipPos(cm.doc, changeEnd(change2))));
            })();
          }
        };
        var readTextFromFile = function(file, i3) {
          if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) {
            markAsReadAndPasteIfAllFilesAreRead();
            return;
          }
          var reader = new FileReader();
          reader.onerror = function() {
            return markAsReadAndPasteIfAllFilesAreRead();
          };
          reader.onload = function() {
            var content = reader.result;
            if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) {
              markAsReadAndPasteIfAllFilesAreRead();
              return;
            }
            text[i3] = content;
            markAsReadAndPasteIfAllFilesAreRead();
          };
          reader.readAsText(file);
        };
        for (var i2 = 0; i2 < files.length; i2++) {
          readTextFromFile(files[i2], i2);
        }
      } else {
        if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
          cm.state.draggingText(e);
          setTimeout(function() {
            return cm.display.input.focus();
          }, 20);
          return;
        }
        try {
          var text$1 = e.dataTransfer.getData("Text");
          if (text$1) {
            var selected;
            if (cm.state.draggingText && !cm.state.draggingText.copy) {
              selected = cm.listSelections();
            }
            setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
            if (selected) {
              for (var i$12 = 0; i$12 < selected.length; ++i$12) {
                replaceRange(cm.doc, "", selected[i$12].anchor, selected[i$12].head, "drag");
              }
            }
            cm.replaceSelection(text$1, "around", "paste");
            cm.display.input.focus();
          }
        } catch (e$1) {
        }
      }
    }
    function onDragStart(cm, e) {
      if (ie && (!cm.state.draggingText || +new Date() - lastDrop < 100)) {
        e_stop(e);
        return;
      }
      if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) {
        return;
      }
      e.dataTransfer.setData("Text", cm.getSelection());
      e.dataTransfer.effectAllowed = "copyMove";
      if (e.dataTransfer.setDragImage && !safari) {
        var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
        img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
        if (presto) {
          img.width = img.height = 1;
          cm.display.wrapper.appendChild(img);
          img._top = img.offsetTop;
        }
        e.dataTransfer.setDragImage(img, 0, 0);
        if (presto) {
          img.parentNode.removeChild(img);
        }
      }
    }
    function onDragOver(cm, e) {
      var pos = posFromMouse(cm, e);
      if (!pos) {
        return;
      }
      var frag = document.createDocumentFragment();
      drawSelectionCursor(cm, pos, frag);
      if (!cm.display.dragCursor) {
        cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
        cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
      }
      removeChildrenAndAdd(cm.display.dragCursor, frag);
    }
    function clearDragCursor(cm) {
      if (cm.display.dragCursor) {
        cm.display.lineSpace.removeChild(cm.display.dragCursor);
        cm.display.dragCursor = null;
      }
    }
    function forEachCodeMirror(f) {
      if (!document.getElementsByClassName) {
        return;
      }
      var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
      for (var i2 = 0; i2 < byClass.length; i2++) {
        var cm = byClass[i2].CodeMirror;
        if (cm) {
          editors.push(cm);
        }
      }
      if (editors.length) {
        editors[0].operation(function() {
          for (var i3 = 0; i3 < editors.length; i3++) {
            f(editors[i3]);
          }
        });
      }
    }
    var globalsRegistered = false;
    function ensureGlobalHandlers() {
      if (globalsRegistered) {
        return;
      }
      registerGlobalHandlers();
      globalsRegistered = true;
    }
    function registerGlobalHandlers() {
      var resizeTimer;
      on2(window, "resize", function() {
        if (resizeTimer == null) {
          resizeTimer = setTimeout(function() {
            resizeTimer = null;
            forEachCodeMirror(onResize);
          }, 100);
        }
      });
      on2(window, "blur", function() {
        return forEachCodeMirror(onBlur);
      });
    }
    function onResize(cm) {
      var d = cm.display;
      d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
      d.scrollbarsClipped = false;
      cm.setSize();
    }
    var keyNames = {
      3: "Pause",
      8: "Backspace",
      9: "Tab",
      13: "Enter",
      16: "Shift",
      17: "Ctrl",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Esc",
      32: "Space",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "Left",
      38: "Up",
      39: "Right",
      40: "Down",
      44: "PrintScrn",
      45: "Insert",
      46: "Delete",
      59: ";",
      61: "=",
      91: "Mod",
      92: "Mod",
      93: "Mod",
      106: "*",
      107: "=",
      109: "-",
      110: ".",
      111: "/",
      145: "ScrollLock",
      173: "-",
      186: ";",
      187: "=",
      188: ",",
      189: "-",
      190: ".",
      191: "/",
      192: "`",
      219: "[",
      220: "\\",
      221: "]",
      222: "'",
      224: "Mod",
      63232: "Up",
      63233: "Down",
      63234: "Left",
      63235: "Right",
      63272: "Delete",
      63273: "Home",
      63275: "End",
      63276: "PageUp",
      63277: "PageDown",
      63302: "Insert"
    };
    for (var i = 0; i < 10; i++) {
      keyNames[i + 48] = keyNames[i + 96] = String(i);
    }
    for (var i$1 = 65; i$1 <= 90; i$1++) {
      keyNames[i$1] = String.fromCharCode(i$1);
    }
    for (var i$2 = 1; i$2 <= 12; i$2++) {
      keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
    }
    var keyMap = {};
    keyMap.basic = {
      "Left": "goCharLeft",
      "Right": "goCharRight",
      "Up": "goLineUp",
      "Down": "goLineDown",
      "End": "goLineEnd",
      "Home": "goLineStartSmart",
      "PageUp": "goPageUp",
      "PageDown": "goPageDown",
      "Delete": "delCharAfter",
      "Backspace": "delCharBefore",
      "Shift-Backspace": "delCharBefore",
      "Tab": "defaultTab",
      "Shift-Tab": "indentAuto",
      "Enter": "newlineAndIndent",
      "Insert": "toggleOverwrite",
      "Esc": "singleSelection"
    };
    keyMap.pcDefault = {
      "Ctrl-A": "selectAll",
      "Ctrl-D": "deleteLine",
      "Ctrl-Z": "undo",
      "Shift-Ctrl-Z": "redo",
      "Ctrl-Y": "redo",
      "Ctrl-Home": "goDocStart",
      "Ctrl-End": "goDocEnd",
      "Ctrl-Up": "goLineUp",
      "Ctrl-Down": "goLineDown",
      "Ctrl-Left": "goGroupLeft",
      "Ctrl-Right": "goGroupRight",
      "Alt-Left": "goLineStart",
      "Alt-Right": "goLineEnd",
      "Ctrl-Backspace": "delGroupBefore",
      "Ctrl-Delete": "delGroupAfter",
      "Ctrl-S": "save",
      "Ctrl-F": "find",
      "Ctrl-G": "findNext",
      "Shift-Ctrl-G": "findPrev",
      "Shift-Ctrl-F": "replace",
      "Shift-Ctrl-R": "replaceAll",
      "Ctrl-[": "indentLess",
      "Ctrl-]": "indentMore",
      "Ctrl-U": "undoSelection",
      "Shift-Ctrl-U": "redoSelection",
      "Alt-U": "redoSelection",
      "fallthrough": "basic"
    };
    keyMap.emacsy = {
      "Ctrl-F": "goCharRight",
      "Ctrl-B": "goCharLeft",
      "Ctrl-P": "goLineUp",
      "Ctrl-N": "goLineDown",
      "Ctrl-A": "goLineStart",
      "Ctrl-E": "goLineEnd",
      "Ctrl-V": "goPageDown",
      "Shift-Ctrl-V": "goPageUp",
      "Ctrl-D": "delCharAfter",
      "Ctrl-H": "delCharBefore",
      "Alt-Backspace": "delWordBefore",
      "Ctrl-K": "killLine",
      "Ctrl-T": "transposeChars",
      "Ctrl-O": "openLine"
    };
    keyMap.macDefault = {
      "Cmd-A": "selectAll",
      "Cmd-D": "deleteLine",
      "Cmd-Z": "undo",
      "Shift-Cmd-Z": "redo",
      "Cmd-Y": "redo",
      "Cmd-Home": "goDocStart",
      "Cmd-Up": "goDocStart",
      "Cmd-End": "goDocEnd",
      "Cmd-Down": "goDocEnd",
      "Alt-Left": "goGroupLeft",
      "Alt-Right": "goGroupRight",
      "Cmd-Left": "goLineLeft",
      "Cmd-Right": "goLineRight",
      "Alt-Backspace": "delGroupBefore",
      "Ctrl-Alt-Backspace": "delGroupAfter",
      "Alt-Delete": "delGroupAfter",
      "Cmd-S": "save",
      "Cmd-F": "find",
      "Cmd-G": "findNext",
      "Shift-Cmd-G": "findPrev",
      "Cmd-Alt-F": "replace",
      "Shift-Cmd-Alt-F": "replaceAll",
      "Cmd-[": "indentLess",
      "Cmd-]": "indentMore",
      "Cmd-Backspace": "delWrappedLineLeft",
      "Cmd-Delete": "delWrappedLineRight",
      "Cmd-U": "undoSelection",
      "Shift-Cmd-U": "redoSelection",
      "Ctrl-Up": "goDocStart",
      "Ctrl-Down": "goDocEnd",
      "fallthrough": ["basic", "emacsy"]
    };
    keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
    function normalizeKeyName(name) {
      var parts = name.split(/-(?!$)/);
      name = parts[parts.length - 1];
      var alt, ctrl, shift, cmd;
      for (var i2 = 0; i2 < parts.length - 1; i2++) {
        var mod = parts[i2];
        if (/^(cmd|meta|m)$/i.test(mod)) {
          cmd = true;
        } else if (/^a(lt)?$/i.test(mod)) {
          alt = true;
        } else if (/^(c|ctrl|control)$/i.test(mod)) {
          ctrl = true;
        } else if (/^s(hift)?$/i.test(mod)) {
          shift = true;
        } else {
          throw new Error("Unrecognized modifier name: " + mod);
        }
      }
      if (alt) {
        name = "Alt-" + name;
      }
      if (ctrl) {
        name = "Ctrl-" + name;
      }
      if (cmd) {
        name = "Cmd-" + name;
      }
      if (shift) {
        name = "Shift-" + name;
      }
      return name;
    }
    function normalizeKeyMap(keymap) {
      var copy = {};
      for (var keyname in keymap) {
        if (keymap.hasOwnProperty(keyname)) {
          var value = keymap[keyname];
          if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) {
            continue;
          }
          if (value == "...") {
            delete keymap[keyname];
            continue;
          }
          var keys = map(keyname.split(" "), normalizeKeyName);
          for (var i2 = 0; i2 < keys.length; i2++) {
            var val = void 0, name = void 0;
            if (i2 == keys.length - 1) {
              name = keys.join(" ");
              val = value;
            } else {
              name = keys.slice(0, i2 + 1).join(" ");
              val = "...";
            }
            var prev2 = copy[name];
            if (!prev2) {
              copy[name] = val;
            } else if (prev2 != val) {
              throw new Error("Inconsistent bindings for " + name);
            }
          }
          delete keymap[keyname];
        }
      }
      for (var prop2 in copy) {
        keymap[prop2] = copy[prop2];
      }
      return keymap;
    }
    function lookupKey(key, map2, handle, context) {
      map2 = getKeyMap(map2);
      var found = map2.call ? map2.call(key, context) : map2[key];
      if (found === false) {
        return "nothing";
      }
      if (found === "...") {
        return "multi";
      }
      if (found != null && handle(found)) {
        return "handled";
      }
      if (map2.fallthrough) {
        if (Object.prototype.toString.call(map2.fallthrough) != "[object Array]") {
          return lookupKey(key, map2.fallthrough, handle, context);
        }
        for (var i2 = 0; i2 < map2.fallthrough.length; i2++) {
          var result = lookupKey(key, map2.fallthrough[i2], handle, context);
          if (result) {
            return result;
          }
        }
      }
    }
    function isModifierKey(value) {
      var name = typeof value == "string" ? value : keyNames[value.keyCode];
      return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
    }
    function addModifierNames(name, event, noShift) {
      var base = name;
      if (event.altKey && base != "Alt") {
        name = "Alt-" + name;
      }
      if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") {
        name = "Ctrl-" + name;
      }
      if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Mod") {
        name = "Cmd-" + name;
      }
      if (!noShift && event.shiftKey && base != "Shift") {
        name = "Shift-" + name;
      }
      return name;
    }
    function keyName(event, noShift) {
      if (presto && event.keyCode == 34 && event["char"]) {
        return false;
      }
      var name = keyNames[event.keyCode];
      if (name == null || event.altGraphKey) {
        return false;
      }
      if (event.keyCode == 3 && event.code) {
        name = event.code;
      }
      return addModifierNames(name, event, noShift);
    }
    function getKeyMap(val) {
      return typeof val == "string" ? keyMap[val] : val;
    }
    function deleteNearSelection(cm, compute) {
      var ranges = cm.doc.sel.ranges, kill = [];
      for (var i2 = 0; i2 < ranges.length; i2++) {
        var toKill = compute(ranges[i2]);
        while (kill.length && cmp(toKill.from, lst(kill).to) <= 0) {
          var replaced = kill.pop();
          if (cmp(replaced.from, toKill.from) < 0) {
            toKill.from = replaced.from;
            break;
          }
        }
        kill.push(toKill);
      }
      runInOp(cm, function() {
        for (var i3 = kill.length - 1; i3 >= 0; i3--) {
          replaceRange(cm.doc, "", kill[i3].from, kill[i3].to, "+delete");
        }
        ensureCursorVisible(cm);
      });
    }
    function moveCharLogically(line, ch, dir) {
      var target = skipExtendingChars(line.text, ch + dir, dir);
      return target < 0 || target > line.text.length ? null : target;
    }
    function moveLogically(line, start, dir) {
      var ch = moveCharLogically(line, start.ch, dir);
      return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
    }
    function endOfLine(visually, cm, lineObj, lineNo2, dir) {
      if (visually) {
        if (cm.doc.direction == "rtl") {
          dir = -dir;
        }
        var order = getOrder(lineObj, cm.doc.direction);
        if (order) {
          var part = dir < 0 ? lst(order) : order[0];
          var moveInStorageOrder = dir < 0 == (part.level == 1);
          var sticky = moveInStorageOrder ? "after" : "before";
          var ch;
          if (part.level > 0 || cm.doc.direction == "rtl") {
            var prep = prepareMeasureForLine(cm, lineObj);
            ch = dir < 0 ? lineObj.text.length - 1 : 0;
            var targetTop = measureCharPrepared(cm, prep, ch).top;
            ch = findFirst(function(ch2) {
              return measureCharPrepared(cm, prep, ch2).top == targetTop;
            }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
            if (sticky == "before") {
              ch = moveCharLogically(lineObj, ch, 1);
            }
          } else {
            ch = dir < 0 ? part.to : part.from;
          }
          return new Pos(lineNo2, ch, sticky);
        }
      }
      return new Pos(lineNo2, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
    }
    function moveVisually(cm, line, start, dir) {
      var bidi = getOrder(line, cm.doc.direction);
      if (!bidi) {
        return moveLogically(line, start, dir);
      }
      if (start.ch >= line.text.length) {
        start.ch = line.text.length;
        start.sticky = "before";
      } else if (start.ch <= 0) {
        start.ch = 0;
        start.sticky = "after";
      }
      var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
      if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) {
        return moveLogically(line, start, dir);
      }
      var mv = function(pos, dir2) {
        return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir2);
      };
      var prep;
      var getWrappedLineExtent = function(ch2) {
        if (!cm.options.lineWrapping) {
          return { begin: 0, end: line.text.length };
        }
        prep = prep || prepareMeasureForLine(cm, line);
        return wrappedLineExtentChar(cm, line, prep, ch2);
      };
      var wrappedLineExtent2 = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
      if (cm.doc.direction == "rtl" || part.level == 1) {
        var moveInStorageOrder = part.level == 1 == dir < 0;
        var ch = mv(start, moveInStorageOrder ? 1 : -1);
        if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent2.begin : ch <= part.to && ch <= wrappedLineExtent2.end)) {
          var sticky = moveInStorageOrder ? "before" : "after";
          return new Pos(start.line, ch, sticky);
        }
      }
      var searchInVisualLine = function(partPos2, dir2, wrappedLineExtent3) {
        var getRes = function(ch3, moveInStorageOrder3) {
          return moveInStorageOrder3 ? new Pos(start.line, mv(ch3, 1), "before") : new Pos(start.line, ch3, "after");
        };
        for (; partPos2 >= 0 && partPos2 < bidi.length; partPos2 += dir2) {
          var part2 = bidi[partPos2];
          var moveInStorageOrder2 = dir2 > 0 == (part2.level != 1);
          var ch2 = moveInStorageOrder2 ? wrappedLineExtent3.begin : mv(wrappedLineExtent3.end, -1);
          if (part2.from <= ch2 && ch2 < part2.to) {
            return getRes(ch2, moveInStorageOrder2);
          }
          ch2 = moveInStorageOrder2 ? part2.from : mv(part2.to, -1);
          if (wrappedLineExtent3.begin <= ch2 && ch2 < wrappedLineExtent3.end) {
            return getRes(ch2, moveInStorageOrder2);
          }
        }
      };
      var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent2);
      if (res) {
        return res;
      }
      var nextCh = dir > 0 ? wrappedLineExtent2.end : mv(wrappedLineExtent2.begin, -1);
      if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
        res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
        if (res) {
          return res;
        }
      }
      return null;
    }
    var commands = {
      selectAll,
      singleSelection: function(cm) {
        return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
      },
      killLine: function(cm) {
        return deleteNearSelection(cm, function(range2) {
          if (range2.empty()) {
            var len = getLine(cm.doc, range2.head.line).text.length;
            if (range2.head.ch == len && range2.head.line < cm.lastLine()) {
              return { from: range2.head, to: Pos(range2.head.line + 1, 0) };
            } else {
              return { from: range2.head, to: Pos(range2.head.line, len) };
            }
          } else {
            return { from: range2.from(), to: range2.to() };
          }
        });
      },
      deleteLine: function(cm) {
        return deleteNearSelection(cm, function(range2) {
          return {
            from: Pos(range2.from().line, 0),
            to: clipPos(cm.doc, Pos(range2.to().line + 1, 0))
          };
        });
      },
      delLineLeft: function(cm) {
        return deleteNearSelection(cm, function(range2) {
          return {
            from: Pos(range2.from().line, 0),
            to: range2.from()
          };
        });
      },
      delWrappedLineLeft: function(cm) {
        return deleteNearSelection(cm, function(range2) {
          var top = cm.charCoords(range2.head, "div").top + 5;
          var leftPos = cm.coordsChar({ left: 0, top }, "div");
          return { from: leftPos, to: range2.from() };
        });
      },
      delWrappedLineRight: function(cm) {
        return deleteNearSelection(cm, function(range2) {
          var top = cm.charCoords(range2.head, "div").top + 5;
          var rightPos = cm.coordsChar({ left: cm.display.lineDiv.offsetWidth + 100, top }, "div");
          return { from: range2.from(), to: rightPos };
        });
      },
      undo: function(cm) {
        return cm.undo();
      },
      redo: function(cm) {
        return cm.redo();
      },
      undoSelection: function(cm) {
        return cm.undoSelection();
      },
      redoSelection: function(cm) {
        return cm.redoSelection();
      },
      goDocStart: function(cm) {
        return cm.extendSelection(Pos(cm.firstLine(), 0));
      },
      goDocEnd: function(cm) {
        return cm.extendSelection(Pos(cm.lastLine()));
      },
      goLineStart: function(cm) {
        return cm.extendSelectionsBy(
          function(range2) {
            return lineStart(cm, range2.head.line);
          },
          { origin: "+move", bias: 1 }
        );
      },
      goLineStartSmart: function(cm) {
        return cm.extendSelectionsBy(
          function(range2) {
            return lineStartSmart(cm, range2.head);
          },
          { origin: "+move", bias: 1 }
        );
      },
      goLineEnd: function(cm) {
        return cm.extendSelectionsBy(
          function(range2) {
            return lineEnd(cm, range2.head.line);
          },
          { origin: "+move", bias: -1 }
        );
      },
      goLineRight: function(cm) {
        return cm.extendSelectionsBy(function(range2) {
          var top = cm.cursorCoords(range2.head, "div").top + 5;
          return cm.coordsChar({ left: cm.display.lineDiv.offsetWidth + 100, top }, "div");
        }, sel_move);
      },
      goLineLeft: function(cm) {
        return cm.extendSelectionsBy(function(range2) {
          var top = cm.cursorCoords(range2.head, "div").top + 5;
          return cm.coordsChar({ left: 0, top }, "div");
        }, sel_move);
      },
      goLineLeftSmart: function(cm) {
        return cm.extendSelectionsBy(function(range2) {
          var top = cm.cursorCoords(range2.head, "div").top + 5;
          var pos = cm.coordsChar({ left: 0, top }, "div");
          if (pos.ch < cm.getLine(pos.line).search(/\S/)) {
            return lineStartSmart(cm, range2.head);
          }
          return pos;
        }, sel_move);
      },
      goLineUp: function(cm) {
        return cm.moveV(-1, "line");
      },
      goLineDown: function(cm) {
        return cm.moveV(1, "line");
      },
      goPageUp: function(cm) {
        return cm.moveV(-1, "page");
      },
      goPageDown: function(cm) {
        return cm.moveV(1, "page");
      },
      goCharLeft: function(cm) {
        return cm.moveH(-1, "char");
      },
      goCharRight: function(cm) {
        return cm.moveH(1, "char");
      },
      goColumnLeft: function(cm) {
        return cm.moveH(-1, "column");
      },
      goColumnRight: function(cm) {
        return cm.moveH(1, "column");
      },
      goWordLeft: function(cm) {
        return cm.moveH(-1, "word");
      },
      goGroupRight: function(cm) {
        return cm.moveH(1, "group");
      },
      goGroupLeft: function(cm) {
        return cm.moveH(-1, "group");
      },
      goWordRight: function(cm) {
        return cm.moveH(1, "word");
      },
      delCharBefore: function(cm) {
        return cm.deleteH(-1, "codepoint");
      },
      delCharAfter: function(cm) {
        return cm.deleteH(1, "char");
      },
      delWordBefore: function(cm) {
        return cm.deleteH(-1, "word");
      },
      delWordAfter: function(cm) {
        return cm.deleteH(1, "word");
      },
      delGroupBefore: function(cm) {
        return cm.deleteH(-1, "group");
      },
      delGroupAfter: function(cm) {
        return cm.deleteH(1, "group");
      },
      indentAuto: function(cm) {
        return cm.indentSelection("smart");
      },
      indentMore: function(cm) {
        return cm.indentSelection("add");
      },
      indentLess: function(cm) {
        return cm.indentSelection("subtract");
      },
      insertTab: function(cm) {
        return cm.replaceSelection("	");
      },
      insertSoftTab: function(cm) {
        var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
        for (var i2 = 0; i2 < ranges.length; i2++) {
          var pos = ranges[i2].from();
          var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
          spaces.push(spaceStr(tabSize - col % tabSize));
        }
        cm.replaceSelections(spaces);
      },
      defaultTab: function(cm) {
        if (cm.somethingSelected()) {
          cm.indentSelection("add");
        } else {
          cm.execCommand("insertTab");
        }
      },
      transposeChars: function(cm) {
        return runInOp(cm, function() {
          var ranges = cm.listSelections(), newSel = [];
          for (var i2 = 0; i2 < ranges.length; i2++) {
            if (!ranges[i2].empty()) {
              continue;
            }
            var cur = ranges[i2].head, line = getLine(cm.doc, cur.line).text;
            if (line) {
              if (cur.ch == line.length) {
                cur = new Pos(cur.line, cur.ch - 1);
              }
              if (cur.ch > 0) {
                cur = new Pos(cur.line, cur.ch + 1);
                cm.replaceRange(
                  line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2),
                  Pos(cur.line, cur.ch - 2),
                  cur,
                  "+transpose"
                );
              } else if (cur.line > cm.doc.first) {
                var prev2 = getLine(cm.doc, cur.line - 1).text;
                if (prev2) {
                  cur = new Pos(cur.line, 1);
                  cm.replaceRange(
                    line.charAt(0) + cm.doc.lineSeparator() + prev2.charAt(prev2.length - 1),
                    Pos(cur.line - 1, prev2.length - 1),
                    cur,
                    "+transpose"
                  );
                }
              }
            }
            newSel.push(new Range(cur, cur));
          }
          cm.setSelections(newSel);
        });
      },
      newlineAndIndent: function(cm) {
        return runInOp(cm, function() {
          var sels = cm.listSelections();
          for (var i2 = sels.length - 1; i2 >= 0; i2--) {
            cm.replaceRange(cm.doc.lineSeparator(), sels[i2].anchor, sels[i2].head, "+input");
          }
          sels = cm.listSelections();
          for (var i$12 = 0; i$12 < sels.length; i$12++) {
            cm.indentLine(sels[i$12].from().line, null, true);
          }
          ensureCursorVisible(cm);
        });
      },
      openLine: function(cm) {
        return cm.replaceSelection("\n", "start");
      },
      toggleOverwrite: function(cm) {
        return cm.toggleOverwrite();
      }
    };
    function lineStart(cm, lineN) {
      var line = getLine(cm.doc, lineN);
      var visual = visualLine(line);
      if (visual != line) {
        lineN = lineNo(visual);
      }
      return endOfLine(true, cm, visual, lineN, 1);
    }
    function lineEnd(cm, lineN) {
      var line = getLine(cm.doc, lineN);
      var visual = visualLineEnd(line);
      if (visual != line) {
        lineN = lineNo(visual);
      }
      return endOfLine(true, cm, line, lineN, -1);
    }
    function lineStartSmart(cm, pos) {
      var start = lineStart(cm, pos.line);
      var line = getLine(cm.doc, start.line);
      var order = getOrder(line, cm.doc.direction);
      if (!order || order[0].level == 0) {
        var firstNonWS = Math.max(start.ch, line.text.search(/\S/));
        var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
        return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
      }
      return start;
    }
    function doHandleBinding(cm, bound, dropShift) {
      if (typeof bound == "string") {
        bound = commands[bound];
        if (!bound) {
          return false;
        }
      }
      cm.display.input.ensurePolled();
      var prevShift = cm.display.shift, done = false;
      try {
        if (cm.isReadOnly()) {
          cm.state.suppressEdits = true;
        }
        if (dropShift) {
          cm.display.shift = false;
        }
        done = bound(cm) != Pass;
      } finally {
        cm.display.shift = prevShift;
        cm.state.suppressEdits = false;
      }
      return done;
    }
    function lookupKeyForEditor(cm, name, handle) {
      for (var i2 = 0; i2 < cm.state.keyMaps.length; i2++) {
        var result = lookupKey(name, cm.state.keyMaps[i2], handle, cm);
        if (result) {
          return result;
        }
      }
      return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
    }
    var stopSeq = new Delayed();
    function dispatchKey(cm, name, e, handle) {
      var seq = cm.state.keySeq;
      if (seq) {
        if (isModifierKey(name)) {
          return "handled";
        }
        if (/\'$/.test(name)) {
          cm.state.keySeq = null;
        } else {
          stopSeq.set(50, function() {
            if (cm.state.keySeq == seq) {
              cm.state.keySeq = null;
              cm.display.input.reset();
            }
          });
        }
        if (dispatchKeyInner(cm, seq + " " + name, e, handle)) {
          return true;
        }
      }
      return dispatchKeyInner(cm, name, e, handle);
    }
    function dispatchKeyInner(cm, name, e, handle) {
      var result = lookupKeyForEditor(cm, name, handle);
      if (result == "multi") {
        cm.state.keySeq = name;
      }
      if (result == "handled") {
        signalLater(cm, "keyHandled", cm, name, e);
      }
      if (result == "handled" || result == "multi") {
        e_preventDefault(e);
        restartBlink(cm);
      }
      return !!result;
    }
    function handleKeyBinding(cm, e) {
      var name = keyName(e, true);
      if (!name) {
        return false;
      }
      if (e.shiftKey && !cm.state.keySeq) {
        return dispatchKey(cm, "Shift-" + name, e, function(b) {
          return doHandleBinding(cm, b, true);
        }) || dispatchKey(cm, name, e, function(b) {
          if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) {
            return doHandleBinding(cm, b);
          }
        });
      } else {
        return dispatchKey(cm, name, e, function(b) {
          return doHandleBinding(cm, b);
        });
      }
    }
    function handleCharBinding(cm, e, ch) {
      return dispatchKey(cm, "'" + ch + "'", e, function(b) {
        return doHandleBinding(cm, b, true);
      });
    }
    var lastStoppedKey = null;
    function onKeyDown(e) {
      var cm = this;
      if (e.target && e.target != cm.display.input.getField()) {
        return;
      }
      cm.curOp.focus = activeElt(root(cm));
      if (signalDOMEvent(cm, e)) {
        return;
      }
      if (ie && ie_version < 11 && e.keyCode == 27) {
        e.returnValue = false;
      }
      var code2 = e.keyCode;
      cm.display.shift = code2 == 16 || e.shiftKey;
      var handled = handleKeyBinding(cm, e);
      if (presto) {
        lastStoppedKey = handled ? code2 : null;
        if (!handled && code2 == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) {
          cm.replaceSelection("", null, "cut");
        }
      }
      if (gecko && !mac && !handled && code2 == 46 && e.shiftKey && !e.ctrlKey && document.execCommand) {
        document.execCommand("cut");
      }
      if (code2 == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) {
        showCrossHair(cm);
      }
    }
    function showCrossHair(cm) {
      var lineDiv = cm.display.lineDiv;
      addClass2(lineDiv, "CodeMirror-crosshair");
      function up(e) {
        if (e.keyCode == 18 || !e.altKey) {
          rmClass(lineDiv, "CodeMirror-crosshair");
          off2(document, "keyup", up);
          off2(document, "mouseover", up);
        }
      }
      on2(document, "keyup", up);
      on2(document, "mouseover", up);
    }
    function onKeyUp(e) {
      if (e.keyCode == 16) {
        this.doc.sel.shift = false;
      }
      signalDOMEvent(this, e);
    }
    function onKeyPress(e) {
      var cm = this;
      if (e.target && e.target != cm.display.input.getField()) {
        return;
      }
      if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) {
        return;
      }
      var keyCode = e.keyCode, charCode = e.charCode;
      if (presto && keyCode == lastStoppedKey) {
        lastStoppedKey = null;
        e_preventDefault(e);
        return;
      }
      if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) {
        return;
      }
      var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
      if (ch == "\b") {
        return;
      }
      if (handleCharBinding(cm, e, ch)) {
        return;
      }
      cm.display.input.onKeyPress(e);
    }
    var DOUBLECLICK_DELAY = 400;
    var PastClick = function(time, pos, button) {
      this.time = time;
      this.pos = pos;
      this.button = button;
    };
    PastClick.prototype.compare = function(time, pos, button) {
      return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
    };
    var lastClick, lastDoubleClick;
    function clickRepeat(pos, button) {
      var now = +new Date();
      if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
        lastClick = lastDoubleClick = null;
        return "triple";
      } else if (lastClick && lastClick.compare(now, pos, button)) {
        lastDoubleClick = new PastClick(now, pos, button);
        lastClick = null;
        return "double";
      } else {
        lastClick = new PastClick(now, pos, button);
        lastDoubleClick = null;
        return "single";
      }
    }
    function onMouseDown(e) {
      var cm = this, display = cm.display;
      if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) {
        return;
      }
      display.input.ensurePolled();
      display.shift = e.shiftKey;
      if (eventInWidget(display, e)) {
        if (!webkit) {
          display.scroller.draggable = false;
          setTimeout(function() {
            return display.scroller.draggable = true;
          }, 100);
        }
        return;
      }
      if (clickInGutter(cm, e)) {
        return;
      }
      var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
      win(cm).focus();
      if (button == 1 && cm.state.selectingText) {
        cm.state.selectingText(e);
      }
      if (pos && handleMappedButton(cm, button, pos, repeat, e)) {
        return;
      }
      if (button == 1) {
        if (pos) {
          leftButtonDown(cm, pos, repeat, e);
        } else if (e_target(e) == display.scroller) {
          e_preventDefault(e);
        }
      } else if (button == 2) {
        if (pos) {
          extendSelection(cm.doc, pos);
        }
        setTimeout(function() {
          return display.input.focus();
        }, 20);
      } else if (button == 3) {
        if (captureRightClick) {
          cm.display.input.onContextMenu(e);
        } else {
          delayBlurEvent(cm);
        }
      }
    }
    function handleMappedButton(cm, button, pos, repeat, event) {
      var name = "Click";
      if (repeat == "double") {
        name = "Double" + name;
      } else if (repeat == "triple") {
        name = "Triple" + name;
      }
      name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
      return dispatchKey(cm, addModifierNames(name, event), event, function(bound) {
        if (typeof bound == "string") {
          bound = commands[bound];
        }
        if (!bound) {
          return false;
        }
        var done = false;
        try {
          if (cm.isReadOnly()) {
            cm.state.suppressEdits = true;
          }
          done = bound(cm, pos) != Pass;
        } finally {
          cm.state.suppressEdits = false;
        }
        return done;
      });
    }
    function configureMouse(cm, repeat, event) {
      var option2 = cm.getOption("configureMouse");
      var value = option2 ? option2(cm, repeat, event) : {};
      if (value.unit == null) {
        var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
        value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
      }
      if (value.extend == null || cm.doc.extend) {
        value.extend = cm.doc.extend || event.shiftKey;
      }
      if (value.addNew == null) {
        value.addNew = mac ? event.metaKey : event.ctrlKey;
      }
      if (value.moveOnDrag == null) {
        value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
      }
      return value;
    }
    function leftButtonDown(cm, pos, repeat, event) {
      if (ie) {
        setTimeout(bind4(ensureFocus, cm), 0);
      } else {
        cm.curOp.focus = activeElt(root(cm));
      }
      var behavior = configureMouse(cm, repeat, event);
      var sel = cm.doc.sel, contained;
      if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) {
        leftButtonStartDrag(cm, event, pos, behavior);
      } else {
        leftButtonSelect(cm, event, pos, behavior);
      }
    }
    function leftButtonStartDrag(cm, event, pos, behavior) {
      var display = cm.display, moved2 = false;
      var dragEnd = operation(cm, function(e) {
        if (webkit) {
          display.scroller.draggable = false;
        }
        cm.state.draggingText = false;
        if (cm.state.delayingBlurEvent) {
          if (cm.hasFocus()) {
            cm.state.delayingBlurEvent = false;
          } else {
            delayBlurEvent(cm);
          }
        }
        off2(display.wrapper.ownerDocument, "mouseup", dragEnd);
        off2(display.wrapper.ownerDocument, "mousemove", mouseMove);
        off2(display.scroller, "dragstart", dragStart2);
        off2(display.scroller, "drop", dragEnd);
        if (!moved2) {
          e_preventDefault(e);
          if (!behavior.addNew) {
            extendSelection(cm.doc, pos, null, null, behavior.extend);
          }
          if (webkit && !safari || ie && ie_version == 9) {
            setTimeout(function() {
              display.wrapper.ownerDocument.body.focus({ preventScroll: true });
              display.input.focus();
            }, 20);
          } else {
            display.input.focus();
          }
        }
      });
      var mouseMove = function(e2) {
        moved2 = moved2 || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
      };
      var dragStart2 = function() {
        return moved2 = true;
      };
      if (webkit) {
        display.scroller.draggable = true;
      }
      cm.state.draggingText = dragEnd;
      dragEnd.copy = !behavior.moveOnDrag;
      on2(display.wrapper.ownerDocument, "mouseup", dragEnd);
      on2(display.wrapper.ownerDocument, "mousemove", mouseMove);
      on2(display.scroller, "dragstart", dragStart2);
      on2(display.scroller, "drop", dragEnd);
      cm.state.delayingBlurEvent = true;
      setTimeout(function() {
        return display.input.focus();
      }, 20);
      if (display.scroller.dragDrop) {
        display.scroller.dragDrop();
      }
    }
    function rangeForUnit(cm, pos, unit) {
      if (unit == "char") {
        return new Range(pos, pos);
      }
      if (unit == "word") {
        return cm.findWordAt(pos);
      }
      if (unit == "line") {
        return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
      }
      var result = unit(cm, pos);
      return new Range(result.from, result.to);
    }
    function leftButtonSelect(cm, event, start, behavior) {
      if (ie) {
        delayBlurEvent(cm);
      }
      var display = cm.display, doc2 = cm.doc;
      e_preventDefault(event);
      var ourRange, ourIndex, startSel = doc2.sel, ranges = startSel.ranges;
      if (behavior.addNew && !behavior.extend) {
        ourIndex = doc2.sel.contains(start);
        if (ourIndex > -1) {
          ourRange = ranges[ourIndex];
        } else {
          ourRange = new Range(start, start);
        }
      } else {
        ourRange = doc2.sel.primary();
        ourIndex = doc2.sel.primIndex;
      }
      if (behavior.unit == "rectangle") {
        if (!behavior.addNew) {
          ourRange = new Range(start, start);
        }
        start = posFromMouse(cm, event, true, true);
        ourIndex = -1;
      } else {
        var range2 = rangeForUnit(cm, start, behavior.unit);
        if (behavior.extend) {
          ourRange = extendRange(ourRange, range2.anchor, range2.head, behavior.extend);
        } else {
          ourRange = range2;
        }
      }
      if (!behavior.addNew) {
        ourIndex = 0;
        setSelection(doc2, new Selection([ourRange], 0), sel_mouse);
        startSel = doc2.sel;
      } else if (ourIndex == -1) {
        ourIndex = ranges.length;
        setSelection(
          doc2,
          normalizeSelection(cm, ranges.concat([ourRange]), ourIndex),
          { scroll: false, origin: "*mouse" }
        );
      } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
        setSelection(
          doc2,
          normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0),
          { scroll: false, origin: "*mouse" }
        );
        startSel = doc2.sel;
      } else {
        replaceOneSelection(doc2, ourIndex, ourRange, sel_mouse);
      }
      var lastPos = start;
      function extendTo(pos) {
        if (cmp(lastPos, pos) == 0) {
          return;
        }
        lastPos = pos;
        if (behavior.unit == "rectangle") {
          var ranges2 = [], tabSize = cm.options.tabSize;
          var startCol = countColumn(getLine(doc2, start.line).text, start.ch, tabSize);
          var posCol = countColumn(getLine(doc2, pos.line).text, pos.ch, tabSize);
          var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
          for (var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++) {
            var text = getLine(doc2, line).text, leftPos = findColumn(text, left, tabSize);
            if (left == right) {
              ranges2.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
            } else if (text.length > leftPos) {
              ranges2.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
            }
          }
          if (!ranges2.length) {
            ranges2.push(new Range(start, start));
          }
          setSelection(
            doc2,
            normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges2), ourIndex),
            { origin: "*mouse", scroll: false }
          );
          cm.scrollIntoView(pos);
        } else {
          var oldRange = ourRange;
          var range3 = rangeForUnit(cm, pos, behavior.unit);
          var anchor = oldRange.anchor, head;
          if (cmp(range3.anchor, anchor) > 0) {
            head = range3.head;
            anchor = minPos(oldRange.from(), range3.anchor);
          } else {
            head = range3.anchor;
            anchor = maxPos(oldRange.to(), range3.head);
          }
          var ranges$1 = startSel.ranges.slice(0);
          ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc2, anchor), head));
          setSelection(doc2, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
        }
      }
      var editorSize = display.wrapper.getBoundingClientRect();
      var counter = 0;
      function extend2(e) {
        var curCount = ++counter;
        var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
        if (!cur) {
          return;
        }
        if (cmp(cur, lastPos) != 0) {
          cm.curOp.focus = activeElt(root(cm));
          extendTo(cur);
          var visible = visibleLines(display, doc2);
          if (cur.line >= visible.to || cur.line < visible.from) {
            setTimeout(operation(cm, function() {
              if (counter == curCount) {
                extend2(e);
              }
            }), 150);
          }
        } else {
          var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
          if (outside) {
            setTimeout(operation(cm, function() {
              if (counter != curCount) {
                return;
              }
              display.scroller.scrollTop += outside;
              extend2(e);
            }), 50);
          }
        }
      }
      function done(e) {
        cm.state.selectingText = false;
        counter = Infinity;
        if (e) {
          e_preventDefault(e);
          display.input.focus();
        }
        off2(display.wrapper.ownerDocument, "mousemove", move2);
        off2(display.wrapper.ownerDocument, "mouseup", up);
        doc2.history.lastSelOrigin = null;
      }
      var move2 = operation(cm, function(e) {
        if (e.buttons === 0 || !e_button(e)) {
          done(e);
        } else {
          extend2(e);
        }
      });
      var up = operation(cm, done);
      cm.state.selectingText = up;
      on2(display.wrapper.ownerDocument, "mousemove", move2);
      on2(display.wrapper.ownerDocument, "mouseup", up);
    }
    function bidiSimplify(cm, range2) {
      var anchor = range2.anchor;
      var head = range2.head;
      var anchorLine = getLine(cm.doc, anchor.line);
      if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) {
        return range2;
      }
      var order = getOrder(anchorLine);
      if (!order) {
        return range2;
      }
      var index2 = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index2];
      if (part.from != anchor.ch && part.to != anchor.ch) {
        return range2;
      }
      var boundary = index2 + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
      if (boundary == 0 || boundary == order.length) {
        return range2;
      }
      var leftSide;
      if (head.line != anchor.line) {
        leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
      } else {
        var headIndex = getBidiPartAt(order, head.ch, head.sticky);
        var dir = headIndex - index2 || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
        if (headIndex == boundary - 1 || headIndex == boundary) {
          leftSide = dir < 0;
        } else {
          leftSide = dir > 0;
        }
      }
      var usePart = order[boundary + (leftSide ? -1 : 0)];
      var from = leftSide == (usePart.level == 1);
      var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
      return anchor.ch == ch && anchor.sticky == sticky ? range2 : new Range(new Pos(anchor.line, ch, sticky), head);
    }
    function gutterEvent(cm, e, type, prevent) {
      var mX, mY;
      if (e.touches) {
        mX = e.touches[0].clientX;
        mY = e.touches[0].clientY;
      } else {
        try {
          mX = e.clientX;
          mY = e.clientY;
        } catch (e$1) {
          return false;
        }
      }
      if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) {
        return false;
      }
      if (prevent) {
        e_preventDefault(e);
      }
      var display = cm.display;
      var lineBox = display.lineDiv.getBoundingClientRect();
      if (mY > lineBox.bottom || !hasHandler(cm, type)) {
        return e_defaultPrevented(e);
      }
      mY -= lineBox.top - display.viewOffset;
      for (var i2 = 0; i2 < cm.display.gutterSpecs.length; ++i2) {
        var g = display.gutters.childNodes[i2];
        if (g && g.getBoundingClientRect().right >= mX) {
          var line = lineAtHeight(cm.doc, mY);
          var gutter = cm.display.gutterSpecs[i2];
          signal(cm, type, cm, line, gutter.className, e);
          return e_defaultPrevented(e);
        }
      }
    }
    function clickInGutter(cm, e) {
      return gutterEvent(cm, e, "gutterClick", true);
    }
    function onContextMenu(cm, e) {
      if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) {
        return;
      }
      if (signalDOMEvent(cm, e, "contextmenu")) {
        return;
      }
      if (!captureRightClick) {
        cm.display.input.onContextMenu(e);
      }
    }
    function contextMenuInGutter(cm, e) {
      if (!hasHandler(cm, "gutterContextMenu")) {
        return false;
      }
      return gutterEvent(cm, e, "gutterContextMenu", false);
    }
    function themeChanged(cm) {
      cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
      clearCaches(cm);
    }
    var Init = { toString: function() {
      return "CodeMirror.Init";
    } };
    var defaults2 = {};
    var optionHandlers = {};
    function defineOptions(CodeMirror3) {
      var optionHandlers2 = CodeMirror3.optionHandlers;
      function option2(name, deflt, handle, notOnInit) {
        CodeMirror3.defaults[name] = deflt;
        if (handle) {
          optionHandlers2[name] = notOnInit ? function(cm, val, old) {
            if (old != Init) {
              handle(cm, val, old);
            }
          } : handle;
        }
      }
      CodeMirror3.defineOption = option2;
      CodeMirror3.Init = Init;
      option2("value", "", function(cm, val) {
        return cm.setValue(val);
      }, true);
      option2("mode", null, function(cm, val) {
        cm.doc.modeOption = val;
        loadMode(cm);
      }, true);
      option2("indentUnit", 2, loadMode, true);
      option2("indentWithTabs", false);
      option2("smartIndent", true);
      option2("tabSize", 4, function(cm) {
        resetModeState(cm);
        clearCaches(cm);
        regChange(cm);
      }, true);
      option2("lineSeparator", null, function(cm, val) {
        cm.doc.lineSep = val;
        if (!val) {
          return;
        }
        var newBreaks = [], lineNo2 = cm.doc.first;
        cm.doc.iter(function(line) {
          for (var pos = 0; ; ) {
            var found = line.text.indexOf(val, pos);
            if (found == -1) {
              break;
            }
            pos = found + val.length;
            newBreaks.push(Pos(lineNo2, found));
          }
          lineNo2++;
        });
        for (var i2 = newBreaks.length - 1; i2 >= 0; i2--) {
          replaceRange(cm.doc, val, newBreaks[i2], Pos(newBreaks[i2].line, newBreaks[i2].ch + val.length));
        }
      });
      option2("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\u202d\u202e\u2066\u2067\u2069\ufeff\ufff9-\ufffc]/g, function(cm, val, old) {
        cm.state.specialChars = new RegExp(val.source + (val.test("	") ? "" : "|	"), "g");
        if (old != Init) {
          cm.refresh();
        }
      });
      option2("specialCharPlaceholder", defaultSpecialCharPlaceholder, function(cm) {
        return cm.refresh();
      }, true);
      option2("electricChars", true);
      option2("inputStyle", mobile ? "contenteditable" : "textarea", function() {
        throw new Error("inputStyle can not (yet) be changed in a running editor");
      }, true);
      option2("spellcheck", false, function(cm, val) {
        return cm.getInputField().spellcheck = val;
      }, true);
      option2("autocorrect", false, function(cm, val) {
        return cm.getInputField().autocorrect = val;
      }, true);
      option2("autocapitalize", false, function(cm, val) {
        return cm.getInputField().autocapitalize = val;
      }, true);
      option2("rtlMoveVisually", !windows);
      option2("wholeLineUpdateBefore", true);
      option2("theme", "default", function(cm) {
        themeChanged(cm);
        updateGutters(cm);
      }, true);
      option2("keyMap", "default", function(cm, val, old) {
        var next2 = getKeyMap(val);
        var prev2 = old != Init && getKeyMap(old);
        if (prev2 && prev2.detach) {
          prev2.detach(cm, next2);
        }
        if (next2.attach) {
          next2.attach(cm, prev2 || null);
        }
      });
      option2("extraKeys", null);
      option2("configureMouse", null);
      option2("lineWrapping", false, wrappingChanged, true);
      option2("gutters", [], function(cm, val) {
        cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
        updateGutters(cm);
      }, true);
      option2("fixedGutter", true, function(cm, val) {
        cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
        cm.refresh();
      }, true);
      option2("coverGutterNextToScrollbar", false, function(cm) {
        return updateScrollbars(cm);
      }, true);
      option2("scrollbarStyle", "native", function(cm) {
        initScrollbars(cm);
        updateScrollbars(cm);
        cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
        cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
      }, true);
      option2("lineNumbers", false, function(cm, val) {
        cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
        updateGutters(cm);
      }, true);
      option2("firstLineNumber", 1, updateGutters, true);
      option2("lineNumberFormatter", function(integer) {
        return integer;
      }, updateGutters, true);
      option2("showCursorWhenSelecting", false, updateSelection, true);
      option2("resetSelectionOnContextMenu", true);
      option2("lineWiseCopyCut", true);
      option2("pasteLinesPerSelection", true);
      option2("selectionsMayTouch", false);
      option2("readOnly", false, function(cm, val) {
        if (val == "nocursor") {
          onBlur(cm);
          cm.display.input.blur();
        }
        cm.display.input.readOnlyChanged(val);
      });
      option2("screenReaderLabel", null, function(cm, val) {
        val = val === "" ? null : val;
        cm.display.input.screenReaderLabelChanged(val);
      });
      option2("disableInput", false, function(cm, val) {
        if (!val) {
          cm.display.input.reset();
        }
      }, true);
      option2("dragDrop", true, dragDropChanged);
      option2("allowDropFileTypes", null);
      option2("cursorBlinkRate", 530);
      option2("cursorScrollMargin", 0);
      option2("cursorHeight", 1, updateSelection, true);
      option2("singleCursorHeightPerLine", true, updateSelection, true);
      option2("workTime", 100);
      option2("workDelay", 100);
      option2("flattenSpans", true, resetModeState, true);
      option2("addModeClass", false, resetModeState, true);
      option2("pollInterval", 100);
      option2("undoDepth", 200, function(cm, val) {
        return cm.doc.history.undoDepth = val;
      });
      option2("historyEventDelay", 1250);
      option2("viewportMargin", 10, function(cm) {
        return cm.refresh();
      }, true);
      option2("maxHighlightLength", 1e4, resetModeState, true);
      option2("moveInputWithCursor", true, function(cm, val) {
        if (!val) {
          cm.display.input.resetPosition();
        }
      });
      option2("tabindex", null, function(cm, val) {
        return cm.display.input.getField().tabIndex = val || "";
      });
      option2("autofocus", null);
      option2("direction", "ltr", function(cm, val) {
        return cm.doc.setDirection(val);
      }, true);
      option2("phrases", null);
    }
    function dragDropChanged(cm, value, old) {
      var wasOn = old && old != Init;
      if (!value != !wasOn) {
        var funcs = cm.display.dragFunctions;
        var toggle2 = value ? on2 : off2;
        toggle2(cm.display.scroller, "dragstart", funcs.start);
        toggle2(cm.display.scroller, "dragenter", funcs.enter);
        toggle2(cm.display.scroller, "dragover", funcs.over);
        toggle2(cm.display.scroller, "dragleave", funcs.leave);
        toggle2(cm.display.scroller, "drop", funcs.drop);
      }
    }
    function wrappingChanged(cm) {
      if (cm.options.lineWrapping) {
        addClass2(cm.display.wrapper, "CodeMirror-wrap");
        cm.display.sizer.style.minWidth = "";
        cm.display.sizerWidth = null;
      } else {
        rmClass(cm.display.wrapper, "CodeMirror-wrap");
        findMaxLine(cm);
      }
      estimateLineHeights(cm);
      regChange(cm);
      clearCaches(cm);
      setTimeout(function() {
        return updateScrollbars(cm);
      }, 100);
    }
    function CodeMirror2(place, options) {
      var this$1$1 = this;
      if (!(this instanceof CodeMirror2)) {
        return new CodeMirror2(place, options);
      }
      this.options = options = options ? copyObj(options) : {};
      copyObj(defaults2, options, false);
      var doc2 = options.value;
      if (typeof doc2 == "string") {
        doc2 = new Doc(doc2, options.mode, null, options.lineSeparator, options.direction);
      } else if (options.mode) {
        doc2.modeOption = options.mode;
      }
      this.doc = doc2;
      var input = new CodeMirror2.inputStyles[options.inputStyle](this);
      var display = this.display = new Display(place, doc2, input, options);
      display.wrapper.CodeMirror = this;
      themeChanged(this);
      if (options.lineWrapping) {
        this.display.wrapper.className += " CodeMirror-wrap";
      }
      initScrollbars(this);
      this.state = {
        keyMaps: [],
        overlays: [],
        modeGen: 0,
        overwrite: false,
        delayingBlurEvent: false,
        focused: false,
        suppressEdits: false,
        pasteIncoming: -1,
        cutIncoming: -1,
        selectingText: false,
        draggingText: false,
        highlight: new Delayed(),
        keySeq: null,
        specialChars: null
      };
      if (options.autofocus && !mobile) {
        display.input.focus();
      }
      if (ie && ie_version < 11) {
        setTimeout(function() {
          return this$1$1.display.input.reset(true);
        }, 20);
      }
      registerEventHandlers(this);
      ensureGlobalHandlers();
      startOperation(this);
      this.curOp.forceUpdate = true;
      attachDoc(this, doc2);
      if (options.autofocus && !mobile || this.hasFocus()) {
        setTimeout(function() {
          if (this$1$1.hasFocus() && !this$1$1.state.focused) {
            onFocus(this$1$1);
          }
        }, 20);
      } else {
        onBlur(this);
      }
      for (var opt in optionHandlers) {
        if (optionHandlers.hasOwnProperty(opt)) {
          optionHandlers[opt](this, options[opt], Init);
        }
      }
      maybeUpdateLineNumberWidth(this);
      if (options.finishInit) {
        options.finishInit(this);
      }
      for (var i2 = 0; i2 < initHooks.length; ++i2) {
        initHooks[i2](this);
      }
      endOperation(this);
      if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") {
        display.lineDiv.style.textRendering = "auto";
      }
    }
    CodeMirror2.defaults = defaults2;
    CodeMirror2.optionHandlers = optionHandlers;
    function registerEventHandlers(cm) {
      var d = cm.display;
      on2(d.scroller, "mousedown", operation(cm, onMouseDown));
      if (ie && ie_version < 11) {
        on2(d.scroller, "dblclick", operation(cm, function(e) {
          if (signalDOMEvent(cm, e)) {
            return;
          }
          var pos = posFromMouse(cm, e);
          if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) {
            return;
          }
          e_preventDefault(e);
          var word = cm.findWordAt(pos);
          extendSelection(cm.doc, word.anchor, word.head);
        }));
      } else {
        on2(d.scroller, "dblclick", function(e) {
          return signalDOMEvent(cm, e) || e_preventDefault(e);
        });
      }
      on2(d.scroller, "contextmenu", function(e) {
        return onContextMenu(cm, e);
      });
      on2(d.input.getField(), "contextmenu", function(e) {
        if (!d.scroller.contains(e.target)) {
          onContextMenu(cm, e);
        }
      });
      var touchFinished, prevTouch = { end: 0 };
      function finishTouch() {
        if (d.activeTouch) {
          touchFinished = setTimeout(function() {
            return d.activeTouch = null;
          }, 1e3);
          prevTouch = d.activeTouch;
          prevTouch.end = +new Date();
        }
      }
      function isMouseLikeTouchEvent(e) {
        if (e.touches.length != 1) {
          return false;
        }
        var touch = e.touches[0];
        return touch.radiusX <= 1 && touch.radiusY <= 1;
      }
      function farAway(touch, other) {
        if (other.left == null) {
          return true;
        }
        var dx = other.left - touch.left, dy = other.top - touch.top;
        return dx * dx + dy * dy > 20 * 20;
      }
      on2(d.scroller, "touchstart", function(e) {
        if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
          d.input.ensurePolled();
          clearTimeout(touchFinished);
          var now = +new Date();
          d.activeTouch = {
            start: now,
            moved: false,
            prev: now - prevTouch.end <= 300 ? prevTouch : null
          };
          if (e.touches.length == 1) {
            d.activeTouch.left = e.touches[0].pageX;
            d.activeTouch.top = e.touches[0].pageY;
          }
        }
      });
      on2(d.scroller, "touchmove", function() {
        if (d.activeTouch) {
          d.activeTouch.moved = true;
        }
      });
      on2(d.scroller, "touchend", function(e) {
        var touch = d.activeTouch;
        if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date() - touch.start < 300) {
          var pos = cm.coordsChar(d.activeTouch, "page"), range2;
          if (!touch.prev || farAway(touch, touch.prev)) {
            range2 = new Range(pos, pos);
          } else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) {
            range2 = cm.findWordAt(pos);
          } else {
            range2 = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
          }
          cm.setSelection(range2.anchor, range2.head);
          cm.focus();
          e_preventDefault(e);
        }
        finishTouch();
      });
      on2(d.scroller, "touchcancel", finishTouch);
      on2(d.scroller, "scroll", function() {
        if (d.scroller.clientHeight) {
          updateScrollTop(cm, d.scroller.scrollTop);
          setScrollLeft(cm, d.scroller.scrollLeft, true);
          signal(cm, "scroll", cm);
        }
      });
      on2(d.scroller, "mousewheel", function(e) {
        return onScrollWheel(cm, e);
      });
      on2(d.scroller, "DOMMouseScroll", function(e) {
        return onScrollWheel(cm, e);
      });
      on2(d.wrapper, "scroll", function() {
        return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
      });
      d.dragFunctions = {
        enter: function(e) {
          if (!signalDOMEvent(cm, e)) {
            e_stop(e);
          }
        },
        over: function(e) {
          if (!signalDOMEvent(cm, e)) {
            onDragOver(cm, e);
            e_stop(e);
          }
        },
        start: function(e) {
          return onDragStart(cm, e);
        },
        drop: operation(cm, onDrop),
        leave: function(e) {
          if (!signalDOMEvent(cm, e)) {
            clearDragCursor(cm);
          }
        }
      };
      var inp = d.input.getField();
      on2(inp, "keyup", function(e) {
        return onKeyUp.call(cm, e);
      });
      on2(inp, "keydown", operation(cm, onKeyDown));
      on2(inp, "keypress", operation(cm, onKeyPress));
      on2(inp, "focus", function(e) {
        return onFocus(cm, e);
      });
      on2(inp, "blur", function(e) {
        return onBlur(cm, e);
      });
    }
    var initHooks = [];
    CodeMirror2.defineInitHook = function(f) {
      return initHooks.push(f);
    };
    function indentLine(cm, n, how, aggressive) {
      var doc2 = cm.doc, state;
      if (how == null) {
        how = "add";
      }
      if (how == "smart") {
        if (!doc2.mode.indent) {
          how = "prev";
        } else {
          state = getContextBefore(cm, n).state;
        }
      }
      var tabSize = cm.options.tabSize;
      var line = getLine(doc2, n), curSpace = countColumn(line.text, null, tabSize);
      if (line.stateAfter) {
        line.stateAfter = null;
      }
      var curSpaceString = line.text.match(/^\s*/)[0], indentation;
      if (!aggressive && !/\S/.test(line.text)) {
        indentation = 0;
        how = "not";
      } else if (how == "smart") {
        indentation = doc2.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
        if (indentation == Pass || indentation > 150) {
          if (!aggressive) {
            return;
          }
          how = "prev";
        }
      }
      if (how == "prev") {
        if (n > doc2.first) {
          indentation = countColumn(getLine(doc2, n - 1).text, null, tabSize);
        } else {
          indentation = 0;
        }
      } else if (how == "add") {
        indentation = curSpace + cm.options.indentUnit;
      } else if (how == "subtract") {
        indentation = curSpace - cm.options.indentUnit;
      } else if (typeof how == "number") {
        indentation = curSpace + how;
      }
      indentation = Math.max(0, indentation);
      var indentString = "", pos = 0;
      if (cm.options.indentWithTabs) {
        for (var i2 = Math.floor(indentation / tabSize); i2; --i2) {
          pos += tabSize;
          indentString += "	";
        }
      }
      if (pos < indentation) {
        indentString += spaceStr(indentation - pos);
      }
      if (indentString != curSpaceString) {
        replaceRange(doc2, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
        line.stateAfter = null;
        return true;
      } else {
        for (var i$12 = 0; i$12 < doc2.sel.ranges.length; i$12++) {
          var range2 = doc2.sel.ranges[i$12];
          if (range2.head.line == n && range2.head.ch < curSpaceString.length) {
            var pos$1 = Pos(n, curSpaceString.length);
            replaceOneSelection(doc2, i$12, new Range(pos$1, pos$1));
            break;
          }
        }
      }
    }
    var lastCopied = null;
    function setLastCopied(newLastCopied) {
      lastCopied = newLastCopied;
    }
    function applyTextInput(cm, inserted, deleted, sel, origin) {
      var doc2 = cm.doc;
      cm.display.shift = false;
      if (!sel) {
        sel = doc2.sel;
      }
      var recent = +new Date() - 200;
      var paste = origin == "paste" || cm.state.pasteIncoming > recent;
      var textLines = splitLinesAuto(inserted), multiPaste = null;
      if (paste && sel.ranges.length > 1) {
        if (lastCopied && lastCopied.text.join("\n") == inserted) {
          if (sel.ranges.length % lastCopied.text.length == 0) {
            multiPaste = [];
            for (var i2 = 0; i2 < lastCopied.text.length; i2++) {
              multiPaste.push(doc2.splitLines(lastCopied.text[i2]));
            }
          }
        } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) {
          multiPaste = map(textLines, function(l) {
            return [l];
          });
        }
      }
      var updateInput = cm.curOp.updateInput;
      for (var i$12 = sel.ranges.length - 1; i$12 >= 0; i$12--) {
        var range2 = sel.ranges[i$12];
        var from = range2.from(), to = range2.to();
        if (range2.empty()) {
          if (deleted && deleted > 0) {
            from = Pos(from.line, from.ch - deleted);
          } else if (cm.state.overwrite && !paste) {
            to = Pos(to.line, Math.min(getLine(doc2, to.line).text.length, to.ch + lst(textLines).length));
          } else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == textLines.join("\n")) {
            from = to = Pos(from.line, 0);
          }
        }
        var changeEvent = {
          from,
          to,
          text: multiPaste ? multiPaste[i$12 % multiPaste.length] : textLines,
          origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")
        };
        makeChange(cm.doc, changeEvent);
        signalLater(cm, "inputRead", cm, changeEvent);
      }
      if (inserted && !paste) {
        triggerElectric(cm, inserted);
      }
      ensureCursorVisible(cm);
      if (cm.curOp.updateInput < 2) {
        cm.curOp.updateInput = updateInput;
      }
      cm.curOp.typing = true;
      cm.state.pasteIncoming = cm.state.cutIncoming = -1;
    }
    function handlePaste(e, cm) {
      var pasted = e.clipboardData && e.clipboardData.getData("Text");
      if (pasted) {
        e.preventDefault();
        if (!cm.isReadOnly() && !cm.options.disableInput && cm.hasFocus()) {
          runInOp(cm, function() {
            return applyTextInput(cm, pasted, 0, null, "paste");
          });
        }
        return true;
      }
    }
    function triggerElectric(cm, inserted) {
      if (!cm.options.electricChars || !cm.options.smartIndent) {
        return;
      }
      var sel = cm.doc.sel;
      for (var i2 = sel.ranges.length - 1; i2 >= 0; i2--) {
        var range2 = sel.ranges[i2];
        if (range2.head.ch > 100 || i2 && sel.ranges[i2 - 1].head.line == range2.head.line) {
          continue;
        }
        var mode = cm.getModeAt(range2.head);
        var indented = false;
        if (mode.electricChars) {
          for (var j = 0; j < mode.electricChars.length; j++) {
            if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
              indented = indentLine(cm, range2.head.line, "smart");
              break;
            }
          }
        } else if (mode.electricInput) {
          if (mode.electricInput.test(getLine(cm.doc, range2.head.line).text.slice(0, range2.head.ch))) {
            indented = indentLine(cm, range2.head.line, "smart");
          }
        }
        if (indented) {
          signalLater(cm, "electricInput", cm, range2.head.line);
        }
      }
    }
    function copyableRanges(cm) {
      var text = [], ranges = [];
      for (var i2 = 0; i2 < cm.doc.sel.ranges.length; i2++) {
        var line = cm.doc.sel.ranges[i2].head.line;
        var lineRange = { anchor: Pos(line, 0), head: Pos(line + 1, 0) };
        ranges.push(lineRange);
        text.push(cm.getRange(lineRange.anchor, lineRange.head));
      }
      return { text, ranges };
    }
    function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
      field.setAttribute("autocorrect", autocorrect ? "on" : "off");
      field.setAttribute("autocapitalize", autocapitalize ? "on" : "off");
      field.setAttribute("spellcheck", !!spellcheck);
    }
    function hiddenTextarea() {
      var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none");
      var div = elt("div", [te], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
      if (webkit) {
        te.style.width = "1000px";
      } else {
        te.setAttribute("wrap", "off");
      }
      if (ios) {
        te.style.border = "1px solid black";
      }
      return div;
    }
    function addEditorMethods(CodeMirror3) {
      var optionHandlers2 = CodeMirror3.optionHandlers;
      var helpers = CodeMirror3.helpers = {};
      CodeMirror3.prototype = {
        constructor: CodeMirror3,
        focus: function() {
          win(this).focus();
          this.display.input.focus();
        },
        setOption: function(option2, value) {
          var options = this.options, old = options[option2];
          if (options[option2] == value && option2 != "mode") {
            return;
          }
          options[option2] = value;
          if (optionHandlers2.hasOwnProperty(option2)) {
            operation(this, optionHandlers2[option2])(this, value, old);
          }
          signal(this, "optionChange", this, option2);
        },
        getOption: function(option2) {
          return this.options[option2];
        },
        getDoc: function() {
          return this.doc;
        },
        addKeyMap: function(map2, bottom) {
          this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map2));
        },
        removeKeyMap: function(map2) {
          var maps = this.state.keyMaps;
          for (var i2 = 0; i2 < maps.length; ++i2) {
            if (maps[i2] == map2 || maps[i2].name == map2) {
              maps.splice(i2, 1);
              return true;
            }
          }
        },
        addOverlay: methodOp(function(spec, options) {
          var mode = spec.token ? spec : CodeMirror3.getMode(this.options, spec);
          if (mode.startState) {
            throw new Error("Overlays may not be stateful.");
          }
          insertSorted(
            this.state.overlays,
            {
              mode,
              modeSpec: spec,
              opaque: options && options.opaque,
              priority: options && options.priority || 0
            },
            function(overlay) {
              return overlay.priority;
            }
          );
          this.state.modeGen++;
          regChange(this);
        }),
        removeOverlay: methodOp(function(spec) {
          var overlays = this.state.overlays;
          for (var i2 = 0; i2 < overlays.length; ++i2) {
            var cur = overlays[i2].modeSpec;
            if (cur == spec || typeof spec == "string" && cur.name == spec) {
              overlays.splice(i2, 1);
              this.state.modeGen++;
              regChange(this);
              return;
            }
          }
        }),
        indentLine: methodOp(function(n, dir, aggressive) {
          if (typeof dir != "string" && typeof dir != "number") {
            if (dir == null) {
              dir = this.options.smartIndent ? "smart" : "prev";
            } else {
              dir = dir ? "add" : "subtract";
            }
          }
          if (isLine(this.doc, n)) {
            indentLine(this, n, dir, aggressive);
          }
        }),
        indentSelection: methodOp(function(how) {
          var ranges = this.doc.sel.ranges, end = -1;
          for (var i2 = 0; i2 < ranges.length; i2++) {
            var range2 = ranges[i2];
            if (!range2.empty()) {
              var from = range2.from(), to = range2.to();
              var start = Math.max(end, from.line);
              end = Math.min(this.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
              for (var j = start; j < end; ++j) {
                indentLine(this, j, how);
              }
              var newRanges = this.doc.sel.ranges;
              if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i2].from().ch > 0) {
                replaceOneSelection(this.doc, i2, new Range(from, newRanges[i2].to()), sel_dontScroll);
              }
            } else if (range2.head.line > end) {
              indentLine(this, range2.head.line, how, true);
              end = range2.head.line;
              if (i2 == this.doc.sel.primIndex) {
                ensureCursorVisible(this);
              }
            }
          }
        }),
        getTokenAt: function(pos, precise) {
          return takeToken(this, pos, precise);
        },
        getLineTokens: function(line, precise) {
          return takeToken(this, Pos(line), precise, true);
        },
        getTokenTypeAt: function(pos) {
          pos = clipPos(this.doc, pos);
          var styles = getLineStyles(this, getLine(this.doc, pos.line));
          var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
          var type;
          if (ch == 0) {
            type = styles[2];
          } else {
            for (; ; ) {
              var mid = before + after >> 1;
              if ((mid ? styles[mid * 2 - 1] : 0) >= ch) {
                after = mid;
              } else if (styles[mid * 2 + 1] < ch) {
                before = mid + 1;
              } else {
                type = styles[mid * 2 + 2];
                break;
              }
            }
          }
          var cut = type ? type.indexOf("overlay ") : -1;
          return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
        },
        getModeAt: function(pos) {
          var mode = this.doc.mode;
          if (!mode.innerMode) {
            return mode;
          }
          return CodeMirror3.innerMode(mode, this.getTokenAt(pos).state).mode;
        },
        getHelper: function(pos, type) {
          return this.getHelpers(pos, type)[0];
        },
        getHelpers: function(pos, type) {
          var found = [];
          if (!helpers.hasOwnProperty(type)) {
            return found;
          }
          var help = helpers[type], mode = this.getModeAt(pos);
          if (typeof mode[type] == "string") {
            if (help[mode[type]]) {
              found.push(help[mode[type]]);
            }
          } else if (mode[type]) {
            for (var i2 = 0; i2 < mode[type].length; i2++) {
              var val = help[mode[type][i2]];
              if (val) {
                found.push(val);
              }
            }
          } else if (mode.helperType && help[mode.helperType]) {
            found.push(help[mode.helperType]);
          } else if (help[mode.name]) {
            found.push(help[mode.name]);
          }
          for (var i$12 = 0; i$12 < help._global.length; i$12++) {
            var cur = help._global[i$12];
            if (cur.pred(mode, this) && indexOf(found, cur.val) == -1) {
              found.push(cur.val);
            }
          }
          return found;
        },
        getStateAfter: function(line, precise) {
          var doc2 = this.doc;
          line = clipLine(doc2, line == null ? doc2.first + doc2.size - 1 : line);
          return getContextBefore(this, line + 1, precise).state;
        },
        cursorCoords: function(start, mode) {
          var pos, range2 = this.doc.sel.primary();
          if (start == null) {
            pos = range2.head;
          } else if (typeof start == "object") {
            pos = clipPos(this.doc, start);
          } else {
            pos = start ? range2.from() : range2.to();
          }
          return cursorCoords(this, pos, mode || "page");
        },
        charCoords: function(pos, mode) {
          return charCoords(this, clipPos(this.doc, pos), mode || "page");
        },
        coordsChar: function(coords, mode) {
          coords = fromCoordSystem(this, coords, mode || "page");
          return coordsChar(this, coords.left, coords.top);
        },
        lineAtHeight: function(height, mode) {
          height = fromCoordSystem(this, { top: height, left: 0 }, mode || "page").top;
          return lineAtHeight(this.doc, height + this.display.viewOffset);
        },
        heightAtLine: function(line, mode, includeWidgets) {
          var end = false, lineObj;
          if (typeof line == "number") {
            var last = this.doc.first + this.doc.size - 1;
            if (line < this.doc.first) {
              line = this.doc.first;
            } else if (line > last) {
              line = last;
              end = true;
            }
            lineObj = getLine(this.doc, line);
          } else {
            lineObj = line;
          }
          return intoCoordSystem(this, lineObj, { top: 0, left: 0 }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - heightAtLine(lineObj) : 0);
        },
        defaultTextHeight: function() {
          return textHeight(this.display);
        },
        defaultCharWidth: function() {
          return charWidth(this.display);
        },
        getViewport: function() {
          return { from: this.display.viewFrom, to: this.display.viewTo };
        },
        addWidget: function(pos, node, scroll, vert, horiz) {
          var display = this.display;
          pos = cursorCoords(this, clipPos(this.doc, pos));
          var top = pos.bottom, left = pos.left;
          node.style.position = "absolute";
          node.setAttribute("cm-ignore-events", "true");
          this.display.input.setUneditable(node);
          display.sizer.appendChild(node);
          if (vert == "over") {
            top = pos.top;
          } else if (vert == "above" || vert == "near") {
            var vspace = Math.max(display.wrapper.clientHeight, this.doc.height), hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
            if ((vert == "above" || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) {
              top = pos.top - node.offsetHeight;
            } else if (pos.bottom + node.offsetHeight <= vspace) {
              top = pos.bottom;
            }
            if (left + node.offsetWidth > hspace) {
              left = hspace - node.offsetWidth;
            }
          }
          node.style.top = top + "px";
          node.style.left = node.style.right = "";
          if (horiz == "right") {
            left = display.sizer.clientWidth - node.offsetWidth;
            node.style.right = "0px";
          } else {
            if (horiz == "left") {
              left = 0;
            } else if (horiz == "middle") {
              left = (display.sizer.clientWidth - node.offsetWidth) / 2;
            }
            node.style.left = left + "px";
          }
          if (scroll) {
            scrollIntoView(this, { left, top, right: left + node.offsetWidth, bottom: top + node.offsetHeight });
          }
        },
        triggerOnKeyDown: methodOp(onKeyDown),
        triggerOnKeyPress: methodOp(onKeyPress),
        triggerOnKeyUp: onKeyUp,
        triggerOnMouseDown: methodOp(onMouseDown),
        execCommand: function(cmd) {
          if (commands.hasOwnProperty(cmd)) {
            return commands[cmd].call(null, this);
          }
        },
        triggerElectric: methodOp(function(text) {
          triggerElectric(this, text);
        }),
        findPosH: function(from, amount, unit, visually) {
          var dir = 1;
          if (amount < 0) {
            dir = -1;
            amount = -amount;
          }
          var cur = clipPos(this.doc, from);
          for (var i2 = 0; i2 < amount; ++i2) {
            cur = findPosH(this.doc, cur, dir, unit, visually);
            if (cur.hitSide) {
              break;
            }
          }
          return cur;
        },
        moveH: methodOp(function(dir, unit) {
          var this$1$1 = this;
          this.extendSelectionsBy(function(range2) {
            if (this$1$1.display.shift || this$1$1.doc.extend || range2.empty()) {
              return findPosH(this$1$1.doc, range2.head, dir, unit, this$1$1.options.rtlMoveVisually);
            } else {
              return dir < 0 ? range2.from() : range2.to();
            }
          }, sel_move);
        }),
        deleteH: methodOp(function(dir, unit) {
          var sel = this.doc.sel, doc2 = this.doc;
          if (sel.somethingSelected()) {
            doc2.replaceSelection("", null, "+delete");
          } else {
            deleteNearSelection(this, function(range2) {
              var other = findPosH(doc2, range2.head, dir, unit, false);
              return dir < 0 ? { from: other, to: range2.head } : { from: range2.head, to: other };
            });
          }
        }),
        findPosV: function(from, amount, unit, goalColumn) {
          var dir = 1, x = goalColumn;
          if (amount < 0) {
            dir = -1;
            amount = -amount;
          }
          var cur = clipPos(this.doc, from);
          for (var i2 = 0; i2 < amount; ++i2) {
            var coords = cursorCoords(this, cur, "div");
            if (x == null) {
              x = coords.left;
            } else {
              coords.left = x;
            }
            cur = findPosV(this, coords, dir, unit);
            if (cur.hitSide) {
              break;
            }
          }
          return cur;
        },
        moveV: methodOp(function(dir, unit) {
          var this$1$1 = this;
          var doc2 = this.doc, goals = [];
          var collapse = !this.display.shift && !doc2.extend && doc2.sel.somethingSelected();
          doc2.extendSelectionsBy(function(range2) {
            if (collapse) {
              return dir < 0 ? range2.from() : range2.to();
            }
            var headPos = cursorCoords(this$1$1, range2.head, "div");
            if (range2.goalColumn != null) {
              headPos.left = range2.goalColumn;
            }
            goals.push(headPos.left);
            var pos = findPosV(this$1$1, headPos, dir, unit);
            if (unit == "page" && range2 == doc2.sel.primary()) {
              addToScrollTop(this$1$1, charCoords(this$1$1, pos, "div").top - headPos.top);
            }
            return pos;
          }, sel_move);
          if (goals.length) {
            for (var i2 = 0; i2 < doc2.sel.ranges.length; i2++) {
              doc2.sel.ranges[i2].goalColumn = goals[i2];
            }
          }
        }),
        findWordAt: function(pos) {
          var doc2 = this.doc, line = getLine(doc2, pos.line).text;
          var start = pos.ch, end = pos.ch;
          if (line) {
            var helper = this.getHelper(pos, "wordChars");
            if ((pos.sticky == "before" || end == line.length) && start) {
              --start;
            } else {
              ++end;
            }
            var startChar = line.charAt(start);
            var check = isWordChar(startChar, helper) ? function(ch) {
              return isWordChar(ch, helper);
            } : /\s/.test(startChar) ? function(ch) {
              return /\s/.test(ch);
            } : function(ch) {
              return !/\s/.test(ch) && !isWordChar(ch);
            };
            while (start > 0 && check(line.charAt(start - 1))) {
              --start;
            }
            while (end < line.length && check(line.charAt(end))) {
              ++end;
            }
          }
          return new Range(Pos(pos.line, start), Pos(pos.line, end));
        },
        toggleOverwrite: function(value) {
          if (value != null && value == this.state.overwrite) {
            return;
          }
          if (this.state.overwrite = !this.state.overwrite) {
            addClass2(this.display.cursorDiv, "CodeMirror-overwrite");
          } else {
            rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
          }
          signal(this, "overwriteToggle", this, this.state.overwrite);
        },
        hasFocus: function() {
          return this.display.input.getField() == activeElt(root(this));
        },
        isReadOnly: function() {
          return !!(this.options.readOnly || this.doc.cantEdit);
        },
        scrollTo: methodOp(function(x, y) {
          scrollToCoords(this, x, y);
        }),
        getScrollInfo: function() {
          var scroller = this.display.scroller;
          return {
            left: scroller.scrollLeft,
            top: scroller.scrollTop,
            height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
            width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
            clientHeight: displayHeight(this),
            clientWidth: displayWidth(this)
          };
        },
        scrollIntoView: methodOp(function(range2, margin) {
          if (range2 == null) {
            range2 = { from: this.doc.sel.primary().head, to: null };
            if (margin == null) {
              margin = this.options.cursorScrollMargin;
            }
          } else if (typeof range2 == "number") {
            range2 = { from: Pos(range2, 0), to: null };
          } else if (range2.from == null) {
            range2 = { from: range2, to: null };
          }
          if (!range2.to) {
            range2.to = range2.from;
          }
          range2.margin = margin || 0;
          if (range2.from.line != null) {
            scrollToRange(this, range2);
          } else {
            scrollToCoordsRange(this, range2.from, range2.to, range2.margin);
          }
        }),
        setSize: methodOp(function(width, height) {
          var this$1$1 = this;
          var interpret = function(val) {
            return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
          };
          if (width != null) {
            this.display.wrapper.style.width = interpret(width);
          }
          if (height != null) {
            this.display.wrapper.style.height = interpret(height);
          }
          if (this.options.lineWrapping) {
            clearLineMeasurementCache(this);
          }
          var lineNo2 = this.display.viewFrom;
          this.doc.iter(lineNo2, this.display.viewTo, function(line) {
            if (line.widgets) {
              for (var i2 = 0; i2 < line.widgets.length; i2++) {
                if (line.widgets[i2].noHScroll) {
                  regLineChange(this$1$1, lineNo2, "widget");
                  break;
                }
              }
            }
            ++lineNo2;
          });
          this.curOp.forceUpdate = true;
          signal(this, "refresh", this);
        }),
        operation: function(f) {
          return runInOp(this, f);
        },
        startOperation: function() {
          return startOperation(this);
        },
        endOperation: function() {
          return endOperation(this);
        },
        refresh: methodOp(function() {
          var oldHeight = this.display.cachedTextHeight;
          regChange(this);
          this.curOp.forceUpdate = true;
          clearCaches(this);
          scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
          updateGutterSpace(this.display);
          if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > 0.5 || this.options.lineWrapping) {
            estimateLineHeights(this);
          }
          signal(this, "refresh", this);
        }),
        swapDoc: methodOp(function(doc2) {
          var old = this.doc;
          old.cm = null;
          if (this.state.selectingText) {
            this.state.selectingText();
          }
          attachDoc(this, doc2);
          clearCaches(this);
          this.display.input.reset();
          scrollToCoords(this, doc2.scrollLeft, doc2.scrollTop);
          this.curOp.forceScroll = true;
          signalLater(this, "swapDoc", this, old);
          return old;
        }),
        phrase: function(phraseText) {
          var phrases = this.options.phrases;
          return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
        },
        getInputField: function() {
          return this.display.input.getField();
        },
        getWrapperElement: function() {
          return this.display.wrapper;
        },
        getScrollerElement: function() {
          return this.display.scroller;
        },
        getGutterElement: function() {
          return this.display.gutters;
        }
      };
      eventMixin(CodeMirror3);
      CodeMirror3.registerHelper = function(type, name, value) {
        if (!helpers.hasOwnProperty(type)) {
          helpers[type] = CodeMirror3[type] = { _global: [] };
        }
        helpers[type][name] = value;
      };
      CodeMirror3.registerGlobalHelper = function(type, name, predicate, value) {
        CodeMirror3.registerHelper(type, name, value);
        helpers[type]._global.push({ pred: predicate, val: value });
      };
    }
    function findPosH(doc2, pos, dir, unit, visually) {
      var oldPos = pos;
      var origDir = dir;
      var lineObj = getLine(doc2, pos.line);
      var lineDir = visually && doc2.direction == "rtl" ? -dir : dir;
      function findNextLine() {
        var l = pos.line + lineDir;
        if (l < doc2.first || l >= doc2.first + doc2.size) {
          return false;
        }
        pos = new Pos(l, pos.ch, pos.sticky);
        return lineObj = getLine(doc2, l);
      }
      function moveOnce(boundToLine) {
        var next2;
        if (unit == "codepoint") {
          var ch = lineObj.text.charCodeAt(pos.ch + (dir > 0 ? 0 : -1));
          if (isNaN(ch)) {
            next2 = null;
          } else {
            var astral = dir > 0 ? ch >= 55296 && ch < 56320 : ch >= 56320 && ch < 57343;
            next2 = new Pos(pos.line, Math.max(0, Math.min(lineObj.text.length, pos.ch + dir * (astral ? 2 : 1))), -dir);
          }
        } else if (visually) {
          next2 = moveVisually(doc2.cm, lineObj, pos, dir);
        } else {
          next2 = moveLogically(lineObj, pos, dir);
        }
        if (next2 == null) {
          if (!boundToLine && findNextLine()) {
            pos = endOfLine(visually, doc2.cm, lineObj, pos.line, lineDir);
          } else {
            return false;
          }
        } else {
          pos = next2;
        }
        return true;
      }
      if (unit == "char" || unit == "codepoint") {
        moveOnce();
      } else if (unit == "column") {
        moveOnce(true);
      } else if (unit == "word" || unit == "group") {
        var sawType = null, group = unit == "group";
        var helper = doc2.cm && doc2.cm.getHelper(pos, "wordChars");
        for (var first = true; ; first = false) {
          if (dir < 0 && !moveOnce(!first)) {
            break;
          }
          var cur = lineObj.text.charAt(pos.ch) || "\n";
          var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
          if (group && !first && !type) {
            type = "s";
          }
          if (sawType && sawType != type) {
            if (dir < 0) {
              dir = 1;
              moveOnce();
              pos.sticky = "after";
            }
            break;
          }
          if (type) {
            sawType = type;
          }
          if (dir > 0 && !moveOnce(!first)) {
            break;
          }
        }
      }
      var result = skipAtomic(doc2, pos, oldPos, origDir, true);
      if (equalCursorPos(oldPos, result)) {
        result.hitSide = true;
      }
      return result;
    }
    function findPosV(cm, pos, dir, unit) {
      var doc2 = cm.doc, x = pos.left, y;
      if (unit == "page") {
        var pageSize = Math.min(cm.display.wrapper.clientHeight, win(cm).innerHeight || doc2(cm).documentElement.clientHeight);
        var moveAmount = Math.max(pageSize - 0.5 * textHeight(cm.display), 3);
        y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
      } else if (unit == "line") {
        y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
      }
      var target;
      for (; ; ) {
        target = coordsChar(cm, x, y);
        if (!target.outside) {
          break;
        }
        if (dir < 0 ? y <= 0 : y >= doc2.height) {
          target.hitSide = true;
          break;
        }
        y += dir * 5;
      }
      return target;
    }
    var ContentEditableInput = function(cm) {
      this.cm = cm;
      this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
      this.polling = new Delayed();
      this.composing = null;
      this.gracePeriod = false;
      this.readDOMTimeout = null;
    };
    ContentEditableInput.prototype.init = function(display) {
      var this$1$1 = this;
      var input = this, cm = input.cm;
      var div = input.div = display.lineDiv;
      div.contentEditable = true;
      disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
      function belongsToInput(e) {
        for (var t = e.target; t; t = t.parentNode) {
          if (t == div) {
            return true;
          }
          if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) {
            break;
          }
        }
        return false;
      }
      on2(div, "paste", function(e) {
        if (!belongsToInput(e) || signalDOMEvent(cm, e) || handlePaste(e, cm)) {
          return;
        }
        if (ie_version <= 11) {
          setTimeout(operation(cm, function() {
            return this$1$1.updateFromDOM();
          }), 20);
        }
      });
      on2(div, "compositionstart", function(e) {
        this$1$1.composing = { data: e.data, done: false };
      });
      on2(div, "compositionupdate", function(e) {
        if (!this$1$1.composing) {
          this$1$1.composing = { data: e.data, done: false };
        }
      });
      on2(div, "compositionend", function(e) {
        if (this$1$1.composing) {
          if (e.data != this$1$1.composing.data) {
            this$1$1.readFromDOMSoon();
          }
          this$1$1.composing.done = true;
        }
      });
      on2(div, "touchstart", function() {
        return input.forceCompositionEnd();
      });
      on2(div, "input", function() {
        if (!this$1$1.composing) {
          this$1$1.readFromDOMSoon();
        }
      });
      function onCopyCut(e) {
        if (!belongsToInput(e) || signalDOMEvent(cm, e)) {
          return;
        }
        if (cm.somethingSelected()) {
          setLastCopied({ lineWise: false, text: cm.getSelections() });
          if (e.type == "cut") {
            cm.replaceSelection("", null, "cut");
          }
        } else if (!cm.options.lineWiseCopyCut) {
          return;
        } else {
          var ranges = copyableRanges(cm);
          setLastCopied({ lineWise: true, text: ranges.text });
          if (e.type == "cut") {
            cm.operation(function() {
              cm.setSelections(ranges.ranges, 0, sel_dontScroll);
              cm.replaceSelection("", null, "cut");
            });
          }
        }
        if (e.clipboardData) {
          e.clipboardData.clearData();
          var content = lastCopied.text.join("\n");
          e.clipboardData.setData("Text", content);
          if (e.clipboardData.getData("Text") == content) {
            e.preventDefault();
            return;
          }
        }
        var kludge = hiddenTextarea(), te = kludge.firstChild;
        disableBrowserMagic(te);
        cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
        te.value = lastCopied.text.join("\n");
        var hadFocus = activeElt(rootNode(div));
        selectInput(te);
        setTimeout(function() {
          cm.display.lineSpace.removeChild(kludge);
          hadFocus.focus();
          if (hadFocus == div) {
            input.showPrimarySelection();
          }
        }, 50);
      }
      on2(div, "copy", onCopyCut);
      on2(div, "cut", onCopyCut);
    };
    ContentEditableInput.prototype.screenReaderLabelChanged = function(label) {
      if (label) {
        this.div.setAttribute("aria-label", label);
      } else {
        this.div.removeAttribute("aria-label");
      }
    };
    ContentEditableInput.prototype.prepareSelection = function() {
      var result = prepareSelection(this.cm, false);
      result.focus = activeElt(rootNode(this.div)) == this.div;
      return result;
    };
    ContentEditableInput.prototype.showSelection = function(info, takeFocus) {
      if (!info || !this.cm.display.view.length) {
        return;
      }
      if (info.focus || takeFocus) {
        this.showPrimarySelection();
      }
      this.showMultipleSelections(info);
    };
    ContentEditableInput.prototype.getSelection = function() {
      return this.cm.display.wrapper.ownerDocument.getSelection();
    };
    ContentEditableInput.prototype.showPrimarySelection = function() {
      var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
      var from = prim.from(), to = prim.to();
      if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
        sel.removeAllRanges();
        return;
      }
      var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
      var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
      if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) {
        return;
      }
      var view2 = cm.display.view;
      var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || { node: view2[0].measure.map[2], offset: 0 };
      var end = to.line < cm.display.viewTo && posToDOM(cm, to);
      if (!end) {
        var measure = view2[view2.length - 1].measure;
        var map2 = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
        end = { node: map2[map2.length - 1], offset: map2[map2.length - 2] - map2[map2.length - 3] };
      }
      if (!start || !end) {
        sel.removeAllRanges();
        return;
      }
      var old = sel.rangeCount && sel.getRangeAt(0), rng;
      try {
        rng = range(start.node, start.offset, end.offset, end.node);
      } catch (e) {
      }
      if (rng) {
        if (!gecko && cm.state.focused) {
          sel.collapse(start.node, start.offset);
          if (!rng.collapsed) {
            sel.removeAllRanges();
            sel.addRange(rng);
          }
        } else {
          sel.removeAllRanges();
          sel.addRange(rng);
        }
        if (old && sel.anchorNode == null) {
          sel.addRange(old);
        } else if (gecko) {
          this.startGracePeriod();
        }
      }
      this.rememberSelection();
    };
    ContentEditableInput.prototype.startGracePeriod = function() {
      var this$1$1 = this;
      clearTimeout(this.gracePeriod);
      this.gracePeriod = setTimeout(function() {
        this$1$1.gracePeriod = false;
        if (this$1$1.selectionChanged()) {
          this$1$1.cm.operation(function() {
            return this$1$1.cm.curOp.selectionChanged = true;
          });
        }
      }, 20);
    };
    ContentEditableInput.prototype.showMultipleSelections = function(info) {
      removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
      removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
    };
    ContentEditableInput.prototype.rememberSelection = function() {
      var sel = this.getSelection();
      this.lastAnchorNode = sel.anchorNode;
      this.lastAnchorOffset = sel.anchorOffset;
      this.lastFocusNode = sel.focusNode;
      this.lastFocusOffset = sel.focusOffset;
    };
    ContentEditableInput.prototype.selectionInEditor = function() {
      var sel = this.getSelection();
      if (!sel.rangeCount) {
        return false;
      }
      var node = sel.getRangeAt(0).commonAncestorContainer;
      return contains(this.div, node);
    };
    ContentEditableInput.prototype.focus = function() {
      if (this.cm.options.readOnly != "nocursor") {
        if (!this.selectionInEditor() || activeElt(rootNode(this.div)) != this.div) {
          this.showSelection(this.prepareSelection(), true);
        }
        this.div.focus();
      }
    };
    ContentEditableInput.prototype.blur = function() {
      this.div.blur();
    };
    ContentEditableInput.prototype.getField = function() {
      return this.div;
    };
    ContentEditableInput.prototype.supportsTouch = function() {
      return true;
    };
    ContentEditableInput.prototype.receivedFocus = function() {
      var this$1$1 = this;
      var input = this;
      if (this.selectionInEditor()) {
        setTimeout(function() {
          return this$1$1.pollSelection();
        }, 20);
      } else {
        runInOp(this.cm, function() {
          return input.cm.curOp.selectionChanged = true;
        });
      }
      function poll() {
        if (input.cm.state.focused) {
          input.pollSelection();
          input.polling.set(input.cm.options.pollInterval, poll);
        }
      }
      this.polling.set(this.cm.options.pollInterval, poll);
    };
    ContentEditableInput.prototype.selectionChanged = function() {
      var sel = this.getSelection();
      return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
    };
    ContentEditableInput.prototype.pollSelection = function() {
      if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) {
        return;
      }
      var sel = this.getSelection(), cm = this.cm;
      if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
        this.cm.triggerOnKeyDown({ type: "keydown", keyCode: 8, preventDefault: Math.abs });
        this.blur();
        this.focus();
        return;
      }
      if (this.composing) {
        return;
      }
      this.rememberSelection();
      var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
      var head = domToPos(cm, sel.focusNode, sel.focusOffset);
      if (anchor && head) {
        runInOp(cm, function() {
          setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
          if (anchor.bad || head.bad) {
            cm.curOp.selectionChanged = true;
          }
        });
      }
    };
    ContentEditableInput.prototype.pollContent = function() {
      if (this.readDOMTimeout != null) {
        clearTimeout(this.readDOMTimeout);
        this.readDOMTimeout = null;
      }
      var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
      var from = sel.from(), to = sel.to();
      if (from.ch == 0 && from.line > cm.firstLine()) {
        from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
      }
      if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) {
        to = Pos(to.line + 1, 0);
      }
      if (from.line < display.viewFrom || to.line > display.viewTo - 1) {
        return false;
      }
      var fromIndex, fromLine, fromNode;
      if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
        fromLine = lineNo(display.view[0].line);
        fromNode = display.view[0].node;
      } else {
        fromLine = lineNo(display.view[fromIndex].line);
        fromNode = display.view[fromIndex - 1].node.nextSibling;
      }
      var toIndex = findViewIndex(cm, to.line);
      var toLine, toNode;
      if (toIndex == display.view.length - 1) {
        toLine = display.viewTo - 1;
        toNode = display.lineDiv.lastChild;
      } else {
        toLine = lineNo(display.view[toIndex + 1].line) - 1;
        toNode = display.view[toIndex + 1].node.previousSibling;
      }
      if (!fromNode) {
        return false;
      }
      var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
      var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
      while (newText.length > 1 && oldText.length > 1) {
        if (lst(newText) == lst(oldText)) {
          newText.pop();
          oldText.pop();
          toLine--;
        } else if (newText[0] == oldText[0]) {
          newText.shift();
          oldText.shift();
          fromLine++;
        } else {
          break;
        }
      }
      var cutFront = 0, cutEnd = 0;
      var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
      while (cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront)) {
        ++cutFront;
      }
      var newBot = lst(newText), oldBot = lst(oldText);
      var maxCutEnd = Math.min(
        newBot.length - (newText.length == 1 ? cutFront : 0),
        oldBot.length - (oldText.length == 1 ? cutFront : 0)
      );
      while (cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
        ++cutEnd;
      }
      if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) {
        while (cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)) {
          cutFront--;
          cutEnd++;
        }
      }
      newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
      newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
      var chFrom = Pos(fromLine, cutFront);
      var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
      if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
        replaceRange(cm.doc, newText, chFrom, chTo, "+input");
        return true;
      }
    };
    ContentEditableInput.prototype.ensurePolled = function() {
      this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.reset = function() {
      this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.forceCompositionEnd = function() {
      if (!this.composing) {
        return;
      }
      clearTimeout(this.readDOMTimeout);
      this.composing = null;
      this.updateFromDOM();
      this.div.blur();
      this.div.focus();
    };
    ContentEditableInput.prototype.readFromDOMSoon = function() {
      var this$1$1 = this;
      if (this.readDOMTimeout != null) {
        return;
      }
      this.readDOMTimeout = setTimeout(function() {
        this$1$1.readDOMTimeout = null;
        if (this$1$1.composing) {
          if (this$1$1.composing.done) {
            this$1$1.composing = null;
          } else {
            return;
          }
        }
        this$1$1.updateFromDOM();
      }, 80);
    };
    ContentEditableInput.prototype.updateFromDOM = function() {
      var this$1$1 = this;
      if (this.cm.isReadOnly() || !this.pollContent()) {
        runInOp(this.cm, function() {
          return regChange(this$1$1.cm);
        });
      }
    };
    ContentEditableInput.prototype.setUneditable = function(node) {
      node.contentEditable = "false";
    };
    ContentEditableInput.prototype.onKeyPress = function(e) {
      if (e.charCode == 0 || this.composing) {
        return;
      }
      e.preventDefault();
      if (!this.cm.isReadOnly()) {
        operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
      }
    };
    ContentEditableInput.prototype.readOnlyChanged = function(val) {
      this.div.contentEditable = String(val != "nocursor");
    };
    ContentEditableInput.prototype.onContextMenu = function() {
    };
    ContentEditableInput.prototype.resetPosition = function() {
    };
    ContentEditableInput.prototype.needsContentAttribute = true;
    function posToDOM(cm, pos) {
      var view2 = findViewForLine(cm, pos.line);
      if (!view2 || view2.hidden) {
        return null;
      }
      var line = getLine(cm.doc, pos.line);
      var info = mapFromLineView(view2, line, pos.line);
      var order = getOrder(line, cm.doc.direction), side = "left";
      if (order) {
        var partPos = getBidiPartAt(order, pos.ch);
        side = partPos % 2 ? "right" : "left";
      }
      var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
      result.offset = result.collapse == "right" ? result.end : result.start;
      return result;
    }
    function isInGutter(node) {
      for (var scan = node; scan; scan = scan.parentNode) {
        if (/CodeMirror-gutter-wrapper/.test(scan.className)) {
          return true;
        }
      }
      return false;
    }
    function badPos(pos, bad) {
      if (bad) {
        pos.bad = true;
      }
      return pos;
    }
    function domTextBetween(cm, from, to, fromLine, toLine) {
      var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
      function recognizeMarker(id) {
        return function(marker) {
          return marker.id == id;
        };
      }
      function close2() {
        if (closing) {
          text += lineSep;
          if (extraLinebreak) {
            text += lineSep;
          }
          closing = extraLinebreak = false;
        }
      }
      function addText(str) {
        if (str) {
          close2();
          text += str;
        }
      }
      function walk(node) {
        if (node.nodeType == 1) {
          var cmText = node.getAttribute("cm-text");
          if (cmText) {
            addText(cmText);
            return;
          }
          var markerID = node.getAttribute("cm-marker"), range2;
          if (markerID) {
            var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
            if (found.length && (range2 = found[0].find(0))) {
              addText(getBetween(cm.doc, range2.from, range2.to).join(lineSep));
            }
            return;
          }
          if (node.getAttribute("contenteditable") == "false") {
            return;
          }
          var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
          if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) {
            return;
          }
          if (isBlock) {
            close2();
          }
          for (var i2 = 0; i2 < node.childNodes.length; i2++) {
            walk(node.childNodes[i2]);
          }
          if (/^(pre|p)$/i.test(node.nodeName)) {
            extraLinebreak = true;
          }
          if (isBlock) {
            closing = true;
          }
        } else if (node.nodeType == 3) {
          addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
        }
      }
      for (; ; ) {
        walk(from);
        if (from == to) {
          break;
        }
        from = from.nextSibling;
        extraLinebreak = false;
      }
      return text;
    }
    function domToPos(cm, node, offset) {
      var lineNode;
      if (node == cm.display.lineDiv) {
        lineNode = cm.display.lineDiv.childNodes[offset];
        if (!lineNode) {
          return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
        }
        node = null;
        offset = 0;
      } else {
        for (lineNode = node; ; lineNode = lineNode.parentNode) {
          if (!lineNode || lineNode == cm.display.lineDiv) {
            return null;
          }
          if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) {
            break;
          }
        }
      }
      for (var i2 = 0; i2 < cm.display.view.length; i2++) {
        var lineView = cm.display.view[i2];
        if (lineView.node == lineNode) {
          return locateNodeInLineView(lineView, node, offset);
        }
      }
    }
    function locateNodeInLineView(lineView, node, offset) {
      var wrapper = lineView.text.firstChild, bad = false;
      if (!node || !contains(wrapper, node)) {
        return badPos(Pos(lineNo(lineView.line), 0), true);
      }
      if (node == wrapper) {
        bad = true;
        node = wrapper.childNodes[offset];
        offset = 0;
        if (!node) {
          var line = lineView.rest ? lst(lineView.rest) : lineView.line;
          return badPos(Pos(lineNo(line), line.text.length), bad);
        }
      }
      var textNode = node.nodeType == 3 ? node : null, topNode = node;
      if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
        textNode = node.firstChild;
        if (offset) {
          offset = textNode.nodeValue.length;
        }
      }
      while (topNode.parentNode != wrapper) {
        topNode = topNode.parentNode;
      }
      var measure = lineView.measure, maps = measure.maps;
      function find2(textNode2, topNode2, offset2) {
        for (var i2 = -1; i2 < (maps ? maps.length : 0); i2++) {
          var map2 = i2 < 0 ? measure.map : maps[i2];
          for (var j = 0; j < map2.length; j += 3) {
            var curNode = map2[j + 2];
            if (curNode == textNode2 || curNode == topNode2) {
              var line2 = lineNo(i2 < 0 ? lineView.line : lineView.rest[i2]);
              var ch = map2[j] + offset2;
              if (offset2 < 0 || curNode != textNode2) {
                ch = map2[j + (offset2 ? 1 : 0)];
              }
              return Pos(line2, ch);
            }
          }
        }
      }
      var found = find2(textNode, topNode, offset);
      if (found) {
        return badPos(found, bad);
      }
      for (var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling) {
        found = find2(after, after.firstChild, 0);
        if (found) {
          return badPos(Pos(found.line, found.ch - dist), bad);
        } else {
          dist += after.textContent.length;
        }
      }
      for (var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling) {
        found = find2(before, before.firstChild, -1);
        if (found) {
          return badPos(Pos(found.line, found.ch + dist$1), bad);
        } else {
          dist$1 += before.textContent.length;
        }
      }
    }
    var TextareaInput = function(cm) {
      this.cm = cm;
      this.prevInput = "";
      this.pollingFast = false;
      this.polling = new Delayed();
      this.hasSelection = false;
      this.composing = null;
      this.resetting = false;
    };
    TextareaInput.prototype.init = function(display) {
      var this$1$1 = this;
      var input = this, cm = this.cm;
      this.createField(display);
      var te = this.textarea;
      display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
      if (ios) {
        te.style.width = "0px";
      }
      on2(te, "input", function() {
        if (ie && ie_version >= 9 && this$1$1.hasSelection) {
          this$1$1.hasSelection = null;
        }
        input.poll();
      });
      on2(te, "paste", function(e) {
        if (signalDOMEvent(cm, e) || handlePaste(e, cm)) {
          return;
        }
        cm.state.pasteIncoming = +new Date();
        input.fastPoll();
      });
      function prepareCopyCut(e) {
        if (signalDOMEvent(cm, e)) {
          return;
        }
        if (cm.somethingSelected()) {
          setLastCopied({ lineWise: false, text: cm.getSelections() });
        } else if (!cm.options.lineWiseCopyCut) {
          return;
        } else {
          var ranges = copyableRanges(cm);
          setLastCopied({ lineWise: true, text: ranges.text });
          if (e.type == "cut") {
            cm.setSelections(ranges.ranges, null, sel_dontScroll);
          } else {
            input.prevInput = "";
            te.value = ranges.text.join("\n");
            selectInput(te);
          }
        }
        if (e.type == "cut") {
          cm.state.cutIncoming = +new Date();
        }
      }
      on2(te, "cut", prepareCopyCut);
      on2(te, "copy", prepareCopyCut);
      on2(display.scroller, "paste", function(e) {
        if (eventInWidget(display, e) || signalDOMEvent(cm, e)) {
          return;
        }
        if (!te.dispatchEvent) {
          cm.state.pasteIncoming = +new Date();
          input.focus();
          return;
        }
        var event = new Event("paste");
        event.clipboardData = e.clipboardData;
        te.dispatchEvent(event);
      });
      on2(display.lineSpace, "selectstart", function(e) {
        if (!eventInWidget(display, e)) {
          e_preventDefault(e);
        }
      });
      on2(te, "compositionstart", function() {
        var start = cm.getCursor("from");
        if (input.composing) {
          input.composing.range.clear();
        }
        input.composing = {
          start,
          range: cm.markText(start, cm.getCursor("to"), { className: "CodeMirror-composing" })
        };
      });
      on2(te, "compositionend", function() {
        if (input.composing) {
          input.poll();
          input.composing.range.clear();
          input.composing = null;
        }
      });
    };
    TextareaInput.prototype.createField = function(_display) {
      this.wrapper = hiddenTextarea();
      this.textarea = this.wrapper.firstChild;
      var opts = this.cm.options;
      disableBrowserMagic(this.textarea, opts.spellcheck, opts.autocorrect, opts.autocapitalize);
    };
    TextareaInput.prototype.screenReaderLabelChanged = function(label) {
      if (label) {
        this.textarea.setAttribute("aria-label", label);
      } else {
        this.textarea.removeAttribute("aria-label");
      }
    };
    TextareaInput.prototype.prepareSelection = function() {
      var cm = this.cm, display = cm.display, doc2 = cm.doc;
      var result = prepareSelection(cm);
      if (cm.options.moveInputWithCursor) {
        var headPos = cursorCoords(cm, doc2.sel.primary().head, "div");
        var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
        result.teTop = Math.max(0, Math.min(
          display.wrapper.clientHeight - 10,
          headPos.top + lineOff.top - wrapOff.top
        ));
        result.teLeft = Math.max(0, Math.min(
          display.wrapper.clientWidth - 10,
          headPos.left + lineOff.left - wrapOff.left
        ));
      }
      return result;
    };
    TextareaInput.prototype.showSelection = function(drawn) {
      var cm = this.cm, display = cm.display;
      removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
      removeChildrenAndAdd(display.selectionDiv, drawn.selection);
      if (drawn.teTop != null) {
        this.wrapper.style.top = drawn.teTop + "px";
        this.wrapper.style.left = drawn.teLeft + "px";
      }
    };
    TextareaInput.prototype.reset = function(typing) {
      if (this.contextMenuPending || this.composing && typing) {
        return;
      }
      var cm = this.cm;
      this.resetting = true;
      if (cm.somethingSelected()) {
        this.prevInput = "";
        var content = cm.getSelection();
        this.textarea.value = content;
        if (cm.state.focused) {
          selectInput(this.textarea);
        }
        if (ie && ie_version >= 9) {
          this.hasSelection = content;
        }
      } else if (!typing) {
        this.prevInput = this.textarea.value = "";
        if (ie && ie_version >= 9) {
          this.hasSelection = null;
        }
      }
      this.resetting = false;
    };
    TextareaInput.prototype.getField = function() {
      return this.textarea;
    };
    TextareaInput.prototype.supportsTouch = function() {
      return false;
    };
    TextareaInput.prototype.focus = function() {
      if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt(rootNode(this.textarea)) != this.textarea)) {
        try {
          this.textarea.focus();
        } catch (e) {
        }
      }
    };
    TextareaInput.prototype.blur = function() {
      this.textarea.blur();
    };
    TextareaInput.prototype.resetPosition = function() {
      this.wrapper.style.top = this.wrapper.style.left = 0;
    };
    TextareaInput.prototype.receivedFocus = function() {
      this.slowPoll();
    };
    TextareaInput.prototype.slowPoll = function() {
      var this$1$1 = this;
      if (this.pollingFast) {
        return;
      }
      this.polling.set(this.cm.options.pollInterval, function() {
        this$1$1.poll();
        if (this$1$1.cm.state.focused) {
          this$1$1.slowPoll();
        }
      });
    };
    TextareaInput.prototype.fastPoll = function() {
      var missed = false, input = this;
      input.pollingFast = true;
      function p() {
        var changed = input.poll();
        if (!changed && !missed) {
          missed = true;
          input.polling.set(60, p);
        } else {
          input.pollingFast = false;
          input.slowPoll();
        }
      }
      input.polling.set(20, p);
    };
    TextareaInput.prototype.poll = function() {
      var this$1$1 = this;
      var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
      if (this.contextMenuPending || this.resetting || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) {
        return false;
      }
      var text = input.value;
      if (text == prevInput && !cm.somethingSelected()) {
        return false;
      }
      if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
        cm.display.input.reset();
        return false;
      }
      if (cm.doc.sel == cm.display.selForContextMenu) {
        var first = text.charCodeAt(0);
        if (first == 8203 && !prevInput) {
          prevInput = "\u200B";
        }
        if (first == 8666) {
          this.reset();
          return this.cm.execCommand("undo");
        }
      }
      var same = 0, l = Math.min(prevInput.length, text.length);
      while (same < l && prevInput.charCodeAt(same) == text.charCodeAt(same)) {
        ++same;
      }
      runInOp(cm, function() {
        applyTextInput(
          cm,
          text.slice(same),
          prevInput.length - same,
          null,
          this$1$1.composing ? "*compose" : null
        );
        if (text.length > 1e3 || text.indexOf("\n") > -1) {
          input.value = this$1$1.prevInput = "";
        } else {
          this$1$1.prevInput = text;
        }
        if (this$1$1.composing) {
          this$1$1.composing.range.clear();
          this$1$1.composing.range = cm.markText(
            this$1$1.composing.start,
            cm.getCursor("to"),
            { className: "CodeMirror-composing" }
          );
        }
      });
      return true;
    };
    TextareaInput.prototype.ensurePolled = function() {
      if (this.pollingFast && this.poll()) {
        this.pollingFast = false;
      }
    };
    TextareaInput.prototype.onKeyPress = function() {
      if (ie && ie_version >= 9) {
        this.hasSelection = null;
      }
      this.fastPoll();
    };
    TextareaInput.prototype.onContextMenu = function(e) {
      var input = this, cm = input.cm, display = cm.display, te = input.textarea;
      if (input.contextMenuPending) {
        input.contextMenuPending();
      }
      var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
      if (!pos || presto) {
        return;
      }
      var reset2 = cm.options.resetSelectionOnContextMenu;
      if (reset2 && cm.doc.sel.contains(pos) == -1) {
        operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
      }
      var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
      var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
      input.wrapper.style.cssText = "position: static";
      te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
      var oldScrollY;
      if (webkit) {
        oldScrollY = te.ownerDocument.defaultView.scrollY;
      }
      display.input.focus();
      if (webkit) {
        te.ownerDocument.defaultView.scrollTo(null, oldScrollY);
      }
      display.input.reset();
      if (!cm.somethingSelected()) {
        te.value = input.prevInput = " ";
      }
      input.contextMenuPending = rehide;
      display.selForContextMenu = cm.doc.sel;
      clearTimeout(display.detectingSelectAll);
      function prepareSelectAllHack() {
        if (te.selectionStart != null) {
          var selected = cm.somethingSelected();
          var extval = "\u200B" + (selected ? te.value : "");
          te.value = "\u21DA";
          te.value = extval;
          input.prevInput = selected ? "" : "\u200B";
          te.selectionStart = 1;
          te.selectionEnd = extval.length;
          display.selForContextMenu = cm.doc.sel;
        }
      }
      function rehide() {
        if (input.contextMenuPending != rehide) {
          return;
        }
        input.contextMenuPending = false;
        input.wrapper.style.cssText = oldWrapperCSS;
        te.style.cssText = oldCSS;
        if (ie && ie_version < 9) {
          display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
        }
        if (te.selectionStart != null) {
          if (!ie || ie && ie_version < 9) {
            prepareSelectAllHack();
          }
          var i2 = 0, poll = function() {
            if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == "\u200B") {
              operation(cm, selectAll)(cm);
            } else if (i2++ < 10) {
              display.detectingSelectAll = setTimeout(poll, 500);
            } else {
              display.selForContextMenu = null;
              display.input.reset();
            }
          };
          display.detectingSelectAll = setTimeout(poll, 200);
        }
      }
      if (ie && ie_version >= 9) {
        prepareSelectAllHack();
      }
      if (captureRightClick) {
        e_stop(e);
        var mouseup = function() {
          off2(window, "mouseup", mouseup);
          setTimeout(rehide, 20);
        };
        on2(window, "mouseup", mouseup);
      } else {
        setTimeout(rehide, 50);
      }
    };
    TextareaInput.prototype.readOnlyChanged = function(val) {
      if (!val) {
        this.reset();
      }
      this.textarea.disabled = val == "nocursor";
      this.textarea.readOnly = !!val;
    };
    TextareaInput.prototype.setUneditable = function() {
    };
    TextareaInput.prototype.needsContentAttribute = false;
    function fromTextArea(textarea, options) {
      options = options ? copyObj(options) : {};
      options.value = textarea.value;
      if (!options.tabindex && textarea.tabIndex) {
        options.tabindex = textarea.tabIndex;
      }
      if (!options.placeholder && textarea.placeholder) {
        options.placeholder = textarea.placeholder;
      }
      if (options.autofocus == null) {
        var hasFocus = activeElt(rootNode(textarea));
        options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
      }
      function save2() {
        textarea.value = cm.getValue();
      }
      var realSubmit;
      if (textarea.form) {
        on2(textarea.form, "submit", save2);
        if (!options.leaveSubmitMethodAlone) {
          var form = textarea.form;
          realSubmit = form.submit;
          try {
            var wrappedSubmit = form.submit = function() {
              save2();
              form.submit = realSubmit;
              form.submit();
              form.submit = wrappedSubmit;
            };
          } catch (e) {
          }
        }
      }
      options.finishInit = function(cm2) {
        cm2.save = save2;
        cm2.getTextArea = function() {
          return textarea;
        };
        cm2.toTextArea = function() {
          cm2.toTextArea = isNaN;
          save2();
          textarea.parentNode.removeChild(cm2.getWrapperElement());
          textarea.style.display = "";
          if (textarea.form) {
            off2(textarea.form, "submit", save2);
            if (!options.leaveSubmitMethodAlone && typeof textarea.form.submit == "function") {
              textarea.form.submit = realSubmit;
            }
          }
        };
      };
      textarea.style.display = "none";
      var cm = CodeMirror2(
        function(node) {
          return textarea.parentNode.insertBefore(node, textarea.nextSibling);
        },
        options
      );
      return cm;
    }
    function addLegacyProps(CodeMirror3) {
      CodeMirror3.off = off2;
      CodeMirror3.on = on2;
      CodeMirror3.wheelEventPixels = wheelEventPixels;
      CodeMirror3.Doc = Doc;
      CodeMirror3.splitLines = splitLinesAuto;
      CodeMirror3.countColumn = countColumn;
      CodeMirror3.findColumn = findColumn;
      CodeMirror3.isWordChar = isWordCharBasic;
      CodeMirror3.Pass = Pass;
      CodeMirror3.signal = signal;
      CodeMirror3.Line = Line;
      CodeMirror3.changeEnd = changeEnd;
      CodeMirror3.scrollbarModel = scrollbarModel;
      CodeMirror3.Pos = Pos;
      CodeMirror3.cmpPos = cmp;
      CodeMirror3.modes = modes;
      CodeMirror3.mimeModes = mimeModes;
      CodeMirror3.resolveMode = resolveMode;
      CodeMirror3.getMode = getMode;
      CodeMirror3.modeExtensions = modeExtensions;
      CodeMirror3.extendMode = extendMode;
      CodeMirror3.copyState = copyState;
      CodeMirror3.startState = startState;
      CodeMirror3.innerMode = innerMode;
      CodeMirror3.commands = commands;
      CodeMirror3.keyMap = keyMap;
      CodeMirror3.keyName = keyName;
      CodeMirror3.isModifierKey = isModifierKey;
      CodeMirror3.lookupKey = lookupKey;
      CodeMirror3.normalizeKeyMap = normalizeKeyMap;
      CodeMirror3.StringStream = StringStream;
      CodeMirror3.SharedTextMarker = SharedTextMarker;
      CodeMirror3.TextMarker = TextMarker;
      CodeMirror3.LineWidget = LineWidget;
      CodeMirror3.e_preventDefault = e_preventDefault;
      CodeMirror3.e_stopPropagation = e_stopPropagation;
      CodeMirror3.e_stop = e_stop;
      CodeMirror3.addClass = addClass2;
      CodeMirror3.contains = contains;
      CodeMirror3.rmClass = rmClass;
      CodeMirror3.keyNames = keyNames;
    }
    defineOptions(CodeMirror2);
    addEditorMethods(CodeMirror2);
    var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
    for (var prop in Doc.prototype) {
      if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) {
        CodeMirror2.prototype[prop] = function(method) {
          return function() {
            return method.apply(this.doc, arguments);
          };
        }(Doc.prototype[prop]);
      }
    }
    eventMixin(Doc);
    CodeMirror2.inputStyles = { "textarea": TextareaInput, "contenteditable": ContentEditableInput };
    CodeMirror2.defineMode = function(name) {
      if (!CodeMirror2.defaults.mode && name != "null") {
        CodeMirror2.defaults.mode = name;
      }
      defineMode.apply(this, arguments);
    };
    CodeMirror2.defineMIME = defineMIME;
    CodeMirror2.defineMode("null", function() {
      return { token: function(stream) {
        return stream.skipToEnd();
      } };
    });
    CodeMirror2.defineMIME("text/plain", "null");
    CodeMirror2.defineExtension = function(name, func) {
      CodeMirror2.prototype[name] = func;
    };
    CodeMirror2.defineDocExtension = function(name, func) {
      Doc.prototype[name] = func;
    };
    CodeMirror2.fromTextArea = fromTextArea;
    addLegacyProps(CodeMirror2);
    CodeMirror2.version = "5.65.16";
    return CodeMirror2;
  });
})(codemirror$1);
var CodeMirror = codemirror$1.exports;
var codemirror = "";
(function(module, exports) {
  (function(mod) {
    mod(codemirror$1.exports);
  })(function(CodeMirror2) {
    CodeMirror2.defineMode("javascript", function(config, parserConfig) {
      var indentUnit = config.indentUnit;
      var statementIndent = parserConfig.statementIndent;
      var jsonldMode = parserConfig.jsonld;
      var jsonMode = parserConfig.json || jsonldMode;
      var trackScope = parserConfig.trackScope !== false;
      var isTS = parserConfig.typescript;
      var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;
      var keywords = function() {
        function kw(type2) {
          return { type: type2, style: "keyword" };
        }
        var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
        var operator = kw("operator"), atom = { type: "atom", style: "atom" };
        return {
          "if": kw("if"),
          "while": A,
          "with": A,
          "else": B,
          "do": B,
          "try": B,
          "finally": B,
          "return": D,
          "break": D,
          "continue": D,
          "new": kw("new"),
          "delete": C,
          "void": C,
          "throw": C,
          "debugger": kw("debugger"),
          "var": kw("var"),
          "const": kw("var"),
          "let": kw("var"),
          "function": kw("function"),
          "catch": kw("catch"),
          "for": kw("for"),
          "switch": kw("switch"),
          "case": kw("case"),
          "default": kw("default"),
          "in": operator,
          "typeof": operator,
          "instanceof": operator,
          "true": atom,
          "false": atom,
          "null": atom,
          "undefined": atom,
          "NaN": atom,
          "Infinity": atom,
          "this": kw("this"),
          "class": kw("class"),
          "super": kw("atom"),
          "yield": C,
          "export": kw("export"),
          "import": kw("import"),
          "extends": C,
          "await": C
        };
      }();
      var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
      var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
      function readRegexp(stream) {
        var escaped = false, next2, inSet = false;
        while ((next2 = stream.next()) != null) {
          if (!escaped) {
            if (next2 == "/" && !inSet)
              return;
            if (next2 == "[")
              inSet = true;
            else if (inSet && next2 == "]")
              inSet = false;
          }
          escaped = !escaped && next2 == "\\";
        }
      }
      var type, content;
      function ret(tp, style, cont2) {
        type = tp;
        content = cont2;
        return style;
      }
      function tokenBase(stream, state) {
        var ch = stream.next();
        if (ch == '"' || ch == "'") {
          state.tokenize = tokenString(ch);
          return state.tokenize(stream, state);
        } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) {
          return ret("number", "number");
        } else if (ch == "." && stream.match("..")) {
          return ret("spread", "meta");
        } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
          return ret(ch);
        } else if (ch == "=" && stream.eat(">")) {
          return ret("=>", "operator");
        } else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
          return ret("number", "number");
        } else if (/\d/.test(ch)) {
          stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
          return ret("number", "number");
        } else if (ch == "/") {
          if (stream.eat("*")) {
            state.tokenize = tokenComment;
            return tokenComment(stream, state);
          } else if (stream.eat("/")) {
            stream.skipToEnd();
            return ret("comment", "comment");
          } else if (expressionAllowed(stream, state, 1)) {
            readRegexp(stream);
            stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
            return ret("regexp", "string-2");
          } else {
            stream.eat("=");
            return ret("operator", "operator", stream.current());
          }
        } else if (ch == "`") {
          state.tokenize = tokenQuasi;
          return tokenQuasi(stream, state);
        } else if (ch == "#" && stream.peek() == "!") {
          stream.skipToEnd();
          return ret("meta", "meta");
        } else if (ch == "#" && stream.eatWhile(wordRE)) {
          return ret("variable", "property");
        } else if (ch == "<" && stream.match("!--") || ch == "-" && stream.match("->") && !/\S/.test(stream.string.slice(0, stream.start))) {
          stream.skipToEnd();
          return ret("comment", "comment");
        } else if (isOperatorChar.test(ch)) {
          if (ch != ">" || !state.lexical || state.lexical.type != ">") {
            if (stream.eat("=")) {
              if (ch == "!" || ch == "=")
                stream.eat("=");
            } else if (/[<>*+\-|&?]/.test(ch)) {
              stream.eat(ch);
              if (ch == ">")
                stream.eat(ch);
            }
          }
          if (ch == "?" && stream.eat("."))
            return ret(".");
          return ret("operator", "operator", stream.current());
        } else if (wordRE.test(ch)) {
          stream.eatWhile(wordRE);
          var word = stream.current();
          if (state.lastType != ".") {
            if (keywords.propertyIsEnumerable(word)) {
              var kw = keywords[word];
              return ret(kw.type, kw.style, word);
            }
            if (word == "async" && stream.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, false))
              return ret("async", "keyword", word);
          }
          return ret("variable", "variable", word);
        }
      }
      function tokenString(quote) {
        return function(stream, state) {
          var escaped = false, next2;
          if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)) {
            state.tokenize = tokenBase;
            return ret("jsonld-keyword", "meta");
          }
          while ((next2 = stream.next()) != null) {
            if (next2 == quote && !escaped)
              break;
            escaped = !escaped && next2 == "\\";
          }
          if (!escaped)
            state.tokenize = tokenBase;
          return ret("string", "string");
        };
      }
      function tokenComment(stream, state) {
        var maybeEnd = false, ch;
        while (ch = stream.next()) {
          if (ch == "/" && maybeEnd) {
            state.tokenize = tokenBase;
            break;
          }
          maybeEnd = ch == "*";
        }
        return ret("comment", "comment");
      }
      function tokenQuasi(stream, state) {
        var escaped = false, next2;
        while ((next2 = stream.next()) != null) {
          if (!escaped && (next2 == "`" || next2 == "$" && stream.eat("{"))) {
            state.tokenize = tokenBase;
            break;
          }
          escaped = !escaped && next2 == "\\";
        }
        return ret("quasi", "string-2", stream.current());
      }
      var brackets = "([{}])";
      function findFatArrow(stream, state) {
        if (state.fatArrowAt)
          state.fatArrowAt = null;
        var arrow = stream.string.indexOf("=>", stream.start);
        if (arrow < 0)
          return;
        if (isTS) {
          var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow));
          if (m)
            arrow = m.index;
        }
        var depth = 0, sawSomething = false;
        for (var pos = arrow - 1; pos >= 0; --pos) {
          var ch = stream.string.charAt(pos);
          var bracket = brackets.indexOf(ch);
          if (bracket >= 0 && bracket < 3) {
            if (!depth) {
              ++pos;
              break;
            }
            if (--depth == 0) {
              if (ch == "(")
                sawSomething = true;
              break;
            }
          } else if (bracket >= 3 && bracket < 6) {
            ++depth;
          } else if (wordRE.test(ch)) {
            sawSomething = true;
          } else if (/["'\/`]/.test(ch)) {
            for (; ; --pos) {
              if (pos == 0)
                return;
              var next2 = stream.string.charAt(pos - 1);
              if (next2 == ch && stream.string.charAt(pos - 2) != "\\") {
                pos--;
                break;
              }
            }
          } else if (sawSomething && !depth) {
            ++pos;
            break;
          }
        }
        if (sawSomething && !depth)
          state.fatArrowAt = pos;
      }
      var atomicTypes = {
        "atom": true,
        "number": true,
        "variable": true,
        "string": true,
        "regexp": true,
        "this": true,
        "import": true,
        "jsonld-keyword": true
      };
      function JSLexical(indented, column, type2, align, prev2, info) {
        this.indented = indented;
        this.column = column;
        this.type = type2;
        this.prev = prev2;
        this.info = info;
        if (align != null)
          this.align = align;
      }
      function inScope(state, varname) {
        if (!trackScope)
          return false;
        for (var v = state.localVars; v; v = v.next)
          if (v.name == varname)
            return true;
        for (var cx2 = state.context; cx2; cx2 = cx2.prev) {
          for (var v = cx2.vars; v; v = v.next)
            if (v.name == varname)
              return true;
        }
      }
      function parseJS(state, style, type2, content2, stream) {
        var cc = state.cc;
        cx.state = state;
        cx.stream = stream;
        cx.marked = null, cx.cc = cc;
        cx.style = style;
        if (!state.lexical.hasOwnProperty("align"))
          state.lexical.align = true;
        while (true) {
          var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
          if (combinator(type2, content2)) {
            while (cc.length && cc[cc.length - 1].lex)
              cc.pop()();
            if (cx.marked)
              return cx.marked;
            if (type2 == "variable" && inScope(state, content2))
              return "variable-2";
            return style;
          }
        }
      }
      var cx = { state: null, column: null, marked: null, cc: null };
      function pass() {
        for (var i = arguments.length - 1; i >= 0; i--)
          cx.cc.push(arguments[i]);
      }
      function cont() {
        pass.apply(null, arguments);
        return true;
      }
      function inList(name, list) {
        for (var v = list; v; v = v.next)
          if (v.name == name)
            return true;
        return false;
      }
      function register(varname) {
        var state = cx.state;
        cx.marked = "def";
        if (!trackScope)
          return;
        if (state.context) {
          if (state.lexical.info == "var" && state.context && state.context.block) {
            var newContext = registerVarScoped(varname, state.context);
            if (newContext != null) {
              state.context = newContext;
              return;
            }
          } else if (!inList(varname, state.localVars)) {
            state.localVars = new Var(varname, state.localVars);
            return;
          }
        }
        if (parserConfig.globalVars && !inList(varname, state.globalVars))
          state.globalVars = new Var(varname, state.globalVars);
      }
      function registerVarScoped(varname, context) {
        if (!context) {
          return null;
        } else if (context.block) {
          var inner = registerVarScoped(varname, context.prev);
          if (!inner)
            return null;
          if (inner == context.prev)
            return context;
          return new Context(inner, context.vars, true);
        } else if (inList(varname, context.vars)) {
          return context;
        } else {
          return new Context(context.prev, new Var(varname, context.vars), false);
        }
      }
      function isModifier(name) {
        return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly";
      }
      function Context(prev2, vars2, block2) {
        this.prev = prev2;
        this.vars = vars2;
        this.block = block2;
      }
      function Var(name, next2) {
        this.name = name;
        this.next = next2;
      }
      var defaultVars = new Var("this", new Var("arguments", null));
      function pushcontext() {
        cx.state.context = new Context(cx.state.context, cx.state.localVars, false);
        cx.state.localVars = defaultVars;
      }
      function pushblockcontext() {
        cx.state.context = new Context(cx.state.context, cx.state.localVars, true);
        cx.state.localVars = null;
      }
      pushcontext.lex = pushblockcontext.lex = true;
      function popcontext() {
        cx.state.localVars = cx.state.context.vars;
        cx.state.context = cx.state.context.prev;
      }
      popcontext.lex = true;
      function pushlex(type2, info) {
        var result = function() {
          var state = cx.state, indent = state.indented;
          if (state.lexical.type == "stat")
            indent = state.lexical.indented;
          else
            for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
              indent = outer.indented;
          state.lexical = new JSLexical(indent, cx.stream.column(), type2, null, state.lexical, info);
        };
        result.lex = true;
        return result;
      }
      function poplex() {
        var state = cx.state;
        if (state.lexical.prev) {
          if (state.lexical.type == ")")
            state.indented = state.lexical.indented;
          state.lexical = state.lexical.prev;
        }
      }
      poplex.lex = true;
      function expect(wanted) {
        function exp(type2) {
          if (type2 == wanted)
            return cont();
          else if (wanted == ";" || type2 == "}" || type2 == ")" || type2 == "]")
            return pass();
          else
            return cont(exp);
        }
        return exp;
      }
      function statement(type2, value) {
        if (type2 == "var")
          return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
        if (type2 == "keyword a")
          return cont(pushlex("form"), parenExpr, statement, poplex);
        if (type2 == "keyword b")
          return cont(pushlex("form"), statement, poplex);
        if (type2 == "keyword d")
          return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
        if (type2 == "debugger")
          return cont(expect(";"));
        if (type2 == "{")
          return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
        if (type2 == ";")
          return cont();
        if (type2 == "if") {
          if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
            cx.state.cc.pop()();
          return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
        }
        if (type2 == "function")
          return cont(functiondef);
        if (type2 == "for")
          return cont(pushlex("form"), pushblockcontext, forspec, statement, popcontext, poplex);
        if (type2 == "class" || isTS && value == "interface") {
          cx.marked = "keyword";
          return cont(pushlex("form", type2 == "class" ? type2 : value), className, poplex);
        }
        if (type2 == "variable") {
          if (isTS && value == "declare") {
            cx.marked = "keyword";
            return cont(statement);
          } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
            cx.marked = "keyword";
            if (value == "enum")
              return cont(enumdef);
            else if (value == "type")
              return cont(typename, expect("operator"), typeexpr, expect(";"));
            else
              return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex);
          } else if (isTS && value == "namespace") {
            cx.marked = "keyword";
            return cont(pushlex("form"), expression, statement, poplex);
          } else if (isTS && value == "abstract") {
            cx.marked = "keyword";
            return cont(statement);
          } else {
            return cont(pushlex("stat"), maybelabel);
          }
        }
        if (type2 == "switch")
          return cont(
            pushlex("form"),
            parenExpr,
            expect("{"),
            pushlex("}", "switch"),
            pushblockcontext,
            block,
            poplex,
            poplex,
            popcontext
          );
        if (type2 == "case")
          return cont(expression, expect(":"));
        if (type2 == "default")
          return cont(expect(":"));
        if (type2 == "catch")
          return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
        if (type2 == "export")
          return cont(pushlex("stat"), afterExport, poplex);
        if (type2 == "import")
          return cont(pushlex("stat"), afterImport, poplex);
        if (type2 == "async")
          return cont(statement);
        if (value == "@")
          return cont(expression, statement);
        return pass(pushlex("stat"), expression, expect(";"), poplex);
      }
      function maybeCatchBinding(type2) {
        if (type2 == "(")
          return cont(funarg, expect(")"));
      }
      function expression(type2, value) {
        return expressionInner(type2, value, false);
      }
      function expressionNoComma(type2, value) {
        return expressionInner(type2, value, true);
      }
      function parenExpr(type2) {
        if (type2 != "(")
          return pass();
        return cont(pushlex(")"), maybeexpression, expect(")"), poplex);
      }
      function expressionInner(type2, value, noComma) {
        if (cx.state.fatArrowAt == cx.stream.start) {
          var body = noComma ? arrowBodyNoComma : arrowBody;
          if (type2 == "(")
            return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
          else if (type2 == "variable")
            return pass(pushcontext, pattern, expect("=>"), body, popcontext);
        }
        var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
        if (atomicTypes.hasOwnProperty(type2))
          return cont(maybeop);
        if (type2 == "function")
          return cont(functiondef, maybeop);
        if (type2 == "class" || isTS && value == "interface") {
          cx.marked = "keyword";
          return cont(pushlex("form"), classExpression, poplex);
        }
        if (type2 == "keyword c" || type2 == "async")
          return cont(noComma ? expressionNoComma : expression);
        if (type2 == "(")
          return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
        if (type2 == "operator" || type2 == "spread")
          return cont(noComma ? expressionNoComma : expression);
        if (type2 == "[")
          return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
        if (type2 == "{")
          return contCommasep(objprop, "}", null, maybeop);
        if (type2 == "quasi")
          return pass(quasi, maybeop);
        if (type2 == "new")
          return cont(maybeTarget(noComma));
        return cont();
      }
      function maybeexpression(type2) {
        if (type2.match(/[;\}\)\],]/))
          return pass();
        return pass(expression);
      }
      function maybeoperatorComma(type2, value) {
        if (type2 == ",")
          return cont(maybeexpression);
        return maybeoperatorNoComma(type2, value, false);
      }
      function maybeoperatorNoComma(type2, value, noComma) {
        var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
        var expr = noComma == false ? expression : expressionNoComma;
        if (type2 == "=>")
          return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
        if (type2 == "operator") {
          if (/\+\+|--/.test(value) || isTS && value == "!")
            return cont(me);
          if (isTS && value == "<" && cx.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, false))
            return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
          if (value == "?")
            return cont(expression, expect(":"), expr);
          return cont(expr);
        }
        if (type2 == "quasi") {
          return pass(quasi, me);
        }
        if (type2 == ";")
          return;
        if (type2 == "(")
          return contCommasep(expressionNoComma, ")", "call", me);
        if (type2 == ".")
          return cont(property, me);
        if (type2 == "[")
          return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
        if (isTS && value == "as") {
          cx.marked = "keyword";
          return cont(typeexpr, me);
        }
        if (type2 == "regexp") {
          cx.state.lastType = cx.marked = "operator";
          cx.stream.backUp(cx.stream.pos - cx.stream.start - 1);
          return cont(expr);
        }
      }
      function quasi(type2, value) {
        if (type2 != "quasi")
          return pass();
        if (value.slice(value.length - 2) != "${")
          return cont(quasi);
        return cont(maybeexpression, continueQuasi);
      }
      function continueQuasi(type2) {
        if (type2 == "}") {
          cx.marked = "string-2";
          cx.state.tokenize = tokenQuasi;
          return cont(quasi);
        }
      }
      function arrowBody(type2) {
        findFatArrow(cx.stream, cx.state);
        return pass(type2 == "{" ? statement : expression);
      }
      function arrowBodyNoComma(type2) {
        findFatArrow(cx.stream, cx.state);
        return pass(type2 == "{" ? statement : expressionNoComma);
      }
      function maybeTarget(noComma) {
        return function(type2) {
          if (type2 == ".")
            return cont(noComma ? targetNoComma : target);
          else if (type2 == "variable" && isTS)
            return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma);
          else
            return pass(noComma ? expressionNoComma : expression);
        };
      }
      function target(_2, value) {
        if (value == "target") {
          cx.marked = "keyword";
          return cont(maybeoperatorComma);
        }
      }
      function targetNoComma(_2, value) {
        if (value == "target") {
          cx.marked = "keyword";
          return cont(maybeoperatorNoComma);
        }
      }
      function maybelabel(type2) {
        if (type2 == ":")
          return cont(poplex, statement);
        return pass(maybeoperatorComma, expect(";"), poplex);
      }
      function property(type2) {
        if (type2 == "variable") {
          cx.marked = "property";
          return cont();
        }
      }
      function objprop(type2, value) {
        if (type2 == "async") {
          cx.marked = "property";
          return cont(objprop);
        } else if (type2 == "variable" || cx.style == "keyword") {
          cx.marked = "property";
          if (value == "get" || value == "set")
            return cont(getterSetter);
          var m;
          if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false)))
            cx.state.fatArrowAt = cx.stream.pos + m[0].length;
          return cont(afterprop);
        } else if (type2 == "number" || type2 == "string") {
          cx.marked = jsonldMode ? "property" : cx.style + " property";
          return cont(afterprop);
        } else if (type2 == "jsonld-keyword") {
          return cont(afterprop);
        } else if (isTS && isModifier(value)) {
          cx.marked = "keyword";
          return cont(objprop);
        } else if (type2 == "[") {
          return cont(expression, maybetype, expect("]"), afterprop);
        } else if (type2 == "spread") {
          return cont(expressionNoComma, afterprop);
        } else if (value == "*") {
          cx.marked = "keyword";
          return cont(objprop);
        } else if (type2 == ":") {
          return pass(afterprop);
        }
      }
      function getterSetter(type2) {
        if (type2 != "variable")
          return pass(afterprop);
        cx.marked = "property";
        return cont(functiondef);
      }
      function afterprop(type2) {
        if (type2 == ":")
          return cont(expressionNoComma);
        if (type2 == "(")
          return pass(functiondef);
      }
      function commasep(what, end, sep) {
        function proceed(type2, value) {
          if (sep ? sep.indexOf(type2) > -1 : type2 == ",") {
            var lex = cx.state.lexical;
            if (lex.info == "call")
              lex.pos = (lex.pos || 0) + 1;
            return cont(function(type3, value2) {
              if (type3 == end || value2 == end)
                return pass();
              return pass(what);
            }, proceed);
          }
          if (type2 == end || value == end)
            return cont();
          if (sep && sep.indexOf(";") > -1)
            return pass(what);
          return cont(expect(end));
        }
        return function(type2, value) {
          if (type2 == end || value == end)
            return cont();
          return pass(what, proceed);
        };
      }
      function contCommasep(what, end, info) {
        for (var i = 3; i < arguments.length; i++)
          cx.cc.push(arguments[i]);
        return cont(pushlex(end, info), commasep(what, end), poplex);
      }
      function block(type2) {
        if (type2 == "}")
          return cont();
        return pass(statement, block);
      }
      function maybetype(type2, value) {
        if (isTS) {
          if (type2 == ":")
            return cont(typeexpr);
          if (value == "?")
            return cont(maybetype);
        }
      }
      function maybetypeOrIn(type2, value) {
        if (isTS && (type2 == ":" || value == "in"))
          return cont(typeexpr);
      }
      function mayberettype(type2) {
        if (isTS && type2 == ":") {
          if (cx.stream.match(/^\s*\w+\s+is\b/, false))
            return cont(expression, isKW, typeexpr);
          else
            return cont(typeexpr);
        }
      }
      function isKW(_2, value) {
        if (value == "is") {
          cx.marked = "keyword";
          return cont();
        }
      }
      function typeexpr(type2, value) {
        if (value == "keyof" || value == "typeof" || value == "infer" || value == "readonly") {
          cx.marked = "keyword";
          return cont(value == "typeof" ? expressionNoComma : typeexpr);
        }
        if (type2 == "variable" || value == "void") {
          cx.marked = "type";
          return cont(afterType);
        }
        if (value == "|" || value == "&")
          return cont(typeexpr);
        if (type2 == "string" || type2 == "number" || type2 == "atom")
          return cont(afterType);
        if (type2 == "[")
          return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType);
        if (type2 == "{")
          return cont(pushlex("}"), typeprops, poplex, afterType);
        if (type2 == "(")
          return cont(commasep(typearg, ")"), maybeReturnType, afterType);
        if (type2 == "<")
          return cont(commasep(typeexpr, ">"), typeexpr);
        if (type2 == "quasi") {
          return pass(quasiType, afterType);
        }
      }
      function maybeReturnType(type2) {
        if (type2 == "=>")
          return cont(typeexpr);
      }
      function typeprops(type2) {
        if (type2.match(/[\}\)\]]/))
          return cont();
        if (type2 == "," || type2 == ";")
          return cont(typeprops);
        return pass(typeprop, typeprops);
      }
      function typeprop(type2, value) {
        if (type2 == "variable" || cx.style == "keyword") {
          cx.marked = "property";
          return cont(typeprop);
        } else if (value == "?" || type2 == "number" || type2 == "string") {
          return cont(typeprop);
        } else if (type2 == ":") {
          return cont(typeexpr);
        } else if (type2 == "[") {
          return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop);
        } else if (type2 == "(") {
          return pass(functiondecl, typeprop);
        } else if (!type2.match(/[;\}\)\],]/)) {
          return cont();
        }
      }
      function quasiType(type2, value) {
        if (type2 != "quasi")
          return pass();
        if (value.slice(value.length - 2) != "${")
          return cont(quasiType);
        return cont(typeexpr, continueQuasiType);
      }
      function continueQuasiType(type2) {
        if (type2 == "}") {
          cx.marked = "string-2";
          cx.state.tokenize = tokenQuasi;
          return cont(quasiType);
        }
      }
      function typearg(type2, value) {
        if (type2 == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?")
          return cont(typearg);
        if (type2 == ":")
          return cont(typeexpr);
        if (type2 == "spread")
          return cont(typearg);
        return pass(typeexpr);
      }
      function afterType(type2, value) {
        if (value == "<")
          return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
        if (value == "|" || type2 == "." || value == "&")
          return cont(typeexpr);
        if (type2 == "[")
          return cont(typeexpr, expect("]"), afterType);
        if (value == "extends" || value == "implements") {
          cx.marked = "keyword";
          return cont(typeexpr);
        }
        if (value == "?")
          return cont(typeexpr, expect(":"), typeexpr);
      }
      function maybeTypeArgs(_2, value) {
        if (value == "<")
          return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType);
      }
      function typeparam() {
        return pass(typeexpr, maybeTypeDefault);
      }
      function maybeTypeDefault(_2, value) {
        if (value == "=")
          return cont(typeexpr);
      }
      function vardef(_2, value) {
        if (value == "enum") {
          cx.marked = "keyword";
          return cont(enumdef);
        }
        return pass(pattern, maybetype, maybeAssign, vardefCont);
      }
      function pattern(type2, value) {
        if (isTS && isModifier(value)) {
          cx.marked = "keyword";
          return cont(pattern);
        }
        if (type2 == "variable") {
          register(value);
          return cont();
        }
        if (type2 == "spread")
          return cont(pattern);
        if (type2 == "[")
          return contCommasep(eltpattern, "]");
        if (type2 == "{")
          return contCommasep(proppattern, "}");
      }
      function proppattern(type2, value) {
        if (type2 == "variable" && !cx.stream.match(/^\s*:/, false)) {
          register(value);
          return cont(maybeAssign);
        }
        if (type2 == "variable")
          cx.marked = "property";
        if (type2 == "spread")
          return cont(pattern);
        if (type2 == "}")
          return pass();
        if (type2 == "[")
          return cont(expression, expect("]"), expect(":"), proppattern);
        return cont(expect(":"), pattern, maybeAssign);
      }
      function eltpattern() {
        return pass(pattern, maybeAssign);
      }
      function maybeAssign(_type, value) {
        if (value == "=")
          return cont(expressionNoComma);
      }
      function vardefCont(type2) {
        if (type2 == ",")
          return cont(vardef);
      }
      function maybeelse(type2, value) {
        if (type2 == "keyword b" && value == "else")
          return cont(pushlex("form", "else"), statement, poplex);
      }
      function forspec(type2, value) {
        if (value == "await")
          return cont(forspec);
        if (type2 == "(")
          return cont(pushlex(")"), forspec1, poplex);
      }
      function forspec1(type2) {
        if (type2 == "var")
          return cont(vardef, forspec2);
        if (type2 == "variable")
          return cont(forspec2);
        return pass(forspec2);
      }
      function forspec2(type2, value) {
        if (type2 == ")")
          return cont();
        if (type2 == ";")
          return cont(forspec2);
        if (value == "in" || value == "of") {
          cx.marked = "keyword";
          return cont(expression, forspec2);
        }
        return pass(expression, forspec2);
      }
      function functiondef(type2, value) {
        if (value == "*") {
          cx.marked = "keyword";
          return cont(functiondef);
        }
        if (type2 == "variable") {
          register(value);
          return cont(functiondef);
        }
        if (type2 == "(")
          return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
        if (isTS && value == "<")
          return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef);
      }
      function functiondecl(type2, value) {
        if (value == "*") {
          cx.marked = "keyword";
          return cont(functiondecl);
        }
        if (type2 == "variable") {
          register(value);
          return cont(functiondecl);
        }
        if (type2 == "(")
          return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
        if (isTS && value == "<")
          return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl);
      }
      function typename(type2, value) {
        if (type2 == "keyword" || type2 == "variable") {
          cx.marked = "type";
          return cont(typename);
        } else if (value == "<") {
          return cont(pushlex(">"), commasep(typeparam, ">"), poplex);
        }
      }
      function funarg(type2, value) {
        if (value == "@")
          cont(expression, funarg);
        if (type2 == "spread")
          return cont(funarg);
        if (isTS && isModifier(value)) {
          cx.marked = "keyword";
          return cont(funarg);
        }
        if (isTS && type2 == "this")
          return cont(maybetype, maybeAssign);
        return pass(pattern, maybetype, maybeAssign);
      }
      function classExpression(type2, value) {
        if (type2 == "variable")
          return className(type2, value);
        return classNameAfter(type2, value);
      }
      function className(type2, value) {
        if (type2 == "variable") {
          register(value);
          return cont(classNameAfter);
        }
      }
      function classNameAfter(type2, value) {
        if (value == "<")
          return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter);
        if (value == "extends" || value == "implements" || isTS && type2 == ",") {
          if (value == "implements")
            cx.marked = "keyword";
          return cont(isTS ? typeexpr : expression, classNameAfter);
        }
        if (type2 == "{")
          return cont(pushlex("}"), classBody, poplex);
      }
      function classBody(type2, value) {
        if (type2 == "async" || type2 == "variable" && (value == "static" || value == "get" || value == "set" || isTS && isModifier(value)) && cx.stream.match(/^\s+#?[\w$\xa1-\uffff]/, false)) {
          cx.marked = "keyword";
          return cont(classBody);
        }
        if (type2 == "variable" || cx.style == "keyword") {
          cx.marked = "property";
          return cont(classfield, classBody);
        }
        if (type2 == "number" || type2 == "string")
          return cont(classfield, classBody);
        if (type2 == "[")
          return cont(expression, maybetype, expect("]"), classfield, classBody);
        if (value == "*") {
          cx.marked = "keyword";
          return cont(classBody);
        }
        if (isTS && type2 == "(")
          return pass(functiondecl, classBody);
        if (type2 == ";" || type2 == ",")
          return cont(classBody);
        if (type2 == "}")
          return cont();
        if (value == "@")
          return cont(expression, classBody);
      }
      function classfield(type2, value) {
        if (value == "!")
          return cont(classfield);
        if (value == "?")
          return cont(classfield);
        if (type2 == ":")
          return cont(typeexpr, maybeAssign);
        if (value == "=")
          return cont(expressionNoComma);
        var context = cx.state.lexical.prev, isInterface = context && context.info == "interface";
        return pass(isInterface ? functiondecl : functiondef);
      }
      function afterExport(type2, value) {
        if (value == "*") {
          cx.marked = "keyword";
          return cont(maybeFrom, expect(";"));
        }
        if (value == "default") {
          cx.marked = "keyword";
          return cont(expression, expect(";"));
        }
        if (type2 == "{")
          return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
        return pass(statement);
      }
      function exportField(type2, value) {
        if (value == "as") {
          cx.marked = "keyword";
          return cont(expect("variable"));
        }
        if (type2 == "variable")
          return pass(expressionNoComma, exportField);
      }
      function afterImport(type2) {
        if (type2 == "string")
          return cont();
        if (type2 == "(")
          return pass(expression);
        if (type2 == ".")
          return pass(maybeoperatorComma);
        return pass(importSpec, maybeMoreImports, maybeFrom);
      }
      function importSpec(type2, value) {
        if (type2 == "{")
          return contCommasep(importSpec, "}");
        if (type2 == "variable")
          register(value);
        if (value == "*")
          cx.marked = "keyword";
        return cont(maybeAs);
      }
      function maybeMoreImports(type2) {
        if (type2 == ",")
          return cont(importSpec, maybeMoreImports);
      }
      function maybeAs(_type, value) {
        if (value == "as") {
          cx.marked = "keyword";
          return cont(importSpec);
        }
      }
      function maybeFrom(_type, value) {
        if (value == "from") {
          cx.marked = "keyword";
          return cont(expression);
        }
      }
      function arrayLiteral(type2) {
        if (type2 == "]")
          return cont();
        return pass(commasep(expressionNoComma, "]"));
      }
      function enumdef() {
        return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex);
      }
      function enummember() {
        return pass(pattern, maybeAssign);
      }
      function isContinuedStatement(state, textAfter) {
        return state.lastType == "operator" || state.lastType == "," || isOperatorChar.test(textAfter.charAt(0)) || /[,.]/.test(textAfter.charAt(0));
      }
      function expressionAllowed(stream, state, backUp) {
        return state.tokenize == tokenBase && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) || state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0)));
      }
      return {
        startState: function(basecolumn) {
          var state = {
            tokenize: tokenBase,
            lastType: "sof",
            cc: [],
            lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
            localVars: parserConfig.localVars,
            context: parserConfig.localVars && new Context(null, null, false),
            indented: basecolumn || 0
          };
          if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
            state.globalVars = parserConfig.globalVars;
          return state;
        },
        token: function(stream, state) {
          if (stream.sol()) {
            if (!state.lexical.hasOwnProperty("align"))
              state.lexical.align = false;
            state.indented = stream.indentation();
            findFatArrow(stream, state);
          }
          if (state.tokenize != tokenComment && stream.eatSpace())
            return null;
          var style = state.tokenize(stream, state);
          if (type == "comment")
            return style;
          state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
          return parseJS(state, style, type, content, stream);
        },
        indent: function(state, textAfter) {
          if (state.tokenize == tokenComment || state.tokenize == tokenQuasi)
            return CodeMirror2.Pass;
          if (state.tokenize != tokenBase)
            return 0;
          var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top;
          if (!/^\s*else\b/.test(textAfter))
            for (var i = state.cc.length - 1; i >= 0; --i) {
              var c = state.cc[i];
              if (c == poplex)
                lexical = lexical.prev;
              else if (c != maybeelse && c != popcontext)
                break;
            }
          while ((lexical.type == "stat" || lexical.type == "form") && (firstChar == "}" || (top = state.cc[state.cc.length - 1]) && (top == maybeoperatorComma || top == maybeoperatorNoComma) && !/^[,\.=+\-*:?[\(]/.test(textAfter)))
            lexical = lexical.prev;
          if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
            lexical = lexical.prev;
          var type2 = lexical.type, closing = firstChar == type2;
          if (type2 == "vardef")
            return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
          else if (type2 == "form" && firstChar == "{")
            return lexical.indented;
          else if (type2 == "form")
            return lexical.indented + indentUnit;
          else if (type2 == "stat")
            return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
          else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
            return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
          else if (lexical.align)
            return lexical.column + (closing ? 0 : 1);
          else
            return lexical.indented + (closing ? 0 : indentUnit);
        },
        electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
        blockCommentStart: jsonMode ? null : "/*",
        blockCommentEnd: jsonMode ? null : "*/",
        blockCommentContinue: jsonMode ? null : " * ",
        lineComment: jsonMode ? null : "//",
        fold: "brace",
        closeBrackets: "()[]{}''\"\"``",
        helperType: jsonMode ? "json" : "javascript",
        jsonldMode,
        jsonMode,
        expressionAllowed,
        skipExpression: function(state) {
          parseJS(state, "atom", "atom", "true", new CodeMirror2.StringStream("", 2, null));
        }
      };
    });
    CodeMirror2.registerHelper("wordChars", "javascript", /[\w$]/);
    CodeMirror2.defineMIME("text/javascript", "javascript");
    CodeMirror2.defineMIME("text/ecmascript", "javascript");
    CodeMirror2.defineMIME("application/javascript", "javascript");
    CodeMirror2.defineMIME("application/x-javascript", "javascript");
    CodeMirror2.defineMIME("application/ecmascript", "javascript");
    CodeMirror2.defineMIME("application/json", { name: "javascript", json: true });
    CodeMirror2.defineMIME("application/x-json", { name: "javascript", json: true });
    CodeMirror2.defineMIME("application/manifest+json", { name: "javascript", json: true });
    CodeMirror2.defineMIME("application/ld+json", { name: "javascript", jsonld: true });
    CodeMirror2.defineMIME("text/typescript", { name: "javascript", typescript: true });
    CodeMirror2.defineMIME("application/typescript", { name: "javascript", typescript: true });
  });
})();
var ayuDark = "";
(function(module, exports) {
  (function(mod) {
    mod(codemirror$1.exports);
  })(function(CodeMirror2) {
    var defaults2 = {
      pairs: `()[]{}''""`,
      closeBefore: `)]}'":;>`,
      triples: "",
      explode: "[]{}"
    };
    var Pos = CodeMirror2.Pos;
    CodeMirror2.defineOption("autoCloseBrackets", false, function(cm, val, old) {
      if (old && old != CodeMirror2.Init) {
        cm.removeKeyMap(keyMap);
        cm.state.closeBrackets = null;
      }
      if (val) {
        ensureBound(getOption(val, "pairs"));
        cm.state.closeBrackets = val;
        cm.addKeyMap(keyMap);
      }
    });
    function getOption(conf, name) {
      if (name == "pairs" && typeof conf == "string")
        return conf;
      if (typeof conf == "object" && conf[name] != null)
        return conf[name];
      return defaults2[name];
    }
    var keyMap = { Backspace: handleBackspace, Enter: handleEnter };
    function ensureBound(chars) {
      for (var i = 0; i < chars.length; i++) {
        var ch = chars.charAt(i), key = "'" + ch + "'";
        if (!keyMap[key])
          keyMap[key] = handler(ch);
      }
    }
    ensureBound(defaults2.pairs + "`");
    function handler(ch) {
      return function(cm) {
        return handleChar(cm, ch);
      };
    }
    function getConfig(cm) {
      var deflt = cm.state.closeBrackets;
      if (!deflt || deflt.override)
        return deflt;
      var mode = cm.getModeAt(cm.getCursor());
      return mode.closeBrackets || deflt;
    }
    function handleBackspace(cm) {
      var conf = getConfig(cm);
      if (!conf || cm.getOption("disableInput"))
        return CodeMirror2.Pass;
      var pairs = getOption(conf, "pairs");
      var ranges = cm.listSelections();
      for (var i = 0; i < ranges.length; i++) {
        if (!ranges[i].empty())
          return CodeMirror2.Pass;
        var around = charsAround(cm, ranges[i].head);
        if (!around || pairs.indexOf(around) % 2 != 0)
          return CodeMirror2.Pass;
      }
      for (var i = ranges.length - 1; i >= 0; i--) {
        var cur = ranges[i].head;
        cm.replaceRange("", Pos(cur.line, cur.ch - 1), Pos(cur.line, cur.ch + 1), "+delete");
      }
    }
    function handleEnter(cm) {
      var conf = getConfig(cm);
      var explode = conf && getOption(conf, "explode");
      if (!explode || cm.getOption("disableInput"))
        return CodeMirror2.Pass;
      var ranges = cm.listSelections();
      for (var i = 0; i < ranges.length; i++) {
        if (!ranges[i].empty())
          return CodeMirror2.Pass;
        var around = charsAround(cm, ranges[i].head);
        if (!around || explode.indexOf(around) % 2 != 0)
          return CodeMirror2.Pass;
      }
      cm.operation(function() {
        var linesep = cm.lineSeparator() || "\n";
        cm.replaceSelection(linesep + linesep, null);
        moveSel(cm, -1);
        ranges = cm.listSelections();
        for (var i2 = 0; i2 < ranges.length; i2++) {
          var line = ranges[i2].head.line;
          cm.indentLine(line, null, true);
          cm.indentLine(line + 1, null, true);
        }
      });
    }
    function moveSel(cm, dir) {
      var newRanges = [], ranges = cm.listSelections(), primary = 0;
      for (var i = 0; i < ranges.length; i++) {
        var range = ranges[i];
        if (range.head == cm.getCursor())
          primary = i;
        var pos = range.head.ch || dir > 0 ? { line: range.head.line, ch: range.head.ch + dir } : { line: range.head.line - 1 };
        newRanges.push({ anchor: pos, head: pos });
      }
      cm.setSelections(newRanges, primary);
    }
    function contractSelection(sel) {
      var inverted = CodeMirror2.cmpPos(sel.anchor, sel.head) > 0;
      return {
        anchor: new Pos(sel.anchor.line, sel.anchor.ch + (inverted ? -1 : 1)),
        head: new Pos(sel.head.line, sel.head.ch + (inverted ? 1 : -1))
      };
    }
    function handleChar(cm, ch) {
      var conf = getConfig(cm);
      if (!conf || cm.getOption("disableInput"))
        return CodeMirror2.Pass;
      var pairs = getOption(conf, "pairs");
      var pos = pairs.indexOf(ch);
      if (pos == -1)
        return CodeMirror2.Pass;
      var closeBefore = getOption(conf, "closeBefore");
      var triples = getOption(conf, "triples");
      var identical = pairs.charAt(pos + 1) == ch;
      var ranges = cm.listSelections();
      var opening = pos % 2 == 0;
      var type;
      for (var i = 0; i < ranges.length; i++) {
        var range = ranges[i], cur = range.head, curType;
        var next2 = cm.getRange(cur, Pos(cur.line, cur.ch + 1));
        if (opening && !range.empty()) {
          curType = "surround";
        } else if ((identical || !opening) && next2 == ch) {
          if (identical && stringStartsAfter(cm, cur))
            curType = "both";
          else if (triples.indexOf(ch) >= 0 && cm.getRange(cur, Pos(cur.line, cur.ch + 3)) == ch + ch + ch)
            curType = "skipThree";
          else
            curType = "skip";
        } else if (identical && cur.ch > 1 && triples.indexOf(ch) >= 0 && cm.getRange(Pos(cur.line, cur.ch - 2), cur) == ch + ch) {
          if (cur.ch > 2 && /\bstring/.test(cm.getTokenTypeAt(Pos(cur.line, cur.ch - 2))))
            return CodeMirror2.Pass;
          curType = "addFour";
        } else if (identical) {
          var prev2 = cur.ch == 0 ? " " : cm.getRange(Pos(cur.line, cur.ch - 1), cur);
          if (!CodeMirror2.isWordChar(next2) && prev2 != ch && !CodeMirror2.isWordChar(prev2))
            curType = "both";
          else
            return CodeMirror2.Pass;
        } else if (opening && (next2.length === 0 || /\s/.test(next2) || closeBefore.indexOf(next2) > -1)) {
          curType = "both";
        } else {
          return CodeMirror2.Pass;
        }
        if (!type)
          type = curType;
        else if (type != curType)
          return CodeMirror2.Pass;
      }
      var left = pos % 2 ? pairs.charAt(pos - 1) : ch;
      var right = pos % 2 ? ch : pairs.charAt(pos + 1);
      cm.operation(function() {
        if (type == "skip") {
          moveSel(cm, 1);
        } else if (type == "skipThree") {
          moveSel(cm, 3);
        } else if (type == "surround") {
          var sels = cm.getSelections();
          for (var i2 = 0; i2 < sels.length; i2++)
            sels[i2] = left + sels[i2] + right;
          cm.replaceSelections(sels, "around");
          sels = cm.listSelections().slice();
          for (var i2 = 0; i2 < sels.length; i2++)
            sels[i2] = contractSelection(sels[i2]);
          cm.setSelections(sels);
        } else if (type == "both") {
          cm.replaceSelection(left + right, null);
          cm.triggerElectric(left + right);
          moveSel(cm, -1);
        } else if (type == "addFour") {
          cm.replaceSelection(left + left + left + left, "before");
          moveSel(cm, 1);
        }
      });
    }
    function charsAround(cm, pos) {
      var str = cm.getRange(
        Pos(pos.line, pos.ch - 1),
        Pos(pos.line, pos.ch + 1)
      );
      return str.length == 2 ? str : null;
    }
    function stringStartsAfter(cm, pos) {
      var token = cm.getTokenAt(Pos(pos.line, pos.ch + 1));
      return /\bstring/.test(token.type) && token.start == pos.ch && (pos.ch == 0 || !/\bstring/.test(cm.getTokenTypeAt(pos)));
    }
  });
})();
var index_vue_vue_type_style_index_0_lang$5 = "";
const _sfc_main$X = {
  props: ["modelValue"],
  inject: {
    getFormModels: {
      default: () => {
        return new Function();
      }
    },
    getResponseVariables: {
      default: () => {
        return new Function();
      }
    },
    getLocalVariables: {
      default: () => {
        return new Function();
      }
    }
  },
  data() {
    return {
      value: this.modelValue,
      editorId: "formula-" + Math.random().toString(36).slice(-8),
      modelsData: [],
      argsData: [{
        id: "arguments[0]",
        name: this.$t("fm.formula.argsData.name")
      }],
      responseVariables: [],
      localVariables: []
    };
  },
  mounted() {
    var _a2, _b, _c;
    this.modelsData = (_a2 = this.getFormModels()) != null ? _a2 : [];
    let responseVariables = (_b = this.getResponseVariables()) != null ? _b : [];
    let localVars = (_c = this.getLocalVariables()) != null ? _c : [];
    if (responseVariables.length || localVars.length) {
      this.localVariables = [{
        id: "",
        name: this.$t("fm.formula.argsData.variable"),
        children: [...responseVariables, ...localVars].map((item) => ({
          id: item,
          name: item
        }))
      }];
    }
    setTimeout(() => {
      this.initEditor();
    });
  },
  methods: {
    initEditor() {
      let theme = "default";
      if (document.querySelector("html").className.indexOf("dark") > -1) {
        theme = "ayu-dark";
      }
      this.editor = CodeMirror(document.getElementById(this.editorId), {
        value: this.value,
        lineNumbers: false,
        mode: "javascript",
        lineWrapping: true,
        autofocus: true,
        theme,
        autoCloseBrackets: true
      });
      this.editor.on("change", (cm) => {
        this.value = cm.getValue();
      });
      this.replaceFieldContent();
      this.replaceArgsContent();
      this.editor.execCommand("goDocEnd");
    },
    replaceArgsContent() {
      const regex2 = /arguments\[0\]/g;
      const matches2 = [];
      let match;
      while ((match = regex2.exec(this.value)) !== null) {
        const matchedValue = match[0];
        const startIndex = match.index - this.calcLastIndex(this.value, match.index) - 1;
        const lineIndex = this.calcLineCount(this.value, match.index);
        matches2.push({
          value: matchedValue,
          startIndex,
          lineIndex
        });
      }
      matches2.forEach((item) => {
        let widgetNode = document.createElement("span");
        widgetNode.className = "cm-eventargs";
        widgetNode.textContent = item.value;
        this.editor.markText({ line: item.lineIndex, ch: item.startIndex }, { line: item.lineIndex, ch: item.startIndex + item.value.length }, {
          atomic: true,
          selectLeft: true,
          selectRight: true,
          inclusiveLeft: false,
          inclusiveRight: false,
          replacedWith: widgetNode,
          handleMouseEvents: true
        });
      });
    },
    replaceFieldContent() {
      const regex2 = /this\.getValue\("([^"]+)"\)/g;
      const matches2 = [];
      let match;
      while ((match = regex2.exec(this.value)) !== null) {
        const matchedValue = match[0];
        const matchedId = match[1];
        const startIndex = match.index - this.calcLastIndex(this.value, match.index) - 1;
        const lineIndex = this.calcLineCount(this.value, match.index);
        const matchNode = this.$refs.fieldTree.getNode(matchedId);
        if (matchNode) {
          matches2.push({
            value: matchedValue,
            startIndex,
            lineIndex,
            id: matchedId,
            data: matchNode.data
          });
        }
      }
      matches2.forEach((item) => {
        let widgetNode = document.createElement("span");
        widgetNode.className = "cm-field";
        widgetNode.textContent = "this.getValue";
        this.editor.markText({ line: item.lineIndex, ch: item.startIndex }, { line: item.lineIndex, ch: item.startIndex + 13 }, {
          atomic: true,
          selectLeft: true,
          selectRight: true,
          inclusiveLeft: false,
          inclusiveRight: false,
          replacedWith: widgetNode,
          handleMouseEvents: true
        });
      });
    },
    calcLineCount(str, n) {
      let count = 0;
      for (let i = 0; i < n; i++) {
        if (str[i] === "\n") {
          count++;
        }
      }
      return count;
    },
    calcLastIndex(str, n) {
      let lastIndex = -1;
      for (let i = 0; i < n; i++) {
        if (str[i] === "\n") {
          lastIndex = i;
        }
      }
      return lastIndex;
    },
    handleNode(data2) {
      let cursor = this.editor.getCursor();
      let widgetNode = document.createElement("span");
      widgetNode.className = "cm-field";
      widgetNode.textContent = "this.getValue";
      widgetNode.title = data2.id;
      let text = `this.getValue("${data2.id}")`;
      this.editor.replaceRange(text, cursor);
      this.editor.markText({ line: cursor.line, ch: cursor.ch }, { line: cursor.line, ch: cursor.ch + 13 }, {
        atomic: true,
        selectLeft: true,
        selectRight: true,
        inclusiveLeft: false,
        inclusiveRight: false,
        replacedWith: widgetNode,
        handleMouseEvents: true
      });
      this.editor.focus();
    },
    handleArgsNode(data2) {
      let cursor = this.editor.getCursor();
      let widgetNode = document.createElement("span");
      widgetNode.className = "cm-eventargs";
      widgetNode.textContent = "arguments[0]";
      let text = data2.id;
      this.editor.replaceRange(text, cursor);
      this.editor.markText({ line: cursor.line, ch: cursor.ch }, { line: cursor.line, ch: cursor.ch + 12 }, {
        atomic: true,
        selectLeft: true,
        selectRight: true,
        inclusiveLeft: false,
        inclusiveRight: false,
        replacedWith: widgetNode,
        handleMouseEvents: true
      });
      this.editor.focus();
    },
    handleVariableNode(data2) {
      let cursor = this.editor.getCursor();
      let text = data2.id;
      this.editor.replaceRange(text, cursor);
      this.editor.focus();
    }
  },
  watch: {
    modelValue(val) {
      this.value = val;
    },
    value(val) {
      this.$emit("update:modelValue", val);
    }
  }
};
const _hoisted_1$C = { class: "fm-formula-container" };
const _hoisted_2$x = ["id"];
const _hoisted_3$r = ["onClick"];
const _hoisted_4$q = { style: { "padding": "0 5px", "max-width": "50%" } };
const _hoisted_5$q = { style: { "font-size": "12px" } };
const _hoisted_6$n = ["onClick"];
const _hoisted_7$m = { style: { "padding": "0 5px", "max-width": "50%" } };
const _hoisted_8$f = { style: { "font-size": "12px" } };
const _hoisted_9$e = ["onClick"];
const _hoisted_10$9 = { style: { "padding": "0 5px", "max-width": "50%" } };
function _sfc_render$V(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_card = resolveComponent("el-card");
  const _component_el_col = resolveComponent("el-col");
  const _component_el_row = resolveComponent("el-row");
  const _component_el_tag = resolveComponent("el-tag");
  const _component_el_tooltip = resolveComponent("el-tooltip");
  const _component_el_tree = resolveComponent("el-tree");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  return openBlock(), createElementBlock("div", _hoisted_1$C, [
    createVNode(_component_el_row, { justify: "space-between" }, {
      default: withCtx(() => [
        createVNode(_component_el_col, { span: 24 }, {
          default: withCtx(() => [
            createVNode(_component_el_card, {
              header: _ctx.$t("fm.formula.header"),
              shadow: "never",
              size: "small",
              class: "formula-card"
            }, {
              default: withCtx(() => [
                createElementVNode("div", {
                  id: $data.editorId,
                  class: "formula-editor"
                }, null, 8, _hoisted_2$x)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    createVNode(_component_el_row, {
      justify: "space-between",
      gutter: 10
    }, {
      default: withCtx(() => [
        createVNode(_component_el_col, { span: 12 }, {
          default: withCtx(() => [
            createVNode(_component_el_card, {
              header: _ctx.$t("fm.formula.field"),
              shadow: "never",
              size: "small",
              class: "formula-card formula-field"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_scrollbar, {
                  ref: "scrollRef",
                  noresize: ""
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_tree, {
                      data: $data.modelsData,
                      "node-key": "id",
                      "default-expand-all": "",
                      "expand-on-click-node": false,
                      style: { "width": "100%" },
                      ref: "fieldTree"
                    }, {
                      default: withCtx(({ node }) => [
                        createVNode(_component_el_tooltip, {
                          content: `this.getValue('${node.data.id}')`,
                          placement: "right"
                        }, {
                          default: withCtx(() => [
                            createElementVNode("div", {
                              style: { "display": "flex", "justify-content": "space-between", "width": "90%", "align-items": "center" },
                              onClick: ($event) => $options.handleNode(node.data)
                            }, [
                              createElementVNode("span", _hoisted_4$q, [
                                createTextVNode(toDisplayString$1(node.data.name) + " {", 1),
                                createElementVNode("span", _hoisted_5$q, toDisplayString$1(node.data.id), 1),
                                createTextVNode("}")
                              ]),
                              createVNode(_component_el_tag, { type: "info" }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString$1(_ctx.$t("fm.components.fields." + node.data.type)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ], 8, _hoisted_3$r)
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }, 512)
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }),
        createVNode(_component_el_col, { span: 12 }, {
          default: withCtx(() => [
            createVNode(_component_el_card, {
              header: _ctx.$t("fm.formula.event"),
              shadow: "never",
              size: "small",
              class: "formula-card formula-method"
            }, {
              default: withCtx(() => [
                createVNode(_component_el_scrollbar, { noresize: "" }, {
                  default: withCtx(() => [
                    createVNode(_component_el_tree, {
                      data: $data.argsData,
                      "node-key": "id",
                      "default-expand-all": "",
                      "expand-on-click-node": false,
                      style: { "width": "100%" }
                    }, {
                      default: withCtx(({ node }) => [
                        createElementVNode("div", {
                          style: { "display": "flex", "justify-content": "space-between", "width": "90%", "align-items": "center" },
                          onClick: ($event) => $options.handleArgsNode(node.data)
                        }, [
                          createElementVNode("span", _hoisted_7$m, toDisplayString$1(node.data.name), 1),
                          createElementVNode("span", _hoisted_8$f, toDisplayString$1(node.data.id), 1)
                        ], 8, _hoisted_6$n)
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    $data.localVariables.length ? (openBlock(), createBlock(_component_el_tree, {
                      key: 0,
                      data: $data.localVariables,
                      "node-key": "id",
                      "default-expand-all": "",
                      "expand-on-click-node": false,
                      style: { "width": "100%" }
                    }, {
                      default: withCtx(({ node }) => [
                        createElementVNode("div", {
                          style: { "display": "flex", "justify-content": "space-between", "width": "90%" },
                          onClick: ($event) => $options.handleVariableNode(node.data)
                        }, [
                          createElementVNode("span", _hoisted_10$9, toDisplayString$1(node.data.name), 1)
                        ], 8, _hoisted_9$e)
                      ]),
                      _: 1
                    }, 8, ["data"])) : createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
var FormulaPanelIndex = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["render", _sfc_render$V]]);
var dialog_vue_vue_type_style_index_0_lang$2 = "";
const _sfc_main$W = {
  components: {
    CusDialog,
    FormulaPanelIndex
  },
  emits: ["dialog-close", "dialog-confirm"],
  data: () => ({
    visible: false,
    scriptList: [],
    formulaValue: ""
  }),
  methods: {
    open(val) {
      this.formulaValue = val != null ? val : "";
      this.visible = true;
    },
    handleClose() {
      this.$emit("dialog-close");
      this.visible = false;
    },
    handleSubmit() {
      this.$emit("dialog-confirm", this.formulaValue);
      this.visible = false;
    }
  }
};
const _hoisted_1$B = { class: "fm-formula-panel-dialog-container" };
function _sfc_render$U(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FormulaPanelIndex = resolveComponent("FormulaPanelIndex");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_dialog = resolveComponent("el-dialog");
  return openBlock(), createBlock(_component_el_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => _ctx.visible = $event),
    onOnClose: $options.handleClose,
    ref: "formulaDialog",
    width: "800px",
    "close-on-click-modal": false,
    "show-close": false,
    draggable: "",
    "destroy-on-close": "",
    "append-to-body": "",
    class: "fm-formula-dialog"
  }, {
    footer: withCtx(() => [
      createElementVNode("span", null, [
        createVNode(_component_el_button, { onClick: $options.handleClose }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.handleSubmit
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.confirm")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$B, [
        createVNode(_component_FormulaPanelIndex, {
          modelValue: _ctx.formulaValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.formulaValue = $event)
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "onOnClose"]);
}
var FormulaDialog = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["render", _sfc_render$U]]);
var input_vue_vue_type_style_index_0_lang = "";
const _sfc_main$V = {
  components: {
    FormulaDialog
  },
  props: ["select", "modelValue"],
  emits: ["update:select", "update:modelValue"],
  watch: {
    selectValue(val) {
      this.$emit("update:select", val);
    },
    value(val) {
      this.$emit("update:modelValue", val);
    }
  },
  data() {
    var _a2, _b;
    return {
      selectValue: (_a2 = this.select) != null ? _a2 : false,
      value: (_b = this.modelValue) != null ? _b : ""
    };
  },
  computed: {
    placeholder() {
      if (this.selectValue) {
        return this.$t("fm.formula.input.fxPlaceholder");
      } else {
        return this.$t("fm.formula.input.valuePlaceholder");
      }
    }
  },
  methods: {
    handleFormulaInput() {
      this.selectValue && this.$refs.formulaDialog.open(this.value);
    },
    handleFormulaConfirm(val) {
      this.value = val;
    }
  }
};
function _sfc_render$T(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  const _component_el_input = resolveComponent("el-input");
  const _component_FormulaDialog = resolveComponent("FormulaDialog");
  return openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_el_input, {
      placeholder: $options.placeholder,
      modelValue: $data.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.value = $event),
      size: "small",
      class: normalizeClass({
        "input-with-select": true,
        "formula-input": this.selectValue
      }),
      onClick: $options.handleFormulaInput,
      readonly: $data.selectValue
    }, {
      append: withCtx(() => [
        createVNode(_component_el_select, {
          modelValue: $data.selectValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.selectValue = $event),
          style: { "width": "80px" }
        }, {
          default: withCtx(() => [
            createVNode(_component_el_option, {
              label: _ctx.$t("fm.formula.input.value"),
              value: false
            }, null, 8, ["label"]),
            createVNode(_component_el_option, {
              label: _ctx.$t("fm.formula.input.fx"),
              value: true
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["placeholder", "modelValue", "class", "onClick", "readonly"]),
    createVNode(_component_FormulaDialog, {
      ref: "formulaDialog",
      onDialogConfirm: $options.handleFormulaConfirm
    }, null, 8, ["onDialogConfirm"])
  ], 64);
}
var FormulaInput = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["render", _sfc_render$T]]);
var arrayDynamic_vue_vue_type_style_index_0_lang = "";
const _sfc_main$U = {
  components: {
    FormulaInput
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      array: this.modelValue
    };
  },
  methods: {
    handleAdd() {
      this.array.push({ key: "", value: "", fx: false });
    },
    handleRemove(index2) {
      this.array.splice(index2, 1);
    }
  },
  watch: {
    modelValue(val) {
      this.array = val;
    },
    array: {
      deep: true,
      handler(val) {
        this.$emit("update:modelValue", val);
      }
    }
  }
};
const _hoisted_1$A = { class: "array-dynamic-container" };
const _hoisted_2$w = ["onClick"];
const _hoisted_3$q = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" }, null, -1);
const _hoisted_4$p = [
  _hoisted_3$q
];
const _hoisted_5$p = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = resolveComponent("el-input");
  const _component_formula_input = resolveComponent("formula-input");
  const _component_el_button = resolveComponent("el-button");
  return openBlock(), createElementBlock("div", _hoisted_1$A, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($data.array, (item, index2) => {
      return openBlock(), createElementBlock("div", {
        key: index2,
        class: "array-dynamic-item"
      }, [
        createVNode(_component_el_input, {
          modelValue: item.key,
          "onUpdate:modelValue": ($event) => item.key = $event,
          placeholder: "KEY",
          size: "small"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        createVNode(_component_formula_input, {
          modelValue: item.value,
          "onUpdate:modelValue": ($event) => item.value = $event,
          select: item.fx,
          "onUpdate:select": ($event) => item.fx = $event
        }, null, 8, ["modelValue", "onUpdate:modelValue", "select", "onUpdate:select"]),
        createElementVNode("i", {
          onClick: ($event) => $options.handleRemove(index2),
          style: { "font-size": "16px", "margin": "0 10px", "cursor": "pointer", "color": "#F56C6C" }
        }, _hoisted_4$p, 8, _hoisted_2$w)
      ]);
    }), 128)),
    createVNode(_component_el_button, {
      link: "",
      type: "primary",
      onClick: $options.handleAdd
    }, {
      default: withCtx(() => [
        _hoisted_5$p,
        createTextVNode(toDisplayString$1(_ctx.$t("fm.datasource.edit.add")), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]);
}
var ArrayDynamic = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["render", _sfc_render$S]]);
var axios$2 = { exports: {} };
var bind$2 = function bind2(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};
var bind$1 = bind$2;
var toString = Object.prototype.toString;
function isArray(val) {
  return Array.isArray(val);
}
function isUndefined$1(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return toString.call(val) === "[object FormData]";
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
function isString$1(val) {
  return typeof val === "string";
}
function isNumber$1(val) {
  return typeof val === "number";
}
function isObject$1(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject$1(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction$1(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject$1(val) && isFunction$1(val.pipe);
}
function isURLSearchParams(val) {
  return toString.call(val) === "[object URLSearchParams]";
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach$1(obj, fn) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$1(result[key]) && isPlainObject$1(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject$1(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach$1(arguments[i], assignValue);
  }
  return result;
}
function extend(a, b, thisArg) {
  forEach$1(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$e = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber$1,
  isObject: isObject$1,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined$1,
  isDate,
  isFile,
  isBlob,
  isFunction: isFunction$1,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach: forEach$1,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$d = utils$e;
function encode$1(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL2(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$d.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$d.forEach(val, function parseValue2(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode$1(key) + "=" + encode$1(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$c = utils$e;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h2) {
    if (h2 !== null) {
      fn(h2);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$b = utils$e;
var normalizeHeaderName$1 = function normalizeHeaderName2(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};
var enhanceError$2 = function enhanceError2(error, config, code2, request3, response) {
  error.config = config;
  if (code2) {
    error.code = code2;
  }
  error.request = request3;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError2(message, config, code2, request3, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code2, request3, response);
};
var createError$1 = createError$2;
var settle$1 = function settle2(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1(
      "Request failed with status code " + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};
var utils$a = utils$e;
var cookies$1 = utils$a.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + "=" + encodeURIComponent(value));
      if (utils$a.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$a.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$a.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write() {
    },
    read: function read() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL2(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs2(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;
var buildFullPath$1 = function buildFullPath2(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$9 = utils$e;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders2(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils$9.forEach(headers.split("\n"), function parser(line) {
    i = line.indexOf(":");
    key = utils$9.trim(line.substr(0, i)).toLowerCase();
    val = utils$9.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$8 = utils$e;
var isURLSameOrigin$1 = utils$8.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$8.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$7 = utils$e;
var settle = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath = buildFullPath$1;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError = createError$2;
var transitionalDefaults$1 = transitional;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$7.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request3 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath(config.baseURL, config.url);
    request3.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request3.timeout = config.timeout;
    function onloadend() {
      if (!request3) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request3 ? parseHeaders(request3.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request3.responseText : request3.response;
      var response = {
        data: responseData,
        status: request3.status,
        statusText: request3.statusText,
        headers: responseHeaders,
        config,
        request: request3
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request3 = null;
    }
    if ("onloadend" in request3) {
      request3.onloadend = onloadend;
    } else {
      request3.onreadystatechange = function handleLoad() {
        if (!request3 || request3.readyState !== 4) {
          return;
        }
        if (request3.status === 0 && !(request3.responseURL && request3.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request3.onabort = function handleAbort() {
      if (!request3) {
        return;
      }
      reject(createError("Request aborted", config, "ECONNABORTED", request3));
      request3 = null;
    };
    request3.onerror = function handleError() {
      reject(createError("Network Error", config, null, request3));
      request3 = null;
    };
    request3.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional3 = config.transitional || transitionalDefaults$1;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional3.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
        request3
      ));
      request3 = null;
    };
    if (utils$7.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request3) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request3.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$7.isUndefined(config.withCredentials)) {
      request3.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request3.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request3.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request3.upload) {
      request3.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request3) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request3.abort();
        request3 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request3.send(requestData);
  });
};
var utils$6 = utils$e;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$2;
var transitionalDefaults = transitional;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: transitionalDefaults,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName(headers, "Accept");
    normalizeHeaderName(headers, "Content-Type");
    if (utils$6.isFormData(data2) || utils$6.isArrayBuffer(data2) || utils$6.isBuffer(data2) || utils$6.isStream(data2) || utils$6.isFile(data2) || utils$6.isBlob(data2)) {
      return data2;
    }
    if (utils$6.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$6.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$6.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional3 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional3 && transitional3.silentJSONParsing;
    var forcedJSONParsing = transitional3 && transitional3.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$6.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw enhanceError(e, this, "E_JSON_PARSE");
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$6.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$6.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$5 = utils$e;
var defaults$2 = defaults_1;
var transformData$1 = function transformData2(data2, headers, fns) {
  var context = this || defaults$2;
  utils$5.forEach(fns, function transform2(fn) {
    data2 = fn.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel2(value) {
  return !!(value && value.__CANCEL__);
};
var utils$4 = utils$e;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest2(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );
  config.headers = utils$4.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );
  utils$4.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }
    return Promise.reject(reason);
  });
};
var utils$3 = utils$e;
var mergeConfig$2 = function mergeConfig2(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source2) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source2)) {
      return utils$3.merge(target, source2);
    } else if (utils$3.isPlainObject(source2)) {
      return utils$3.merge({}, source2);
    } else if (utils$3.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$3.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data$1 = {
  "version": "0.26.1"
};
var VERSION = data$1.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
  validators$1[type] = function validator2(thing) {
    return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional2(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$2 = utils$e;
var buildURL = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request2(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional3 = config.transitional;
  if (transitional3 !== void 0) {
    validator.assertOptions(transitional3, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$2.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$2.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i;
    var l = token._listeners.length;
    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};
var utils$1 = utils$e;
var isAxiosError = function isAxiosError2(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
};
var utils = utils$e;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance2 = bind(Axios.prototype.request, context);
  utils.extend(instance2, Axios.prototype, context);
  utils.extend(instance2, context);
  instance2.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance2;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data$1.version;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
const isExpression = (str) => {
  const regex2 = /^{{.*}}$/;
  return regex2.test(str);
};
const extractExpression = (str) => {
  const regex2 = /{{(.*?)}}/;
  const match = regex2.exec(str);
  if (match) {
    return match[1];
  } else {
    return "";
  }
};
const executeExpression = (str, args, context) => {
  try {
    if (context) {
      return Function("args", `return ${str}`).bind(context)(args);
    } else {
      return Function("args", `return ${str}`)(args);
    }
  } catch (e) {
    return null;
  }
};
var index_vue_vue_type_style_index_0_lang$4 = "";
const _sfc_main$T = {
  components: {
    ArrayDynamic,
    CodeEditor
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      formData: {
        key: "",
        name: "",
        url: "",
        method: "GET",
        auto: true,
        params: [],
        headers: [],
        responseFunc: `return res;`,
        requestFunc: `return config;`,
        errorFunc: ``
      },
      formRules: {
        name: [
          { required: true, message: " " },
          { validator: (rule, value, callback) => {
            let currentItem = this.historyList.find((item) => item.name == value);
            if (currentItem && currentItem.key != this.selectKey) {
              callback(new Error(this.$t("fm.datasource.message.repeat")));
            } else {
              callback();
            }
          } }
        ],
        url: [
          { required: true, message: " " }
        ]
      },
      list: [...this.modelValue],
      selectIndex: -1,
      selectKey: "",
      historyList: [...this.modelValue],
      saved: true,
      requestError: false,
      collapseAppend: [],
      tempFormData: {
        key: "",
        name: "",
        url: "",
        method: "GET",
        auto: true,
        params: [],
        headers: [],
        responseFunc: `return res;`,
        requestFunc: `return config;`,
        errorFunc: ``
      }
    };
  },
  computed: {
    isFormChange() {
      return !_.isEqual(this.formData, this.tempFormData);
    }
  },
  methods: {
    _getAttributeFunction(funcStrs) {
      let matchReg1 = new RegExp("(?<=args.)\\w*(?=[\\s|,|;]|$)", "g");
      let matchReg2 = new RegExp(`(?<=args\\[\\s*['|"])\\w*(?=['|"]\\s*\\])`, "g");
      let matchReg3 = new RegExp("(?<={)[\\s+\\w*\\s+,{0|1}]+(?=}\\s+=\\s+args)", "g");
      let args = /* @__PURE__ */ new Set();
      funcStrs.forEach((funcStr) => {
        var _a2, _b, _c;
        (_a2 = funcStr == null ? void 0 : funcStr.match(matchReg1)) == null ? void 0 : _a2.forEach((item) => item && args.add(item.trim()));
        (_b = funcStr == null ? void 0 : funcStr.match(matchReg2)) == null ? void 0 : _b.forEach((item) => item && args.add(item.trim()));
        (_c = funcStr == null ? void 0 : funcStr.match(matchReg3)) == null ? void 0 : _c.forEach((item) => item && item.split(",").forEach((sitem) => sitem && args.add(sitem.trim())));
      });
      return args;
    },
    _getArgsObject(argSet) {
      const args = {};
      for (let arg of argSet) {
        args[arg] = "";
      }
      return args;
    },
    handleTest() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const argSet = this._getAttributeFunction([
            this.formData.requestFunc,
            this.formData.responseFunc,
            ...this.formData.params.filter((item) => item.fx).map((item) => item.value),
            ...this.formData.headers.filter((item) => item.fx).map((item) => item.value)
          ]);
          if (argSet.size > 0) {
            let argsModel = this._getArgsObject(argSet);
            ElMessageBox({
              title: "Data source arguments",
              customStyle: "z-index: 3000",
              customClass: "fm-messagebox",
              class: "aaa",
              draggable: true,
              key: new Date().getTime(),
              message: h(
                "div",
                null,
                [
                  h(
                    CodeEditor,
                    {
                      modelValue: argsModel,
                      mode: typeof data == "object" ? "javascript" : "xml",
                      height: "200px",
                      key: new Date().getTime(),
                      "onUpdate:modelValue": (value) => {
                        argsModel = value;
                      }
                    }
                  )
                ]
              ),
              callback: (action) => {
                if (action == "confirm") {
                  let args = {};
                  if (typeof argsModel == "string") {
                    args = Function('"use strict";return (' + argsModel + ")")();
                  } else {
                    args = argsModel;
                  }
                  this.requestTest(args);
                }
              }
            });
          } else {
            this.requestTest();
          }
        } else {
          ElMessage({
            message: this.$t("fm.datasource.message.settingError"),
            type: "warning"
          });
        }
      });
    },
    requestTest(args = {}) {
      let options = {
        method: this.formData.method,
        url: this.formData.url,
        headers: (() => {
          let headObj = {};
          this.formData.headers.forEach((item) => {
            if (item.key) {
              headObj[item.key] = item.fx ? executeExpression(item.value, args) : item.value;
            }
          });
          return headObj;
        })()
      };
      if (this.formData.method === "POST" || this.formData.method === "PUT") {
        options.data = (() => {
          let paramsObj = {};
          this.formData.params.forEach((item) => {
            if (item.key) {
              paramsObj[item.key] = item.fx ? executeExpression(item.value, args) : item.value;
            }
          });
          return paramsObj;
        })();
      } else {
        options.params = (() => {
          let paramsObj = {};
          this.formData.params.forEach((item) => {
            if (item.key) {
              paramsObj[item.key] = item.fx ? executeExpression(item.value, args) : item.value;
            }
          });
          return paramsObj;
        })();
      }
      this.requestError = false;
      if (this.formData.requestFunc) {
        const requestDynamicFunc = new Function("config", "args", this.formData.requestFunc);
        try {
          options = requestDynamicFunc(options, args);
        } catch (error) {
          this.requestError = true;
        }
      }
      axios(options).then((res) => {
        try {
          let data2 = new Function("res", "args", this.formData.responseFunc)(res.data, args);
          ElMessageBox({
            title: "Response",
            customStyle: "z-index: 3000",
            customClass: "fm-messagebox",
            class: "aaa",
            draggable: true,
            key: new Date().getTime(),
            message: h(
              "div",
              null,
              [
                h("div", { style: this.requestError ? "margin: 10px 0; " : "display: none;" }, [
                  "The request test does not support ",
                  h("b", { style: "color: red;" }, "this"),
                  ", has been ignored."
                ]),
                h(
                  CodeEditor,
                  {
                    modelValue: data2,
                    mode: typeof data2 == "object" ? "javascript" : "xml",
                    height: "300px",
                    key: new Date().getTime()
                  }
                )
              ]
            )
          });
        } catch (error) {
          ElMessageBox({
            title: "Response",
            customStyle: "z-index: 3000",
            customClass: "fm-messagebox",
            class: "aaa",
            draggable: true,
            key: new Date().getTime(),
            message: h(
              "div",
              null,
              [
                h("div", { style: this.requestError ? "margin: 10px 0; " : "display: none;" }, [
                  "The request test does not support ",
                  h("b", { style: "color: red;" }, "this"),
                  ", has been ignored."
                ]),
                h(
                  CodeEditor,
                  {
                    modelValue: res.data,
                    mode: typeof res.data == "object" ? "javascript" : "xml",
                    height: "300px",
                    key: new Date().getTime()
                  }
                )
              ]
            )
          });
        }
      }).catch((err) => {
        ElMessageBox.alert(err.message);
      });
    },
    handleSave() {
      return new Promise((resolve, reject) => {
        this.$refs.dataForm.validate((valid) => {
          if (valid) {
            const argSet = this._getAttributeFunction([
              this.formData.requestFunc,
              this.formData.responseFunc,
              ...this.formData.params.filter((item) => item.fx).map((item) => item.value),
              ...this.formData.headers.filter((item) => item.fx).map((item) => item.value)
            ]);
            let options = {
              ...this.formData,
              params: (() => {
                let paramsObj = {};
                this.formData.params.forEach((item) => {
                  if (item.key) {
                    paramsObj[item.key] = item.fx ? `{{${item.value}}}` : item.value;
                  }
                });
                return paramsObj;
              })(),
              headers: (() => {
                let headersObj = {};
                this.formData.headers.forEach((item) => {
                  if (item.key) {
                    headersObj[item.key] = item.fx ? `{{${item.value}}}` : item.value;
                  }
                });
                return headersObj;
              })(),
              args: [...argSet]
            };
            this.list[this.list.findIndex((item) => item.key === this.selectKey)] = options;
            this.historyList = [...this.list];
            this.saved = true;
            this.$emit("update:modelValue", this.historyList);
            ElMessage({
              message: this.$t("fm.datasource.message.saveSuccess"),
              type: "success"
            });
            this.tempFormData = _.cloneDeep(this.formData);
            resolve();
          } else {
            ElMessage({
              message: this.$t("fm.datasource.message.settingError"),
              type: "warning"
            });
            reject();
          }
        });
      });
    },
    handleAdd() {
      if (!this.saved || this.isFormChange) {
        ElMessage({
          message: this.$t("fm.datasource.message.saveError"),
          type: "warning"
        });
        return;
      }
      let key = Math.random().toString(36).slice(-8);
      this.list.push({
        key,
        name: "DataSource_" + key,
        url: "",
        method: "GET",
        auto: false,
        params: {},
        headers: {},
        responseFunc: "return res;",
        requestFunc: `return config;`,
        errorFunc: ``
      });
      this.selectKey = key;
      this.saved = false;
    },
    loadForm() {
      let currentData = this.list[this.selectIndex];
      this.formData = {
        ...currentData,
        params: currentData.params && Object.keys(currentData.params).map((item) => ({
          key: item,
          fx: isExpression(currentData.params[item]),
          value: isExpression(currentData.params[item]) ? extractExpression(currentData.params[item]) : currentData.params[item]
        })) || [],
        headers: currentData.headers && Object.keys(currentData.headers).map((item) => ({
          key: item,
          fx: isExpression(currentData.headers[item]),
          value: isExpression(currentData.headers[item]) ? extractExpression(currentData.headers[item]) : currentData.headers[item]
        })) || [],
        requestFunc: currentData.requestFunc || `return config;`
      };
      this.tempFormData = _.cloneDeep(this.formData);
      let append = [];
      this.formData.requestFunc != "return config;" && append.push("1");
      this.formData.responseFunc != "return res;" && append.push("2");
      this.formData.errorFunc && append.push("3");
      this.collapseAppend = append;
    },
    handleSelect(key) {
      if (key === this.selectKey) {
        return;
      }
      if (this.selectKey && (!this.saved || this.isFormChange)) {
        ElMessage({
          message: this.$t("fm.datasource.message.saveError"),
          type: "warning"
        });
        return;
      }
      this.selectKey = key;
    },
    handleCancal() {
      this.beforeClose(() => {
        this.selectKey = "";
        this.list = [...this.historyList];
        this.saved = true;
      });
    },
    handleClone(index2) {
      if (!this.saved) {
        ElMessage({
          message: this.$t("fm.datasource.message.saveError"),
          type: "warning"
        });
        return;
      }
      let currentData = this.list[index2];
      let key = Math.random().toString(36).slice(-8);
      let cloneData = {
        ...currentData,
        key,
        name: currentData.name + "_copy"
      };
      this.list.push(cloneData);
      this.selectKey = key;
      this.saved = false;
    },
    handleRemove(index2) {
      let currentData = this.list[index2];
      ElMessageBox.confirm(`${this.$t("fm.datasource.message.confirmRemove")} [${currentData.name}] ?`, "", {
        type: "warning"
      }).then(() => {
        if (currentData.key === this.selectKey) {
          this.selectKey = "";
          this.saved = true;
        }
        this.list.splice(index2, 1);
        if (index2 < this.historyList.length) {
          this.historyList.splice(index2, 1);
        }
        this.$emit("update:modelValue", this.historyList);
      }).catch(() => {
      });
    },
    beforeClose(done) {
      if (!_.isEqual(this.formData, this.tempFormData) || !this.saved) {
        ElMessageBox.confirm(
          this.$t("fm.eventscript.message.saveConfirm"),
          "Confirm",
          {
            distinguishCancelAndClose: true,
            confirmButtonText: this.$t("fm.eventscript.config.save"),
            cancelButtonText: this.$t("fm.eventscript.config.notSave"),
            type: "warning"
          }
        ).then(() => {
          this.handleSave().then(() => {
            done();
          });
        }).catch((action) => {
          if (action === "cancel") {
            done();
          }
        });
      } else {
        done();
      }
    }
  },
  watch: {
    selectKey(val) {
      if (val) {
        this.selectIndex = this.list.findIndex((item) => item.key === val);
        this.loadForm();
      } else {
        this.selectIndex = -1;
      }
    },
    modelValue(val) {
      this.historyList = [...val];
      this.list = [...val];
    }
  }
};
const _hoisted_1$z = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_2$v = { class: "data-source-menu-label" };
const _hoisted_3$p = { class: "data-source-menu-action" };
const _hoisted_4$o = ["onClick", "title"];
const _hoisted_5$o = ["onClick", "title"];
const _hoisted_6$m = { class: "data-source-action" };
const _hoisted_7$l = {
  key: 0,
  class: "code-desc"
};
const _hoisted_8$e = {
  key: 1,
  class: "code-desc"
};
const _hoisted_9$d = {
  key: 2,
  class: "code-desc"
};
const _hoisted_10$8 = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "(config, args) => {", -1);
const _hoisted_11$8 = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "}", -1);
const _hoisted_12$8 = {
  key: 0,
  class: "code-desc"
};
const _hoisted_13$6 = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "(res, args) => {", -1);
const _hoisted_14$5 = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "}", -1);
const _hoisted_15$3 = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "(error) => {", -1);
const _hoisted_16$2 = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "}", -1);
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = resolveComponent("el-button");
  const _component_el_header = resolveComponent("el-header");
  const _component_el_badge = resolveComponent("el-badge");
  const _component_el_menu_item = resolveComponent("el-menu-item");
  const _component_el_menu = resolveComponent("el-menu");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  const _component_el_main = resolveComponent("el-main");
  const _component_el_container = resolveComponent("el-container");
  const _component_el_aside = resolveComponent("el-aside");
  const _component_el_input = resolveComponent("el-input");
  const _component_el_form_item = resolveComponent("el-form-item");
  const _component_el_radio_button = resolveComponent("el-radio-button");
  const _component_el_radio_group = resolveComponent("el-radio-group");
  const _component_array_dynamic = resolveComponent("array-dynamic");
  const _component_el_switch = resolveComponent("el-switch");
  const _component_code_editor = resolveComponent("code-editor");
  const _component_el_collapse_item = resolveComponent("el-collapse-item");
  const _component_el_collapse = resolveComponent("el-collapse");
  const _component_el_form = resolveComponent("el-form");
  return openBlock(), createBlock(_component_el_container, { class: "data-source-container" }, {
    default: withCtx(() => [
      createVNode(_component_el_aside, {
        width: "300px",
        class: "data-source-aside"
      }, {
        default: withCtx(() => [
          createVNode(_component_el_container, null, {
            default: withCtx(() => [
              createVNode(_component_el_header, { height: "42px" }, {
                default: withCtx(() => [
                  createVNode(_component_el_button, {
                    link: "",
                    type: "primary",
                    size: "default",
                    onClick: $options.handleAdd
                  }, {
                    default: withCtx(() => [
                      _hoisted_1$z,
                      createTextVNode(" " + toDisplayString$1(_ctx.$t("fm.datasource.config.add")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              createVNode(_component_el_main, null, {
                default: withCtx(() => [
                  createVNode(_component_el_scrollbar, null, {
                    default: withCtx(() => [
                      createVNode(_component_el_menu, {
                        class: "data-source-aside-menu",
                        "default-active": $data.selectKey
                      }, {
                        default: withCtx(() => [
                          (openBlock(true), createElementBlock(Fragment, null, renderList($data.list, (item, index2) => {
                            return openBlock(), createBlock(_component_el_menu_item, {
                              class: normalizeClass({
                                "is-disabled": $options.isFormChange || !$data.saved,
                                "is-active2": $data.selectKey == item.key
                              }),
                              index: item.key,
                              key: item.key,
                              onClick: ($event) => $options.handleSelect(item.key)
                            }, {
                              title: withCtx(() => [
                                createElementVNode("div", null, [
                                  ($options.isFormChange || !$data.saved) && $data.selectKey == item.key ? (openBlock(), createBlock(_component_el_badge, {
                                    key: 0,
                                    "is-dot": "",
                                    style: { "position": "absolute", "top": "2px", "left": "2px" }
                                  })) : createCommentVNode("", true),
                                  createElementVNode("span", {
                                    class: normalizeClass(["data-source-menu-i", item.method])
                                  }, toDisplayString$1(item.method), 3),
                                  createElementVNode("div", _hoisted_2$v, toDisplayString$1(item.name), 1),
                                  createElementVNode("div", _hoisted_3$p, [
                                    createElementVNode("i", {
                                      class: "fm-iconfont icon-icon_clone",
                                      onClick: withModifiers(($event) => $options.handleClone(index2), ["stop"]),
                                      title: _ctx.$t("fm.tooltip.clone")
                                    }, null, 8, _hoisted_4$o),
                                    createElementVNode("i", {
                                      class: "fm-iconfont icon-trash",
                                      onClick: withModifiers(($event) => $options.handleRemove(index2), ["stop"]),
                                      title: _ctx.$t("fm.tooltip.trash")
                                    }, null, 8, _hoisted_5$o)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["class", "index", "onClick"]);
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["default-active"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createVNode(_component_el_main, { class: "data-source-main" }, {
        default: withCtx(() => [
          $data.selectIndex >= 0 ? (openBlock(), createBlock(_component_el_container, { key: 0 }, {
            default: withCtx(() => [
              createVNode(_component_el_header, { height: "42px" }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_6$m, [
                    createVNode(_component_el_button, {
                      type: "primary",
                      size: "default",
                      onClick: $options.handleSave
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.datasource.config.save")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    createVNode(_component_el_button, {
                      size: "default",
                      onClick: $options.handleTest
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.datasource.config.test")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    createVNode(_component_el_button, {
                      size: "default",
                      onClick: $options.handleCancal
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.datasource.config.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }),
              createVNode(_component_el_main, null, {
                default: withCtx(() => [
                  (openBlock(), createBlock(_component_el_form, {
                    ref: "dataForm",
                    model: $data.formData,
                    rules: $data.formRules,
                    "label-width": _ctx.$i18n.locale == "zh-cn" ? "79px" : "119px",
                    size: "default",
                    "label-position": "right",
                    key: $data.selectKey
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_form_item, {
                        label: _ctx.$t("fm.datasource.edit.name"),
                        prop: "name"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_input, {
                            modelValue: $data.formData.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.formData.name = $event)
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      createVNode(_component_el_form_item, {
                        label: _ctx.$t("fm.datasource.edit.url"),
                        prop: "url"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_input, {
                            type: "textarea",
                            rows: 1,
                            modelValue: $data.formData.url,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.formData.url = $event),
                            autosize: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      createVNode(_component_el_form_item, {
                        label: _ctx.$t("fm.datasource.edit.method"),
                        prop: "method"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio_group, {
                            modelValue: $data.formData.method,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.formData.method = $event)
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_radio_button, {
                                label: "GET",
                                value: "GET"
                              }),
                              createVNode(_component_el_radio_button, {
                                label: "POST",
                                value: "POST"
                              }),
                              createVNode(_component_el_radio_button, {
                                label: "PUT",
                                value: "PUT"
                              }),
                              createVNode(_component_el_radio_button, {
                                label: "DELETE",
                                value: "DELETE"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      createVNode(_component_el_form_item, {
                        label: _ctx.$t("fm.datasource.edit.headers")
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_array_dynamic, {
                            modelValue: $data.formData.headers,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $data.formData.headers = $event)
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      createVNode(_component_el_form_item, {
                        label: _ctx.$t("fm.datasource.edit.params")
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_array_dynamic, {
                            modelValue: $data.formData.params,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $data.formData.params = $event)
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      createVNode(_component_el_form_item, {
                        label: _ctx.$t("fm.datasource.edit.auto"),
                        "label-width": _ctx.$i18n.locale == "zh-cn" ? "175px" : "340px"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_switch, {
                            modelValue: $data.formData.auto,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $data.formData.auto = $event)
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label", "label-width"]),
                      createVNode(_component_el_form_item, {
                        label: _ctx.$t("fm.datasource.edit.response")
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_collapse, { modelValue: $data.collapseAppend }, {
                            default: withCtx(() => [
                              createVNode(_component_el_collapse_item, {
                                name: "1",
                                title: _ctx.$t("fm.datasource.edit.willRequest")
                              }, {
                                default: withCtx(() => [
                                  _ctx.$i18n.locale == "zh-cn" ? (openBlock(), createElementBlock("div", _hoisted_7$l, "// config: \u53D1\u51FA\u8BF7\u6C42\u7684\u53EF\u7528\u914D\u7F6E\u9009\u9879;")) : createCommentVNode("", true),
                                  _ctx.$i18n.locale == "zh-cn" ? (openBlock(), createElementBlock("div", _hoisted_8$e, "// \u901A\u8FC7 config.url \u53EF\u4EE5\u66F4\u6539\u8BF7\u6C42\u5730\u5740\uFF0C\u901A\u8FC7 config.headers \u53EF\u4EE5\u66F4\u6539\u8BF7\u6C42\u5934\u90E8")) : createCommentVNode("", true),
                                  _ctx.$i18n.locale == "zh-cn" ? (openBlock(), createElementBlock("div", _hoisted_9$d, "// \u901A\u8FC7 config.data \u53EF\u4EE5\u66F4\u6539\u53D1\u9001\u7684\u6570\u636E\uFF0C\uFF08GET \u8BF7\u6C42\u4E0D\u9002\u7528\uFF0C\u9700\u8981\u66F4\u6539 config.params\uFF09")) : createCommentVNode("", true),
                                  _hoisted_10$8,
                                  createVNode(_component_code_editor, {
                                    modelValue: $data.formData.requestFunc,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $data.formData.requestFunc = $event),
                                    mode: "javascript",
                                    height: "150px"
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_11$8
                                ]),
                                _: 1
                              }, 8, ["title"]),
                              createVNode(_component_el_collapse_item, {
                                title: _ctx.$t("fm.datasource.edit.responseSuccess"),
                                name: "2"
                              }, {
                                default: withCtx(() => [
                                  _ctx.$i18n.locale == "zh-cn" ? (openBlock(), createElementBlock("div", _hoisted_12$8, "// " + toDisplayString$1(_ctx.$t("fm.datasource.edit.annotation")), 1)) : createCommentVNode("", true),
                                  _hoisted_13$6,
                                  createVNode(_component_code_editor, {
                                    modelValue: $data.formData.responseFunc,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => $data.formData.responseFunc = $event),
                                    mode: "javascript",
                                    height: "150px"
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_14$5
                                ]),
                                _: 1
                              }, 8, ["title"]),
                              createVNode(_component_el_collapse_item, {
                                title: _ctx.$t("fm.datasource.edit.requestError"),
                                name: "3"
                              }, {
                                default: withCtx(() => [
                                  _hoisted_15$3,
                                  createVNode(_component_code_editor, {
                                    modelValue: $data.formData.errorFunc,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => $data.formData.errorFunc = $event),
                                    mode: "javascript",
                                    height: "150px"
                                  }, null, 8, ["modelValue"]),
                                  _hoisted_16$2
                                ]),
                                _: 1
                              }, 8, ["title"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["model", "rules", "label-width"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
var DatasourceIndex = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["render", _sfc_render$R]]);
var dialog_vue_vue_type_style_index_0_lang$1 = "";
const _sfc_main$S = {
  components: {
    CusDialog,
    DatasourceIndex
  },
  emits: ["dialog-close"],
  data: () => ({
    visible: false,
    dataSourceList: []
  }),
  methods: {
    open(list) {
      this.visible = true;
      if (list) {
        this.dataSourceList = list;
      }
    },
    handleClose() {
      this.$emit("dialog-close", this.dataSourceList);
      this.visible = false;
    },
    beforeClose(done) {
      this.$refs.datasourceIndex.beforeClose(done);
    }
  }
};
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_datasource_index = resolveComponent("datasource-index");
  const _component_el_container = resolveComponent("el-container");
  const _component_cus_dialog = resolveComponent("cus-dialog");
  return openBlock(), createBlock(_component_cus_dialog, {
    visible: _ctx.visible,
    onOnClose: $options.handleClose,
    ref: "dataSourceDialog",
    width: "1000px",
    form: "",
    title: _ctx.$t("fm.datasource.config.title"),
    action: false,
    "before-close": $options.beforeClose
  }, {
    default: withCtx(() => [
      createVNode(_component_el_container, {
        class: "fm-data-source-dialog-container",
        style: { "height": "600px" }
      }, {
        default: withCtx(() => [
          createVNode(_component_datasource_index, {
            ref: "datasourceIndex",
            modelValue: _ctx.dataSourceList,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.dataSourceList = $event)
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "onOnClose", "title", "before-close"]);
}
var DatasourceDialog = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["render", _sfc_render$Q]]);
var fieldsSelect_vue_vue_type_style_index_0_lang = "";
const _sfc_main$R = {
  props: ["modelValue", "multiple", "action", "defaultExpand"],
  emits: ["update:modelValue", "on-data-change"],
  data() {
    return {
      value: this.modelValue,
      formFields: []
    };
  },
  computed: {
    disabledProp() {
      switch (this.action) {
        case "openDialog":
        case "closeDialog":
          return "dialogDisabled";
        case "setData":
        case "validate":
          return "setdataDisabled";
        case "refreshFieldDataSource":
        case "getFieldDataSource":
          return "remoteOptionDisabled";
        case "hide":
        case "display":
          return "hideDisabled";
        default:
          return "disabled";
      }
    }
  },
  inject: ["getFormFields"],
  mounted() {
    this.formFields = this.getFormFields();
  },
  methods: {
    handleChange(data2) {
      if (this.action == "refreshFieldDataSource" && !data2.remoteOptionDisabled) {
        this.$emit("on-data-change", _.cloneDeep(data2));
      }
    }
  },
  watch: {
    modelValue(val) {
      this.value = val;
    },
    value(val) {
      this.$emit("update:modelValue", val);
    }
  }
};
const _hoisted_1$y = { class: "custom-tree-node-type" };
const _hoisted_2$u = {
  key: 0,
  class: "custom-tree-node-model"
};
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tree_select = resolveComponent("el-tree-select");
  return openBlock(), createBlock(_component_el_tree_select, {
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.value = $event),
    data: $data.formFields,
    "check-strictly": "",
    "render-after-expand": false,
    "default-expand-all": $props.defaultExpand,
    "expand-on-click-node": false,
    "node-key": "id",
    multiple: $props.multiple,
    clearable: $props.multiple,
    style: { "width": "100%" },
    class: "fm-custom-fields-select",
    props: { disabled: $options.disabledProp, label: "label" },
    onCurrentChange: $options.handleChange
  }, {
    default: withCtx(({ node }) => {
      var _a2;
      return [
        createElementVNode("div", {
          class: normalizeClass(["custom-tree-node", { "is-bind": (_a2 = node.data) == null ? void 0 : _a2.dataBind }])
        }, [
          createElementVNode("span", _hoisted_1$y, toDisplayString$1(node.data.type ? "<" + this.$t("fm.components.fields." + node.data.type) + ">" : node.data.label), 1),
          node.data.model ? (openBlock(), createElementBlock("span", _hoisted_2$u, toDisplayString$1(node.data.model), 1)) : createCommentVNode("", true)
        ], 2)
      ];
    }),
    _: 1
  }, 8, ["modelValue", "data", "default-expand-all", "multiple", "clearable", "props", "onCurrentChange"]);
}
var FieldsSelect = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["render", _sfc_render$P]]);
const _sfc_main$Q = {
  props: ["modelValue"],
  emits: ["update:modelValue"],
  data() {
    return {
      value: this.modelValue,
      dataSource: []
    };
  },
  inject: ["getDataSourceArray"],
  mounted() {
    this.dataSource = this.getDataSourceArray();
  },
  watch: {
    modelValue(val) {
      this.value = val;
    },
    value(val) {
      this.$emit("update:modelValue", val);
    }
  }
};
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  return openBlock(), createBlock(_component_el_select, {
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.value = $event),
    style: { "width": "100%" }
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($data.dataSource, (item) => {
        return openBlock(), createBlock(_component_el_option, {
          key: item.key,
          value: item,
          label: item.label
        }, null, 8, ["value", "label"]);
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]);
}
var DataSourceSelect = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["render", _sfc_render$O]]);
const _sfc_main$P = {
  props: ["modelValue"],
  emits: ["update:modelValue"],
  data() {
    return {
      value: this.modelValue,
      events: []
    };
  },
  inject: ["getEventsArray"],
  mounted() {
    this.events = this.getEventsArray();
  },
  watch: {
    modelValue(val) {
      this.value = val;
    },
    value(val) {
      this.$emit("update:modelValue", val);
    }
  }
};
const _hoisted_1$x = { style: { "display": "flex", "justify-content": "space-between", "align-items": "center" } };
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = resolveComponent("el-tag");
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  return openBlock(), createBlock(_component_el_select, {
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.value = $event),
    style: { "width": "100%" }
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($data.events, (item) => {
        return openBlock(), createBlock(_component_el_option, {
          key: item.key,
          value: item.name,
          label: item.name
        }, {
          default: withCtx(() => [
            createElementVNode("div", _hoisted_1$x, [
              createElementVNode("span", null, toDisplayString$1(item.name), 1),
              createVNode(_component_el_tag, {
                size: "small",
                type: item.type == "rule" ? "warning" : "success"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString$1(item.type == "rule" ? "VIS" : "JS"), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ])
          ]),
          _: 2
        }, 1032, ["value", "label"]);
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]);
}
var EventsSelect = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["render", _sfc_render$N]]);
const formActions = [
  {
    action: "hide",
    options: {
      fields: [],
      condition: "",
      isCondition: false
    }
  },
  {
    action: "display",
    options: {
      fields: [],
      condition: "",
      isCondition: false
    }
  },
  {
    action: "disabled",
    options: {
      fields: [],
      condition: "",
      isCondition: false,
      disabled: false
    }
  },
  {
    action: "refresh",
    options: {
      condition: "",
      isCondition: false
    }
  },
  {
    action: "reset",
    options: {
      condition: "",
      isCondition: false
    }
  },
  {
    action: "setData",
    options: {
      condition: "",
      isCondition: false,
      fields: [],
      values: {},
      valueTypes: {}
    }
  },
  {
    action: "validate",
    options: {
      condition: "",
      isCondition: false,
      fields: [],
      failSuspend: false
    }
  }
];
const requestActions = [
  {
    action: "sendRequest",
    options: {
      condition: "",
      isCondition: false,
      dataSource: "",
      valueTypes: {},
      responseVariable: ""
    }
  },
  {
    action: "refreshFieldDataSource",
    options: {
      condition: "",
      isCondition: false,
      field: "",
      valueTypes: {}
    }
  },
  {
    action: "getFieldDataSource",
    options: {
      condition: "",
      isCondition: false,
      field: "",
      localVariable: ""
    }
  }
];
const dialogActions = [
  {
    action: "openDialog",
    options: {
      condition: "",
      isCondition: false,
      field: ""
    }
  },
  {
    action: "closeDialog",
    options: {
      condition: "",
      isCondition: false,
      field: ""
    }
  }
];
const otherActions = [
  {
    action: "triggerEvent",
    options: {
      condition: "",
      isCondition: false,
      functionName: "",
      functionParams: ""
    }
  },
  {
    action: "js",
    options: {
      func: ""
    }
  }
];
var rule_vue_vue_type_style_index_0_lang = "";
const _sfc_main$O = {
  components: {
    Draggable: draggableComponent,
    FieldsSelect,
    DataSourceSelect,
    EventsSelect,
    FormulaDialog,
    CodeEditor
  },
  props: ["modelValue"],
  emits: ["update:modelValue"],
  data() {
    return {
      ruleList: this.modelValue || [],
      select: "",
      formActions,
      requestActions,
      dialogActions,
      otherActions,
      curIndex: -1,
      curOption: "",
      curField: ""
    };
  },
  provide() {
    return {
      "getResponseVariables": this.getResponseVariables,
      "getLocalVariables": this.getLocalVariables
    };
  },
  methods: {
    handleOpenCondition(condition, index2) {
      this.$refs.formulaDialog.open(condition);
      this.curIndex = index2;
      this.curOption = "condition";
    },
    handleOpenFx(fx, index2, field, option2 = "values") {
      this.$refs.formulaDialog.open(fx);
      this.curIndex = index2;
      this.curOption = option2;
      this.curField = field;
    },
    handleFormulaConfirm(val) {
      if (this.curIndex >= 0 && this.curOption == "condition") {
        this.ruleList[this.curIndex].options[this.curOption] = val;
      }
      if (this.curIndex >= 0 && this.curOption == "values") {
        this.ruleList[this.curIndex].options[this.curOption][this.curField] = val;
      }
      if (this.curIndex >= 0 && this.curOption == "dataSource") {
        this.ruleList[this.curIndex].options.dataSource["args"][this.curField] = val;
      }
    },
    handleActionCommand(command) {
      let key = Math.random().toString(36).slice(-8);
      this.ruleList.push({
        key,
        ..._.cloneDeep(command)
      });
    },
    handleActonRemove(index2) {
      this.ruleList.splice(index2, 1);
    },
    handleFieldDataChange(fieldData, element) {
      if (fieldData) {
        element.options.dataSource = {
          args: typeof fieldData.options.remoteArgs == "string" ? JSON.parse(fieldData.options.remoteArgs) : fieldData.options.remoteArgs
        };
      } else {
        element.options.dataSource = {};
      }
    },
    getResponseVariables() {
      let vars2 = [];
      this.ruleList.forEach((item) => {
        if (item.options.responseVariable) {
          vars2.push(item.options.responseVariable);
        }
      });
      return vars2;
    },
    getLocalVariables() {
      let vars2 = [];
      this.ruleList.forEach((item) => {
        if (item.options.localVariable) {
          vars2.push(item.options.localVariable);
        }
      });
      return vars2;
    },
    handleTypeChange(val, target, field) {
      var _a2, _b, _c;
      switch (val) {
        case "string":
        case "fx":
          target[field] = String((_a2 = target[field]) != null ? _a2 : "");
          break;
        case "boolean":
          target[field] = Boolean((_b = target[field]) != null ? _b : false);
          break;
        case "number":
          target[field] = Number((_c = target[field]) != null ? _c : 0);
          break;
      }
    }
  },
  watch: {
    modelValue(val) {
      this.ruleList = val;
    },
    ruleList: {
      deep: true,
      handler(val) {
        this.$emit("update:modelValue", val);
      }
    }
  }
};
const _hoisted_1$w = { class: "fm-rules-config-container" };
const _hoisted_2$t = { class: "card-header" };
const _hoisted_3$o = /* @__PURE__ */ createElementVNode("div", { class: "widget-view-delete widget-view-action" }, [
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-delete" })
], -1);
const _hoisted_4$n = /* @__PURE__ */ createElementVNode("div", { class: "widget-view-drag widget-view-action" }, [
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-icon_bars drag-widget" })
], -1);
const _hoisted_5$n = /* @__PURE__ */ createElementVNode("div", null, "\xA0=\xA0", -1);
const _hoisted_6$l = { class: "values-value" };
const _hoisted_7$k = /* @__PURE__ */ createElementVNode("div", null, "\xA0=\xA0", -1);
const _hoisted_8$d = { class: "values-value" };
const _hoisted_9$c = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-editor-formula",
  style: { "font-size": "13px" }
}, null, -1);
const _hoisted_10$7 = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "Function () {", -1);
const _hoisted_11$7 = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "}", -1);
const _hoisted_12$7 = { class: "fm-add-rules-button" };
const _hoisted_13$5 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = resolveComponent("el-tag");
  const _component_el_popconfirm = resolveComponent("el-popconfirm");
  const _component_FieldsSelect = resolveComponent("FieldsSelect");
  const _component_el_form_item = resolveComponent("el-form-item");
  const _component_events_select = resolveComponent("events-select");
  const _component_el_input = resolveComponent("el-input");
  const _component_data_source_select = resolveComponent("data-source-select");
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  const _component_el_switch = resolveComponent("el-switch");
  const _component_el_radio = resolveComponent("el-radio");
  const _component_el_radio_group = resolveComponent("el-radio-group");
  const _component_el_button = resolveComponent("el-button");
  const _component_code_editor = resolveComponent("code-editor");
  const _component_el_form = resolveComponent("el-form");
  const _component_el_card = resolveComponent("el-card");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_dropdown_item = resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = resolveComponent("el-dropdown");
  const _component_FormulaDialog = resolveComponent("FormulaDialog");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$w, [
      createVNode(_component_draggable, mergeProps({ list: $data.ruleList }, { group: "peo2", ghostClass: "ghost11", animation: 200, handle: ".drag-widget" }, {
        "no-transition-on-drag": true,
        "item-key": "key",
        class: "widget-form-list"
      }), {
        item: withCtx(({ element, index: index2 }) => [
          createVNode(_component_el_card, {
            class: "rule-card",
            shadow: "never",
            size: "small"
          }, {
            header: withCtx(() => [
              createElementVNode("div", _hoisted_2$t, [
                createVNode(_component_el_tag, null, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(_ctx.$t("fm.rules.actions." + element.action)), 1)
                  ]),
                  _: 2
                }, 1024),
                createElementVNode("div", null, [
                  createVNode(_component_el_popconfirm, {
                    width: "200",
                    title: _ctx.$t("fm.rules.message.confirmDelete"),
                    onConfirm: ($event) => $options.handleActonRemove(index2)
                  }, {
                    reference: withCtx(() => [
                      _hoisted_3$o
                    ]),
                    _: 2
                  }, 1032, ["title", "onConfirm"]),
                  _hoisted_4$n
                ])
              ])
            ]),
            default: withCtx(() => [
              createVNode(_component_el_form, {
                "label-width": "100px",
                style: { "margin-right": "20px" },
                modelValue: element.options,
                "onUpdate:modelValue": ($event) => element.options = $event,
                class: "rule-card-form"
              }, {
                default: withCtx(() => [
                  Object.keys(element.options).includes("fields") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 0,
                    label: _ctx.$t("fm.rules.label.field")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_FieldsSelect, {
                        defaultExpand: true,
                        multiple: true,
                        modelValue: element.options.fields,
                        "onUpdate:modelValue": ($event) => element.options.fields = $event,
                        action: element.action
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "action"])
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  Object.keys(element.options).includes("field") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 1,
                    label: _ctx.$t("fm.rules.label.field")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_FieldsSelect, {
                        defaultExpand: element.action != "openDialog" && element.action != "closeDialog",
                        multiple: false,
                        modelValue: element.options.field,
                        "onUpdate:modelValue": ($event) => element.options.field = $event,
                        action: element.action,
                        onOnDataChange: ($event) => $options.handleFieldDataChange($event, element)
                      }, null, 8, ["defaultExpand", "modelValue", "onUpdate:modelValue", "action", "onOnDataChange"])
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  Object.keys(element.options).includes("functionName") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 2,
                    label: _ctx.$t("fm.rules.label.functionName")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_events_select, {
                        modelValue: element.options.functionName,
                        "onUpdate:modelValue": ($event) => element.options.functionName = $event
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  element.options.functionName && !["mounted", "refresh"].includes(element.options.functionName) && Object.keys(element.options).includes("functionParams") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 3,
                    label: _ctx.$t("fm.rules.label.functionParams")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: element.options.functionParams,
                        "onUpdate:modelValue": ($event) => element.options.functionParams = $event,
                        autosize: true
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  Object.keys(element.options).includes("dataSource") && element.action == "sendRequest" ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 4,
                    label: _ctx.$t("fm.rules.label.datasource")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_data_source_select, {
                        modelValue: element.options.dataSource,
                        "onUpdate:modelValue": ($event) => element.options.dataSource = $event
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  element.options.dataSource && Object.keys(element.options.dataSource.args).length ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 5,
                    label: _ctx.$t("fm.rules.label.datasourceArgs")
                  }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(Object.keys(element.options.dataSource.args), (argKey) => {
                        return openBlock(), createElementBlock("div", {
                          key: argKey,
                          class: "values-item"
                        }, [
                          createVNode(_component_el_input, {
                            value: argKey,
                            readonly: "",
                            style: { "width": "200px" },
                            title: argKey
                          }, null, 8, ["value", "title"]),
                          _hoisted_5$n,
                          createVNode(_component_el_select, {
                            onChange: ($event) => $options.handleTypeChange($event, element.options.dataSource.args, argKey),
                            modelValue: element.options.valueTypes[argKey],
                            "onUpdate:modelValue": ($event) => element.options.valueTypes[argKey] = $event,
                            placeholder: _ctx.$t("fm.rules.label.string"),
                            style: { "width": "150px" }
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_option, {
                                label: _ctx.$t("fm.rules.label.string"),
                                value: "string"
                              }, null, 8, ["label"]),
                              createVNode(_component_el_option, {
                                label: _ctx.$t("fm.rules.label.number"),
                                value: "number"
                              }, null, 8, ["label"]),
                              createVNode(_component_el_option, {
                                label: _ctx.$t("fm.rules.label.boolean"),
                                value: "boolean"
                              }, null, 8, ["label"]),
                              createVNode(_component_el_option, {
                                label: _ctx.$t("fm.rules.label.fx"),
                                value: "fx"
                              }, null, 8, ["label"])
                            ]),
                            _: 2
                          }, 1032, ["onChange", "modelValue", "onUpdate:modelValue", "placeholder"]),
                          createElementVNode("div", _hoisted_6$l, [
                            !element.options.valueTypes[argKey] || element.options.valueTypes[argKey] == "string" ? (openBlock(), createBlock(_component_el_input, {
                              key: 0,
                              modelValue: element.options.dataSource.args[argKey],
                              "onUpdate:modelValue": ($event) => element.options.dataSource.args[argKey] = $event
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true),
                            element.options.valueTypes[argKey] == "number" ? (openBlock(), createBlock(_component_el_input, {
                              key: 1,
                              type: "number",
                              modelValue: element.options.dataSource.args[argKey],
                              "onUpdate:modelValue": ($event) => element.options.dataSource.args[argKey] = $event,
                              modelModifiers: { number: true }
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true),
                            element.options.valueTypes[argKey] == "boolean" ? (openBlock(), createBlock(_component_el_switch, {
                              key: 2,
                              "active-value": "true",
                              "inactive-value": "false",
                              modelValue: element.options.dataSource.args[argKey],
                              "onUpdate:modelValue": ($event) => element.options.dataSource.args[argKey] = $event,
                              style: { "margin-left": "5px" }
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true),
                            element.options.valueTypes[argKey] == "fx" ? (openBlock(), createBlock(_component_el_input, {
                              key: 3,
                              class: normalizeClass({ "is-fx": element.options.valueTypes[argKey] == "fx" }),
                              readonly: "",
                              modelValue: element.options.dataSource.args[argKey],
                              "onUpdate:modelValue": ($event) => element.options.dataSource.args[argKey] = $event,
                              placeholder: _ctx.$t("fm.rules.message.editFx"),
                              onClick: ($event) => $options.handleOpenFx(element.options.dataSource.args[argKey], index2, argKey, "dataSource")
                            }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "placeholder", "onClick"])) : createCommentVNode("", true)
                          ])
                        ]);
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  element.options.dataSource && Object.keys(element.options).includes("responseVariable") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 6,
                    label: _ctx.$t("fm.rules.label.responseVariable")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        modelValue: element.options.responseVariable,
                        "onUpdate:modelValue": ($event) => element.options.responseVariable = $event,
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  element.options.field && Object.keys(element.options).includes("localVariable") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 7,
                    label: _ctx.$t("fm.rules.label.localVariable")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_input, {
                        modelValue: element.options.localVariable,
                        "onUpdate:modelValue": ($event) => element.options.localVariable = $event,
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  Object.keys(element.options).includes("disabled") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 8,
                    "label-width": _ctx.$i18n.locale == "zh-cn" ? "100px" : "120px",
                    label: _ctx.$t("fm.rules.label.enabled") + "/" + _ctx.$t("fm.rules.label.disabled")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: element.options.disabled,
                        "onUpdate:modelValue": ($event) => element.options.disabled = $event
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio, {
                            label: false,
                            value: false
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.rules.label.enabled")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio, {
                            label: true,
                            value: true
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.rules.label.disabled")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label-width", "label"])) : createCommentVNode("", true),
                  Object.keys(element.options).includes("values") && element.options.fields.length ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 9,
                    label: _ctx.$t("fm.rules.label.values")
                  }, {
                    default: withCtx(() => [
                      (openBlock(true), createElementBlock(Fragment, null, renderList(element.options.fields, (field) => {
                        return openBlock(), createElementBlock("div", {
                          key: field,
                          class: "values-item"
                        }, [
                          createVNode(_component_el_input, {
                            value: field,
                            readonly: "",
                            style: { "width": "200px", "direction": "rtl" },
                            title: field
                          }, null, 8, ["value", "title"]),
                          _hoisted_7$k,
                          createVNode(_component_el_select, {
                            onChange: ($event) => $options.handleTypeChange($event, element.options.values, field),
                            modelValue: element.options.valueTypes[field],
                            "onUpdate:modelValue": ($event) => element.options.valueTypes[field] = $event,
                            placeholder: _ctx.$t("fm.rules.label.string"),
                            style: { "width": "150px" }
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_option, {
                                label: _ctx.$t("fm.rules.label.string"),
                                value: "string"
                              }, null, 8, ["label"]),
                              createVNode(_component_el_option, {
                                label: _ctx.$t("fm.rules.label.number"),
                                value: "number"
                              }, null, 8, ["label"]),
                              createVNode(_component_el_option, {
                                label: _ctx.$t("fm.rules.label.boolean"),
                                value: "boolean"
                              }, null, 8, ["label"]),
                              createVNode(_component_el_option, {
                                label: _ctx.$t("fm.rules.label.fx"),
                                value: "fx"
                              }, null, 8, ["label"])
                            ]),
                            _: 2
                          }, 1032, ["onChange", "modelValue", "onUpdate:modelValue", "placeholder"]),
                          createElementVNode("div", _hoisted_8$d, [
                            !element.options.valueTypes[field] || element.options.valueTypes[field] == "string" ? (openBlock(), createBlock(_component_el_input, {
                              key: 0,
                              modelValue: element.options.values[field],
                              "onUpdate:modelValue": ($event) => element.options.values[field] = $event
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true),
                            element.options.valueTypes[field] == "number" ? (openBlock(), createBlock(_component_el_input, {
                              key: 1,
                              type: "number",
                              modelValue: element.options.values[field],
                              "onUpdate:modelValue": ($event) => element.options.values[field] = $event,
                              modelModifiers: { number: true }
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true),
                            element.options.valueTypes[field] == "boolean" ? (openBlock(), createBlock(_component_el_switch, {
                              key: 2,
                              modelValue: element.options.values[field],
                              "onUpdate:modelValue": ($event) => element.options.values[field] = $event,
                              style: { "margin-left": "5px" }
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true),
                            element.options.valueTypes[field] == "fx" ? (openBlock(), createBlock(_component_el_input, {
                              key: 3,
                              class: normalizeClass({ "is-fx": element.options.valueTypes[field] == "fx" }),
                              readonly: "",
                              modelValue: element.options.values[field],
                              "onUpdate:modelValue": ($event) => element.options.values[field] = $event,
                              placeholder: _ctx.$t("fm.rules.message.editFx"),
                              onClick: ($event) => $options.handleOpenFx(element.options.values[field], index2, field)
                            }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "placeholder", "onClick"])) : createCommentVNode("", true)
                          ])
                        ]);
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  Object.keys(element.options).includes("failSuspend") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 10,
                    label: _ctx.$t("fm.rules.label.validateFail")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_radio_group, {
                        modelValue: element.options.failSuspend,
                        "onUpdate:modelValue": ($event) => element.options.failSuspend = $event
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio, {
                            label: false,
                            value: false
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.rules.label.validateFailContinue")), 1)
                            ]),
                            _: 1
                          }),
                          createVNode(_component_el_radio, {
                            label: true,
                            value: true
                          }, {
                            default: withCtx(() => [
                              createTextVNode(toDisplayString$1(_ctx.$t("fm.rules.label.validateFailSuspend")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  Object.keys(element.options).includes("condition") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 11,
                    label: _ctx.$t("fm.rules.label.condition")
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_switch, {
                        modelValue: element.options.isCondition,
                        "onUpdate:modelValue": ($event) => element.options.isCondition = $event
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      element.options.isCondition ? (openBlock(), createBlock(_component_el_input, {
                        key: 0,
                        modelValue: element.options.condition,
                        "onUpdate:modelValue": ($event) => element.options.condition = $event,
                        placeholder: _ctx.$t("fm.rules.message.condition"),
                        class: "input-with-select",
                        readonly: "",
                        onClick: ($event) => $options.handleOpenCondition(element.options.condition, index2)
                      }, {
                        append: withCtx(() => [
                          createVNode(_component_el_button, {
                            size: "small",
                            onClick: ($event) => $options.handleOpenCondition(element.options.condition, index2)
                          }, {
                            default: withCtx(() => [
                              _hoisted_9$c
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onClick"])) : createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["label"])) : createCommentVNode("", true),
                  Object.keys(element.options).includes("func") ? (openBlock(), createBlock(_component_el_form_item, {
                    key: 12,
                    "label-width": "0",
                    style: { "margin-bottom": "0px" }
                  }, {
                    default: withCtx(() => [
                      _hoisted_10$7,
                      createVNode(_component_code_editor, {
                        modelValue: element.options.func,
                        "onUpdate:modelValue": ($event) => element.options.func = $event,
                        mode: "tsx",
                        height: "200px"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _hoisted_11$7
                    ]),
                    _: 2
                  }, 1024)) : createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 16, ["list"]),
      createVNode(_component_el_dropdown, {
        onCommand: $options.handleActionCommand,
        trigger: "click",
        class: "fm-add-rules-wrapper",
        "max-height": "400px"
      }, {
        dropdown: withCtx(() => [
          createVNode(_component_el_dropdown_menu, null, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList($data.dialogActions, (item) => {
                return openBlock(), createBlock(_component_el_dropdown_item, {
                  key: item.action,
                  command: item
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", null, toDisplayString$1(_ctx.$t("fm.rules.actions." + item.action)), 1)
                  ]),
                  _: 2
                }, 1032, ["command"]);
              }), 128)),
              (openBlock(true), createElementBlock(Fragment, null, renderList($data.formActions, (item, index2) => {
                return openBlock(), createBlock(_component_el_dropdown_item, {
                  key: item.action,
                  command: item,
                  divided: index2 == 0
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", null, toDisplayString$1(_ctx.$t("fm.rules.actions." + item.action)), 1)
                  ]),
                  _: 2
                }, 1032, ["command", "divided"]);
              }), 128)),
              (openBlock(true), createElementBlock(Fragment, null, renderList($data.requestActions, (item, index2) => {
                return openBlock(), createBlock(_component_el_dropdown_item, {
                  key: item.action,
                  command: item,
                  divided: index2 == 0
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", null, toDisplayString$1(_ctx.$t("fm.rules.actions." + item.action)), 1)
                  ]),
                  _: 2
                }, 1032, ["command", "divided"]);
              }), 128)),
              (openBlock(true), createElementBlock(Fragment, null, renderList($data.otherActions, (item, index2) => {
                return openBlock(), createBlock(_component_el_dropdown_item, {
                  key: item.action,
                  command: item,
                  divided: index2 == 0
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", null, toDisplayString$1(_ctx.$t("fm.rules.actions." + item.action)), 1)
                  ]),
                  _: 2
                }, 1032, ["command", "divided"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        default: withCtx(() => [
          createElementVNode("div", _hoisted_12$7, [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.rules.actions.add")), 1),
            _hoisted_13$5
          ])
        ]),
        _: 1
      }, 8, ["onCommand"])
    ]),
    createVNode(_component_FormulaDialog, {
      ref: "formulaDialog",
      onDialogConfirm: $options.handleFormulaConfirm
    }, null, 8, ["onDialogConfirm"])
  ], 64);
}
var EventRule = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["render", _sfc_render$M]]);
var index_vue_vue_type_style_index_0_lang$3 = "";
const _sfc_main$N = {
  components: {
    Draggable: draggableComponent,
    CodeEditor,
    EventRule
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue", "on-confirm-event"],
  data() {
    return {
      formData: {
        key: "",
        name: "",
        func: "",
        type: "rule"
      },
      tmpData: {},
      formRules: {
        name: [
          { required: true, message: " " },
          { validator: (rule, value, callback) => {
            let currentItem = this.historyList.find((item) => item.name == value);
            if (currentItem && currentItem.key != this.selectKey) {
              callback(new Error(this.$t("fm.eventscript.message.repeat")));
            } else {
              callback();
            }
          } }
        ]
      },
      list: [...this.modelValue],
      selectIndex: -1,
      selectKey: "",
      historyList: [...this.modelValue],
      saved: true,
      eventType: "",
      readonlyFunctions: ["mounted", "refresh"]
    };
  },
  provide() {
    return {
      "getEventsArray": this.getEventsArray
    };
  },
  methods: {
    handleSave(confirm) {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.list[this.list.findIndex((item) => item.key === this.selectKey)] = this.formData;
          this.historyList = [...this.list];
          this.saved = true;
          this.tmpData = _.cloneDeep(this.formData);
          this.$emit("update:modelValue", this.historyList);
          if (confirm) {
            this.$emit("on-confirm-event", { ...this.formData, type: this.eventType });
          } else {
            ElMessage({
              message: this.$t("fm.eventscript.message.saveSuccess"),
              type: "success"
            });
          }
        }
      });
    },
    handleAdd() {
      if (!this.saved || !this.isFormChange()) {
        ElMessage({
          message: this.$t("fm.eventscript.message.saveError"),
          type: "warning"
        });
        return;
      }
      let key = Math.random().toString(36).slice(-8);
      this.list.push({
        key,
        name: "func_" + key,
        func: "",
        type: "rule"
      });
      this.selectKey = key;
      this.saved = false;
    },
    loadNewFunction(name) {
      let key = Math.random().toString(36).slice(-8);
      this.list.push({
        key,
        name: name + "_" + key,
        func: "",
        type: "rule"
      });
      this.selectKey = key;
      this.saved = false;
      this.eventType = name;
    },
    loadForm() {
      let currentData = this.list[this.selectIndex];
      this.formData = {
        ...currentData,
        type: currentData.type || "js"
      };
      this.tmpData = _.cloneDeep(this.formData);
    },
    handleSelect(key) {
      if (key === this.selectKey) {
        return;
      }
      if (!this.saved || !this.isFormChange()) {
        ElMessage({
          message: this.$t("fm.eventscript.message.saveError"),
          type: "warning"
        });
        return;
      }
      this.selectKey = key;
    },
    isFormChange() {
      if (this.selectKey && Object.keys(this.tmpData).length) {
        return _.isEqual(this.formData, this.tmpData);
      } else {
        return true;
      }
    },
    loadFunction(key, name) {
      this.selectKey = key;
      if (name) {
        this.eventType = name;
      }
    },
    handleCancal() {
      this.selectKey = "";
      this.list = [...this.historyList];
      this.saved = true;
    },
    handleClone(index2) {
      if (!this.saved || !this.isFormChange()) {
        ElMessage({
          message: this.$t("fm.eventscript.message.saveError"),
          type: "warning"
        });
        return;
      }
      let currentData = this.list[index2];
      let key = Math.random().toString(36).slice(-8);
      let cloneData = {
        ...currentData,
        key,
        name: currentData.name + "_copy"
      };
      this.list.push(cloneData);
      this.selectKey = key;
      this.saved = false;
    },
    handleRemove(index2) {
      let currentData = this.list[index2];
      ElMessageBox.confirm(`${this.$t("fm.eventscript.message.confirmRemove")} [${currentData.name}] ?`, "", {
        type: "warning"
      }).then(() => {
        if (currentData.key === this.selectKey) {
          this.selectKey = "";
          this.saved = true;
        }
        this.list.splice(index2, 1);
        if (index2 < this.historyList.length) {
          this.historyList.splice(index2, 1);
        }
        this.$emit("update:modelValue", this.historyList);
      }).catch(() => {
      });
    },
    getEventsArray() {
      return this.list.map((item) => ({ key: item.key, name: item.name, type: item.type })).filter((item) => item.key != "mounted" && item.key != "refresh" && item.key != this.selectKey);
    }
  },
  watch: {
    selectKey(val) {
      if (val) {
        this.selectIndex = this.list.findIndex((item) => item.key === val);
        if (this.selectIndex >= 0) {
          this.loadForm();
        }
      } else {
        this.selectIndex = -1;
      }
    },
    modelValue(val) {
      this.historyList = [...val];
      this.list = [...val];
    }
  }
};
const _hoisted_1$v = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_2$s = { class: "event-script-menu-label" };
const _hoisted_3$n = {
  key: 0,
  class: "event-script-menu-action"
};
const _hoisted_4$m = ["onClick", "title"];
const _hoisted_5$m = ["onClick", "title"];
const _hoisted_6$k = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-icon_bars drag-widget" }, null, -1);
const _hoisted_7$j = { class: "event-script-action" };
const _hoisted_8$c = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "Function () {", -1);
const _hoisted_9$b = /* @__PURE__ */ createElementVNode("div", { class: "code-line" }, "}", -1);
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = resolveComponent("el-button");
  const _component_el_header = resolveComponent("el-header");
  const _component_el_menu_item = resolveComponent("el-menu-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_menu = resolveComponent("el-menu");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  const _component_el_main = resolveComponent("el-main");
  const _component_el_container = resolveComponent("el-container");
  const _component_el_aside = resolveComponent("el-aside");
  const _component_el_input = resolveComponent("el-input");
  const _component_el_form_item = resolveComponent("el-form-item");
  const _component_el_radio_button = resolveComponent("el-radio-button");
  const _component_el_radio_group = resolveComponent("el-radio-group");
  const _component_code_editor = resolveComponent("code-editor");
  const _component_event_rule = resolveComponent("event-rule");
  const _component_el_form = resolveComponent("el-form");
  return openBlock(), createBlock(_component_el_container, { class: "event-script-container" }, {
    default: withCtx(() => [
      createVNode(_component_el_aside, {
        width: "300px",
        class: "event-script-aside"
      }, {
        default: withCtx(() => [
          createVNode(_component_el_container, null, {
            default: withCtx(() => [
              createVNode(_component_el_header, { height: "42px" }, {
                default: withCtx(() => [
                  createVNode(_component_el_button, {
                    link: "",
                    type: "primary",
                    size: "default",
                    onClick: $options.handleAdd
                  }, {
                    default: withCtx(() => [
                      _hoisted_1$v,
                      createTextVNode(toDisplayString$1(_ctx.$t("fm.eventscript.config.add")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              createVNode(_component_el_main, null, {
                default: withCtx(() => [
                  createVNode(_component_el_scrollbar, null, {
                    default: withCtx(() => [
                      createVNode(_component_el_menu, {
                        class: "event-script-aside-menu",
                        "default-active": $data.selectKey,
                        onSelect: $options.handleSelect
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_draggable, mergeProps({ list: $data.list }, { group: "peo1", ghostClass: "ghost11", animation: 200, handle: ".drag-widget" }, {
                            "no-transition-on-drag": true,
                            "item-key": "key"
                          }), {
                            item: withCtx(({ element: item, index: index2 }) => [
                              createVNode(_component_el_menu_item, {
                                index: item.key,
                                disabled: !$data.saved || !$options.isFormChange(),
                                onClick: ($event) => $options.handleSelect(item.key)
                              }, {
                                title: withCtx(() => [
                                  createElementVNode("div", null, [
                                    createElementVNode("span", {
                                      class: normalizeClass(["event-script-menu-i", { "is-vis": item.type == "rule" }])
                                    }, toDisplayString$1(item.type == "rule" ? "VIS" : "JS"), 3),
                                    createElementVNode("div", _hoisted_2$s, toDisplayString$1(item.name), 1),
                                    !$data.readonlyFunctions.includes(item.name) ? (openBlock(), createElementBlock("div", _hoisted_3$n, [
                                      createElementVNode("i", {
                                        class: "fm-iconfont icon-icon_clone",
                                        onClick: withModifiers(($event) => $options.handleClone(index2), ["stop"]),
                                        title: _ctx.$t("fm.tooltip.clone")
                                      }, null, 8, _hoisted_4$m),
                                      createElementVNode("i", {
                                        class: "fm-iconfont icon-trash",
                                        onClick: withModifiers(($event) => $options.handleRemove(index2), ["stop"]),
                                        title: _ctx.$t("fm.tooltip.trash")
                                      }, null, 8, _hoisted_5$m),
                                      _hoisted_6$k
                                    ])) : createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["index", "disabled", "onClick"])
                            ]),
                            _: 1
                          }, 16, ["list"])
                        ]),
                        _: 1
                      }, 8, ["default-active", "onSelect"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createVNode(_component_el_main, { class: "event-script-main" }, {
        default: withCtx(() => [
          $data.selectIndex >= 0 ? (openBlock(), createBlock(_component_el_container, { key: 0 }, {
            default: withCtx(() => [
              createVNode(_component_el_header, { height: "42px" }, {
                default: withCtx(() => [
                  createElementVNode("div", _hoisted_7$j, [
                    this.eventType ? (openBlock(), createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "default",
                      onClick: _cache[0] || (_cache[0] = ($event) => $options.handleSave(true))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.eventscript.config.confirm")), 1)
                      ]),
                      _: 1
                    })) : createCommentVNode("", true),
                    createVNode(_component_el_button, {
                      type: "primary",
                      size: "default",
                      onClick: _cache[1] || (_cache[1] = ($event) => $options.handleSave(false))
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.eventscript.config.save")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_button, {
                      size: "default",
                      onClick: $options.handleCancal
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.eventscript.config.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }),
              createVNode(_component_el_main, null, {
                default: withCtx(() => [
                  (openBlock(), createBlock(_component_el_form, {
                    ref: "dataForm",
                    model: $data.formData,
                    rules: $data.formRules,
                    "label-width": "125px",
                    size: "default",
                    "label-position": "left",
                    key: $data.selectKey
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_form_item, {
                        label: _ctx.$t("fm.eventscript.config.name"),
                        "label-width": _ctx.$i18n.locale == "zh-cn" ? "100px" : "125px",
                        prop: "name"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_input, {
                            modelValue: $data.formData.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.formData.name = $event),
                            disabled: $data.readonlyFunctions.includes($data.formData.name)
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label", "label-width"]),
                      $data.formData.type ? (openBlock(), createBlock(_component_el_form_item, {
                        key: 0,
                        "label-width": "0"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_el_radio_group, {
                            modelValue: $data.formData.type,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $data.formData.type = $event)
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_radio_button, {
                                label: "rule",
                                value: "rule"
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString$1(_ctx.$t("fm.eventscript.config.rules")), 1)
                                ]),
                                _: 1
                              }),
                              createVNode(_component_el_radio_button, {
                                label: "js",
                                value: "js"
                              }, {
                                default: withCtx(() => [
                                  createTextVNode(toDisplayString$1(_ctx.$t("fm.eventscript.config.js")), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })) : createCommentVNode("", true),
                      !$data.formData.type || $data.formData.type == "js" ? (openBlock(), createBlock(_component_el_form_item, {
                        key: 1,
                        "label-width": "0",
                        prop: "func",
                        style: { "margin-bottom": "0px" }
                      }, {
                        default: withCtx(() => [
                          _hoisted_8$c,
                          createVNode(_component_code_editor, {
                            modelValue: $data.formData.func,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $data.formData.func = $event),
                            mode: "javascript",
                            height: $data.formData.type ? "350px" : "400px"
                          }, null, 8, ["modelValue", "height"]),
                          _hoisted_9$b
                        ]),
                        _: 1
                      })) : createCommentVNode("", true),
                      $data.formData.type == "rule" ? (openBlock(), createBlock(_component_event_rule, {
                        key: 2,
                        modelValue: $data.formData.rules,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $data.formData.rules = $event)
                      }, null, 8, ["modelValue"])) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["model", "rules"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })) : createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
var EventScriptIndex = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$L]]);
var dialog_vue_vue_type_style_index_0_lang = "";
const _sfc_main$M = {
  components: {
    CusDialog,
    EventScriptIndex
  },
  emits: ["dialog-close", "dialog-confirm"],
  data: () => ({
    visible: false,
    scriptList: []
  }),
  methods: {
    open(list, eventName, eventKey) {
      this.visible = true;
      if (list) {
        this.scriptList = list;
      }
      this.$nextTick(() => {
        if (!eventKey && eventName) {
          this.$refs.eventScriptIndex.loadNewFunction(eventName);
        }
        if (eventKey && eventName) {
          this.$refs.eventScriptIndex.loadFunction(eventKey, eventName);
        }
      });
    },
    handleClose() {
      this.$emit("dialog-close", this.scriptList);
      this.visible = false;
    },
    handleConfirmEvent(eventObj) {
      this.$emit("dialog-close", this.scriptList);
      this.$emit("dialog-confirm", eventObj);
      this.visible = false;
    }
  }
};
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_event_script_index = resolveComponent("event-script-index");
  const _component_el_container = resolveComponent("el-container");
  const _component_cus_dialog = resolveComponent("cus-dialog");
  return openBlock(), createBlock(_component_cus_dialog, {
    visible: _ctx.visible,
    onOnClose: $options.handleClose,
    ref: "scriptDialog",
    width: "1000px",
    form: "",
    title: _ctx.$t("fm.eventscript.config.title"),
    action: false
  }, {
    default: withCtx(() => [
      createVNode(_component_el_container, {
        style: { "height": "600px" },
        class: "fm-event-panel-dialog-container"
      }, {
        default: withCtx(() => [
          createVNode(_component_event_script_index, {
            modelValue: _ctx.scriptList,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.scriptList = $event),
            ref: "eventScriptIndex",
            onOnConfirmEvent: $options.handleConfirmEvent
          }, null, 8, ["modelValue", "onOnConfirmEvent"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "onOnClose", "title"]);
}
var EventScriptDialog = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["render", _sfc_render$K]]);
const _sfc_main$L = {
  components: {
    CodeDialog,
    DatasourceDialog,
    EventScriptDialog
  },
  props: ["data", "sheets", "formKey"],
  emits: ["on-style-update", "on-datasource-update", "on-eventscript-update", "on-eventscript-confirm", "update:data"],
  data() {
    return {
      customClassArray: this.data && this.data.customClass ? this.data.customClass.split(" ").filter((item) => item) : [],
      dataModel: this.data
    };
  },
  inject: ["isMobile", "useAntdForm"],
  methods: {
    handleSetStyleSheets() {
      let sheets = document.styleSheets[0];
      if (sheets.insertRule) {
        this.$refs.styleDialog.open(this.data.styleSheets || "");
      } else {
        ElMessage({
          message: this.$t("fm.message.notSupport"),
          type: "warning"
        });
      }
    },
    handlestyleSheetsConfirm(value) {
      this.dataModel.styleSheets = value;
      this.$refs.styleDialog.close();
      var arr = splitStyleSheets(value);
      this.$emit("on-style-update", arr);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleSetDatasource() {
      this.dataModel.dataSource = this.data.dataSource || [];
      this.$refs.dataSourceDialog.open(this.data.dataSource);
    },
    handleDataSourceClose(list) {
      this.dataModel.dataSource = list;
      this.$emit("on-datasource-update", list);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleSetScript() {
      this.dataModel.eventScript = this.data.eventScript || [];
      this.$refs.eventScriptDialog.open(this.data.eventScript);
    },
    editScript(eventName, eventKey) {
      this.dataModel.eventScript = this.data.eventScript || [];
      this.$refs.eventScriptDialog.open(this.data.eventScript, eventName, eventKey);
    },
    handleEventScriptClose(list) {
      this.dataModel.eventScript = list;
      this.$emit("on-eventscript-update", list);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleEventConfirm(eventObj) {
      this.$emit("on-eventscript-confirm", eventObj);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    }
  },
  created() {
    if (this.useAntdForm) {
      this.dataModel.ui = "antd";
    } else {
      this.dataModel.ui = "element";
    }
  },
  watch: {
    "data.customClass": function(val) {
      this.customClassArray = this.data && this.data.customClass ? this.data.customClass.split(" ").filter((item) => item) : [];
    },
    customClassArray(val) {
      this.dataModel.customClass = val.join(" ");
    },
    data(val) {
      this.dataModel = val;
    },
    dataModel: {
      deep: true,
      handler(val) {
        this.$emit("update:data", val);
      }
    }
  }
};
const _hoisted_1$u = { class: "form-config-container" };
function _sfc_render$J(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio_button = resolveComponent("el-radio-button");
  const _component_el_radio_group = resolveComponent("el-radio-group");
  const _component_el_form_item = resolveComponent("el-form-item");
  const _component_el_input = resolveComponent("el-input");
  const _component_el_input_number = resolveComponent("el-input-number");
  const _component_el_switch = resolveComponent("el-switch");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  const _component_el_form = resolveComponent("el-form");
  const _component_code_dialog = resolveComponent("code-dialog");
  const _component_datasource_dialog = resolveComponent("datasource-dialog");
  const _component_event_script_dialog = resolveComponent("event-script-dialog");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  return openBlock(), createBlock(_component_el_scrollbar, null, {
    default: withCtx(() => [
      createElementVNode("div", _hoisted_1$u, [
        createVNode(_component_el_form, {
          "label-position": "top",
          size: "default"
        }, {
          default: withCtx(() => [
            createVNode(_component_el_form_item, { label: "UI" }, {
              default: withCtx(() => [
                createVNode(_component_el_radio_group, {
                  modelValue: $data.dataModel.ui,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.dataModel.ui = $event)
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_button, {
                      value: "element",
                      label: "element"
                    }, {
                      default: withCtx(() => [
                        createTextVNode("Element")
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_radio_button, {
                      value: "antd",
                      label: "antd",
                      disabled: !$options.useAntdForm
                    }, {
                      default: withCtx(() => [
                        createTextVNode("Ant Design")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.config.form.width")
            }, {
              default: withCtx(() => [
                createVNode(_component_el_input, {
                  modelValue: $data.dataModel.width,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.dataModel.width = $event),
                  clearable: "",
                  disabled: $options.isMobile()
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.config.form.labelPosition.title")
            }, {
              default: withCtx(() => [
                (openBlock(), createBlock(_component_el_radio_group, {
                  modelValue: $data.dataModel.labelPosition,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.dataModel.labelPosition = $event),
                  key: $props.data.labelPosition
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_button, {
                      value: "left",
                      label: "left"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.form.labelPosition.left")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_radio_button, {
                      value: "right",
                      label: "right"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.form.labelPosition.right")), 1)
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_radio_button, {
                      value: "top",
                      label: "top"
                    }, {
                      default: withCtx(() => [
                        createTextVNode(toDisplayString$1(_ctx.$t("fm.config.form.labelPosition.top")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.config.form.labelWidth")
            }, {
              default: withCtx(() => [
                createVNode(_component_el_input_number, {
                  modelValue: $data.dataModel.labelWidth,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $data.dataModel.labelWidth = $event),
                  min: 0,
                  max: 200,
                  step: 10
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.config.form.labelSuffix")
            }, {
              default: withCtx(() => [
                createVNode(_component_el_switch, {
                  modelValue: $data.dataModel.labelSuffix,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $data.dataModel.labelSuffix = $event)
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.config.form.size")
            }, {
              default: withCtx(() => [
                createVNode(_component_el_radio_group, {
                  modelValue: $data.dataModel.size,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $data.dataModel.size = $event)
                }, {
                  default: withCtx(() => [
                    createVNode(_component_el_radio_button, {
                      value: "large",
                      label: "large"
                    }, {
                      default: withCtx(() => [
                        createTextVNode("Large")
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_radio_button, {
                      value: "default",
                      label: "default"
                    }, {
                      default: withCtx(() => [
                        createTextVNode("Default")
                      ]),
                      _: 1
                    }),
                    createVNode(_component_el_radio_button, {
                      value: "small",
                      label: "small"
                    }, {
                      default: withCtx(() => [
                        createTextVNode("Small")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.config.form.styleSheets")
            }, {
              default: withCtx(() => [
                createVNode(_component_el_button, {
                  style: { "width": "100%" },
                  onClick: $options.handleSetStyleSheets
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.config.form.customClass")
            }, {
              default: withCtx(() => [
                createVNode(_component_el_select, {
                  style: { "width": "100%" },
                  modelValue: $data.customClassArray,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $data.customClassArray = $event),
                  multiple: "",
                  filterable: "",
                  "allow-create": "",
                  "default-first-option": ""
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList($props.sheets, (item) => {
                      return openBlock(), createBlock(_component_el_option, {
                        key: item,
                        label: item,
                        value: item
                      }, null, 8, ["label", "value"]);
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.datasource.name")
            }, {
              default: withCtx(() => [
                createVNode(_component_el_button, {
                  style: { "width": "100%" },
                  onClick: $options.handleSetDatasource
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["label"]),
            createVNode(_component_el_form_item, {
              label: _ctx.$t("fm.eventscript.name")
            }, {
              default: withCtx(() => [
                createVNode(_component_el_button, {
                  style: { "width": "100%" },
                  onClick: $options.handleSetScript
                }, {
                  default: withCtx(() => [
                    createTextVNode(toDisplayString$1(_ctx.$t("fm.config.widget.setting")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        createVNode(_component_code_dialog, {
          ref: "styleDialog",
          mode: "css",
          title: _ctx.$t("fm.config.form.styleSheets"),
          help: "https://form.making.link/docs/manual/custom-style.html#%E8%A1%A8%E5%8D%95%E6%A0%B7%E5%BC%8F%E8%A1%A8",
          onOnConfirm: $options.handlestyleSheetsConfirm
        }, null, 8, ["title", "onOnConfirm"]),
        createVNode(_component_datasource_dialog, {
          ref: "dataSourceDialog",
          onDialogClose: $options.handleDataSourceClose
        }, null, 8, ["onDialogClose"]),
        createVNode(_component_event_script_dialog, {
          ref: "eventScriptDialog",
          onDialogClose: $options.handleEventScriptClose,
          onDialogConfirm: $options.handleEventConfirm
        }, null, 8, ["onDialogClose", "onDialogConfirm"])
      ])
    ]),
    _: 1
  });
}
var FormConfig = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["render", _sfc_render$J]]);
/*!
 * Viewer.js v1.11.6
 * https://fengyuanchen.github.io/viewerjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-09-17T03:16:38.052Z
 */
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _classCallCheck(instance2, Constructor) {
  if (!(instance2 instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props2) {
  for (var i = 0; i < props2.length; i++) {
    var descriptor = props2[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var DEFAULTS = {
  backdrop: true,
  button: true,
  navbar: true,
  title: true,
  toolbar: true,
  className: "",
  container: "body",
  filter: null,
  fullscreen: true,
  inheritedAttributes: ["crossOrigin", "decoding", "isMap", "loading", "referrerPolicy", "sizes", "srcset", "useMap"],
  initialCoverage: 0.9,
  initialViewIndex: 0,
  inline: false,
  interval: 5e3,
  keyboard: true,
  focus: true,
  loading: true,
  loop: true,
  minWidth: 200,
  minHeight: 100,
  movable: true,
  rotatable: true,
  scalable: true,
  zoomable: true,
  zoomOnTouch: true,
  zoomOnWheel: true,
  slideOnTouch: true,
  toggleOnDblclick: true,
  tooltip: true,
  transition: true,
  zIndex: 2015,
  zIndexInline: 0,
  zoomRatio: 0.1,
  minZoomRatio: 0.01,
  maxZoomRatio: 100,
  url: "src",
  ready: null,
  show: null,
  shown: null,
  hide: null,
  hidden: null,
  view: null,
  viewed: null,
  move: null,
  moved: null,
  rotate: null,
  rotated: null,
  scale: null,
  scaled: null,
  zoom: null,
  zoomed: null,
  play: null,
  stop: null
};
var TEMPLATE = '<div class="viewer-container" tabindex="-1" touch-action="none"><div class="viewer-canvas"></div><div class="viewer-footer"><div class="viewer-title"></div><div class="viewer-toolbar"></div><div class="viewer-navbar"><ul class="viewer-list" role="navigation"></ul></div></div><div class="viewer-tooltip" role="alert" aria-hidden="true"></div><div class="viewer-button" data-viewer-action="mix" role="button"></div><div class="viewer-player"></div></div>';
var IS_BROWSER = typeof window !== "undefined" && typeof window.document !== "undefined";
var WINDOW = IS_BROWSER ? window : {};
var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? "ontouchstart" in WINDOW.document.documentElement : false;
var HAS_POINTER_EVENT = IS_BROWSER ? "PointerEvent" in WINDOW : false;
var NAMESPACE = "viewer";
var ACTION_MOVE = "move";
var ACTION_SWITCH = "switch";
var ACTION_ZOOM = "zoom";
var CLASS_ACTIVE = "".concat(NAMESPACE, "-active");
var CLASS_CLOSE = "".concat(NAMESPACE, "-close");
var CLASS_FADE = "".concat(NAMESPACE, "-fade");
var CLASS_FIXED = "".concat(NAMESPACE, "-fixed");
var CLASS_FULLSCREEN = "".concat(NAMESPACE, "-fullscreen");
var CLASS_FULLSCREEN_EXIT = "".concat(NAMESPACE, "-fullscreen-exit");
var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
var CLASS_HIDE_MD_DOWN = "".concat(NAMESPACE, "-hide-md-down");
var CLASS_HIDE_SM_DOWN = "".concat(NAMESPACE, "-hide-sm-down");
var CLASS_HIDE_XS_DOWN = "".concat(NAMESPACE, "-hide-xs-down");
var CLASS_IN = "".concat(NAMESPACE, "-in");
var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
var CLASS_LOADING = "".concat(NAMESPACE, "-loading");
var CLASS_MOVE = "".concat(NAMESPACE, "-move");
var CLASS_OPEN = "".concat(NAMESPACE, "-open");
var CLASS_SHOW = "".concat(NAMESPACE, "-show");
var CLASS_TRANSITION = "".concat(NAMESPACE, "-transition");
var EVENT_CLICK = "click";
var EVENT_DBLCLICK = "dblclick";
var EVENT_DRAG_START = "dragstart";
var EVENT_FOCUSIN = "focusin";
var EVENT_KEY_DOWN = "keydown";
var EVENT_LOAD = "load";
var EVENT_ERROR = "error";
var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? "touchend touchcancel" : "mouseup";
var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? "touchmove" : "mousemove";
var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? "touchstart" : "mousedown";
var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? "pointerdown" : EVENT_TOUCH_START;
var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? "pointermove" : EVENT_TOUCH_MOVE;
var EVENT_POINTER_UP = HAS_POINTER_EVENT ? "pointerup pointercancel" : EVENT_TOUCH_END;
var EVENT_RESIZE = "resize";
var EVENT_TRANSITION_END = "transitionend";
var EVENT_WHEEL = "wheel";
var EVENT_READY = "ready";
var EVENT_SHOW = "show";
var EVENT_SHOWN = "shown";
var EVENT_HIDE = "hide";
var EVENT_HIDDEN = "hidden";
var EVENT_VIEW = "view";
var EVENT_VIEWED = "viewed";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_ROTATE = "rotate";
var EVENT_ROTATED = "rotated";
var EVENT_SCALE = "scale";
var EVENT_SCALED = "scaled";
var EVENT_ZOOM = "zoom";
var EVENT_ZOOMED = "zoomed";
var EVENT_PLAY = "play";
var EVENT_STOP = "stop";
var DATA_ACTION = "".concat(NAMESPACE, "Action");
var REGEXP_SPACES = /\s\s*/;
var BUTTONS = ["zoom-in", "zoom-out", "one-to-one", "reset", "prev", "play", "next", "rotate-left", "rotate-right", "flip-horizontal", "flip-vertical"];
function isString(value) {
  return typeof value === "string";
}
var isNaN$1 = Number.isNaN || WINDOW.isNaN;
function isNumber(value) {
  return typeof value === "number" && !isNaN$1(value);
}
function isUndefined(value) {
  return typeof value === "undefined";
}
function isObject(value) {
  return _typeof(value) === "object" && value !== null;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isPlainObject(value) {
  if (!isObject(value)) {
    return false;
  }
  try {
    var _constructor = value.constructor;
    var prototype = _constructor.prototype;
    return _constructor && prototype && hasOwnProperty.call(prototype, "isPrototypeOf");
  } catch (error) {
    return false;
  }
}
function isFunction(value) {
  return typeof value === "function";
}
function forEach(data2, callback) {
  if (data2 && isFunction(callback)) {
    if (Array.isArray(data2) || isNumber(data2.length)) {
      var length = data2.length;
      var i;
      for (i = 0; i < length; i += 1) {
        if (callback.call(data2, data2[i], i, data2) === false) {
          break;
        }
      }
    } else if (isObject(data2)) {
      Object.keys(data2).forEach(function(key) {
        callback.call(data2, data2[key], key, data2);
      });
    }
  }
  return data2;
}
var assign = Object.assign || function assign2(obj) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (isObject(obj) && args.length > 0) {
    args.forEach(function(arg) {
      if (isObject(arg)) {
        Object.keys(arg).forEach(function(key) {
          obj[key] = arg[key];
        });
      }
    });
  }
  return obj;
};
var REGEXP_SUFFIX = /^(?:width|height|left|top|marginLeft|marginTop)$/;
function setStyle(element, styles) {
  var style = element.style;
  forEach(styles, function(value, property) {
    if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
      value += "px";
    }
    style[property] = value;
  });
}
function escapeHTMLEntities(value) {
  return isString(value) ? value.replace(/&(?!amp;|quot;|#39;|lt;|gt;)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;") : value;
}
function hasClass(element, value) {
  if (!element || !value) {
    return false;
  }
  return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
}
function addClass(element, value) {
  if (!element || !value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      addClass(elem, value);
    });
    return;
  }
  if (element.classList) {
    element.classList.add(value);
    return;
  }
  var className = element.className.trim();
  if (!className) {
    element.className = value;
  } else if (className.indexOf(value) < 0) {
    element.className = "".concat(className, " ").concat(value);
  }
}
function removeClass(element, value) {
  if (!element || !value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      removeClass(elem, value);
    });
    return;
  }
  if (element.classList) {
    element.classList.remove(value);
    return;
  }
  if (element.className.indexOf(value) >= 0) {
    element.className = element.className.replace(value, "");
  }
}
function toggleClass(element, value, added) {
  if (!value) {
    return;
  }
  if (isNumber(element.length)) {
    forEach(element, function(elem) {
      toggleClass(elem, value, added);
    });
    return;
  }
  if (added) {
    addClass(element, value);
  } else {
    removeClass(element, value);
  }
}
var REGEXP_HYPHENATE = /([a-z\d])([A-Z])/g;
function hyphenate(value) {
  return value.replace(REGEXP_HYPHENATE, "$1-$2").toLowerCase();
}
function getData(element, name) {
  if (isObject(element[name])) {
    return element[name];
  }
  if (element.dataset) {
    return element.dataset[name];
  }
  return element.getAttribute("data-".concat(hyphenate(name)));
}
function setData(element, name, data2) {
  if (isObject(data2)) {
    element[name] = data2;
  } else if (element.dataset) {
    element.dataset[name] = data2;
  } else {
    element.setAttribute("data-".concat(hyphenate(name)), data2);
  }
}
var onceSupported = function() {
  var supported = false;
  if (IS_BROWSER) {
    var once = false;
    var listener = function listener2() {
    };
    var options = Object.defineProperty({}, "once", {
      get: function get() {
        supported = true;
        return once;
      },
      set: function set(value) {
        once = value;
      }
    });
    WINDOW.addEventListener("test", listener, options);
    WINDOW.removeEventListener("test", listener, options);
  }
  return supported;
}();
function removeListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function(event) {
    if (!onceSupported) {
      var listeners = element.listeners;
      if (listeners && listeners[event] && listeners[event][listener]) {
        handler = listeners[event][listener];
        delete listeners[event][listener];
        if (Object.keys(listeners[event]).length === 0) {
          delete listeners[event];
        }
        if (Object.keys(listeners).length === 0) {
          delete element.listeners;
        }
      }
    }
    element.removeEventListener(event, handler, options);
  });
}
function addListener(element, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var _handler = listener;
  type.trim().split(REGEXP_SPACES).forEach(function(event) {
    if (options.once && !onceSupported) {
      var _element$listeners = element.listeners, listeners = _element$listeners === void 0 ? {} : _element$listeners;
      _handler = function handler() {
        delete listeners[event][listener];
        element.removeEventListener(event, _handler, options);
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        listener.apply(element, args);
      };
      if (!listeners[event]) {
        listeners[event] = {};
      }
      if (listeners[event][listener]) {
        element.removeEventListener(event, listeners[event][listener], options);
      }
      listeners[event][listener] = _handler;
      element.listeners = listeners;
    }
    element.addEventListener(event, _handler, options);
  });
}
function dispatchEvent(element, type, data2, options) {
  var event;
  if (isFunction(Event) && isFunction(CustomEvent)) {
    event = new CustomEvent(type, _objectSpread2({
      bubbles: true,
      cancelable: true,
      detail: data2
    }, options));
  } else {
    event = document.createEvent("CustomEvent");
    event.initCustomEvent(type, true, true, data2);
  }
  return element.dispatchEvent(event);
}
function getOffset(element) {
  var box = element.getBoundingClientRect();
  return {
    left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: box.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
function getTransforms(_ref) {
  var rotate2 = _ref.rotate, scaleX2 = _ref.scaleX, scaleY2 = _ref.scaleY, translateX = _ref.translateX, translateY = _ref.translateY;
  var values = [];
  if (isNumber(translateX) && translateX !== 0) {
    values.push("translateX(".concat(translateX, "px)"));
  }
  if (isNumber(translateY) && translateY !== 0) {
    values.push("translateY(".concat(translateY, "px)"));
  }
  if (isNumber(rotate2) && rotate2 !== 0) {
    values.push("rotate(".concat(rotate2, "deg)"));
  }
  if (isNumber(scaleX2) && scaleX2 !== 1) {
    values.push("scaleX(".concat(scaleX2, ")"));
  }
  if (isNumber(scaleY2) && scaleY2 !== 1) {
    values.push("scaleY(".concat(scaleY2, ")"));
  }
  var transform2 = values.length ? values.join(" ") : "none";
  return {
    WebkitTransform: transform2,
    msTransform: transform2,
    transform: transform2
  };
}
function getImageNameFromURL(url) {
  return isString(url) ? decodeURIComponent(url.replace(/^.*\//, "").replace(/[?&#].*$/, "")) : "";
}
var IS_SAFARI = WINDOW.navigator && /Version\/\d+(\.\d+)+?\s+Safari/i.test(WINDOW.navigator.userAgent);
function getImageNaturalSizes(image, options, callback) {
  var newImage = document.createElement("img");
  if (image.naturalWidth && !IS_SAFARI) {
    callback(image.naturalWidth, image.naturalHeight);
    return newImage;
  }
  var body = document.body || document.documentElement;
  newImage.onload = function() {
    callback(newImage.width, newImage.height);
    if (!IS_SAFARI) {
      body.removeChild(newImage);
    }
  };
  forEach(options.inheritedAttributes, function(name) {
    var value = image.getAttribute(name);
    if (value !== null) {
      newImage.setAttribute(name, value);
    }
  });
  newImage.src = image.src;
  if (!IS_SAFARI) {
    newImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;";
    body.appendChild(newImage);
  }
  return newImage;
}
function getResponsiveClass(type) {
  switch (type) {
    case 2:
      return CLASS_HIDE_XS_DOWN;
    case 3:
      return CLASS_HIDE_SM_DOWN;
    case 4:
      return CLASS_HIDE_MD_DOWN;
    default:
      return "";
  }
}
function getMaxZoomRatio(pointers) {
  var pointers2 = _objectSpread2({}, pointers);
  var ratios = [];
  forEach(pointers, function(pointer, pointerId) {
    delete pointers2[pointerId];
    forEach(pointers2, function(pointer2) {
      var x1 = Math.abs(pointer.startX - pointer2.startX);
      var y1 = Math.abs(pointer.startY - pointer2.startY);
      var x2 = Math.abs(pointer.endX - pointer2.endX);
      var y2 = Math.abs(pointer.endY - pointer2.endY);
      var z1 = Math.sqrt(x1 * x1 + y1 * y1);
      var z2 = Math.sqrt(x2 * x2 + y2 * y2);
      var ratio = (z2 - z1) / z1;
      ratios.push(ratio);
    });
  });
  ratios.sort(function(a, b) {
    return Math.abs(a) < Math.abs(b);
  });
  return ratios[0];
}
function getPointer(_ref2, endOnly) {
  var pageX = _ref2.pageX, pageY = _ref2.pageY;
  var end = {
    endX: pageX,
    endY: pageY
  };
  return endOnly ? end : _objectSpread2({
    timeStamp: Date.now(),
    startX: pageX,
    startY: pageY
  }, end);
}
function getPointersCenter(pointers) {
  var pageX = 0;
  var pageY = 0;
  var count = 0;
  forEach(pointers, function(_ref3) {
    var startX = _ref3.startX, startY = _ref3.startY;
    pageX += startX;
    pageY += startY;
    count += 1;
  });
  pageX /= count;
  pageY /= count;
  return {
    pageX,
    pageY
  };
}
var render = {
  render: function render2() {
    this.initContainer();
    this.initViewer();
    this.initList();
    this.renderViewer();
  },
  initBody: function initBody() {
    var ownerDocument = this.element.ownerDocument;
    var body = ownerDocument.body || ownerDocument.documentElement;
    this.body = body;
    this.scrollbarWidth = window.innerWidth - ownerDocument.documentElement.clientWidth;
    this.initialBodyPaddingRight = body.style.paddingRight;
    this.initialBodyComputedPaddingRight = window.getComputedStyle(body).paddingRight;
  },
  initContainer: function initContainer() {
    this.containerData = {
      width: window.innerWidth,
      height: window.innerHeight
    };
  },
  initViewer: function initViewer() {
    var options = this.options, parent = this.parent;
    var viewerData;
    if (options.inline) {
      viewerData = {
        width: Math.max(parent.offsetWidth, options.minWidth),
        height: Math.max(parent.offsetHeight, options.minHeight)
      };
      this.parentData = viewerData;
    }
    if (this.fulled || !viewerData) {
      viewerData = this.containerData;
    }
    this.viewerData = assign({}, viewerData);
  },
  renderViewer: function renderViewer() {
    if (this.options.inline && !this.fulled) {
      setStyle(this.viewer, this.viewerData);
    }
  },
  initList: function initList() {
    var _this = this;
    var element = this.element, options = this.options, list = this.list;
    var items = [];
    list.innerHTML = "";
    forEach(this.images, function(image, index2) {
      var src = image.src;
      var alt = image.alt || getImageNameFromURL(src);
      var url = _this.getImageURL(image);
      if (src || url) {
        var item = document.createElement("li");
        var img = document.createElement("img");
        forEach(options.inheritedAttributes, function(name) {
          var value = image.getAttribute(name);
          if (value !== null) {
            img.setAttribute(name, value);
          }
        });
        if (options.navbar) {
          img.src = src || url;
        }
        img.alt = alt;
        img.setAttribute("data-original-url", url || src);
        item.setAttribute("data-index", index2);
        item.setAttribute("data-viewer-action", "view");
        item.setAttribute("role", "button");
        if (options.keyboard) {
          item.setAttribute("tabindex", 0);
        }
        item.appendChild(img);
        list.appendChild(item);
        items.push(item);
      }
    });
    this.items = items;
    forEach(items, function(item) {
      var image = item.firstElementChild;
      var onLoad;
      var onError;
      setData(image, "filled", true);
      if (options.loading) {
        addClass(item, CLASS_LOADING);
      }
      addListener(image, EVENT_LOAD, onLoad = function onLoad2(event) {
        removeListener(image, EVENT_ERROR, onError);
        if (options.loading) {
          removeClass(item, CLASS_LOADING);
        }
        _this.loadImage(event);
      }, {
        once: true
      });
      addListener(image, EVENT_ERROR, onError = function onError2() {
        removeListener(image, EVENT_LOAD, onLoad);
        if (options.loading) {
          removeClass(item, CLASS_LOADING);
        }
      }, {
        once: true
      });
    });
    if (options.transition) {
      addListener(element, EVENT_VIEWED, function() {
        addClass(list, CLASS_TRANSITION);
      }, {
        once: true
      });
    }
  },
  renderList: function renderList2() {
    var index2 = this.index;
    var item = this.items[index2];
    if (!item) {
      return;
    }
    var next2 = item.nextElementSibling;
    var gutter = parseInt(window.getComputedStyle(next2 || item).marginLeft, 10);
    var offsetWidth = item.offsetWidth;
    var outerWidth = offsetWidth + gutter;
    setStyle(this.list, assign({
      width: outerWidth * this.length - gutter
    }, getTransforms({
      translateX: (this.viewerData.width - offsetWidth) / 2 - outerWidth * index2
    })));
  },
  resetList: function resetList() {
    var list = this.list;
    list.innerHTML = "";
    removeClass(list, CLASS_TRANSITION);
    setStyle(list, getTransforms({
      translateX: 0
    }));
  },
  initImage: function initImage(done) {
    var _this2 = this;
    var options = this.options, image = this.image, viewerData = this.viewerData;
    var footerHeight = this.footer.offsetHeight;
    var viewerWidth = viewerData.width;
    var viewerHeight = Math.max(viewerData.height - footerHeight, footerHeight);
    var oldImageData = this.imageData || {};
    var sizingImage;
    this.imageInitializing = {
      abort: function abort() {
        sizingImage.onload = null;
      }
    };
    sizingImage = getImageNaturalSizes(image, options, function(naturalWidth, naturalHeight) {
      var aspectRatio = naturalWidth / naturalHeight;
      var initialCoverage = Math.max(0, Math.min(1, options.initialCoverage));
      var width = viewerWidth;
      var height = viewerHeight;
      _this2.imageInitializing = false;
      if (viewerHeight * aspectRatio > viewerWidth) {
        height = viewerWidth / aspectRatio;
      } else {
        width = viewerHeight * aspectRatio;
      }
      initialCoverage = isNumber(initialCoverage) ? initialCoverage : 0.9;
      width = Math.min(width * initialCoverage, naturalWidth);
      height = Math.min(height * initialCoverage, naturalHeight);
      var left = (viewerWidth - width) / 2;
      var top = (viewerHeight - height) / 2;
      var imageData = {
        left,
        top,
        x: left,
        y: top,
        width,
        height,
        oldRatio: 1,
        ratio: width / naturalWidth,
        aspectRatio,
        naturalWidth,
        naturalHeight
      };
      var initialImageData = assign({}, imageData);
      if (options.rotatable) {
        imageData.rotate = oldImageData.rotate || 0;
        initialImageData.rotate = 0;
      }
      if (options.scalable) {
        imageData.scaleX = oldImageData.scaleX || 1;
        imageData.scaleY = oldImageData.scaleY || 1;
        initialImageData.scaleX = 1;
        initialImageData.scaleY = 1;
      }
      _this2.imageData = imageData;
      _this2.initialImageData = initialImageData;
      if (done) {
        done();
      }
    });
  },
  renderImage: function renderImage(done) {
    var _this3 = this;
    var image = this.image, imageData = this.imageData;
    setStyle(image, assign({
      width: imageData.width,
      height: imageData.height,
      marginLeft: imageData.x,
      marginTop: imageData.y
    }, getTransforms(imageData)));
    if (done) {
      if ((this.viewing || this.moving || this.rotating || this.scaling || this.zooming) && this.options.transition && hasClass(image, CLASS_TRANSITION)) {
        var onTransitionEnd = function onTransitionEnd2() {
          _this3.imageRendering = false;
          done();
        };
        this.imageRendering = {
          abort: function abort() {
            removeListener(image, EVENT_TRANSITION_END, onTransitionEnd);
          }
        };
        addListener(image, EVENT_TRANSITION_END, onTransitionEnd, {
          once: true
        });
      } else {
        done();
      }
    }
  },
  resetImage: function resetImage() {
    var image = this.image;
    if (image) {
      if (this.viewing) {
        this.viewing.abort();
      }
      image.parentNode.removeChild(image);
      this.image = null;
      this.title.innerHTML = "";
    }
  }
};
var events = {
  bind: function bind3() {
    var options = this.options, viewer2 = this.viewer, canvas = this.canvas;
    var document2 = this.element.ownerDocument;
    addListener(viewer2, EVENT_CLICK, this.onClick = this.click.bind(this));
    addListener(viewer2, EVENT_DRAG_START, this.onDragStart = this.dragstart.bind(this));
    addListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown = this.pointerdown.bind(this));
    addListener(document2, EVENT_POINTER_MOVE, this.onPointerMove = this.pointermove.bind(this));
    addListener(document2, EVENT_POINTER_UP, this.onPointerUp = this.pointerup.bind(this));
    addListener(document2, EVENT_KEY_DOWN, this.onKeyDown = this.keydown.bind(this));
    addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
    if (options.zoomable && options.zoomOnWheel) {
      addListener(viewer2, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
        passive: false,
        capture: true
      });
    }
    if (options.toggleOnDblclick) {
      addListener(canvas, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
    }
  },
  unbind: function unbind() {
    var options = this.options, viewer2 = this.viewer, canvas = this.canvas;
    var document2 = this.element.ownerDocument;
    removeListener(viewer2, EVENT_CLICK, this.onClick);
    removeListener(viewer2, EVENT_DRAG_START, this.onDragStart);
    removeListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown);
    removeListener(document2, EVENT_POINTER_MOVE, this.onPointerMove);
    removeListener(document2, EVENT_POINTER_UP, this.onPointerUp);
    removeListener(document2, EVENT_KEY_DOWN, this.onKeyDown);
    removeListener(window, EVENT_RESIZE, this.onResize);
    if (options.zoomable && options.zoomOnWheel) {
      removeListener(viewer2, EVENT_WHEEL, this.onWheel, {
        passive: false,
        capture: true
      });
    }
    if (options.toggleOnDblclick) {
      removeListener(canvas, EVENT_DBLCLICK, this.onDblclick);
    }
  }
};
var handlers = {
  click: function click(event) {
    var options = this.options, imageData = this.imageData;
    var target = event.target;
    var action = getData(target, DATA_ACTION);
    if (!action && target.localName === "img" && target.parentElement.localName === "li") {
      target = target.parentElement;
      action = getData(target, DATA_ACTION);
    }
    if (IS_TOUCH_DEVICE && event.isTrusted && target === this.canvas) {
      clearTimeout(this.clickCanvasTimeout);
    }
    switch (action) {
      case "mix":
        if (this.played) {
          this.stop();
        } else if (options.inline) {
          if (this.fulled) {
            this.exit();
          } else {
            this.full();
          }
        } else {
          this.hide();
        }
        break;
      case "hide":
        if (!this.pointerMoved) {
          this.hide();
        }
        break;
      case "view":
        this.view(getData(target, "index"));
        break;
      case "zoom-in":
        this.zoom(0.1, true);
        break;
      case "zoom-out":
        this.zoom(-0.1, true);
        break;
      case "one-to-one":
        this.toggle();
        break;
      case "reset":
        this.reset();
        break;
      case "prev":
        this.prev(options.loop);
        break;
      case "play":
        this.play(options.fullscreen);
        break;
      case "next":
        this.next(options.loop);
        break;
      case "rotate-left":
        this.rotate(-90);
        break;
      case "rotate-right":
        this.rotate(90);
        break;
      case "flip-horizontal":
        this.scaleX(-imageData.scaleX || -1);
        break;
      case "flip-vertical":
        this.scaleY(-imageData.scaleY || -1);
        break;
      default:
        if (this.played) {
          this.stop();
        }
    }
  },
  dblclick: function dblclick(event) {
    event.preventDefault();
    if (this.viewed && event.target === this.image) {
      if (IS_TOUCH_DEVICE && event.isTrusted) {
        clearTimeout(this.doubleClickImageTimeout);
      }
      this.toggle(event.isTrusted ? event : event.detail && event.detail.originalEvent);
    }
  },
  load: function load() {
    var _this = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = false;
    }
    var element = this.element, options = this.options, image = this.image, index2 = this.index, viewerData = this.viewerData;
    removeClass(image, CLASS_INVISIBLE);
    if (options.loading) {
      removeClass(this.canvas, CLASS_LOADING);
    }
    image.style.cssText = "height:0;" + "margin-left:".concat(viewerData.width / 2, "px;") + "margin-top:".concat(viewerData.height / 2, "px;") + "max-width:none!important;position:relative;width:0;";
    this.initImage(function() {
      toggleClass(image, CLASS_MOVE, options.movable);
      toggleClass(image, CLASS_TRANSITION, options.transition);
      _this.renderImage(function() {
        _this.viewed = true;
        _this.viewing = false;
        if (isFunction(options.viewed)) {
          addListener(element, EVENT_VIEWED, options.viewed, {
            once: true
          });
        }
        dispatchEvent(element, EVENT_VIEWED, {
          originalImage: _this.images[index2],
          index: index2,
          image
        }, {
          cancelable: false
        });
      });
    });
  },
  loadImage: function loadImage(event) {
    var image = event.target;
    var parent = image.parentNode;
    var parentWidth = parent.offsetWidth || 30;
    var parentHeight = parent.offsetHeight || 50;
    var filled = !!getData(image, "filled");
    getImageNaturalSizes(image, this.options, function(naturalWidth, naturalHeight) {
      var aspectRatio = naturalWidth / naturalHeight;
      var width = parentWidth;
      var height = parentHeight;
      if (parentHeight * aspectRatio > parentWidth) {
        if (filled) {
          width = parentHeight * aspectRatio;
        } else {
          height = parentWidth / aspectRatio;
        }
      } else if (filled) {
        height = parentWidth / aspectRatio;
      } else {
        width = parentHeight * aspectRatio;
      }
      setStyle(image, assign({
        width,
        height
      }, getTransforms({
        translateX: (parentWidth - width) / 2,
        translateY: (parentHeight - height) / 2
      })));
    });
  },
  keydown: function keydown(event) {
    var options = this.options;
    if (!options.keyboard) {
      return;
    }
    var keyCode = event.keyCode || event.which || event.charCode;
    switch (keyCode) {
      case 13:
        if (this.viewer.contains(event.target)) {
          this.click(event);
        }
        break;
    }
    if (!this.fulled) {
      return;
    }
    switch (keyCode) {
      case 27:
        if (this.played) {
          this.stop();
        } else if (options.inline) {
          if (this.fulled) {
            this.exit();
          }
        } else {
          this.hide();
        }
        break;
      case 32:
        if (this.played) {
          this.stop();
        }
        break;
      case 37:
        if (this.played && this.playing) {
          this.playing.prev();
        } else {
          this.prev(options.loop);
        }
        break;
      case 38:
        event.preventDefault();
        this.zoom(options.zoomRatio, true);
        break;
      case 39:
        if (this.played && this.playing) {
          this.playing.next();
        } else {
          this.next(options.loop);
        }
        break;
      case 40:
        event.preventDefault();
        this.zoom(-options.zoomRatio, true);
        break;
      case 48:
      case 49:
        if (event.ctrlKey) {
          event.preventDefault();
          this.toggle();
        }
        break;
    }
  },
  dragstart: function dragstart(event) {
    if (event.target.localName === "img") {
      event.preventDefault();
    }
  },
  pointerdown: function pointerdown(event) {
    var options = this.options, pointers = this.pointers;
    var buttons = event.buttons, button = event.button;
    this.pointerMoved = false;
    if (!this.viewed || this.showing || this.viewing || this.hiding || (event.type === "mousedown" || event.type === "pointerdown" && event.pointerType === "mouse") && (isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 || event.ctrlKey)) {
      return;
    }
    event.preventDefault();
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        pointers[touch.identifier] = getPointer(touch);
      });
    } else {
      pointers[event.pointerId || 0] = getPointer(event);
    }
    var action = options.movable ? ACTION_MOVE : false;
    if (options.zoomOnTouch && options.zoomable && Object.keys(pointers).length > 1) {
      action = ACTION_ZOOM;
    } else if (options.slideOnTouch && (event.pointerType === "touch" || event.type === "touchstart") && this.isSwitchable()) {
      action = ACTION_SWITCH;
    }
    if (options.transition && (action === ACTION_MOVE || action === ACTION_ZOOM)) {
      removeClass(this.image, CLASS_TRANSITION);
    }
    this.action = action;
  },
  pointermove: function pointermove(event) {
    var pointers = this.pointers, action = this.action;
    if (!this.viewed || !action) {
      return;
    }
    event.preventDefault();
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        assign(pointers[touch.identifier] || {}, getPointer(touch, true));
      });
    } else {
      assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
    }
    this.change(event);
  },
  pointerup: function pointerup(event) {
    var _this2 = this;
    var options = this.options, action = this.action, pointers = this.pointers;
    var pointer;
    if (event.changedTouches) {
      forEach(event.changedTouches, function(touch) {
        pointer = pointers[touch.identifier];
        delete pointers[touch.identifier];
      });
    } else {
      pointer = pointers[event.pointerId || 0];
      delete pointers[event.pointerId || 0];
    }
    if (!action) {
      return;
    }
    event.preventDefault();
    if (options.transition && (action === ACTION_MOVE || action === ACTION_ZOOM)) {
      addClass(this.image, CLASS_TRANSITION);
    }
    this.action = false;
    if (IS_TOUCH_DEVICE && action !== ACTION_ZOOM && pointer && Date.now() - pointer.timeStamp < 500) {
      clearTimeout(this.clickCanvasTimeout);
      clearTimeout(this.doubleClickImageTimeout);
      if (options.toggleOnDblclick && this.viewed && event.target === this.image) {
        if (this.imageClicked) {
          this.imageClicked = false;
          this.doubleClickImageTimeout = setTimeout(function() {
            dispatchEvent(_this2.image, EVENT_DBLCLICK, {
              originalEvent: event
            });
          }, 50);
        } else {
          this.imageClicked = true;
          this.doubleClickImageTimeout = setTimeout(function() {
            _this2.imageClicked = false;
          }, 500);
        }
      } else {
        this.imageClicked = false;
        if (options.backdrop && options.backdrop !== "static" && event.target === this.canvas) {
          this.clickCanvasTimeout = setTimeout(function() {
            dispatchEvent(_this2.canvas, EVENT_CLICK, {
              originalEvent: event
            });
          }, 50);
        }
      }
    }
  },
  resize: function resize() {
    var _this3 = this;
    if (!this.isShown || this.hiding) {
      return;
    }
    if (this.fulled) {
      this.close();
      this.initBody();
      this.open();
    }
    this.initContainer();
    this.initViewer();
    this.renderViewer();
    this.renderList();
    if (this.viewed) {
      this.initImage(function() {
        _this3.renderImage();
      });
    }
    if (this.played) {
      if (this.options.fullscreen && this.fulled && !(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
        this.stop();
        return;
      }
      forEach(this.player.getElementsByTagName("img"), function(image) {
        addListener(image, EVENT_LOAD, _this3.loadImage.bind(_this3), {
          once: true
        });
        dispatchEvent(image, EVENT_LOAD);
      });
    }
  },
  wheel: function wheel(event) {
    var _this4 = this;
    if (!this.viewed) {
      return;
    }
    event.preventDefault();
    if (this.wheeling) {
      return;
    }
    this.wheeling = true;
    setTimeout(function() {
      _this4.wheeling = false;
    }, 50);
    var ratio = Number(this.options.zoomRatio) || 0.1;
    var delta = 1;
    if (event.deltaY) {
      delta = event.deltaY > 0 ? 1 : -1;
    } else if (event.wheelDelta) {
      delta = -event.wheelDelta / 120;
    } else if (event.detail) {
      delta = event.detail > 0 ? 1 : -1;
    }
    this.zoom(-delta * ratio, true, null, event);
  }
};
var methods = {
  show: function show() {
    var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var element = this.element, options = this.options;
    if (options.inline || this.showing || this.isShown || this.showing) {
      return this;
    }
    if (!this.ready) {
      this.build();
      if (this.ready) {
        this.show(immediate);
      }
      return this;
    }
    if (isFunction(options.show)) {
      addListener(element, EVENT_SHOW, options.show, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_SHOW) === false || !this.ready) {
      return this;
    }
    if (this.hiding) {
      this.transitioning.abort();
    }
    this.showing = true;
    this.open();
    var viewer2 = this.viewer;
    removeClass(viewer2, CLASS_HIDE);
    viewer2.setAttribute("role", "dialog");
    viewer2.setAttribute("aria-labelledby", this.title.id);
    viewer2.setAttribute("aria-modal", true);
    viewer2.removeAttribute("aria-hidden");
    if (options.transition && !immediate) {
      var shown2 = this.shown.bind(this);
      this.transitioning = {
        abort: function abort() {
          removeListener(viewer2, EVENT_TRANSITION_END, shown2);
          removeClass(viewer2, CLASS_IN);
        }
      };
      addClass(viewer2, CLASS_TRANSITION);
      viewer2.initialOffsetWidth = viewer2.offsetWidth;
      addListener(viewer2, EVENT_TRANSITION_END, shown2, {
        once: true
      });
      addClass(viewer2, CLASS_IN);
    } else {
      addClass(viewer2, CLASS_IN);
      this.shown();
    }
    return this;
  },
  hide: function hide() {
    var _this = this;
    var immediate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var element = this.element, options = this.options;
    if (options.inline || this.hiding || !(this.isShown || this.showing)) {
      return this;
    }
    if (isFunction(options.hide)) {
      addListener(element, EVENT_HIDE, options.hide, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_HIDE) === false) {
      return this;
    }
    if (this.showing) {
      this.transitioning.abort();
    }
    this.hiding = true;
    if (this.played) {
      this.stop();
    } else if (this.viewing) {
      this.viewing.abort();
    }
    var viewer2 = this.viewer, image = this.image;
    var hideImmediately = function hideImmediately2() {
      removeClass(viewer2, CLASS_IN);
      _this.hidden();
    };
    if (options.transition && !immediate) {
      var onViewerTransitionEnd = function onViewerTransitionEnd2(event) {
        if (event && event.target === viewer2) {
          removeListener(viewer2, EVENT_TRANSITION_END, onViewerTransitionEnd2);
          _this.hidden();
        }
      };
      var onImageTransitionEnd = function onImageTransitionEnd2() {
        if (hasClass(viewer2, CLASS_TRANSITION)) {
          addListener(viewer2, EVENT_TRANSITION_END, onViewerTransitionEnd);
          removeClass(viewer2, CLASS_IN);
        } else {
          hideImmediately();
        }
      };
      this.transitioning = {
        abort: function abort() {
          if (_this.viewed && hasClass(image, CLASS_TRANSITION)) {
            removeListener(image, EVENT_TRANSITION_END, onImageTransitionEnd);
          } else if (hasClass(viewer2, CLASS_TRANSITION)) {
            removeListener(viewer2, EVENT_TRANSITION_END, onViewerTransitionEnd);
          }
        }
      };
      if (this.viewed && hasClass(image, CLASS_TRANSITION)) {
        addListener(image, EVENT_TRANSITION_END, onImageTransitionEnd, {
          once: true
        });
        this.zoomTo(0, false, null, null, true);
      } else {
        onImageTransitionEnd();
      }
    } else {
      hideImmediately();
    }
    return this;
  },
  view: function view() {
    var _this2 = this;
    var index2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.options.initialViewIndex;
    index2 = Number(index2) || 0;
    if (this.hiding || this.played || index2 < 0 || index2 >= this.length || this.viewed && index2 === this.index) {
      return this;
    }
    if (!this.isShown) {
      this.index = index2;
      return this.show();
    }
    if (this.viewing) {
      this.viewing.abort();
    }
    var element = this.element, options = this.options, title = this.title, canvas = this.canvas;
    var item = this.items[index2];
    var img = item.querySelector("img");
    var url = getData(img, "originalUrl");
    var alt = img.getAttribute("alt");
    var image = document.createElement("img");
    forEach(options.inheritedAttributes, function(name) {
      var value = img.getAttribute(name);
      if (value !== null) {
        image.setAttribute(name, value);
      }
    });
    image.src = url;
    image.alt = alt;
    if (isFunction(options.view)) {
      addListener(element, EVENT_VIEW, options.view, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_VIEW, {
      originalImage: this.images[index2],
      index: index2,
      image
    }) === false || !this.isShown || this.hiding || this.played) {
      return this;
    }
    var activeItem = this.items[this.index];
    if (activeItem) {
      removeClass(activeItem, CLASS_ACTIVE);
      activeItem.removeAttribute("aria-selected");
    }
    addClass(item, CLASS_ACTIVE);
    item.setAttribute("aria-selected", true);
    if (options.focus) {
      item.focus();
    }
    this.image = image;
    this.viewed = false;
    this.index = index2;
    this.imageData = {};
    addClass(image, CLASS_INVISIBLE);
    if (options.loading) {
      addClass(canvas, CLASS_LOADING);
    }
    canvas.innerHTML = "";
    canvas.appendChild(image);
    this.renderList();
    title.innerHTML = "";
    var onViewed = function onViewed2() {
      var imageData = _this2.imageData;
      var render3 = Array.isArray(options.title) ? options.title[1] : options.title;
      title.innerHTML = escapeHTMLEntities(isFunction(render3) ? render3.call(_this2, image, imageData) : "".concat(alt, " (").concat(imageData.naturalWidth, " \xD7 ").concat(imageData.naturalHeight, ")"));
    };
    var onLoad;
    var onError;
    addListener(element, EVENT_VIEWED, onViewed, {
      once: true
    });
    this.viewing = {
      abort: function abort() {
        removeListener(element, EVENT_VIEWED, onViewed);
        if (image.complete) {
          if (_this2.imageRendering) {
            _this2.imageRendering.abort();
          } else if (_this2.imageInitializing) {
            _this2.imageInitializing.abort();
          }
        } else {
          image.src = "";
          removeListener(image, EVENT_LOAD, onLoad);
          if (_this2.timeout) {
            clearTimeout(_this2.timeout);
          }
        }
      }
    };
    if (image.complete) {
      this.load();
    } else {
      addListener(image, EVENT_LOAD, onLoad = function onLoad2() {
        removeListener(image, EVENT_ERROR, onError);
        _this2.load();
      }, {
        once: true
      });
      addListener(image, EVENT_ERROR, onError = function onError2() {
        removeListener(image, EVENT_LOAD, onLoad);
        if (_this2.timeout) {
          clearTimeout(_this2.timeout);
          _this2.timeout = false;
        }
        removeClass(image, CLASS_INVISIBLE);
        if (options.loading) {
          removeClass(_this2.canvas, CLASS_LOADING);
        }
      }, {
        once: true
      });
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(function() {
        removeClass(image, CLASS_INVISIBLE);
        _this2.timeout = false;
      }, 1e3);
    }
    return this;
  },
  prev: function prev() {
    var loop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var index2 = this.index - 1;
    if (index2 < 0) {
      index2 = loop ? this.length - 1 : 0;
    }
    this.view(index2);
    return this;
  },
  next: function next() {
    var loop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var maxIndex = this.length - 1;
    var index2 = this.index + 1;
    if (index2 > maxIndex) {
      index2 = loop ? 0 : maxIndex;
    }
    this.view(index2);
    return this;
  },
  move: function move(x) {
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x;
    var imageData = this.imageData;
    this.moveTo(isUndefined(x) ? x : imageData.x + Number(x), isUndefined(y) ? y : imageData.y + Number(y));
    return this;
  },
  moveTo: function moveTo(x) {
    var _this3 = this;
    var y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : x;
    var _originalEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var element = this.element, options = this.options, imageData = this.imageData;
    x = Number(x);
    y = Number(y);
    if (this.viewed && !this.played && options.movable) {
      var oldX = imageData.x;
      var oldY = imageData.y;
      var changed = false;
      if (isNumber(x)) {
        changed = true;
      } else {
        x = oldX;
      }
      if (isNumber(y)) {
        changed = true;
      } else {
        y = oldY;
      }
      if (changed) {
        if (isFunction(options.move)) {
          addListener(element, EVENT_MOVE, options.move, {
            once: true
          });
        }
        if (dispatchEvent(element, EVENT_MOVE, {
          x,
          y,
          oldX,
          oldY,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }
        imageData.x = x;
        imageData.y = y;
        imageData.left = x;
        imageData.top = y;
        this.moving = true;
        this.renderImage(function() {
          _this3.moving = false;
          if (isFunction(options.moved)) {
            addListener(element, EVENT_MOVED, options.moved, {
              once: true
            });
          }
          dispatchEvent(element, EVENT_MOVED, {
            x,
            y,
            oldX,
            oldY,
            originalEvent: _originalEvent
          }, {
            cancelable: false
          });
        });
      }
    }
    return this;
  },
  rotate: function rotate(degree) {
    this.rotateTo((this.imageData.rotate || 0) + Number(degree));
    return this;
  },
  rotateTo: function rotateTo(degree) {
    var _this4 = this;
    var element = this.element, options = this.options, imageData = this.imageData;
    degree = Number(degree);
    if (isNumber(degree) && this.viewed && !this.played && options.rotatable) {
      var oldDegree = imageData.rotate;
      if (isFunction(options.rotate)) {
        addListener(element, EVENT_ROTATE, options.rotate, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_ROTATE, {
        degree,
        oldDegree
      }) === false) {
        return this;
      }
      imageData.rotate = degree;
      this.rotating = true;
      this.renderImage(function() {
        _this4.rotating = false;
        if (isFunction(options.rotated)) {
          addListener(element, EVENT_ROTATED, options.rotated, {
            once: true
          });
        }
        dispatchEvent(element, EVENT_ROTATED, {
          degree,
          oldDegree
        }, {
          cancelable: false
        });
      });
    }
    return this;
  },
  scaleX: function scaleX(_scaleX) {
    this.scale(_scaleX, this.imageData.scaleY);
    return this;
  },
  scaleY: function scaleY(_scaleY) {
    this.scale(this.imageData.scaleX, _scaleY);
    return this;
  },
  scale: function scale(scaleX2) {
    var _this5 = this;
    var scaleY2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scaleX2;
    var element = this.element, options = this.options, imageData = this.imageData;
    scaleX2 = Number(scaleX2);
    scaleY2 = Number(scaleY2);
    if (this.viewed && !this.played && options.scalable) {
      var oldScaleX = imageData.scaleX;
      var oldScaleY = imageData.scaleY;
      var changed = false;
      if (isNumber(scaleX2)) {
        changed = true;
      } else {
        scaleX2 = oldScaleX;
      }
      if (isNumber(scaleY2)) {
        changed = true;
      } else {
        scaleY2 = oldScaleY;
      }
      if (changed) {
        if (isFunction(options.scale)) {
          addListener(element, EVENT_SCALE, options.scale, {
            once: true
          });
        }
        if (dispatchEvent(element, EVENT_SCALE, {
          scaleX: scaleX2,
          scaleY: scaleY2,
          oldScaleX,
          oldScaleY
        }) === false) {
          return this;
        }
        imageData.scaleX = scaleX2;
        imageData.scaleY = scaleY2;
        this.scaling = true;
        this.renderImage(function() {
          _this5.scaling = false;
          if (isFunction(options.scaled)) {
            addListener(element, EVENT_SCALED, options.scaled, {
              once: true
            });
          }
          dispatchEvent(element, EVENT_SCALED, {
            scaleX: scaleX2,
            scaleY: scaleY2,
            oldScaleX,
            oldScaleY
          }, {
            cancelable: false
          });
        });
      }
    }
    return this;
  },
  zoom: function zoom(ratio) {
    var showTooltip = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var pivot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var _originalEvent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var imageData = this.imageData;
    ratio = Number(ratio);
    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }
    this.zoomTo(imageData.width * ratio / imageData.naturalWidth, showTooltip, pivot, _originalEvent);
    return this;
  },
  zoomTo: function zoomTo(ratio) {
    var _this6 = this;
    var showTooltip = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var pivot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var _originalEvent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    var _zoomable = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var element = this.element, options = this.options, pointers = this.pointers, imageData = this.imageData;
    var x = imageData.x, y = imageData.y, width = imageData.width, height = imageData.height, naturalWidth = imageData.naturalWidth, naturalHeight = imageData.naturalHeight;
    ratio = Math.max(0, ratio);
    if (isNumber(ratio) && this.viewed && !this.played && (_zoomable || options.zoomable)) {
      if (!_zoomable) {
        var minZoomRatio = Math.max(0.01, options.minZoomRatio);
        var maxZoomRatio = Math.min(100, options.maxZoomRatio);
        ratio = Math.min(Math.max(ratio, minZoomRatio), maxZoomRatio);
      }
      if (_originalEvent) {
        switch (_originalEvent.type) {
          case "wheel":
            if (options.zoomRatio >= 0.055 && ratio > 0.95 && ratio < 1.05) {
              ratio = 1;
            }
            break;
          case "pointermove":
          case "touchmove":
          case "mousemove":
            if (ratio > 0.99 && ratio < 1.01) {
              ratio = 1;
            }
            break;
        }
      }
      var newWidth = naturalWidth * ratio;
      var newHeight = naturalHeight * ratio;
      var offsetWidth = newWidth - width;
      var offsetHeight = newHeight - height;
      var oldRatio = imageData.ratio;
      if (isFunction(options.zoom)) {
        addListener(element, EVENT_ZOOM, options.zoom, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_ZOOM, {
        ratio,
        oldRatio,
        originalEvent: _originalEvent
      }) === false) {
        return this;
      }
      this.zooming = true;
      if (_originalEvent) {
        var offset = getOffset(this.viewer);
        var center = pointers && Object.keys(pointers).length > 0 ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY
        };
        imageData.x -= offsetWidth * ((center.pageX - offset.left - x) / width);
        imageData.y -= offsetHeight * ((center.pageY - offset.top - y) / height);
      } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
        imageData.x -= offsetWidth * ((pivot.x - x) / width);
        imageData.y -= offsetHeight * ((pivot.y - y) / height);
      } else {
        imageData.x -= offsetWidth / 2;
        imageData.y -= offsetHeight / 2;
      }
      imageData.left = imageData.x;
      imageData.top = imageData.y;
      imageData.width = newWidth;
      imageData.height = newHeight;
      imageData.oldRatio = oldRatio;
      imageData.ratio = ratio;
      this.renderImage(function() {
        _this6.zooming = false;
        if (isFunction(options.zoomed)) {
          addListener(element, EVENT_ZOOMED, options.zoomed, {
            once: true
          });
        }
        dispatchEvent(element, EVENT_ZOOMED, {
          ratio,
          oldRatio,
          originalEvent: _originalEvent
        }, {
          cancelable: false
        });
      });
      if (showTooltip) {
        this.tooltip();
      }
    }
    return this;
  },
  play: function play() {
    var _this7 = this;
    var fullscreen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!this.isShown || this.played) {
      return this;
    }
    var element = this.element, options = this.options;
    if (isFunction(options.play)) {
      addListener(element, EVENT_PLAY, options.play, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_PLAY) === false) {
      return this;
    }
    var player = this.player;
    var onLoad = this.loadImage.bind(this);
    var list = [];
    var total = 0;
    var index2 = 0;
    this.played = true;
    this.onLoadWhenPlay = onLoad;
    if (fullscreen) {
      this.requestFullscreen(fullscreen);
    }
    addClass(player, CLASS_SHOW);
    forEach(this.items, function(item, i) {
      var img = item.querySelector("img");
      var image = document.createElement("img");
      image.src = getData(img, "originalUrl");
      image.alt = img.getAttribute("alt");
      image.referrerPolicy = img.referrerPolicy;
      total += 1;
      addClass(image, CLASS_FADE);
      toggleClass(image, CLASS_TRANSITION, options.transition);
      if (hasClass(item, CLASS_ACTIVE)) {
        addClass(image, CLASS_IN);
        index2 = i;
      }
      list.push(image);
      addListener(image, EVENT_LOAD, onLoad, {
        once: true
      });
      player.appendChild(image);
    });
    if (isNumber(options.interval) && options.interval > 0) {
      var prev2 = function prev3() {
        clearTimeout(_this7.playing.timeout);
        removeClass(list[index2], CLASS_IN);
        index2 -= 1;
        index2 = index2 >= 0 ? index2 : total - 1;
        addClass(list[index2], CLASS_IN);
        _this7.playing.timeout = setTimeout(prev3, options.interval);
      };
      var next2 = function next3() {
        clearTimeout(_this7.playing.timeout);
        removeClass(list[index2], CLASS_IN);
        index2 += 1;
        index2 = index2 < total ? index2 : 0;
        addClass(list[index2], CLASS_IN);
        _this7.playing.timeout = setTimeout(next3, options.interval);
      };
      if (total > 1) {
        this.playing = {
          prev: prev2,
          next: next2,
          timeout: setTimeout(next2, options.interval)
        };
      }
    }
    return this;
  },
  stop: function stop() {
    var _this8 = this;
    if (!this.played) {
      return this;
    }
    var element = this.element, options = this.options;
    if (isFunction(options.stop)) {
      addListener(element, EVENT_STOP, options.stop, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_STOP) === false) {
      return this;
    }
    var player = this.player;
    clearTimeout(this.playing.timeout);
    this.playing = false;
    this.played = false;
    forEach(player.getElementsByTagName("img"), function(image) {
      removeListener(image, EVENT_LOAD, _this8.onLoadWhenPlay);
    });
    removeClass(player, CLASS_SHOW);
    player.innerHTML = "";
    this.exitFullscreen();
    return this;
  },
  full: function full() {
    var _this9 = this;
    var options = this.options, viewer2 = this.viewer, image = this.image, list = this.list;
    if (!this.isShown || this.played || this.fulled || !options.inline) {
      return this;
    }
    this.fulled = true;
    this.open();
    addClass(this.button, CLASS_FULLSCREEN_EXIT);
    if (options.transition) {
      removeClass(list, CLASS_TRANSITION);
      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
    }
    addClass(viewer2, CLASS_FIXED);
    viewer2.setAttribute("role", "dialog");
    viewer2.setAttribute("aria-labelledby", this.title.id);
    viewer2.setAttribute("aria-modal", true);
    viewer2.removeAttribute("style");
    setStyle(viewer2, {
      zIndex: options.zIndex
    });
    if (options.focus) {
      this.enforceFocus();
    }
    this.initContainer();
    this.viewerData = assign({}, this.containerData);
    this.renderList();
    if (this.viewed) {
      this.initImage(function() {
        _this9.renderImage(function() {
          if (options.transition) {
            setTimeout(function() {
              addClass(image, CLASS_TRANSITION);
              addClass(list, CLASS_TRANSITION);
            }, 0);
          }
        });
      });
    }
    return this;
  },
  exit: function exit() {
    var _this10 = this;
    var options = this.options, viewer2 = this.viewer, image = this.image, list = this.list;
    if (!this.isShown || this.played || !this.fulled || !options.inline) {
      return this;
    }
    this.fulled = false;
    this.close();
    removeClass(this.button, CLASS_FULLSCREEN_EXIT);
    if (options.transition) {
      removeClass(list, CLASS_TRANSITION);
      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
    }
    if (options.focus) {
      this.clearEnforceFocus();
    }
    viewer2.removeAttribute("role");
    viewer2.removeAttribute("aria-labelledby");
    viewer2.removeAttribute("aria-modal");
    removeClass(viewer2, CLASS_FIXED);
    setStyle(viewer2, {
      zIndex: options.zIndexInline
    });
    this.viewerData = assign({}, this.parentData);
    this.renderViewer();
    this.renderList();
    if (this.viewed) {
      this.initImage(function() {
        _this10.renderImage(function() {
          if (options.transition) {
            setTimeout(function() {
              addClass(image, CLASS_TRANSITION);
              addClass(list, CLASS_TRANSITION);
            }, 0);
          }
        });
      });
    }
    return this;
  },
  tooltip: function tooltip() {
    var _this11 = this;
    var options = this.options, tooltipBox = this.tooltipBox, imageData = this.imageData;
    if (!this.viewed || this.played || !options.tooltip) {
      return this;
    }
    tooltipBox.textContent = "".concat(Math.round(imageData.ratio * 100), "%");
    if (!this.tooltipping) {
      if (options.transition) {
        if (this.fading) {
          dispatchEvent(tooltipBox, EVENT_TRANSITION_END);
        }
        addClass(tooltipBox, CLASS_SHOW);
        addClass(tooltipBox, CLASS_FADE);
        addClass(tooltipBox, CLASS_TRANSITION);
        tooltipBox.removeAttribute("aria-hidden");
        tooltipBox.initialOffsetWidth = tooltipBox.offsetWidth;
        addClass(tooltipBox, CLASS_IN);
      } else {
        addClass(tooltipBox, CLASS_SHOW);
        tooltipBox.removeAttribute("aria-hidden");
      }
    } else {
      clearTimeout(this.tooltipping);
    }
    this.tooltipping = setTimeout(function() {
      if (options.transition) {
        addListener(tooltipBox, EVENT_TRANSITION_END, function() {
          removeClass(tooltipBox, CLASS_SHOW);
          removeClass(tooltipBox, CLASS_FADE);
          removeClass(tooltipBox, CLASS_TRANSITION);
          tooltipBox.setAttribute("aria-hidden", true);
          _this11.fading = false;
        }, {
          once: true
        });
        removeClass(tooltipBox, CLASS_IN);
        _this11.fading = true;
      } else {
        removeClass(tooltipBox, CLASS_SHOW);
        tooltipBox.setAttribute("aria-hidden", true);
      }
      _this11.tooltipping = false;
    }, 1e3);
    return this;
  },
  toggle: function toggle() {
    var _originalEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (this.imageData.ratio === 1) {
      this.zoomTo(this.imageData.oldRatio, true, null, _originalEvent);
    } else {
      this.zoomTo(1, true, null, _originalEvent);
    }
    return this;
  },
  reset: function reset() {
    if (this.viewed && !this.played) {
      this.imageData = assign({}, this.initialImageData);
      this.renderImage();
    }
    return this;
  },
  update: function update() {
    var _this12 = this;
    var element = this.element, options = this.options, isImg = this.isImg;
    if (isImg && !element.parentNode) {
      return this.destroy();
    }
    var images = [];
    forEach(isImg ? [element] : element.querySelectorAll("img"), function(image) {
      if (isFunction(options.filter)) {
        if (options.filter.call(_this12, image)) {
          images.push(image);
        }
      } else if (_this12.getImageURL(image)) {
        images.push(image);
      }
    });
    if (!images.length) {
      return this;
    }
    this.images = images;
    this.length = images.length;
    if (this.ready) {
      var changedIndexes = [];
      forEach(this.items, function(item, i) {
        var img = item.querySelector("img");
        var image = images[i];
        if (image && img) {
          if (image.src !== img.src || image.alt !== img.alt) {
            changedIndexes.push(i);
          }
        } else {
          changedIndexes.push(i);
        }
      });
      setStyle(this.list, {
        width: "auto"
      });
      this.initList();
      if (this.isShown) {
        if (this.length) {
          if (this.viewed) {
            var changedIndex = changedIndexes.indexOf(this.index);
            if (changedIndex >= 0) {
              this.viewed = false;
              this.view(Math.max(Math.min(this.index - changedIndex, this.length - 1), 0));
            } else {
              var activeItem = this.items[this.index];
              addClass(activeItem, CLASS_ACTIVE);
              activeItem.setAttribute("aria-selected", true);
            }
          }
        } else {
          this.image = null;
          this.viewed = false;
          this.index = 0;
          this.imageData = {};
          this.canvas.innerHTML = "";
          this.title.innerHTML = "";
        }
      }
    } else {
      this.build();
    }
    return this;
  },
  destroy: function destroy2() {
    var element = this.element, options = this.options;
    if (!element[NAMESPACE]) {
      return this;
    }
    this.destroyed = true;
    if (this.ready) {
      if (this.played) {
        this.stop();
      }
      if (options.inline) {
        if (this.fulled) {
          this.exit();
        }
        this.unbind();
      } else if (this.isShown) {
        if (this.viewing) {
          if (this.imageRendering) {
            this.imageRendering.abort();
          } else if (this.imageInitializing) {
            this.imageInitializing.abort();
          }
        }
        if (this.hiding) {
          this.transitioning.abort();
        }
        this.hidden();
      } else if (this.showing) {
        this.transitioning.abort();
        this.hidden();
      }
      this.ready = false;
      this.viewer.parentNode.removeChild(this.viewer);
    } else if (options.inline) {
      if (this.delaying) {
        this.delaying.abort();
      } else if (this.initializing) {
        this.initializing.abort();
      }
    }
    if (!options.inline) {
      removeListener(element, EVENT_CLICK, this.onStart);
    }
    element[NAMESPACE] = void 0;
    return this;
  }
};
var others = {
  getImageURL: function getImageURL(image) {
    var url = this.options.url;
    if (isString(url)) {
      url = image.getAttribute(url);
    } else if (isFunction(url)) {
      url = url.call(this, image);
    } else {
      url = "";
    }
    return url;
  },
  enforceFocus: function enforceFocus() {
    var _this = this;
    this.clearEnforceFocus();
    addListener(document, EVENT_FOCUSIN, this.onFocusin = function(event) {
      var viewer2 = _this.viewer;
      var target = event.target;
      if (target === document || target === viewer2 || viewer2.contains(target)) {
        return;
      }
      while (target) {
        if (target.getAttribute("tabindex") !== null || target.getAttribute("aria-modal") === "true") {
          return;
        }
        target = target.parentElement;
      }
      viewer2.focus();
    });
  },
  clearEnforceFocus: function clearEnforceFocus() {
    if (this.onFocusin) {
      removeListener(document, EVENT_FOCUSIN, this.onFocusin);
      this.onFocusin = null;
    }
  },
  open: function open() {
    var body = this.body;
    addClass(body, CLASS_OPEN);
    if (this.scrollbarWidth > 0) {
      body.style.paddingRight = "".concat(this.scrollbarWidth + (parseFloat(this.initialBodyComputedPaddingRight) || 0), "px");
    }
  },
  close: function close() {
    var body = this.body;
    removeClass(body, CLASS_OPEN);
    if (this.scrollbarWidth > 0) {
      body.style.paddingRight = this.initialBodyPaddingRight;
    }
  },
  shown: function shown() {
    var element = this.element, options = this.options, viewer2 = this.viewer;
    this.fulled = true;
    this.isShown = true;
    this.render();
    this.bind();
    this.showing = false;
    if (options.focus) {
      viewer2.focus();
      this.enforceFocus();
    }
    if (isFunction(options.shown)) {
      addListener(element, EVENT_SHOWN, options.shown, {
        once: true
      });
    }
    if (dispatchEvent(element, EVENT_SHOWN) === false) {
      return;
    }
    if (this.ready && this.isShown && !this.hiding) {
      this.view(this.index);
    }
  },
  hidden: function hidden() {
    var element = this.element, options = this.options, viewer2 = this.viewer;
    if (options.fucus) {
      this.clearEnforceFocus();
    }
    this.close();
    this.unbind();
    addClass(viewer2, CLASS_HIDE);
    viewer2.removeAttribute("role");
    viewer2.removeAttribute("aria-labelledby");
    viewer2.removeAttribute("aria-modal");
    viewer2.setAttribute("aria-hidden", true);
    this.resetList();
    this.resetImage();
    this.fulled = false;
    this.viewed = false;
    this.isShown = false;
    this.hiding = false;
    if (!this.destroyed) {
      if (isFunction(options.hidden)) {
        addListener(element, EVENT_HIDDEN, options.hidden, {
          once: true
        });
      }
      dispatchEvent(element, EVENT_HIDDEN, null, {
        cancelable: false
      });
    }
  },
  requestFullscreen: function requestFullscreen(options) {
    var document2 = this.element.ownerDocument;
    if (this.fulled && !(document2.fullscreenElement || document2.webkitFullscreenElement || document2.mozFullScreenElement || document2.msFullscreenElement)) {
      var documentElement = document2.documentElement;
      if (documentElement.requestFullscreen) {
        if (isPlainObject(options)) {
          documentElement.requestFullscreen(options);
        } else {
          documentElement.requestFullscreen();
        }
      } else if (documentElement.webkitRequestFullscreen) {
        documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (documentElement.mozRequestFullScreen) {
        documentElement.mozRequestFullScreen();
      } else if (documentElement.msRequestFullscreen) {
        documentElement.msRequestFullscreen();
      }
    }
  },
  exitFullscreen: function exitFullscreen() {
    var document2 = this.element.ownerDocument;
    if (this.fulled && (document2.fullscreenElement || document2.webkitFullscreenElement || document2.mozFullScreenElement || document2.msFullscreenElement)) {
      if (document2.exitFullscreen) {
        document2.exitFullscreen();
      } else if (document2.webkitExitFullscreen) {
        document2.webkitExitFullscreen();
      } else if (document2.mozCancelFullScreen) {
        document2.mozCancelFullScreen();
      } else if (document2.msExitFullscreen) {
        document2.msExitFullscreen();
      }
    }
  },
  change: function change(event) {
    var options = this.options, pointers = this.pointers;
    var pointer = pointers[Object.keys(pointers)[0]];
    if (!pointer) {
      return;
    }
    var offsetX = pointer.endX - pointer.startX;
    var offsetY = pointer.endY - pointer.startY;
    switch (this.action) {
      case ACTION_MOVE:
        if (offsetX !== 0 || offsetY !== 0) {
          this.pointerMoved = true;
          this.move(offsetX, offsetY, event);
        }
        break;
      case ACTION_ZOOM:
        this.zoom(getMaxZoomRatio(pointers), false, null, event);
        break;
      case ACTION_SWITCH: {
        this.action = "switched";
        var absoluteOffsetX = Math.abs(offsetX);
        if (absoluteOffsetX > 1 && absoluteOffsetX > Math.abs(offsetY)) {
          this.pointers = {};
          if (offsetX > 1) {
            this.prev(options.loop);
          } else if (offsetX < -1) {
            this.next(options.loop);
          }
        }
        break;
      }
    }
    forEach(pointers, function(p) {
      p.startX = p.endX;
      p.startY = p.endY;
    });
  },
  isSwitchable: function isSwitchable() {
    var imageData = this.imageData, viewerData = this.viewerData;
    return this.length > 1 && imageData.x >= 0 && imageData.y >= 0 && imageData.width <= viewerData.width && imageData.height <= viewerData.height;
  }
};
var AnotherViewer = WINDOW.Viewer;
var getUniqueID = function(id) {
  return function() {
    id += 1;
    return id;
  };
}(-1);
var Viewer$1 = /* @__PURE__ */ function() {
  function Viewer2(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    _classCallCheck(this, Viewer2);
    if (!element || element.nodeType !== 1) {
      throw new Error("The first argument is required and must be an element.");
    }
    this.element = element;
    this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
    this.action = false;
    this.fading = false;
    this.fulled = false;
    this.hiding = false;
    this.imageClicked = false;
    this.imageData = {};
    this.index = this.options.initialViewIndex;
    this.isImg = false;
    this.isShown = false;
    this.length = 0;
    this.moving = false;
    this.played = false;
    this.playing = false;
    this.pointers = {};
    this.ready = false;
    this.rotating = false;
    this.scaling = false;
    this.showing = false;
    this.timeout = false;
    this.tooltipping = false;
    this.viewed = false;
    this.viewing = false;
    this.wheeling = false;
    this.zooming = false;
    this.pointerMoved = false;
    this.id = getUniqueID();
    this.init();
  }
  _createClass(Viewer2, [{
    key: "init",
    value: function init() {
      var _this = this;
      var element = this.element, options = this.options;
      if (element[NAMESPACE]) {
        return;
      }
      element[NAMESPACE] = this;
      if (options.focus && !options.keyboard) {
        options.focus = false;
      }
      var isImg = element.localName === "img";
      var images = [];
      forEach(isImg ? [element] : element.querySelectorAll("img"), function(image) {
        if (isFunction(options.filter)) {
          if (options.filter.call(_this, image)) {
            images.push(image);
          }
        } else if (_this.getImageURL(image)) {
          images.push(image);
        }
      });
      this.isImg = isImg;
      this.length = images.length;
      this.images = images;
      this.initBody();
      if (isUndefined(document.createElement(NAMESPACE).style.transition)) {
        options.transition = false;
      }
      if (options.inline) {
        var count = 0;
        var progress = function progress2() {
          count += 1;
          if (count === _this.length) {
            var timeout;
            _this.initializing = false;
            _this.delaying = {
              abort: function abort() {
                clearTimeout(timeout);
              }
            };
            timeout = setTimeout(function() {
              _this.delaying = false;
              _this.build();
            }, 0);
          }
        };
        this.initializing = {
          abort: function abort() {
            forEach(images, function(image) {
              if (!image.complete) {
                removeListener(image, EVENT_LOAD, progress);
                removeListener(image, EVENT_ERROR, progress);
              }
            });
          }
        };
        forEach(images, function(image) {
          if (image.complete) {
            progress();
          } else {
            var onLoad;
            var onError;
            addListener(image, EVENT_LOAD, onLoad = function onLoad2() {
              removeListener(image, EVENT_ERROR, onError);
              progress();
            }, {
              once: true
            });
            addListener(image, EVENT_ERROR, onError = function onError2() {
              removeListener(image, EVENT_LOAD, onLoad);
              progress();
            }, {
              once: true
            });
          }
        });
      } else {
        addListener(element, EVENT_CLICK, this.onStart = function(_ref) {
          var target = _ref.target;
          if (target.localName === "img" && (!isFunction(options.filter) || options.filter.call(_this, target))) {
            _this.view(_this.images.indexOf(target));
          }
        });
      }
    }
  }, {
    key: "build",
    value: function build() {
      if (this.ready) {
        return;
      }
      var element = this.element, options = this.options;
      var parent = element.parentNode;
      var template = document.createElement("div");
      template.innerHTML = TEMPLATE;
      var viewer2 = template.querySelector(".".concat(NAMESPACE, "-container"));
      var title = viewer2.querySelector(".".concat(NAMESPACE, "-title"));
      var toolbar = viewer2.querySelector(".".concat(NAMESPACE, "-toolbar"));
      var navbar = viewer2.querySelector(".".concat(NAMESPACE, "-navbar"));
      var button = viewer2.querySelector(".".concat(NAMESPACE, "-button"));
      var canvas = viewer2.querySelector(".".concat(NAMESPACE, "-canvas"));
      this.parent = parent;
      this.viewer = viewer2;
      this.title = title;
      this.toolbar = toolbar;
      this.navbar = navbar;
      this.button = button;
      this.canvas = canvas;
      this.footer = viewer2.querySelector(".".concat(NAMESPACE, "-footer"));
      this.tooltipBox = viewer2.querySelector(".".concat(NAMESPACE, "-tooltip"));
      this.player = viewer2.querySelector(".".concat(NAMESPACE, "-player"));
      this.list = viewer2.querySelector(".".concat(NAMESPACE, "-list"));
      viewer2.id = "".concat(NAMESPACE).concat(this.id);
      title.id = "".concat(NAMESPACE, "Title").concat(this.id);
      addClass(title, !options.title ? CLASS_HIDE : getResponsiveClass(Array.isArray(options.title) ? options.title[0] : options.title));
      addClass(navbar, !options.navbar ? CLASS_HIDE : getResponsiveClass(options.navbar));
      toggleClass(button, CLASS_HIDE, !options.button);
      if (options.keyboard) {
        button.setAttribute("tabindex", 0);
      }
      if (options.backdrop) {
        addClass(viewer2, "".concat(NAMESPACE, "-backdrop"));
        if (!options.inline && options.backdrop !== "static") {
          setData(canvas, DATA_ACTION, "hide");
        }
      }
      if (isString(options.className) && options.className) {
        options.className.split(REGEXP_SPACES).forEach(function(className) {
          addClass(viewer2, className);
        });
      }
      if (options.toolbar) {
        var list = document.createElement("ul");
        var custom = isPlainObject(options.toolbar);
        var zoomButtons = BUTTONS.slice(0, 3);
        var rotateButtons = BUTTONS.slice(7, 9);
        var scaleButtons = BUTTONS.slice(9);
        if (!custom) {
          addClass(toolbar, getResponsiveClass(options.toolbar));
        }
        forEach(custom ? options.toolbar : BUTTONS, function(value, index2) {
          var deep = custom && isPlainObject(value);
          var name = custom ? hyphenate(index2) : value;
          var show2 = deep && !isUndefined(value.show) ? value.show : value;
          if (!show2 || !options.zoomable && zoomButtons.indexOf(name) !== -1 || !options.rotatable && rotateButtons.indexOf(name) !== -1 || !options.scalable && scaleButtons.indexOf(name) !== -1) {
            return;
          }
          var size = deep && !isUndefined(value.size) ? value.size : value;
          var click2 = deep && !isUndefined(value.click) ? value.click : value;
          var item = document.createElement("li");
          if (options.keyboard) {
            item.setAttribute("tabindex", 0);
          }
          item.setAttribute("role", "button");
          addClass(item, "".concat(NAMESPACE, "-").concat(name));
          if (!isFunction(click2)) {
            setData(item, DATA_ACTION, name);
          }
          if (isNumber(show2)) {
            addClass(item, getResponsiveClass(show2));
          }
          if (["small", "large"].indexOf(size) !== -1) {
            addClass(item, "".concat(NAMESPACE, "-").concat(size));
          } else if (name === "play") {
            addClass(item, "".concat(NAMESPACE, "-large"));
          }
          if (isFunction(click2)) {
            addListener(item, EVENT_CLICK, click2);
          }
          list.appendChild(item);
        });
        toolbar.appendChild(list);
      } else {
        addClass(toolbar, CLASS_HIDE);
      }
      if (!options.rotatable) {
        var rotates = toolbar.querySelectorAll('li[class*="rotate"]');
        addClass(rotates, CLASS_INVISIBLE);
        forEach(rotates, function(rotate2) {
          toolbar.appendChild(rotate2);
        });
      }
      if (options.inline) {
        addClass(button, CLASS_FULLSCREEN);
        setStyle(viewer2, {
          zIndex: options.zIndexInline
        });
        if (window.getComputedStyle(parent).position === "static") {
          setStyle(parent, {
            position: "relative"
          });
        }
        parent.insertBefore(viewer2, element.nextSibling);
      } else {
        addClass(button, CLASS_CLOSE);
        addClass(viewer2, CLASS_FIXED);
        addClass(viewer2, CLASS_FADE);
        addClass(viewer2, CLASS_HIDE);
        setStyle(viewer2, {
          zIndex: options.zIndex
        });
        var container = options.container;
        if (isString(container)) {
          container = element.ownerDocument.querySelector(container);
        }
        if (!container) {
          container = this.body;
        }
        container.appendChild(viewer2);
      }
      if (options.inline) {
        this.render();
        this.bind();
        this.isShown = true;
      }
      this.ready = true;
      if (isFunction(options.ready)) {
        addListener(element, EVENT_READY, options.ready, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_READY) === false) {
        this.ready = false;
        return;
      }
      if (this.ready && options.inline) {
        this.view(this.index);
      }
    }
  }], [{
    key: "noConflict",
    value: function noConflict() {
      window.Viewer = AnotherViewer;
      return Viewer2;
    }
  }, {
    key: "setDefaults",
    value: function setDefaults(options) {
      assign(DEFAULTS, isPlainObject(options) && options);
    }
  }]);
  return Viewer2;
}();
assign(Viewer$1.prototype, render, events, handlers, methods, others);
var __extends$3 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (b2.hasOwnProperty(p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var QiniuErrorName;
(function(QiniuErrorName2) {
  QiniuErrorName2["InvalidFile"] = "InvalidFile";
  QiniuErrorName2["InvalidToken"] = "InvalidToken";
  QiniuErrorName2["InvalidMetadata"] = "InvalidMetadata";
  QiniuErrorName2["InvalidChunkSize"] = "InvalidChunkSize";
  QiniuErrorName2["InvalidCustomVars"] = "InvalidCustomVars";
  QiniuErrorName2["NotAvailableUploadHost"] = "NotAvailableUploadHost";
  QiniuErrorName2["ReadCacheFailed"] = "ReadCacheFailed";
  QiniuErrorName2["InvalidCacheData"] = "InvalidCacheData";
  QiniuErrorName2["WriteCacheFailed"] = "WriteCacheFailed";
  QiniuErrorName2["RemoveCacheFailed"] = "RemoveCacheFailed";
  QiniuErrorName2["GetCanvasContextFailed"] = "GetCanvasContextFailed";
  QiniuErrorName2["UnsupportedFileType"] = "UnsupportedFileType";
  QiniuErrorName2["FileReaderReadFailed"] = "FileReaderReadFailed";
  QiniuErrorName2["NotAvailableXMLHttpRequest"] = "NotAvailableXMLHttpRequest";
  QiniuErrorName2["InvalidProgressEventTarget"] = "InvalidProgressEventTarget";
  QiniuErrorName2["RequestError"] = "RequestError";
})(QiniuErrorName || (QiniuErrorName = {}));
var QiniuError = function() {
  function QiniuError2(name, message) {
    this.name = name;
    this.message = message;
    this.stack = new Error().stack;
  }
  return QiniuError2;
}();
var QiniuRequestError = function(_super) {
  __extends$3(QiniuRequestError2, _super);
  function QiniuRequestError2(code2, reqId, message, data2) {
    var _this = _super.call(this, QiniuErrorName.RequestError, message) || this;
    _this.code = code2;
    _this.reqId = reqId;
    _this.isRequestError = true;
    _this.data = data2;
    return _this;
  }
  return QiniuRequestError2;
}(QiniuError);
var QiniuNetworkError = function(_super) {
  __extends$3(QiniuNetworkError2, _super);
  function QiniuNetworkError2(message, reqId) {
    if (reqId === void 0) {
      reqId = "";
    }
    return _super.call(this, 0, reqId, message) || this;
  }
  return QiniuNetworkError2;
}(QiniuRequestError);
var Pool = function() {
  function Pool2(runTask, limit) {
    this.runTask = runTask;
    this.limit = limit;
    this.aborted = false;
    this.queue = [];
    this.processing = [];
  }
  Pool2.prototype.enqueue = function(task) {
    var _this = this;
    return new Promise(function(resolve, reject) {
      _this.queue.push({
        task,
        resolve,
        reject
      });
      _this.check();
    });
  };
  Pool2.prototype.run = function(item) {
    var _this = this;
    this.queue = this.queue.filter(function(v) {
      return v !== item;
    });
    this.processing.push(item);
    this.runTask(item.task).then(function() {
      _this.processing = _this.processing.filter(function(v) {
        return v !== item;
      });
      item.resolve();
      _this.check();
    }, function(err) {
      return item.reject(err);
    });
  };
  Pool2.prototype.check = function() {
    var _this = this;
    if (this.aborted)
      return;
    var processingNum = this.processing.length;
    var availableNum = this.limit - processingNum;
    this.queue.slice(0, availableNum).forEach(function(item) {
      _this.run(item);
    });
  };
  Pool2.prototype.abort = function() {
    this.queue = [];
    this.aborted = true;
  };
  return Pool2;
}();
var __extends$2 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (b2.hasOwnProperty(p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$6 = globalThis && globalThis.__assign || function() {
  __assign$6 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$6.apply(this, arguments);
};
var Subscription = function() {
  function Subscription2() {
    this.closed = false;
  }
  Subscription2.prototype.unsubscribe = function() {
    if (this.closed) {
      return;
    }
    this.closed = true;
    if (this._unsubscribe) {
      this._unsubscribe();
    }
  };
  Subscription2.prototype.add = function(teardown) {
    this._unsubscribe = teardown;
  };
  return Subscription2;
}();
var Subscriber = function(_super) {
  __extends$2(Subscriber2, _super);
  function Subscriber2(observerOrNext, error, complete) {
    var _this = _super.call(this) || this;
    _this.isStopped = false;
    if (observerOrNext && typeof observerOrNext === "object") {
      _this.destination = observerOrNext;
    } else {
      _this.destination = __assign$6(__assign$6(__assign$6({}, observerOrNext && { next: observerOrNext }), error && { error }), complete && { complete });
    }
    return _this;
  }
  Subscriber2.prototype.unsubscribe = function() {
    if (this.closed) {
      return;
    }
    this.isStopped = true;
    _super.prototype.unsubscribe.call(this);
  };
  Subscriber2.prototype.next = function(value) {
    if (!this.isStopped && this.destination.next) {
      this.destination.next(value);
    }
  };
  Subscriber2.prototype.error = function(err) {
    if (!this.isStopped && this.destination.error) {
      this.isStopped = true;
      this.destination.error(err);
    }
  };
  Subscriber2.prototype.complete = function(result) {
    if (!this.isStopped && this.destination.complete) {
      this.isStopped = true;
      this.destination.complete(result);
    }
  };
  return Subscriber2;
}(Subscription);
var Observable = function() {
  function Observable2(_subscribe) {
    this._subscribe = _subscribe;
  }
  Observable2.prototype.subscribe = function(observerOrNext, error, complete) {
    var sink = new Subscriber(observerOrNext, error, complete);
    sink.add(this._subscribe(sink));
    return sink;
  };
  return Observable2;
}();
function utf8Encode(argString) {
  if (argString === null || typeof argString === "undefined") {
    return "";
  }
  var string = argString + "";
  var utftext = "", start, end, stringl = 0;
  start = end = 0;
  stringl = string.length;
  for (var n = 0; n < stringl; n++) {
    var c1 = string.charCodeAt(n);
    var enc = null;
    if (c1 < 128) {
      end++;
    } else if (c1 > 127 && c1 < 2048) {
      enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
    } else if ((c1 & 63488 ^ 55296) > 0) {
      enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
    } else {
      if ((c1 & 64512 ^ 55296) > 0) {
        throw new RangeError("Unmatched trail surrogate at " + n);
      }
      var c2 = string.charCodeAt(++n);
      if ((c2 & 64512 ^ 56320) > 0) {
        throw new RangeError("Unmatched lead surrogate at " + (n - 1));
      }
      c1 = ((c1 & 1023) << 10) + (c2 & 1023) + 65536;
      enc = String.fromCharCode(c1 >> 18 | 240, c1 >> 12 & 63 | 128, c1 >> 6 & 63 | 128, c1 & 63 | 128);
    }
    if (enc !== null) {
      if (end > start) {
        utftext += string.slice(start, end);
      }
      utftext += enc;
      start = end = n + 1;
    }
  }
  if (end > start) {
    utftext += string.slice(start, stringl);
  }
  return utftext;
}
function utf8Decode(strData) {
  var tmpArr = [];
  var i = 0;
  var c1 = 0;
  var seqlen = 0;
  strData += "";
  while (i < strData.length) {
    c1 = strData.charCodeAt(i) & 255;
    seqlen = 0;
    if (c1 <= 191) {
      c1 = c1 & 127;
      seqlen = 1;
    } else if (c1 <= 223) {
      c1 = c1 & 31;
      seqlen = 2;
    } else if (c1 <= 239) {
      c1 = c1 & 15;
      seqlen = 3;
    } else {
      c1 = c1 & 7;
      seqlen = 4;
    }
    for (var ai = 1; ai < seqlen; ++ai) {
      c1 = c1 << 6 | strData.charCodeAt(ai + i) & 63;
    }
    if (seqlen === 4) {
      c1 -= 65536;
      tmpArr.push(String.fromCharCode(55296 | c1 >> 10 & 1023));
      tmpArr.push(String.fromCharCode(56320 | c1 & 1023));
    } else {
      tmpArr.push(String.fromCharCode(c1));
    }
    i += seqlen;
  }
  return tmpArr.join("");
}
function base64Encode(data2) {
  var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = "", tmp_arr = [];
  if (!data2) {
    return data2;
  }
  data2 = utf8Encode(data2 + "");
  do {
    o1 = data2.charCodeAt(i++);
    o2 = data2.charCodeAt(i++);
    o3 = data2.charCodeAt(i++);
    bits = o1 << 16 | o2 << 8 | o3;
    h1 = bits >> 18 & 63;
    h2 = bits >> 12 & 63;
    h3 = bits >> 6 & 63;
    h4 = bits & 63;
    tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
  } while (i < data2.length);
  enc = tmp_arr.join("");
  switch (data2.length % 3) {
    case 1:
      enc = enc.slice(0, -2) + "==";
      break;
    case 2:
      enc = enc.slice(0, -1) + "=";
      break;
  }
  return enc;
}
function base64Decode(data2) {
  var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, dec = "", tmp_arr = [];
  if (!data2) {
    return data2;
  }
  data2 += "";
  do {
    h1 = b64.indexOf(data2.charAt(i++));
    h2 = b64.indexOf(data2.charAt(i++));
    h3 = b64.indexOf(data2.charAt(i++));
    h4 = b64.indexOf(data2.charAt(i++));
    bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
    o1 = bits >> 16 & 255;
    o2 = bits >> 8 & 255;
    o3 = bits & 255;
    if (h3 === 64) {
      tmp_arr[ac++] = String.fromCharCode(o1);
    } else if (h4 === 64) {
      tmp_arr[ac++] = String.fromCharCode(o1, o2);
    } else {
      tmp_arr[ac++] = String.fromCharCode(o1, o2, o3);
    }
  } while (i < data2.length);
  dec = tmp_arr.join("");
  return utf8Decode(dec);
}
function urlSafeBase64Encode(v) {
  v = base64Encode(v);
  return v.replace(/\//g, "_").replace(/\+/g, "-");
}
function urlSafeBase64Decode(v) {
  v = v.replace(/_/g, "/").replace(/-/g, "+");
  return base64Decode(v);
}
var sparkMd5 = { exports: {} };
(function(module, exports) {
  (function(factory) {
    {
      module.exports = factory();
    }
  })(function(undefined$1) {
    var hex_chr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    function md5cycle(x, k) {
      var a = x[0], b = x[1], c = x[2], d = x[3];
      a += (b & c | ~b & d) + k[0] - 680876936 | 0;
      a = (a << 7 | a >>> 25) + b | 0;
      d += (a & b | ~a & c) + k[1] - 389564586 | 0;
      d = (d << 12 | d >>> 20) + a | 0;
      c += (d & a | ~d & b) + k[2] + 606105819 | 0;
      c = (c << 17 | c >>> 15) + d | 0;
      b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
      b = (b << 22 | b >>> 10) + c | 0;
      a += (b & c | ~b & d) + k[4] - 176418897 | 0;
      a = (a << 7 | a >>> 25) + b | 0;
      d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
      d = (d << 12 | d >>> 20) + a | 0;
      c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
      c = (c << 17 | c >>> 15) + d | 0;
      b += (c & d | ~c & a) + k[7] - 45705983 | 0;
      b = (b << 22 | b >>> 10) + c | 0;
      a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
      a = (a << 7 | a >>> 25) + b | 0;
      d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
      d = (d << 12 | d >>> 20) + a | 0;
      c += (d & a | ~d & b) + k[10] - 42063 | 0;
      c = (c << 17 | c >>> 15) + d | 0;
      b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
      b = (b << 22 | b >>> 10) + c | 0;
      a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
      a = (a << 7 | a >>> 25) + b | 0;
      d += (a & b | ~a & c) + k[13] - 40341101 | 0;
      d = (d << 12 | d >>> 20) + a | 0;
      c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
      c = (c << 17 | c >>> 15) + d | 0;
      b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
      b = (b << 22 | b >>> 10) + c | 0;
      a += (b & d | c & ~d) + k[1] - 165796510 | 0;
      a = (a << 5 | a >>> 27) + b | 0;
      d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
      d = (d << 9 | d >>> 23) + a | 0;
      c += (d & b | a & ~b) + k[11] + 643717713 | 0;
      c = (c << 14 | c >>> 18) + d | 0;
      b += (c & a | d & ~a) + k[0] - 373897302 | 0;
      b = (b << 20 | b >>> 12) + c | 0;
      a += (b & d | c & ~d) + k[5] - 701558691 | 0;
      a = (a << 5 | a >>> 27) + b | 0;
      d += (a & c | b & ~c) + k[10] + 38016083 | 0;
      d = (d << 9 | d >>> 23) + a | 0;
      c += (d & b | a & ~b) + k[15] - 660478335 | 0;
      c = (c << 14 | c >>> 18) + d | 0;
      b += (c & a | d & ~a) + k[4] - 405537848 | 0;
      b = (b << 20 | b >>> 12) + c | 0;
      a += (b & d | c & ~d) + k[9] + 568446438 | 0;
      a = (a << 5 | a >>> 27) + b | 0;
      d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
      d = (d << 9 | d >>> 23) + a | 0;
      c += (d & b | a & ~b) + k[3] - 187363961 | 0;
      c = (c << 14 | c >>> 18) + d | 0;
      b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
      b = (b << 20 | b >>> 12) + c | 0;
      a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
      a = (a << 5 | a >>> 27) + b | 0;
      d += (a & c | b & ~c) + k[2] - 51403784 | 0;
      d = (d << 9 | d >>> 23) + a | 0;
      c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
      c = (c << 14 | c >>> 18) + d | 0;
      b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
      b = (b << 20 | b >>> 12) + c | 0;
      a += (b ^ c ^ d) + k[5] - 378558 | 0;
      a = (a << 4 | a >>> 28) + b | 0;
      d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
      d = (d << 11 | d >>> 21) + a | 0;
      c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
      c = (c << 16 | c >>> 16) + d | 0;
      b += (c ^ d ^ a) + k[14] - 35309556 | 0;
      b = (b << 23 | b >>> 9) + c | 0;
      a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
      a = (a << 4 | a >>> 28) + b | 0;
      d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
      d = (d << 11 | d >>> 21) + a | 0;
      c += (d ^ a ^ b) + k[7] - 155497632 | 0;
      c = (c << 16 | c >>> 16) + d | 0;
      b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
      b = (b << 23 | b >>> 9) + c | 0;
      a += (b ^ c ^ d) + k[13] + 681279174 | 0;
      a = (a << 4 | a >>> 28) + b | 0;
      d += (a ^ b ^ c) + k[0] - 358537222 | 0;
      d = (d << 11 | d >>> 21) + a | 0;
      c += (d ^ a ^ b) + k[3] - 722521979 | 0;
      c = (c << 16 | c >>> 16) + d | 0;
      b += (c ^ d ^ a) + k[6] + 76029189 | 0;
      b = (b << 23 | b >>> 9) + c | 0;
      a += (b ^ c ^ d) + k[9] - 640364487 | 0;
      a = (a << 4 | a >>> 28) + b | 0;
      d += (a ^ b ^ c) + k[12] - 421815835 | 0;
      d = (d << 11 | d >>> 21) + a | 0;
      c += (d ^ a ^ b) + k[15] + 530742520 | 0;
      c = (c << 16 | c >>> 16) + d | 0;
      b += (c ^ d ^ a) + k[2] - 995338651 | 0;
      b = (b << 23 | b >>> 9) + c | 0;
      a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
      a = (a << 6 | a >>> 26) + b | 0;
      d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
      d = (d << 10 | d >>> 22) + a | 0;
      c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
      c = (c << 15 | c >>> 17) + d | 0;
      b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
      b = (b << 21 | b >>> 11) + c | 0;
      a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
      a = (a << 6 | a >>> 26) + b | 0;
      d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
      d = (d << 10 | d >>> 22) + a | 0;
      c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
      c = (c << 15 | c >>> 17) + d | 0;
      b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
      b = (b << 21 | b >>> 11) + c | 0;
      a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
      a = (a << 6 | a >>> 26) + b | 0;
      d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
      d = (d << 10 | d >>> 22) + a | 0;
      c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
      c = (c << 15 | c >>> 17) + d | 0;
      b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
      b = (b << 21 | b >>> 11) + c | 0;
      a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
      a = (a << 6 | a >>> 26) + b | 0;
      d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
      d = (d << 10 | d >>> 22) + a | 0;
      c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
      c = (c << 15 | c >>> 17) + d | 0;
      b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
      b = (b << 21 | b >>> 11) + c | 0;
      x[0] = a + x[0] | 0;
      x[1] = b + x[1] | 0;
      x[2] = c + x[2] | 0;
      x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
      var md5blks = [], i;
      for (i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
      }
      return md5blks;
    }
    function md5blk_array(a) {
      var md5blks = [], i;
      for (i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
      }
      return md5blks;
    }
    function md51(s) {
      var n = s.length, state = [1732584193, -271733879, -1732584194, 271733878], i, length, tail, tmp, lo, hi;
      for (i = 64; i <= n; i += 64) {
        md5cycle(state, md5blk(s.substring(i - 64, i)));
      }
      s = s.substring(i - 64);
      length = s.length;
      tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
      }
      tail[i >> 2] |= 128 << (i % 4 << 3);
      if (i > 55) {
        md5cycle(state, tail);
        for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }
      tmp = n * 8;
      tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
      lo = parseInt(tmp[2], 16);
      hi = parseInt(tmp[1], 16) || 0;
      tail[14] = lo;
      tail[15] = hi;
      md5cycle(state, tail);
      return state;
    }
    function md51_array(a) {
      var n = a.length, state = [1732584193, -271733879, -1732584194, 271733878], i, length, tail, tmp, lo, hi;
      for (i = 64; i <= n; i += 64) {
        md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
      }
      a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
      length = a.length;
      tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= a[i] << (i % 4 << 3);
      }
      tail[i >> 2] |= 128 << (i % 4 << 3);
      if (i > 55) {
        md5cycle(state, tail);
        for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }
      tmp = n * 8;
      tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
      lo = parseInt(tmp[2], 16);
      hi = parseInt(tmp[1], 16) || 0;
      tail[14] = lo;
      tail[15] = hi;
      md5cycle(state, tail);
      return state;
    }
    function rhex(n) {
      var s = "", j;
      for (j = 0; j < 4; j += 1) {
        s += hex_chr[n >> j * 8 + 4 & 15] + hex_chr[n >> j * 8 & 15];
      }
      return s;
    }
    function hex(x) {
      var i;
      for (i = 0; i < x.length; i += 1) {
        x[i] = rhex(x[i]);
      }
      return x.join("");
    }
    if (hex(md51("hello")) !== "5d41402abc4b2a76b9719d911017c592")
      ;
    if (typeof ArrayBuffer !== "undefined" && !ArrayBuffer.prototype.slice) {
      (function() {
        function clamp(val, length) {
          val = val | 0 || 0;
          if (val < 0) {
            return Math.max(val + length, 0);
          }
          return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
          var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
          if (to !== undefined$1) {
            end = clamp(to, length);
          }
          if (begin > end) {
            return new ArrayBuffer(0);
          }
          num = end - begin;
          target = new ArrayBuffer(num);
          targetArray = new Uint8Array(target);
          sourceArray = new Uint8Array(this, begin, num);
          targetArray.set(sourceArray);
          return target;
        };
      })();
    }
    function toUtf8(str) {
      if (/[\u0080-\uFFFF]/.test(str)) {
        str = unescape(encodeURIComponent(str));
      }
      return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
      var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
      for (i = 0; i < length; i += 1) {
        arr[i] = str.charCodeAt(i);
      }
      return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
      return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
      var result = new Uint8Array(first.byteLength + second.byteLength);
      result.set(new Uint8Array(first));
      result.set(new Uint8Array(second), first.byteLength);
      return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex2) {
      var bytes = [], length = hex2.length, x;
      for (x = 0; x < length - 1; x += 2) {
        bytes.push(parseInt(hex2.substr(x, 2), 16));
      }
      return String.fromCharCode.apply(String, bytes);
    }
    function SparkMD52() {
      this.reset();
    }
    SparkMD52.prototype.append = function(str) {
      this.appendBinary(toUtf8(str));
      return this;
    };
    SparkMD52.prototype.appendBinary = function(contents) {
      this._buff += contents;
      this._length += contents.length;
      var length = this._buff.length, i;
      for (i = 64; i <= length; i += 64) {
        md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
      }
      this._buff = this._buff.substring(i - 64);
      return this;
    };
    SparkMD52.prototype.end = function(raw) {
      var buff = this._buff, length = buff.length, i, tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], ret;
      for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
      }
      this._finish(tail, length);
      ret = hex(this._hash);
      if (raw) {
        ret = hexToBinaryString(ret);
      }
      this.reset();
      return ret;
    };
    SparkMD52.prototype.reset = function() {
      this._buff = "";
      this._length = 0;
      this._hash = [1732584193, -271733879, -1732584194, 271733878];
      return this;
    };
    SparkMD52.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    };
    SparkMD52.prototype.setState = function(state) {
      this._buff = state.buff;
      this._length = state.length;
      this._hash = state.hash;
      return this;
    };
    SparkMD52.prototype.destroy = function() {
      delete this._hash;
      delete this._buff;
      delete this._length;
    };
    SparkMD52.prototype._finish = function(tail, length) {
      var i = length, tmp, lo, hi;
      tail[i >> 2] |= 128 << (i % 4 << 3);
      if (i > 55) {
        md5cycle(this._hash, tail);
        for (i = 0; i < 16; i += 1) {
          tail[i] = 0;
        }
      }
      tmp = this._length * 8;
      tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
      lo = parseInt(tmp[2], 16);
      hi = parseInt(tmp[1], 16) || 0;
      tail[14] = lo;
      tail[15] = hi;
      md5cycle(this._hash, tail);
    };
    SparkMD52.hash = function(str, raw) {
      return SparkMD52.hashBinary(toUtf8(str), raw);
    };
    SparkMD52.hashBinary = function(content, raw) {
      var hash = md51(content), ret = hex(hash);
      return raw ? hexToBinaryString(ret) : ret;
    };
    SparkMD52.ArrayBuffer = function() {
      this.reset();
    };
    SparkMD52.ArrayBuffer.prototype.append = function(arr) {
      var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
      this._length += arr.byteLength;
      for (i = 64; i <= length; i += 64) {
        md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
      }
      this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
      return this;
    };
    SparkMD52.ArrayBuffer.prototype.end = function(raw) {
      var buff = this._buff, length = buff.length, tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], i, ret;
      for (i = 0; i < length; i += 1) {
        tail[i >> 2] |= buff[i] << (i % 4 << 3);
      }
      this._finish(tail, length);
      ret = hex(this._hash);
      if (raw) {
        ret = hexToBinaryString(ret);
      }
      this.reset();
      return ret;
    };
    SparkMD52.ArrayBuffer.prototype.reset = function() {
      this._buff = new Uint8Array(0);
      this._length = 0;
      this._hash = [1732584193, -271733879, -1732584194, 271733878];
      return this;
    };
    SparkMD52.ArrayBuffer.prototype.getState = function() {
      var state = SparkMD52.prototype.getState.call(this);
      state.buff = arrayBuffer2Utf8Str(state.buff);
      return state;
    };
    SparkMD52.ArrayBuffer.prototype.setState = function(state) {
      state.buff = utf8Str2ArrayBuffer(state.buff, true);
      return SparkMD52.prototype.setState.call(this, state);
    };
    SparkMD52.ArrayBuffer.prototype.destroy = SparkMD52.prototype.destroy;
    SparkMD52.ArrayBuffer.prototype._finish = SparkMD52.prototype._finish;
    SparkMD52.ArrayBuffer.hash = function(arr, raw) {
      var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
      return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD52;
  });
})(sparkMd5);
var SparkMD5 = sparkMd5.exports;
var __assign$5 = globalThis && globalThis.__assign || function() {
  __assign$5 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$5.apply(this, arguments);
};
var __awaiter$6 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$6 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t[1]) {
              _2.label = t[1];
              t = op;
              break;
            }
            if (t && _2.label < t[2]) {
              _2.label = t[2];
              _2.ops.push(op);
              break;
            }
            if (t[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var MB = Math.pow(1024, 2);
function getChunks(file, blockSize) {
  var chunkByteSize = blockSize * MB;
  if (chunkByteSize > file.size) {
    chunkByteSize = file.size;
  } else {
    while (file.size > chunkByteSize * 1e4) {
      chunkByteSize *= 2;
    }
  }
  var chunks = [];
  var count = Math.ceil(file.size / chunkByteSize);
  for (var i = 0; i < count; i++) {
    var chunk = file.slice(chunkByteSize * i, i === count - 1 ? file.size : chunkByteSize * (i + 1));
    chunks.push(chunk);
  }
  return chunks;
}
function isMetaDataValid(params) {
  return Object.keys(params).every(function(key) {
    return key.indexOf("x-qn-meta-") === 0;
  });
}
function isCustomVarsValid(params) {
  return Object.keys(params).every(function(key) {
    return key.indexOf("x:") === 0;
  });
}
function sum(list) {
  return list.reduce(function(data2, loaded) {
    return data2 + loaded;
  }, 0);
}
function setLocalFileInfo(localKey, info, logger) {
  try {
    localStorage.setItem(localKey, JSON.stringify(info));
  } catch (err) {
    logger.warn(new QiniuError(QiniuErrorName.WriteCacheFailed, "setLocalFileInfo failed: " + localKey));
  }
}
function createLocalKey(name, key, size) {
  var localKey = key == null ? "_" : "_key_" + key + "_";
  return "qiniu_js_sdk_upload_file_name_" + name + localKey + "size_" + size;
}
function removeLocalFileInfo(localKey, logger) {
  try {
    localStorage.removeItem(localKey);
  } catch (err) {
    logger.warn(new QiniuError(QiniuErrorName.RemoveCacheFailed, "removeLocalFileInfo failed. key: " + localKey));
  }
}
function getLocalFileInfo(localKey, logger) {
  var localInfoString = null;
  try {
    localInfoString = localStorage.getItem(localKey);
  } catch (_a2) {
    logger.warn(new QiniuError(QiniuErrorName.ReadCacheFailed, "getLocalFileInfo failed. key: " + localKey));
  }
  if (localInfoString == null) {
    return null;
  }
  var localInfo = null;
  try {
    localInfo = JSON.parse(localInfoString);
  } catch (_b) {
    removeLocalFileInfo(localKey, logger);
    logger.warn(new QiniuError(QiniuErrorName.InvalidCacheData, "getLocalFileInfo failed to parse. key: " + localKey));
  }
  return localInfo;
}
function getAuthHeaders(token) {
  var auth = "UpToken " + token;
  return { Authorization: auth };
}
function getHeadersForChunkUpload(token) {
  var header = getAuthHeaders(token);
  return __assign$5({ "content-type": "application/octet-stream" }, header);
}
function getHeadersForMkFile(token) {
  var header = getAuthHeaders(token);
  return __assign$5({ "content-type": "application/json" }, header);
}
function createXHR() {
  if (window.XMLHttpRequest) {
    return new XMLHttpRequest();
  }
  if (window.ActiveXObject) {
    return new window.ActiveXObject("Microsoft.XMLHTTP");
  }
  throw new QiniuError(QiniuErrorName.NotAvailableXMLHttpRequest, "the current environment does not support.");
}
function computeMd5(data2) {
  return __awaiter$6(this, void 0, void 0, function() {
    var buffer, spark;
    return __generator$6(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          return [4, readAsArrayBuffer(data2)];
        case 1:
          buffer = _a2.sent();
          spark = new SparkMD5.ArrayBuffer();
          spark.append(buffer);
          return [2, spark.end()];
      }
    });
  });
}
function readAsArrayBuffer(data2) {
  return new Promise(function(resolve, reject) {
    var reader = new FileReader();
    reader.onload = function(evt) {
      if (evt.target) {
        var body = evt.target.result;
        resolve(body);
      } else {
        reject(new QiniuError(QiniuErrorName.InvalidProgressEventTarget, "progress event target is undefined"));
      }
    };
    reader.onerror = function() {
      reject(new QiniuError(QiniuErrorName.FileReaderReadFailed, "fileReader read failed"));
    };
    reader.readAsArrayBuffer(data2);
  });
}
function request$1(url, options) {
  return new Promise(function(resolve, reject) {
    var xhr2 = createXHR();
    xhr2.open(options.method, url);
    if (options.onCreate) {
      options.onCreate(xhr2);
    }
    if (options.headers) {
      var headers_1 = options.headers;
      Object.keys(headers_1).forEach(function(k) {
        xhr2.setRequestHeader(k, headers_1[k]);
      });
    }
    xhr2.upload.addEventListener("progress", function(evt) {
      if (evt.lengthComputable && options.onProgress) {
        options.onProgress({
          loaded: evt.loaded,
          total: evt.total
        });
      }
    });
    xhr2.onreadystatechange = function() {
      var responseText = xhr2.responseText;
      if (xhr2.readyState !== 4) {
        return;
      }
      var reqId = xhr2.getResponseHeader("x-reqId") || "";
      if (xhr2.status === 0) {
        reject(new QiniuNetworkError("network error.", reqId));
        return;
      }
      if (xhr2.status !== 200) {
        var message = "xhr request failed, code: " + xhr2.status;
        if (responseText) {
          message += " response: " + responseText;
        }
        var data2 = void 0;
        try {
          data2 = JSON.parse(responseText);
        } catch (_a2) {
        }
        reject(new QiniuRequestError(xhr2.status, reqId, message, data2));
        return;
      }
      try {
        resolve({
          data: JSON.parse(responseText),
          reqId
        });
      } catch (err) {
        reject(err);
      }
    };
    xhr2.send(options.body);
  });
}
function getPortFromUrl(url) {
  if (url && url.match) {
    var groups = url.match(/(^https?)/);
    if (!groups) {
      return "";
    }
    var type = groups[1];
    groups = url.match(/^https?:\/\/([^:^/]*):(\d*)/);
    if (groups) {
      return groups[2];
    }
    if (type === "http") {
      return "80";
    }
    return "443";
  }
  return "";
}
function getDomainFromUrl(url) {
  if (url && url.match) {
    var groups = url.match(/^https?:\/\/([^:^/]*)/);
    return groups ? groups[1] : "";
  }
  return "";
}
function getPutPolicy(token) {
  if (!token)
    throw new QiniuError(QiniuErrorName.InvalidToken, "invalid token.");
  var segments = token.split(":");
  if (segments.length === 1)
    throw new QiniuError(QiniuErrorName.InvalidToken, "invalid token segments.");
  var assessKey = segments.length > 3 ? segments[1] : segments[0];
  if (!assessKey)
    throw new QiniuError(QiniuErrorName.InvalidToken, "missing assess key field.");
  var putPolicy = null;
  try {
    putPolicy = JSON.parse(urlSafeBase64Decode(segments[segments.length - 1]));
  } catch (error) {
    throw new QiniuError(QiniuErrorName.InvalidToken, "token parse failed.");
  }
  if (putPolicy == null) {
    throw new QiniuError(QiniuErrorName.InvalidToken, "putPolicy is null.");
  }
  if (putPolicy.scope == null) {
    throw new QiniuError(QiniuErrorName.InvalidToken, "scope field is null.");
  }
  var bucketName = putPolicy.scope.split(":")[0];
  if (!bucketName) {
    throw new QiniuError(QiniuErrorName.InvalidToken, "resolve bucketName failed.");
  }
  return { assessKey, bucketName, scope: putPolicy.scope };
}
var _a;
var region = {
  z0: "z0",
  z1: "z1",
  z2: "z2",
  na0: "na0",
  as0: "as0",
  cnEast2: "cn-east-2"
};
var regionUphostMap = (_a = {}, _a[region.z0] = {
  srcUphost: ["up.qiniup.com"],
  cdnUphost: ["upload.qiniup.com"]
}, _a[region.z1] = {
  srcUphost: ["up-z1.qiniup.com"],
  cdnUphost: ["upload-z1.qiniup.com"]
}, _a[region.z2] = {
  srcUphost: ["up-z2.qiniup.com"],
  cdnUphost: ["upload-z2.qiniup.com"]
}, _a[region.na0] = {
  srcUphost: ["up-na0.qiniup.com"],
  cdnUphost: ["upload-na0.qiniup.com"]
}, _a[region.as0] = {
  srcUphost: ["up-as0.qiniup.com"],
  cdnUphost: ["upload-as0.qiniup.com"]
}, _a[region.cnEast2] = {
  srcUphost: ["up-cn-east-2.qiniup.com"],
  cdnUphost: ["upload-cn-east-2.qiniup.com"]
}, _a);
var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case "string":
      return v;
    case "boolean":
      return v ? "true" : "false";
    case "number":
      return isFinite(v) ? v : "";
    default:
      return "";
  }
};
var encode = function(obj, sep, eq, name) {
  sep = sep || "&";
  eq = eq || "=";
  if (obj === null) {
    obj = void 0;
  }
  if (typeof obj === "object") {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).filter(Boolean).join(sep);
  }
  if (!name)
    return "";
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};
var stringify;
stringify = encode;
var __assign$4 = globalThis && globalThis.__assign || function() {
  __assign$4 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$4.apply(this, arguments);
};
var __awaiter$5 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$5 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t[1]) {
              _2.label = t[1];
              t = op;
              break;
            }
            if (t && _2.label < t[2]) {
              _2.label = t[2];
              _2.ops.push(op);
              break;
            }
            if (t[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
function getUpHosts(accessKey, bucketName, protocol) {
  return __awaiter$5(this, void 0, void 0, function() {
    var params, url;
    return __generator$5(this, function(_a2) {
      params = stringify({ ak: accessKey, bucket: bucketName });
      url = protocol + "://api.qiniu.com/v2/query?" + params;
      return [2, request$1(url, { method: "GET" })];
    });
  });
}
function getBaseUrl(bucket, key, uploadInfo) {
  var url = uploadInfo.url, id = uploadInfo.id;
  return url + "/buckets/" + bucket + "/objects/" + (key != null ? urlSafeBase64Encode(key) : "~") + "/uploads/" + id;
}
function initUploadParts(token, bucket, key, uploadUrl) {
  var url = uploadUrl + "/buckets/" + bucket + "/objects/" + (key != null ? urlSafeBase64Encode(key) : "~") + "/uploads";
  return request$1(url, {
    method: "POST",
    headers: getAuthHeaders(token)
  });
}
function uploadChunk(token, key, index2, uploadInfo, options) {
  var bucket = getPutPolicy(token).bucketName;
  var url = getBaseUrl(bucket, key, uploadInfo) + ("/" + index2);
  var headers = getHeadersForChunkUpload(token);
  if (options.md5)
    headers["Content-MD5"] = options.md5;
  return request$1(url, __assign$4(__assign$4({}, options), { method: "PUT", headers }));
}
function uploadComplete(token, key, uploadInfo, options) {
  var bucket = getPutPolicy(token).bucketName;
  var url = getBaseUrl(bucket, key, uploadInfo);
  return request$1(url, __assign$4(__assign$4({}, options), { method: "POST", headers: getHeadersForMkFile(token) }));
}
function direct(url, data2, options) {
  return request$1(url, __assign$4({ method: "POST", body: data2 }, options));
}
var __assign$3 = globalThis && globalThis.__assign || function() {
  __assign$3 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$3.apply(this, arguments);
};
var __awaiter$4 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$4 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t[1]) {
              _2.label = t[1];
              t = op;
              break;
            }
            if (t && _2.label < t[2]) {
              _2.label = t[2];
              _2.ops.push(op);
              break;
            }
            if (t[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read$3 = globalThis && globalThis.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spread$3 = globalThis && globalThis.__spread || function() {
  for (var ar = [], i = 0; i < arguments.length; i++)
    ar = ar.concat(__read$3(arguments[i]));
  return ar;
};
var DEFAULT_CHUNK_SIZE = 4;
var FREEZE_CODE_LIST = [0, 502, 503, 504, 599];
var RETRY_CODE_LIST = __spread$3(FREEZE_CODE_LIST, [612]);
var GB = Math.pow(1024, 3);
var Base = function() {
  function Base2(options, handlers2, hostPool, logger) {
    this.hostPool = hostPool;
    this.logger = logger;
    this.aborted = false;
    this.retryCount = 0;
    this.xhrList = [];
    this.config = options.config;
    logger.info("config inited.", this.config);
    this.putExtra = __assign$3({ fname: "" }, options.putExtra);
    logger.info("putExtra inited.", this.putExtra);
    this.key = options.key;
    this.file = options.file;
    this.token = options.token;
    this.onData = handlers2.onData;
    this.onError = handlers2.onError;
    this.onComplete = handlers2.onComplete;
    try {
      var putPolicy = getPutPolicy(this.token);
      this.bucketName = putPolicy.bucketName;
      this.assessKey = putPolicy.assessKey;
    } catch (error) {
      logger.error("get putPolicy from token failed.", error);
      this.onError(error);
    }
  }
  Base2.prototype.checkAndUpdateUploadHost = function() {
    return __awaiter$4(this, void 0, void 0, function() {
      var newHost;
      return __generator$4(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            this.logger.info("get available upload host.");
            return [4, this.hostPool.getUp(this.assessKey, this.bucketName, this.config.upprotocol)];
          case 1:
            newHost = _a2.sent();
            if (newHost == null) {
              throw new QiniuError(QiniuErrorName.NotAvailableUploadHost, "no available upload host.");
            }
            if (this.uploadHost != null && this.uploadHost.host !== newHost.host) {
              this.logger.warn("host switches from " + this.uploadHost.host + " to " + newHost.host + ".");
            } else {
              this.logger.info("use host " + newHost.host + ".");
            }
            this.uploadHost = newHost;
            return [2];
        }
      });
    });
  };
  Base2.prototype.checkAndUnfreezeHost = function() {
    this.logger.info("check unfreeze host.");
    if (this.uploadHost != null && this.uploadHost.isFrozen()) {
      this.logger.warn(this.uploadHost.host + " will be unfrozen.");
      this.uploadHost.unfreeze();
    }
  };
  Base2.prototype.checkAndFreezeHost = function(error) {
    this.logger.info("check freeze host.");
    if (error instanceof QiniuRequestError && this.uploadHost != null) {
      if (FREEZE_CODE_LIST.includes(error.code)) {
        this.logger.warn(this.uploadHost.host + " will be temporarily frozen.");
        this.uploadHost.freeze();
      }
    }
  };
  Base2.prototype.handleError = function(error) {
    this.logger.error(error.message);
    this.onError(error);
  };
  Base2.prototype.putFile = function() {
    return __awaiter$4(this, void 0, void 0, function() {
      var result, err_1, notReachRetryCount, needRetry;
      return __generator$4(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            this.aborted = false;
            if (!this.putExtra.fname) {
              this.logger.info("use file.name as fname.");
              this.putExtra.fname = this.file.name;
            }
            if (this.file.size > 1e4 * GB) {
              this.handleError(new QiniuError(QiniuErrorName.InvalidFile, "file size exceed maximum value 10000G"));
              return [2];
            }
            if (this.putExtra.customVars) {
              if (!isCustomVarsValid(this.putExtra.customVars)) {
                this.handleError(new QiniuError(
                  QiniuErrorName.InvalidCustomVars,
                  "customVars key should start width x:"
                ));
                return [2];
              }
            }
            if (this.putExtra.metadata) {
              if (!isMetaDataValid(this.putExtra.metadata)) {
                this.handleError(new QiniuError(QiniuErrorName.InvalidMetadata, "metadata key should start with x-qn-meta-"));
                return [2];
              }
            }
            _a2.label = 1;
          case 1:
            _a2.trys.push([1, 4, , 5]);
            this.uploadAt = new Date().getTime();
            return [4, this.checkAndUpdateUploadHost()];
          case 2:
            _a2.sent();
            return [4, this.run()];
          case 3:
            result = _a2.sent();
            this.onComplete(result.data);
            this.checkAndUnfreezeHost();
            this.sendLog(result.reqId, 200);
            return [2];
          case 4:
            err_1 = _a2.sent();
            if (this.aborted) {
              this.logger.warn("upload is aborted.");
              this.sendLog("", -2);
              return [2];
            }
            this.clear();
            this.logger.error(err_1);
            if (err_1 instanceof QiniuRequestError) {
              this.sendLog(err_1.reqId, err_1.code);
              this.checkAndFreezeHost(err_1);
              notReachRetryCount = ++this.retryCount <= this.config.retryCount;
              needRetry = RETRY_CODE_LIST.includes(err_1.code);
              if (needRetry && notReachRetryCount) {
                this.logger.warn("error auto retry: " + this.retryCount + "/" + this.config.retryCount + ".");
                this.putFile();
                return [2];
              }
            }
            this.onError(err_1);
            return [3, 5];
          case 5:
            return [2];
        }
      });
    });
  };
  Base2.prototype.clear = function() {
    this.xhrList.forEach(function(xhr2) {
      xhr2.onreadystatechange = null;
      xhr2.abort();
    });
    this.xhrList = [];
    this.logger.info("cleanup uploading xhr.");
  };
  Base2.prototype.stop = function() {
    this.logger.info("aborted.");
    this.clear();
    this.aborted = true;
  };
  Base2.prototype.addXhr = function(xhr2) {
    this.xhrList.push(xhr2);
  };
  Base2.prototype.sendLog = function(reqId, code2) {
    var _a2, _b;
    this.logger.report({
      code: code2,
      reqId,
      remoteIp: "",
      upType: "jssdk-h5",
      size: this.file.size,
      time: Math.floor(this.uploadAt / 1e3),
      port: getPortFromUrl((_a2 = this.uploadHost) === null || _a2 === void 0 ? void 0 : _a2.getUrl()),
      host: getDomainFromUrl((_b = this.uploadHost) === null || _b === void 0 ? void 0 : _b.getUrl()),
      bytesSent: this.progress ? this.progress.total.loaded : 0,
      duration: Math.floor((new Date().getTime() - this.uploadAt) / 1e3)
    });
  };
  Base2.prototype.getProgressInfoItem = function(loaded, size, fromCache) {
    return __assign$3({
      size,
      loaded,
      percent: loaded / size * 100
    }, fromCache == null ? {} : { fromCache });
  };
  return Base2;
}();
var __extends$1 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (b2.hasOwnProperty(p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$2 = globalThis && globalThis.__assign || function() {
  __assign$2 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$2.apply(this, arguments);
};
var __awaiter$3 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$3 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t[1]) {
              _2.label = t[1];
              t = op;
              break;
            }
            if (t && _2.label < t[2]) {
              _2.label = t[2];
              _2.ops.push(op);
              break;
            }
            if (t[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
function isPositiveInteger(n) {
  var re = /^[1-9]\d*$/;
  return re.test(String(n));
}
var Resume = function(_super) {
  __extends$1(Resume2, _super);
  function Resume2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Resume2.prototype.run = function() {
    return __awaiter$3(this, void 0, void 0, function() {
      var pool, mkFileResponse, localKey, uploadChunks, error_1;
      var _this = this;
      return __generator$3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            this.logger.info("start run Resume.");
            if (!this.config.chunkSize || !isPositiveInteger(this.config.chunkSize)) {
              throw new QiniuError(QiniuErrorName.InvalidChunkSize, "chunkSize must be a positive integer");
            }
            if (this.config.chunkSize > 1024) {
              throw new QiniuError(QiniuErrorName.InvalidChunkSize, "chunkSize maximum value is 1024");
            }
            return [4, this.initBeforeUploadChunks()];
          case 1:
            _a2.sent();
            pool = new Pool(function(chunkInfo) {
              return __awaiter$3(_this, void 0, void 0, function() {
                return __generator$3(this, function(_a3) {
                  switch (_a3.label) {
                    case 0:
                      if (this.aborted) {
                        pool.abort();
                        throw new Error("pool is aborted");
                      }
                      return [4, this.uploadChunk(chunkInfo)];
                    case 1:
                      _a3.sent();
                      return [2];
                  }
                });
              });
            }, this.config.concurrentRequestLimit);
            mkFileResponse = null;
            localKey = this.getLocalKey();
            uploadChunks = this.chunks.map(function(chunk, index2) {
              return pool.enqueue({ chunk, index: index2 });
            });
            _a2.label = 2;
          case 2:
            _a2.trys.push([2, 5, , 6]);
            return [4, Promise.all(uploadChunks)];
          case 3:
            _a2.sent();
            return [4, this.mkFileReq()];
          case 4:
            mkFileResponse = _a2.sent();
            return [3, 6];
          case 5:
            error_1 = _a2.sent();
            if (error_1 instanceof QiniuRequestError && (error_1.code === 612 || error_1.code === 400)) {
              removeLocalFileInfo(localKey, this.logger);
            }
            throw error_1;
          case 6:
            removeLocalFileInfo(localKey, this.logger);
            return [2, mkFileResponse];
        }
      });
    });
  };
  Resume2.prototype.uploadChunk = function(chunkInfo) {
    return __awaiter$3(this, void 0, void 0, function() {
      var index2, chunk, cachedInfo, shouldCheckMD5, reuseSaved, md5, onProgress, requestOptions, response;
      var _this = this;
      return __generator$3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            index2 = chunkInfo.index, chunk = chunkInfo.chunk;
            cachedInfo = this.cachedUploadedList[index2];
            this.logger.info("upload part " + index2 + ", cache:", cachedInfo);
            shouldCheckMD5 = this.config.checkByMD5;
            reuseSaved = function() {
              _this.usedCacheList[index2] = true;
              _this.updateChunkProgress(chunk.size, index2);
              _this.uploadedList[index2] = cachedInfo;
              _this.updateLocalCache();
            };
            if (cachedInfo && !shouldCheckMD5) {
              reuseSaved();
              return [2];
            }
            return [4, computeMd5(chunk)];
          case 1:
            md5 = _a2.sent();
            this.logger.info("computed part md5.", md5);
            if (cachedInfo && md5 === cachedInfo.md5) {
              reuseSaved();
              return [2];
            }
            this.usedCacheList[index2] = false;
            onProgress = function(data2) {
              _this.updateChunkProgress(data2.loaded, index2);
            };
            requestOptions = {
              body: chunk,
              md5: this.config.checkByServer ? md5 : void 0,
              onProgress,
              onCreate: function(xhr2) {
                return _this.addXhr(xhr2);
              }
            };
            this.logger.info("part " + index2 + " start uploading.");
            return [4, uploadChunk(this.token, this.key, chunkInfo.index + 1, this.getUploadInfo(), requestOptions)];
          case 2:
            response = _a2.sent();
            this.logger.info("part " + index2 + " upload completed.");
            onProgress({
              loaded: chunk.size,
              total: chunk.size
            });
            this.uploadedList[index2] = {
              etag: response.data.etag,
              md5: response.data.md5,
              size: chunk.size
            };
            this.updateLocalCache();
            return [2];
        }
      });
    });
  };
  Resume2.prototype.mkFileReq = function() {
    return __awaiter$3(this, void 0, void 0, function() {
      var data2, result;
      var _this = this;
      return __generator$3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            data2 = __assign$2(__assign$2(__assign$2({ parts: this.uploadedList.map(function(value, index2) {
              return {
                etag: value.etag,
                partNumber: index2 + 1
              };
            }), fname: this.putExtra.fname }, this.putExtra.mimeType && { mimeType: this.putExtra.mimeType }), this.putExtra.customVars && { customVars: this.putExtra.customVars }), this.putExtra.metadata && { metadata: this.putExtra.metadata });
            this.logger.info("parts upload completed, make file.", data2);
            return [4, uploadComplete(this.token, this.key, this.getUploadInfo(), {
              onCreate: function(xhr2) {
                return _this.addXhr(xhr2);
              },
              body: JSON.stringify(data2)
            })];
          case 1:
            result = _a2.sent();
            this.logger.info("finish Resume Progress.");
            this.updateMkFileProgress(1);
            return [2, result];
        }
      });
    });
  };
  Resume2.prototype.initBeforeUploadChunks = function() {
    return __awaiter$3(this, void 0, void 0, function() {
      var cachedInfo, res, infoMessage;
      return __generator$3(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            this.uploadedList = [];
            this.usedCacheList = [];
            cachedInfo = getLocalFileInfo(this.getLocalKey(), this.logger);
            if (!!cachedInfo)
              return [3, 2];
            this.logger.info("init upload parts from api.");
            return [4, initUploadParts(this.token, this.bucketName, this.key, this.uploadHost.getUrl())];
          case 1:
            res = _a2.sent();
            this.logger.info("initd upload parts of id: " + res.data.uploadId + ".");
            this.uploadId = res.data.uploadId;
            this.cachedUploadedList = [];
            return [3, 3];
          case 2:
            infoMessage = [
              "resume upload parts from local cache,",
              "total " + cachedInfo.data.length + " part,",
              "id is " + cachedInfo.id + "."
            ];
            this.logger.info(infoMessage.join(" "));
            this.cachedUploadedList = cachedInfo.data;
            this.uploadId = cachedInfo.id;
            _a2.label = 3;
          case 3:
            this.chunks = getChunks(this.file, this.config.chunkSize);
            this.loaded = {
              mkFileProgress: 0,
              chunks: this.chunks.map(function(_2) {
                return 0;
              })
            };
            this.notifyResumeProgress();
            return [2];
        }
      });
    });
  };
  Resume2.prototype.getUploadInfo = function() {
    return {
      id: this.uploadId,
      url: this.uploadHost.getUrl()
    };
  };
  Resume2.prototype.getLocalKey = function() {
    return createLocalKey(this.file.name, this.key, this.file.size);
  };
  Resume2.prototype.updateLocalCache = function() {
    setLocalFileInfo(this.getLocalKey(), {
      id: this.uploadId,
      data: this.uploadedList
    }, this.logger);
  };
  Resume2.prototype.updateChunkProgress = function(loaded, index2) {
    this.loaded.chunks[index2] = loaded;
    this.notifyResumeProgress();
  };
  Resume2.prototype.updateMkFileProgress = function(progress) {
    this.loaded.mkFileProgress = progress;
    this.notifyResumeProgress();
  };
  Resume2.prototype.notifyResumeProgress = function() {
    var _this = this;
    this.progress = {
      total: this.getProgressInfoItem(
        sum(this.loaded.chunks) + this.loaded.mkFileProgress,
        this.file.size + 1
      ),
      chunks: this.chunks.map(function(chunk, index2) {
        var fromCache = _this.usedCacheList[index2];
        return _this.getProgressInfoItem(_this.loaded.chunks[index2], chunk.size, fromCache);
      }),
      uploadInfo: {
        id: this.uploadId,
        url: this.uploadHost.getUrl()
      }
    };
    this.onData(this.progress);
  };
  return Resume2;
}(Base);
var __awaiter$2 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$2 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t[1]) {
              _2.label = t[1];
              t = op;
              break;
            }
            if (t && _2.label < t[2]) {
              _2.label = t[2];
              _2.ops.push(op);
              break;
            }
            if (t[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var CRC32 = function() {
  function CRC322() {
    this.crc = -1;
    this.table = this.makeTable();
  }
  CRC322.prototype.makeTable = function() {
    var table = new Array();
    for (var i = 0; i < 256; i++) {
      var t = i;
      for (var j = 0; j < 8; j++) {
        if (t & 1) {
          t = t >>> 1 ^ 3988292384;
        } else {
          t >>>= 1;
        }
      }
      table[i] = t;
    }
    return table;
  };
  CRC322.prototype.append = function(data2) {
    var crc = this.crc;
    for (var offset = 0; offset < data2.byteLength; offset++) {
      crc = crc >>> 8 ^ this.table[(crc ^ data2[offset]) & 255];
    }
    this.crc = crc;
  };
  CRC322.prototype.compute = function() {
    return (this.crc ^ -1) >>> 0;
  };
  CRC322.prototype.readAsUint8Array = function(file) {
    return __awaiter$2(this, void 0, void 0, function() {
      var _a2;
      return __generator$2(this, function(_b) {
        switch (_b.label) {
          case 0:
            if (!(typeof file.arrayBuffer === "function"))
              return [3, 2];
            _a2 = Uint8Array.bind;
            return [4, file.arrayBuffer()];
          case 1:
            return [2, new (_a2.apply(Uint8Array, [void 0, _b.sent()]))()];
          case 2:
            return [2, new Promise(function(resolve, reject) {
              var reader = new FileReader();
              reader.onload = function() {
                if (reader.result == null) {
                  reject();
                  return;
                }
                if (typeof reader.result === "string") {
                  reject();
                  return;
                }
                resolve(new Uint8Array(reader.result));
              };
              reader.readAsArrayBuffer(file);
            })];
        }
      });
    });
  };
  CRC322.prototype.file = function(file) {
    return __awaiter$2(this, void 0, void 0, function() {
      var _a2, count, index2, start, end, chuck;
      return __generator$2(this, function(_b) {
        switch (_b.label) {
          case 0:
            if (!(file.size <= MB))
              return [3, 2];
            _a2 = this.append;
            return [4, this.readAsUint8Array(file)];
          case 1:
            _a2.apply(this, [_b.sent()]);
            return [2, this.compute()];
          case 2:
            count = Math.ceil(file.size / MB);
            index2 = 0;
            _b.label = 3;
          case 3:
            if (!(index2 < count))
              return [3, 6];
            start = index2 * MB;
            end = index2 === count - 1 ? file.size : start + MB;
            return [4, this.readAsUint8Array(file.slice(start, end))];
          case 4:
            chuck = _b.sent();
            this.append(new Uint8Array(chuck));
            _b.label = 5;
          case 5:
            index2++;
            return [3, 3];
          case 6:
            return [2, this.compute()];
        }
      });
    });
  };
  CRC322.file = function(file) {
    var crc = new CRC322();
    return crc.file(file);
  };
  return CRC322;
}();
var __extends = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (b2.hasOwnProperty(p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$1 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$1 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t[1]) {
              _2.label = t[1];
              t = op;
              break;
            }
            if (t && _2.label < t[2]) {
              _2.label = t[2];
              _2.ops.push(op);
              break;
            }
            if (t[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var Direct = function(_super) {
  __extends(Direct2, _super);
  function Direct2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Direct2.prototype.run = function() {
    return __awaiter$1(this, void 0, void 0, function() {
      var formData, crcSign, customVars_1, metadata_1, result;
      var _this = this;
      return __generator$1(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            this.logger.info("start run Direct.");
            formData = new FormData();
            formData.append("file", this.file);
            formData.append("token", this.token);
            if (this.key != null) {
              formData.append("key", this.key);
            }
            formData.append("fname", this.putExtra.fname);
            if (!this.config.checkByServer)
              return [3, 2];
            return [4, CRC32.file(this.file)];
          case 1:
            crcSign = _a2.sent();
            formData.append("crc32", crcSign.toString());
            _a2.label = 2;
          case 2:
            if (this.putExtra.customVars) {
              this.logger.info("init customVars.");
              customVars_1 = this.putExtra.customVars;
              Object.keys(customVars_1).forEach(function(key) {
                return formData.append(key, customVars_1[key].toString());
              });
              this.logger.info("customVars inited.");
            }
            if (this.putExtra.metadata) {
              this.logger.info("init metadata.");
              metadata_1 = this.putExtra.metadata;
              Object.keys(metadata_1).forEach(function(key) {
                return formData.append(key, metadata_1[key].toString());
              });
            }
            this.logger.info("formData inited.");
            return [4, direct(this.uploadHost.getUrl(), formData, {
              onProgress: function(data2) {
                _this.updateDirectProgress(data2.loaded, data2.total);
              },
              onCreate: function(xhr2) {
                return _this.addXhr(xhr2);
              }
            })];
          case 3:
            result = _a2.sent();
            this.logger.info("Direct progress finish.");
            this.finishDirectProgress();
            return [2, result];
        }
      });
    });
  };
  Direct2.prototype.updateDirectProgress = function(loaded, total) {
    this.progress = { total: this.getProgressInfoItem(loaded, total + 1) };
    this.onData(this.progress);
  };
  Direct2.prototype.finishDirectProgress = function() {
    if (!this.progress) {
      this.logger.warn("progress is null.");
      this.progress = { total: this.getProgressInfoItem(this.file.size, this.file.size) };
      this.onData(this.progress);
      return;
    }
    var total = this.progress.total;
    this.progress = { total: this.getProgressInfoItem(total.loaded + 1, total.size) };
    this.onData(this.progress);
  };
  return Direct2;
}(Base);
function reportV3(token, data2, retry) {
  if (retry === void 0) {
    retry = 3;
  }
  var xhr2 = createXHR();
  xhr2.open("POST", "https://uplog.qbox.me/log/3");
  xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhr2.setRequestHeader("Authorization", getAuthHeaders(token).Authorization);
  xhr2.onreadystatechange = function() {
    if (xhr2.readyState === 4 && xhr2.status !== 200 && retry > 0) {
      reportV3(token, data2, retry - 1);
    }
  };
  var stringifyData = [
    data2.code || "",
    data2.reqId || "",
    data2.host || "",
    data2.remoteIp || "",
    data2.port || "",
    data2.duration || "",
    data2.time || "",
    data2.bytesSent || "",
    data2.upType || "",
    data2.size || ""
  ].join(",");
  xhr2.send(stringifyData);
}
var __read$2 = globalThis && globalThis.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spread$2 = globalThis && globalThis.__spread || function() {
  for (var ar = [], i = 0; i < arguments.length; i++)
    ar = ar.concat(__read$2(arguments[i]));
  return ar;
};
var Logger = function() {
  function Logger2(token, disableReport, level, prefix) {
    if (disableReport === void 0) {
      disableReport = true;
    }
    if (level === void 0) {
      level = "OFF";
    }
    if (prefix === void 0) {
      prefix = "UPLOAD";
    }
    this.token = token;
    this.disableReport = disableReport;
    this.level = level;
    this.prefix = prefix;
    this.id = ++Logger2.id;
  }
  Logger2.prototype.getPrintPrefix = function(level) {
    return "Qiniu-JS-SDK [" + level + "][" + this.prefix + "#" + this.id + "]:";
  };
  Logger2.prototype.report = function(data2, retry) {
    if (this.disableReport)
      return;
    try {
      reportV3(this.token, data2, retry);
    } catch (error) {
      this.warn(error);
    }
  };
  Logger2.prototype.info = function() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var allowLevel = ["INFO"];
    if (allowLevel.includes(this.level)) {
      console.log.apply(console, __spread$2([this.getPrintPrefix("INFO")], args));
    }
  };
  Logger2.prototype.warn = function() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var allowLevel = ["INFO", "WARN"];
    if (allowLevel.includes(this.level)) {
      console.warn.apply(console, __spread$2([this.getPrintPrefix("WARN")], args));
    }
  };
  Logger2.prototype.error = function() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var allowLevel = ["INFO", "WARN", "ERROR"];
    if (allowLevel.includes(this.level)) {
      console.error.apply(console, __spread$2([this.getPrintPrefix("ERROR")], args));
    }
  };
  Logger2.id = 0;
  return Logger2;
}();
var __awaiter = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = globalThis && globalThis.__generator || function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t[1]) {
              _2.label = t[1];
              t = op;
              break;
            }
            if (t && _2.label < t[2]) {
              _2.label = t[2];
              _2.ops.push(op);
              break;
            }
            if (t[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read$1 = globalThis && globalThis.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spread$1 = globalThis && globalThis.__spread || function() {
  for (var ar = [], i = 0; i < arguments.length; i++)
    ar = ar.concat(__read$1(arguments[i]));
  return ar;
};
var unfreezeTimeMap = /* @__PURE__ */ new Map();
var Host = function() {
  function Host2(host, protocol) {
    this.host = host;
    this.protocol = protocol;
  }
  Host2.prototype.isFrozen = function() {
    var currentTime = new Date().getTime();
    var unfreezeTime = unfreezeTimeMap.get(this.host);
    return unfreezeTime != null && unfreezeTime >= currentTime;
  };
  Host2.prototype.freeze = function(time) {
    if (time === void 0) {
      time = 20;
    }
    var unfreezeTime = new Date().getTime() + time * 1e3;
    unfreezeTimeMap.set(this.host, unfreezeTime);
  };
  Host2.prototype.unfreeze = function() {
    unfreezeTimeMap["delete"](this.host);
  };
  Host2.prototype.getUrl = function() {
    return this.protocol + "://" + this.host;
  };
  Host2.prototype.getUnfreezeTime = function() {
    return unfreezeTimeMap.get(this.host);
  };
  return Host2;
}();
var HostPool = function() {
  function HostPool2(initHosts) {
    if (initHosts === void 0) {
      initHosts = [];
    }
    this.initHosts = initHosts;
    this.cachedHostsMap = /* @__PURE__ */ new Map();
  }
  HostPool2.prototype.register = function(accessKey, bucketName, hosts, protocol) {
    this.cachedHostsMap.set(accessKey + "@" + bucketName, hosts.map(function(host) {
      return new Host(host, protocol);
    }));
  };
  HostPool2.prototype.refresh = function(accessKey, bucketName, protocol) {
    var _a2, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function() {
      var cachedHostList, response, stashHosts;
      return __generator(this, function(_e) {
        switch (_e.label) {
          case 0:
            cachedHostList = this.cachedHostsMap.get(accessKey + "@" + bucketName) || [];
            if (cachedHostList.length > 0)
              return [2];
            if (this.initHosts.length > 0) {
              this.register(accessKey, bucketName, this.initHosts, protocol);
              return [2];
            }
            return [4, getUpHosts(accessKey, bucketName, protocol)];
          case 1:
            response = _e.sent();
            if ((response === null || response === void 0 ? void 0 : response.data) != null) {
              stashHosts = __spread$1(((_b = (_a2 = response.data.up) === null || _a2 === void 0 ? void 0 : _a2.acc) === null || _b === void 0 ? void 0 : _b.main) || [], ((_d = (_c = response.data.up) === null || _c === void 0 ? void 0 : _c.acc) === null || _d === void 0 ? void 0 : _d.backup) || []);
              this.register(accessKey, bucketName, stashHosts, protocol);
            }
            return [2];
        }
      });
    });
  };
  HostPool2.prototype.getUp = function(accessKey, bucketName, protocol) {
    return __awaiter(this, void 0, void 0, function() {
      var cachedHostList, availableHostList, priorityQueue;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, this.refresh(accessKey, bucketName, protocol)];
          case 1:
            _a2.sent();
            cachedHostList = this.cachedHostsMap.get(accessKey + "@" + bucketName) || [];
            if (cachedHostList.length === 0)
              return [2, null];
            availableHostList = cachedHostList.filter(function(host) {
              return !host.isFrozen();
            });
            if (availableHostList.length > 0)
              return [
                2,
                availableHostList[0]
              ];
            priorityQueue = cachedHostList.slice().sort(function(hostA, hostB) {
              return (hostA.getUnfreezeTime() || 0) - (hostB.getUnfreezeTime() || 0);
            });
            return [2, priorityQueue[0]];
        }
      });
    });
  };
  return HostPool2;
}();
function createUploadManager(options, handlers2, hostPool, logger) {
  if (options.config && options.config.forceDirect) {
    logger.info("ues forceDirect mode.");
    return new Direct(options, handlers2, hostPool, logger);
  }
  if (options.file.size > 4 * MB) {
    logger.info("file size over 4M, use Resume.");
    return new Resume(options, handlers2, hostPool, logger);
  }
  logger.info("file size less or equal than 4M, use Direct.");
  return new Direct(options, handlers2, hostPool, logger);
}
function upload(file, key, token, putExtra, config) {
  var logger = new Logger(token, config === null || config === void 0 ? void 0 : config.disableStatisticsReport, config === null || config === void 0 ? void 0 : config.debugLogLevel, file.name);
  var options = {
    file,
    key,
    token,
    putExtra,
    config: normalizeUploadConfig(config, logger)
  };
  var hostPool = new HostPool(options.config.uphost);
  return new Observable(function(observer) {
    var manager = createUploadManager(options, {
      onData: function(data2) {
        return observer.next(data2);
      },
      onError: function(err) {
        return observer.error(err);
      },
      onComplete: function(res) {
        return observer.complete(res);
      }
    }, hostPool, logger);
    manager.putFile();
    return manager.stop.bind(manager);
  });
}
var __assign$1 = globalThis && globalThis.__assign || function() {
  __assign$1 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
var __rest = globalThis && globalThis.__rest || function(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
var __read = globalThis && globalThis.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spread = globalThis && globalThis.__spread || function() {
  for (var ar = [], i = 0; i < arguments.length; i++)
    ar = ar.concat(__read(arguments[i]));
  return ar;
};
function normalizeUploadConfig(config, logger) {
  var _a2 = __assign$1({}, config), upprotocol = _a2.upprotocol, uphost = _a2.uphost, otherConfig = __rest(_a2, ["upprotocol", "uphost"]);
  var normalizeConfig = __assign$1({ uphost: [], retryCount: 3, checkByMD5: false, forceDirect: false, useCdnDomain: true, checkByServer: false, concurrentRequestLimit: 3, chunkSize: DEFAULT_CHUNK_SIZE, upprotocol: "https", debugLogLevel: "OFF", disableStatisticsReport: false }, otherConfig);
  if (upprotocol) {
    normalizeConfig.upprotocol = upprotocol.replace(/:$/, "");
  }
  var hostList = [];
  if (logger && (config === null || config === void 0 ? void 0 : config.uphost) != null && (config === null || config === void 0 ? void 0 : config.region) != null) {
    logger.warn("do not use both the uphost and region config.");
  }
  if (uphost) {
    if (Array.isArray(uphost)) {
      hostList.push.apply(hostList, __spread(uphost));
    } else {
      hostList.push(uphost);
    }
  } else if (normalizeConfig === null || normalizeConfig === void 0 ? void 0 : normalizeConfig.region) {
    var hostMap = regionUphostMap[normalizeConfig === null || normalizeConfig === void 0 ? void 0 : normalizeConfig.region];
    if (normalizeConfig.useCdnDomain) {
      hostList.push.apply(hostList, __spread(hostMap.cdnUphost));
    } else {
      hostList.push.apply(hostList, __spread(hostMap.srcUphost));
    }
  }
  return __assign$1(__assign$1({}, normalizeConfig), { uphost: hostList.filter(Boolean) });
}
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
globalThis && globalThis.__generator || function(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t = _2.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t[1]) {
              _2.label = t[1];
              t = op;
              break;
            }
            if (t && _2.label < t[2]) {
              _2.label = t[2];
              _2.ops.push(op);
              break;
            }
            if (t[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var mimeTypes = {
  PNG: "image/png",
  JPEG: "image/jpeg",
  WEBP: "image/webp",
  BMP: "image/bmp"
};
Object.keys(mimeTypes).map(function(type) {
  return mimeTypes[type];
});
mimeTypes.JPEG;
var viewer = "";
var index_vue_vue_type_style_index_0_lang$2 = "";
const _sfc_main$K = {
  components: {
    Draggable: draggableComponent
  },
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    token: {
      type: String,
      default: ""
    },
    domain: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 9
    },
    isQiniu: {
      type: Boolean,
      default: false
    },
    isDelete: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    meitu: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    headers: {
      type: Array,
      default: () => []
    },
    ui: {
      type: String,
      default: "element"
    },
    containerKey: {
      type: String,
      default: ""
    },
    withCredentials: {
      type: Boolean,
      default: false
    },
    printRead: {
      type: Boolean,
      default: false
    },
    onSelect: {
      type: Function,
      default: void 0
    }
  },
  emits: ["update:modelValue", "on-upload-success", "on-upload-error", "on-upload-progress", "on-upload-remove", "on-meitu"],
  data() {
    return {
      fileList: this.modelValue.map((item) => {
        return {
          ...item,
          key: item.key ? item.key : new Date().getTime() + "_" + Math.ceil(Math.random() * 99999)
        };
      }),
      viewer: null,
      uploadId: "upload_" + new Date().getTime(),
      editIndex: -1,
      meituIndex: -1
    };
  },
  computed: {
    miniWidth() {
      if (this.width > this.height) {
        return this.height;
      } else {
        return this.width;
      }
    }
  },
  methods: {
    handleChange() {
      const files = this.$refs.uploadInput.files;
      if (this.editIndex < 0 && this.fileList.length + files.length > this.limit) {
        this.$refs.uploadInput.value = [];
        return false;
      }
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let rFile = this.onSelect(file);
        if (rFile === false) {
          return false;
        }
        if (rFile instanceof File) {
          file = rFile;
        }
        const reader = new FileReader();
        const key = new Date().getTime() + "_" + Math.ceil(Math.random() * 99999);
        reader.readAsDataURL(file);
        reader.onload = () => {
          if (this.editIndex >= 0) {
            this.fileList[this.editIndex] = {
              key,
              url: reader.result,
              percent: 0,
              status: "uploading"
            };
            this.editIndex = -1;
          } else {
            this.fileList.push({
              key,
              url: reader.result,
              percent: 0,
              status: "uploading"
            });
          }
          this.$nextTick(() => {
            if (this.isQiniu) {
              this.uploadAction2(reader.result, file, key);
            } else {
              this.uploadAction(reader.result, file, key);
            }
          });
        };
      }
      this.$refs.uploadInput.value = [];
    },
    uploadAction(res, file, key) {
      this.fileList.findIndex((item) => item.key === key);
      const xhr2 = new XMLHttpRequest();
      const url = this.action;
      xhr2.open("POST", url, true);
      this.headers.map((item) => {
        item.key && xhr2.setRequestHeader(item.key, item.value);
      });
      let formData = new FormData();
      formData.append("file", file);
      formData.append("fname", file.name);
      formData.append("key", key);
      xhr2.withCredentials = this.withCredentials;
      xhr2.onreadystatechange = () => {
        if (xhr2.readyState === 4) {
          let resData = JSON.parse(xhr2.response);
          if (resData && resData.url) {
            this.fileList[this.fileList.findIndex((item) => item.key === key)] = {
              ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
              url: resData.url,
              percent: 100,
              ...resData
            };
            setTimeout(() => {
              this.fileList[this.fileList.findIndex((item) => item.key === key)] = {
                ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
                status: "success"
              };
              this.$emit("on-upload-success", {
                ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
                status: "success"
              });
              this.$emit("update:modelValue", this.fileList);
            }, 200);
          } else {
            this.fileList[this.fileList.findIndex((item) => item.key === key)] = {
              ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
              status: "error"
            };
            this.$emit("on-upload-error", {
              ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
              status: "error"
            });
            this.fileList.splice(this.fileList.findIndex((item) => item.key === key), 1);
          }
        }
      };
      xhr2.upload.onprogress = (res2) => {
        if (res2.total && res2.loaded) {
          this.fileList[this.fileList.findIndex((item) => item.key === key)].percent = res2.loaded == res2.total ? 99 : parseInt(res2.loaded / res2.total * 100);
          this.$emit("on-upload-progress", {
            ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
            status: "uploading",
            percent: res2.loaded == res2.total ? 99 : parseInt(res2.loaded / res2.total * 100)
          });
        }
      };
      xhr2.send(formData);
    },
    uploadAction2(res, file, key) {
      const _this = this;
      const observable = upload(file, key, this.token, {
        fname: key,
        mimeType: []
      }, {
        useCdnDomain: true
      });
      observable.subscribe({
        next(res2) {
          _this.fileList[_this.fileList.findIndex((item) => item.key === key)].percent = parseInt(res2.total.percent);
          _this.$emit("on-upload-progress", {
            ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
            status: "uploading",
            percent: parseInt(res2.total.percent)
          });
        },
        error(err) {
          _this.$message.error(err.message);
          _this.fileList[_this.fileList.findIndex((item) => item.key === key)] = {
            ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
            status: "error"
          };
          _this.$emit("on-upload-error", {
            ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
            status: "error"
          });
          _this.fileList.splice(_this.fileList.findIndex((item) => item.key === key), 1);
        },
        complete(res2) {
          _this.fileList[_this.fileList.findIndex((item) => item.key === key)] = {
            ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
            url: _this.domain + res2.key,
            percent: 100,
            ...res2
          };
          setTimeout(() => {
            _this.fileList[_this.fileList.findIndex((item) => item.key === key)] = {
              ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
              status: "success"
            };
            _this.$emit("on-upload-success", {
              ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
              status: "success"
            });
            _this.$emit("update:modelValue", _this.fileList);
          }, 200);
        }
      });
    },
    handleRemove(key) {
      this.$emit("on-upload-remove", this.fileList[this.fileList.findIndex((item) => item.key === key)]);
      this.fileList.splice(this.fileList.findIndex((item) => item.key === key), 1);
      this.$nextTick(() => {
        this.$emit("update:modelValue", this.fileList);
      });
    },
    handleEdit(key) {
      this.editIndex = this.fileList.findIndex((item) => item.key === key);
      this.$refs.uploadInput.click();
    },
    handleMeitu(key) {
      this.$emit("on-meitu", this.fileList.findIndex((item) => item.key === key));
    },
    handleAdd() {
      if (!this.disabled) {
        this.editIndex = -1;
        this.$refs.uploadInput.click();
      }
    },
    handlePreviewFile(key) {
      this.viewer && this.viewer.destroy();
      this.uploadId = "upload_" + new Date().getTime();
      this.$nextTick(() => {
        this.viewer = new Viewer$1(document.getElementById(this.uploadId));
        this.viewer.view(this.fileList.findIndex((item) => item.key === key));
      });
    }
  },
  watch: {
    modelValue(val) {
      this.fileList = this.modelValue.map((item) => {
        return {
          ...item,
          key: item.key ? item.key : new Date().getTime() + "_" + Math.ceil(Math.random() * 99999)
        };
      });
    }
  }
};
const _hoisted_1$t = ["id"];
const _hoisted_2$r = ["id"];
const _hoisted_3$m = ["src"];
const _hoisted_4$l = {
  key: 2,
  class: "item-status"
};
const _hoisted_5$l = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-check1",
  style: { "color": "#fff", "transform": "rotate(-45deg)", "line-height": "12px", "display": "block" }
}, null, -1);
const _hoisted_6$j = [
  _hoisted_5$l
];
const _hoisted_7$i = ["title", "onClick"];
const _hoisted_8$b = ["title", "onClick"];
const _hoisted_9$a = ["title", "onClick"];
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_progress = resolveComponent("el-progress");
  const _component_a_progress = resolveComponent("a-progress");
  const _component_draggable = resolveComponent("draggable");
  return openBlock(), createElementBlock("div", {
    class: "fm-uplaod-container",
    id: $data.uploadId
  }, [
    createVNode(_component_draggable, mergeProps({
      class: "drag-img-list",
      modelValue: $data.fileList,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.fileList = $event)
    }, { group: $data.uploadId, ghostClass: "ghost", animation: 200 }, {
      "no-transition-on-drag": true,
      "item-key": "key"
    }), {
      item: withCtx(({ element: item }) => [
        (openBlock(), createElementBlock("div", {
          id: item.key,
          style: normalizeStyle({ width: $props.width + "px", height: $props.height + "px" }),
          class: normalizeClass([{ uploading: item.status == "uploading", "is-success": item.status == "success", "is-disabled": $props.disabled }, "upload-file"]),
          key: item.key
        }, [
          createElementVNode("img", {
            src: item.url
          }, null, 8, _hoisted_3$m),
          item.status == "uploading" && $props.ui == "element" ? (openBlock(), createBlock(_component_el_progress, {
            key: 0,
            width: $options.miniWidth * 0.9,
            class: "upload-progress",
            type: "circle",
            percentage: item.percent
          }, null, 8, ["width", "percentage"])) : createCommentVNode("", true),
          item.status == "uploading" && $props.ui == "antd" ? (openBlock(), createBlock(_component_a_progress, {
            key: 1,
            size: $options.miniWidth * 0.9,
            class: "upload-progress",
            type: "circle",
            percent: item.percent
          }, null, 8, ["size", "percent"])) : createCommentVNode("", true),
          item.status == "success" ? (openBlock(), createElementBlock("label", _hoisted_4$l, _hoisted_6$j)) : createCommentVNode("", true),
          createElementVNode("div", {
            class: "uplaod-action",
            style: normalizeStyle({ height: $options.miniWidth / 4 + "px" })
          }, [
            createElementVNode("i", {
              class: "fm-iconfont icon-tupianyulan",
              title: _ctx.$t("fm.upload.preview"),
              onClick: ($event) => $options.handlePreviewFile(item.key),
              style: normalizeStyle({ "font-size": $options.miniWidth / 8 + "px" })
            }, null, 12, _hoisted_7$i),
            $props.isEdit && !$props.disabled && !$props.printRead ? (openBlock(), createElementBlock("i", {
              key: 0,
              class: "fm-iconfont icon-sync1",
              title: _ctx.$t("fm.upload.edit"),
              onClick: ($event) => $options.handleEdit(item.key),
              style: normalizeStyle({ "font-size": $options.miniWidth / 8 + "px" })
            }, null, 12, _hoisted_8$b)) : createCommentVNode("", true),
            $props.isDelete && $data.fileList.length > $props.min && !$props.disabled && !$props.printRead ? (openBlock(), createElementBlock("i", {
              key: 1,
              class: "fm-iconfont icon-delete",
              title: _ctx.$t("fm.upload.delete"),
              onClick: ($event) => $options.handleRemove(item.key),
              style: normalizeStyle({ "font-size": $options.miniWidth / 8 + "px" })
            }, null, 12, _hoisted_9$a)) : createCommentVNode("", true)
          ], 4)
        ], 14, _hoisted_2$r))
      ]),
      _: 1
    }, 16, ["modelValue"]),
    !$props.readonly ? withDirectives((openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass({ "is-disabled": $props.disabled, "el-upload": $props.ui == "element", "el-upload--picture-card": $props.ui == "element", "ant-upload": $props.ui == "antd", "ant-upload-select": $props.ui == "antd", "ant-upload-select-picture-card": $props.ui == "antd" }),
      style: normalizeStyle({ width: $props.width + "px", height: $props.height + "px" }),
      onClick: _cache[4] || (_cache[4] = withModifiers((...args) => $options.handleAdd && $options.handleAdd(...args), ["self"]))
    }, [
      createElementVNode("i", {
        onClick: _cache[1] || (_cache[1] = withModifiers((...args) => $options.handleAdd && $options.handleAdd(...args), ["self"])),
        class: "fm-iconfont icon-plus",
        style: normalizeStyle({ fontSize: $options.miniWidth / 4 + "px", lineHeight: $options.miniWidth / 4 + "px", marginTop: -$options.miniWidth / 8 + "px", marginLeft: -$options.miniWidth / 8 + "px", position: "absolute", top: $props.height / 2 + "px", left: $props.width / 2 + "px" })
      }, null, 4),
      $props.multiple ? (openBlock(), createElementBlock("input", {
        key: 0,
        accept: "image/*",
        multiple: "",
        ref: "uploadInput",
        onChange: _cache[2] || (_cache[2] = (...args) => $options.handleChange && $options.handleChange(...args)),
        type: "file",
        style: { width: 0, height: 0 },
        name: "file",
        class: "upload-input"
      }, null, 544)) : (openBlock(), createElementBlock("input", {
        key: 1,
        accept: "image/*",
        ref: "uploadInput",
        onChange: _cache[3] || (_cache[3] = (...args) => $options.handleChange && $options.handleChange(...args)),
        type: "file",
        style: { width: 0, height: 0 },
        name: "file",
        class: "upload-input"
      }, null, 544))
    ], 6)), [
      [vShow, (!$props.isQiniu || $props.isQiniu && $props.token) && $data.fileList.length < $props.limit]
    ]) : createCommentVNode("", true)
  ], 8, _hoisted_1$t);
}
var FmUpload = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["render", _sfc_render$I]]);
const _sfc_main$J = {
  components: {
    FmUpload,
    Editor: _sfc_main$Z
  },
  props: ["element", "isTable"],
  data() {
    return {
      key: Math.random().toString(36).slice(-8),
      elementKey: Math.random().toString(36).slice(-8)
    };
  },
  created() {
    if (this.element.type == "component") {
      this.$options.components[`component-${this.element.key}`] = {
        template: `${this.element.options.template}`,
        props: ["modelValue"],
        data: () => ({
          dataModel: this.modelValue
        })
      };
    }
  },
  beforeUnmount() {
    if (this.$options.components[`component-${this.element.key}`]) {
      this.$options.components[`component-${this.element.key}`] = null;
    }
  },
  watch: {
    "element.options.template": function(val) {
      this.$options.components[`component-${this.element.key}`] = {
        template: `${val}`,
        props: ["modelValue"],
        data: () => ({
          dataModel: this.modelValue
        })
      };
      this.key = Math.random().toString(36).slice(-8);
    },
    "element.options.defaultValue": function(val) {
      this.elementKey = Math.random().toString(36).slice(-8);
    }
  }
};
const _hoisted_1$s = {
  key: 16,
  style: { "height": "50px", "color": "#999", "line-height": "50px", "text-align": "center", "width": "100%" }
};
const _hoisted_2$q = ["innerHTML"];
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = resolveComponent("el-input");
  const _component_el_input_number = resolveComponent("el-input-number");
  const _component_el_radio = resolveComponent("el-radio");
  const _component_el_radio_group = resolveComponent("el-radio-group");
  const _component_el_checkbox = resolveComponent("el-checkbox");
  const _component_el_checkbox_group = resolveComponent("el-checkbox-group");
  const _component_el_time_picker = resolveComponent("el-time-picker");
  const _component_el_date_picker = resolveComponent("el-date-picker");
  const _component_el_rate = resolveComponent("el-rate");
  const _component_el_color_picker = resolveComponent("el-color-picker");
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  const _component_el_switch = resolveComponent("el-switch");
  const _component_el_slider = resolveComponent("el-slider");
  const _component_fm_upload = resolveComponent("fm-upload");
  const _component_el_cascader = resolveComponent("el-cascader");
  const _component_el_tree_select = resolveComponent("el-tree-select");
  const _component_Editor = resolveComponent("Editor");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_upload = resolveComponent("el-upload");
  const _component_el_link = resolveComponent("el-link");
  const _component_el_step = resolveComponent("el-step");
  const _component_el_steps = resolveComponent("el-steps");
  const _component_el_transfer = resolveComponent("el-transfer");
  const _component_el_pagination = resolveComponent("el-pagination");
  return openBlock(), createElementBlock(Fragment, null, [
    $props.element.type == "input" ? (openBlock(), createBlock(_component_el_input, mergeProps({
      key: 0,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $props.element.options.defaultValue = $event),
      style: { width: $props.isTable ? "100%" : $props.element.options.width },
      placeholder: $props.element.options.placeholder,
      disabled: $props.element.options.disabled,
      "show-password": $props.element.options.showPassword,
      maxlength: $props.element.options.maxlength,
      "show-word-limit": $props.element.options.showWordLimit
    }, $props.element.options.customProps), null, 16, ["modelValue", "style", "placeholder", "disabled", "show-password", "maxlength", "show-word-limit"])) : createCommentVNode("", true),
    $props.element.type == "textarea" ? (openBlock(), createBlock(_component_el_input, mergeProps({
      key: 1,
      type: "textarea",
      rows: $props.element.options.rows,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $props.element.options.defaultValue = $event),
      style: { width: $props.isTable ? "100%" : $props.element.options.width },
      disabled: $props.element.options.disabled,
      placeholder: $props.element.options.placeholder,
      maxlength: $props.element.options.maxlength,
      "show-word-limit": $props.element.options.showWordLimit,
      autosize: $props.element.options.autosize
    }, $props.element.options.customProps), null, 16, ["rows", "modelValue", "style", "disabled", "placeholder", "maxlength", "show-word-limit", "autosize"])) : createCommentVNode("", true),
    $props.element.type == "number" ? (openBlock(), createBlock(_component_el_input_number, mergeProps({
      key: 2,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $props.element.options.defaultValue = $event),
      disabled: $props.element.options.disabled,
      "controls-position": $props.element.options.controlsPosition,
      precision: $props.element.options.precision,
      controls: $props.element.options.controls,
      style: { width: $props.isTable ? "100%" : $props.element.options.width }
    }, $props.element.options.customProps), null, 16, ["modelValue", "disabled", "controls-position", "precision", "controls", "style"])) : createCommentVNode("", true),
    $props.element.type == "radio" ? (openBlock(), createBlock(_component_el_radio_group, mergeProps({
      key: 3,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $props.element.options.defaultValue = $event),
      style: { width: $props.isTable ? "100%" : $props.element.options.width, display: "block" },
      disabled: $props.element.options.disabled
    }, $props.element.options.customProps), {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.options.options, (item, index2) => {
          return openBlock(), createBlock(_component_el_radio, {
            style: normalizeStyle({ display: $props.element.options.inline ? "inline-block" : "block" }),
            label: item.value,
            value: item.value,
            key: item.value + index2
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1($props.element.options.showLabel ? item.label : item.value), 1)
            ]),
            _: 2
          }, 1032, ["style", "label", "value"]);
        }), 128))
      ]),
      _: 1
    }, 16, ["modelValue", "style", "disabled"])) : createCommentVNode("", true),
    $props.element.type == "checkbox" ? (openBlock(), createBlock(_component_el_checkbox_group, mergeProps({
      key: 4,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $props.element.options.defaultValue = $event),
      style: { width: $props.isTable ? "100%" : $props.element.options.width },
      disabled: $props.element.options.disabled
    }, $props.element.options.customProps), {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.options.options, (item, index2) => {
          return openBlock(), createBlock(_component_el_checkbox, {
            style: normalizeStyle({ display: $props.element.options.inline ? "inline-block" : "block" }),
            label: item.value,
            value: item.value,
            key: item.value + index2
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1($props.element.options.showLabel ? item.label : item.value), 1)
            ]),
            _: 2
          }, 1032, ["style", "label", "value"]);
        }), 128))
      ]),
      _: 1
    }, 16, ["modelValue", "style", "disabled"])) : createCommentVNode("", true),
    $props.element.type == "time" ? (openBlock(), createBlock(_component_el_time_picker, mergeProps({
      key: $data.elementKey,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $props.element.options.defaultValue = $event),
      "is-range": $props.element.options.isRange,
      placeholder: $props.element.options.placeholder,
      "start-placeholder": $props.element.options.startPlaceholder,
      "end-placeholder": $props.element.options.endPlaceholder,
      readonly: $props.element.options.readonly,
      disabled: $props.element.options.disabled,
      editable: $props.element.options.editable,
      clearable: $props.element.options.clearable,
      style: { width: $props.isTable ? "100%" : $props.element.options.width },
      "value-format": $props.element.options.format
    }, $props.element.options.customProps), null, 16, ["modelValue", "is-range", "placeholder", "start-placeholder", "end-placeholder", "readonly", "disabled", "editable", "clearable", "style", "value-format"])) : createCommentVNode("", true),
    $props.element.type == "date" ? (openBlock(), createBlock(_component_el_date_picker, mergeProps({
      key: $data.elementKey,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $props.element.options.defaultValue = $event),
      type: $props.element.options.type,
      "is-range": $props.element.options.isRange,
      placeholder: $props.element.options.placeholder,
      "start-placeholder": $props.element.options.startPlaceholder,
      "end-placeholder": $props.element.options.endPlaceholder,
      readonly: $props.element.options.readonly,
      disabled: $props.element.options.disabled,
      editable: $props.element.options.editable,
      clearable: $props.element.options.clearable,
      "value-format": $props.element.options.timestamp ? "timestamp" : $props.element.options.format,
      format: $props.element.options.format,
      style: { width: $props.isTable ? "100%" : $props.element.options.width }
    }, $props.element.options.customProps), null, 16, ["modelValue", "type", "is-range", "placeholder", "start-placeholder", "end-placeholder", "readonly", "disabled", "editable", "clearable", "value-format", "format", "style"])) : createCommentVNode("", true),
    $props.element.type == "rate" ? (openBlock(), createBlock(_component_el_rate, mergeProps({
      key: 7,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => $props.element.options.defaultValue = $event),
      max: $props.element.options.max,
      disabled: $props.element.options.disabled,
      "allow-half": $props.element.options.allowHalf,
      "show-score": $props.element.options.showScore,
      style: { width: $props.isTable ? "100%" : $props.element.options.width, display: "inline-block" }
    }, $props.element.options.customProps), null, 16, ["modelValue", "max", "disabled", "allow-half", "show-score", "style"])) : createCommentVNode("", true),
    $props.element.type == "color" ? (openBlock(), createBlock(_component_el_color_picker, mergeProps({
      key: 8,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => $props.element.options.defaultValue = $event),
      disabled: $props.element.options.disabled,
      "show-alpha": $props.element.options.showAlpha
    }, $props.element.options.customProps), null, 16, ["modelValue", "disabled", "show-alpha"])) : createCommentVNode("", true),
    $props.element.type == "select" ? (openBlock(), createBlock(_component_el_select, mergeProps({
      key: 9,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => $props.element.options.defaultValue = $event),
      disabled: $props.element.options.disabled,
      multiple: $props.element.options.multiple,
      clearable: $props.element.options.clearable,
      placeholder: $props.element.options.placeholder,
      style: { width: $props.isTable ? "100%" : $props.element.options.width }
    }, $props.element.options.customProps), {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.options.options, (item) => {
          return openBlock(), createBlock(_component_el_option, {
            key: item.value,
            value: item.value,
            label: $props.element.options.showLabel ? item.label : item.value
          }, null, 8, ["value", "label"]);
        }), 128))
      ]),
      _: 1
    }, 16, ["modelValue", "disabled", "multiple", "clearable", "placeholder", "style"])) : createCommentVNode("", true),
    $props.element.type == "switch" ? (openBlock(), createBlock(_component_el_switch, mergeProps({
      key: 10,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $props.element.options.defaultValue = $event),
      disabled: $props.element.options.disabled,
      style: { width: $props.isTable ? "100%" : $props.element.options.width }
    }, $props.element.options.customProps), null, 16, ["modelValue", "disabled", "style"])) : createCommentVNode("", true),
    $props.element.type == "slider" ? (openBlock(), createBlock(_component_el_slider, mergeProps({
      key: 11,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => $props.element.options.defaultValue = $event),
      min: $props.element.options.min,
      max: $props.element.options.max,
      disabled: $props.element.options.disabled,
      step: $props.element.options.step,
      "show-input": $props.element.options.showInput,
      range: $props.element.options.range,
      style: { width: $props.isTable ? "100%" : $props.element.options.width }
    }, $props.element.options.customProps), null, 16, ["modelValue", "min", "max", "disabled", "step", "show-input", "range", "style"])) : createCommentVNode("", true),
    $props.element.type == "imgupload" ? (openBlock(), createBlock(_component_fm_upload, {
      key: 12,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => $props.element.options.defaultValue = $event),
      disabled: $props.element.options.disabled,
      style: normalizeStyle({ "width": $props.isTable ? "100%" : $props.element.options.width }),
      width: $props.element.options.size.width,
      height: $props.element.options.size.height,
      token: "xxx",
      domain: "xxx"
    }, null, 8, ["modelValue", "disabled", "style", "width", "height"])) : createCommentVNode("", true),
    $props.element.type == "cascader" ? (openBlock(), createBlock(_component_el_cascader, mergeProps({
      key: 13,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => $props.element.options.defaultValue = $event),
      disabled: $props.element.options.disabled,
      clearable: $props.element.options.clearable,
      placeholder: $props.element.options.placeholder,
      style: { width: $props.isTable ? "100%" : $props.element.options.width },
      options: $props.element.options.remote ? [] : $props.element.options.options,
      props: { multiple: $props.element.options.multiple, checkStrictly: $props.element.options.checkStrictly }
    }, $props.element.options.customProps), null, 16, ["modelValue", "disabled", "clearable", "placeholder", "style", "options", "props"])) : createCommentVNode("", true),
    $props.element.type == "treeselect" ? (openBlock(), createBlock(_component_el_tree_select, mergeProps({
      key: $props.element.options.defaultValue,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => $props.element.options.defaultValue = $event),
      disabled: $props.element.options.disabled,
      clearable: $props.element.options.clearable,
      placeholder: $props.element.options.placeholder,
      style: { width: $props.isTable ? "100%" : $props.element.options.width },
      data: $props.element.options.remote ? [] : $props.element.options.options,
      multiple: $props.element.options.multiple
    }, $props.element.options.customProps), null, 16, ["modelValue", "disabled", "clearable", "placeholder", "style", "data", "multiple"])) : createCommentVNode("", true),
    $props.element.type == "editor" ? (openBlock(), createBlock(_component_Editor, {
      modelValue: $props.element.options.defaultValue,
      "custom-style": { width: $props.isTable ? "100%" : $props.element.options.width, cursor: $props.element.options.disabled ? "no-drop" : "", backgroundColor: $props.element.options.disabled ? "#F5F7FA" : "" },
      toolbar: $props.element.options.customToolbar,
      class: "fm-editor",
      disabled: $props.element.options.disabled,
      key: $data.elementKey
    }, null, 8, ["modelValue", "custom-style", "toolbar", "disabled"])) : createCommentVNode("", true),
    $props.element.type == "blank" ? (openBlock(), createElementBlock("div", _hoisted_1$s, toDisplayString$1($props.element.model), 1)) : createCommentVNode("", true),
    $props.element.type == "component" ? (openBlock(), createBlock(resolveDynamicComponent(`component-${$props.element.key}`), {
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.element.options.width }),
      key: $data.key,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => $props.element.options.defaultValue = $event)
    }, null, 8, ["style", "modelValue"])) : createCommentVNode("", true),
    $props.element.type == "custom" ? (openBlock(), createBlock(resolveDynamicComponent($props.element.el), mergeProps({
      key: 18,
      modelValue: $props.element.options.defaultValue,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => $props.element.options.defaultValue = $event),
      width: $props.element.options.width,
      height: $props.element.options.height,
      placeholder: $props.element.options.placeholder,
      readonly: $props.element.options.readonly,
      disabled: $props.element.options.disabled,
      editable: $props.element.options.editable,
      clearable: $props.element.options.clearable
    }, { ...$props.element.options.customProps, ...$props.element.options.extendProps }), null, 16, ["modelValue", "width", "height", "placeholder", "readonly", "disabled", "editable", "clearable"])) : createCommentVNode("", true),
    $props.element.type == "text" ? (openBlock(), createElementBlock("span", {
      key: 19,
      style: normalizeStyle({ "width": $props.isTable ? "100%" : $props.element.options.width || "100%", display: "inline-block" })
    }, toDisplayString$1($props.element.options.defaultValue), 5)) : createCommentVNode("", true),
    $props.element.type == "html" ? (openBlock(), createElementBlock("span", {
      key: 20,
      style: normalizeStyle({ "width": $props.isTable ? "100%" : $props.element.options.width || "100%", display: "inline-block" }),
      innerHTML: $props.element.options.defaultValue
    }, null, 12, _hoisted_2$q)) : createCommentVNode("", true),
    $props.element.type == "fileupload" ? (openBlock(), createBlock(_component_el_upload, {
      key: 21,
      action: "https://jsonplaceholder.typicode.com/posts/",
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.element.options.width }),
      disabled: $props.element.options.disabled,
      limit: $props.element.options.limit
    }, {
      default: withCtx(() => [
        createVNode(_component_el_button, {
          size: "default",
          type: "primary"
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.upload")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["style", "disabled", "limit"])) : createCommentVNode("", true),
    $props.element.type == "button" ? (openBlock(), createBlock(_component_el_button, mergeProps({
      key: 22,
      disabled: $props.element.options.disabled,
      size: $props.element.options.buttonSize,
      type: $props.element.options.buttonType == "text" || $props.element.options.buttonType == "link" ? "primary" : $props.element.options.buttonType,
      text: $props.element.options.buttonType == "text",
      link: $props.element.options.buttonType == "link",
      plain: $props.element.options.buttonPlain,
      round: $props.element.options.buttonRound,
      circle: $props.element.options.buttonCircle,
      style: { width: $props.element.options.width }
    }, $props.element.options.customProps), {
      default: withCtx(() => [
        createTextVNode(toDisplayString$1($props.element.options.buttonName), 1)
      ]),
      _: 1
    }, 16, ["disabled", "size", "type", "text", "link", "plain", "round", "circle", "style"])) : createCommentVNode("", true),
    $props.element.type == "link" ? (openBlock(), createBlock(_component_el_link, mergeProps({
      key: 23,
      disabled: $props.element.options.disabled,
      type: $props.element.options.linkType,
      underline: $props.element.options.underline
    }, $props.element.options.customProps), {
      default: withCtx(() => [
        createTextVNode(toDisplayString$1($props.element.options.linkName), 1)
      ]),
      _: 1
    }, 16, ["disabled", "type", "underline"])) : createCommentVNode("", true),
    $props.element.type == "steps" ? (openBlock(), createBlock(_component_el_steps, mergeProps({
      key: 24,
      active: $props.element.options.defaultValue,
      space: $props.element.options.space,
      direction: $props.element.options.direction,
      "process-status": $props.element.options.processStatus,
      "finish-status": $props.element.options.finishStatus,
      "align-center": $props.element.options.alignCenter,
      simple: $props.element.options.simple,
      style: { "line-height": "normal" }
    }, $props.element.options.customProps), {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.options.steps, (item, index2) => {
          return openBlock(), createBlock(_component_el_step, {
            title: item.title,
            description: item.description,
            key: index2
          }, null, 8, ["title", "description"]);
        }), 128))
      ]),
      _: 1
    }, 16, ["active", "space", "direction", "process-status", "finish-status", "align-center", "simple"])) : createCommentVNode("", true),
    $props.element.type == "transfer" ? (openBlock(), createBlock(_component_el_transfer, mergeProps({
      key: 25,
      "model-value": $props.element.options.defaultValue,
      data: $props.element.options.data,
      filterable: $props.element.options.filterable,
      titles: $props.element.options.titles,
      style: { "width": $props.isTable ? "100%" : $props.element.options.width }
    }, $props.element.options.customProps), null, 16, ["model-value", "data", "filterable", "titles", "style"])) : createCommentVNode("", true),
    $props.element.type == "pagination" ? (openBlock(), createBlock(_component_el_pagination, mergeProps({
      key: 26,
      currentPage: $props.element.options.defaultValue,
      "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event) => $props.element.options.defaultValue = $event),
      "page-size": $props.element.options.pageSize,
      "pager-count": $props.element.options.pagerCount,
      disabled: $props.element.options.disabled,
      background: $props.element.options.background,
      layout: "total, prev, pager, next",
      total: $props.element.options.total
    }, $props.element.options.customProps), null, 16, ["currentPage", "page-size", "pager-count", "disabled", "background", "total"])) : createCommentVNode("", true)
  ], 64);
}
var WidgetElementItem = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["render", _sfc_render$H]]);
const _sfc_main$I = {
  props: ["element", "select", "index", "data", "formKey"],
  components: {
    WidgetElementItem
  },
  emits: ["select-change", "update:data", "update:select"],
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    handleMouseover(e) {
      addClass$1(e.target, "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(e.target, "is-hover");
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data.list[index2]);
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.$nextTick(() => {
        this.data.list.splice(index2, 1);
        setTimeout(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        }, 20);
      });
    },
    handleWidgetClone(index2) {
      const key = Math.random().toString(36).slice(-8);
      let cloneData = {
        ..._.cloneDeep(this.data.list[index2]),
        key,
        model: this.data.list[index2].type + "_" + key
      };
      this.data.list.splice(index2 + 1, 0, cloneData);
      this.$nextTick(() => {
        this.$emit("update:select", this.data.list[index2 + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    }
  },
  watch: {}
};
const _hoisted_1$r = ["innerHTML"];
const _hoisted_2$p = {
  key: 0,
  class: "widget-view-action"
};
const _hoisted_3$l = ["title"];
const _hoisted_4$k = ["title"];
const _hoisted_5$k = {
  key: 1,
  class: "widget-view-drag"
};
const _hoisted_6$i = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_7$h = [
  _hoisted_6$i
];
const _hoisted_8$a = { class: "widget-view-type" };
const _hoisted_9$9 = {
  key: 0,
  class: "widget-view-action"
};
const _hoisted_10$6 = ["title"];
const _hoisted_11$6 = ["title"];
const _hoisted_12$6 = {
  key: 1,
  class: "widget-view-drag"
};
const _hoisted_13$4 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_14$4 = [
  _hoisted_13$4
];
const _hoisted_15$2 = { class: "widget-view-type" };
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_element_item = resolveComponent("widget-element-item");
  const _component_el_form_item = resolveComponent("el-form-item");
  const _component_el_divider = resolveComponent("el-divider");
  const _component_el_alert = resolveComponent("el-alert");
  return openBlock(), createElementBlock("div", null, [
    $props.element && $props.element.key && $props.element.type != "divider" && $props.element.type != "alert" ? (openBlock(), createElementBlock("div", {
      key: 0,
      class: normalizeClass(["widget-view", {
        active: $props.select.key == $props.element.key,
        "is_req": $props.element.options.required,
        "is_hidden": $props.element.options.hidden
      }]),
      onClick: _cache[2] || (_cache[2] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
      onMouseover: _cache[3] || (_cache[3] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
      onMouseout: _cache[4] || (_cache[4] = (...args) => $options.handleMouseout && $options.handleMouseout(...args))
    }, [
      createVNode(_component_el_form_item, {
        class: normalizeClass({
          [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false,
          "fm-label-wrap": $props.element.options.labelWrap
        }),
        label: $props.element.options.hideLabel ? "" : $props.element.name,
        "label-width": $props.element.options.hideLabel ? "0px" : $props.element.options.isLabelWidth ? $props.element.options.labelWidth + "px" : ""
      }, {
        default: withCtx(() => [
          $props.element.options.tip ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "fm-item-tooltip",
            innerHTML: $props.element.options.tip.replace(/\n/g, "<br/>")
          }, null, 8, _hoisted_1$r)) : createCommentVNode("", true),
          (openBlock(), createBlock(_component_widget_element_item, {
            element: $props.element,
            "is-table": false,
            key: $props.element.key
          }, null, 8, ["element"]))
        ]),
        _: 1
      }, 8, ["class", "label", "label-width"]),
      $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_2$p, [
        createElementVNode("i", {
          class: "fm-iconfont icon-icon_clone",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => $options.handleWidgetClone($props.index), ["stop"])),
          title: _ctx.$t("fm.tooltip.clone")
        }, null, 8, _hoisted_3$l),
        createElementVNode("i", {
          class: "fm-iconfont icon-trash",
          onClick: _cache[1] || (_cache[1] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
          title: _ctx.$t("fm.tooltip.trash")
        }, null, 8, _hoisted_4$k)
      ])) : createCommentVNode("", true),
      $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_5$k, _hoisted_7$h)) : createCommentVNode("", true),
      createElementVNode("div", {
        class: "widget-view-model",
        style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
      }, [
        createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
      ], 4),
      createElementVNode("div", _hoisted_8$a, [
        createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
      ])
    ], 34)) : createCommentVNode("", true),
    $props.element && $props.element.key && ($props.element.type == "divider" || $props.element.type == "alert") ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: normalizeClass(["widget-view no-put", { active: $props.select.key == $props.element.key, "is_hidden": $props.element.options.hidden }]),
      onClick: _cache[7] || (_cache[7] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
      style: { "padding-bottom": "0" },
      onMouseover: _cache[8] || (_cache[8] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
      onMouseout: _cache[9] || (_cache[9] = (...args) => $options.handleMouseout && $options.handleMouseout(...args))
    }, [
      createVNode(_component_el_form_item, { "label-width": "0" }, {
        default: withCtx(() => [
          $props.element.type == "divider" ? (openBlock(), createBlock(_component_el_divider, mergeProps({
            key: 0,
            "content-position": $props.element.options.contentPosition
          }, $props.element.options.customProps), {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1($props.element.name), 1)
            ]),
            _: 1
          }, 16, ["content-position"])) : createCommentVNode("", true),
          $props.element.type == "alert" ? (openBlock(), createBlock(_component_el_alert, mergeProps({
            key: 1,
            title: $props.element.options.title,
            type: $props.element.options.type,
            description: $props.element.options.description,
            closable: $props.element.options.closable,
            center: $props.element.options.center,
            "show-icon": $props.element.options.showIcon,
            effect: $props.element.options.effect,
            style: { width: $props.element.options.width }
          }, $props.element.options.customProps), null, 16, ["title", "type", "description", "closable", "center", "show-icon", "effect", "style"])) : createCommentVNode("", true)
        ]),
        _: 1
      }),
      $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_9$9, [
        createElementVNode("i", {
          class: "fm-iconfont icon-icon_clone",
          onClick: _cache[5] || (_cache[5] = withModifiers(($event) => $options.handleWidgetClone($props.index), ["stop"])),
          title: _ctx.$t("fm.tooltip.clone")
        }, null, 8, _hoisted_10$6),
        createElementVNode("i", {
          class: "fm-iconfont icon-trash",
          onClick: _cache[6] || (_cache[6] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
          title: _ctx.$t("fm.tooltip.trash")
        }, null, 8, _hoisted_11$6)
      ])) : createCommentVNode("", true),
      $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_12$6, _hoisted_14$4)) : createCommentVNode("", true),
      createElementVNode("div", {
        class: "widget-view-model",
        style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
      }, [
        createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
      ], 4),
      createElementVNode("div", _hoisted_15$2, [
        createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
      ])
    ], 34)) : createCommentVNode("", true)
  ]);
}
var WidgetFormItem = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["render", _sfc_render$G]]);
const _sfc_main$H = {
  components: {
    WidgetElementItem
  },
  props: ["element", "select", "index", "data", "platform", "formKey"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {}
    };
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetTableItem"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetTableItem"], "is-hover");
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data[index2]);
    },
    handleWidgetDelete(index2) {
      if (this.data.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.$nextTick(() => {
        this.data.splice(index2, 1);
        setTimeout(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        }, 20);
      });
    },
    handleWidgetClone(index2) {
      const key = Math.random().toString(36).slice(-8);
      let cloneData = {
        ..._.cloneDeep(this.data[index2]),
        key,
        model: this.data[index2].type + "_" + key
      };
      this.data.splice(index2 + 1, 0, cloneData);
      this.$nextTick(() => {
        this.$emit("update:select", this.data[index2 + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$q = {
  key: 2,
  class: "widget-view-action"
};
const _hoisted_2$o = ["title"];
const _hoisted_3$k = ["title"];
const _hoisted_4$j = {
  key: 3,
  class: "widget-view-drag"
};
const _hoisted_5$j = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_6$h = [
  _hoisted_5$j
];
const _hoisted_7$g = { class: "widget-view-type" };
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_element_item = resolveComponent("widget-element-item");
  const _component_el_table_column = resolveComponent("el-table-column");
  const _component_el_table = resolveComponent("el-table");
  const _component_el_form_item = resolveComponent("el-form-item");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-table-view", {
      active: $data.selectWidget.key == $props.element.key,
      "is_req": $props.element.options.required,
      "is_hidden": $props.element.options.hidden,
      "mobile": $props.platform == "mobile"
    }]),
    onClick: _cache[2] || (_cache[2] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[3] || (_cache[3] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[4] || (_cache[4] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetTableItem",
    style: normalizeStyle({
      width: $props.platform != "mobile" ? !$props.element.options.width ? "200px" : $props.element.options.width : ""
    })
  }, [
    $props.platform != "mobile" ? (openBlock(), createBlock(_component_el_table, {
      key: 0,
      "row-class-name": "widget-table-row",
      data: [{}]
    }, {
      default: withCtx(() => {
        var _a2;
        return [
          createVNode(_component_el_table_column, {
            label: $props.element.options.hideLabel ? "" : $props.element.name,
            "class-name": (_a2 = $props.element.options) == null ? void 0 : _a2.customClass,
            "label-class-name": $props.element.options.required ? "required" : ""
          }, {
            default: withCtx(() => [
              createVNode(_component_widget_element_item, {
                element: $props.element,
                "is-table": true
              }, null, 8, ["element"])
            ]),
            _: 1
          }, 8, ["label", "class-name", "label-class-name"])
        ];
      }),
      _: 1
    })) : createCommentVNode("", true),
    $props.platform == "mobile" ? (openBlock(), createBlock(_component_el_form_item, {
      key: 1,
      label: $props.element.options.hideLabel ? "" : $props.element.name,
      "label-width": $props.element.options.hideLabel ? "0px" : $props.element.options.isLabelWidth ? $props.element.options.labelWidth + "px" : "",
      class: normalizeClass({
        [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false,
        "fm-label-wrap": $props.element.options.labelWrap
      })
    }, {
      default: withCtx(() => [
        createVNode(_component_widget_element_item, {
          element: $props.element,
          "is-table": true
        }, null, 8, ["element"])
      ]),
      _: 1
    }, 8, ["label", "label-width", "class"])) : createCommentVNode("", true),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_1$q, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[0] || (_cache[0] = withModifiers(($event) => $options.handleWidgetClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_2$o),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[1] || (_cache[1] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_3$k)
    ])) : createCommentVNode("", true),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_4$j, _hoisted_6$h)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_7$g, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 38);
}
var WidgetTableItem = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$F]]);
const CloneLayout = (data2) => {
  if (data2.type === "grid") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      columns: data2.columns.map((item) => {
        return {
          ...item,
          list: item.list.map((colItem) => {
            return CloneLayout(colItem);
          }),
          key: Math.random().toString(36).slice(-8)
        };
      })
    };
  } else if (data2.type === "col") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      list: data2.list.map((item) => {
        return CloneLayout(item);
      })
    };
  } else if (data2.type === "tabs" || data2.type === "collapse") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      tabs: data2.tabs.map((item) => {
        return {
          ...item,
          list: item.list.map((tabItem) => {
            return CloneLayout(tabItem);
          })
        };
      })
    };
  } else if (data2.type === "table") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      tableColumns: data2.tableColumns.map((item) => {
        return CloneLayout(item);
      })
    };
  } else if (data2.type === "subform") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      list: data2.list.map((item) => {
        return CloneLayout(item);
      })
    };
  } else if (data2.type === "report") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      rows: data2.rows.map((r) => {
        return {
          ...r,
          columns: r.columns.map((c) => {
            return {
              ...c,
              list: c.list.map((cItem) => {
                return CloneLayout(cItem);
              }),
              key: Math.random().toString(36).slice(-8)
            };
          })
        };
      })
    };
  } else if (data2.type === "inline") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      list: data2.list.map((item) => {
        return CloneLayout(item);
      })
    };
  } else if (data2.type === "dialog") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      list: data2.list.map((item) => {
        return CloneLayout(item);
      })
    };
  } else if (data2.type === "card") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      list: data2.list.map((item) => {
        return CloneLayout(item);
      })
    };
  } else if (data2.type === "group") {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key,
      list: data2.list.map((item) => {
        return CloneLayout(item);
      })
    };
  } else {
    let key = Math.random().toString(36).slice(-8);
    return {
      ...data2,
      key,
      model: data2.type + "_" + key
    };
  }
};
const _sfc_main$G = {
  components: {
    Draggable: draggableComponent,
    WidgetTableItem
  },
  props: ["element", "select", "index", "data", "platform", "formKey"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {},
      columnsWidthStyle: "200px"
    };
  },
  mounted() {
    this.calcTableColumnsWidth();
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetTable"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetTable"], "is-hover");
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data.list[index2]);
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleTableClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.$emit("update:select", this.data.list[index2 + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetTableUpdate(evt) {
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    calcTableColumnsWidth() {
      this.columnsWidthStyle = "calc(200px)";
      let widthArray = [];
      for (let i = 0; i < this.element.tableColumns.length; i++) {
        if (!this.element.tableColumns[i].options.width) {
          widthArray.push("200px");
        } else {
          widthArray.push(this.element.tableColumns[i].options.width);
        }
      }
      widthArray.length && (this.columnsWidthStyle = `calc(200px + ${widthArray.join(" + ")})`);
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-col") >= 0 || c.className.split(" ").indexOf("widget-table") >= 0 || c.className.split(" ").indexOf("widget-tab") >= 0 || c.className.split(" ").indexOf("widget-report") >= 0 || c.className.split(" ").indexOf("widget-inline") >= 0 || c.className.split(" ").indexOf("widget-subform") >= 0 || c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("widget-card") >= 0 || c.className.split(" ").indexOf("widget-group") >= 0 || c.className.split(" ").indexOf("no-put") >= 0 || c.children[0].className.split(" ").indexOf("no-put") >= 0) {
        return false;
      }
      return true;
    },
    handleWidgetTableAdd($event, table) {
      const newIndex2 = $event.newIndex;
      const key = Math.random().toString(36).slice(-8);
      table.tableColumns[newIndex2] = _.cloneDeep(table.tableColumns[newIndex2]);
      table.tableColumns[newIndex2] = {
        ...table.tableColumns[newIndex2],
        options: {
          ...table.tableColumns[newIndex2].options,
          remoteFunc: table.tableColumns[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: table.tableColumns[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: true,
          subform: this.subform ? true : false
        },
        novalid: {
          ...table.tableColumns[newIndex2].novalid
        },
        key: table.tableColumns[newIndex2].key ? table.tableColumns[newIndex2].key : key,
        model: table.tableColumns[newIndex2].model ? table.tableColumns[newIndex2].model : table.tableColumns[newIndex2].type + "_" + key,
        rules: table.tableColumns[newIndex2].rules ? [...table.tableColumns[newIndex2].rules] : []
      };
      this.$nextTick(() => {
        this.selectWidget = table.tableColumns[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.$emit("update:select", this.element.tableColumns[index2]) : this.$emit("update:select", this.data.list[this.index]);
      });
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    },
    element: {
      deep: true,
      handler(val) {
        this.calcTableColumnsWidth();
      }
    }
  }
};
const _hoisted_1$p = ["innerHTML"];
const _hoisted_2$n = {
  key: 0,
  class: "widget-table-left"
};
const _hoisted_3$j = /* @__PURE__ */ createElementVNode("div", { class: "widget-table-left__top" }, "#", -1);
const _hoisted_4$i = /* @__PURE__ */ createElementVNode("div", { class: "widget-table-left__body" }, "1", -1);
const _hoisted_5$i = [
  _hoisted_3$j,
  _hoisted_4$i
];
const _hoisted_6$g = {
  key: 1,
  class: "widget-table-top"
};
const _hoisted_7$f = {
  key: 0,
  class: "table-empty"
};
const _hoisted_8$9 = {
  key: 0,
  class: "widget-view-action widget-col-action"
};
const _hoisted_9$8 = ["title"];
const _hoisted_10$5 = ["title"];
const _hoisted_11$5 = {
  key: 1,
  class: "widget-view-drag widget-col-drag"
};
const _hoisted_12$5 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_13$3 = [
  _hoisted_12$5
];
const _hoisted_14$3 = { class: "widget-view-type" };
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_table_item = resolveComponent("widget-table-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_form_item = resolveComponent("el-form-item");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-table widget-view", {
      active: $data.selectWidget.key && $data.selectWidget.key == $props.element.key,
      "is_hidden": $props.element.options.hidden,
      "mobile": $props.platform == "mobile"
    }]),
    onClick: _cache[5] || (_cache[5] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[6] || (_cache[6] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[7] || (_cache[7] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetTable"
  }, [
    createVNode(_component_el_form_item, {
      label: $props.element.options.hideLabel ? "" : $props.element.name,
      "label-width": $props.element.options.hideLabel ? "0px" : $props.element.options.isLabelWidth ? $props.element.options.labelWidth + "px" : "",
      class: normalizeClass({
        [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false,
        "fm-label-wrap": $props.element.options.labelWrap
      })
    }, {
      default: withCtx(() => [
        $props.element.options.tip ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "fm-item-tooltip",
          innerHTML: $props.element.options.tip.replace(/\n/g, "<br/>")
        }, null, 8, _hoisted_1$p)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: normalizeClass(["widget-table-wrapper", { "mobile": $props.platform == "mobile" }])
        }, [
          $props.platform != "mobile" && $props.element.options.showControl ? (openBlock(), createElementBlock("div", _hoisted_2$n, _hoisted_5$i)) : createCommentVNode("", true),
          $props.platform == "mobile" && $props.element.options.showControl ? (openBlock(), createElementBlock("div", _hoisted_6$g, " # 1 ")) : createCommentVNode("", true),
          createElementVNode("div", {
            class: normalizeClass(["widget-table-content", { "mobile": $props.platform == "mobile" }])
          }, [
            $props.element.tableColumns.length == 0 ? (openBlock(), createElementBlock("div", _hoisted_7$f, toDisplayString$1(_ctx.$t("fm.description.tableEmpty")), 1)) : createCommentVNode("", true),
            createElementVNode("div", {
              style: normalizeStyle({ width: $props.platform != "mobile" ? $data.columnsWidthStyle : "100%" })
            }, [
              createVNode(_component_draggable, {
                modelValue: $props.element.tableColumns,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $props.element.tableColumns = $event),
                group: { name: "people", put: $options.handlePut },
                "ghost-class": "ghost",
                animation: 200,
                handle: ".drag-widget",
                "no-transition-on-drag": true,
                onAdd: _cache[2] || (_cache[2] = ($event) => $options.handleWidgetTableAdd($event, $props.element)),
                onUpdate: $options.handleWidgetTableUpdate,
                class: "widget-table-col",
                "item-key": "key"
              }, {
                item: withCtx(({ element: item, index: index2 }) => [
                  (openBlock(), createBlock(_component_widget_table_item, {
                    key: item.key,
                    element: item,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
                    index: index2,
                    data: $props.element.tableColumns,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"]))
                ]),
                _: 1
              }, 8, ["modelValue", "group", "onUpdate"])
            ], 4)
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["label", "label-width", "class"]),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_8$9, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[3] || (_cache[3] = withModifiers(($event) => $options.handleTableClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_9$8),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[4] || (_cache[4] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_10$5)
    ])) : createCommentVNode("", true),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_11$5, _hoisted_13$3)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_14$3, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetTable = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$E]]);
var WidgetTable$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": WidgetTable
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$F = {
  name: "widget-inline",
  components: {
    Draggable: draggableComponent,
    WidgetFormItem
  },
  props: ["element", "select", "index", "data", "platform", "formKey", "subform"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {}
    };
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetInline"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetInline"], "is-hover");
    },
    handleSelectWidget(index2) {
      this.selectWidget = this.data.list[index2];
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-col") >= 0 || c.className.split(" ").indexOf("widget-table") >= 0 || c.className.split(" ").indexOf("widget-tab") >= 0 || c.className.split(" ").indexOf("widget-inline") >= 0 || c.className.split(" ").indexOf("widget-report") >= 0 || c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("widget-card") >= 0 || c.className.split(" ").indexOf("no-put") >= 0 || c.children[0].className.split(" ").indexOf("no-put") >= 0) {
        return false;
      }
      return true;
    },
    handleWidgetInlineAdd($event, table) {
      const newIndex2 = $event.newIndex;
      const key = Math.random().toString(36).slice(-8);
      table.list[newIndex2] = _.cloneDeep(table.list[newIndex2]);
      table.list[newIndex2] = {
        ...table.list[newIndex2],
        options: {
          ...table.list[newIndex2].options,
          remoteFunc: table.list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: table.list[newIndex2].options.remoteOption || "option_" + key,
          subform: this.subform ? true : false,
          tableColumn: false
        },
        key: table.list[newIndex2].key ? table.list[newIndex2].key : key,
        model: table.list[newIndex2].model ? table.list[newIndex2].model : table.list[newIndex2].type + "_" + key,
        rules: table.list[newIndex2].rules ? [...table.list[newIndex2].rules] : []
      };
      this.$nextTick(() => {
        this.selectWidget = table.list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleInlineClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.selectWidget = this.data.list[index2 + 1];
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleWidgetInlineUpdate() {
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.selectWidget = item.list[index2] : this.selectWidget = this.data.list[this.index];
      });
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$o = ["size"];
const _hoisted_2$m = { class: "widget-inline-content" };
const _hoisted_3$i = {
  key: 0,
  class: "widget-view-action widget-inline-action"
};
const _hoisted_4$h = ["title"];
const _hoisted_5$h = ["title"];
const _hoisted_6$f = {
  key: 1,
  class: "widget-view-drag widget-inline-drag"
};
const _hoisted_7$e = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_8$8 = [
  _hoisted_7$e
];
const _hoisted_9$7 = { class: "widget-view-type" };
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_draggable = resolveComponent("draggable");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-inline widget-view", {
      active: $data.selectWidget.key && $data.selectWidget.key == $props.element.key,
      "is_hidden": $props.element.options.hidden
    }]),
    onClick: _cache[6] || (_cache[6] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    size: $props.element.options.size,
    onMouseover: _cache[7] || (_cache[7] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[8] || (_cache[8] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetInline"
  }, [
    createElementVNode("div", _hoisted_2$m, [
      createVNode(_component_draggable, mergeProps({
        modelValue: $props.element.list,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $props.element.list = $event)
      }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
        "no-transition-on-drag": true,
        onAdd: _cache[3] || (_cache[3] = ($event) => $options.handleWidgetInlineAdd($event, $props.element)),
        onUpdate: $options.handleWidgetInlineUpdate,
        class: ["widget-inline-list", {
          [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false
        }],
        "item-key": "key"
      }), {
        item: withCtx(({ element: item, index: index2 }) => [
          item && item.key ? (openBlock(), createBlock(_component_widget_form_item, {
            key: item.key,
            element: item,
            select: $data.selectWidget,
            "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
            index: index2,
            data: $props.element,
            onSelectChange: _cache[1] || (_cache[1] = ($event) => $options.handleSelectChange($event, $props.element)),
            "form-key": $props.formKey,
            style: normalizeStyle({ "margin-right": $props.element.options.spaceSize + "px" })
          }, null, 8, ["element", "select", "index", "data", "form-key", "style"])) : createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["modelValue", "onUpdate", "class"])
    ]),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_3$i, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[4] || (_cache[4] = withModifiers(($event) => $options.handleInlineClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_4$h),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[5] || (_cache[5] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_5$h)
    ])) : createCommentVNode("", true),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_6$f, _hoisted_8$8)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_9$7, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 42, _hoisted_1$o);
}
var WidgetInline = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$D]]);
const _sfc_main$E = {
  name: "widget-col-item",
  components: {
    Draggable: draggableComponent,
    WidgetFormItem,
    WidgetTable,
    WidgetInline,
    WidgetReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetReport$1;
    })),
    WidgetCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCollapse$1;
    })),
    WidgetCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCard$1;
    })),
    WidgetSubForm: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetSubForm$1;
    })),
    WidgetTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTabItem$1;
    })),
    WidgetGroup: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetGroup$1;
    }))
  },
  props: ["element", "select", "index", "data", "platform", "formKey", "subform"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {},
      selectIndex: -1
    };
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetCol"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetCol"], "is-hover");
    },
    handleMouseoverCol(i) {
      addClass$1(this.$refs["widgetColItem"][i].$el, "is-hover");
    },
    handleMouseoutCol(i) {
      removeClass$1(this.$refs["widgetColItem"][i].$el, "is-hover");
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("dialog-put") >= 0 || c.children[0].className.split(" ").indexOf("dialog-put") >= 0) {
        return false;
      }
      return true;
    },
    getColSpan(options) {
      if (this.platform == "pc") {
        return options && options.md;
      }
      if (this.platform == "pad") {
        return options && options.sm;
      }
      if (this.platform == "mobile") {
        return options && options.xs;
      }
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data.list[index2]);
    },
    handleSelectItemWidget(i) {
      this.$emit("update:select", this.data.list[this.index].columns[i]);
      this.selectIndex = i;
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleColItemDelete(index2, i) {
      this.data.list[index2].columns.splice(i, 1);
      if (i == 0) {
        this.$emit("update:select", this.data.list[index2].columns[0]);
      } else {
        this.$emit("update:select", this.data.list[index2].columns[i - 1]);
      }
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleAddCol(index2) {
      this.data.list[index2].columns.push({
        type: "col",
        options: {
          span: 12,
          offset: 0,
          push: 0,
          pull: 0,
          xs: 24,
          sm: 12,
          md: 12,
          lg: 12,
          xl: 12,
          customClass: ""
        },
        list: [],
        key: Math.random().toString(36).slice(-8)
      });
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleColClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.data.list[index2 + 1];
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleColItemClone(index2, i) {
      let cloneData = _.cloneDeep(this.data.list[index2].columns[i]);
      this.data.list[index2].columns.splice(i + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.$emit("update:select", this.data.list[index2].columns[i + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetColUpdate(evt) {
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetColAdd($event, row, colIndex) {
      const newIndex2 = $event.newIndex;
      fixDraggbleList(row.columns[colIndex].list, newIndex2);
      row.columns[colIndex].list[newIndex2] = _.cloneDeep(row.columns[colIndex].list[newIndex2]);
      const key = Math.random().toString(36).slice(-8);
      row.columns[colIndex].list[newIndex2] = {
        ...row.columns[colIndex].list[newIndex2],
        options: {
          ...row.columns[colIndex].list[newIndex2].options,
          remoteFunc: row.columns[colIndex].list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: row.columns[colIndex].list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          subform: this.subform ? true : false
        },
        novalid: {
          ...row.columns[colIndex].list[newIndex2].novalid
        },
        key: row.columns[colIndex].list[newIndex2].key ? row.columns[colIndex].list[newIndex2].key : key,
        model: row.columns[colIndex].list[newIndex2].model ? row.columns[colIndex].list[newIndex2].model : row.columns[colIndex].list[newIndex2].type + "_" + key,
        rules: row.columns[colIndex].list[newIndex2].rules ? [...row.columns[colIndex].list[newIndex2].rules] : []
      };
      if (row.columns[colIndex].list[newIndex2].type == "report") {
        row.columns[colIndex].list[newIndex2].rows = generateKeyToTD(row.columns[colIndex].list[newIndex2].rows);
        row.columns[colIndex].list[newIndex2].headerRow = generateKeyToTH(row.columns[colIndex].list[newIndex2].headerRow);
      }
      if (row.columns[colIndex].list[newIndex2].type == "grid") {
        row.columns[colIndex].list[newIndex2].columns = generateKeyToCol(row.columns[colIndex].list[newIndex2].columns);
      }
      setTimeout(() => {
        this.selectWidget = row.columns[colIndex].list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 50);
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.$emit("update:select", item.list[index2]) : this.$emit("update:select", {});
      });
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$n = {
  key: 0,
  class: "widget-view-action widget-col-action"
};
const _hoisted_2$l = ["onClick", "title"];
const _hoisted_3$h = ["onClick", "title"];
const _hoisted_4$g = { class: "widget-view-type" };
const _hoisted_5$g = {
  key: 0,
  class: "widget-view-action widget-col-action"
};
const _hoisted_6$e = ["title"];
const _hoisted_7$d = ["title"];
const _hoisted_8$7 = ["title"];
const _hoisted_9$6 = {
  key: 1,
  class: "widget-view-drag widget-col-drag"
};
const _hoisted_10$4 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_11$4 = [
  _hoisted_10$4
];
const _hoisted_12$4 = { class: "widget-view-type" };
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_col_item = resolveComponent("widget-col-item", true);
  const _component_widget_tab_item = resolveComponent("widget-tab-item");
  const _component_widget_collapse = resolveComponent("widget-collapse");
  const _component_widget_report = resolveComponent("widget-report");
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_sub_form = resolveComponent("widget-sub-form");
  const _component_widget_card = resolveComponent("widget-card");
  const _component_widget_group = resolveComponent("widget-group");
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_col = resolveComponent("el-col");
  const _component_el_row = resolveComponent("el-row");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-col widget-view", {
      active: $props.select.key && $props.select.key == $props.element.key,
      "is_hidden": $props.element.options.hidden
    }]),
    onClick: _cache[13] || (_cache[13] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[14] || (_cache[14] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[15] || (_cache[15] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetCol"
  }, [
    createVNode(_component_el_row, {
      type: $props.element.options.flex ? "flex" : "",
      gutter: $props.element.options.gutter || 0,
      justify: $props.element.options.justify,
      align: $props.element.options.align,
      class: normalizeClass({
        [$props.element.options && $props.element.options.customClass]: $props.element.options && $props.element.options.customClass ? true : false
      })
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.columns, (item, i) => {
          return openBlock(), createBlock(_component_el_col, {
            class: normalizeClass(["widget-col-item", {
              active: $props.select.key && $props.select.key == item.key,
              [item.options && item.options.customClass]: item.options && item.options.customClass ? true : false
            }]),
            key: item.key,
            onClick: withModifiers(($event) => $options.handleSelectItemWidget(i), ["stop"]),
            span: $options.getColSpan(item.options),
            offset: item.options ? item.options.offset : 0,
            push: item.options ? item.options.push : 0,
            pull: item.options ? item.options.pull : 0,
            onMouseover: withModifiers(($event) => $options.handleMouseoverCol(i), ["stop"]),
            onMouseout: ($event) => $options.handleMouseoutCol(i),
            ref_for: true,
            ref: "widgetColItem"
          }, {
            default: withCtx(() => [
              createVNode(_component_draggable, mergeProps({
                list: $props.element.columns[i].list
              }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
                "no-transition-on-drag": true,
                onAdd: ($event) => $options.handleWidgetColAdd($event, $props.element, i),
                onUpdate: $options.handleWidgetColUpdate,
                class: "widget-col-list",
                "item-key": "key"
              }), {
                item: withCtx(({ element: col, index: colindex }) => [
                  col.type === "grid" ? (openBlock(), createBlock(_component_widget_col_item, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : col.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : col.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : col.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : col.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : col.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : col.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : col.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : col.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : (openBlock(), createBlock(_component_widget_form_item, {
                    key: col.key,
                    element: col,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
                    index: colindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"]))
                ]),
                _: 2
              }, 1040, ["list", "onAdd", "onUpdate"]),
              $props.select.key == item.key ? (openBlock(), createElementBlock("div", _hoisted_1$n, [
                createElementVNode("i", {
                  class: "fm-iconfont icon-icon_clone",
                  onClick: withModifiers(($event) => $options.handleColItemClone($props.index, i), ["stop"]),
                  title: _ctx.$t("fm.tooltip.clone")
                }, null, 8, _hoisted_2$l),
                $props.element.columns.length > 1 ? (openBlock(), createElementBlock("i", {
                  key: 0,
                  class: "fm-iconfont icon-trash",
                  onClick: withModifiers(($event) => $options.handleColItemDelete($props.index, i), ["stop"]),
                  title: _ctx.$t("fm.tooltip.trash")
                }, null, 8, _hoisted_3$h)) : createCommentVNode("", true)
              ])) : createCommentVNode("", true),
              createElementVNode("div", _hoisted_4$g, [
                createElementVNode("span", null, toDisplayString$1(item.type ? this.$t("fm.components.fields." + item.type) : ""), 1)
              ])
            ]),
            _: 2
          }, 1032, ["class", "onClick", "span", "offset", "push", "pull", "onMouseover", "onMouseout"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["type", "gutter", "justify", "align", "class"]),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_5$g, [
      createElementVNode("i", {
        class: "fm-iconfont icon-tianjiazengjiajia",
        onClick: _cache[10] || (_cache[10] = withModifiers(($event) => $options.handleAddCol($props.index), ["stop"])),
        title: _ctx.$t("fm.actions.addColumn")
      }, null, 8, _hoisted_6$e),
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[11] || (_cache[11] = withModifiers(($event) => $options.handleColClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_7$d),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[12] || (_cache[12] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_8$7)
    ])) : createCommentVNode("", true),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_9$6, _hoisted_11$4)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_12$4, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetColItem = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$C]]);
var WidgetColItem$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": WidgetColItem
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$D = {
  name: "widget-tab-item",
  components: {
    WidgetFormItem,
    WidgetTable,
    WidgetInline,
    Draggable: draggableComponent,
    WidgetColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetColItem$1;
    })),
    WidgetReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetReport$1;
    })),
    WidgetSubForm: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetSubForm$1;
    })),
    WidgetCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCollapse$1;
    })),
    WidgetCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCard$1;
    })),
    WidgetGroup: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetGroup$1;
    }))
  },
  props: ["element", "select", "index", "data", "platform", "formKey", "subform"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      tabActive: this.element.tabs[0].name,
      selectWidget: this.select || {}
    };
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetTab"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetTab"], "is-hover");
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("dialog-put") >= 0 || c.children[0].className.split(" ").indexOf("dialog-put") >= 0) {
        return false;
      }
      return true;
    },
    handleSelectWidget(index2) {
      this.selectWidget = this.data.list[index2];
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleTabClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.selectWidget = this.data.list[index2 + 1];
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetTabUpdate(evt) {
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetTabAdd($event, element, tabIndex) {
      const newIndex2 = $event.newIndex;
      const key = Math.random().toString(36).slice(-8);
      fixDraggbleList(element.tabs[tabIndex].list, newIndex2);
      element.tabs[tabIndex].list[newIndex2] = _.cloneDeep(element.tabs[tabIndex].list[newIndex2]);
      element.tabs[tabIndex].list[newIndex2] = {
        ...element.tabs[tabIndex].list[newIndex2],
        options: {
          ...element.tabs[tabIndex].list[newIndex2].options,
          remoteFunc: element.tabs[tabIndex].list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: element.tabs[tabIndex].list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          subform: this.subform ? true : false
        },
        key: element.tabs[tabIndex].list[newIndex2].key ? element.tabs[tabIndex].list[newIndex2].key : key,
        model: element.tabs[tabIndex].list[newIndex2].model ? element.tabs[tabIndex].list[newIndex2].model : element.tabs[tabIndex].list[newIndex2].type + "_" + key,
        rules: element.tabs[tabIndex].list[newIndex2].rules ? [...element.tabs[tabIndex].list[newIndex2].rules] : []
      };
      if (element.tabs[tabIndex].list[newIndex2].type == "report") {
        element.tabs[tabIndex].list[newIndex2].rows = generateKeyToTD(element.tabs[tabIndex].list[newIndex2].rows);
        element.tabs[tabIndex].list[newIndex2].headerRow = generateKeyToTH(element.tabs[tabIndex].list[newIndex2].headerRow);
      }
      if (element.tabs[tabIndex].list[newIndex2].type == "grid") {
        element.tabs[tabIndex].list[newIndex2].columns = generateKeyToCol(element.tabs[tabIndex].list[newIndex2].columns);
      }
      setTimeout(() => {
        this.selectWidget = element.tabs[tabIndex].list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 50);
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.selectWidget = item.list[index2] : this.selectWidget = {};
      });
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$m = {
  key: 0,
  class: "widget-view-action widget-col-action"
};
const _hoisted_2$k = ["title"];
const _hoisted_3$g = ["title"];
const _hoisted_4$f = {
  key: 1,
  class: "widget-view-drag widget-col-drag"
};
const _hoisted_5$f = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_6$d = [
  _hoisted_5$f
];
const _hoisted_7$c = { class: "widget-view-type" };
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_tab_item = resolveComponent("widget-tab-item", true);
  const _component_widget_collapse = resolveComponent("widget-collapse");
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_sub_form = resolveComponent("widget-sub-form");
  const _component_widget_card = resolveComponent("widget-card");
  const _component_widget_group = resolveComponent("widget-group");
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_report = resolveComponent("widget-report");
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_widget_col_item = resolveComponent("widget-col-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_tab_pane = resolveComponent("el-tab-pane");
  const _component_el_tabs = resolveComponent("el-tabs");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-tab widget-view", {
      active: $data.selectWidget.key && $data.selectWidget.key == $props.element.key,
      "is_hidden": $props.element.options.hidden
    }]),
    onClick: _cache[13] || (_cache[13] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[14] || (_cache[14] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[15] || (_cache[15] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetTab"
  }, [
    createVNode(_component_el_tabs, {
      modelValue: $data.tabActive,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $data.tabActive = $event),
      type: $props.element.options.type,
      "tab-position": $props.element.options.tabPosition,
      class: normalizeClass({
        [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false
      })
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.tabs, (item, index2) => {
          return openBlock(), createBlock(_component_el_tab_pane, {
            key: item.name,
            label: item.label,
            name: item.name
          }, {
            default: withCtx(() => [
              createVNode(_component_draggable, mergeProps({
                modelValue: item.list,
                "onUpdate:modelValue": ($event) => item.list = $event
              }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
                "no-transition-on-drag": true,
                onAdd: ($event) => $options.handleWidgetTabAdd($event, $props.element, index2),
                onUpdate: $options.handleWidgetTabUpdate,
                class: "widget-col-list",
                "item-key": "key"
              }), {
                item: withCtx(({ element: tab, index: tabindex }) => [
                  tab.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : tab.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : tab.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : tab.type !== "grid" ? (openBlock(), createBlock(_component_widget_form_item, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"])) : (openBlock(), createBlock(_component_widget_col_item, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"]))
                ]),
                _: 2
              }, 1040, ["modelValue", "onUpdate:modelValue", "onAdd", "onUpdate"])
            ]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "type", "tab-position", "class"]),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_1$m, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[11] || (_cache[11] = withModifiers(($event) => $options.handleTabClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_2$k),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[12] || (_cache[12] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_3$g)
    ])) : createCommentVNode("", true),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_4$f, _hoisted_6$d)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_7$c, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetTabItem = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$B]]);
var WidgetTabItem$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": WidgetTabItem
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$C = {
  name: "widget-report",
  components: {
    Draggable: draggableComponent,
    WidgetFormItem,
    WidgetTable,
    WidgetInline,
    WidgetColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetColItem$1;
    })),
    WidgetTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTabItem$1;
    })),
    WidgetSubForm: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetSubForm$1;
    })),
    WidgetCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCollapse$1;
    })),
    WidgetCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCard$1;
    })),
    WidgetGroup: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetGroup$1;
    }))
  },
  props: ["element", "select", "index", "data", "platform", "formKey", "subform"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {},
      selectR: -1,
      selectC: -1,
      selectIndex: -1
    };
  },
  created() {
    if (!this.element.headerRow) {
      this.element.headerRow = this.element.rows[0].columns.map((item) => ({
        type: "th",
        options: {
          width: item.options.width
        },
        key: Math.random().toString(36).slice(-8)
      }));
    }
  },
  computed: {
    showRight() {
      if (this.selectR >= 0 && this.selectC >= 0) {
        const currentRowspan = this.element.rows[this.selectR].columns[this.selectC].options.rowspan;
        const currentColspan = this.element.rows[this.selectR].columns[this.selectC].options.colspan;
        if (this.selectC + currentColspan < this.element.rows[this.selectR].columns.length) {
          const nextColumn = this.element.rows[this.selectR].columns[currentColspan + this.selectC];
          if (!nextColumn.options.invisible && currentRowspan == nextColumn.options.rowspan) {
            return true;
          }
        }
      }
      return false;
    },
    showBottom() {
      if (this.selectR >= 0 && this.selectC >= 0) {
        const currentRowspan = this.element.rows[this.selectR].columns[this.selectC].options.rowspan;
        const currentColspan = this.element.rows[this.selectR].columns[this.selectC].options.colspan;
        if (currentRowspan + this.selectR < this.element.rows.length) {
          const nextColumn = this.element.rows[currentRowspan + this.selectR].columns[this.selectC];
          if (!nextColumn.options.invisible && currentColspan == nextColumn.options.colspan) {
            return true;
          }
        }
      }
      return false;
    },
    showRemoveRow() {
      if (this.element.rows.length > 1 && this.selectR >= 0 && this.selectC >= 0) {
        const currentRowspan = this.element.rows[this.selectR].columns[this.selectC].options.rowspan;
        if (currentRowspan == 1) {
          return true;
        } else {
          let i = 0;
          for (; i < this.element.rows[this.selectR].columns.length; i++) {
            if (currentRowspan != this.element.rows[this.selectR].columns[i].options.rowspan || this.element.rows[this.selectR].columns[i].options.invisible) {
              return false;
            }
          }
          if (this.element.rows[this.selectR].columns.length == i) {
            return true;
          }
        }
      }
      return false;
    },
    showRemoveColumn() {
      if (this.selectR >= 0 && this.selectC >= 0 && this.element.rows[this.selectR].columns.length > 1) {
        const currentColspan = this.element.rows[this.selectR].columns[this.selectC].options.colspan;
        if (currentColspan == 1) {
          return true;
        } else {
          let i = 0;
          for (; i < this.element.rows.length; i++) {
            if (currentColspan != this.element.rows[i].columns[this.selectC].options.colspan || this.element.rows[i].columns[this.selectC].options.invisible) {
              return false;
            }
          }
          if (this.element.rows.length == i) {
            return true;
          }
        }
      }
      return false;
    },
    showSplitColumn() {
      if (this.selectR >= 0 && this.selectC >= 0) {
        return this.element.rows[this.selectR].columns[this.selectC].options.colspan > 1;
      }
      return false;
    },
    showSplitRow() {
      if (this.selectR >= 0 && this.selectC >= 0) {
        return this.element.rows[this.selectR].columns[this.selectC].options.rowspan > 1;
      }
      return false;
    }
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetReport"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetReport"], "is-hover");
    },
    handleMouseoverTD(r, i) {
      addClass$1(this.$refs[`widgetTD_${r}_${i}`][0], "is-hover");
    },
    handleMouseoutTD(r, i) {
      removeClass$1(this.$refs[`widgetTD_${r}_${i}`][0], "is-hover");
    },
    handleMouseoverTH(i) {
      addClass$1(this.$refs[`widgetTH_${i}`][0], "is-hover");
    },
    handleMouseoutTH(i) {
      removeClass$1(this.$refs[`widgetTH_${i}`][0], "is-hover");
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("dialog-put") >= 0 || c.children[0].className.split(" ").indexOf("dialog-put") >= 0) {
        return false;
      }
      return true;
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data.list[index2]);
    },
    handleSelectItemWidget(rowIndex, colIndex) {
      this.$emit("update:select", this.data.list[this.index].rows[rowIndex].columns[colIndex]);
      this.selectR = rowIndex;
      this.selectC = colIndex;
    },
    handleSelectHeaderWidget(index2) {
      this.$emit("update:select", this.data.list[this.index].headerRow[index2]);
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleWidgetItemAdd($event, element, rowIndex, colIndex) {
      const newIndex2 = $event.newIndex;
      fixDraggbleList(element.rows[rowIndex].columns[colIndex].list, newIndex2);
      const key = Math.random().toString(36).slice(-8);
      element.rows[rowIndex].columns[colIndex].list[newIndex2] = _.cloneDeep(element.rows[rowIndex].columns[colIndex].list[newIndex2]);
      element.rows[rowIndex].columns[colIndex].list[newIndex2] = {
        ...element.rows[rowIndex].columns[colIndex].list[newIndex2],
        options: {
          ...element.rows[rowIndex].columns[colIndex].list[newIndex2].options,
          remoteFunc: element.rows[rowIndex].columns[colIndex].list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: element.rows[rowIndex].columns[colIndex].list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          hideLabel: true,
          subform: this.subform ? true : false
        },
        key: element.rows[rowIndex].columns[colIndex].list[newIndex2].key ? element.rows[rowIndex].columns[colIndex].list[newIndex2].key : key,
        model: element.rows[rowIndex].columns[colIndex].list[newIndex2].model ? element.rows[rowIndex].columns[colIndex].list[newIndex2].model : element.rows[rowIndex].columns[colIndex].list[newIndex2].type + "_" + key,
        rules: element.rows[rowIndex].columns[colIndex].list[newIndex2].rules ? [...element.rows[rowIndex].columns[colIndex].list[newIndex2].rules] : []
      };
      if (element.rows[rowIndex].columns[colIndex].list[newIndex2].type == "report") {
        element.rows[rowIndex].columns[colIndex].list[newIndex2].rows = generateKeyToTD(element.rows[rowIndex].columns[colIndex].list[newIndex2].rows);
        element.rows[rowIndex].columns[colIndex].list[newIndex2].headerRow = generateKeyToTH(element.rows[rowIndex].columns[colIndex].list[newIndex2].headerRow);
      }
      if (element.rows[rowIndex].columns[colIndex].list[newIndex2].type == "grid") {
        element.rows[rowIndex].columns[colIndex].list[newIndex2].columns = generateKeyToCol(element.rows[rowIndex].columns[colIndex].list[newIndex2].columns);
      }
      setTimeout(() => {
        this.selectWidget = element.rows[rowIndex].columns[colIndex].list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 50);
    },
    handleWidgetItemUpdate() {
      EventBus.$emit("on-history-add-" + this.formKey);
    },
    handleReportClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.$emit("update:select", this.data.list[index2 + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleAddRow(index2) {
      const columns = this.data.list[index2].rows[this.data.list[index2].rows.length - 1].columns.length;
      this.data.list[index2].rows.push({
        columns: Array.from({ length: columns }, (_2) => {
          return {
            type: "td",
            list: [],
            options: {
              customClass: "",
              colspan: 1,
              rowspan: 1,
              align: "left",
              valign: "top",
              width: "",
              height: ""
            },
            key: Math.random().toString(36).slice(-8)
          };
        })
      });
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleAddColumns(index2) {
      this.data.list[index2].headerRow.push({
        type: "th",
        options: {
          width: ""
        },
        key: Math.random().toString(36).slice(-8)
      });
      this.data.list[index2].rows.forEach((item) => {
        item.columns.push({
          type: "td",
          list: [],
          options: {
            customClass: "",
            colspan: 1,
            rowspan: 1,
            align: "left",
            valign: "top",
            width: "",
            height: ""
          },
          key: Math.random().toString(36).slice(-8)
        });
      });
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    insertColumns(insertIndex) {
      this.element.headerRow.splice(insertIndex, 0, {
        type: "th",
        options: {
          width: ""
        },
        key: Math.random().toString(36).slice(-8)
      });
      for (let i = 0; i < this.element.rows.length; i++) {
        const prevIndex = this.findPrevColIndex(i, insertIndex);
        if (prevIndex != insertIndex && this.element.rows[i].columns[insertIndex].options.invisible) {
          this.element.rows[i].columns.splice(insertIndex, 0, {
            type: "td",
            list: [],
            options: {
              customClass: "",
              colspan: 1,
              rowspan: 1,
              align: "left",
              valign: "top",
              width: "",
              height: "",
              invisible: true
            },
            key: Math.random().toString(36).slice(-8)
          });
          const beforeColspan = this.element.rows[i].columns[prevIndex].options.colspan;
          this.element.rows[i].columns[prevIndex].options.colspan = beforeColspan + 1;
          for (let j = 0; j < beforeColspan + 1; j++) {
            this.element.rows[i].columns[prevIndex + j].options.markCol = j;
          }
        } else {
          this.element.rows[i].columns.splice(insertIndex, 0, {
            type: "td",
            list: [],
            options: {
              customClass: "",
              colspan: 1,
              rowspan: 1,
              align: "left",
              valign: "top",
              width: "",
              height: ""
            },
            key: Math.random().toString(36).slice(-8)
          });
        }
      }
    },
    insertRow(insertIndex) {
      const rowArray = [];
      for (let i = 0; i < this.element.rows[0].columns.length; i++) {
        const prevIndex = this.findPrevRowIndex(insertIndex, i);
        if (prevIndex != insertIndex && this.element.rows[insertIndex].columns[i].options.invisible) {
          rowArray.push({
            type: "td",
            list: [],
            options: {
              customClass: "",
              colspan: 1,
              rowspan: 1,
              align: "left",
              valign: "top",
              width: "",
              height: "",
              invisible: true
            },
            key: Math.random().toString(36).slice(-8)
          });
          this.element.rows[prevIndex].columns[i].options.rowspan = this.element.rows[prevIndex].columns[i].options.rowspan + 1;
        } else {
          rowArray.push({
            type: "td",
            list: [],
            options: {
              customClass: "",
              colspan: 1,
              rowspan: 1,
              align: "left",
              valign: "top",
              width: "",
              height: ""
            },
            key: Math.random().toString(36).slice(-8)
          });
        }
      }
      this.element.rows.splice(insertIndex, 0, {
        columns: rowArray
      });
      this.$nextTick(() => {
        for (let i = 0; i < this.element.rows[insertIndex].columns.length; i++) {
          if (this.element.rows[insertIndex].columns[i].options.invisible) {
            const prevIndex = this.findPrevRowIndex(insertIndex - 1, i);
            if (!this.element.rows[prevIndex].columns[i].options.invisible) {
              this.markTableItem(prevIndex, i);
            }
          }
        }
      });
    },
    handleInsertLeft() {
      const insertIndex = this.selectC;
      this.insertColumns(insertIndex);
      this.selectC = this.selectC++;
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleInsertRight() {
      const insertColIndex = this.element.rows[this.selectR].columns[this.selectC].options.colspan > 1 ? this.findNextColIndex(this.selectR, this.selectC + 1) : this.selectC + 1;
      this.insertColumns(insertColIndex);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleInserBefore() {
      const insertIndex = this.selectR;
      this.insertRow(insertIndex);
      this.selectR = this.selectR++;
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleInserAfter() {
      const insertRowIndex = this.element.rows[this.selectR].columns[this.selectC].options.rowspan > 1 ? this.findNextRowIndex(this.selectR + 1, this.selectC) : this.selectR + 1;
      this.insertRow(insertRowIndex);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    markTableItem(R, C) {
      const colspan = this.element.rows[R].columns[C].options.colspan;
      const rowspan = this.element.rows[R].columns[C].options.rowspan;
      for (let i = 0; i < rowspan; i++) {
        for (let j = 0; j < colspan; j++) {
          this.element.rows[R + i].columns[C + j].options.markCol = j;
          this.element.rows[R + i].columns[C + j].options.markRow = i;
        }
      }
    },
    handleRight(column) {
      if (!this.showRight)
        return;
      const currentColspan = column.options.colspan;
      const nextC = this.selectC + currentColspan;
      const nextColspan = this.element.rows[this.selectR].columns[nextC].options.colspan;
      column.options.colspan = currentColspan + nextColspan;
      this.element.rows[this.selectR].columns[nextC].options.invisible = true;
      const tempList = [...this.element.rows[this.selectR].columns[nextC].list];
      this.element.rows[this.selectR].columns[nextC].list = [];
      column.list = column.list.concat(tempList);
      this.markTableItem(this.selectR, this.selectC);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleBottom(column) {
      if (!this.showBottom)
        return;
      const currentRowspan = column.options.rowspan;
      const nextR = this.selectR + currentRowspan;
      const nextRowspan = this.element.rows[nextR].columns[this.selectC].options.rowspan;
      column.options.rowspan = currentRowspan + nextRowspan;
      this.element.rows[nextR].columns[this.selectC].options.invisible = true;
      const tempList = [...this.element.rows[nextR].columns[this.selectC].list];
      this.element.rows[nextR].columns[this.selectC].list = [];
      column.list = column.list.concat(tempList);
      this.markTableItem(this.selectR, this.selectC);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleSplitColumn() {
      if (!this.showSplitColumn)
        return;
      const currentColspan = this.element.rows[this.selectR].columns[this.selectC].options.colspan;
      const currentRowspan = this.element.rows[this.selectR].columns[this.selectC].options.rowspan;
      for (let i = 0; i < currentColspan; i++) {
        this.element.rows[this.selectR].columns[this.selectC + i].options.invisible = false;
        this.element.rows[this.selectR].columns[this.selectC + i].options.colspan = 1;
        this.element.rows[this.selectR].columns[this.selectC + i].options.rowspan = currentRowspan;
        this.markTableItem(this.selectR, this.selectC + i);
      }
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleSplitRow() {
      if (!this.showSplitRow)
        return;
      const currentColspan = this.element.rows[this.selectR].columns[this.selectC].options.colspan;
      const currentRowspan = this.element.rows[this.selectR].columns[this.selectC].options.rowspan;
      for (let i = 0; i < currentRowspan; i++) {
        this.element.rows[this.selectR + i].columns[this.selectC].options.invisible = false;
        this.element.rows[this.selectR + i].columns[this.selectC].options.rowspan = 1;
        this.element.rows[this.selectR + i].columns[this.selectC].options.colspan = currentColspan;
        this.markTableItem(this.selectR + i, this.selectC);
      }
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    findPrevRowIndex(rowIndex, colIndex) {
      if (rowIndex >= this.element.rows.length || !this.element.rows[rowIndex].columns[colIndex].options.markRow) {
        return rowIndex;
      } else {
        return this.findPrevRowIndex(rowIndex - 1, colIndex);
      }
    },
    findPrevColIndex(rowIndex, colIndex) {
      if (colIndex >= this.element.rows[rowIndex].columns.length || !this.element.rows[rowIndex].columns[colIndex].options.markCol) {
        return colIndex;
      } else {
        return this.findPrevColIndex(rowIndex, colIndex - 1);
      }
    },
    findNextColIndex(rowIndex, colIndex) {
      if (colIndex >= this.element.rows[rowIndex].columns.length || !this.element.rows[rowIndex].columns[colIndex].options.markCol) {
        return colIndex;
      } else {
        return this.findNextColIndex(rowIndex, colIndex + 1);
      }
    },
    findNextRowIndex(rowIndex, colIndex) {
      if (rowIndex >= this.element.rows.length || !this.element.rows[rowIndex].columns[colIndex].options.markRow) {
        return rowIndex;
      } else {
        return this.findNextRowIndex(rowIndex + 1, colIndex);
      }
    },
    handleRemoveRow() {
      if (!this.showRemoveRow)
        return;
      for (let j = 0; j < this.element.rows[this.selectR].columns.length; j++) {
        const currentRowspan = this.element.rows[this.selectR].columns[j].options.rowspan;
        const currentcolspan = this.element.rows[this.selectR].columns[j].options.colspan;
        const invisible = this.element.rows[this.selectR].columns[j].options.invisible;
        if (invisible) {
          const prevIndex = this.findPrevRowIndex(this.selectR, j);
          if (prevIndex != this.selectR && this.element.rows[prevIndex].columns[j].options.rowspan > 1) {
            this.element.rows[prevIndex].columns[j].options.rowspan = this.element.rows[prevIndex].columns[j].options.rowspan - 1;
          }
        } else if (currentRowspan > 1) {
          this.element.rows[this.selectR + 1].columns[j].list = [...this.element.rows[this.selectR].columns[j].list];
          this.element.rows[this.selectR + 1].columns[j].options.invisible = false;
          this.element.rows[this.selectR + 1].columns[j].options.rowspan = currentRowspan - 1;
          this.element.rows[this.selectR + 1].columns[j].options.colspan = currentcolspan;
          this.markTableItem(this.selectR + 1, j);
        } else
          ;
      }
      this.element.rows.splice(this.selectR, 1);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleRemoveColumn() {
      if (!this.showRemoveColumn)
        return;
      for (let i = 0; i < this.element.rows.length; i++) {
        const currentColspan = this.element.rows[i].columns[this.selectC].options.colspan;
        const currentRowspan = this.element.rows[i].columns[this.selectC].options.rowspan;
        const invisible = this.element.rows[i].columns[this.selectC].options.invisible;
        if (invisible) {
          const prevIndex = this.findPrevColIndex(i, this.selectC);
          if (prevIndex != this.selectC && this.element.rows[i].columns[prevIndex].options.colspan > 1) {
            this.element.rows[i].columns[prevIndex].options.colspan = this.element.rows[i].columns[prevIndex].options.colspan - 1;
          }
        } else if (currentColspan > 1) {
          this.element.rows[i].columns[this.selectC + 1].list = [...this.element.rows[i].columns[this.selectC].list];
          this.element.rows[i].columns[this.selectC + 1].options.invisible = false;
          this.element.rows[i].columns[this.selectC + 1].options.colspan = currentColspan - 1;
          this.element.rows[i].columns[this.selectC + 1].options.rowspan = currentRowspan;
          this.markTableItem(i, this.selectC + 1);
        } else
          ;
        this.element.rows[i].columns.splice(this.selectC, 1);
      }
      this.element.headerRow.splice(this.selectC, 1);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleSetColumnWidth() {
      this.$emit("update:select", this.data.list[this.index].headerRow[this.selectC]);
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.$emit("update:select", item.list[index2]) : this.$emit("update:select", this.data.list[this.index]);
      });
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
      this.element.headerRow && (this.selectIndex = this.element.headerRow.findIndex((item) => item.key === val.key));
    },
    selectWidget(val) {
      this.$emit("update:select", val);
      this.element.headerRow && (this.selectIndex = this.element.headerRow.findIndex((item) => item.key === val.key));
    }
  }
};
const _hoisted_1$l = { class: "fm-report-table" };
const _hoisted_2$j = ["onClick", "onMouseover", "onMouseout"];
const _hoisted_3$f = { style: { "text-align": "center", "height": "10px", "line-height": "10px", "font-size": "12px" } };
const _hoisted_4$e = ["colspan", "rowspan", "onClick", "onMouseover", "onMouseout"];
const _hoisted_5$e = {
  key: 0,
  class: "widget-view-action widget-col-action"
};
const _hoisted_6$c = { class: "el-dropdown-link" };
const _hoisted_7$b = ["title"];
const _hoisted_8$6 = { class: "widget-view-type" };
const _hoisted_9$5 = {
  key: 0,
  class: "widget-view-action widget-col-action"
};
const _hoisted_10$3 = ["title"];
const _hoisted_11$3 = ["title"];
const _hoisted_12$3 = ["title"];
const _hoisted_13$2 = ["title"];
const _hoisted_14$2 = {
  key: 1,
  class: "widget-view-drag widget-col-drag"
};
const _hoisted_15$1 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_16$1 = [
  _hoisted_15$1
];
const _hoisted_17$1 = { class: "widget-view-type" };
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_tab_item = resolveComponent("widget-tab-item");
  const _component_widget_collapse = resolveComponent("widget-collapse");
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_sub_form = resolveComponent("widget-sub-form");
  const _component_widget_card = resolveComponent("widget-card");
  const _component_widget_group = resolveComponent("widget-group");
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_report = resolveComponent("widget-report", true);
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_widget_col_item = resolveComponent("widget-col-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_dropdown_item = resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = resolveComponent("el-dropdown");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-report widget-view", {
      active: $props.select.key && $props.select.key == $props.element.key,
      "is_hidden": $props.element.options.hidden
    }]),
    onClick: _cache[14] || (_cache[14] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[15] || (_cache[15] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[16] || (_cache[16] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetReport"
  }, [
    createElementVNode("div", _hoisted_1$l, [
      createElementVNode("table", {
        class: normalizeClass(["fm-report-table__table", {
          [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false
        }]),
        style: normalizeStyle({
          "border-top-width": $props.element.options.borderWidth + "px",
          "border-top-color": $props.element.options.borderColor,
          "border-left-width": $props.element.options.borderWidth + "px",
          "border-left-color": $props.element.options.borderColor,
          "width": $props.element.options.width || "auto"
        })
      }, [
        createElementVNode("tr", null, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.headerRow, (th, i) => {
            return openBlock(), createElementBlock("th", {
              key: i,
              style: normalizeStyle({
                "border-right-width": $props.element.options.borderWidth + "px",
                "border-bottom-width": $props.element.options.borderWidth + "px",
                "border-bottom-color": $props.element.options.borderColor,
                "width": th.options.width
              }),
              class: normalizeClass(["widget-report-item widget-report-header", {
                active: $props.select.key && $props.select.key == th.key
              }]),
              valign: "top",
              onClick: withModifiers(($event) => $options.handleSelectHeaderWidget(i), ["stop"]),
              onMouseover: withModifiers(($event) => $options.handleMouseoverTH(i), ["stop"]),
              onMouseout: ($event) => $options.handleMouseoutTH(i),
              ref_for: true,
              ref: `widgetTH_${i}`
            }, [
              createElementVNode("div", _hoisted_3$f, toDisplayString$1(th.options.width), 1)
            ], 46, _hoisted_2$j);
          }), 128))
        ]),
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.rows, (row, rowIndex) => {
          return openBlock(), createElementBlock("tr", { key: rowIndex }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(row.columns, (column, i) => {
              return openBlock(), createElementBlock(Fragment, {
                key: rowIndex + "-" + i
              }, [
                !column.options.invisible ? (openBlock(), createElementBlock("td", {
                  key: 0,
                  style: normalizeStyle({
                    "border-right-width": $props.element.options.borderWidth + "px",
                    "border-right-color": $props.element.options.borderColor,
                    "border-bottom-width": $props.element.options.borderWidth + "px",
                    "border-bottom-color": $props.element.options.borderColor,
                    "width": column.options.width,
                    "height": column.options.height
                  }),
                  colspan: column.options.colspan,
                  rowspan: column.options.rowspan,
                  class: normalizeClass(["widget-report-item fm-report-table__td", {
                    active: $props.select.key && $props.select.key == column.key,
                    [column.options.customClass]: column.options.customClass ? true : false,
                    selected: $data.selectIndex == i && column.options.colspan == 1
                  }]),
                  onClick: withModifiers(($event) => $options.handleSelectItemWidget(rowIndex, i), ["stop"]),
                  valign: "top",
                  onMouseover: withModifiers(($event) => $options.handleMouseoverTD(rowIndex, i), ["stop"]),
                  onMouseout: ($event) => $options.handleMouseoutTD(rowIndex, i),
                  ref_for: true,
                  ref: `widgetTD_${rowIndex}_${i}`
                }, [
                  createVNode(_component_draggable, mergeProps({
                    modelValue: column.list,
                    "onUpdate:modelValue": ($event) => column.list = $event
                  }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
                    "no-transition-on-drag": true,
                    onAdd: ($event) => $options.handleWidgetItemAdd($event, $props.element, rowIndex, i),
                    onUpdate: $options.handleWidgetItemUpdate,
                    class: "widget-col-list",
                    "item-key": "key"
                  }), {
                    item: withCtx(({ element: c, index: cindex }) => [
                      c.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey,
                        subform: $props.subform
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : c.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey,
                        subform: $props.subform
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : c.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : c.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : c.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : c.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : c.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : c.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey,
                        subform: $props.subform
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : c.type !== "grid" ? (openBlock(), createBlock(_component_widget_form_item, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        "form-key": $props.formKey
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"])) : (openBlock(), createBlock(_component_widget_col_item, {
                        key: c.key,
                        element: c,
                        select: $data.selectWidget,
                        "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
                        index: cindex,
                        data: column,
                        onSelectChange: ($event) => $options.handleSelectChange($event, column),
                        platform: $props.platform,
                        "form-key": $props.formKey,
                        subform: $props.subform
                      }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"]))
                    ]),
                    _: 2
                  }, 1040, ["modelValue", "onUpdate:modelValue", "onAdd", "onUpdate"]),
                  $props.select.key == column.key ? (openBlock(), createElementBlock("div", _hoisted_5$e, [
                    createVNode(_component_el_dropdown, {
                      size: "default",
                      trigger: "click"
                    }, {
                      dropdown: withCtx(() => [
                        createVNode(_component_el_dropdown_menu, null, {
                          default: withCtx(() => [
                            createVNode(_component_el_dropdown_item, {
                              command: "insertleft",
                              onClick: withModifiers($options.handleInsertLeft, ["stop"])
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.insertcolumnleft")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "insertright",
                              onClick: withModifiers($options.handleInsertRight, ["stop"])
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.insertcolumnright")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "insertbefore",
                              onClick: withModifiers($options.handleInserBefore, ["stop"])
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.insertrowbefore")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "insertafter",
                              onClick: withModifiers($options.handleInserAfter, ["stop"])
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.insertrowafter")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "right",
                              onClick: withModifiers(($event) => $options.handleRight(column), ["stop"]),
                              disabled: !$options.showRight,
                              divided: ""
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.mergeright")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "bottom",
                              onClick: withModifiers(($event) => $options.handleBottom(column), ["stop"]),
                              disabled: !$options.showBottom
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.mergedown")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "splitcolumns",
                              onClick: withModifiers($options.handleSplitColumn, ["stop"]),
                              divided: "",
                              disabled: !$options.showSplitColumn
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.splitcolumns")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "splitrows",
                              onClick: withModifiers($options.handleSplitRow, ["stop"]),
                              disabled: !$options.showSplitRow
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.splitrows")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "removecolumn",
                              onClick: withModifiers($options.handleRemoveColumn, ["stop"]),
                              disabled: !$options.showRemoveColumn,
                              divided: ""
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.deletecolumn")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "removerow",
                              onClick: withModifiers($options.handleRemoveRow, ["stop"]),
                              disabled: !$options.showRemoveRow
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.deleterow")), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled"]),
                            createVNode(_component_el_dropdown_item, {
                              command: "setcolwidth",
                              onClick: withModifiers($options.handleSetColumnWidth, ["stop"]),
                              disabled: column.options.colspan !== 1,
                              divided: ""
                            }, {
                              default: withCtx(() => [
                                createTextVNode(toDisplayString$1(_ctx.$t("fm.tooltip.setcolwidth")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "disabled"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: withCtx(() => [
                        createElementVNode("span", _hoisted_6$c, [
                          createElementVNode("i", {
                            class: "fm-iconfont icon-biaogeshezhi",
                            title: _ctx.$t("fm.tooltip.cellsetting")
                          }, null, 8, _hoisted_7$b)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ])) : createCommentVNode("", true),
                  createElementVNode("div", _hoisted_8$6, [
                    createElementVNode("span", null, toDisplayString$1(column.type ? this.$t("fm.components.fields." + column.type) : ""), 1)
                  ])
                ], 46, _hoisted_4$e)) : createCommentVNode("", true)
              ], 64);
            }), 128))
          ]);
        }), 128))
      ], 6)
    ]),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_9$5, [
      createElementVNode("i", {
        class: "fm-iconfont icon--charuhang",
        onClick: _cache[10] || (_cache[10] = withModifiers(($event) => $options.handleAddRow($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.addrow")
      }, null, 8, _hoisted_10$3),
      createElementVNode("i", {
        class: "fm-iconfont icon--charulie",
        onClick: _cache[11] || (_cache[11] = withModifiers(($event) => $options.handleAddColumns($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.addcolumn")
      }, null, 8, _hoisted_11$3),
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[12] || (_cache[12] = withModifiers(($event) => $options.handleReportClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_12$3),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[13] || (_cache[13] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_13$2)
    ])) : createCommentVNode("", true),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_14$2, _hoisted_16$1)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_17$1, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetReport = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$A]]);
var WidgetReport$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": WidgetReport
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$B = {
  name: "widget-sub-form",
  components: {
    Draggable: draggableComponent,
    WidgetFormItem,
    WidgetInline,
    WidgetTable,
    WidgetColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetColItem$1;
    })),
    WidgetTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTabItem$1;
    })),
    WidgetReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetReport$1;
    })),
    WidgetCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCollapse$1;
    })),
    WidgetCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCard$1;
    })),
    WidgetGroup: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetGroup$1;
    }))
  },
  props: ["element", "select", "index", "data", "platform", "formKey"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {}
    };
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetSubform"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetSubform"], "is-hover");
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("dialog-put") >= 0 || c.children[0].className.split(" ").indexOf("dialog-put") >= 0) {
        return false;
      }
      return true;
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data.list[index2]);
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.$emit("update:select", this.element.list[index2]) : this.$emit("update:select", this.data.list[this.index]);
      });
    },
    handleWidgetClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.$emit("update:select", this.data.list[index2 + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleWidgetSubFormAdd($event, element) {
      const newIndex2 = $event.newIndex;
      const key = Math.random().toString(36).slice(-8);
      fixDraggbleList(element.list, newIndex2);
      element.list[newIndex2] = _.cloneDeep(element.list[newIndex2]);
      element.list[newIndex2] = {
        ...element.list[newIndex2],
        options: {
          ...element.list[newIndex2].options,
          remoteFunc: element.list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: element.list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          subform: true
        },
        key: element.list[newIndex2].key ? element.list[newIndex2].key : key,
        model: element.list[newIndex2].model ? element.list[newIndex2].model : element.list[newIndex2].type + "_" + key,
        rules: element.list[newIndex2].rules ? [...element.list[newIndex2].rules] : []
      };
      if (element.list[newIndex2].type == "report") {
        element.list[newIndex2].rows = generateKeyToTD(element.list[newIndex2].rows);
        element.list[newIndex2].headerRow = generateKeyToTH(element.list[newIndex2].headerRow);
      }
      if (element.list[newIndex2].type == "grid") {
        element.list[newIndex2].columns = generateKeyToCol(element.list[newIndex2].columns);
      }
      this.$nextTick(() => {
        this.selectWidget = element.list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetSubFormUpdate() {
      EventBus.$emit("on-history-add-" + this.formKey);
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$k = ["innerHTML"];
const _hoisted_2$i = { class: "widget-subform-wrapper" };
const _hoisted_3$e = {
  key: 0,
  class: "widget-view-action widget-subform-action"
};
const _hoisted_4$d = ["title"];
const _hoisted_5$d = ["title"];
const _hoisted_6$b = {
  key: 1,
  class: "widget-view-drag widget-subform-drag"
};
const _hoisted_7$a = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_8$5 = [
  _hoisted_7$a
];
const _hoisted_9$4 = { class: "widget-view-type" };
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_tab_item = resolveComponent("widget-tab-item");
  const _component_widget_collapse = resolveComponent("widget-collapse");
  const _component_widget_card = resolveComponent("widget-card");
  const _component_widget_group = resolveComponent("widget-group");
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_report = resolveComponent("widget-report");
  const _component_widget_sub_form = resolveComponent("widget-sub-form", true);
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_widget_col_item = resolveComponent("widget-col-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_form_item = resolveComponent("el-form-item");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-subform widget-view", {
      active: $props.select.key && $props.select.key == $props.element.key,
      "is_hidden": $props.element.options.hidden
    }]),
    onClick: _cache[14] || (_cache[14] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[15] || (_cache[15] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[16] || (_cache[16] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetSubform"
  }, [
    createVNode(_component_el_form_item, {
      label: $props.element.options.hideLabel ? "" : $props.element.name,
      "label-width": $props.element.options.hideLabel ? "0px" : $props.element.options.isLabelWidth ? $props.element.options.labelWidth + "px" : "",
      class: normalizeClass({
        [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false,
        "fm-label-wrap": $props.element.options.labelWrap
      })
    }, {
      default: withCtx(() => [
        $props.element.options.tip ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "fm-item-tooltip",
          innerHTML: $props.element.options.tip.replace(/\n/g, "<br/>")
        }, null, 8, _hoisted_1$k)) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2$i, [
          createVNode(_component_draggable, mergeProps({
            modelValue: $props.element.list,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $props.element.list = $event)
          }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
            "no-transition-on-drag": true,
            onAdd: _cache[11] || (_cache[11] = ($event) => $options.handleWidgetSubFormAdd($event, $props.element)),
            onUpdate: $options.handleWidgetSubFormUpdate,
            class: ["widget-col-list", {
              [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false
            }],
            "item-key": "key"
          }), {
            item: withCtx(({ element: item, index: index2 }) => [
              item.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type !== "grid" ? (openBlock(), createBlock(_component_widget_form_item, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"])) : (openBlock(), createBlock(_component_widget_col_item, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey,
                subform: true
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"]))
            ]),
            _: 1
          }, 16, ["modelValue", "onUpdate", "class"])
        ])
      ]),
      _: 1
    }, 8, ["label", "label-width", "class"]),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_3$e, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[12] || (_cache[12] = withModifiers(($event) => $options.handleWidgetClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_4$d),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[13] || (_cache[13] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_5$d)
    ])) : createCommentVNode("", true),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_6$b, _hoisted_8$5)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_9$4, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetSubForm = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$z]]);
var WidgetSubForm$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": WidgetSubForm
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$A = {
  name: "widget-collapse",
  components: {
    WidgetFormItem,
    WidgetTable,
    WidgetInline,
    Draggable: draggableComponent,
    WidgetColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetColItem$1;
    })),
    WidgetReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetReport$1;
    })),
    WidgetSubForm: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetSubForm$1;
    })),
    WidgetTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTabItem$1;
    })),
    WidgetCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCard$1;
    })),
    WidgetGroup: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetGroup$1;
    }))
  },
  props: ["element", "select", "index", "data", "platform", "formKey", "subform"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      tabActive: this.element.tabs.map((t) => t.name),
      selectWidget: this.select || {}
    };
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetCollapse"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetCollapse"], "is-hover");
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("dialog-put") >= 0 || c.children[0].className.split(" ").indexOf("dialog-put") >= 0) {
        return false;
      }
      return true;
    },
    handleSelectWidget(index2) {
      this.selectWidget = this.data.list[index2];
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleTabClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.selectWidget = this.data.list[index2 + 1];
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetTabUpdate(evt) {
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetTabAdd($event, element, tabIndex) {
      const newIndex2 = $event.newIndex;
      const key = Math.random().toString(36).slice(-8);
      fixDraggbleList(element.tabs[tabIndex].list, newIndex2);
      element.tabs[tabIndex].list[newIndex2] = _.cloneDeep(element.tabs[tabIndex].list[newIndex2]);
      element.tabs[tabIndex].list[newIndex2] = {
        ...element.tabs[tabIndex].list[newIndex2],
        options: {
          ...element.tabs[tabIndex].list[newIndex2].options,
          remoteFunc: element.tabs[tabIndex].list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: element.tabs[tabIndex].list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          subform: this.subform ? true : false
        },
        key: element.tabs[tabIndex].list[newIndex2].key ? element.tabs[tabIndex].list[newIndex2].key : key,
        model: element.tabs[tabIndex].list[newIndex2].model ? element.tabs[tabIndex].list[newIndex2].model : element.tabs[tabIndex].list[newIndex2].type + "_" + key,
        rules: element.tabs[tabIndex].list[newIndex2].rules ? [...element.tabs[tabIndex].list[newIndex2].rules] : []
      };
      if (element.tabs[tabIndex].list[newIndex2].type == "report") {
        element.tabs[tabIndex].list[newIndex2].rows = generateKeyToTD(element.tabs[tabIndex].list[newIndex2].rows);
        element.tabs[tabIndex].list[newIndex2].headerRow = generateKeyToTH(element.tabs[tabIndex].list[newIndex2].headerRow);
      }
      if (element.tabs[tabIndex].list[newIndex2].type == "grid") {
        element.tabs[tabIndex].list[newIndex2].columns = generateKeyToCol(element.tabs[tabIndex].list[newIndex2].columns);
      }
      setTimeout(() => {
        this.selectWidget = element.tabs[tabIndex].list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 50);
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.selectWidget = item.list[index2] : this.selectWidget = {};
      });
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$j = {
  key: 0,
  class: "widget-view-action widget-col-action"
};
const _hoisted_2$h = ["title"];
const _hoisted_3$d = ["title"];
const _hoisted_4$c = {
  key: 1,
  class: "widget-view-drag widget-col-drag"
};
const _hoisted_5$c = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_6$a = [
  _hoisted_5$c
];
const _hoisted_7$9 = { class: "widget-view-type" };
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_tab_item = resolveComponent("widget-tab-item");
  const _component_widget_collapse = resolveComponent("widget-collapse", true);
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_sub_form = resolveComponent("widget-sub-form");
  const _component_widget_card = resolveComponent("widget-card");
  const _component_widget_group = resolveComponent("widget-group");
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_report = resolveComponent("widget-report");
  const _component_widget_col_item = resolveComponent("widget-col-item");
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_collapse_item = resolveComponent("el-collapse-item");
  const _component_el_collapse = resolveComponent("el-collapse");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-collapse widget-view", {
      active: $data.selectWidget.key && $data.selectWidget.key == $props.element.key,
      "is_hidden": $props.element.options.hidden
    }]),
    onClick: _cache[13] || (_cache[13] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[14] || (_cache[14] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[15] || (_cache[15] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetCollapse"
  }, [
    createVNode(_component_el_collapse, {
      modelValue: $data.tabActive,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $data.tabActive = $event),
      accordion: $props.element.options.accordion,
      class: normalizeClass({
        [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false
      })
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.tabs, (item, index2) => {
          return openBlock(), createBlock(_component_el_collapse_item, {
            key: item.name,
            title: item.title,
            name: item.name
          }, {
            default: withCtx(() => [
              createVNode(_component_draggable, mergeProps({
                modelValue: item.list,
                "onUpdate:modelValue": ($event) => item.list = $event
              }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
                "no-transition-on-drag": true,
                onAdd: ($event) => $options.handleWidgetTabAdd($event, $props.element, index2),
                onUpdate: $options.handleWidgetTabUpdate,
                class: "widget-col-list",
                "item-key": "key"
              }), {
                item: withCtx(({ element: tab, index: tabindex }) => [
                  tab.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : tab.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : tab.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : tab.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : tab.type === "grid" ? (openBlock(), createBlock(_component_widget_col_item, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    platform: $props.platform,
                    "form-key": $props.formKey,
                    subform: $props.subform
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key", "subform"])) : (openBlock(), createBlock(_component_widget_form_item, {
                    key: tab.key,
                    element: tab,
                    select: $data.selectWidget,
                    "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
                    index: tabindex,
                    data: item,
                    onSelectChange: ($event) => $options.handleSelectChange($event, item),
                    "form-key": $props.formKey
                  }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"]))
                ]),
                _: 2
              }, 1040, ["modelValue", "onUpdate:modelValue", "onAdd", "onUpdate"])
            ]),
            _: 2
          }, 1032, ["title", "name"]);
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "accordion", "class"]),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_1$j, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[11] || (_cache[11] = withModifiers(($event) => $options.handleTabClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_2$h),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[12] || (_cache[12] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_3$d)
    ])) : createCommentVNode("", true),
    $data.selectWidget.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_4$c, _hoisted_6$a)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_7$9, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetCollapse = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$y]]);
var WidgetCollapse$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": WidgetCollapse
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$z = {
  name: "widget-dialog",
  components: {
    Draggable: draggableComponent,
    WidgetFormItem,
    WidgetInline,
    WidgetColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetColItem$1;
    })),
    WidgetTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTabItem$1;
    })),
    WidgetReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetReport$1;
    })),
    WidgetCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCollapse$1;
    })),
    WidgetTable: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTable$1;
    })),
    WidgetSubForm: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetSubForm$1;
    })),
    WidgetCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCard$1;
    })),
    WidgetGroup: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetGroup$1;
    }))
  },
  props: ["element", "select", "index", "data", "platform", "formKey"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {},
      visible: true
    };
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetDialog"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetDialog"], "is-hover");
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("dialog-put") >= 0 || c.children[0].className.split(" ").indexOf("dialog-put") >= 0) {
        return false;
      }
      return true;
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data.list[index2]);
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.$emit("update:select", this.element.list[index2]) : this.$emit("update:select", this.data.list[this.index]);
      });
    },
    handleWidgetClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.$emit("update:select", this.data.list[index2 + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleWidgetDialogAdd($event, element) {
      const newIndex2 = $event.newIndex;
      const key = Math.random().toString(36).slice(-8);
      fixDraggbleList(element.list, newIndex2);
      element.list[newIndex2] = _.cloneDeep(element.list[newIndex2]);
      element.list[newIndex2] = {
        ...element.list[newIndex2],
        options: {
          ...element.list[newIndex2].options,
          remoteFunc: element.list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: element.list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          subform: false
        },
        key: element.list[newIndex2].key ? element.list[newIndex2].key : key,
        model: element.list[newIndex2].model ? element.list[newIndex2].model : element.list[newIndex2].type + "_" + key,
        rules: element.list[newIndex2].rules ? [...element.list[newIndex2].rules] : []
      };
      if (element.list[newIndex2].type == "report") {
        element.list[newIndex2].rows = generateKeyToTD(element.list[newIndex2].rows);
        element.list[newIndex2].headerRow = generateKeyToTH(element.list[newIndex2].headerRow);
      }
      if (element.list[newIndex2].type == "grid") {
        element.list[newIndex2].columns = generateKeyToCol(element.list[newIndex2].columns);
      }
      this.$nextTick(() => {
        this.selectWidget = element.list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetDialogUpdate() {
      EventBus.$emit("on-history-add-" + this.formKey);
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$i = { class: "el-dialog__header" };
const _hoisted_2$g = { class: "el-dialog__title" };
const _hoisted_3$c = {
  key: 0,
  "aria-label": "Close this dialog",
  class: "el-dialog__headerbtn",
  type: "button"
};
const _hoisted_4$b = /* @__PURE__ */ createElementVNode("i", { class: "el-icon el-dialog__close" }, [
  /* @__PURE__ */ createElementVNode("svg", {
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /* @__PURE__ */ createElementVNode("path", {
      fill: "currentColor",
      d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
    })
  ])
], -1);
const _hoisted_5$b = [
  _hoisted_4$b
];
const _hoisted_6$9 = { class: "el-dialog__body" };
const _hoisted_7$8 = {
  key: 0,
  class: "el-dialog__footer"
};
const _hoisted_8$4 = {
  key: 0,
  class: "widget-view-action widget-subform-action"
};
const _hoisted_9$3 = ["title"];
const _hoisted_10$2 = ["title"];
const _hoisted_11$2 = {
  key: 1,
  class: "widget-view-drag widget-subform-drag"
};
const _hoisted_12$2 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_13$1 = [
  _hoisted_12$2
];
const _hoisted_14$1 = { class: "widget-view-type" };
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_tab_item = resolveComponent("widget-tab-item");
  const _component_widget_collapse = resolveComponent("widget-collapse");
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_sub_form = resolveComponent("widget-sub-form");
  const _component_widget_card = resolveComponent("widget-card");
  const _component_widget_group = resolveComponent("widget-group");
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_report = resolveComponent("widget-report");
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_widget_col_item = resolveComponent("widget-col-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_button = resolveComponent("el-button");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-dialog widget-view", {
      active: $props.select.key && $props.select.key == $props.element.key,
      "is_hidden": !$props.element.options.visible
    }]),
    onClick: _cache[14] || (_cache[14] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[15] || (_cache[15] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[16] || (_cache[16] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetDialog"
  }, [
    createElementVNode("div", {
      class: normalizeClass(["el-dialog", { "el-dialog--center": $props.element.options.center }]),
      style: normalizeStyle({
        "--el-dialog-width": $props.element.options.width ? $props.element.options.width : "100%",
        "--el-dialog-margin-top": $props.element.options.top
      })
    }, [
      createElementVNode("div", _hoisted_1$i, [
        createElementVNode("span", _hoisted_2$g, toDisplayString$1($props.element.options.title), 1),
        $props.element.options.showClose ? (openBlock(), createElementBlock("button", _hoisted_3$c, _hoisted_5$b)) : createCommentVNode("", true)
      ]),
      createElementVNode("div", _hoisted_6$9, [
        createVNode(_component_draggable, mergeProps({
          modelValue: $props.element.list,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $props.element.list = $event)
        }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
          "no-transition-on-drag": true,
          onAdd: _cache[11] || (_cache[11] = ($event) => $options.handleWidgetDialogAdd($event, $props.element)),
          onUpdate: $options.handleWidgetDialogUpdate,
          class: ["widget-col-list", {
            [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false
          }],
          "item-key": "key"
        }), {
          item: withCtx(({ element: item, index: index2 }) => [
            item.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type !== "grid" ? (openBlock(), createBlock(_component_widget_form_item, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"])) : (openBlock(), createBlock(_component_widget_col_item, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"]))
          ]),
          _: 1
        }, 16, ["modelValue", "onUpdate", "class"])
      ]),
      $props.element.options.showCancel || $props.element.options.showOk ? (openBlock(), createElementBlock("div", _hoisted_7$8, [
        createElementVNode("div", null, [
          $props.element.options.showCancel ? (openBlock(), createBlock(_component_el_button, { key: 0 }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1($props.element.options.cancelText), 1)
            ]),
            _: 1
          })) : createCommentVNode("", true),
          $props.element.options.showOk ? (openBlock(), createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            loading: $props.element.options.confirmLoading
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1($props.element.options.okText), 1)
            ]),
            _: 1
          }, 8, ["loading"])) : createCommentVNode("", true)
        ])
      ])) : createCommentVNode("", true)
    ], 6),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_8$4, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[12] || (_cache[12] = withModifiers(($event) => $options.handleWidgetClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_9$3),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[13] || (_cache[13] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_10$2)
    ])) : createCommentVNode("", true),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_11$2, _hoisted_13$1)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_14$1, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetDialog = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$x]]);
var WidgetCard_vue_vue_type_style_index_0_lang = "";
const __default__$3 = {
  name: "widget-card",
  components: {
    Draggable: draggableComponent,
    WidgetFormItem,
    WidgetInline,
    WidgetColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetColItem$1;
    })),
    WidgetTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTabItem$1;
    })),
    WidgetReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetReport$1;
    })),
    WidgetCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCollapse$1;
    })),
    WidgetTable: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTable$1;
    })),
    WidgetSubForm: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetSubForm$1;
    })),
    WidgetGroup: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetGroup$1;
    }))
  },
  props: ["element", "select", "index", "data", "platform", "formKey", "subform"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {}
    };
  },
  computed: {
    padding() {
      return this.element.options.padding || "20px";
    }
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetCard"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetCard"], "is-hover");
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("dialog-put") >= 0 || c.children[0].className.split(" ").indexOf("dialog-put") >= 0) {
        return false;
      }
      return true;
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data.list[index2]);
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.$emit("update:select", this.element.list[index2]) : this.$emit("update:select", this.data.list[this.index]);
      });
    },
    handleWidgetClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.$emit("update:select", this.data.list[index2 + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleWidgetCardAdd($event, element) {
      const newIndex2 = $event.newIndex;
      const key = Math.random().toString(36).slice(-8);
      fixDraggbleList(element.list, newIndex2);
      element.list[newIndex2] = _.cloneDeep(element.list[newIndex2]);
      element.list[newIndex2] = {
        ...element.list[newIndex2],
        options: {
          ...element.list[newIndex2].options,
          remoteFunc: element.list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: element.list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          subform: false
        },
        key: element.list[newIndex2].key ? element.list[newIndex2].key : key,
        model: element.list[newIndex2].model ? element.list[newIndex2].model : element.list[newIndex2].type + "_" + key,
        rules: element.list[newIndex2].rules ? [...element.list[newIndex2].rules] : []
      };
      if (element.list[newIndex2].type == "report") {
        element.list[newIndex2].rows = generateKeyToTD(element.list[newIndex2].rows);
        element.list[newIndex2].headerRow = generateKeyToTH(element.list[newIndex2].headerRow);
      }
      if (element.list[newIndex2].type == "grid") {
        element.list[newIndex2].columns = generateKeyToCol(element.list[newIndex2].columns);
      }
      this.$nextTick(() => {
        this.selectWidget = element.list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetCardUpdate() {
      EventBus.$emit("on-history-add-" + this.formKey);
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const __injectCSSVars__$3 = () => {
  useCssVars((_ctx) => ({
    "7bb30a08": _ctx.padding
  }));
};
const __setup__$3 = __default__$3.setup;
__default__$3.setup = __setup__$3 ? (props2, ctx) => {
  __injectCSSVars__$3();
  return __setup__$3(props2, ctx);
} : __injectCSSVars__$3;
const _sfc_main$y = __default__$3;
const _hoisted_1$h = {
  key: 0,
  class: "widget-view-action widget-subform-action"
};
const _hoisted_2$f = ["title"];
const _hoisted_3$b = ["title"];
const _hoisted_4$a = {
  key: 1,
  class: "widget-view-drag widget-subform-drag"
};
const _hoisted_5$a = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_6$8 = [
  _hoisted_5$a
];
const _hoisted_7$7 = { class: "widget-view-type" };
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b;
  const _component_widget_tab_item = resolveComponent("widget-tab-item");
  const _component_widget_collapse = resolveComponent("widget-collapse");
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_sub_form = resolveComponent("widget-sub-form");
  const _component_widget_card = resolveComponent("widget-card", true);
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_report = resolveComponent("widget-report");
  const _component_widget_group = resolveComponent("widget-group");
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_widget_col_item = resolveComponent("widget-col-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_card = resolveComponent("el-card");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-card widget-view", {
      active: $props.select.key && $props.select.key == $props.element.key,
      "is_hidden": $props.element.options.hidden
    }]),
    onClick: _cache[14] || (_cache[14] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    ref: "widgetCard",
    onMouseover: _cache[15] || (_cache[15] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[16] || (_cache[16] = (...args) => $options.handleMouseout && $options.handleMouseout(...args))
  }, [
    createVNode(_component_el_card, {
      shadow: $props.element.options.shadow,
      "body-style": {
        padding: $props.element.options.padding
      },
      style: normalizeStyle({
        width: $props.element.options.width,
        "border-width": $props.element.options.bordered ? "1px" : "0px"
      }),
      class: normalizeClass({
        [(_a2 = $props.element.options) == null ? void 0 : _a2.customClass]: ((_b = $props.element.options) == null ? void 0 : _b.customClass) ? true : false
      })
    }, createSlots({
      default: withCtx(() => [
        createVNode(_component_draggable, mergeProps({
          modelValue: $props.element.list,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $props.element.list = $event)
        }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
          "no-transition-on-drag": true,
          onAdd: _cache[11] || (_cache[11] = ($event) => $options.handleWidgetCardAdd($event, $props.element)),
          onUpdate: $options.handleWidgetCardUpdate,
          class: ["widget-col-list", {
            [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false
          }],
          "item-key": "key"
        }), {
          item: withCtx(({ element: item, index: index2 }) => [
            item.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type !== "grid" ? (openBlock(), createBlock(_component_widget_form_item, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"])) : (openBlock(), createBlock(_component_widget_col_item, {
              key: item.key,
              element: item,
              select: $data.selectWidget,
              "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
              index: index2,
              data: $props.element,
              onSelectChange: ($event) => $options.handleSelectChange($event, item),
              platform: $props.platform,
              "form-key": $props.formKey
            }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"]))
          ]),
          _: 1
        }, 16, ["modelValue", "onUpdate", "class"])
      ]),
      _: 2
    }, [
      $props.element.options.showHeader ? {
        name: "header",
        fn: withCtx(() => [
          createElementVNode("div", null, [
            createElementVNode("span", null, toDisplayString$1($props.element.options.title), 1)
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["shadow", "body-style", "style", "class"]),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_1$h, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[12] || (_cache[12] = withModifiers(($event) => $options.handleWidgetClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_2$f),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[13] || (_cache[13] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_3$b)
    ])) : createCommentVNode("", true),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_4$a, _hoisted_6$8)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_7$7, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetCard = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$w]]);
var WidgetCard$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": WidgetCard
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$x = {
  name: "widget-group",
  components: {
    Draggable: draggableComponent,
    WidgetFormItem,
    WidgetInline,
    WidgetColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetColItem$1;
    })),
    WidgetTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTabItem$1;
    })),
    WidgetReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetReport$1;
    })),
    WidgetCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCollapse$1;
    })),
    WidgetTable: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetTable$1;
    })),
    WidgetSubForm: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetSubForm$1;
    })),
    WidgetCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return WidgetCard$1;
    }))
  },
  props: ["element", "select", "index", "data", "platform", "formKey", "subform"],
  emits: ["select-change", "update:select"],
  data() {
    return {
      selectWidget: this.select || {}
    };
  },
  methods: {
    handleMouseover(e) {
      addClass$1(this.$refs["widgetGroup"], "is-hover");
    },
    handleMouseout(e) {
      removeClass$1(this.$refs["widgetGroup"], "is-hover");
    },
    handlePut(a, b, c) {
      if (c.className.split(" ").indexOf("widget-dialog") >= 0 || c.className.split(" ").indexOf("dialog-put") >= 0 || c.children[0].className.split(" ").indexOf("dialog-put") >= 0) {
        return false;
      }
      return true;
    },
    handleSelectWidget(index2) {
      this.$emit("update:select", this.data.list[index2]);
    },
    handleSelectChange(index2, item) {
      setTimeout(() => {
        index2 >= 0 ? this.$emit("update:select", this.element.list[index2]) : this.$emit("update:select", this.data.list[this.index]);
      });
    },
    handleWidgetClone(index2) {
      let cloneData = _.cloneDeep(this.data.list[index2]);
      this.data.list.splice(index2 + 1, 0, CloneLayout(cloneData));
      this.$nextTick(() => {
        this.$emit("update:select", this.data.list[index2 + 1]);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length == 1) {
        this.$emit("select-change", -1);
      } else {
        if (this.data.list.length - 1 == index2) {
          this.$emit("select-change", index2 - 1);
        } else {
          this.$emit("select-change", index2);
        }
      }
      this.data.list.splice(index2, 1);
      setTimeout(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      }, 20);
    },
    handleWidgetGroupAdd($event, element) {
      const newIndex2 = $event.newIndex;
      const key = Math.random().toString(36).slice(-8);
      fixDraggbleList(element.list, newIndex2);
      element.list[newIndex2] = _.cloneDeep(element.list[newIndex2]);
      element.list[newIndex2] = {
        ...element.list[newIndex2],
        options: {
          ...element.list[newIndex2].options,
          remoteFunc: element.list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: element.list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          subform: false
        },
        key: element.list[newIndex2].key ? element.list[newIndex2].key : key,
        model: element.list[newIndex2].model ? element.list[newIndex2].model : element.list[newIndex2].type + "_" + key,
        rules: element.list[newIndex2].rules ? [...element.list[newIndex2].rules] : []
      };
      if (element.list[newIndex2].type == "report") {
        element.list[newIndex2].rows = generateKeyToTD(element.list[newIndex2].rows);
        element.list[newIndex2].headerRow = generateKeyToTH(element.list[newIndex2].headerRow);
      }
      if (element.list[newIndex2].type == "grid") {
        element.list[newIndex2].columns = generateKeyToCol(element.list[newIndex2].columns);
      }
      this.$nextTick(() => {
        this.selectWidget = element.list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetGroupUpdate() {
      EventBus.$emit("on-history-add-" + this.formKey);
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$g = ["innerHTML"];
const _hoisted_2$e = {
  key: 0,
  class: "widget-view-action widget-subform-action"
};
const _hoisted_3$a = ["title"];
const _hoisted_4$9 = ["title"];
const _hoisted_5$9 = {
  key: 1,
  class: "widget-view-drag widget-subform-drag"
};
const _hoisted_6$7 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-drag drag-widget" }, null, -1);
const _hoisted_7$6 = [
  _hoisted_6$7
];
const _hoisted_8$3 = { class: "widget-view-type" };
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_widget_tab_item = resolveComponent("widget-tab-item");
  const _component_widget_collapse = resolveComponent("widget-collapse");
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_sub_form = resolveComponent("widget-sub-form");
  const _component_widget_card = resolveComponent("widget-card");
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_report = resolveComponent("widget-report");
  const _component_widget_group = resolveComponent("widget-group", true);
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_widget_col_item = resolveComponent("widget-col-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_form_item = resolveComponent("el-form-item");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-group widget-view", {
      active: $props.select.key && $props.select.key == $props.element.key,
      "is_hidden": $props.element.options.hidden
    }]),
    onClick: _cache[14] || (_cache[14] = withModifiers(($event) => $options.handleSelectWidget($props.index), ["stop"])),
    onMouseover: _cache[15] || (_cache[15] = withModifiers((...args) => $options.handleMouseover && $options.handleMouseover(...args), ["stop"])),
    onMouseout: _cache[16] || (_cache[16] = (...args) => $options.handleMouseout && $options.handleMouseout(...args)),
    ref: "widgetGroup"
  }, [
    createVNode(_component_el_form_item, {
      label: $props.element.options.hideLabel ? "" : $props.element.name,
      "label-width": $props.element.options.hideLabel ? "0px" : $props.element.options.isLabelWidth ? $props.element.options.labelWidth + "px" : "",
      class: normalizeClass({
        [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false,
        "fm-label-wrap": $props.element.options.labelWrap
      })
    }, {
      default: withCtx(() => [
        $props.element.options.tip ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "fm-item-tooltip",
          innerHTML: $props.element.options.tip.replace(/\n/g, "<br/>")
        }, null, 8, _hoisted_1$g)) : createCommentVNode("", true),
        createElementVNode("div", {
          style: normalizeStyle({
            width: $props.element.options.width
          })
        }, [
          createVNode(_component_draggable, mergeProps({
            modelValue: $props.element.list,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $props.element.list = $event)
          }, { group: { name: "people", put: $options.handlePut }, ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
            "no-transition-on-drag": true,
            onAdd: _cache[11] || (_cache[11] = ($event) => $options.handleWidgetGroupAdd($event, $props.element)),
            onUpdate: $options.handleWidgetGroupUpdate,
            class: ["widget-col-list", {
              [$props.element.options && $props.element.options.customClass]: $props.element.options.customClass ? true : false
            }],
            "item-key": "key"
          }), {
            item: withCtx(({ element: item, index: index2 }) => [
              item.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : item.type !== "grid" ? (openBlock(), createBlock(_component_widget_form_item, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"])) : (openBlock(), createBlock(_component_widget_col_item, {
                key: item.key,
                element: item,
                select: $data.selectWidget,
                "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
                index: index2,
                data: $props.element,
                onSelectChange: ($event) => $options.handleSelectChange($event, item),
                platform: $props.platform,
                "form-key": $props.formKey
              }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"]))
            ]),
            _: 1
          }, 16, ["modelValue", "onUpdate", "class"])
        ], 4)
      ]),
      _: 1
    }, 8, ["label", "label-width", "class"]),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_2$e, [
      createElementVNode("i", {
        class: "fm-iconfont icon-icon_clone",
        onClick: _cache[12] || (_cache[12] = withModifiers(($event) => $options.handleWidgetClone($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.clone")
      }, null, 8, _hoisted_3$a),
      createElementVNode("i", {
        class: "fm-iconfont icon-trash",
        onClick: _cache[13] || (_cache[13] = withModifiers(($event) => $options.handleWidgetDelete($props.index), ["stop"])),
        title: _ctx.$t("fm.tooltip.trash")
      }, null, 8, _hoisted_4$9)
    ])) : createCommentVNode("", true),
    $props.select.key == $props.element.key ? (openBlock(), createElementBlock("div", _hoisted_5$9, _hoisted_7$6)) : createCommentVNode("", true),
    createElementVNode("div", {
      class: "widget-view-model",
      style: normalizeStyle({ "color": $props.element.options.dataBind ? "" : "#666" })
    }, [
      createElementVNode("span", null, toDisplayString$1($props.element.model), 1)
    ], 4),
    createElementVNode("div", _hoisted_8$3, [
      createElementVNode("span", null, toDisplayString$1($props.element.type ? this.$t("fm.components.fields." + $props.element.type) : ""), 1)
    ])
  ], 34);
}
var WidgetGroup = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$v]]);
var WidgetGroup$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": WidgetGroup
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$w = {
  components: {
    Draggable: draggableComponent,
    WidgetFormItem,
    WidgetColItem,
    WidgetTable,
    WidgetTabItem,
    WidgetReport,
    WidgetInline,
    WidgetSubForm,
    WidgetCollapse,
    WidgetDialog,
    WidgetCard,
    WidgetGroup
  },
  props: ["data", "select", "platform", "formKey"],
  emits: ["update:select"],
  inject: ["changeConfigTab"],
  data() {
    return {
      selectWidget: this.select || {}
    };
  },
  mounted() {
    document.body.ondrop = function(event) {
      let isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
      if (isFirefox) {
        event.preventDefault();
        event.stopPropagation();
      }
    };
    EventBus.$on("on-field-add-" + this.formKey, (item) => {
      var _a2, _b, _c, _d;
      const key = Math.random().toString(36).slice(-8);
      let widgetItem = _.cloneDeep({
        ...item,
        options: {
          ...item.options,
          remoteFunc: "func_" + key,
          remoteOption: "option_" + key
        },
        key,
        model: item.type + "_" + key,
        rules: []
      });
      if (widgetItem.type == "report") {
        widgetItem.rows = generateKeyToTD(widgetItem.rows);
        widgetItem.headerRow = generateKeyToTH(widgetItem.headerRow);
      }
      if (widgetItem.type == "grid") {
        widgetItem.columns = generateKeyToCol(widgetItem.columns);
      }
      widgetItem.options.subform = (_b = (_a2 = this.selectWidget) == null ? void 0 : _a2.options) == null ? void 0 : _b.subform;
      widgetItem.options.tableColumn = (_d = (_c = this.selectWidget) == null ? void 0 : _c.options) == null ? void 0 : _d.tableColumn;
      this._addWidget(this.data.list, widgetItem);
    });
  },
  beforeUnmount() {
    EventBus.$off("on-field-add-" + this.formKey);
  },
  methods: {
    _addWidget(list, widget, isTable = false) {
      if (isTable && (widget.type == "subform" || widget.type == "grid" || widget.type == "table" || widget.type == "tabs" || widget.type == "collapse" || widget.type == "divider" || widget.type == "report" || widget.type == "inline" || widget.type == "dialog" || widget.type == "card")) {
        ElMessage({
          message: this.$t("fm.message.noPut"),
          type: "warning"
        });
        return "table";
      }
      if (this.selectWidget && this.selectWidget.key) {
        const index2 = list.findIndex((item) => item.key == this.selectWidget.key);
        if (index2 >= 0) {
          list.splice(index2 + 1, 0, widget);
          this.selectWidget = list[index2 + 1];
          setTimeout(() => {
            this.scrollTo();
          }, 200);
          this.$nextTick(() => {
            EventBus.$emit("on-history-add-" + this.formKey);
          });
        } else {
          for (let l = 0; l < list.length; l++) {
            let item = list[l];
            if (item.type === "grid") {
              item.columns.forEach((column) => {
                this._addWidget(column.list, widget);
              });
            }
            if (item.type === "table") {
              if ("table" == this._addWidget(item.tableColumns, widget, true)) {
                return "table";
              }
            }
            if (item.type === "subform") {
              if ("table" == this._addWidget(item.list, widget, true)) {
                return "table";
              }
            }
            if (item.type === "tabs") {
              item.tabs.forEach((tab) => {
                this._addWidget(tab.list, widget);
              });
            }
            if (item.type === "collapse") {
              item.tabs.forEach((tab) => {
                this._addWidget(tab.list, widget);
              });
            }
            if (item.type === "report") {
              for (let i = 0; i < item.rows.length; i++) {
                for (let j = 0; j < item.rows[i].columns.length; j++) {
                  widget.options.hideLabel = true;
                  if ("table" == this._addWidget(item.rows[i].columns[j].list, widget, false)) {
                    return "table";
                  }
                }
              }
            }
            if (item.type === "inline") {
              if ("table" == this._addWidget(item.list, widget, true)) {
                return "table";
              }
            }
            if (item.type === "dialog") {
              if ("table" == this._addWidget(item.list, widget, true)) {
                return "table";
              }
            }
            if (item.type === "card") {
              if ("table" == this._addWidget(item.list, widget, true)) {
                return "table";
              }
            }
            if (item.type === "group") {
              if ("table" == this._addWidget(item.list, widget, true)) {
                return "table";
              }
            }
          }
        }
      } else {
        list.push(widget);
        this.selectWidget = list[list.length - 1];
        setTimeout(() => {
          this.scrollTo();
        }, 200);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      }
    },
    handleWidgetUpdate(evt) {
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetAdd(evt) {
      const newIndex2 = evt.newIndex;
      evt.to;
      this.data.list[newIndex2] = _.cloneDeep(this.data.list[newIndex2]);
      const key = Math.random().toString(36).slice(-8);
      this.data.list[newIndex2] = {
        ...this.data.list[newIndex2],
        options: {
          ...this.data.list[newIndex2].options,
          remoteFunc: this.data.list[newIndex2].options.remoteFunc || "func_" + key,
          remoteOption: this.data.list[newIndex2].options.remoteOption || "option_" + key,
          tableColumn: false,
          subform: false
        },
        key: this.data.list[newIndex2].key ? this.data.list[newIndex2].key : key,
        model: this.data.list[newIndex2].model ? this.data.list[newIndex2].model : this.data.list[newIndex2].type + "_" + key,
        rules: this.data.list[newIndex2].rules ? [...this.data.list[newIndex2].rules] : []
      };
      if (this.data.list[newIndex2].type == "report") {
        this.data.list[newIndex2].rows = generateKeyToTD(this.data.list[newIndex2].rows);
        this.data.list[newIndex2].headerRow = generateKeyToTH(this.data.list[newIndex2].headerRow);
      }
      if (this.data.list[newIndex2].type == "grid") {
        this.data.list[newIndex2].columns = generateKeyToCol(this.data.list[newIndex2].columns);
      }
      this.$nextTick(() => {
        this.selectWidget = this.data.list[newIndex2];
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleWidgetDelete(index2) {
      if (this.data.list.length - 1 === index2) {
        if (index2 === 0) {
          this.selectWidget = {};
        } else {
          this.selectWidget = this.data.list[index2 - 1];
        }
      } else {
        this.selectWidget = this.data.list[index2 + 1];
      }
      this.$nextTick(() => {
        this.data.list.splice(index2, 1);
        this.$nextTick(() => {
          EventBus.$emit("on-history-add-" + this.formKey);
        });
      });
    },
    handleSelectChange(index2) {
      setTimeout(() => {
        index2 >= 0 ? this.selectWidget = this.data.list[index2] : this.selectWidget = {};
      });
    },
    scrollTo() {
      let activeTop = document.querySelector(".widget-form-container .active").getBoundingClientRect().top;
      let activeHeight = document.querySelector(".widget-form-container .active").offsetHeight;
      let containerHeight = document.querySelector(".widget-form-container").offsetHeight;
      let containerTop = document.querySelector(".widget-form-container").getBoundingClientRect().top;
      let scorllTop = document.querySelector(".widget-form-container .el-scrollbar__view").getBoundingClientRect().top;
      let y = activeTop - scorllTop;
      let top = scorllTop - containerTop;
      if (y + activeHeight > -top + containerHeight || y < -top) {
        this.$refs.formScrollRef.scrollTo({ top: y - 5, behavior: "smooth" });
      }
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val;
      if (Object.keys(val).length) {
        this.changeConfigTab("widget");
      } else {
        this.changeConfigTab("form");
      }
    },
    selectWidget(val) {
      this.$emit("update:select", val);
    }
  }
};
const _hoisted_1$f = {
  key: 0,
  class: "form-empty"
};
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2;
  const _component_widget_table = resolveComponent("widget-table");
  const _component_widget_collapse = resolveComponent("widget-collapse");
  const _component_widget_tab_item = resolveComponent("widget-tab-item");
  const _component_widget_report = resolveComponent("widget-report");
  const _component_widget_inline = resolveComponent("widget-inline");
  const _component_widget_sub_form = resolveComponent("widget-sub-form");
  const _component_widget_group = resolveComponent("widget-group");
  const _component_widget_dialog = resolveComponent("widget-dialog");
  const _component_widget_card = resolveComponent("widget-card");
  const _component_widget_form_item = resolveComponent("widget-form-item");
  const _component_widget_col_item = resolveComponent("widget-col-item");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  const _component_el_form = resolveComponent("el-form");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["widget-form-container", `${$props.platform}`])
  }, [
    createVNode(_component_el_form, {
      size: $props.data.config.size,
      "label-position": $props.data.config.labelPosition,
      "label-width": $props.data.config.labelWidth + "px",
      class: normalizeClass({
        [$props.data.config && $props.data.config.customClass]: $props.data.config && $props.data.config.customClass ? true : false
      }),
      style: normalizeStyle({ width: $props.data.config.width, margin: "auto" }),
      "label-suffix": ((_a2 = $props.data.config) == null ? void 0 : _a2.labelSuffix) ? " : " : " "
    }, {
      default: withCtx(() => [
        $props.data.list.length == 0 ? (openBlock(), createElementBlock("div", _hoisted_1$f, toDisplayString$1(_ctx.$t("fm.description.containerEmpty")), 1)) : createCommentVNode("", true),
        createVNode(_component_el_scrollbar, { ref: "formScrollRef" }, {
          default: withCtx(() => [
            createVNode(_component_draggable, mergeProps({
              list: $props.data.list
            }, { group: "people", ghostClass: "ghost", animation: 200, handle: ".drag-widget" }, {
              onAdd: $options.handleWidgetAdd,
              onUpdate: $options.handleWidgetUpdate,
              "no-transition-on-drag": true,
              "item-key": "key",
              class: "widget-form-list"
            }), {
              item: withCtx(({ element, index: index2 }) => [
                element.type === "table" ? (openBlock(), createBlock(_component_widget_table, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[0] || (_cache[0] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type === "collapse" ? (openBlock(), createBlock(_component_widget_collapse, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[1] || (_cache[1] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type === "tabs" ? (openBlock(), createBlock(_component_widget_tab_item, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[2] || (_cache[2] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type === "report" ? (openBlock(), createBlock(_component_widget_report, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[3] || (_cache[3] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type === "inline" ? (openBlock(), createBlock(_component_widget_inline, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[4] || (_cache[4] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type === "subform" ? (openBlock(), createBlock(_component_widget_sub_form, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[5] || (_cache[5] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type === "group" ? (openBlock(), createBlock(_component_widget_group, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[6] || (_cache[6] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type === "dialog" ? (openBlock(), createBlock(_component_widget_dialog, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[7] || (_cache[7] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type === "card" ? (openBlock(), createBlock(_component_widget_card, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[8] || (_cache[8] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"])) : element.type !== "grid" ? (openBlock(), createBlock(_component_widget_form_item, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[9] || (_cache[9] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "form-key"])) : (openBlock(), createBlock(_component_widget_col_item, {
                  key: element.key,
                  element,
                  select: $data.selectWidget,
                  "onUpdate:select": _cache[10] || (_cache[10] = ($event) => $data.selectWidget = $event),
                  index: index2,
                  data: $props.data,
                  onSelectChange: $options.handleSelectChange,
                  platform: $props.platform,
                  "form-key": $props.formKey
                }, null, 8, ["element", "select", "index", "data", "onSelectChange", "platform", "form-key"]))
              ]),
              _: 1
            }, 16, ["list", "onAdd", "onUpdate"])
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["size", "label-position", "label-width", "class", "style", "label-suffix"])
  ], 2);
}
var WidgetForm = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$u]]);
var clipboard = { exports: {} };
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    return function() {
      var __webpack_modules__ = {
        686: function(__unused_webpack_module, __webpack_exports__, __webpack_require__2) {
          __webpack_require__2.d(__webpack_exports__, {
            "default": function() {
              return clipboard2;
            }
          });
          var tiny_emitter = __webpack_require__2(279);
          var tiny_emitter_default = /* @__PURE__ */ __webpack_require__2.n(tiny_emitter);
          var listen = __webpack_require__2(370);
          var listen_default = /* @__PURE__ */ __webpack_require__2.n(listen);
          var src_select = __webpack_require__2(817);
          var select_default = /* @__PURE__ */ __webpack_require__2.n(src_select);
          function command(type) {
            try {
              return document.execCommand(type);
            } catch (err) {
              return false;
            }
          }
          var ClipboardActionCut = function ClipboardActionCut2(target) {
            var selectedText = select_default()(target);
            command("cut");
            return selectedText;
          };
          var actions_cut = ClipboardActionCut;
          function createFakeElement(value) {
            var isRTL = document.documentElement.getAttribute("dir") === "rtl";
            var fakeElement = document.createElement("textarea");
            fakeElement.style.fontSize = "12pt";
            fakeElement.style.border = "0";
            fakeElement.style.padding = "0";
            fakeElement.style.margin = "0";
            fakeElement.style.position = "absolute";
            fakeElement.style[isRTL ? "right" : "left"] = "-9999px";
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            fakeElement.style.top = "".concat(yPosition, "px");
            fakeElement.setAttribute("readonly", "");
            fakeElement.value = value;
            return fakeElement;
          }
          var fakeCopyAction = function fakeCopyAction2(value, options) {
            var fakeElement = createFakeElement(value);
            options.container.appendChild(fakeElement);
            var selectedText = select_default()(fakeElement);
            command("copy");
            fakeElement.remove();
            return selectedText;
          };
          var ClipboardActionCopy = function ClipboardActionCopy2(target) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
              container: document.body
            };
            var selectedText = "";
            if (typeof target === "string") {
              selectedText = fakeCopyAction(target, options);
            } else if (target instanceof HTMLInputElement && !["text", "search", "url", "tel", "password"].includes(target === null || target === void 0 ? void 0 : target.type)) {
              selectedText = fakeCopyAction(target.value, options);
            } else {
              selectedText = select_default()(target);
              command("copy");
            }
            return selectedText;
          };
          var actions_copy = ClipboardActionCopy;
          function _typeof2(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              _typeof2 = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              _typeof2 = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return _typeof2(obj);
          }
          var ClipboardActionDefault = function ClipboardActionDefault2() {
            var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text;
            if (action !== "copy" && action !== "cut") {
              throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
            if (target !== void 0) {
              if (target && _typeof2(target) === "object" && target.nodeType === 1) {
                if (action === "copy" && target.hasAttribute("disabled")) {
                  throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                }
                if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) {
                  throw new Error(`Invalid "target" attribute. You can't cut text from elements with "readonly" or "disabled" attributes`);
                }
              } else {
                throw new Error('Invalid "target" value, use a valid Element');
              }
            }
            if (text) {
              return actions_copy(text, {
                container
              });
            }
            if (target) {
              return action === "cut" ? actions_cut(target) : actions_copy(target, {
                container
              });
            }
          };
          var actions_default = ClipboardActionDefault;
          function clipboard_typeof(obj) {
            "@babel/helpers - typeof";
            if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
              clipboard_typeof = function _typeof3(obj2) {
                return typeof obj2;
              };
            } else {
              clipboard_typeof = function _typeof3(obj2) {
                return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
              };
            }
            return clipboard_typeof(obj);
          }
          function _classCallCheck2(instance2, Constructor) {
            if (!(instance2 instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _defineProperties2(target, props2) {
            for (var i = 0; i < props2.length; i++) {
              var descriptor = props2[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor)
                descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          function _createClass2(Constructor, protoProps, staticProps) {
            if (protoProps)
              _defineProperties2(Constructor.prototype, protoProps);
            if (staticProps)
              _defineProperties2(Constructor, staticProps);
            return Constructor;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function");
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
            if (superClass)
              _setPrototypeOf(subClass, superClass);
          }
          function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
              o2.__proto__ = p2;
              return o2;
            };
            return _setPrototypeOf(o, p);
          }
          function _createSuper(Derived) {
            var hasNativeReflectConstruct = _isNativeReflectConstruct();
            return function _createSuperInternal() {
              var Super = _getPrototypeOf(Derived), result;
              if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
              } else {
                result = Super.apply(this, arguments);
              }
              return _possibleConstructorReturn(this, result);
            };
          }
          function _possibleConstructorReturn(self2, call) {
            if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) {
              return call;
            }
            return _assertThisInitialized(self2);
          }
          function _assertThisInitialized(self2) {
            if (self2 === void 0) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return self2;
          }
          function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct)
              return false;
            if (Reflect.construct.sham)
              return false;
            if (typeof Proxy === "function")
              return true;
            try {
              Date.prototype.toString.call(Reflect.construct(Date, [], function() {
              }));
              return true;
            } catch (e) {
              return false;
            }
          }
          function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
              return o2.__proto__ || Object.getPrototypeOf(o2);
            };
            return _getPrototypeOf(o);
          }
          function getAttributeValue(suffix, element) {
            var attribute = "data-clipboard-".concat(suffix);
            if (!element.hasAttribute(attribute)) {
              return;
            }
            return element.getAttribute(attribute);
          }
          var Clipboard = /* @__PURE__ */ function(_Emitter) {
            _inherits(Clipboard2, _Emitter);
            var _super = _createSuper(Clipboard2);
            function Clipboard2(trigger, options) {
              var _this;
              _classCallCheck2(this, Clipboard2);
              _this = _super.call(this);
              _this.resolveOptions(options);
              _this.listenClick(trigger);
              return _this;
            }
            _createClass2(Clipboard2, [{
              key: "resolveOptions",
              value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
              }
            }, {
              key: "listenClick",
              value: function listenClick(trigger) {
                var _this2 = this;
                this.listener = listen_default()(trigger, "click", function(e) {
                  return _this2.onClick(e);
                });
              }
            }, {
              key: "onClick",
              value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;
                var action = this.action(trigger) || "copy";
                var text = actions_default({
                  action,
                  container: this.container,
                  target: this.target(trigger),
                  text: this.text(trigger)
                });
                this.emit(text ? "success" : "error", {
                  action,
                  text,
                  trigger,
                  clearSelection: function clearSelection() {
                    if (trigger) {
                      trigger.focus();
                    }
                    window.getSelection().removeAllRanges();
                  }
                });
              }
            }, {
              key: "defaultAction",
              value: function defaultAction(trigger) {
                return getAttributeValue("action", trigger);
              }
            }, {
              key: "defaultTarget",
              value: function defaultTarget(trigger) {
                var selector = getAttributeValue("target", trigger);
                if (selector) {
                  return document.querySelector(selector);
                }
              }
            }, {
              key: "defaultText",
              value: function defaultText(trigger) {
                return getAttributeValue("text", trigger);
              }
            }, {
              key: "destroy",
              value: function destroy3() {
                this.listener.destroy();
              }
            }], [{
              key: "copy",
              value: function copy(target) {
                var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                  container: document.body
                };
                return actions_copy(target, options);
              }
            }, {
              key: "cut",
              value: function cut(target) {
                return actions_cut(target);
              }
            }, {
              key: "isSupported",
              value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["copy", "cut"];
                var actions = typeof action === "string" ? [action] : action;
                var support = !!document.queryCommandSupported;
                actions.forEach(function(action2) {
                  support = support && !!document.queryCommandSupported(action2);
                });
                return support;
              }
            }]);
            return Clipboard2;
          }(tiny_emitter_default());
          var clipboard2 = Clipboard;
        },
        828: function(module2) {
          var DOCUMENT_NODE_TYPE = 9;
          if (typeof Element !== "undefined" && !Element.prototype.matches) {
            var proto = Element.prototype;
            proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
          }
          function closest2(element, selector) {
            while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
              if (typeof element.matches === "function" && element.matches(selector)) {
                return element;
              }
              element = element.parentNode;
            }
          }
          module2.exports = closest2;
        },
        438: function(module2, __unused_webpack_exports, __webpack_require__2) {
          var closest2 = __webpack_require__2(828);
          function _delegate(element, selector, type, callback, useCapture) {
            var listenerFn = listener.apply(this, arguments);
            element.addEventListener(type, listenerFn, useCapture);
            return {
              destroy: function() {
                element.removeEventListener(type, listenerFn, useCapture);
              }
            };
          }
          function delegate(elements, selector, type, callback, useCapture) {
            if (typeof elements.addEventListener === "function") {
              return _delegate.apply(null, arguments);
            }
            if (typeof type === "function") {
              return _delegate.bind(null, document).apply(null, arguments);
            }
            if (typeof elements === "string") {
              elements = document.querySelectorAll(elements);
            }
            return Array.prototype.map.call(elements, function(element) {
              return _delegate(element, selector, type, callback, useCapture);
            });
          }
          function listener(element, selector, type, callback) {
            return function(e) {
              e.delegateTarget = closest2(e.target, selector);
              if (e.delegateTarget) {
                callback.call(element, e);
              }
            };
          }
          module2.exports = delegate;
        },
        879: function(__unused_webpack_module, exports2) {
          exports2.node = function(value) {
            return value !== void 0 && value instanceof HTMLElement && value.nodeType === 1;
          };
          exports2.nodeList = function(value) {
            var type = Object.prototype.toString.call(value);
            return value !== void 0 && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports2.node(value[0]));
          };
          exports2.string = function(value) {
            return typeof value === "string" || value instanceof String;
          };
          exports2.fn = function(value) {
            var type = Object.prototype.toString.call(value);
            return type === "[object Function]";
          };
        },
        370: function(module2, __unused_webpack_exports, __webpack_require__2) {
          var is2 = __webpack_require__2(879);
          var delegate = __webpack_require__2(438);
          function listen(target, type, callback) {
            if (!target && !type && !callback) {
              throw new Error("Missing required arguments");
            }
            if (!is2.string(type)) {
              throw new TypeError("Second argument must be a String");
            }
            if (!is2.fn(callback)) {
              throw new TypeError("Third argument must be a Function");
            }
            if (is2.node(target)) {
              return listenNode(target, type, callback);
            } else if (is2.nodeList(target)) {
              return listenNodeList(target, type, callback);
            } else if (is2.string(target)) {
              return listenSelector(target, type, callback);
            } else {
              throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
            }
          }
          function listenNode(node, type, callback) {
            node.addEventListener(type, callback);
            return {
              destroy: function() {
                node.removeEventListener(type, callback);
              }
            };
          }
          function listenNodeList(nodeList, type, callback) {
            Array.prototype.forEach.call(nodeList, function(node) {
              node.addEventListener(type, callback);
            });
            return {
              destroy: function() {
                Array.prototype.forEach.call(nodeList, function(node) {
                  node.removeEventListener(type, callback);
                });
              }
            };
          }
          function listenSelector(selector, type, callback) {
            return delegate(document.body, selector, type, callback);
          }
          module2.exports = listen;
        },
        817: function(module2) {
          function select(element) {
            var selectedText;
            if (element.nodeName === "SELECT") {
              element.focus();
              selectedText = element.value;
            } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
              var isReadOnly2 = element.hasAttribute("readonly");
              if (!isReadOnly2) {
                element.setAttribute("readonly", "");
              }
              element.select();
              element.setSelectionRange(0, element.value.length);
              if (!isReadOnly2) {
                element.removeAttribute("readonly");
              }
              selectedText = element.value;
            } else {
              if (element.hasAttribute("contenteditable")) {
                element.focus();
              }
              var selection = window.getSelection();
              var range = document.createRange();
              range.selectNodeContents(element);
              selection.removeAllRanges();
              selection.addRange(range);
              selectedText = selection.toString();
            }
            return selectedText;
          }
          module2.exports = select;
        },
        279: function(module2) {
          function E2() {
          }
          E2.prototype = {
            on: function(name, callback, ctx) {
              var e = this.e || (this.e = {});
              (e[name] || (e[name] = [])).push({
                fn: callback,
                ctx
              });
              return this;
            },
            once: function(name, callback, ctx) {
              var self2 = this;
              function listener() {
                self2.off(name, listener);
                callback.apply(ctx, arguments);
              }
              listener._ = callback;
              return this.on(name, listener, ctx);
            },
            emit: function(name) {
              var data2 = [].slice.call(arguments, 1);
              var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
              var i = 0;
              var len = evtArr.length;
              for (i; i < len; i++) {
                evtArr[i].fn.apply(evtArr[i].ctx, data2);
              }
              return this;
            },
            off: function(name, callback) {
              var e = this.e || (this.e = {});
              var evts = e[name];
              var liveEvents = [];
              if (evts && callback) {
                for (var i = 0, len = evts.length; i < len; i++) {
                  if (evts[i].fn !== callback && evts[i].fn._ !== callback)
                    liveEvents.push(evts[i]);
                }
              }
              liveEvents.length ? e[name] = liveEvents : delete e[name];
              return this;
            }
          };
          module2.exports = E2;
          module2.exports.TinyEmitter = E2;
        }
      };
      var __webpack_module_cache__ = {};
      function __webpack_require__(moduleId) {
        if (__webpack_module_cache__[moduleId]) {
          return __webpack_module_cache__[moduleId].exports;
        }
        var module2 = __webpack_module_cache__[moduleId] = {
          exports: {}
        };
        __webpack_modules__[moduleId](module2, module2.exports, __webpack_require__);
        return module2.exports;
      }
      !function() {
        __webpack_require__.n = function(module2) {
          var getter = module2 && module2.__esModule ? function() {
            return module2["default"];
          } : function() {
            return module2;
          };
          __webpack_require__.d(getter, { a: getter });
          return getter;
        };
      }();
      !function() {
        __webpack_require__.d = function(exports2, definition) {
          for (var key in definition) {
            if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports2, key)) {
              Object.defineProperty(exports2, key, { enumerable: true, get: definition[key] });
            }
          }
        };
      }();
      !function() {
        __webpack_require__.o = function(obj, prop) {
          return Object.prototype.hasOwnProperty.call(obj, prop);
        };
      }();
      return __webpack_require__(686);
    }().default;
  });
})(clipboard);
var ClipboardJS = /* @__PURE__ */ getDefaultExportFromCjs(clipboard.exports);
const basicComponents = [
  {
    type: "input",
    icon: "icon-input",
    options: {
      width: "",
      defaultValue: "",
      required: false,
      requiredMessage: "",
      dataType: "",
      dataTypeCheck: false,
      dataTypeMessage: "",
      pattern: "",
      patternCheck: false,
      patternMessage: "",
      validatorCheck: false,
      validator: "",
      placeholder: "",
      customClass: "",
      disabled: false,
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      showPassword: false,
      clearable: false,
      maxlength: "",
      showWordLimit: false,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: "",
      onFocus: "",
      onBlur: ""
    }
  },
  {
    type: "textarea",
    icon: "icon-diy-com-textarea",
    options: {
      width: "",
      defaultValue: "",
      required: false,
      requiredMessage: "",
      disabled: false,
      pattern: "",
      patternMessage: "",
      validatorCheck: false,
      validator: "",
      placeholder: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      clearable: false,
      maxlength: "",
      showWordLimit: false,
      rows: 2,
      autosize: false,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: "",
      onFocus: "",
      onBlur: ""
    }
  },
  {
    type: "number",
    icon: "icon-number",
    options: {
      width: "",
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      defaultValue: 0,
      min: 0,
      max: 9,
      step: 1,
      disabled: false,
      controls: true,
      controlsPosition: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      precision: 0,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: "",
      onFocus: "",
      onBlur: ""
    }
  },
  {
    type: "radio",
    icon: "icon-radio-active",
    options: {
      inline: false,
      defaultValue: "",
      showLabel: false,
      options: [
        {
          value: "Option 1",
          label: "Option 1"
        },
        {
          value: "Option 2",
          label: "Option 2"
        },
        {
          value: "Option 3",
          label: "Option 3"
        }
      ],
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      width: "",
      remote: false,
      remoteType: "datasource",
      remoteOption: "",
      remoteOptions: [],
      props: {
        value: "value",
        label: "label"
      },
      remoteFunc: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      disabled: false,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "checkbox",
    icon: "icon-check-box",
    options: {
      inline: false,
      defaultValue: [],
      showLabel: false,
      options: [
        {
          value: "Option 1"
        },
        {
          value: "Option 2"
        },
        {
          value: "Option 3"
        }
      ],
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      width: "",
      remote: false,
      remoteType: "datasource",
      remoteOption: "",
      remoteOptions: [],
      props: {
        value: "value",
        label: "label"
      },
      remoteFunc: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      disabled: false,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "select",
    icon: "icon-select",
    options: {
      defaultValue: "",
      multiple: false,
      disabled: false,
      clearable: false,
      placeholder: "",
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      showLabel: false,
      width: "",
      options: [
        {
          value: "Option 1"
        },
        {
          value: "Option 2"
        },
        {
          value: "Option 3"
        }
      ],
      remote: false,
      remoteType: "datasource",
      remoteOption: "",
      filterable: false,
      remoteOptions: [],
      props: {
        value: "value",
        label: "label"
      },
      remoteFunc: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: "",
      onFocus: "",
      onBlur: ""
    }
  },
  {
    type: "time",
    icon: "icon-time",
    options: {
      defaultValue: "",
      readonly: false,
      disabled: false,
      editable: false,
      clearable: true,
      placeholder: "",
      startPlaceholder: "",
      endPlaceholder: "",
      isRange: false,
      arrowControl: false,
      format: "HH:mm:ss",
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      width: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: "",
      onFocus: "",
      onBlur: ""
    }
  },
  {
    type: "date",
    icon: "icon-date",
    options: {
      defaultValue: "",
      readonly: false,
      disabled: false,
      editable: false,
      clearable: true,
      placeholder: "",
      startPlaceholder: "",
      endPlaceholder: "",
      type: "date",
      format: "YYYY-MM-DD",
      timestamp: false,
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      width: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: "",
      onFocus: "",
      onBlur: ""
    }
  },
  {
    type: "rate",
    icon: "icon-pingfen1",
    options: {
      defaultValue: null,
      max: 5,
      disabled: false,
      allowHalf: false,
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      showScore: false,
      width: "",
      customProps: {},
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "color",
    icon: "icon-color",
    options: {
      defaultValue: "",
      disabled: false,
      showAlpha: false,
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      width: "",
      customProps: {},
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "switch",
    icon: "icon-switch",
    options: {
      defaultValue: false,
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      disabled: false,
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      width: "",
      customProps: {},
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "slider",
    icon: "icon-slider",
    options: {
      defaultValue: 0,
      disabled: false,
      required: false,
      requiredMessage: "",
      validatorCheck: false,
      validator: "",
      min: 0,
      max: 100,
      step: 1,
      showInput: false,
      range: false,
      width: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "text",
    icon: "icon-wenzishezhi-",
    options: {
      defaultValue: "This is a text",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      required: false,
      width: "",
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "html",
    icon: "icon-html",
    options: {
      defaultValue: '<b style="color: red;">\n	This is a HTML5\n</b>',
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      required: false,
      width: "",
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "button",
    icon: "icon-button",
    options: {
      customClass: "",
      disabled: false,
      labelWidth: 100,
      isLabelWidth: false,
      hideLabel: true,
      hidden: false,
      buttonSize: "default",
      buttonType: "",
      buttonPlain: false,
      buttonRound: false,
      buttonCircle: false,
      buttonName: "Button",
      width: "",
      customProps: {},
      tip: ""
    },
    events: {
      onClick: ""
    }
  },
  {
    type: "link",
    icon: "icon-lianjie",
    options: {
      customClass: "",
      disabled: false,
      labelWidth: 100,
      isLabelWidth: false,
      hideLabel: false,
      hidden: false,
      linkType: "default",
      linkName: "Link",
      underline: true,
      blank: true,
      href: "",
      customProps: {},
      tip: ""
    },
    events: {
      onClick: ""
    }
  },
  {
    type: "cascader",
    icon: "icon-jilianxuanze",
    options: {
      defaultValue: [],
      width: "",
      placeholder: "",
      disabled: false,
      clearable: false,
      options: [
        {
          value: "Option 1",
          label: "Option 1",
          children: [
            { value: "Option 1 - children", label: "Option 1 - children" }
          ]
        },
        {
          value: "Option 2",
          label: "Option 2",
          children: [
            { value: "Option 2 - children", label: "Option 2 - children" }
          ]
        },
        {
          value: "Option 3",
          label: "Option 3"
        }
      ],
      remote: false,
      remoteType: "datasource",
      remoteOption: "",
      remoteOptions: [],
      props: {
        value: "value",
        label: "label",
        children: "children"
      },
      remoteFunc: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      required: false,
      validatorCheck: false,
      validator: "",
      multiple: false,
      filterable: false,
      checkStrictly: false,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: "",
      onFocus: "",
      onBlur: ""
    }
  },
  {
    type: "treeselect",
    icon: "icon-shuxuanzeqi",
    options: {
      defaultValue: [],
      width: "",
      placeholder: "",
      disabled: false,
      clearable: false,
      options: [
        {
          value: "Option 1",
          label: "Option 1",
          children: [
            { value: "Option 1 - children", label: "Option 1 - children" }
          ]
        },
        {
          value: "Option 2",
          label: "Option 2",
          children: [
            { value: "Option 2 - children", label: "Option 2 - children" }
          ]
        },
        {
          value: "Option 3",
          label: "Option 3"
        }
      ],
      remote: false,
      remoteType: "datasource",
      remoteOption: "",
      remoteOptions: [],
      props: {
        value: "value",
        label: "label",
        children: "children"
      },
      remoteFunc: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      required: false,
      validatorCheck: false,
      validator: "",
      multiple: false,
      filterable: false,
      checkStrictly: false,
      customProps: {},
      tip: ""
    },
    events: {
      onChange: "",
      onFocus: "",
      onBlur: ""
    }
  },
  {
    type: "steps",
    icon: "icon-m-buzhou",
    options: {
      defaultValue: 0,
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hideLabel: true,
      hidden: false,
      dataBind: true,
      steps: [
        {
          title: "Step 1"
        },
        {
          title: "Step 2"
        },
        {
          title: "Step 3"
        }
      ],
      props: {
        title: "title",
        description: "description"
      },
      remote: false,
      width: "",
      direction: "horizontal",
      processStatus: "process",
      finishStatus: "finish",
      alignCenter: false,
      simple: false,
      remoteType: "datasource",
      customProps: {},
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "transfer",
    icon: "icon-m-chuansuokuang",
    options: {
      defaultValue: [],
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hideLabel: false,
      hidden: false,
      dataBind: true,
      data: [
        { key: "1", label: "Option 1" },
        { key: "2", label: "Option 2" },
        { key: "3", label: "Option 3" }
      ],
      props: {
        key: "key",
        label: "label",
        disabled: "disabled"
      },
      filterable: false,
      required: false,
      validatorCheck: false,
      validator: "",
      width: "",
      remote: false,
      titles: ["Source", "Target"],
      disabled: false,
      remoteType: "datasource",
      customProps: {},
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "pagination",
    icon: "icon-pagination",
    options: {
      defaultValue: 1,
      customClass: "",
      disabled: false,
      labelWidth: 100,
      isLabelWidth: false,
      hideLabel: false,
      hidden: false,
      dataBind: true,
      background: true,
      pageSize: 10,
      pagerCount: 7,
      total: 100,
      customProps: {}
    },
    events: {
      onChange: ""
    }
  }
];
const advanceComponents = [
  {
    type: "blank",
    icon: "icon-zidingyishuju",
    options: {
      defaultType: "String",
      customClass: "",
      width: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      required: false,
      pattern: "",
      validator: "",
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "component",
    icon: "icon-component",
    options: {
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      template: "<div>\u81EA\u5B9A\u4E49\u5185\u5BB9</div>",
      required: false,
      pattern: "",
      validator: "",
      width: "",
      tip: ""
    },
    events: {
      onChange: ""
    }
  },
  {
    type: "fileupload",
    icon: "icon-wenjianshangchuan",
    options: {
      defaultValue: [],
      width: "",
      tokenFunc: "funcGetToken",
      token: "",
      tokenType: "datasource",
      domain: "",
      disabled: false,
      tip: "",
      action: "",
      customClass: "",
      limit: 9,
      multiple: false,
      isQiniu: false,
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      headers: [],
      required: false,
      validatorCheck: false,
      validator: "",
      withCredentials: false
    },
    events: {
      onChange: "",
      onSelect: "",
      onUploadSuccess: "",
      onUploadError: "",
      onRemove: ""
    }
  },
  {
    type: "imgupload",
    icon: "icon-tupian",
    options: {
      defaultValue: [],
      size: {
        width: 100,
        height: 100
      },
      width: "",
      tokenFunc: "funcGetToken",
      token: "",
      tokenType: "datasource",
      domain: "",
      disabled: false,
      readonly: false,
      limit: 8,
      multiple: false,
      isQiniu: false,
      isDelete: true,
      min: 0,
      isEdit: true,
      action: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      headers: [],
      required: false,
      validatorCheck: false,
      validator: "",
      withCredentials: false,
      tip: ""
    },
    events: {
      onChange: "",
      onSelect: "",
      onUploadSuccess: "",
      onUploadError: "",
      onRemove: ""
    }
  },
  {
    type: "editor",
    icon: "icon-fuwenbenkuang",
    options: {
      defaultValue: "",
      width: "",
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      customToolbar: [
        [
          "bold",
          "italic",
          "underline",
          "strike",
          { "color": [] },
          { "background": [] },
          { "align": [] },
          { "list": "ordered" },
          { "list": "bullet" },
          { "indent": "-1" },
          { "indent": "+1" }
        ],
        [{ "font": [] }, { "header": [1, 2, 3, 4, 5, 6, false] }],
        [{ "script": "sub" }, { "script": "super" }],
        ["link", "image", "blockquote", "code-block"],
        [{ "direction": "rtl" }],
        ["clean"]
      ],
      disabled: false,
      required: false,
      validatorCheck: false,
      validator: "",
      tip: ""
    },
    events: {
      onChange: ""
    }
  }
];
const layoutComponents = [
  {
    type: "grid",
    icon: "icon-RectangleCopy",
    columns: [
      {
        type: "col",
        options: {
          span: 12,
          offset: 0,
          push: 0,
          pull: 0,
          xs: 24,
          sm: 12,
          md: 12,
          lg: 12,
          xl: 12,
          customClass: ""
        },
        list: []
      }
    ],
    options: {
      gutter: 0,
      justify: "start",
      align: "top",
      customClass: "",
      hidden: false,
      flex: true,
      responsive: true
    }
  },
  {
    type: "report",
    icon: "icon-table1",
    options: {
      customClass: "",
      hidden: false,
      borderWidth: 1,
      borderColor: "#999",
      width: "100%"
    },
    headerRow: [
      {
        type: "th",
        options: {
          width: ""
        }
      }
    ],
    rows: [
      {
        columns: [
          {
            type: "td",
            options: {
              customClass: "",
              colspan: 1,
              rowspan: 1,
              align: "left",
              valign: "top",
              width: "",
              height: ""
            },
            list: []
          }
        ]
      }
    ]
  },
  {
    type: "tabs",
    icon: "icon-tabs",
    tabs: [
      {
        label: "Tab 1",
        name: "tab_1",
        list: []
      }
    ],
    options: {
      type: "",
      tabPosition: "top",
      customClass: "",
      hidden: false
    }
  },
  {
    type: "collapse",
    icon: "icon-zhediemianban",
    tabs: [
      {
        title: "Collapse 1",
        name: "collapse_1",
        list: []
      }
    ],
    options: {
      type: "",
      accordion: false,
      customClass: "",
      hidden: false
    }
  },
  {
    type: "inline",
    icon: "icon-inlineview",
    options: {
      customClass: "",
      hidden: false,
      spaceSize: 10
    },
    list: []
  },
  {
    type: "card",
    icon: "icon-kapian",
    list: [],
    options: {
      title: "Card name",
      showHeader: true,
      bordered: true,
      customClass: "",
      shadow: "always",
      width: "",
      padding: "10px",
      hidden: false
    }
  },
  {
    type: "divider",
    icon: "icon-fengexian",
    options: {
      hidden: false,
      contentPosition: "left",
      customProps: {}
    }
  },
  {
    type: "alert",
    icon: "icon-jinggaotishi",
    options: {
      hidden: false,
      title: "Info alert",
      type: "info",
      description: "",
      closable: true,
      center: false,
      showIcon: false,
      effect: "light",
      width: "",
      customProps: {}
    }
  }
];
const collectionComponents = [
  {
    type: "table",
    icon: "icon-table",
    options: {
      defaultValue: [],
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      disabled: false,
      required: false,
      validatorCheck: false,
      validator: "",
      paging: false,
      pageSize: 5,
      isAdd: true,
      isDelete: true,
      showControl: true,
      virtualTable: true,
      tip: ""
    },
    events: {
      onChange: "",
      onRowAdd: "",
      onRowRemove: "",
      onPageChange: ""
    },
    tableColumns: []
  },
  {
    type: "subform",
    icon: "icon-a-ziyuan25",
    options: {
      defaultValue: [],
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      disabled: false,
      required: false,
      validatorCheck: false,
      validator: "",
      paging: false,
      pageSize: 5,
      showControl: true,
      isAdd: true,
      isDelete: true,
      tip: ""
    },
    events: {
      onChange: "",
      onRowAdd: "",
      onRowRemove: "",
      onPageChange: ""
    },
    list: []
  },
  {
    type: "dialog",
    icon: "icon-Dialog",
    options: {
      defaultValue: {},
      visible: false,
      customClass: "",
      title: "Dialog Title",
      width: "",
      top: "15vh",
      center: false,
      cancelText: "Cancel",
      showClose: true,
      okText: "Confirm",
      showCancel: true,
      showOk: true,
      confirmLoading: false,
      dataBind: true
    },
    list: [],
    events: {
      onCancel: "",
      onConfirm: ""
    }
  },
  {
    type: "group",
    icon: "icon-fenzu",
    options: {
      defaultValue: {},
      customClass: "",
      labelWidth: 100,
      isLabelWidth: false,
      hidden: false,
      dataBind: true,
      width: "",
      validatorCheck: false,
      validator: "",
      tip: ""
    },
    list: []
  }
];
function findRemoteFunc(list, funcList, tokenFuncList, blankList, optionList) {
  for (let i = 0; i < list.length; i++) {
    if (list[i].type == "grid") {
      list[i].columns.forEach((item) => {
        findRemoteFunc(item.list, funcList, tokenFuncList, blankList, optionList);
      });
    } else if (list[i].type == "table") {
      findRemoteFunc(list[i].tableColumns, funcList, tokenFuncList, blankList, optionList);
    } else if (list[i].type == "subform") {
      findRemoteFunc(list[i].list, funcList, tokenFuncList, blankList, optionList);
    } else if (list[i].type == "tabs") {
      list[i].tabs.forEach((item) => {
        findRemoteFunc(item.list, funcList, tokenFuncList, blankList, optionList);
      });
    } else if (list[i].type == "collapse") {
      list[i].tabs.forEach((item) => {
        findRemoteFunc(item.list, funcList, tokenFuncList, blankList, optionList);
      });
    } else if (list[i].type == "report") {
      list[i].rows.forEach((row) => {
        row.columns.forEach((col) => {
          findRemoteFunc(col.list, funcList, tokenFuncList, blankList, optionList);
        });
      });
    } else if (list[i].type == "inline") {
      findRemoteFunc(list[i].list, funcList, tokenFuncList, blankList, optionList);
    } else if (list[i].type == "dialog") {
      findRemoteFunc(list[i].list, funcList, tokenFuncList, blankList, optionList);
    } else if (list[i].type == "card") {
      findRemoteFunc(list[i].list, funcList, tokenFuncList, blankList, optionList);
    } else if (list[i].type == "group") {
      findRemoteFunc(list[i].list, funcList, tokenFuncList, blankList, optionList);
    } else {
      if (list[i].type == "blank") {
        if (list[i].model && blankList.findIndex((item) => item.name == list[i].model) < 0) {
          blankList.push({
            name: list[i].model,
            label: list[i].name,
            dataBind: list[i].options.dataBind
          });
        }
      } else if (list[i].type == "imgupload") {
        if (list[i].options.tokenType == "func" && list[i].options.tokenFunc) {
          tokenFuncList.push({
            func: list[i].options.tokenFunc,
            label: list[i].name,
            model: list[i].model
          });
        }
      } else {
        if (list[i].options.remote && list[i].options.remoteType == "func" && list[i].options.remoteFunc) {
          funcList.push({
            func: list[i].options.remoteFunc,
            label: list[i].name,
            model: list[i].model
          });
        }
        if (list[i].options.remote && list[i].options.remoteType == "option" && list[i].options.remoteOption) {
          optionList.push({
            option: list[i].options.remoteOption,
            label: list[i].name,
            model: list[i].model
          });
        }
      }
    }
  }
}
function generateCode(data2, type = "html", ui = "element") {
  const isDark = document.querySelector("html").className.indexOf("dark") > -1;
  const funcList = [];
  const tokenFuncList = [];
  const blankList = [];
  const optionList = [];
  const templateName = ui == "element" ? "fm-generate-form" : "fm-generate-antd-form";
  const cdnjs = ui == "element" ? "https://unpkg.com/element-plus" : "https://unpkg.com/ant-design-vue/dist/antd.min.js";
  const dayjs = `<script src="https://unpkg.com/dayjs/dayjs.min.js"><\/script>
  <script src="https://unpkg.com/dayjs/plugin/customParseFormat.js"><\/script>
  <script src="https://unpkg.com/dayjs/plugin/weekday.js"><\/script>
  <script src="https://unpkg.com/dayjs/plugin/localeData.js"><\/script>
  <script src="https://unpkg.com/dayjs/plugin/weekOfYear.js"><\/script>
  <script src="https://unpkg.com/dayjs/plugin/weekYear.js"><\/script>
  <script src="https://unpkg.com/dayjs/plugin/advancedFormat.js"><\/script>
  <script src="https://unpkg.com/dayjs/plugin/quarterOfYear.js"><\/script>`;
  let cdncss = "";
  if (ui == "element") {
    if (isDark) {
      cdncss = `<link rel="stylesheet" href="https://unpkg.com/element-plus/dist/index.css">
      <link rel="stylesheet" href="https://unpkg.com/element-plus/theme-chalk/dark/css-vars.css">`;
    } else {
      cdncss = `<link rel="stylesheet" href="https://unpkg.com/element-plus/dist/index.css">`;
    }
  } else {
    cdncss = `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/ant-design-vue/dist/reset.min.css">`;
  }
  findRemoteFunc(JSON.parse(data2).list, funcList, tokenFuncList, blankList, optionList);
  let funcTemplate = "";
  let blankTemplate = "";
  let optionTemplate = "";
  for (let i = 0; i < optionList.length; i++) {
    optionTemplate += `
          ${optionList[i].option} : [], // ${optionList[i].label} option data
    `;
  }
  for (let i = 0; i < funcList.length; i++) {
    funcTemplate += `
            ${funcList[i].func} (resolve) {
              // ${funcList[i].label} ${funcList[i].model}
              // resolve(data)
            },
    `;
  }
  for (let i = 0; i < tokenFuncList.length; i++) {
    funcTemplate += `
            ${tokenFuncList[i].func} (resolve) {
              // ${tokenFuncList[i].label} ${tokenFuncList[i].model}
              // resolve(token)
            },
    `;
  }
  for (let i = 0; i < blankList.length; i++) {
    if (blankList[i].dataBind) {
      blankTemplate += `
        <template v-slot:${blankList[i].name}="scope">
          <!-- ${blankList[i].label || blankList[i].name} -->
          <!-- use v-model="scope.model.${blankList[i].name}" to bind data -->
        </template>
      `;
    } else {
      blankTemplate += `
        <template v-slot:${blankList[i].name}>
          <!-- ${blankList[i].label || blankList[i].name} -->
        </template>
      `;
    }
  }
  if (type == "html") {
    return `<!DOCTYPE html>
<html class="${isDark ? "dark" : ""}">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no" />
  ${cdncss}
  <link rel="stylesheet" href="https://form.making.link/public/lib/form-making-v3/dist/index.css">
</head>
<body>
  <div id="app">
    <${templateName}
      :data="jsonData" 
      :remote="remoteFuncs"
      :remote-option="dynamicData"
      ref="generateForm"
    >${blankTemplate}
    </${templateName}>
  </div>
  <script src="https://unpkg.com/vue/dist/vue.global.prod.js"><\/script>${ui == "antd" ? `
	${dayjs}` : ""}
  <script src="${cdnjs}"><\/script>
  <script src="https://form.making.link/public/lib/form-making-v3/dist/form-making-v3.umd.js"><\/script>
  <script>
    Vue.createApp({
      data () {
        return {
          jsonData: ${data2},
          remoteFuncs: {
            ${funcTemplate}
          },
          dynamicData: {
            ${optionTemplate}
          }
        }
      }
    }).use(${ui == "element" ? "ElementPlus" : "antd"}).use(FormMakingV3)${ui == "element" ? "" : '.provide("useInjectFormItemContext", antd.Form.useInjectFormItemContext)'}.mount('#app')
  <\/script>
</body>
</html>`;
  } else {
    return `<template>
  <div>
    <${templateName} 
      :data="jsonData" 
      :remote="remoteFuncs" 
      :remote-option="dynamicData"
      ref="generateForm"
    >${blankTemplate}
    </${templateName}>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'

const generateForm = ref()

const jsonData = reactive(${data2})

const remoteFuncs = reactive({
  ${funcTemplate}
})

const dynamicData = reactive({
  ${optionTemplate}
})
<\/script>`;
  }
}
const idb = {
  openDB(name, version2 = 1) {
    const request3 = window.indexedDB.open(name, version2);
    return new Promise((resolve, reject) => {
      request3.onerror = (e) => {
        reject(e.currentTarget.error.message);
      };
      request3.onsuccess = (e) => {
        resolve(e.target.result);
      };
      request3.onupgradeneeded = (e) => {
        const db = e.target.result;
        if (!db.objectStoreNames.contains("history")) {
          db.createObjectStore("history", { keyPath: "id" });
        }
      };
    });
  },
  name: "form-making-v3",
  cursor: 0,
  key: "/#********#/"
};
var historyManager = {
  clear() {
    return new Promise((resolve, reject) => {
      idb.openDB(idb.name).then((db) => {
        const trans = db.transaction(["history"], "readwrite");
        const historyStore = trans.objectStore("history");
        historyStore.clear();
        trans.oncomplete = (e) => {
          idb.cursor = 0;
          resolve();
        };
      });
    });
  },
  updateLatest(data2, selectedKey) {
    return new Promise((resolve, reject) => {
      idb.openDB(idb.name).then((db) => {
        const trans = db.transaction(["history"], "readwrite");
        const historyStore = trans.objectStore("history");
        historyStore.put({
          id: idb.cursor,
          data: JSON.parse(JSON.stringify(data2)),
          selected: selectedKey
        });
        trans.oncomplete = (e) => {
          resolve();
        };
      });
    });
  },
  add(data2, selectedKey) {
    return new Promise((resolve, reject) => {
      idb.openDB(idb.name).then((db) => {
        const trans = db.transaction(["history"], "readwrite");
        const historyStore = trans.objectStore("history");
        const id = idb.cursor + 1;
        const historyList = [];
        historyStore.openCursor().onsuccess = (e) => {
          const cursor = e.target.result;
          if (cursor) {
            historyList.push(cursor.value);
            cursor.continue();
          } else {
            for (let i = 0; i < historyList.length; i++) {
              if (historyList[i].id > idb.cursor) {
                historyStore.delete(historyList[i].id);
              }
            }
            historyStore.add({
              id,
              data: JSON.parse(JSON.stringify(data2)),
              selected: selectedKey
            });
          }
        };
        trans.oncomplete = (e) => {
          idb.cursor = id;
          resolve();
        };
      });
    });
  },
  undo() {
    return new Promise((resolve, reject) => {
      idb.openDB(idb.name).then((db) => {
        const trans = db.transaction(["history"], "readwrite");
        const historyStore = trans.objectStore("history");
        let data2 = {
          list: [],
          config: {
            labelWidth: 100,
            labelPosition: "right",
            size: "default",
            customClass: "",
            ui: "element",
            layout: "horizontal"
          }
        }, undo = false, redo = true, key = "";
        if (idb.cursor > 1) {
          const request3 = historyStore.get(idb.cursor - 1);
          request3.onsuccess = (e) => {
            data2 = request3.result.data;
            key = request3.result.selected;
            undo = true;
          };
        }
        trans.oncomplete = (e) => {
          idb.cursor = idb.cursor - 1;
          resolve({ data: data2, key, undo, redo });
        };
      });
    });
  },
  redo() {
    return new Promise((resolve, reject) => {
      idb.openDB(idb.name).then((db) => {
        const trans = db.transaction(["history"], "readwrite");
        const historyStore = trans.objectStore("history");
        let data2 = {}, undo = true, redo = false, key = "";
        const countRequest = historyStore.count();
        countRequest.onsuccess = () => {
          const count = countRequest.result;
          if (idb.cursor < count) {
            const request3 = historyStore.get(idb.cursor + 1);
            request3.onsuccess = (e) => {
              data2 = request3.result.data;
              key = request3.result.selected;
              redo = idb.cursor + 1 == count ? false : true;
            };
          }
        };
        trans.oncomplete = (e) => {
          idb.cursor = idb.cursor + 1;
          resolve({ data: data2, key, undo, redo });
        };
      });
    });
  }
};
const UpgradeData = (data2) => {
  if (data2.type == "grid") {
    return {
      ...data2,
      columns: data2.columns.map((item) => {
        if (item.key) {
          return item;
        } else {
          return {
            ...item,
            key: Math.random().toString(36).slice(-8),
            type: "col",
            options: {
              span: item.span,
              offset: 0,
              push: 0,
              pull: 0,
              xs: item.xs,
              sm: item.sm,
              md: item.md,
              lg: item.lg,
              xl: item.xl,
              customClass: ""
            },
            list: item.list.map((colItem) => {
              return UpgradeData(colItem);
            })
          };
        }
      })
    };
  } else {
    return data2;
  }
};
var file_vue_vue_type_style_index_0_lang = "";
const _sfc_main$v = {
  components: {},
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    token: {
      type: String,
      default: ""
    },
    domain: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 9
    },
    isQiniu: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: 0
    },
    action: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String,
      default: ""
    },
    headers: {
      type: Array,
      default: () => []
    },
    ui: {
      type: String,
      default: "element"
    },
    containerKey: {
      type: String,
      default: ""
    },
    withCredentials: {
      type: Boolean,
      default: false
    },
    printRead: {
      type: Boolean,
      default: false
    },
    onSelect: {
      type: Function,
      default: void 0
    },
    size: {
      type: String,
      default: "default"
    }
  },
  emits: ["update:modelValue", "on-upload-success", "on-upload-error", "on-upload-progress", "on-upload-remove"],
  data() {
    return {
      fileList: this.modelValue.map((item) => {
        return {
          ...item,
          key: item.key ? item.key : new Date().getTime() + "_" + Math.ceil(Math.random() * 99999)
        };
      }),
      viewer: null,
      uploadId: "upload_" + new Date().getTime(),
      editIndex: -1,
      meituIndex: -1
    };
  },
  computed: {
    miniWidth() {
      if (this.width > this.height) {
        return this.height;
      } else {
        return this.width;
      }
    }
  },
  methods: {
    handleChange() {
      const files = this.$refs.uploadInput.files;
      if (this.fileList.length + files.length > this.limit) {
        this.$refs.uploadInput.value = [];
        return false;
      }
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let rFile = this.onSelect(file);
        if (rFile === false) {
          return false;
        }
        if (rFile instanceof File) {
          file = rFile;
        }
        const reader = new FileReader();
        let key = new Date().getTime();
        reader.readAsDataURL(file);
        reader.onload = () => {
          key = key + "_" + file.name;
          if (this.editIndex >= 0) {
            this.fileList[this.editIndex] = {
              key,
              url: reader.result,
              percent: 0,
              status: "uploading",
              name: file.name
            };
            this.editIndex = -1;
          } else {
            this.fileList.push({
              key,
              url: reader.result,
              percent: 0,
              status: "uploading",
              name: file.name
            });
          }
          this.$nextTick(() => {
            if (this.isQiniu) {
              this.uploadAction2(reader.result, file, key);
            } else {
              this.uploadAction(reader.result, file, key);
            }
          });
        };
      }
      this.$refs.uploadInput.value = [];
    },
    uploadAction(res, file, key) {
      this.fileList.findIndex((item) => item.key === key);
      const xhr2 = new XMLHttpRequest();
      const url = this.action;
      xhr2.open("POST", url, true);
      this.headers.map((item) => {
        item.key && xhr2.setRequestHeader(item.key, item.value);
      });
      let formData = new FormData();
      formData.append("file", file);
      formData.append("fname", file.name);
      formData.append("key", key);
      xhr2.withCredentials = this.withCredentials;
      xhr2.onreadystatechange = () => {
        if (xhr2 && xhr2.readyState === 4) {
          let resData = xhr2.response ? JSON.parse(xhr2.response) : {};
          if (resData && resData.url) {
            this.fileList[this.fileList.findIndex((item) => item.key === key)] = {
              ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
              url: resData.url,
              percent: 100,
              ...resData
            };
            setTimeout(() => {
              this.fileList[this.fileList.findIndex((item) => item.key === key)] = {
                ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
                status: "success"
              };
              this.$emit("on-upload-success", {
                ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
                status: "success"
              });
              this.$emit("update:modelValue", this.fileList);
            }, 200);
          } else {
            this.fileList[this.fileList.findIndex((item) => item.key === key)] = {
              ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
              status: "error"
            };
            this.$emit("on-upload-error", {
              ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
              status: "error"
            });
            this.fileList.splice(this.fileList.findIndex((item) => item.key === key), 1);
          }
        }
      };
      xhr2.upload.onprogress = (res2) => {
        if (res2.total && res2.loaded) {
          this.fileList[this.fileList.findIndex((item) => item.key === key)].percent = res2.loaded == res2.total ? 99 : parseInt(res2.loaded / res2.total * 100);
          this.$emit("on-upload-progress", {
            ...this.fileList[this.fileList.findIndex((item) => item.key === key)],
            status: "uploading",
            percent: res2.loaded == res2.total ? 99 : parseInt(res2.loaded / res2.total * 100)
          });
        }
      };
      xhr2.send(formData);
    },
    uploadAction2(res, file, key) {
      const _this = this;
      const observable = upload(file, key, this.token, {
        fname: file.name,
        mimeType: []
      }, {
        useCdnDomain: true
      });
      observable.subscribe({
        next(res2) {
          _this.fileList[_this.fileList.findIndex((item) => item.key === key)].percent = parseInt(res2.total.percent);
          _this.$emit("on-upload-progress", {
            ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
            status: "uploading",
            percent: parseInt(res2.total.percent)
          });
        },
        error(err) {
          _this.$message.error(err.message);
          _this.fileList[_this.fileList.findIndex((item) => item.key === key)] = {
            ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
            status: "error"
          };
          _this.$emit("on-upload-error", {
            ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
            status: "error"
          });
          _this.fileList.splice(_this.fileList.findIndex((item) => item.key === key), 1);
        },
        complete(res2) {
          _this.fileList[_this.fileList.findIndex((item) => item.key === key)] = {
            ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
            url: _this.domain + res2.key,
            percent: 100,
            ...res2
          };
          setTimeout(() => {
            _this.fileList[_this.fileList.findIndex((item) => item.key === key)] = {
              ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
              status: "success"
            };
            _this.$emit("on-upload-success", {
              ..._this.fileList[_this.fileList.findIndex((item) => item.key === key)],
              status: "success"
            });
            _this.$emit("update:modelValue", _this.fileList);
          }, 200);
        }
      });
    },
    handleRemove(key) {
      if (!this.disabled) {
        this.$emit("on-upload-remove", this.fileList[this.fileList.findIndex((item) => item.key === key)]);
        this.fileList.splice(this.fileList.findIndex((item) => item.key === key), 1);
        this.$nextTick(() => {
          this.$emit("update:modelValue", this.fileList);
        });
      }
    },
    handleAdd() {
      if (!this.disabled) {
        this.editIndex = -1;
        this.$refs.uploadInput.click();
      }
    },
    handlePreviewFile(key) {
      this.viewer && this.viewer.destroy();
      this.uploadId = "upload_" + new Date().getTime();
      this.$nextTick(() => {
        this.viewer = new Viewer(document.getElementById(this.uploadId));
        this.viewer.view(this.fileList.findIndex((item) => item.key === key));
      });
    }
  },
  watch: {
    modelValue(val) {
      this.fileList = this.modelValue.map((item) => {
        return {
          ...item,
          key: item.key ? item.key : new Date().getTime() + "_" + Math.ceil(Math.random() * 99999)
        };
      });
    }
  }
};
const _hoisted_1$e = ["id"];
const _hoisted_2$d = {
  key: 0,
  class: "file-button"
};
const _hoisted_3$9 = { class: "upload_tip" };
const _hoisted_4$8 = { class: "upload-list" };
const _hoisted_5$8 = ["href"];
const _hoisted_6$6 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-file" }, null, -1);
const _hoisted_7$5 = { class: "list_item-status-label" };
const _hoisted_8$2 = {
  key: 0,
  class: "fm-iconfont icon-check",
  style: { "color": "#67c23a" }
};
const _hoisted_9$2 = ["onClick"];
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = resolveComponent("el-button");
  const _component_a_button = resolveComponent("a-button");
  const _component_el_progress = resolveComponent("el-progress");
  const _component_a_progress = resolveComponent("a-progress");
  return openBlock(), createElementBlock("div", {
    class: "fm-upload-file",
    id: $data.uploadId
  }, [
    !$props.printRead ? withDirectives((openBlock(), createElementBlock("div", _hoisted_2$d, [
      $props.ui == "element" ? (openBlock(), createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        disabled: $props.disabled || $data.fileList.length == $props.limit,
        onClick: $options.handleAdd
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.upload")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])) : createCommentVNode("", true),
      $props.ui == "antd" ? (openBlock(), createBlock(_component_a_button, {
        key: 1,
        size: $props.size,
        disabled: $props.disabled || $data.fileList.length == $props.limit,
        onClick: $options.handleAdd
      }, {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.upload")), 1)
        ]),
        _: 1
      }, 8, ["size", "disabled", "onClick"])) : createCommentVNode("", true),
      $props.multiple ? (openBlock(), createElementBlock("input", {
        key: 2,
        multiple: "",
        ref: "uploadInput",
        onChange: _cache[0] || (_cache[0] = (...args) => $options.handleChange && $options.handleChange(...args)),
        type: "file",
        name: "file",
        class: "upload_input"
      }, null, 544)) : (openBlock(), createElementBlock("input", {
        key: 3,
        ref: "uploadInput",
        onChange: _cache[1] || (_cache[1] = (...args) => $options.handleChange && $options.handleChange(...args)),
        type: "file",
        name: "file",
        class: "upload_input"
      }, null, 544))
    ], 512)), [
      [vShow, !$props.isQiniu || $props.isQiniu && $props.token]
    ]) : createCommentVNode("", true),
    createElementVNode("div", _hoisted_3$9, toDisplayString$1($props.tip), 1),
    createElementVNode("ul", _hoisted_4$8, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($data.fileList, (item) => {
        return openBlock(), createElementBlock("li", {
          class: normalizeClass(["list_item", { uploading: item.status == "uploading", "is-success": item.status == "success", "is-disabled": $props.disabled }]),
          key: item.key
        }, [
          createElementVNode("a", {
            class: "list_item-name",
            href: item.url,
            target: "_blank"
          }, [
            _hoisted_6$6,
            createTextVNode(" " + toDisplayString$1(item.name), 1)
          ], 8, _hoisted_5$8),
          !$props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createElementVNode("label", _hoisted_7$5, [
              item.status === "success" ? (openBlock(), createElementBlock("i", _hoisted_8$2)) : createCommentVNode("", true)
            ]),
            createElementVNode("i", {
              class: "fm-iconfont icon-close",
              onClick: ($event) => $options.handleRemove(item.key),
              style: { "font-size": "12px", "z-index": "1" }
            }, null, 8, _hoisted_9$2),
            item.status == "uploading" && $props.ui == "element" ? (openBlock(), createBlock(_component_el_progress, {
              key: 0,
              "stroke-width": 2,
              percentage: item.percent
            }, null, 8, ["percentage"])) : createCommentVNode("", true),
            item.status == "uploading" && $props.ui == "antd" ? (openBlock(), createBlock(_component_a_progress, {
              key: 1,
              "stroke-width": 2,
              percent: item.percent
            }, null, 8, ["percent"])) : createCommentVNode("", true)
          ], 64)) : createCommentVNode("", true)
        ], 2);
      }), 128))
    ])
  ], 8, _hoisted_1$e);
}
var FmFileUpload = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$t]]);
var index_vue_vue_type_style_index_0_lang$1 = "";
const _sfc_main$u = {
  name: "fm-sub-form",
  components: {
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$3;
    })),
    GenerateFormItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateFormItem$3;
    })),
    GenerateInline: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateInline$2;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$3;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$3;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$3;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$3;
    }))
  },
  props: [
    "showControl",
    "list",
    "value",
    "models",
    "remote",
    "blanks",
    "disableddata",
    "rules",
    "name",
    "remoteOption",
    "preview",
    "platform",
    "dataSourceValue",
    "eventFunction",
    "widget",
    "printRead",
    "paging",
    "pageSize",
    "containerKey",
    "isAdd",
    "isDelete",
    "isDialog",
    "dialogName",
    "group",
    "fieldNode"
  ],
  emits: ["update:value"],
  data() {
    var _a2;
    return {
      subformData: (_a2 = this.value) != null ? _a2 : [],
      displayFields: {},
      changeItem: {},
      pagingData: [],
      pagingLength: 0,
      currentPage: 1,
      itemModel: {},
      subHideFields: [],
      subDisabledFields: [],
      itemDisabled: {}
    };
  },
  created() {
    this._generateModel(this.list);
    this.loadPagingData();
    this.subHideFields = this.subformData.map((v) => Object.fromEntries(Object.keys(this.displayFields).map((field) => [field, !this.displayFields[field]])));
    this.subDisabledFields = this.subformData.map((v) => Object.fromEntries(Object.keys(this.itemDisabled).map((field) => [field, !this.itemDisabled[field]])));
  },
  provide() {
    return {
      "setSubformData": this.setSubformData
    };
  },
  inject: ["onFormDisabled", "onFormHide", "onFormDisplay"],
  methods: {
    handleMouseover(key) {
      addClass$1(this.$refs[`formSubformItem_${key}`][0], "is-hover");
    },
    handleMouseout(key) {
      removeClass$1(this.$refs[`formSubformItem_${key}`][0], "is-hover");
    },
    setSubformData(value, rowIndex, field) {
      this.subformData[rowIndex][field] = value;
    },
    setData(rowIndex, value) {
      if (typeof rowIndex !== "number") {
        return new Promise((resolve) => {
          value = rowIndex;
          this.subformData.forEach((_2, index2) => {
            Object.keys(value).forEach((item) => {
              this.setSubformData(value[item], index2, item);
            });
          });
          resolve();
        });
      }
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            this.setSubformData(value[item], rowIndex, item);
          });
          resolve();
        });
      });
    },
    handleAddRow() {
      this.subformData.push(_.cloneDeep(this.itemModel));
      this.subHideFields.push(
        Object.fromEntries(Object.keys(this.displayFields).map((field) => [field, !this.displayFields[field]]))
      );
      this.subDisabledFields.push(
        Object.fromEntries(Object.keys(this.itemDisabled).map((field) => [field, !this.itemDisabled[field]]))
      );
      if (this.widget && this.widget.events && this.widget.events.onRowAdd) {
        let funcKey = this.widget.events.onRowAdd;
        this.eventFunction[funcKey]({
          rowIndex: this.subformData.length - 1,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
      if (this.paging) {
        this.$nextTick(() => {
          if (this.subformData.length > this.currentPage * this.pageSize) {
            this.currentPage = parseInt((this.subformData.length - 1) / this.pageSize) + 1;
          }
          this.loadPagingData();
        });
      }
    },
    handleRemove(index2) {
      const removeData = { ...this.subformData[index2] };
      this.subformData.splice(index2, 1);
      this.subHideFields.splice(index2, 1);
      this.subDisabledFields.splice(index2, 1);
      if (this.widget && this.widget.events && this.widget.events.onRowRemove) {
        let funcKey = this.widget.events.onRowRemove;
        this.eventFunction[funcKey]({
          removeIndex: index2,
          removeData,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
      this.pagingData = [];
      this.pagingLength = 0;
      if (this.paging) {
        this.$nextTick(() => {
          if (this.subformData.length % this.pageSize == 0 && this.currentPage > parseInt(this.subformData.length / this.pageSize)) {
            this.currentPage = parseInt(this.subformData.length / this.pageSize);
          }
          this.loadPagingData();
        });
      }
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${field}`);
      });
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${field}`);
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this.subformData.forEach((_2, index2) => {
        fields.forEach((field) => {
          this.subDisabledFields[index2][field] = disabled;
        });
      });
      this._setDisabled(this.list, fields, disabled);
    },
    hideChild(rowIndex, fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${rowIndex}.${field}`);
      });
    },
    displayChild(rowIndex, fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${rowIndex}.${field}`);
      });
    },
    disabledChild(rowIndex, fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.subDisabledFields[rowIndex][field] = disabled;
        this.onFormDisabled(`${this.fieldNode}.${rowIndex}.${field}`, disabled);
      });
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setOptions(this.list, fields, options);
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.list, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.list, item.split("."), className, "remove");
      });
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.pagingData = [];
      this.pagingLength = 0;
      this.$nextTick(() => {
        this.loadPagingData();
      });
      if (this.widget && this.widget.events && this.widget.events.onPageChange) {
        let funcKey = this.widget.events.onPageChange;
        this.eventFunction[funcKey]({
          currentPage: val,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
    },
    loadPagingData() {
      let beginIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = beginIndex + this.pageSize;
      this.pagingData = this.subformData.slice(beginIndex, endIndex);
      this.pagingLength = this.pagingData.length;
    },
    _generateModel(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type == "grid") {
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          genList[i].columns.forEach((item) => {
            this._generateModel(item.list);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._generateModel(column.list);
            });
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "inline") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "card") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else {
          if (genList[i].type == "blank") {
            this.itemModel[genList[i].model] = genList[i].options.defaultType === "String" ? "" : genList[i].options.defaultType === "Object" ? {} : [];
          } else {
            this.itemModel[genList[i].model] = _.cloneDeep(genList[i].options.defaultValue);
          }
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          this.itemDisabled[genList[i].model] = !genList[i].options.disabled;
        }
      }
    },
    _setDisabled(genList, fields, disabled) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setDisabled(column.list, fields, disabled);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else if (genList[i].type === "card") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else {
          if (fields.indexOf(genList[i].model) >= 0) {
            genList[i].options.disabled = disabled;
            this.itemDisabled[genList[i].model] = !disabled;
          }
        }
      }
    },
    _setOptions(genList, fields, opts) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setOptions(column.list, fields, opts);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setOptions(genList[i].list, fields, opts);
        } else if (genList[i].type === "card") {
          this._setOptions(genList[i].list, fields, opts);
        }
        if (fields.indexOf(genList[i].model) >= 0) {
          Object.keys(opts).forEach((key) => {
            genList[i].options[key] = opts[key];
          });
        }
      }
    }
  },
  watch: {
    value(val) {
      var _a2, _b, _c, _d, _e, _f;
      this.subformData = val;
      let hideFields = [];
      let disabledFields = [];
      for (let i = 0; i < this.value.length; i++) {
        let rowArray = Object.keys(this.displayFields);
        let hideRow = {};
        for (let f = 0; f < rowArray.length; f++) {
          hideRow[rowArray[f]] = (_c = (_b = (_a2 = this.subHideFields) == null ? void 0 : _a2[i]) == null ? void 0 : _b[rowArray[f]]) != null ? _c : !this.displayFields[rowArray[f]];
        }
        hideFields.push(hideRow);
        let disabledArray = Object.keys(this.itemDisabled);
        let disabledRow = {};
        for (let d = 0; d < disabledArray.length; d++) {
          disabledRow[disabledArray[d]] = (_f = (_e = (_d = this.subDisabledFields) == null ? void 0 : _d[i]) == null ? void 0 : _e[disabledArray[d]]) != null ? _f : !this.itemDisabled[disabledArray[d]];
        }
        disabledFields.push(disabledRow);
      }
      this.subHideFields = hideFields;
      this.subDisabledFields = disabledFields;
    },
    subformData: {
      deep: true,
      handler(val) {
        this.loadPagingData();
        this.$emit("update:value", val);
      }
    }
  }
};
const _hoisted_1$d = { class: "form-subform" };
const _hoisted_2$c = ["onMouseover", "onMouseout"];
const _hoisted_3$8 = {
  key: 0,
  class: "form-subform-index"
};
const _hoisted_4$7 = {
  key: 1,
  class: "form-subform-remove"
};
const _hoisted_5$7 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-trash",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_6$5 = { class: "form-subform-content" };
const _hoisted_7$4 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = resolveComponent("el-tag");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_popconfirm = resolveComponent("el-popconfirm");
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_el_col = resolveComponent("el-col");
  const _component_el_pagination = resolveComponent("el-pagination");
  const _component_el_row = resolveComponent("el-row");
  return openBlock(), createElementBlock("div", _hoisted_1$d, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.subformData, (t, index2) => {
      return openBlock(), createElementBlock("div", {
        class: "form-subform-item",
        key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
        onMouseover: withModifiers(($event) => $options.handleMouseover(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2), ["stop"]),
        onMouseout: ($event) => $options.handleMouseout(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2),
        ref_for: true,
        ref: `formSubformItem_${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
      }, [
        $props.showControl ? (openBlock(), createElementBlock("div", _hoisted_3$8, [
          createVNode(_component_el_tag, { round: "" }, {
            default: withCtx(() => [
              createTextVNode("#" + toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)
            ]),
            _: 2
          }, 1024)
        ])) : createCommentVNode("", true),
        $props.showControl ? (openBlock(), createElementBlock("div", _hoisted_4$7, [
          !$props.printRead && $props.isDelete ? (openBlock(), createBlock(_component_el_popconfirm, {
            key: 0,
            teleported: false,
            title: _ctx.$t("fm.description.deleteConfirm"),
            onConfirm: ($event) => $options.handleRemove(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2)
          }, {
            reference: withCtx(() => [
              createVNode(_component_el_button, {
                disabled: $props.disableddata,
                type: "danger",
                size: "small",
                circle: ""
              }, {
                default: withCtx(() => [
                  _hoisted_5$7
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 2
          }, 1032, ["title", "onConfirm"])) : createCommentVNode("", true),
          $props.printRead || !$props.isDelete ? (openBlock(), createBlock(_component_el_tag, {
            key: 1,
            round: ""
          }, {
            default: withCtx(() => [
              createTextVNode("#" + toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)
            ]),
            _: 2
          }, 1024)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_6$5, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.list, (item) => {
            return openBlock(), createElementBlock(Fragment, null, [
              item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "is-dialog", "dialog-name", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                key: item.key,
                models: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                widget: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "is-dialog", "dialog-name", "group", "field-node"]))
            ], 64);
          }), 256))
        ])
      ], 40, _hoisted_2$c);
    }), 128)),
    createVNode(_component_el_row, { class: "form-subform-action" }, {
      default: withCtx(() => [
        createVNode(_component_el_col, {
          span: $props.preview && $props.platform != "mobile" || !$props.preview ? 12 : 24,
          xs: 24
        }, {
          default: withCtx(() => [
            !$props.disableddata && $props.isAdd ? (openBlock(), createBlock(_component_el_button, {
              key: 0,
              link: "",
              type: "primary",
              onClick: $options.handleAddRow
            }, {
              default: withCtx(() => [
                _hoisted_7$4,
                createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.add")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["span"]),
        createVNode(_component_el_col, {
          span: ($props.preview && $props.platform != "mobile" || !$props.preview) && !$props.disableddata ? 12 : 24,
          xs: 24
        }, {
          default: withCtx(() => [
            $props.paging && $data.subformData.length ? (openBlock(), createBlock(_component_el_pagination, {
              key: 0,
              style: { "float": "right" },
              layout: "total, prev, pager, next",
              "page-size": $props.pageSize,
              "current-page": $data.currentPage,
              total: $data.subformData.length,
              "pager-count": 5,
              onCurrentChange: $options.handlePageChange
            }, null, 8, ["page-size", "current-page", "total", "onCurrentChange"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    })
  ]);
}
var FmSubForm$1 = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$s]]);
const _sfc_main$t = {
  name: "fm-group",
  components: {
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$3;
    })),
    GenerateFormItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateFormItem$3;
    })),
    GenerateInline: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateInline$2;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$3;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$3;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$3;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$3;
    }))
  },
  props: ["value", "models", "rules", "element", "remote", "blanks", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "group", "fieldNode"],
  data() {
    var _a2;
    return {
      displayFields: {},
      groupModel: (_a2 = this.value) != null ? _a2 : {},
      groupDisabled: {}
    };
  },
  emits: ["update:value"],
  inject: ["generateComponentInstance", "deleteComponentInstance", "getFormComponent", "onFormHide", "onFormDisplay"],
  created() {
    this._generateModel(this.element.list);
  },
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode, this.$refs[`generate-group-${this.element.model}`].$parent);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode);
  },
  provide() {
    return {
      "setGroupData": this.setGroupData
    };
  },
  methods: {
    setGroupData(value, field) {
      this.groupModel[field] = value;
    },
    _generateModel(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type == "grid") {
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          genList[i].columns.forEach((item) => {
            this._generateModel(item.list);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._generateModel(column.list);
            });
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "inline") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "card") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else {
          if (genList[i].type == "blank") {
            this.groupModel[genList[i].model] = genList[i].options.defaultType === "String" ? "" : genList[i].options.defaultType === "Object" ? {} : [];
          } else {
            this.groupModel[genList[i].model] = _.cloneDeep(genList[i].options.defaultValue);
          }
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          this.groupDisabled[genList[i].model] = !genList[i].options.disabled;
        }
      }
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${field}`);
      });
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${field}`);
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setDisabled(this.element.list, fields, disabled);
    },
    validate() {
      return new Promise((resolve, reject) => {
        let realFields = this._getAllRuleFields();
        this.getFormComponent().validateField(realFields, (valid, error) => {
          if (valid) {
            resolve();
          } else {
            reject(error);
          }
        });
      });
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setOptions(this.element.list, fields, options);
    },
    setData(value) {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            this.groupModel[item] = value[item];
          });
          resolve();
        });
      });
    },
    getValues() {
      return this.groupModel;
    },
    getValue(fieldName) {
      return this.groupModel[fieldName];
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.element.list, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.element.list, item.split("."), className, "remove");
      });
    },
    _setDisabled(genList, fields, disabled) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setDisabled(column.list, fields, disabled);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else if (genList[i].type === "card") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else {
          if (fields.indexOf(genList[i].model) >= 0) {
            genList[i].options.disabled = disabled;
          }
        }
      }
    },
    _setOptions(genList, fields, opts) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setOptions(column.list, fields, opts);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setOptions(genList[i].list, fields, opts);
        } else if (genList[i].type === "card") {
          this._setOptions(genList[i].list, fields, opts);
        }
        if (fields.indexOf(genList[i].model) >= 0) {
          Object.keys(opts).forEach((key) => {
            genList[i].options[key] = opts[key];
          });
        }
      }
    },
    _getAllRuleFields() {
      let realFields = [];
      Object.keys(this.groupModel).forEach((v) => {
        if (Array.isArray(this.groupModel[v])) {
          const currentArray = this.groupModel[v];
          currentArray.forEach((o, i) => {
            Object.keys(o).forEach((key) => {
              realFields.push(`${this.fieldNode}.${v}.${i}.${key}`);
            });
          });
        } else {
          realFields.push(`${this.fieldNode}.${v}`);
        }
      });
      return realFields;
    }
  },
  watch: {
    groupModel: {
      deep: true,
      handler(val) {
        this.$emit("update:value", val);
      }
    },
    value: {
      deep: true,
      handler(val) {
        this.groupModel = val;
      }
    }
  }
};
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  return openBlock(), createElementBlock("div", {
    style: normalizeStyle({
      width: $props.element.options.width
    }),
    ref: `generate-group-${$props.element.model}`
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.list, (item) => {
      return openBlock(), createElementBlock(Fragment, null, [
        item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
          key: item.key,
          models: $data.groupModel,
          rules: $props.rules,
          widget: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node"]))
      ], 64);
    }), 256))
  ], 4);
}
var FmGroup$1 = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$r]]);
const _sfc_main$s = {
  name: "generate-element-item",
  components: {
    FmUpload,
    FmFormTable: FmFormTable$1,
    FmFileUpload,
    FmSubForm: FmSubForm$1,
    FmGroup: FmGroup$1,
    Editor: _sfc_main$Z
  },
  props: [
    "widget",
    "modelValue",
    "models",
    "remote",
    "isTable",
    "blanks",
    "disabled",
    "edit",
    "remoteOption",
    "rules",
    "platform",
    "preview",
    "dataSourceValue",
    "eventFunction",
    "rowIndex",
    "tableName",
    "printRead",
    "isMobile",
    "isSubform",
    "subName",
    "isDialog",
    "dialogName",
    "group",
    "fieldNode",
    "containerKey",
    "isGroup"
  ],
  emits: ["update:modelValue", "on-table-change"],
  data() {
    return {
      dataModel: this.modelValue,
      dataModels: this.models,
      key: new Date().getTime(),
      modelName: this.widget.model,
      propsModel: { multiple: this.widget.options.multiple || false, checkStrictly: this.widget.options.checkStrictly || false },
      propsTransfer: { key: "key", label: "label" },
      remoteOptions: [],
      dynamicEvents: this.handleOnDynamicEvent(),
      generateDisabled: void 0
    };
  },
  computed: {
    elementDisabled() {
      if (typeof this.generateDisabled === "boolean") {
        return !this.edit || this.generateDisabled;
      } else {
        return !this.edit || this.widget.options.disabled;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "eventScriptConfig"],
  created() {
    if (this.widget.options.remote && (Object.keys(this.widget.options).indexOf("remoteType") >= 0 ? this.widget.options.remoteType == "func" : true) && this.remote[this.widget.options.remoteFunc]) {
      this.remote[this.widget.options.remoteFunc]((data2) => {
        this.loadOptions(data2);
      });
    }
    if (this.widget.options.remote && this.widget.options.remoteType == "option" && this.remoteOption[this.widget.options.remoteOption]) {
      this.loadOptions(this.remoteOption[this.widget.options.remoteOption]);
    }
    if (this.widget.options.remote && this.widget.options.remoteType == "datasource" && this.dataSourceValue) {
      let options = this.getDataSourceOptions();
      options && options.value && this.loadOptions(options.value);
    }
    if ((this.widget.type === "imgupload" || this.widget.type === "fileupload") && this.widget.options.isQiniu) {
      this.loadUploadConfig();
    }
    if (this.widget.type == "component") {
      const _pthis = this;
      this.$options.components[`component-${this.widget.key}-${this.key}`] = {
        template: `${this.widget.options.template}`,
        props: ["modelValue"],
        emits: ["update:modelValue"],
        data: () => ({
          dataModel: this.modelValue
        }),
        watch: {
          dataModel(val) {
            if (this.ui == "antd") {
              EventBus.$emit("on-field-change", this.$attrs.id, val);
            } else {
              this.$emit("update:modelValue", val);
            }
          },
          modelValue(val) {
            this.dataModel = val;
          }
        },
        methods: {
          triggerEvent(eventName, arg) {
            if (_pthis.eventScriptConfig()) {
              let currentEventScript = _pthis.eventScriptConfig().find((item) => item.name == eventName);
              if (currentEventScript) {
                if (_pthis.isTable && _pthis.tableName) {
                  _pthis.eventFunction[currentEventScript.key]({
                    field: _pthis.widget.model,
                    table: _pthis.tableName,
                    rowIndex: _pthis.rowIndex,
                    dialog: _pthis.isDialog ? _pthis.dialogName : null,
                    currentRef: this,
                    group: _pthis.group,
                    fieldNode: _pthis.fieldNode,
                    $eventArgs: arg
                  });
                } else if (_pthis.isSubform && _pthis.subName) {
                  _pthis.eventFunction[currentEventScript.key]({
                    field: _pthis.widget.model,
                    subform: _pthis.subName,
                    rowIndex: _pthis.rowIndex,
                    dialog: _pthis.isDialog ? _pthis.dialogName : null,
                    currentRef: this,
                    group: _pthis.group,
                    fieldNode: _pthis.fieldNode,
                    $eventArgs: arg
                  });
                } else if (_pthis.isDialog && _pthis.dialogName) {
                  _pthis.eventFunction[currentEventScript.key]({
                    field: _pthis.widget.model,
                    dialog: _pthis.isDialog ? _pthis.dialogName : null,
                    currentRef: this,
                    group: _pthis.group,
                    fieldNode: _pthis.fieldNode,
                    $eventArgs: arg
                  });
                } else {
                  _pthis.eventFunction[currentEventScript.key]({
                    field: _pthis.widget.model,
                    currentRef: this,
                    group: _pthis.group,
                    fieldNode: _pthis.fieldNode,
                    $eventArgs: arg
                  });
                }
              }
            }
          }
        }
      };
    }
  },
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(
      this.fieldNode,
      this.$refs["fm-" + this.widget.model]
    );
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode);
    if (this.$options.components[`component-${this.widget.key}-${this.key}`]) {
      this.$options.components[`component-${this.widget.key}-${this.key}`] = null;
    }
  },
  methods: {
    handleOnDynamicEvent() {
      let currentEvents = {};
      for (let i in this.widget.events) {
        let funcKey = this.widget.events[i];
        funcKey && (currentEvents[i] = this.callbackDynamicFunc(funcKey));
      }
      return currentEvents;
    },
    callbackDynamicFunc(funcKey) {
      let callback = (...arg) => {
        if (this.isTable && this.tableName) {
          this.eventFunction[funcKey]({
            field: this.widget.model,
            table: this.tableName,
            rowIndex: this.rowIndex,
            dialog: this.isDialog ? this.dialogName : null,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            $eventArgs: arg
          });
        } else if (this.isSubform && this.subName) {
          this.eventFunction[funcKey]({
            field: this.widget.model,
            subform: this.subName,
            rowIndex: this.rowIndex,
            dialog: this.isDialog ? this.dialogName : null,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            $eventArgs: arg
          });
        } else if (this.isDialog && this.dialogName) {
          this.eventFunction[funcKey]({
            field: this.widget.model,
            dialog: this.dialogName,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            $eventArgs: arg
          });
        } else {
          this.eventFunction[funcKey]({
            field: this.widget.model,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            $eventArgs: arg
          });
        }
      };
      return callback;
    },
    loadOptions(data2) {
      if (!Array.isArray(data2))
        return;
      this.remoteOptions = data2.map((item) => {
        if (this.widget.options.props.children && this.widget.options.props.children.length && Object.keys(item).includes(this.widget.options.props.children)) {
          return {
            value: item[this.widget.options.props.value],
            label: item[this.widget.options.props.label],
            children: this.processRemoteProps(item[this.widget.options.props.children], this.widget.options.props)
          };
        } else {
          if (this.widget.type == "steps") {
            return {
              value: item[this.widget.options.props.title] + "",
              label: item[this.widget.options.props.description]
            };
          } else if (this.widget.type == "transfer") {
            return item;
          } else {
            return {
              value: item[this.widget.options.props.value],
              label: item[this.widget.options.props.label]
            };
          }
        }
      });
    },
    processRemoteProps(children, props2) {
      if (children && children.length) {
        return children.map((item) => {
          if (this.processRemoteProps(item[props2.children], props2).length) {
            return {
              value: item[props2.value],
              label: item[props2.label],
              children: this.processRemoteProps(item[props2.children], props2)
            };
          } else {
            return {
              value: item[props2.value],
              label: item[props2.label]
            };
          }
        });
      } else {
        return [];
      }
    },
    onCascaderChange(value) {
      if (value) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$parent && this.$parent.clearValidate();
            this.$parent && this.$parent.$parent && this.$parent.$parent.$refs.generateFormItem && this.$parent.$parent.$refs.generateFormItem.clearValidate();
          });
        });
      }
    },
    handleTransferChange(value) {
      this.dataModel = value;
    },
    getCascaderText(value, options, texts = []) {
      if (value.length >= 1) {
        let currentOpt = options == null ? void 0 : options.find((opt) => opt.value == value[0]);
        if (currentOpt) {
          texts.push(currentOpt.label);
        }
        value.splice(0, 1);
        return this.getCascaderText(value, currentOpt == null ? void 0 : currentOpt.children, texts);
      } else if (value.length == 0) {
        return texts;
      }
    },
    getTreeText(value, options) {
      for (let i = 0; i < options.length; i++) {
        let currentOpt = options[i];
        if (currentOpt.value == value) {
          return currentOpt.label;
        }
        if (currentOpt.children && currentOpt.children.length > 0) {
          let res = this.getTreeText(value, currentOpt.children);
          if (res == "-") {
            continue;
          } else {
            return res;
          }
        }
      }
      return "-";
    },
    loadUploadConfig() {
      if (this.widget.options.tokenType === "func") {
        !this.widget.options.token && this.remote[this.widget.options.tokenFunc]((data2) => {
          this.widget.options.token = data2;
        });
      } else {
        if (this.dataSourceValue) {
          let token = this.getDataSourceOptions("tokenDataSource");
          token && token.value && (this.widget.options.token = token.value);
        }
      }
    },
    handleOnClick() {
      this.execFunction("onClick", {});
    },
    handleOnFocus() {
      this.execFunction("onFocus", {});
    },
    handleOnBlur() {
      this.execFunction("onBlur", {});
    },
    handleOnUploadSelect(file) {
      return this.execFunction("onSelect", { file });
    },
    handleOnUploadSuccess(file) {
      this.execFunction("onUploadSuccess", { file });
    },
    handleOnUploadError(file) {
      this.execFunction("onUploadError", { file });
    },
    handleOnUploadProgress(file) {
      this.execFunction("onUploadProgress", { file });
    },
    handleOnUploadRemove(file) {
      this.execFunction("onRemove", { file });
    },
    execFunction(method, arg) {
      if (this.widget.events && this.widget.events[method]) {
        let funcKey = this.widget.events[method];
        if (this.isTable && this.tableName) {
          return this.eventFunction[funcKey]({
            field: this.widget.model,
            table: this.tableName,
            rowIndex: this.rowIndex,
            dialog: this.isDialog ? this.dialogName : null,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            ...arg
          });
        } else if (this.isSubform && this.subName) {
          return this.eventFunction[funcKey]({
            field: this.widget.model,
            subform: this.subName,
            rowIndex: this.rowIndex,
            dialog: this.isDialog ? this.dialogName : null,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            ...arg
          });
        } else if (this.isDialog && this.dialogName) {
          return this.eventFunction[funcKey]({
            field: this.widget.model,
            dialog: this.dialogName,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            ...arg
          });
        } else {
          return this.eventFunction[funcKey]({
            field: this.widget.model,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            ...arg
          });
        }
      }
    },
    getDataSourceOptions(remoteName = "remoteDataSource") {
      let key = this.group ? this.group + "." + this.widget.model + "." + this.widget.options[remoteName] : this.widget.model + "." + this.widget.options[remoteName];
      return this.dataSourceValue.find((item) => item.key === key);
    },
    disabledElement(disabled) {
      this.generateDisabled = disabled;
    }
  },
  watch: {
    modelValue(val) {
      this.dataModel = val;
    },
    dataModel(val, oldValue) {
      this.$emit("update:modelValue", val);
    },
    "remoteOption": {
      deep: true,
      handler: function(val) {
        if (Object.keys(this.remoteOption).indexOf(this.widget.options.remoteOption) >= 0 && this.widget.options.remote && this.widget.options.remoteType == "option") {
          this.loadOptions(this.remoteOption[this.widget.options.remoteOption]);
        }
      }
    },
    "dataSourceValue": {
      deep: true,
      handler: function(val) {
        if (this.dataSourceValue) {
          let options = this.getDataSourceOptions();
          options && options.value && this.loadOptions(options.value);
        }
        if ((this.widget.type === "imgupload" || this.widget.type === "fileupload") && this.widget.options.isQiniu) {
          this.loadUploadConfig();
        }
      }
    }
  }
};
const _hoisted_1$c = { key: 0 };
const _hoisted_2$b = { key: 0 };
const _hoisted_3$7 = { key: 0 };
const _hoisted_4$6 = ["innerHTML"];
const _hoisted_5$6 = ["innerHTML"];
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b, _c, _d, _e;
  const _component_el_input = resolveComponent("el-input");
  const _component_el_input_number = resolveComponent("el-input-number");
  const _component_el_radio = resolveComponent("el-radio");
  const _component_el_radio_group = resolveComponent("el-radio-group");
  const _component_el_checkbox = resolveComponent("el-checkbox");
  const _component_el_checkbox_group = resolveComponent("el-checkbox-group");
  const _component_el_time_picker = resolveComponent("el-time-picker");
  const _component_el_date_picker = resolveComponent("el-date-picker");
  const _component_el_rate = resolveComponent("el-rate");
  const _component_el_color_picker = resolveComponent("el-color-picker");
  const _component_el_option = resolveComponent("el-option");
  const _component_el_select = resolveComponent("el-select");
  const _component_el_switch = resolveComponent("el-switch");
  const _component_el_slider = resolveComponent("el-slider");
  const _component_fm_upload = resolveComponent("fm-upload");
  const _component_Editor = resolveComponent("Editor");
  const _component_el_cascader = resolveComponent("el-cascader");
  const _component_el_tree_select = resolveComponent("el-tree-select");
  const _component_fm_form_table = resolveComponent("fm-form-table");
  const _component_fm_sub_form = resolveComponent("fm-sub-form");
  const _component_fm_group = resolveComponent("fm-group");
  const _component_fm_file_upload = resolveComponent("fm-file-upload");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_link = resolveComponent("el-link");
  const _component_el_step = resolveComponent("el-step");
  const _component_el_steps = resolveComponent("el-steps");
  const _component_el_pagination = resolveComponent("el-pagination");
  const _component_el_transfer = resolveComponent("el-transfer");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass({ "print-read-label": $props.printRead }),
    style: { "width": "100%" }
  }, [
    $props.widget.type == "blank" ? (openBlock(), createElementBlock("div", {
      key: 0,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width })
    }, [
      renderSlot(_ctx.$slots, $props.widget.model, { model: $data.dataModels })
    ], 4)) : createCommentVNode("", true),
    $props.widget.type == "component" ? (openBlock(), createElementBlock("div", {
      key: 1,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width })
    }, [
      (openBlock(), createBlock(resolveDynamicComponent(`component-${$props.widget.key}-${$data.key}`), {
        key: $data.key,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.dataModel = $event),
        ref: "fm-" + $props.widget.model
      }, null, 8, ["modelValue"]))
    ], 4)) : createCommentVNode("", true),
    $props.widget.type == "custom" ? (openBlock(), createElementBlock("div", {
      key: 2,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width })
    }, [
      (openBlock(), createBlock(resolveDynamicComponent($props.widget.el), mergeProps({
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.dataModel = $event),
        width: $props.widget.options.width,
        height: $props.widget.options.height,
        placeholder: $props.widget.options.placeholder,
        readonly: $props.widget.options.readonly,
        disabled: $options.elementDisabled,
        editable: $props.widget.options.editable,
        clearable: $props.widget.options.clearable,
        ref: "fm-" + $props.widget.model,
        "print-read": $props.printRead
      }, { ...$props.widget.options.customProps, ...$props.widget.options.extendProps }, toHandlers($data.dynamicEvents)), null, 16, ["modelValue", "width", "height", "placeholder", "readonly", "disabled", "editable", "clearable", "print-read"]))
    ], 4)) : createCommentVNode("", true),
    $props.widget.type == "input" ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
      $props.printRead ? (openBlock(), createElementBlock("span", _hoisted_1$c, toDisplayString$1($data.dataModel), 1)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        $props.widget.options.dataTypeCheck && ($props.widget.options.dataType == "number" || $props.widget.options.dataType == "integer" || $props.widget.options.dataType == "float") ? (openBlock(), createBlock(_component_el_input, mergeProps({
          key: 0,
          type: "number",
          modelValue: $data.dataModel,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $data.dataModel = $event),
          modelModifiers: { number: true },
          disabled: $options.elementDisabled,
          clearable: $props.widget.options.clearable,
          placeholder: $props.widget.options.placeholder,
          "show-password": $props.widget.options.showPassword,
          style: { width: $props.isTable ? "100%" : $props.widget.options.width },
          ref: "fm-" + $props.widget.model
        }, $props.widget.options.customProps, {
          onFocus: $options.handleOnFocus,
          onBlur: $options.handleOnBlur
        }), null, 16, ["modelValue", "disabled", "clearable", "placeholder", "show-password", "style", "onFocus", "onBlur"])) : (openBlock(), createBlock(_component_el_input, mergeProps({
          key: 1,
          type: $props.widget.options.dataTypeCheck ? $props.widget.options.dataType : "text",
          modelValue: $data.dataModel,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $data.dataModel = $event),
          disabled: $options.elementDisabled,
          placeholder: $props.widget.options.placeholder,
          "show-password": $props.widget.options.showPassword,
          style: { width: $props.isTable ? "100%" : $props.widget.options.width },
          clearable: $props.widget.options.clearable,
          ref: "fm-" + $props.widget.model,
          maxlength: $props.widget.options.maxlength,
          "show-word-limit": $props.widget.options.showWordLimit
        }, $props.widget.options.customProps, {
          onFocus: $options.handleOnFocus,
          onBlur: $options.handleOnBlur
        }), null, 16, ["type", "modelValue", "disabled", "placeholder", "show-password", "style", "clearable", "maxlength", "show-word-limit", "onFocus", "onBlur"]))
      ], 64))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "textarea" ? (openBlock(), createElementBlock(Fragment, { key: 4 }, [
      $props.printRead ? (openBlock(), createElementBlock("pre", _hoisted_2$b, toDisplayString$1($data.dataModel), 1)) : (openBlock(), createBlock(_component_el_input, mergeProps({
        key: 1,
        type: "textarea",
        rows: $props.widget.options.rows,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        placeholder: $props.widget.options.placeholder,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        clearable: $props.widget.options.clearable,
        ref: "fm-" + $props.widget.model,
        maxlength: $props.widget.options.maxlength,
        "show-word-limit": $props.widget.options.showWordLimit,
        autosize: $props.widget.options.autosize
      }, $props.widget.options.customProps, {
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur
      }), null, 16, ["rows", "modelValue", "disabled", "placeholder", "style", "clearable", "maxlength", "show-word-limit", "autosize", "onFocus", "onBlur"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "number" ? (openBlock(), createElementBlock(Fragment, { key: 5 }, [
      $props.printRead ? (openBlock(), createElementBlock("span", _hoisted_3$7, toDisplayString$1(typeof $data.dataModel == "number" ? $data.dataModel.toFixed($props.widget.options.precision) : $data.dataModel), 1)) : (openBlock(), createBlock(_component_el_input_number, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => $data.dataModel = $event),
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        step: $props.widget.options.step,
        disabled: $options.elementDisabled,
        min: $props.widget.options.min,
        max: $props.widget.options.max,
        "controls-position": $props.widget.options.controlsPosition,
        precision: $props.widget.options.precision,
        controls: $props.widget.options.controls,
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps, {
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur
      }), null, 16, ["modelValue", "style", "step", "disabled", "min", "max", "controls-position", "precision", "controls", "onFocus", "onBlur"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "radio" ? (openBlock(), createElementBlock(Fragment, { key: 6 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1($data.remoteOptions.find((item) => item.value == $data.dataModel) && $data.remoteOptions.find((item) => item.value == $data.dataModel).label), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($props.widget.options.showLabel ? $props.widget.options.options.find((item) => item.value == $data.dataModel) && $props.widget.options.options.find((item) => item.value == $data.dataModel).label : $data.dataModel), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_el_radio_group, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => $data.dataModel = $event),
        style: { width: $props.isTable ? "100%" : $props.widget.options.width, display: "block" },
        disabled: $options.elementDisabled,
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options, (item, index2) => {
            return openBlock(), createBlock(_component_el_radio, {
              style: normalizeStyle({ display: $props.widget.options.inline ? "inline-block" : "block" }),
              value: item.value,
              label: item.value,
              key: index2
            }, {
              default: withCtx(() => [
                $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createTextVNode(toDisplayString$1(item.label), 1)
                ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString$1($props.widget.options.showLabel ? item.label : item.value), 1)
                ], 64))
              ]),
              _: 2
            }, 1032, ["style", "value", "label"]);
          }), 128))
        ]),
        _: 1
      }, 16, ["modelValue", "style", "disabled"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "checkbox" ? (openBlock(), createElementBlock(Fragment, { key: 7 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1($data.dataModel.map(
            (dm) => $data.remoteOptions.find((item) => item.value == dm) && $data.remoteOptions.find((item) => item.value == dm).label
          ).join("\u3001")), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($props.widget.options.showLabel ? $data.dataModel.map((dm) => $props.widget.options.options.find((item) => item.value == dm) && $props.widget.options.options.find((item) => item.value == dm).label).join("\u3001") : $data.dataModel.join("\u3001")), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_el_checkbox_group, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => $data.dataModel = $event),
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        disabled: $options.elementDisabled,
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options, (item, index2) => {
            return openBlock(), createBlock(_component_el_checkbox, {
              style: normalizeStyle({ display: $props.widget.options.inline ? "inline-block" : "block" }),
              label: item.value,
              value: item.value,
              key: index2
            }, {
              default: withCtx(() => [
                $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createTextVNode(toDisplayString$1(item.label), 1)
                ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString$1($props.widget.options.showLabel ? item.label : item.value), 1)
                ], 64))
              ]),
              _: 2
            }, 1032, ["style", "label", "value"]);
          }), 128))
        ]),
        _: 1
      }, 16, ["modelValue", "style", "disabled"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "time" ? (openBlock(), createElementBlock(Fragment, { key: 8 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_el_time_picker, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => $data.dataModel = $event),
        "is-range": $props.widget.options.isRange,
        placeholder: $props.widget.options.placeholder,
        "start-placeholder": $props.widget.options.startPlaceholder,
        "end-placeholder": $props.widget.options.endPlaceholder,
        readonly: $props.widget.options.readonly,
        disabled: $options.elementDisabled,
        editable: $props.widget.options.editable,
        clearable: $props.widget.options.clearable,
        arrowControl: $props.widget.options.arrowControl,
        "value-format": $props.widget.options.format,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps, {
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur
      }), null, 16, ["modelValue", "is-range", "placeholder", "start-placeholder", "end-placeholder", "readonly", "disabled", "editable", "clearable", "arrowControl", "value-format", "style", "onFocus", "onBlur"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "date" ? (openBlock(), createElementBlock(Fragment, { key: 9 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1(typeof $data.dataModel == "object" ? $data.dataModel.join("\u3001") : $data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_el_date_picker, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => $data.dataModel = $event),
        type: $props.widget.options.type,
        placeholder: $props.widget.options.placeholder,
        "start-placeholder": $props.widget.options.startPlaceholder,
        "end-placeholder": $props.widget.options.endPlaceholder,
        readonly: $props.widget.options.readonly,
        disabled: $options.elementDisabled,
        editable: $props.widget.options.editable,
        clearable: $props.widget.options.clearable,
        "value-format": $props.widget.options.timestamp ? "timestamp" : $props.widget.options.format,
        format: $props.widget.options.format,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps, {
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur
      }), null, 16, ["modelValue", "type", "placeholder", "start-placeholder", "end-placeholder", "readonly", "disabled", "editable", "clearable", "value-format", "format", "style", "onFocus", "onBlur"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "rate" ? (openBlock(), createElementBlock(Fragment, { key: 10 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_el_rate, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => $data.dataModel = $event),
        max: $props.widget.options.max,
        disabled: $options.elementDisabled,
        "allow-half": $props.widget.options.allowHalf,
        "show-score": $props.widget.options.showScore,
        ref: "fm-" + $props.widget.model,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width, display: "inline-block" }
      }, $props.widget.options.customProps), null, 16, ["modelValue", "max", "disabled", "allow-half", "show-score", "style"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "color" ? (openBlock(), createElementBlock(Fragment, { key: 11 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_el_color_picker, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        "show-alpha": $props.widget.options.showAlpha,
        ref: "fm-" + $props.widget.model,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width }
      }, $props.widget.options.customProps), null, 16, ["modelValue", "disabled", "show-alpha", "style"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "select" ? (openBlock(), createElementBlock(Fragment, { key: 12 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1(typeof $data.dataModel == "object" ? $data.dataModel.map((dm) => $data.remoteOptions.find((item) => item.value == dm) && $data.remoteOptions.find((item) => item.value == dm).label).join("\u3001") : $data.remoteOptions.find((item) => item.value == $data.dataModel) && $data.remoteOptions.find((item) => item.value == $data.dataModel).label), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($props.widget.options.showLabel ? typeof $data.dataModel == "object" ? $data.dataModel.map((dm) => $props.widget.options.options.find((item) => item.value == dm) && $props.widget.options.options.find((item) => item.value == dm).label).join("\u3001") : $props.widget.options.options.find((item) => item.value == $data.dataModel) && $props.widget.options.options.find((item) => item.value == $data.dataModel).label : typeof $data.dataModel == "object" ? $data.dataModel.join("\u3001") : $data.dataModel), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_el_select, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        multiple: $props.widget.options.multiple,
        clearable: $props.widget.options.clearable,
        placeholder: $props.widget.options.placeholder,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        filterable: $props.widget.options.filterable,
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps, {
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur
      }), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options, (item) => {
            return openBlock(), createBlock(_component_el_option, {
              key: item.value,
              value: item.value,
              label: $props.widget.options.showLabel || $props.widget.options.remote ? item.label : item.value
            }, null, 8, ["value", "label"]);
          }), 128))
        ]),
        _: 1
      }, 16, ["modelValue", "disabled", "multiple", "clearable", "placeholder", "style", "filterable", "onFocus", "onBlur"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "switch" ? (openBlock(), createElementBlock(Fragment, { key: 13 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_el_switch, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        ref: "fm-" + $props.widget.model,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width }
      }, $props.widget.options.customProps), null, 16, ["modelValue", "disabled", "style"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "slider" ? (openBlock(), createElementBlock(Fragment, { key: 14 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_el_slider, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => $data.dataModel = $event),
        min: $props.widget.options.min,
        max: $props.widget.options.max,
        disabled: $options.elementDisabled,
        step: $props.widget.options.step,
        "show-input": $props.widget.options.showInput,
        range: $props.widget.options.range,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps), null, 16, ["modelValue", "min", "max", "disabled", "step", "show-input", "range", "style"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "imgupload" ? (openBlock(), createBlock(_component_fm_upload, {
      key: 15,
      modelValue: $data.dataModel,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => $data.dataModel = $event),
      disabled: $options.elementDisabled,
      readonly: $props.widget.options.readonly || $props.printRead,
      style: normalizeStyle({ "width": $props.isTable ? "100%" : $props.widget.options.width }),
      width: $props.widget.options.size.width,
      height: $props.widget.options.size.height,
      token: $props.widget.options.token,
      domain: $props.widget.options.domain,
      multiple: $props.widget.options.multiple,
      limit: $props.widget.options.limit,
      "is-qiniu": $props.widget.options.isQiniu,
      "is-delete": $props.widget.options.isDelete,
      min: $props.widget.options.min,
      "is-edit": $props.widget.options.isEdit,
      action: $props.widget.options.action,
      headers: $props.widget.options.headers || [],
      ref: "fm-" + $props.widget.model,
      withCredentials: $props.widget.options.withCredentials,
      "print-read": $props.printRead,
      onOnUploadSuccess: $options.handleOnUploadSuccess,
      onOnUploadError: $options.handleOnUploadError,
      onOnUploadRemove: $options.handleOnUploadRemove,
      onOnUploadProgress: $options.handleOnUploadProgress,
      "on-select": $options.handleOnUploadSelect
    }, null, 8, ["modelValue", "disabled", "readonly", "style", "width", "height", "token", "domain", "multiple", "limit", "is-qiniu", "is-delete", "min", "is-edit", "action", "headers", "withCredentials", "print-read", "onOnUploadSuccess", "onOnUploadError", "onOnUploadRemove", "onOnUploadProgress", "on-select"])) : createCommentVNode("", true),
    $props.widget.type == "editor" ? (openBlock(), createElementBlock(Fragment, { key: 16 }, [
      $props.printRead ? (openBlock(), createElementBlock("div", {
        key: 0,
        innerHTML: $data.dataModel,
        class: "ql-editor"
      }, null, 8, _hoisted_4$6)) : (openBlock(), createBlock(_component_Editor, {
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => $data.dataModel = $event),
        "custom-style": { width: $props.isTable ? "100%" : $props.widget.options.width, cursor: $options.elementDisabled ? "no-drop" : "", backgroundColor: $options.elementDisabled ? "#F5F7FA" : "" },
        toolbar: $props.widget.options.customToolbar,
        disabled: $options.elementDisabled,
        ref: "fm-" + $props.widget.model
      }, null, 8, ["modelValue", "custom-style", "toolbar", "disabled"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "cascader" ? (openBlock(), createElementBlock(Fragment, { key: 17 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1($props.widget.options.multiple ? $data.dataModel.map((dm) => $options.getCascaderText([...dm], $data.remoteOptions).join(" / ")).join("\u3001") : $options.getCascaderText([...$data.dataModel], $data.remoteOptions).join(" / ")), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($props.widget.options.multiple ? $data.dataModel.map((dm) => $options.getCascaderText([...dm], $props.widget.options.options).join(" / ")).join("\u3001") : $options.getCascaderText([...$data.dataModel], $props.widget.options.options).join(" / ")), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_el_cascader, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        clearable: $props.widget.options.clearable,
        placeholder: $props.widget.options.placeholder,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        options: $props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options,
        onChange: $options.onCascaderChange,
        ref: "fm-" + $props.widget.model,
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur,
        props: $data.propsModel,
        "collapse-tags": "",
        filterable: $props.widget.options.filterable
      }, $props.widget.options.customProps), null, 16, ["modelValue", "disabled", "clearable", "placeholder", "style", "options", "onChange", "onFocus", "onBlur", "props", "filterable"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "treeselect" ? (openBlock(), createElementBlock(Fragment, { key: 18 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1(typeof $data.dataModel == "object" ? $data.dataModel.map((dm) => $options.getTreeText(dm, $data.remoteOptions)).join("\u3001") : $options.getTreeText($data.dataModel, $data.remoteOptions)), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1(typeof $data.dataModel == "object" ? $data.dataModel.map((dm) => $options.getTreeText(dm, $props.widget.options.options)).join("\u3001") : $options.getTreeText($data.dataModel, $props.widget.options.options)), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_el_tree_select, mergeProps({
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        clearable: $props.widget.options.clearable,
        placeholder: $props.widget.options.placeholder,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        data: $props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options,
        ref: "fm-" + $props.widget.model,
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur,
        multiple: $props.widget.options.multiple,
        "check-strictly": $props.widget.options.checkStrictly,
        filterable: $props.widget.options.filterable
      }, $props.widget.options.customProps), null, 16, ["modelValue", "disabled", "clearable", "placeholder", "style", "data", "onFocus", "onBlur", "multiple", "check-strictly", "filterable"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "text" ? (openBlock(), createElementBlock("span", {
      key: 19,
      ref: "fm-" + $props.widget.model,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width || "100%", display: "inline-block" })
    }, toDisplayString$1($data.dataModel), 5)) : createCommentVNode("", true),
    $props.widget.type == "html" ? (openBlock(), createElementBlock("span", {
      key: 20,
      innerHTML: $data.dataModel,
      ref: "fm-" + $props.widget.model,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width || "100%", display: "inline-block" })
    }, null, 12, _hoisted_5$6)) : createCommentVNode("", true),
    $props.widget.type == "table" ? (openBlock(), createBlock(_component_fm_form_table, {
      key: 21,
      value: $data.dataModel,
      "onUpdate:value": _cache[19] || (_cache[19] = ($event) => $data.dataModel = $event),
      columns: $props.widget.tableColumns,
      models: $data.dataModels,
      remote: $props.remote,
      blanks: $props.blanks,
      disableddata: $options.elementDisabled || $props.printRead,
      rules: $props.rules,
      name: $props.widget.model,
      "remote-option": $props.remoteOption,
      ref: "fm-" + $props.widget.model,
      preview: $props.preview,
      platform: $props.platform,
      "data-source-value": $props.dataSourceValue,
      "event-function": $props.eventFunction,
      widget: $props.widget,
      "print-read": $props.printRead,
      paging: $props.widget.options.paging,
      "page-size": $props.widget.options.pageSize,
      "is-delete": (_a2 = $props.widget.options.isDelete) != null ? _a2 : true,
      "is-add": (_b = $props.widget.options.isAdd) != null ? _b : true,
      "show-control": (_c = $props.widget.options.showControl) != null ? _c : true,
      "is-dialog": $props.isDialog,
      "dialog-name": $props.dialogName,
      "is-group": $props.isGroup,
      group: $props.group,
      "field-node": $props.fieldNode,
      "container-key": $props.containerKey
    }, createSlots({ _: 2 }, [
      renderList($props.blanks, (blank) => {
        return {
          name: blank.name,
          fn: withCtx((scope) => [
            renderSlot(_ctx.$slots, blank.name, {
              model: scope.model
            })
          ])
        };
      })
    ]), 1032, ["value", "columns", "models", "remote", "blanks", "disableddata", "rules", "name", "remote-option", "preview", "platform", "data-source-value", "event-function", "widget", "print-read", "paging", "page-size", "is-delete", "is-add", "show-control", "is-dialog", "dialog-name", "is-group", "group", "field-node", "container-key"])) : createCommentVNode("", true),
    $props.widget.type == "subform" ? (openBlock(), createBlock(_component_fm_sub_form, {
      key: 22,
      value: $data.dataModel,
      "onUpdate:value": _cache[20] || (_cache[20] = ($event) => $data.dataModel = $event),
      list: $props.widget.list,
      models: $data.dataModels,
      remote: $props.remote,
      blanks: $props.blanks,
      disableddata: $options.elementDisabled || $props.printRead,
      rules: $props.rules,
      name: $props.widget.model,
      "remote-option": $props.remoteOption,
      ref: "fm-" + $props.widget.model,
      preview: $props.preview,
      platform: $props.platform,
      "data-source-value": $props.dataSourceValue,
      "event-function": $props.eventFunction,
      widget: $props.widget,
      "print-read": $props.printRead,
      paging: $props.widget.options.paging,
      "page-size": $props.widget.options.pageSize,
      "show-control": $props.widget.options.showControl,
      "is-delete": (_d = $props.widget.options.isDelete) != null ? _d : true,
      "is-add": (_e = $props.widget.options.isAdd) != null ? _e : true,
      "is-dialog": $props.isDialog,
      "dialog-name": $props.dialogName,
      "is-group": $props.isGroup,
      group: $props.group,
      "field-node": $props.fieldNode,
      "container-key": $props.containerKey
    }, createSlots({ _: 2 }, [
      renderList($props.blanks, (blank) => {
        return {
          name: blank.name,
          fn: withCtx((scope) => [
            renderSlot(_ctx.$slots, blank.name, {
              model: scope.model
            })
          ])
        };
      })
    ]), 1032, ["value", "list", "models", "remote", "blanks", "disableddata", "rules", "name", "remote-option", "preview", "platform", "data-source-value", "event-function", "widget", "print-read", "paging", "page-size", "show-control", "is-delete", "is-add", "is-dialog", "dialog-name", "is-group", "group", "field-node", "container-key"])) : createCommentVNode("", true),
    $props.widget.type == "group" ? (openBlock(), createBlock(_component_fm_group, {
      key: 23,
      value: $data.dataModel,
      "onUpdate:value": _cache[21] || (_cache[21] = ($event) => $data.dataModel = $event),
      rules: $props.rules,
      element: $props.widget,
      remote: $props.remote,
      blanks: $props.blanks,
      edit: !$options.elementDisabled,
      "remote-option": $props.remoteOption,
      platform: $props.platform,
      preview: $props.preview,
      "container-key": $props.containerKey,
      "data-source-value": $props.dataSourceValue,
      "event-function": $props.eventFunction,
      "print-read": $props.printRead,
      ref: "fm-" + $props.widget.model,
      "is-group": $props.isGroup,
      group: $props.group,
      "field-node": $props.fieldNode
    }, createSlots({ _: 2 }, [
      renderList($props.blanks, (blank) => {
        return {
          name: blank.name,
          fn: withCtx((scope) => [
            renderSlot(_ctx.$slots, blank.name, {
              model: scope.model
            })
          ])
        };
      })
    ]), 1032, ["value", "rules", "element", "remote", "blanks", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-group", "group", "field-node"])) : createCommentVNode("", true),
    $props.widget.type == "fileupload" ? (openBlock(), createBlock(_component_fm_file_upload, {
      key: 24,
      modelValue: $data.dataModel,
      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => $data.dataModel = $event),
      disabled: $options.elementDisabled,
      style: normalizeStyle({ "width": $props.isTable ? "100%" : $props.widget.options.width }),
      token: $props.widget.options.token,
      domain: $props.widget.options.domain,
      multiple: $props.widget.options.multiple,
      limit: $props.widget.options.limit,
      "is-qiniu": $props.widget.options.isQiniu,
      min: $props.widget.options.min,
      action: $props.widget.options.action,
      headers: $props.widget.options.headers || [],
      ref: "fm-" + $props.widget.model,
      withCredentials: $props.widget.options.withCredentials,
      "print-read": $props.printRead,
      onOnUploadSuccess: $options.handleOnUploadSuccess,
      onOnUploadError: $options.handleOnUploadError,
      onOnUploadRemove: $options.handleOnUploadRemove,
      onOnUploadProgress: $options.handleOnUploadProgress,
      "on-select": $options.handleOnUploadSelect
    }, null, 8, ["modelValue", "disabled", "style", "token", "domain", "multiple", "limit", "is-qiniu", "min", "action", "headers", "withCredentials", "print-read", "onOnUploadSuccess", "onOnUploadError", "onOnUploadRemove", "onOnUploadProgress", "on-select"])) : createCommentVNode("", true),
    $props.widget.type == "button" ? (openBlock(), createBlock(_component_el_button, mergeProps({
      key: 25,
      disabled: $options.elementDisabled,
      size: $props.widget.options.buttonSize,
      type: $props.widget.options.buttonType == "text" || $props.widget.options.buttonType == "link" ? "primary" : $props.widget.options.buttonType,
      text: $props.widget.options.buttonType == "text",
      link: $props.widget.options.buttonType == "link",
      plain: $props.widget.options.buttonPlain,
      round: $props.widget.options.buttonRound,
      circle: $props.widget.options.buttonCircle,
      style: { width: $props.widget.options.width },
      ref: "fm-" + $props.widget.model
    }, $props.widget.options.customProps, { onClick: $options.handleOnClick }), {
      default: withCtx(() => [
        createTextVNode(toDisplayString$1($props.widget.options.buttonName), 1)
      ]),
      _: 1
    }, 16, ["disabled", "size", "type", "text", "link", "plain", "round", "circle", "style", "onClick"])) : createCommentVNode("", true),
    $props.widget.type == "link" ? (openBlock(), createBlock(_component_el_link, mergeProps({
      key: 26,
      disabled: $options.elementDisabled,
      type: $props.widget.options.linkType,
      underline: $props.widget.options.underline,
      href: $props.widget.options.href,
      target: $props.widget.options.blank ? "_blank" : "_self",
      ref: "fm-" + $props.widget.model,
      onClick: $options.handleOnClick,
      style: { width: $props.isTable ? "100%" : $props.widget.options.width }
    }, $props.widget.options.customProps), {
      default: withCtx(() => [
        createTextVNode(toDisplayString$1($props.widget.options.linkName), 1)
      ]),
      _: 1
    }, 16, ["disabled", "type", "underline", "href", "target", "onClick", "style"])) : createCommentVNode("", true),
    $props.widget.type == "steps" ? (openBlock(), createElementBlock(Fragment, { key: 27 }, [
      ($props.widget.options.remote ? $data.remoteOptions && $data.remoteOptions.length > 0 : true) ? (openBlock(), createBlock(_component_el_steps, mergeProps({
        key: 0,
        active: $data.dataModel,
        ref: "fm-" + $props.widget.model,
        space: $props.widget.options.space,
        direction: $props.widget.options.direction,
        "process-status": $props.widget.options.processStatus,
        "finish-status": $props.widget.options.finishStatus,
        "align-center": $props.widget.options.alignCenter,
        simple: $props.widget.options.simple,
        style: { "line-height": "normal" }
      }, $props.widget.options.customProps), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.widget.options.remote ? $data.remoteOptions : $props.widget.options.steps, (item, index2) => {
            return openBlock(), createBlock(_component_el_step, {
              title: $props.widget.options.remote ? item.value : item.title,
              description: $props.widget.options.remote ? item.label : item.description,
              key: index2
            }, null, 8, ["title", "description"]);
          }), 128))
        ]),
        _: 1
      }, 16, ["active", "space", "direction", "process-status", "finish-status", "align-center", "simple"])) : createCommentVNode("", true)
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "pagination" ? (openBlock(), createBlock(_component_el_pagination, mergeProps({
      key: 28,
      currentPage: $data.dataModel,
      "onUpdate:currentPage": _cache[23] || (_cache[23] = ($event) => $data.dataModel = $event),
      "page-size": $props.widget.options.pageSize,
      "pager-count": $props.widget.options.pagerCount,
      disabled: $props.widget.options.disabled,
      background: $props.widget.options.background,
      layout: "total, prev, pager, next",
      total: $props.widget.options.total,
      ref: "fm-" + $props.widget.model
    }, $props.widget.options.customProps), null, 16, ["currentPage", "page-size", "pager-count", "disabled", "background", "total"])) : createCommentVNode("", true),
    $props.widget.type == "transfer" ? (openBlock(), createElementBlock(Fragment, { key: 29 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1($data.dataModel.map((dm) => {
            var _a3;
            return (_a3 = $data.remoteOptions.find((item) => item[$props.widget.options.props.key] == dm)) == null ? void 0 : _a3[$props.widget.options.props.label];
          }).join("\u3001")), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($data.dataModel.map((dm) => {
            var _a3;
            return (_a3 = $props.widget.options.data.find((item) => item[$data.propsTransfer.key] == dm)) == null ? void 0 : _a3[$data.propsTransfer.label];
          }).join("\u3001")), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_el_transfer, mergeProps({
        key: 1,
        "model-value": $data.dataModel,
        disabled: $options.elementDisabled,
        data: $props.widget.options.remote ? $data.remoteOptions : $props.widget.options.data,
        filterable: $props.widget.options.filterable,
        props: $props.widget.options.remote ? $props.widget.options.props : $data.propsTransfer,
        titles: $props.widget.options.titles,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        ref: "fm-" + $props.widget.model,
        onChange: $options.handleTransferChange
      }, $props.widget.options.customProps), null, 16, ["model-value", "disabled", "data", "filterable", "props", "titles", "style", "onChange"]))
    ], 64)) : createCommentVNode("", true)
  ], 2);
}
var GenerateElementItem$2 = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$q]]);
var GenerateElementItem$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateElementItem$2
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$r = {
  components: {
    GenerateElementItem: GenerateElementItem$2
  },
  props: [
    "widget",
    "models",
    "rules",
    "remote",
    "blanks",
    "display",
    "edit",
    "remoteOption",
    "platform",
    "preview",
    "containerKey",
    "dataSourceValue",
    "eventFunction",
    "printRead",
    "isSubform",
    "rowIndex",
    "subName",
    "subHideFields",
    "subDisabledFields",
    "isDialog",
    "dialogName",
    "group",
    "fieldNode",
    "isGroup",
    "isTable",
    "isMobile",
    "tableName"
  ],
  data() {
    return {
      dataModel: this.models[this.widget.model],
      dataModels: this.models
    };
  },
  computed: {
    ruleProp() {
      let currentProp = this.widget.model;
      if (this.group) {
        currentProp = this.group + "." + currentProp;
      }
      return currentProp;
    },
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model) || this.formHideFields.includes(this.group ? this.group + "." + this.widget.model : this.widget.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: {
    setSubformData: {
      default: () => {
      }
    },
    setDialogData: {
      default: () => {
      }
    },
    setGroupData: {
      default: () => {
      }
    },
    setTableData: {
      default: () => {
      }
    },
    onChange: {
      default: () => {
      }
    },
    formHideFields: {
      default: []
    }
  },
  methods: {},
  watch: {
    dataModel: {
      deep: true,
      handler(val) {
        var _a2, _b, _c, _d;
        if (this.isTable) {
          this.setTableData(val, this.rowIndex, this.widget.model);
        } else if (this.isSubform) {
          this.setSubformData(val, this.rowIndex, this.widget.model);
        } else if (this.isDialog) {
          this.setDialogData(val, this.widget.model);
        } else if (this.isGroup) {
          this.setGroupData(val, this.widget.model);
        } else {
          this.onChange(val, this.widget.model);
        }
        if (this.widget.events && this.widget.events.onChange && this.$refs["generateElementItem"]) {
          let funcKey = this.widget.events.onChange;
          if (this.isTable) {
            this.eventFunction[funcKey]({
              value: val,
              field: this.widget.model,
              rowIndex: this.rowIndex,
              table: this.tableName,
              dialog: this.isDialog ? this.dialogName : null,
              currentRef: (_a2 = this.$refs["generateElementItem"]) == null ? void 0 : _a2.$refs[`fm-${this.widget.model}`],
              group: this.group,
              fieldNode: this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model
            });
          } else if (this.isSubform) {
            this.eventFunction[funcKey]({
              value: val,
              field: this.widget.model,
              rowIndex: this.rowIndex,
              subform: this.subName,
              dialog: this.isDialog ? this.dialogName : null,
              currentRef: (_b = this.$refs["generateElementItem"]) == null ? void 0 : _b.$refs[`fm-${this.widget.model}`],
              group: this.group,
              fieldNode: this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model
            });
          } else if (this.isDialog) {
            this.eventFunction[funcKey]({
              value: val,
              field: this.widget.model,
              dialog: this.dialogName,
              currentRef: (_c = this.$refs["generateElementItem"]) == null ? void 0 : _c.$refs[`fm-${this.widget.model}`],
              group: this.group,
              fieldNode: this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model
            });
          } else {
            this.eventFunction[funcKey]({
              value: val,
              field: this.widget.model,
              currentRef: (_d = this.$refs["generateElementItem"]) == null ? void 0 : _d.$refs[`fm-${this.widget.model}`],
              group: this.group,
              fieldNode: this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model
            });
          }
        }
      }
    },
    models: {
      deep: true,
      handler(val) {
        this.dataModels = val;
        this.dataModel = val[this.widget.model];
      }
    }
  }
};
const _hoisted_1$b = ["data-id"];
const _hoisted_2$a = ["innerHTML"];
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_element_item = resolveComponent("generate-element-item");
  const _component_el_form_item = resolveComponent("el-form-item");
  const _component_el_divider = resolveComponent("el-divider");
  const _component_el_alert = resolveComponent("el-alert");
  return $props.widget.key ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "fm-form-item",
    "data-id": $props.widget.model
  }, [
    $props.widget.type != "divider" && $props.widget.type != "alert" && $options.elementDisplay ? (openBlock(), createBlock(_component_el_form_item, {
      prop: $props.fieldNode ? $props.fieldNode + "." + $props.widget.model : $props.widget.model,
      rules: $props.rules[$options.ruleProp],
      class: normalizeClass({
        [$props.widget.options && $props.widget.options.customClass]: $props.widget.options && $props.widget.options.customClass ? true : false,
        "no-label-form-item": $props.widget.options.isLabelWidth && $props.widget.options.labelWidth == 0,
        "fm-label-wrap": $props.widget.options.labelWrap
      }),
      label: $props.widget.options.hideLabel || $props.isTable && !$props.isMobile ? "" : $props.widget.name,
      "label-width": $props.widget.options.hideLabel ? "0px" : $props.widget.options.isLabelWidth ? $props.widget.options.labelWidth + "px" : "",
      key: $props.widget.key,
      required: $props.widget.options.required,
      ref: "generateFormItem"
    }, {
      default: withCtx(() => [
        $props.widget.options.tip ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "fm-item-tooltip",
          innerHTML: $props.widget.options.tip.replace(/\n/g, "<br/>")
        }, null, 8, _hoisted_2$a)) : createCommentVNode("", true),
        (openBlock(), createBlock(_component_generate_element_item, {
          blanks: $props.blanks,
          "is-table": $props.isTable,
          "table-name": $props.tableName,
          widget: $props.widget,
          models: $data.dataModels,
          remote: $props.remote,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          key: $props.widget.key,
          rules: $props.rules,
          modelValue: $data.dataModel,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.dataModel = $event),
          platform: $props.platform,
          preview: $props.preview,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-subform": $props.isSubform,
          "row-index": $props.rowIndex,
          "sub-name": $props.subName,
          "is-dialog": $props.isDialog,
          "dialog-name": $props.dialogName,
          ref: "generateElementItem",
          "container-key": $props.containerKey,
          "is-group": $props.isGroup,
          group: $props.group,
          "field-node": $props.fieldNode ? $props.fieldNode + "." + $props.widget.model : $props.widget.model
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["blanks", "is-table", "table-name", "widget", "models", "remote", "edit", "remote-option", "rules", "modelValue", "platform", "preview", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "container-key", "is-group", "group", "field-node"]))
      ]),
      _: 3
    }, 8, ["prop", "rules", "class", "label", "label-width", "required"])) : createCommentVNode("", true),
    $props.widget.type == "divider" && $options.elementDisplay ? (openBlock(), createBlock(_component_el_form_item, {
      key: 1,
      "label-width": "0"
    }, {
      default: withCtx(() => [
        createVNode(_component_el_divider, mergeProps({
          "content-position": $props.widget.options.contentPosition
        }, $props.widget.options.customProps, { style: { "margin-bottom": "10px" } }), {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1($props.widget.name), 1)
          ]),
          _: 1
        }, 16, ["content-position"])
      ]),
      _: 1
    })) : createCommentVNode("", true),
    $props.widget.type == "alert" && $options.elementDisplay ? (openBlock(), createBlock(_component_el_form_item, {
      key: 2,
      "label-width": "0"
    }, {
      default: withCtx(() => [
        createVNode(_component_el_alert, mergeProps({
          title: $props.widget.options.title,
          type: $props.widget.options.type,
          description: $props.widget.options.description,
          closable: $props.widget.options.closable,
          center: $props.widget.options.center,
          "show-icon": $props.widget.options.showIcon,
          effect: $props.widget.options.effect,
          style: { width: $props.widget.options.width }
        }, $props.widget.options.customProps, {
          onClose: _cache[1] || (_cache[1] = ($event) => $props.display[$props.widget.model] = false)
        }), null, 16, ["title", "type", "description", "closable", "center", "show-icon", "effect", "style"])
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ], 8, _hoisted_1$b)) : createCommentVNode("", true);
}
var GenerateFormItem$2 = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$p]]);
var GenerateFormItem$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateFormItem$2
}, Symbol.toStringTag, { value: "Module" }));
var GenerateInline_vue_vue_type_style_index_0_lang = "";
const _sfc_main$q = {
  name: "generate-inline",
  components: {
    GenerateFormItem: GenerateFormItem$2
  },
  props: ["element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  data() {
    return {
      dataModels: this.model
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {},
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = this.model;
      }
    }
  }
};
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_form_item = resolveComponent("generate-form-item");
  return $options.elementDisplay ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["fm-inline-container", {
      [$props.element.options && $props.element.options.customClass]: $props.element.options && $props.element.options.customClass ? true : false
    }])
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.list, (item) => {
      return openBlock(), createBlock(_component_generate_form_item, {
        key: item.key,
        models: $data.dataModels,
        rules: $props.rules,
        widget: item,
        remote: $props.remote,
        blanks: $props.blanks,
        display: $props.display,
        "sub-hide-fields": $props.subHideFields,
        "sub-disabled-fields": $props.subDisabledFields,
        edit: $props.edit,
        "remote-option": $props.remoteOption,
        platform: $props.platform,
        preview: $props.preview,
        "container-key": $props.containerKey,
        "data-source-value": $props.dataSourceValue,
        "event-function": $props.eventFunction,
        "print-read": $props.printRead,
        style: normalizeStyle({ "margin-right": $props.element.options.spaceSize + "px" }),
        "is-subform": $props.isSubform,
        "row-index": $props.rowIndex,
        "sub-name": $props.subName,
        "is-dialog": $props.isDialog,
        "dialog-name": $props.dialogName,
        "is-group": $props.isGroup,
        group: $props.group,
        "field-node": $props.fieldNode
      }, createSlots({ _: 2 }, [
        renderList($props.blanks, (blank) => {
          return {
            name: blank.name,
            fn: withCtx((scope) => [
              renderSlot(_ctx.$slots, blank.name, {
                model: scope.model
              })
            ])
          };
        })
      ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "style", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]);
    }), 128))
  ], 2)) : createCommentVNode("", true);
}
var GenerateInline$1 = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$o]]);
var GenerateInline$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateInline$1
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$p = {
  name: "generate-col-item",
  components: {
    GenerateFormItem: GenerateFormItem$2,
    GenerateInline: GenerateInline$1,
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$3;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$3;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$3;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$3;
    }))
  },
  props: ["element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  data() {
    return {
      dataModels: this.model,
      hideCols: []
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {
    getColXS(options) {
      if (this.preview) {
        if (this.platform == "pc") {
          return options.md;
        }
        if (this.platform == "pad") {
          return options.sm;
        }
        if (this.platform == "mobile") {
          return options.xs;
        }
      } else {
        return options.xs;
      }
    },
    getColSM(options) {
      if (this.preview) {
        if (this.platform == "pc") {
          return options.md;
        }
        if (this.platform == "pad") {
          return options.sm;
        }
        if (this.platform == "mobile") {
          return options.xs;
        }
      } else {
        return options.sm;
      }
    },
    getColMD(options) {
      if (this.preview) {
        if (this.platform == "pc") {
          return options.md;
        }
        if (this.platform == "pad") {
          return options.sm;
        }
        if (this.platform == "mobile") {
          return options.xs;
        }
      } else {
        return options.md;
      }
    },
    hideCol(index2) {
      !this.hideCols.includes(index2) && this.hideCols.push(index2);
    },
    displayCol(index2) {
      if (this.hideCols.includes(index2)) {
        this.hideCols.splice(this.hideCols.indexOf(index2), 1);
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = val;
      }
    }
  }
};
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item", true);
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_el_col = resolveComponent("el-col");
  const _component_el_row = resolveComponent("el-row");
  return $options.elementDisplay ? (openBlock(), createBlock(_component_el_row, {
    key: 0,
    class: normalizeClass({
      [$props.element.options && $props.element.options.customClass]: $props.element.options && $props.element.options.customClass ? true : false
    }),
    type: $props.element.options.flex ? "flex" : "",
    gutter: $props.element.options.gutter || 0,
    justify: $props.element.options.justify,
    align: $props.element.options.align
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.columns, (item, index2) => {
        return openBlock(), createElementBlock(Fragment, { key: index2 }, [
          !$data.hideCols.includes(index2) ? (openBlock(), createBlock(_component_el_col, {
            key: 0,
            span: item.options ? $options.getColMD(item.options) : item.span,
            xs: item.options ? $options.getColXS(item.options) : item.span,
            sm: item.options ? $options.getColSM(item.options) : item.span,
            md: item.options ? $options.getColMD(item.options) : item.span,
            lg: item.options ? $options.getColMD(item.options) : item.span,
            xl: item.options ? $options.getColMD(item.options) : item.span,
            offset: item.options ? item.options.offset : 0,
            push: item.options ? item.options.push : 0,
            pull: item.options ? item.options.pull : 0,
            class: normalizeClass({
              [item.options && item.options.customClass]: item.options && item.options.customClass ? true : false
            })
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(item.list, (col) => {
                return openBlock(), createElementBlock(Fragment, null, [
                  col.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                    key: col.key,
                    models: $data.dataModels,
                    rules: $props.rules,
                    widget: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
                ], 64);
              }), 256))
            ]),
            _: 2
          }, 1032, ["span", "xs", "sm", "md", "lg", "xl", "offset", "push", "pull", "class"])) : createCommentVNode("", true)
        ], 64);
      }), 128))
    ]),
    _: 3
  }, 8, ["class", "type", "gutter", "justify", "align"])) : createCommentVNode("", true);
}
var GenerateColItem$2 = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$n]]);
var GenerateColItem$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateColItem$2
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$o = {
  name: "generate-tab-item",
  components: {
    GenerateFormItem: GenerateFormItem$2,
    GenerateInline: GenerateInline$1,
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$3;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$3;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$3;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$3;
    }))
  },
  props: ["element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  data() {
    return {
      dataModels: this.model,
      tabActive: this.element.tabs.length ? this.element.tabs[0].name : ""
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {
    activateTab(label) {
      const currentTab = this.element.tabs.find((item) => item.label == label);
      if (currentTab) {
        this.tabActive = currentTab.name;
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = this.model;
      }
    }
  }
};
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_tab_item = resolveComponent("generate-tab-item", true);
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_el_tab_pane = resolveComponent("el-tab-pane");
  const _component_el_tabs = resolveComponent("el-tabs");
  return $options.elementDisplay ? (openBlock(), createBlock(_component_el_tabs, {
    key: 0,
    modelValue: $data.tabActive,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.tabActive = $event),
    type: $props.element.options.type,
    "tab-position": $props.element.options.tabPosition,
    class: normalizeClass({
      [$props.element.options.customClass]: $props.element.options.customClass ? true : false
    }),
    style: { "margin-bottom": "18px" }
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.tabs, (item) => {
        return openBlock(), createBlock(_component_el_tab_pane, {
          key: item.name,
          label: item.label,
          name: item.name
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(item.list, (tab) => {
              return openBlock(), createElementBlock(Fragment, {
                key: tab.key
              }, [
                tab.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                  key: 0,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                  key: 1,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                  key: 2,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                  key: 3,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                  key: 4,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                  key: 5,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                  key: 6,
                  models: $data.dataModels,
                  rules: $props.rules,
                  widget: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
              ], 64);
            }), 128))
          ]),
          _: 2
        }, 1032, ["label", "name"]);
      }), 128))
    ]),
    _: 3
  }, 8, ["modelValue", "type", "tab-position", "class"])) : createCommentVNode("", true);
}
var GenerateTabItem$2 = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$m]]);
var GenerateTabItem$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateTabItem$2
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$n = {
  name: "generate-report",
  components: {
    GenerateFormItem: GenerateFormItem$2,
    GenerateInline: GenerateInline$1,
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$3;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$3;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$3;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$3;
    }))
  },
  props: ["element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  data() {
    return {
      dataModels: this.model
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {},
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = this.model;
      }
    }
  }
};
const _hoisted_1$a = { class: "fm-report-table__wrapper" };
const _hoisted_2$9 = ["colspan", "rowspan"];
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_report = resolveComponent("generate-report", true);
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    $options.elementDisplay ? (openBlock(), createElementBlock("table", {
      key: 0,
      class: normalizeClass(["fm-report-table__table", {
        [$props.element.options && $props.element.options.customClass]: $props.element.options && $props.element.options.customClass ? true : false
      }]),
      style: normalizeStyle({
        "border-top-width": $props.element.options.borderWidth + "px",
        "border-top-color": $props.element.options.borderColor,
        "border-left-width": $props.element.options.borderWidth + "px",
        "border-left-color": $props.element.options.borderColor,
        "width": $props.element.options.width || "auto"
      })
    }, [
      createElementVNode("tr", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.headerRow, (th, i) => {
          return openBlock(), createElementBlock("th", {
            key: i,
            style: normalizeStyle({
              "width": th.options.width,
              "height": 0,
              "padding": 0
            })
          }, null, 4);
        }), 128))
      ]),
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.rows, (row, rIndex) => {
        return openBlock(), createElementBlock("tr", { key: rIndex }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(row.columns, (column, i) => {
            return openBlock(), createElementBlock(Fragment, {
              key: rIndex + "-" + i
            }, [
              !column.options.invisible ? (openBlock(), createElementBlock("td", {
                key: 0,
                style: normalizeStyle({
                  "border-right-width": $props.element.options.borderWidth + "px",
                  "border-right-color": $props.element.options.borderColor,
                  "border-bottom-width": $props.element.options.borderWidth + "px",
                  "border-bottom-color": $props.element.options.borderColor,
                  "width": column.options.width,
                  "height": column.options.height || "40px",
                  "min-height": "40px"
                }),
                colspan: column.options.colspan,
                rowspan: column.options.rowspan,
                class: normalizeClass(["fm-report-table__td", {
                  [column.options.customClass]: column.options.customClass ? true : false
                }]),
                valign: "top"
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(column.list, (columnElement) => {
                  return openBlock(), createElementBlock(Fragment, {
                    key: columnElement.key
                  }, [
                    columnElement.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                      key: 0,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                      key: 1,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                      key: 2,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                      key: 3,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                      key: 4,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                      key: 5,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                      key: 6,
                      models: $data.dataModels,
                      rules: $props.rules,
                      widget: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
                  ], 64);
                }), 128))
              ], 14, _hoisted_2$9)) : createCommentVNode("", true)
            ], 64);
          }), 128))
        ]);
      }), 128))
    ], 6)) : createCommentVNode("", true)
  ]);
}
var GenerateReport$2 = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$l]]);
var GenerateReport$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateReport$2
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$m = {
  name: "generate-collapse",
  components: {
    GenerateFormItem: GenerateFormItem$2,
    GenerateInline: GenerateInline$1,
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$3;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$3;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$3;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$3;
    }))
  },
  props: ["element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  data() {
    return {
      dataModels: this.model,
      tabActive: this.element.tabs.length ? [this.element.tabs[0].name] : ""
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {
    activateCollapse(title) {
      if (typeof title === "string") {
        const currentCollapse = this.element.tabs.find((item) => item.title == title);
        if (currentCollapse) {
          this.tabActive = currentCollapse.name;
        }
      }
      if (typeof title === "object" && Array.isArray(title)) {
        const collapses = title.map((item) => {
          const current = this.element.tabs.find((iitem) => iitem.title == item);
          if (current) {
            return current.name;
          }
          return "";
        });
        this.tabActive = collapses;
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = this.model;
      }
    }
  }
};
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse", true);
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_el_collapse_item = resolveComponent("el-collapse-item");
  const _component_el_collapse = resolveComponent("el-collapse");
  return $options.elementDisplay ? (openBlock(), createBlock(_component_el_collapse, {
    key: 0,
    modelValue: $data.tabActive,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.tabActive = $event),
    accordion: $props.element.options.accordion,
    class: normalizeClass({
      [$props.element.options.customClass]: $props.element.options.customClass ? true : false
    }),
    style: { "margin-bottom": "18px" }
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.tabs, (item) => {
        return openBlock(), createBlock(_component_el_collapse_item, {
          key: item.name,
          title: item.title,
          name: item.name
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(item.list, (tab) => {
              return openBlock(), createElementBlock(Fragment, {
                key: tab.key
              }, [
                tab.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                  key: 0,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                  key: 1,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                  key: 2,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                  key: 3,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                  key: 4,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                  key: 5,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                  key: 6,
                  models: $data.dataModels,
                  rules: $props.rules,
                  widget: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
              ], 64);
            }), 128))
          ]),
          _: 2
        }, 1032, ["title", "name"]);
      }), 128))
    ]),
    _: 3
  }, 8, ["modelValue", "accordion", "class"])) : createCommentVNode("", true);
}
var GenerateCollapse$2 = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$k]]);
var GenerateCollapse$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateCollapse$2
}, Symbol.toStringTag, { value: "Module" }));
var GenerateCard_vue_vue_type_style_index_0_lang$1 = "";
const __default__$2 = {
  name: "generate-card",
  components: {
    GenerateFormItem: GenerateFormItem$2,
    GenerateInline: GenerateInline$1,
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$3;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$3;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$3;
    })),
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$3;
    }))
  },
  props: ["element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  data() {
    return {
      dataModels: this.model
    };
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  computed: {
    padding() {
      return this.element.options.padding || "20px";
    },
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {},
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = val;
      }
    }
  }
};
const __injectCSSVars__$2 = () => {
  useCssVars((_ctx) => ({
    "18bd0dba": _ctx.padding
  }));
};
const __setup__$2 = __default__$2.setup;
__default__$2.setup = __setup__$2 ? (props2, ctx) => {
  __injectCSSVars__$2();
  return __setup__$2(props2, ctx);
} : __injectCSSVars__$2;
const _sfc_main$l = __default__$2;
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b;
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_card = resolveComponent("generate-card", true);
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_el_card = resolveComponent("el-card");
  return $options.elementDisplay ? (openBlock(), createBlock(_component_el_card, {
    key: 0,
    shadow: $props.element.options.shadow,
    "body-style": {
      padding: $props.element.options.padding
    },
    style: normalizeStyle({
      width: $props.element.options.width,
      "border-width": $props.element.options.bordered ? "1px" : "0px"
    }),
    class: normalizeClass({
      [(_a2 = $props.element.options) == null ? void 0 : _a2.customClass]: ((_b = $props.element.options) == null ? void 0 : _b.customClass) ? true : false
    })
  }, createSlots({
    default: withCtx(() => [
      createElementVNode("div", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.list, (item) => {
          return openBlock(), createElementBlock(Fragment, null, [
            item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
              key: item.key,
              models: $data.dataModels,
              rules: $props.rules,
              widget: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
          ], 64);
        }), 256))
      ])
    ]),
    _: 2
  }, [
    $props.element.options.showHeader ? {
      name: "header",
      fn: withCtx(() => [
        createElementVNode("div", null, [
          createElementVNode("span", null, toDisplayString$1($props.element.options.title), 1)
        ])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["shadow", "body-style", "style", "class"])) : createCommentVNode("", true);
}
var GenerateCard$2 = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$j]]);
var GenerateCard$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateCard$2
}, Symbol.toStringTag, { value: "Module" }));
var GenerateDialog_vue_vue_type_style_index_0_lang$1 = "";
const _sfc_main$k = {
  name: "generate-dialog",
  components: {
    GenerateColItem: GenerateColItem$2,
    GenerateFormItem: GenerateFormItem$2,
    GenerateInline: GenerateInline$1,
    GenerateReport: GenerateReport$2,
    GenerateTabItem: GenerateTabItem$2,
    GenerateCollapse: GenerateCollapse$2,
    GenerateCard: GenerateCard$2
  },
  props: ["models", "rules", "element", "remote", "blanks", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "group", "fieldNode"],
  data() {
    var _a2;
    return {
      visible: this.element.options.visible,
      displayFields: {},
      dialogModel: (_a2 = this.models[this.element.model]) != null ? _a2 : {},
      dialogDisabled: {}
    };
  },
  emits: ["update:models"],
  inject: ["generateComponentInstance", "deleteComponentInstance", "getFormComponent", "onFormHide", "onFormDisplay"],
  created() {
    this._generateModel(this.element.list);
  },
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.element.model, this.$refs[`generate-dialog-${this.element.model}`].$parent);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.element.model);
  },
  provide() {
    return {
      "setDialogData": this.setDialogData
    };
  },
  methods: {
    setDialogData(value, field) {
      this.dialogModel[field] = value;
    },
    _generateModel(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type == "grid") {
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          genList[i].columns.forEach((item) => {
            this._generateModel(item.list);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._generateModel(column.list);
            });
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "inline") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "card") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else {
          if (genList[i].type == "blank") {
            this.dialogModel[genList[i].model] = genList[i].options.defaultType === "String" ? "" : genList[i].options.defaultType === "Object" ? {} : [];
          } else {
            this.dialogModel[genList[i].model] = _.cloneDeep(genList[i].options.defaultValue);
          }
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          this.dialogDisabled[genList[i].model] = !genList[i].options.disabled;
        }
      }
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${field}`);
      });
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${field}`);
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setDisabled(this.element.list, fields, disabled);
    },
    validate() {
      return new Promise((resolve, reject) => {
        let realFields = this._getAllRuleFields();
        this.getFormComponent().validateField(realFields, (valid, error) => {
          if (valid) {
            resolve();
          } else {
            reject(error);
          }
        });
      });
    },
    handleCancel() {
      if (this.element && this.element.events && this.element.events.onCancel) {
        let funcKey = this.element.events.onCancel;
        this.eventFunction[funcKey]({
          field: this.element.model,
          currentRef: this
        });
      }
    },
    handleConfirm() {
      if (this.element && this.element.events && this.element.events.onConfirm) {
        let funcKey = this.element.events.onConfirm;
        this.eventFunction[funcKey]({
          field: this.element.model,
          currentRef: this
        });
      }
    },
    confirmLoading(status) {
      this.element.options.confirmLoading = status;
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setOptions(this.element.list, fields, options);
    },
    setData(value) {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            this.dialogModel[item] = value[item];
          });
          resolve();
        });
      });
    },
    getValues() {
      return this.dialogModel;
    },
    getValue(fieldName) {
      return this.dialogModel[fieldName];
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.element.list, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.element.list, item.split("."), className, "remove");
      });
    },
    _setDisabled(genList, fields, disabled) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setDisabled(column.list, fields, disabled);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else if (genList[i].type === "card") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else {
          if (fields.indexOf(genList[i].model) >= 0) {
            genList[i].options.disabled = disabled;
          }
        }
      }
    },
    _setOptions(genList, fields, opts) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setOptions(column.list, fields, opts);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setOptions(genList[i].list, fields, opts);
        } else if (genList[i].type === "card") {
          this._setOptions(genList[i].list, fields, opts);
        }
        if (fields.indexOf(genList[i].model) >= 0) {
          Object.keys(opts).forEach((key) => {
            genList[i].options[key] = opts[key];
          });
        }
      }
    },
    _getAllRuleFields() {
      let realFields = [];
      Object.keys(this.dialogModel).forEach((v) => {
        if (Array.isArray(this.dialogModel[v])) {
          const currentArray = this.dialogModel[v];
          currentArray.forEach((o, i) => {
            Object.keys(o).forEach((key) => {
              realFields.push(`${this.element.model}.${v}.${i}.${key}`);
            });
          });
        } else {
          realFields.push(`${this.element.model}.${v}`);
        }
      });
      return realFields;
    }
  },
  watch: {
    dialogModel: {
      deep: true,
      handler(val) {
        this.$emit("update:models", {
          ...this.models,
          [this.element.model]: val
        });
      }
    },
    models: {
      deep: true,
      handler(val) {
        this.dialogModel = this.models[this.element.model];
      }
    }
  }
};
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_dialog = resolveComponent("el-dialog");
  return openBlock(), createBlock(_component_el_dialog, {
    modelValue: $data.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.visible = $event),
    title: $props.element.options.title,
    width: $props.element.options.width || "50%",
    top: $props.element.options.top || "15vh",
    "close-on-click-modal": false,
    "show-close": $props.element.options.showClose,
    center: $props.element.options.center,
    "destroy-on-close": "",
    ref: `generate-dialog-${$props.element.model}`,
    class: normalizeClass(["fm-generate-dialog", {
      [$props.element.options && $props.element.options.customClass]: $props.element.options && $props.element.options.customClass ? true : false
    }])
  }, createSlots({
    default: withCtx(() => [
      createElementVNode("div", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.list, (item) => {
          return openBlock(), createElementBlock(Fragment, null, [
            item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "group", "field-node"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "group", "field-node"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "group", "field-node"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "group", "field-node"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "group", "field-node"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
              key: item.key,
              models: $data.dialogModel,
              rules: $props.rules,
              widget: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "group", "field-node"]))
          ], 64);
        }), 256))
      ])
    ]),
    _: 2
  }, [
    $props.element.options.showCancel || $props.element.options.showOk ? {
      name: "footer",
      fn: withCtx(() => [
        createElementVNode("div", null, [
          $props.element.options.showCancel ? (openBlock(), createBlock(_component_el_button, {
            key: 0,
            onClick: $options.handleCancel
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1($props.element.options.cancelText), 1)
            ]),
            _: 1
          }, 8, ["onClick"])) : createCommentVNode("", true),
          $props.element.options.showOk ? (openBlock(), createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            loading: $props.element.options.confirmLoading,
            onClick: $options.handleConfirm
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString$1($props.element.options.okText), 1)
            ]),
            _: 1
          }, 8, ["loading", "onClick"])) : createCommentVNode("", true)
        ])
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["modelValue", "title", "width", "top", "show-close", "center", "class"]);
}
var GenerateDialog$1 = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$i]]);
const loadJspdf = () => {
  return new Promise((resolve, reject) => {
    if (window.FormMaking_OPTIONS.jsPDF) {
      resolve(window.FormMaking_OPTIONS.jsPDF);
    } else if (window.jspdf) {
      resolve(window.jspdf.jsPDF);
    } else {
      reject("jsPDF not found");
    }
  });
};
const loadHtml2canvas = () => {
  return new Promise((resolve, reject) => {
    if (window.FormMaking_OPTIONS.html2canvas) {
      resolve(window.FormMaking_OPTIONS.html2canvas);
    } else if (window.html2canvas) {
      resolve(window.html2canvas);
    } else {
      reject("html2canvas not found");
    }
  });
};
const exportPDF = (content) => {
  return new Promise((resolve, reject) => {
    loadJspdf().then((jsPDF) => {
      loadHtml2canvas().then((html2canvas) => {
        const pdf = new jsPDF("p", "pt", "a4");
        html2canvas(content, {
          dpi: 192,
          scale: 4,
          allowTaint: true,
          useCORS: true
        }).then((canvas) => {
          let context = canvas.getContext("2d");
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          const marginLeft = 20;
          const marginRight = 20;
          const marginTop = 20;
          const marginBottom = 30;
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const contentWidth = pageWidth - marginLeft - marginRight;
          const contentHeight = pageHeight - marginTop - marginBottom;
          const imgWidth = contentWidth;
          const imgHeight = canvas.height * imgWidth / canvas.width;
          let leftHeight = imgHeight;
          let currentPage = 1;
          if (leftHeight < contentHeight) {
            let imgData = canvas.toDataURL("image/jpeg");
            pdf.addImage(imgData, "JPEG", marginLeft, marginRight, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              let croppWidth = canvas.width;
              let croppHeight = croppWidth * contentHeight / contentWidth;
              const croppedCanvas = document.createElement("canvas");
              const ctx = croppedCanvas.getContext("2d");
              ctx.mozImageSmoothingEnabled = false;
              ctx.webkitImageSmoothingEnabled = false;
              ctx.msImageSmoothingEnabled = false;
              ctx.imageSmoothingEnabled = false;
              croppedCanvas.width = croppWidth;
              croppedCanvas.height = croppHeight;
              let remainHeight = canvas.height - (currentPage - 1) * croppHeight;
              if (remainHeight < croppHeight) {
                croppedCanvas.height = remainHeight;
                ctx.drawImage(canvas, 0, (currentPage - 1) * croppHeight, canvas.width, remainHeight, 0, 0, croppWidth, remainHeight);
                let imgData = croppedCanvas.toDataURL("image/jpeg");
                pdf.addImage(imgData, "JPEG", marginLeft, marginTop, contentWidth, contentHeight / croppHeight * remainHeight);
              } else {
                ctx.drawImage(canvas, 0, (currentPage - 1) * croppHeight, canvas.width, croppHeight, 0, 0, croppWidth, croppHeight);
                let imgData = croppedCanvas.toDataURL("image/jpeg");
                pdf.addImage(imgData, "JPEG", marginLeft, marginTop, contentWidth, contentHeight);
              }
              leftHeight -= contentHeight;
              if (leftHeight > 0) {
                pdf.addPage();
                currentPage++;
              }
            }
          }
          const footerText = "Powered by FormMaking - https://form.making.link";
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setTextColor(144, 147, 153);
            pdf.setFontSize(10);
            pdf.text(footerText, pageWidth - 240, pageHeight - 10);
          }
          resolve(pdf.output("blob"));
        }).catch(() => {
          reject();
        });
      }).catch((error) => reject(error));
    }).catch((error) => reject(error));
  });
};
const ruleToFuncString = (rule) => {
  var _a2;
  const condition = ((_a2 = rule.options) == null ? void 0 : _a2.isCondition) ? ` if (${rule.options.condition || "false"}) ` : "";
  if (rule.action == "hide") {
    return `${condition} this.hide(${JSON.stringify(rule.options.fields)});`;
  }
  if (rule.action == "display") {
    return `${condition} this.display(${JSON.stringify(rule.options.fields)});`;
  }
  if (rule.action == "disabled") {
    return `${condition} this.disabled(${JSON.stringify(rule.options.fields)}, ${rule.options.disabled});`;
  }
  if (rule.action == "refresh") {
    return `${condition} await this.refresh();`;
  }
  if (rule.action == "reset") {
    return `${condition} this.reset();`;
  }
  if (rule.action == "setData") {
    const setField = rule.options.fields.map((item) => {
      var _a3, _b;
      if (rule.options.valueTypes[item] == "fx") {
        return `'${item}' : ${rule.options.values[item] || JSON.stringify("")}`;
      } else if (rule.options.valueTypes[item] == "boolean") {
        return `'${item}' : ${(_a3 = rule.options.values[item]) != null ? _a3 : false}`;
      } else if (rule.options.valueTypes[item] == "number") {
        return `'${item}' : ${rule.options.values[item] || void 0}`;
      } else {
        return `'${item}' : ${JSON.stringify((_b = rule.options.values[item]) != null ? _b : JSON.stringify(""))}`;
      }
    });
    return `${condition} await this.setData({${setField.join(",")}});`;
  }
  if (rule.action == "validate") {
    if (rule.options.failSuspend) {
      return `${condition} await this.validate(${JSON.stringify(rule.options.fields)});`;
    } else {
      return `${condition} this.validate(${JSON.stringify(rule.options.fields)});`;
    }
  }
  if (rule.action == "sendRequest") {
    if (!rule.options.dataSource)
      return "";
    let argsArray = Object.keys(rule.options.dataSource.args).map((argKey) => {
      var _a3;
      if (rule.options.valueTypes[argKey] == "fx") {
        return `'${argKey}' : ${rule.options.dataSource.args[argKey] || JSON.stringify("")}`;
      } else if (rule.options.valueTypes[argKey] == "boolean") {
        return `'${argKey}' : ${rule.options.dataSource.args[argKey]}`;
      } else if (rule.options.valueTypes[argKey] == "number") {
        return `'${argKey}' : ${rule.options.dataSource.args[argKey] || void 0}`;
      } else {
        return `'${argKey}' : ${JSON.stringify((_a3 = rule.options.dataSource.args[argKey]) != null ? _a3 : JSON.stringify(""))}`;
      }
    });
    if (rule.options.responseVariable) {
      let responseStatement = ` let ${rule.options.responseVariable} = undefined;`;
      return `${responseStatement} ${condition} ${rule.options.responseVariable} = await this.sendRequest('${rule.options.dataSource.label}', {${argsArray.join(",")}});`;
    } else {
      return `${condition} await this.sendRequest('${rule.options.dataSource.label}', {${argsArray.join(",")}});`;
    }
  }
  if (rule.action == "refreshFieldDataSource") {
    if (!rule.options.field)
      return "";
    let argsArray = Object.keys(rule.options.dataSource.args).map((argKey) => {
      var _a3;
      if (rule.options.valueTypes[argKey] == "fx") {
        return `'${argKey}' : ${rule.options.dataSource.args[argKey] || JSON.stringify("")}`;
      } else if (rule.options.valueTypes[argKey] == "boolean") {
        return `'${argKey}' : ${rule.options.dataSource.args[argKey]}`;
      } else if (rule.options.valueTypes[argKey] == "number") {
        return `'${argKey}' : ${rule.options.dataSource.args[argKey] || void 0}`;
      } else {
        return `'${argKey}' : ${JSON.stringify((_a3 = rule.options.dataSource.args[argKey]) != null ? _a3 : JSON.stringify(""))}`;
      }
    });
    return `${condition} await this.refreshFieldDataSource('${rule.options.field}', {${argsArray.join(",")}});`;
  }
  if (rule.action == "getFieldDataSource") {
    if (rule.options.localVariable) {
      let localStatement = ` let ${rule.options.localVariable} = undefined;`;
      return `${localStatement} ${condition} ${rule.options.localVariable} = this.getFieldDataSource('${rule.options.field}');`;
    }
  }
  if (rule.action == "openDialog") {
    if (!rule.options.field)
      return "";
    return `${condition} this.openDialog('${rule.options.field}');`;
  }
  if (rule.action == "closeDialog") {
    if (!rule.options.field)
      return "";
    return `${condition} this.closeDialog('${rule.options.field}');`;
  }
  if (rule.action == "triggerEvent") {
    if (!rule.options.functionName)
      return "";
    let params = rule.options.functionParams.trim();
    if (params) {
      try {
        params = new Function("return " + params)();
      } catch (error) {
        return `${condition} this.triggerEvent('${rule.options.functionName}', "${params}");`;
      }
      return `${condition} this.triggerEvent('${rule.options.functionName}', ${JSON.stringify(params)});`;
    } else {
      return `${condition} this.triggerEvent('${rule.options.functionName}');`;
    }
  }
  if (rule.action == "js") {
    return rule.options.func;
  }
};
const ruleToFunction = (rules2) => {
  if (!rules2)
    return "";
  if (typeof rules2 == "string") {
    rules2 = JSON.parse(rules2);
  }
  let funcs = [];
  rules2.forEach((item) => {
    funcs.push(ruleToFuncString(item));
  });
  return funcs.join("\n");
};
const _sfc_main$j = {
  name: "fm-generate-form",
  components: {
    GenerateFormItem: GenerateFormItem$2,
    GenerateColItem: GenerateColItem$2,
    GenerateTabItem: GenerateTabItem$2,
    GenerateReport: GenerateReport$2,
    GenerateInline: GenerateInline$1,
    GenerateCollapse: GenerateCollapse$2,
    GenerateDialog: GenerateDialog$1,
    GenerateCard: GenerateCard$2
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        "list": [],
        "config": {
          "labelWidth": 100,
          "labelPosition": "right",
          "size": "small",
          "customClass": "",
          "ui": "element",
          "layout": "horizontal"
        }
      })
    },
    remote: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    edit: {
      type: Boolean,
      default: true
    },
    printRead: {
      type: Boolean,
      default: false
    },
    remoteOption: {
      type: Object,
      default: () => ({})
    },
    preview: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      default: "pc"
    }
  },
  emits: ["on-change"],
  data() {
    return {
      formData: {},
      models: {},
      rules: {},
      blanks: [],
      displayFields: {},
      dataBindFields: {},
      generateShow: false,
      resetModels: {},
      formKey: Math.random().toString(36).slice(-8),
      formStyleKey: Math.random().toString(36).slice(-8),
      formValue: this.value,
      formShow: false,
      formRef: Math.random().toString(36).slice(-8) + "Form",
      containerKey: Math.random().toString(36).slice(-8),
      dataSourceValue: [],
      eventFunction: {},
      instanceObject: {},
      dataSourceInterface: [],
      formHideFields: []
    };
  },
  created() {
    this._initForm();
  },
  mounted() {
    this.$nextTick(() => {
      this.eventFunction["mounted"] && this.eventFunction["mounted"]();
    });
  },
  beforeUnmount() {
    let head = ".fm-" + this.formStyleKey + " ";
    clearStyleSheets(head);
  },
  provide() {
    return {
      "generateComponentInstance": this.generateComponentInstance,
      "deleteComponentInstance": this.deleteComponentInstance,
      "eventScriptConfig": this.getEventScriptConfig,
      "getFormComponent": this.getFormComponent,
      "onChange": this._changeFormValue,
      "onFormDisabled": this.disabled,
      "formHideFields": this.formHideFields,
      "onFormHide": this.hide,
      "onFormDisplay": this.display
    };
  },
  methods: {
    getFormComponent() {
      return this.$refs[this.formRef];
    },
    _changeFormValue(value, field) {
      this.models[field] = value;
      this.$emit("on-change", field, value, this.models);
    },
    _initForm() {
      this.formShow = false;
      this.formData = _.cloneDeep(this.data);
      this.models = {};
      this.rules = {};
      this.blanks = [];
      this.displayFields = {};
      this.dataBindFields = {};
      this.resetModels = {};
      this.dataSourceValue = [];
      this.eventFunction = [];
      this.dataSourceInterface = [];
      if (Object.keys(this.data).length) {
        this.generateModel(this.formData.list);
      } else {
        this.generateModel([]);
      }
      this.resetModels = _.cloneDeep(this.models);
      this.models = { ...this.models };
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.formShow = true;
          if (this.formData.config && this.formData.config.styleSheets) {
            let head = ".fm-" + this.formStyleKey + " ";
            updateStyleSheets(splitStyleSheets(this.formData.config.styleSheets), head);
          }
          this.loadDataSource();
          this.loadEvents();
          this.$nextTick(() => {
            this.eventFunction["refresh"] && this.eventFunction["refresh"]();
            resolve();
          });
        });
      });
    },
    getEventScriptConfig() {
      var _a2, _b, _c;
      return (_c = (_b = (_a2 = this.data) == null ? void 0 : _a2.config) == null ? void 0 : _b.eventScript) != null ? _c : [];
    },
    loadEvents() {
      if (this.formData.config && this.formData.config.eventScript) {
        for (let i = 0; i < this.formData.config.eventScript.length; i++) {
          let currentScript = this.formData.config.eventScript[i];
          if (currentScript.type === "rule") {
            const AsyncFunction = Object.getPrototypeOf(async function() {
            }).constructor;
            this.eventFunction[currentScript.key] = new AsyncFunction(ruleToFunction(currentScript.rules)).bind(this);
          } else {
            this.eventFunction[currentScript.key] = Function(currentScript.func).bind(this);
          }
        }
      }
    },
    triggerEvent(eventName, args) {
      if (this.formData.config && this.formData.config.eventScript) {
        let eventScript = this.formData.config.eventScript.find((item) => item.name == eventName);
        if (eventScript) {
          return this.eventFunction[eventScript.key](args);
        }
      }
    },
    loadDataSource() {
      var _a2, _b;
      for (let i = 0; i < this.dataSourceInterface.length; i++) {
        let curRequest = this.dataSourceInterface[i];
        let requestObj = this.formData.config.dataSource.find((item) => item.key == curRequest.key);
        if (requestObj && requestObj.auto)
          requestObj.name && this.sendRequest(requestObj.name, curRequest.args).then((data2) => {
            curRequest.fields.forEach((field) => {
              let curKey = field + "." + curRequest.key;
              let sourceValue = this.dataSourceValue.find((item) => item.key === curKey);
              if (sourceValue) {
                sourceValue.value = data2;
              } else {
                this.dataSourceValue.push({
                  key: curKey,
                  value: data2
                });
              }
            });
          });
      }
      if (((_b = (_a2 = this.formData.config) == null ? void 0 : _a2.dataSource) == null ? void 0 : _b.length) > 0) {
        for (let i = 0; i < this.formData.config.dataSource.length; i++) {
          let currentDataSource = this.formData.config.dataSource[i];
          if (currentDataSource.auto && this.dataSourceInterface.findIndex((item) => item.key == currentDataSource.key) < 0) {
            this.sendRequest(currentDataSource.name, {});
          }
        }
      }
    },
    refreshFieldDataSource(field, args) {
      let curRequest = this.dataSourceInterface.find((item) => item.fields.includes(field));
      return new Promise((resolve, reject) => {
        var _a2;
        if (curRequest) {
          let requestName = (_a2 = this.formData.config.dataSource.find((item) => item.key == curRequest.key)) == null ? void 0 : _a2.name;
          requestName && this.sendRequest(requestName, { ...curRequest.args, ...args }).then((data2) => {
            let curKey = field + "." + curRequest.key;
            let sourceValue = this.dataSourceValue.find((item) => item.key === curKey);
            if (sourceValue) {
              sourceValue.value = data2;
            } else {
              this.dataSourceValue.push({
                key: curKey,
                value: data2
              });
            }
            resolve(data2);
          }).catch(() => {
            reject();
          });
        } else {
          resolve();
        }
      });
    },
    getFieldDataSource(field) {
      let curRequest = this.dataSourceInterface.find((item) => item.fields.includes(field));
      if (curRequest) {
        let curKey = field + "." + curRequest.key;
        let sourceValue = this.dataSourceValue.find((item) => item.key === curKey);
        if (sourceValue) {
          return sourceValue.value;
        }
      }
      return null;
    },
    sendRequest(name, args = {}) {
      return new Promise((resolve, reject) => {
        let currentDataSource = this.formData.config.dataSource.find((item) => item.name === name);
        if (currentDataSource) {
          let options = {
            method: currentDataSource.method,
            url: currentDataSource.url
          };
          let optionsHeaders = {};
          Object.keys(currentDataSource.headers).forEach((key) => {
            if (isExpression(currentDataSource.headers[key])) {
              optionsHeaders[key] = executeExpression(extractExpression(currentDataSource.headers[key]), args, this);
            } else {
              optionsHeaders[key] = currentDataSource.headers[key];
            }
          });
          Object.keys(optionsHeaders).length && (options["headers"] = optionsHeaders);
          let optionsParams = {};
          Object.keys(currentDataSource.params).forEach((key) => {
            if (isExpression(currentDataSource.params[key])) {
              optionsParams[key] = executeExpression(extractExpression(currentDataSource.params[key]), args, this);
            } else {
              optionsParams[key] = currentDataSource.params[key];
            }
          });
          if (options.method === "POST" || options.method === "PUT") {
            options["data"] = optionsParams;
          } else {
            options["params"] = optionsParams;
          }
          if (currentDataSource.requestFunc) {
            const requestDynamicFunc = Function("config, args", currentDataSource.requestFunc).bind(this);
            options = requestDynamicFunc(options, args);
          }
          axios(options).then((res) => {
            let data2 = res;
            if (currentDataSource.responseFunc) {
              const dynamicFunc = Function("res, args", currentDataSource.responseFunc).bind(this);
              data2 = dynamicFunc(res.data, args);
              resolve(data2);
            } else {
              resolve(res.data);
            }
          }).catch((error) => {
            if (currentDataSource.errorFunc) {
              const errorDynamicFunc = Function("error", currentDataSource.errorFunc).bind(this);
              errorDynamicFunc(error);
            }
            reject(error);
          });
        }
      });
    },
    generateSubformModel(subName, genList, dataBindFields) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].options.hidden) {
          this.formHideFields.push(`${subName}.${genList[i].model}`);
        }
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this.generateSubformModel(subName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this.generateSubformModel(subName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this.generateSubformModel(subName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this.generateSubformModel(subName, column.list, dataBindFields);
            });
          });
        } else if (genList[i].type === "inline") {
          this.generateSubformModel(subName, genList[i].list, dataBindFields);
        } else if (genList[i].type === "card") {
          this.generateSubformModel(subName, genList[i].list, dataBindFields);
        } else {
          if (genList[i].type === "blank") {
            this.blanks.push({
              name: genList[i].model
            });
          }
          if (genList[i].options.dataBind) {
            if (["subform", "group", "table"].includes(genList[i].type)) {
              dataBindFields[genList[i].model] = {};
            } else {
              dataBindFields[genList[i].model] = true;
            }
          }
          genList[i].tableColumns && genList[i].tableColumns.length && genList[i].tableColumns.forEach((item) => {
            if (item.type === "blank") {
              this.blanks.push({
                name: item.model
              });
            }
            if (item.options.dataBind && genList[i].options.dataBind) {
              dataBindFields[genList[i].model][item.model] = true;
            }
            if (item.options.hidden) {
              this.formHideFields.push(`${subName}.${genList[i].model}.${item.model}`);
            }
            this._generateRules(`${subName}.${genList[i].model}.${item.model}`, item.rules);
            this._generateDataSource(item, `${subName}.${genList[i].model}.${item.model}`);
          });
          if (genList[i].type == "subform") {
            this.generateSubformModel(`${subName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "group") {
            this.generateGroupModel(`${subName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          this._generateRules(`${subName}.${genList[i].model}`, genList[i].rules);
          this._generateDataSource(genList[i], `${subName}.${genList[i].model}`);
        }
      }
    },
    generateDialogModel(dialogName, genList, dataBindFields) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].options.hidden) {
          this.formHideFields.push(`${dialogName}.${genList[i].model}`);
        }
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this.generateDialogModel(dialogName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this.generateDialogModel(dialogName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this.generateDialogModel(dialogName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this.generateDialogModel(dialogName, column.list, dataBindFields);
            });
          });
        } else if (genList[i].type === "inline") {
          this.generateDialogModel(dialogName, genList[i].list, dataBindFields);
        } else if (genList[i].type === "card") {
          this.generateDialogModel(dialogName, genList[i].list, dataBindFields);
        } else {
          if (genList[i].type === "blank") {
            this.blanks.push({
              name: genList[i].model
            });
          }
          if (genList[i].options.dataBind) {
            if (["subform", "group", "table"].includes(genList[i].type)) {
              dataBindFields[genList[i].model] = {};
            } else {
              dataBindFields[genList[i].model] = true;
            }
          }
          if (genList[i].type == "subform") {
            this.generateSubformModel(`${dialogName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "group") {
            this.generateGroupModel(`${dialogName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          genList[i].tableColumns && genList[i].tableColumns.length && genList[i].tableColumns.forEach((item) => {
            if (item.type === "blank") {
              this.blanks.push({
                name: item.model
              });
            }
            if (item.options.dataBind && genList[i].options.dataBind) {
              dataBindFields[genList[i].model][item.model] = true;
            }
            if (item.options.hidden) {
              this.formHideFields.push(`${dialogName}.${genList[i].model}.${item.model}`);
            }
            this._generateRules(`${dialogName}.${genList[i].model}.${item.model}`, item.rules);
            this._generateDataSource(item, `${dialogName}.${genList[i].model}.${item.model}`);
          });
          this._generateRules(`${dialogName}.${genList[i].model}`, genList[i].rules);
          this._generateDataSource(genList[i], `${dialogName}.${genList[i].model}`);
        }
      }
    },
    generateGroupModel(groupName, genList, dataBindFields) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].options.hidden) {
          this.formHideFields.push(`${groupName}.${genList[i].model}`);
        }
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this.generateGroupModel(groupName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this.generateGroupModel(groupName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this.generateGroupModel(groupName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this.generateGroupModel(groupName, column.list, dataBindFields);
            });
          });
        } else if (genList[i].type === "inline") {
          this.generateGroupModel(groupName, genList[i].list, dataBindFields);
        } else if (genList[i].type === "card") {
          this.generateGroupModel(groupName, genList[i].list, dataBindFields);
        } else {
          if (genList[i].type === "blank") {
            this.blanks.push({
              name: genList[i].model
            });
          }
          if (genList[i].options.dataBind) {
            if (["subform", "group", "table"].includes(genList[i].type)) {
              dataBindFields[genList[i].model] = {};
            } else {
              dataBindFields[genList[i].model] = true;
            }
          }
          if (genList[i].type == "subform") {
            this.generateSubformModel(`${groupName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "group") {
            this.generateGroupModel(`${groupName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          genList[i].tableColumns && genList[i].tableColumns.length && genList[i].tableColumns.forEach((item) => {
            if (item.type === "blank") {
              this.blanks.push({
                name: item.model
              });
            }
            if (item.options.dataBind && genList[i].options.dataBind) {
              dataBindFields[genList[i].model][item.model] = true;
            }
            if (item.options.hidden) {
              this.formHideFields.push(`${groupName}.${genList[i].model}.${item.model}`);
            }
            this._generateRules(`${groupName}.${genList[i].model}.${item.model}`, item.rules);
            this._generateDataSource(item, `${groupName}.${genList[i].model}.${item.model}`);
          });
          this._generateRules(`${groupName}.${genList[i].model}`, genList[i].rules);
          this._generateDataSource(genList[i], `${groupName}.${genList[i].model}`);
        }
      }
    },
    generateModel(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].options.hidden) {
          this.formHideFields.push(genList[i].model);
        }
        if (genList[i].type === "grid") {
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          genList[i].columns.forEach((item) => {
            this.generateModel(item.list);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this.generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this.generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this.generateModel(column.list);
            });
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "inline") {
          this.generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "card") {
          this.generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else {
          if (Object.keys(this.formValue).indexOf(genList[i].model) >= 0) {
            this.models[genList[i].model] = this.formValue[genList[i].model];
            this.displayFields[genList[i].model] = !genList[i].options.hidden;
            if (genList[i].type === "blank") {
              this.blanks.push({
                name: genList[i].model
              });
            }
          } else {
            if (genList[i].type === "blank") {
              this.models[genList[i].model] = genList[i].options.defaultType === "String" ? "" : genList[i].options.defaultType === "Object" ? {} : [];
              this.displayFields[genList[i].model] = !genList[i].options.hidden;
              this.blanks.push({
                name: genList[i].model
              });
            } else {
              this.models[genList[i].model] = _.cloneDeep(genList[i].options.defaultValue);
              this.displayFields[genList[i].model] = !genList[i].options.hidden;
            }
          }
          if ((Object.keys(genList[i].options).indexOf("dataBind") < 0 || genList[i].options.dataBind) && genList[i].key && genList[i].model) {
            if (["subform", "table", "dialog", "group"].includes(genList[i].type)) {
              this.dataBindFields[genList[i].model] = {};
            } else {
              this.dataBindFields[genList[i].model] = true;
            }
          }
          if (genList[i].type == "subform") {
            this.generateSubformModel(genList[i].model, genList[i].list, this.dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "dialog") {
            this.generateDialogModel(genList[i].model, genList[i].list, this.dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "group") {
            this.generateGroupModel(genList[i].model, genList[i].list, this.dataBindFields[genList[i].model] || {});
          }
          genList[i].tableColumns && genList[i].tableColumns.length && genList[i].tableColumns.forEach((item) => {
            if (item.type === "blank") {
              this.blanks.push({
                name: item.model
              });
            }
            if (item.options.dataBind && genList[i].options.dataBind) {
              this.dataBindFields[genList[i].model][item.model] = true;
            }
            if (item.options.hidden) {
              this.formHideFields.push(`${genList[i].model}.${item.model}`);
            }
            this._generateRules(`${genList[i].model}.${item.model}`, item.rules);
            this._generateDataSource(item, `${genList[i].model}.${item.model}`);
          });
          this._generateRules(genList[i].model, genList[i].rules);
          this._generateDataSource(genList[i], genList[i].model);
        }
      }
    },
    _generateDataSource(element, model2) {
      if (element.options.remoteType === "datasource" && element.options.remoteDataSource) {
        this._setDataSourceInterface(model2, element.options.remoteArgs, element.options.remoteDataSource);
      }
      if ((element.type == "imgupload" || element.type == "fileupload") && element.options.tokenType == "datasource" && element.options.tokenDataSource) {
        this._setDataSourceInterface(model2, element.options.remoteArgs, element.options.tokenDataSource);
      }
    },
    _generateRules(model, rules) {
      if (this.rules[model]) {
        this.rules[model] = [
          ...this.rules[model],
          ...rules ? rules.map((im) => {
            if (im.pattern) {
              return { ...im, pattern: eval(im.pattern) };
            } else if (im.func) {
              const validatorFunc = Function("rule", "value", "callback", im.func).bind(this);
              return { ...im, validator: validatorFunc };
            } else {
              return { ...im };
            }
          }) : []
        ];
      } else {
        this.rules[model] = [
          ...rules ? rules.map((im) => {
            if (im.pattern) {
              return { ...im, pattern: eval(im.pattern) };
            } else if (im.func) {
              const validatorFunc = Function("rule", "value", "callback", im.func).bind(this);
              return { ...im, validator: validatorFunc };
            } else {
              return { ...im };
            }
          }) : []
        ];
      }
    },
    _setDataSourceInterface(field, args, key) {
      let argsObj;
      if (typeof args == "string") {
        argsObj = new Function('"use strict";return (' + (args || "{}") + ")").bind(this)();
      } else {
        argsObj = args;
      }
      let findCurInterfaceIndex = this.dataSourceInterface.findIndex((item) => item.key == key && _.isEqual(item.args, argsObj));
      if (findCurInterfaceIndex >= 0) {
        this.dataSourceInterface[findCurInterfaceIndex].fields.push(field);
      } else {
        this.dataSourceInterface.push({
          key,
          args: argsObj,
          fields: [field]
        });
      }
    },
    _setSubDisabled(genList, fields, disabled) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setSubDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setSubDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setSubDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setSubDisabled(column.list, fields, disabled);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setSubDisabled(genList[i].list, fields, disabled);
        } else if (genList[i].type === "card") {
          this._setSubDisabled(genList[i].list, fields, disabled);
        } else {
          if (fields.length === 1) {
            if (genList[i].model === fields[0]) {
              genList[i].options.disabled = disabled;
            }
          } else {
            if (genList[i].model !== fields[0])
              continue;
            let newFields = [...fields];
            newFields.splice(0, 1);
            if (genList[i].type === "table") {
              this._setSubDisabled(genList[i].tableColumns, newFields, disabled);
            }
            if (genList[i].type === "subform") {
              this._setSubDisabled(genList[i].list, newFields, disabled);
            }
            if (genList[i].type === "group") {
              this._setSubDisabled(genList[i].list, newFields, disabled);
            }
            if (genList[i].type === "dialog") {
              this._setSubDisabled(genList[i].list, newFields, disabled);
            }
          }
        }
      }
    },
    _setSubOptions(genList, fields, opts) {
      for (let i = 0; i < genList.length; i++) {
        if (fields.length === 1) {
          if (genList[i].model === fields[0]) {
            Object.keys(opts).forEach((key) => {
              genList[i].options[key] = opts[key];
            });
          } else {
            if (genList[i].type === "grid") {
              genList[i].columns.forEach((item) => {
                this._setSubOptions(item.list, fields, opts);
              });
            } else if (genList[i].type === "tabs") {
              genList[i].tabs.forEach((item) => {
                this._setSubOptions(item.list, fields, opts);
              });
            } else if (genList[i].type === "collapse") {
              genList[i].tabs.forEach((item) => {
                this._setSubOptions(item.list, fields, opts);
              });
            } else if (genList[i].type === "report") {
              genList[i].rows.forEach((row) => {
                row.columns.forEach((column) => {
                  this._setSubOptions(column.list, fields, opts);
                });
              });
            } else if (genList[i].type === "inline") {
              this._setSubOptions(genList[i].list, fields, opts);
            } else if (genList[i].type === "card") {
              this._setSubOptions(genList[i].list, fields, opts);
            }
          }
        } else {
          if (genList[i].type === "grid") {
            genList[i].columns.forEach((item) => {
              this._setSubOptions(item.list, fields, opts);
            });
          } else if (genList[i].type === "tabs") {
            genList[i].tabs.forEach((item) => {
              this._setSubOptions(item.list, fields, opts);
            });
          } else if (genList[i].type === "collapse") {
            genList[i].tabs.forEach((item) => {
              this._setSubOptions(item.list, fields, opts);
            });
          } else if (genList[i].type === "report") {
            genList[i].rows.forEach((row) => {
              row.columns.forEach((column) => {
                this._setSubOptions(column.list, fields, opts);
              });
            });
          } else if (genList[i].type === "inline") {
            this._setSubOptions(genList[i].list, fields, opts);
          } else if (genList[i].type === "card") {
            this._setSubOptions(genList[i].list, fields, opts);
          } else {
            if (genList[i].model !== fields[0])
              continue;
            let newFields = [...fields];
            newFields.splice(0, 1);
            if (genList[i].type === "table") {
              this._setSubOptions(genList[i].tableColumns, newFields, opts);
            }
            if (genList[i].type === "subform") {
              this._setSubOptions(genList[i].list, newFields, opts);
            }
            if (genList[i].type === "group") {
              this._setSubOptions(genList[i].list, newFields, opts);
            }
            if (genList[i].type === "dialog") {
              this._setSubOptions(genList[i].list, newFields, opts);
            }
          }
        }
      }
    },
    _getSubOptions(genList, fields) {
      for (let i = 0; i < genList.length; i++) {
        if (fields.length === 1) {
          if (genList[i].model === fields[0]) {
            return genList[i].options;
          } else {
            if (genList[i].type === "grid") {
              for (const item of genList[i].columns) {
                const options = this._getSubOptions(item.list, fields);
                if (options)
                  return options;
              }
            } else if (genList[i].type === "tabs") {
              for (const item of genList[i].tabs) {
                const options = this._getSubOptions(item.list, fields);
                if (options)
                  return options;
              }
            } else if (genList[i].type === "collapse") {
              for (const item of genList[i].tabs) {
                const options = this._getSubOptions(item.list, fields);
                if (options)
                  return options;
              }
            } else if (genList[i].type === "report") {
              for (const row of genList[i].rows) {
                for (const column of row.columns) {
                  const options = this._getSubOptions(column.list, fields);
                  if (options)
                    return options;
                }
              }
            } else if (genList[i].type === "inline") {
              const options = this._getSubOptions(genList[i].list, fields);
              if (options)
                return options;
            } else if (genList[i].type === "card") {
              const options = this._getSubOptions(genList[i].list, fields);
              if (options)
                return options;
            }
          }
        } else {
          if (genList[i].type === "grid") {
            for (const item of genList[i].columns) {
              const options = this._getSubOptions(item.list, fields);
              if (options)
                return options;
            }
          } else if (genList[i].type === "tabs") {
            for (const item of genList[i].tabs) {
              const options = this._getSubOptions(item.list, fields);
              if (options)
                return options;
            }
          } else if (genList[i].type === "collapse") {
            for (const item of genList[i].tabs) {
              const options = this._getSubOptions(item.list, fields);
              if (options)
                return options;
            }
          } else if (genList[i].type === "report") {
            for (const row of genList[i].rows) {
              for (const column of row.columns) {
                const options = this._getSubOptions(column.list, fields);
                if (options)
                  return options;
              }
            }
          } else if (genList[i].type === "inline") {
            const options = this._getSubOptions(genList[i].list, fields);
            if (options)
              return options;
          } else if (genList[i].type === "card") {
            const options = this._getSubOptions(genList[i].list, fields);
            if (options)
              return options;
          } else {
            if (genList[i].model !== fields[0])
              continue;
            let newFields = [...fields];
            newFields.splice(0, 1);
            if (genList[i].type === "table") {
              const options = this._getSubOptions(genList[i].tableColumns, newFields);
              if (options)
                return options;
            }
            if (genList[i].type === "subform") {
              const options = this._getSubOptions(genList[i].list, newFields);
              if (options)
                return options;
            }
            if (genList[i].type === "group") {
              const options = this._getSubOptions(genList[i].list, newFields);
              if (options)
                return options;
            }
            if (genList[i].type === "dialog") {
              const options = this._getSubOptions(genList[i].list, newFields);
              if (options)
                return options;
            }
          }
        }
      }
      return null;
    },
    validate(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      return new Promise((resolve, reject) => {
        if (fields) {
          this.$refs[this.formRef].validateField(fields, (valid, error) => {
            if (valid) {
              resolve();
            } else {
              reject(error);
            }
          });
        } else {
          this.$refs[this.formRef].validate((valid, error) => {
            if (valid) {
              resolve();
            } else {
              reject(error);
            }
          });
        }
      });
    },
    getData(isValidate = true) {
      return new Promise((resolve, reject) => {
        if (isValidate) {
          this.$refs[this.formRef].validate((valid) => {
            if (valid) {
              resolve(getBindModels(this.models, this.dataBindFields));
            } else {
              reject(new Error(this.$t("fm.message.validError")).message);
            }
          });
        } else {
          resolve(getBindModels(this.models, this.dataBindFields));
        }
      });
    },
    reset() {
      return new Promise((resolve) => {
        this.setData(_.cloneDeep(this.resetModels)).then(() => {
          setTimeout(() => {
            this.$refs[this.formRef].clearValidate();
            resolve();
          });
        });
      });
    },
    onInputChange(value, field) {
      this.$emit("on-change", field, value, this.models);
      this.$emit(`on-${field}-change`, value);
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        if (this.formHideFields.includes(field)) {
          let index2 = this.formHideFields.findIndex((item) => item == field);
          this.formHideFields.splice(index2, 1);
        }
      });
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        if (!this.formHideFields.includes(field)) {
          this.formHideFields.push(field);
        }
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        var _a2;
        let currentComponent = this.instanceObject[item];
        if (currentComponent) {
          if (Array.isArray(currentComponent)) {
            currentComponent.forEach((cc) => {
              var _a3;
              (_a3 = cc.$parent) == null ? void 0 : _a3.disabledElement(disabled);
            });
          } else {
            (_a2 = currentComponent.$parent) == null ? void 0 : _a2.disabledElement(disabled);
          }
        } else {
          this._setSubDisabled(this.formData.list, item.split("."), disabled);
        }
      });
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.formData.list, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.formData.list, item.split("."), className, "remove");
      });
    },
    async refresh() {
      await this._initForm();
    },
    setData(value) {
      const _setNestedValue = (currentObj, keys, value2) => {
        const key = keys.shift();
        if (keys.length === 0) {
          currentObj[key] = value2;
        } else {
          if (key in currentObj) {
            if (Array.isArray(currentObj[key])) {
              if (Number.isNaN(Number(keys[0]))) {
                currentObj[key].forEach((cur) => {
                  _setNestedValue(cur, [...keys], value2);
                });
              } else {
                const indexKey = keys.shift();
                currentObj[key].length > Number(indexKey) && _setNestedValue(currentObj[key][Number(indexKey)], [...keys], value2);
              }
            } else {
              _setNestedValue(currentObj[key], [...keys], value2);
            }
          }
        }
      };
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            _setNestedValue(this.models, item.split("."), value[item]);
          });
          resolve();
        });
      });
    },
    getComponent(name) {
      if (this.instanceObject[name]) {
        return this.instanceObject[name];
      } else {
        consoleError("No component instance found with " + name);
        return null;
      }
    },
    getValues() {
      return _.cloneDeep(this.models);
    },
    getValue(fieldName) {
      const resModels = _.cloneDeep(this.models);
      let fieldArray = fieldName.split(".");
      const _getFieldRes = (res, array) => {
        if (array.length === 1) {
          return res[array[0]];
        } else {
          let newRes = res[array[0]];
          let newFields = [...array];
          newFields.splice(0, 1);
          return _getFieldRes(newRes, newFields);
        }
      };
      return _getFieldRes(resModels, fieldArray);
    },
    setRules(field, rules2) {
      this.rules[field] = [...rules2];
      this.$nextTick(() => {
        var _a2;
        if ((field == null ? void 0 : field.split(".").length) > 1) {
          const tableRowLength = (_a2 = this.getValue(field.split(".")[0])) == null ? void 0 : _a2.length;
          if (tableRowLength) {
            for (let i = 0; i < tableRowLength; i++) {
              this.$refs[this.formRef].validateField([`${field.split(".")[0]}.${i}.${field.split(".")[1]}`]);
            }
          }
        } else {
          this.$refs[this.formRef].validateField([field]);
        }
      });
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        this._setSubOptions(this.formData.list, item.split("."), options);
      });
    },
    getOptions(field, key) {
      const result = this._getSubOptions(this.formData.list, field.split("."));
      if (key && result && result[key]) {
        return result[key];
      } else {
        return result;
      }
    },
    generateComponentInstance(key, instance2) {
      if (this.instanceObject[key]) {
        if (Array.isArray(this.instanceObject[key])) {
          this.instanceObject[key] = [...this.instanceObject[key], instance2];
        } else {
          this.instanceObject[key] = [this.instanceObject[key], instance2];
        }
      } else {
        this.instanceObject[key] = instance2;
      }
    },
    deleteComponentInstance(key) {
      if (this.instanceObject[key]) {
        delete this.instanceObject[key];
      }
    },
    setOptionData(fields, data2) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        var _a2;
        const curRef = this.instanceObject[field];
        (_a2 = curRef == null ? void 0 : curRef.$parent) == null ? void 0 : _a2.loadOptions(data2);
      });
    },
    exportPDF() {
      if (this.printRead) {
        return exportPDF(document.querySelector(".fm-" + this.formStyleKey));
      } else {
        return Promise.reject();
      }
    },
    openDialog(dialogField) {
      const dialogComponent = this.getComponent(dialogField);
      if (dialogComponent) {
        dialogComponent.open();
      }
    },
    closeDialog(dialogField) {
      const dialogComponent = this.getComponent(dialogField);
      if (dialogComponent) {
        dialogComponent.close();
      }
    }
  }
};
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2;
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_dialog = resolveComponent("generate-dialog");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_el_form = resolveComponent("el-form");
  return openBlock(), createElementBlock("div", {
    style: normalizeStyle({ width: $data.formData.config && $data.formData.config.width }),
    class: normalizeClass(["fm-form", {
      ["fm-" + $data.formStyleKey]: true,
      "is-print": $props.printRead
    }])
  }, [
    $data.formShow ? (openBlock(), createBlock(_component_el_form, {
      ref: $data.formRef,
      key: $data.formKey,
      class: normalizeClass({
        [$data.formData.config && $data.formData.config.customClass]: $data.formData.config && $data.formData.config.customClass ? true : false,
        "no-label-form": $data.formData.config && $data.formData.config.labelWidth == 0
      }),
      size: $data.formData.config && $data.formData.config.size,
      model: $data.models,
      rules: $data.rules,
      "label-position": $data.formData.config && $data.formData.config.labelPosition,
      disabled: !$props.edit,
      "label-width": $data.formData.config && $data.formData.config.labelWidth + "px",
      "validate-on-rule-change": false,
      "label-suffix": ((_a2 = $data.formData.config) == null ? void 0 : _a2.labelSuffix) ? " : " : " "
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.formData.list, (item) => {
          return openBlock(), createElementBlock(Fragment, null, [
            item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
              key: item.key,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "form-component"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
              key: item.key,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "form-component"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
              key: item.key,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "form-component"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
              key: item.key,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "form-component"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
              key: item.key,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "form-component"])) : item.type == "dialog" ? (openBlock(), createBlock(_component_generate_dialog, {
              key: item.key,
              models: $data.models,
              "onUpdate:models": _cache[0] || (_cache[0] = ($event) => $data.models = $event),
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["models", "rules", "element", "remote", "blanks", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "form-component"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
              key: item.key,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "form-component"])) : (openBlock(), createBlock(_component_generate_form_item, {
              key: item.key,
              models: $data.models,
              rules: $data.rules,
              widget: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "form-component"]))
          ], 64);
        }), 256))
      ]),
      _: 3
    }, 8, ["class", "size", "model", "rules", "label-position", "disabled", "label-width", "label-suffix"])) : createCommentVNode("", true)
  ], 6);
}
var GenerateForm = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$h]]);
var FormTable_vue_vue_type_style_index_0_lang = "";
const _sfc_main$i = {
  components: {
    VirtualTable,
    VirtualRow,
    VirtualCell,
    GenerateFormItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateFormItem$1;
    })),
    GenerateElementItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateElementItem$1;
    }))
  },
  props: [
    "config",
    "columns",
    "value",
    "models",
    "remote",
    "blanks",
    "disableddata",
    "rules",
    "name",
    "remoteOption",
    "preview",
    "platform",
    "dataSourceValue",
    "eventFunction",
    "widget",
    "containerKey",
    "printRead",
    "paging",
    "pageSize",
    "isAdd",
    "isDelete",
    "showControl",
    "isDialog",
    "dialogName",
    "group",
    "fieldNode"
  ],
  emits: ["update:value"],
  data() {
    var _a2;
    return {
      tableData: (_a2 = this.value) != null ? _a2 : [],
      displayFields: {},
      disabledFields: {},
      changeItem: {},
      pagingData: [],
      pagingLength: 0,
      currentPage: 1,
      tableHideFields: [],
      tableDisabledFields: [],
      mobileScreen: window.innerWidth < 768,
      tableKey: Math.random().toString(36).slice(-8)
    };
  },
  created() {
    for (let i = 0; i < this.columns.length; i++) {
      this.displayFields[this.columns[i].model] = !this.columns[i].options.hidden;
      this.disabledFields[this.columns[i].model] = this.columns[i].options.disabled;
    }
    this.tableHideFields = this.value ? this.value.map((v) => Object.fromEntries(Object.keys(this.displayFields).map((field) => [field, !this.displayFields[field]]))) : [];
    this.tableDisabledFields = this.value ? this.value.map((v) => Object.fromEntries(Object.keys(this.disabledFields).map((field) => [field, this.disabledFields[field]]))) : [];
    window.addEventListener("resize", this.getMobileScreen);
    this.loadPagingData();
  },
  computed: {
    tableSize() {
      switch (this.config.size) {
        case "large":
          return "default";
        case "default":
          return "middle";
        case "small":
          return "small";
      }
    }
  },
  provide() {
    return {
      "setTableData": this.setTableData
    };
  },
  inject: ["onFormDisabled", "formHideFields", "onFormHide", "onFormDisplay"],
  methods: {
    columnDisplay(model2) {
      if (this.formHideFields.includes(this.group ? `${this.group}.${this.widget.model}.${model2}` : `${this.widget.model}.${model2}`)) {
        return false;
      } else {
        return true;
      }
    },
    getMobileScreen() {
      this.mobileScreen = window.innerWidth < 768;
    },
    setData(rowIndex, value) {
      if (typeof rowIndex !== "number") {
        return new Promise((resolve) => {
          value = rowIndex;
          this.tableData.forEach((_2, index2) => {
            Object.keys(value).forEach((item) => {
              this.setTableData(value[item], index2, item);
            });
          });
          resolve();
        });
      }
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            this.setTableData(value[item], rowIndex, item);
          });
          resolve();
        });
      });
    },
    setTableData(value, rowIndex, field) {
      this.tableData[rowIndex][field] = value;
    },
    handleAddRow() {
      let item = {};
      let hideItem = {};
      let disabledItem = {};
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].type === "blank") {
          item[this.columns[i].model] = this.columns[i].options.defaultType == "String" ? "" : this.columns[i].options.defaultType == "Object" ? {} : [];
        } else if (this.columns[i].type === "component" || this.columns[i].type === "link" || this.columns[i].type === "button") {
          item[this.columns[i].model] = void 0;
        } else {
          item[this.columns[i].model] = _.cloneDeep(this.columns[i].options.defaultValue);
        }
        hideItem[this.columns[i].model] = !this.displayFields[this.columns[i].model];
        disabledItem[this.columns[i].model] = this.disabledFields[this.columns[i].model];
      }
      this.tableData.push(item);
      this.tableHideFields.push(hideItem);
      this.tableDisabledFields.push(disabledItem);
      if (this.widget.events && this.widget.events.onRowAdd) {
        let funcKey = this.widget.events.onRowAdd;
        this.eventFunction[funcKey]({
          rowIndex: this.tableData.length - 1,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
      this.changeItem = {};
      if (this.paging) {
        this.$nextTick(() => {
          if (this.tableData.length > this.currentPage * this.pageSize) {
            this.currentPage = parseInt((this.tableData.length - 1) / this.pageSize) + 1;
          }
          this.loadPagingData();
        });
      }
    },
    handleRemove(index2) {
      const removeData = { ...this.tableData[index2] };
      this.tableData.splice(index2, 1);
      if (this.widget.events && this.widget.events.onRowRemove) {
        let funcKey = this.widget.events.onRowRemove;
        this.eventFunction[funcKey]({
          removeIndex: index2,
          removeData,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
      this.changeItem = {};
      this.pagingData = [];
      this.pagingLength = 0;
      if (this.paging) {
        this.$nextTick(() => {
          if (this.tableData.length % this.pageSize == 0 && this.currentPage > parseInt(this.tableData.length / this.pageSize)) {
            this.currentPage = parseInt(this.tableData.length / this.pageSize);
          }
          this.loadPagingData();
        });
      }
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${field}`);
      });
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${field}`);
      });
    },
    hideChild(rowIndex, fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${rowIndex}.${field}`);
      });
    },
    displayChild(rowIndex, fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${rowIndex}.${field}`);
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (fields.indexOf(this.columns[i].model) >= 0) {
          this.columns[i].options.disabled = disabled;
          this.disabledFields[this.columns[i].model] = disabled;
        }
      }
      this.tableData.forEach((_2, index2) => {
        fields.forEach((field) => {
          this.tableDisabledFields[index2][field] = disabled;
        });
      });
    },
    disabledChild(rowIndex, fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.tableDisabledFields[rowIndex][field] = disabled;
        this.onFormDisabled(`${this.fieldNode}.${rowIndex}.${field}`, disabled);
      });
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (fields.indexOf(this.columns[i].model) >= 0) {
          Object.keys(options).forEach((key) => {
            this.columns[i].options[key] = options[key];
          });
        }
      }
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.columns, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.columns, item.split("."), className, "remove");
      });
    },
    handleTableChange(value) {
      this.changeItem = value;
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.pagingData = [];
      this.pagingLength = 0;
      this.$nextTick(() => {
        this.loadPagingData();
      });
      if (this.widget && this.widget.events && this.widget.events.onPageChange) {
        let funcKey = this.widget.events.onPageChange;
        this.eventFunction[funcKey]({
          currentPage: val,
          field: this.widget.model,
          currentRef: this,
          group: this.group,
          fieldNode: this.fieldNode
        });
      }
    },
    loadPagingData() {
      var _a2;
      let beginIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = beginIndex + this.pageSize;
      this.pagingData = (_a2 = this.tableData) == null ? void 0 : _a2.slice(beginIndex, endIndex);
      this.pagingLength = this.pagingData.length;
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.getMobileScreen);
  },
  watch: {
    value(val) {
      var _a2, _b, _c, _d, _e;
      this.tableData = val;
      let hideFields = [];
      let disabledFields = [];
      for (let i = 0; i < ((_a2 = this.value) == null ? void 0 : _a2.length); i++) {
        let row = this.value[i];
        let rowArray = Object.keys(row);
        let hideRow = {};
        let disabledRow = {};
        for (let f = 0; f < rowArray.length; f++) {
          hideRow[rowArray[f]] = ((_c = (_b = this.tableHideFields) == null ? void 0 : _b[i]) == null ? void 0 : _c[rowArray[f]]) || false;
          disabledRow[rowArray[f]] = ((_e = (_d = this.tableDisabledFields) == null ? void 0 : _d[i]) == null ? void 0 : _e[rowArray[f]]) || false;
        }
        hideFields.push(hideRow);
        disabledFields.push(disabledRow);
      }
      this.tableHideFields = hideFields;
      this.tableDisabledFields = disabledFields;
    },
    "tableData": {
      deep: true,
      handler(val) {
        this.loadPagingData();
        this.$emit("update:value", val);
      }
    }
  }
};
const _hoisted_1$9 = { class: "scope-index" };
const _hoisted_2$8 = { class: "scope-action" };
const _hoisted_3$6 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-trash",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_4$5 = { key: 1 };
const _hoisted_5$5 = { class: "scope-index" };
const _hoisted_6$4 = { class: "scope-action" };
const _hoisted_7$3 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-trash",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_8$1 = { key: 1 };
const _hoisted_9$1 = {
  key: 0,
  class: "antd-form-table-mobile-item__top"
};
const _hoisted_10$1 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-trash",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_11$1 = { class: "antd-form-table-mobile-item__content" };
const _hoisted_12$1 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
function _sfc_render$g(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = resolveComponent("a-button");
  const _component_a_popconfirm = resolveComponent("a-popconfirm");
  const _component_a_table_column = resolveComponent("a-table-column");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_a_table = resolveComponent("a-table");
  const _component_VirtualCell = resolveComponent("VirtualCell");
  const _component_VirtualRow = resolveComponent("VirtualRow");
  const _component_VirtualTable = resolveComponent("VirtualTable");
  const _component_a_space = resolveComponent("a-space");
  const _component_a_col = resolveComponent("a-col");
  const _component_a_pagination = resolveComponent("a-pagination");
  const _component_a_row = resolveComponent("a-row");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["antd-form-table", { "is-disabled": $props.disableddata }])
  }, [
    $props.preview && $props.platform != "mobile" || !$props.preview && !$data.mobileScreen ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
      !$props.widget.options.virtualTable ? (openBlock(), createBlock(_component_a_table, {
        key: 0,
        dataSource: $props.paging ? $data.pagingData : $data.tableData,
        pagination: false,
        bordered: "",
        class: normalizeClass({ "antd-form-table-pc": !$props.preview }),
        "table-layout": "auto",
        scroll: { x: "max-content" },
        size: $options.tableSize
      }, {
        default: withCtx(() => [
          $props.showControl ? (openBlock(), createBlock(_component_a_table_column, {
            scopedSlots: { customRender: "#" },
            title: "#",
            "data-index": "#",
            key: "#",
            fixed: "left",
            width: 80
          }, {
            default: withCtx(({ index: index2 }) => [
              createElementVNode("div", _hoisted_1$9, [
                createElementVNode("span", null, toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)
              ]),
              createElementVNode("div", _hoisted_2$8, [
                !$props.printRead && $props.isDelete ? (openBlock(), createBlock(_component_a_popconfirm, {
                  key: 0,
                  disabled: $props.disableddata,
                  title: _ctx.$t("fm.description.deleteConfirm"),
                  onConfirm: ($event) => $options.handleRemove(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2)
                }, {
                  default: withCtx(() => [
                    createVNode(_component_a_button, {
                      disabled: $props.disableddata,
                      type: "primary",
                      danger: "",
                      shape: "circle",
                      size: "small"
                    }, {
                      default: withCtx(() => [
                        _hoisted_3$6
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 2
                }, 1032, ["disabled", "title", "onConfirm"])) : createCommentVNode("", true),
                $props.printRead || !$props.isDelete ? (openBlock(), createElementBlock("span", _hoisted_4$5, toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)) : createCommentVNode("", true)
              ])
            ]),
            _: 1
          })) : createCommentVNode("", true),
          $props.columns.length == 0 ? (openBlock(), createBlock(_component_a_table_column, { key: 1 })) : (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList($props.columns, (column) => {
            return openBlock(), createElementBlock(Fragment, null, [
              $options.columnDisplay(column.model) ? (openBlock(), createBlock(_component_a_table_column, {
                key: column.key,
                "data-index": column.key,
                title: column.options.hideLabel ? "" : column.name,
                width: column.options.width,
                class: normalizeClass(column.options.required ? "required" : ""),
                scopedSlots: { customRender: column.key },
                fixed: column.options.fixedColumn ? column.options.fixedColumnPosition || "left" : false
              }, {
                default: withCtx(({ index: index2 }) => [
                  createVNode(_component_generate_form_item, {
                    models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                    rules: $props.rules,
                    widget: column,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $data.displayFields,
                    "sub-hide-fields": $data.tableHideFields,
                    "sub-disabled-fields": $data.tableDisabledFields,
                    edit: !$props.disableddata,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-table": true,
                    "is-mobile": false,
                    "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                    "table-name": $props.name,
                    config: $props.config,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": false,
                    group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                    "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "config", "is-dialog", "dialog-name", "group", "field-node"])
                ]),
                _: 2
              }, 1032, ["data-index", "title", "width", "class", "scopedSlots", "fixed"])) : createCommentVNode("", true)
            ], 64);
          }), 256))
        ]),
        _: 3
      }, 8, ["dataSource", "class", "size"])) : createCommentVNode("", true),
      $props.widget.options.virtualTable ? (openBlock(), createBlock(_component_VirtualTable, {
        key: 1,
        columns: $props.columns,
        showControl: $props.showControl,
        paging: $props.paging,
        pageSize: $props.pageSize,
        currentPage: $data.currentPage,
        displayFields: $data.displayFields,
        group: $props.group,
        widget: $props.widget
      }, {
        default: withCtx(({ rowWidthCalc, rowLeftWidthCalc, rowRightWidthCalc }) => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.tableData, (t, index2) => {
            return openBlock(), createBlock(_component_VirtualRow, {
              rowWidthCalc,
              key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
              "row-index": index2,
              class: "main",
              "table-key": $data.tableKey
            }, {
              default: withCtx(() => [
                $props.showControl ? (openBlock(), createBlock(_component_VirtualCell, {
                  key: 0,
                  width: "50px"
                })) : createCommentVNode("", true),
                rowLeftWidthCalc != "0px" ? (openBlock(), createBlock(_component_VirtualCell, {
                  key: 1,
                  width: `calc(${rowLeftWidthCalc})`
                }, null, 8, ["width"])) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
                  return openBlock(), createElementBlock(Fragment, null, [
                    $options.columnDisplay(column.model) && !column.options.fixedColumn ? (openBlock(), createBlock(_component_VirtualCell, {
                      key: column.key,
                      width: column.options.width
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_generate_form_item, {
                          models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                          rules: $props.rules,
                          widget: column,
                          remote: $props.remote,
                          blanks: $props.blanks,
                          display: $data.displayFields,
                          "sub-hide-fields": $data.tableHideFields,
                          "sub-disabled-fields": $data.tableDisabledFields,
                          edit: !$props.disableddata,
                          "remote-option": $props.remoteOption,
                          platform: $props.platform,
                          preview: $props.preview,
                          "container-key": $props.containerKey,
                          "data-source-value": $props.dataSourceValue,
                          "event-function": $props.eventFunction,
                          "print-read": $props.printRead,
                          "is-table": true,
                          "is-mobile": false,
                          "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                          "table-name": $props.name,
                          config: $props.config,
                          "is-dialog": $props.isDialog,
                          "dialog-name": $props.dialogName,
                          "is-group": false,
                          group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                          "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
                        }, createSlots({ _: 2 }, [
                          renderList($props.blanks, (blank) => {
                            return {
                              name: blank.name,
                              fn: withCtx((scope) => [
                                renderSlot(_ctx.$slots, blank.name, {
                                  model: scope.model
                                })
                              ])
                            };
                          })
                        ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "config", "is-dialog", "dialog-name", "group", "field-node"])
                      ]),
                      _: 2
                    }, 1032, ["width"])) : createCommentVNode("", true)
                  ], 64);
                }), 256)),
                rowRightWidthCalc != "0px" ? (openBlock(), createBlock(_component_VirtualCell, {
                  key: 2,
                  width: `calc(${rowRightWidthCalc})`
                }, null, 8, ["width"])) : createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["rowWidthCalc", "row-index", "table-key"]);
          }), 128))
        ]),
        left: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.tableData, (t, index2) => {
            return openBlock(), createBlock(_component_VirtualRow, {
              key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
              rowIndex: index2,
              class: "left",
              "table-key": $data.tableKey
            }, {
              default: withCtx(() => [
                $props.showControl ? (openBlock(), createBlock(_component_VirtualCell, {
                  key: 0,
                  width: "50px"
                }, {
                  default: withCtx(() => [
                    createElementVNode("div", _hoisted_5$5, [
                      createElementVNode("span", null, toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)
                    ]),
                    createElementVNode("div", _hoisted_6$4, [
                      !$props.printRead && $props.isDelete ? (openBlock(), createBlock(_component_a_popconfirm, {
                        key: 0,
                        disabled: $props.disableddata,
                        title: _ctx.$t("fm.description.deleteConfirm"),
                        onConfirm: ($event) => $options.handleRemove(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2)
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_a_button, {
                            disabled: $props.disableddata,
                            type: "primary",
                            danger: "",
                            shape: "circle",
                            size: "small"
                          }, {
                            default: withCtx(() => [
                              _hoisted_7$3
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 2
                      }, 1032, ["disabled", "title", "onConfirm"])) : createCommentVNode("", true),
                      $props.printRead || !$props.isDelete ? (openBlock(), createElementBlock("span", _hoisted_8$1, toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)) : createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1024)) : createCommentVNode("", true),
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
                  return openBlock(), createElementBlock(Fragment, null, [
                    $options.columnDisplay(column.model) && column.options.fixedColumn && column.options.fixedColumnPosition != "right" ? (openBlock(), createBlock(_component_VirtualCell, {
                      key: column.key,
                      width: column.options.width
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_generate_form_item, {
                          models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                          rules: $props.rules,
                          widget: column,
                          remote: $props.remote,
                          blanks: $props.blanks,
                          display: $data.displayFields,
                          "sub-hide-fields": $data.tableHideFields,
                          "sub-disabled-fields": $data.tableDisabledFields,
                          edit: !$props.disableddata,
                          "remote-option": $props.remoteOption,
                          platform: $props.platform,
                          preview: $props.preview,
                          "container-key": $props.containerKey,
                          "data-source-value": $props.dataSourceValue,
                          "event-function": $props.eventFunction,
                          "print-read": $props.printRead,
                          "is-table": true,
                          "is-mobile": false,
                          "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                          "table-name": $props.name,
                          config: $props.config,
                          "is-dialog": $props.isDialog,
                          "dialog-name": $props.dialogName,
                          "is-group": false,
                          group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                          "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
                        }, createSlots({ _: 2 }, [
                          renderList($props.blanks, (blank) => {
                            return {
                              name: blank.name,
                              fn: withCtx((scope) => [
                                renderSlot(_ctx.$slots, blank.name, {
                                  model: scope.model
                                })
                              ])
                            };
                          })
                        ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "config", "is-dialog", "dialog-name", "group", "field-node"])
                      ]),
                      _: 2
                    }, 1032, ["width"])) : createCommentVNode("", true)
                  ], 64);
                }), 256))
              ]),
              _: 2
            }, 1032, ["rowIndex", "table-key"]);
          }), 128))
        ]),
        right: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.tableData, (t, index2) => {
            return openBlock(), createBlock(_component_VirtualRow, {
              key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
              rowIndex: index2,
              class: "right",
              "table-key": $data.tableKey
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
                  return openBlock(), createElementBlock(Fragment, null, [
                    $options.columnDisplay(column.model) && column.options.fixedColumn && column.options.fixedColumnPosition == "right" ? (openBlock(), createBlock(_component_VirtualCell, {
                      key: column.key,
                      width: column.options.width
                    }, {
                      default: withCtx(() => [
                        createVNode(_component_generate_form_item, {
                          models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                          rules: $props.rules,
                          widget: column,
                          remote: $props.remote,
                          blanks: $props.blanks,
                          display: $data.displayFields,
                          "sub-hide-fields": $data.tableHideFields,
                          "sub-disabled-fields": $data.tableDisabledFields,
                          edit: !$props.disableddata,
                          "remote-option": $props.remoteOption,
                          platform: $props.platform,
                          preview: $props.preview,
                          "container-key": $props.containerKey,
                          "data-source-value": $props.dataSourceValue,
                          "event-function": $props.eventFunction,
                          "print-read": $props.printRead,
                          "is-table": true,
                          "is-mobile": false,
                          "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                          "table-name": $props.name,
                          config: $props.config,
                          "is-dialog": $props.isDialog,
                          "dialog-name": $props.dialogName,
                          "is-group": false,
                          group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                          "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
                        }, createSlots({ _: 2 }, [
                          renderList($props.blanks, (blank) => {
                            return {
                              name: blank.name,
                              fn: withCtx((scope) => [
                                renderSlot(_ctx.$slots, blank.name, {
                                  model: scope.model
                                })
                              ])
                            };
                          })
                        ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "config", "is-dialog", "dialog-name", "group", "field-node"])
                      ]),
                      _: 2
                    }, 1032, ["width"])) : createCommentVNode("", true)
                  ], 64);
                }), 256))
              ]),
              _: 2
            }, 1032, ["rowIndex", "table-key"]);
          }), 128))
        ]),
        _: 3
      }, 8, ["columns", "showControl", "paging", "pageSize", "currentPage", "displayFields", "group", "widget"])) : createCommentVNode("", true)
    ], 64)) : createCommentVNode("", true),
    $props.preview && $props.platform === "mobile" || !$props.preview && $data.mobileScreen ? (openBlock(), createElementBlock("div", {
      key: 1,
      class: "antd-form-table-mobile",
      style: normalizeStyle({ "display": $props.preview && $props.platform === "mobile" ? "block" : "" })
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.tableData, (t, index2) => {
        return openBlock(), createElementBlock("div", {
          class: "antd-form-table-mobile-item",
          key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2
        }, [
          $props.showControl ? (openBlock(), createElementBlock("div", _hoisted_9$1, [
            createElementVNode("span", null, "# " + toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1),
            !$props.printRead && $props.isDelete ? (openBlock(), createBlock(_component_a_popconfirm, {
              key: 0,
              disabled: $props.disableddata,
              title: _ctx.$t("fm.description.deleteConfirm"),
              onConfirm: ($event) => $options.handleRemove(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2)
            }, {
              default: withCtx(() => [
                createVNode(_component_a_button, {
                  disabled: $props.disableddata,
                  type: "primary",
                  danger: "",
                  shape: "circle",
                  size: "small"
                }, {
                  default: withCtx(() => [
                    _hoisted_10$1
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 2
            }, 1032, ["disabled", "title", "onConfirm"])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_11$1, [
            createVNode(_component_a_space, {
              direction: "vertical",
              style: { "width": "100%" }
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList($props.columns, (column) => {
                  return openBlock(), createBlock(_component_generate_form_item, {
                    key: column.key,
                    models: $data.tableData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                    rules: $props.rules,
                    widget: column,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $data.displayFields,
                    "sub-hide-fields": $data.tableHideFields,
                    "sub-disabled-fields": $data.tableDisabledFields,
                    edit: !$props.disableddata,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    "is-table": true,
                    "is-mobile": true,
                    "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                    "table-name": $props.name,
                    config: $props.config,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": false,
                    group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                    "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "table-name", "config", "is-dialog", "dialog-name", "group", "field-node"]);
                }), 128))
              ]),
              _: 2
            }, 1024)
          ])
        ]);
      }), 128))
    ], 4)) : createCommentVNode("", true),
    createVNode(_component_a_row, null, {
      default: withCtx(() => [
        createVNode(_component_a_col, {
          md: $props.preview && $props.platform != "mobile" || !$props.preview ? 12 : 24,
          xs: 24,
          sm: 24
        }, {
          default: withCtx(() => [
            !$props.disableddata && $props.isAdd ? (openBlock(), createBlock(_component_a_button, {
              key: 0,
              type: "link",
              onClick: $options.handleAddRow
            }, {
              default: withCtx(() => [
                _hoisted_12$1,
                createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.add")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["md"]),
        createVNode(_component_a_col, {
          md: ($props.preview && $props.platform != "mobile" || !$props.preview) && !$props.disableddata ? 12 : 24,
          xs: 24,
          sm: 24
        }, {
          default: withCtx(() => [
            $props.paging && $data.tableData.length ? (openBlock(), createBlock(_component_a_pagination, {
              key: 0,
              style: { "float": "right", "padding-top": "5px", "white-space": "nowrap" },
              layout: "total, prev, pager, next",
              "page-size": $props.pageSize,
              current: $data.currentPage,
              "onUpdate:current": _cache[0] || (_cache[0] = ($event) => $data.currentPage = $event),
              total: $data.tableData.length,
              "pager-count": 5,
              onChange: $options.handlePageChange,
              "show-less-items": ""
            }, null, 8, ["page-size", "current", "total", "onChange"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["md"])
      ]),
      _: 1
    })
  ], 2);
}
var FmFormTable = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$g]]);
var SubForm_vue_vue_type_style_index_0_lang = "";
const _sfc_main$h = {
  name: "fm-sub-form",
  components: {
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$1;
    })),
    GenerateFormItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateFormItem$1;
    })),
    GenerateInline: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenereteInline;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$1;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$1;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$1;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$1;
    }))
  },
  props: [
    "showControl",
    "config",
    "list",
    "value",
    "models",
    "remote",
    "blanks",
    "disableddata",
    "rules",
    "name",
    "remoteOption",
    "preview",
    "platform",
    "dataSourceValue",
    "eventFunction",
    "widget",
    "printRead",
    "paging",
    "pageSize",
    "containerKey",
    "isAdd",
    "isDelete",
    "isDialog",
    "dialogName",
    "group",
    "fieldNode"
  ],
  emits: ["update:value"],
  data() {
    var _a2;
    return {
      subformData: (_a2 = this.value) != null ? _a2 : [],
      displayFields: {},
      changeItem: {},
      pagingData: [],
      pagingLength: 0,
      currentPage: 1,
      itemModel: {},
      subHideFields: [],
      subDisabledFields: [],
      itemDisabled: {}
    };
  },
  created() {
    this._generateModel(this.list);
    this.loadPagingData();
    this.subHideFields = this.subformData.map((v) => Object.fromEntries(Object.keys(this.displayFields).map((field) => [field, !this.displayFields[field]])));
    this.subDisabledFields = this.subformData.map((v) => Object.fromEntries(Object.keys(this.itemDisabled).map((field) => [field, !this.itemDisabled[field]])));
  },
  provide() {
    return {
      "setSubformData": this.setSubformData
    };
  },
  inject: ["onFormDisabled", "onFormHide", "onFormDisplay"],
  methods: {
    handleMouseover(key) {
      addClass$1(this.$refs[`formSubformItem_${key}`][0], "is-hover");
    },
    handleMouseout(key) {
      removeClass$1(this.$refs[`formSubformItem_${key}`][0], "is-hover");
    },
    setSubformData(value, rowIndex, field) {
      this.subformData[rowIndex][field] = value;
    },
    setData(rowIndex, value) {
      if (typeof rowIndex !== "number") {
        return new Promise((resolve) => {
          value = rowIndex;
          this.subformData.forEach((_2, index2) => {
            Object.keys(value).forEach((item) => {
              this.setSubformData(value[item], index2, item);
            });
          });
          resolve();
        });
      }
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            this.setSubformData(value[item], rowIndex, item);
          });
          resolve();
        });
      });
    },
    handleAddRow() {
      this.subformData.push(_.cloneDeep(this.itemModel));
      this.subHideFields.push(
        Object.fromEntries(Object.keys(this.displayFields).map((field) => [field, !this.displayFields[field]]))
      );
      this.subDisabledFields.push(
        Object.fromEntries(Object.keys(this.itemDisabled).map((field) => [field, !this.itemDisabled[field]]))
      );
      if (this.widget && this.widget.events && this.widget.events.onRowAdd) {
        let funcKey = this.widget.events.onRowAdd;
        this.eventFunction[funcKey]({
          rowIndex: this.subformData.length - 1,
          field: this.widget.model,
          currentRef: this
        });
      }
      if (this.paging) {
        this.$nextTick(() => {
          if (this.subformData.length > this.currentPage * this.pageSize) {
            this.currentPage = parseInt((this.subformData.length - 1) / this.pageSize) + 1;
          }
          this.loadPagingData();
        });
      }
    },
    handleRemove(index2) {
      const removeData = { ...this.subformData[index2] };
      this.subformData.splice(index2, 1);
      this.subHideFields.splice(index2, 1);
      this.subDisabledFields.splice(index2, 1);
      if (this.widget && this.widget.events && this.widget.events.onRowRemove) {
        let funcKey = this.widget.events.onRowRemove;
        this.eventFunction[funcKey]({
          removeIndex: index2,
          removeData,
          field: this.widget.model,
          currentRef: this
        });
      }
      this.pagingData = [];
      this.pagingLength = 0;
      if (this.paging) {
        this.$nextTick(() => {
          if (this.subformData.length % this.pageSize == 0 && this.currentPage > parseInt(this.subformData.length / this.pageSize)) {
            this.currentPage = parseInt(this.subformData.length / this.pageSize);
          }
          this.loadPagingData();
        });
      }
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${field}`);
      });
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${field}`);
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this.subformData.forEach((_2, index2) => {
        fields.forEach((field) => {
          this.subDisabledFields[index2][field] = disabled;
        });
      });
      this._setDisabled(this.list, fields, disabled);
    },
    hideChild(rowIndex, fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${rowIndex}.${field}`);
      });
    },
    displayChild(rowIndex, fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${rowIndex}.${field}`);
      });
    },
    disabledChild(rowIndex, fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.subDisabledFields[rowIndex][field] = disabled;
        this.onFormDisabled(`${this.fieldNode}.${rowIndex}.${field}`, disabled);
      });
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setOptions(this.list, fields, options);
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.list, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.list, item.split("."), className, "remove");
      });
    },
    handlePageChange(val) {
      this.currentPage = val;
      this.pagingData = [];
      this.pagingLength = 0;
      this.$nextTick(() => {
        this.loadPagingData();
      });
      if (this.widget && this.widget.events && this.widget.events.onPageChange) {
        let funcKey = this.widget.events.onPageChange;
        this.eventFunction[funcKey]({
          currentPage: val,
          field: this.widget.model,
          currentRef: this
        });
      }
    },
    loadPagingData() {
      let beginIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = beginIndex + this.pageSize;
      this.pagingData = this.subformData.slice(beginIndex, endIndex);
      this.pagingLength = this.pagingData.length;
    },
    _generateModel(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type == "grid") {
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          genList[i].columns.forEach((item) => {
            this._generateModel(item.list);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._generateModel(column.list);
            });
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "inline") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "card") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else {
          if (genList[i].type == "blank") {
            this.itemModel[genList[i].model] = genList[i].options.defaultType === "String" ? "" : genList[i].options.defaultType === "Object" ? {} : [];
          } else {
            this.itemModel[genList[i].model] = _.cloneDeep(genList[i].options.defaultValue);
          }
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          this.itemDisabled[genList[i].model] = !genList[i].options.disabled;
        }
      }
    },
    _setDisabled(genList, fields, disabled) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setDisabled(column.list, fields, disabled);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else if (genList[i].type === "card") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else {
          if (fields.indexOf(genList[i].model) >= 0) {
            genList[i].options.disabled = disabled;
            this.itemDisabled[genList[i].model] = !disabled;
          }
        }
      }
    },
    _setOptions(genList, fields, opts) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setOptions(column.list, fields, opts);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setOptions(genList[i].list, fields, opts);
        } else if (genList[i].type === "card") {
          this._setOptions(genList[i].list, fields, opts);
        }
        if (fields.indexOf(genList[i].model) >= 0) {
          Object.keys(opts).forEach((key) => {
            genList[i].options[key] = opts[key];
          });
        }
      }
    }
  },
  watch: {
    value(val) {
      var _a2, _b, _c, _d, _e, _f;
      this.subformData = val;
      let hideFields = [];
      let disabledFields = [];
      for (let i = 0; i < this.value.length; i++) {
        let rowArray = Object.keys(this.displayFields);
        let hideRow = {};
        for (let f = 0; f < rowArray.length; f++) {
          hideRow[rowArray[f]] = (_c = (_b = (_a2 = this.subHideFields) == null ? void 0 : _a2[i]) == null ? void 0 : _b[rowArray[f]]) != null ? _c : !this.displayFields[rowArray[f]];
        }
        hideFields.push(hideRow);
        let disabledArray = Object.keys(this.itemDisabled);
        let disabledRow = {};
        for (let d = 0; d < disabledArray.length; d++) {
          disabledRow[disabledArray[d]] = (_f = (_e = (_d = this.subDisabledFields) == null ? void 0 : _d[i]) == null ? void 0 : _e[disabledArray[d]]) != null ? _f : !this.itemDisabled[disabledArray[d]];
        }
        disabledFields.push(disabledRow);
      }
      this.subHideFields = hideFields;
      this.subDisabledFields = disabledFields;
    },
    subformData: {
      deep: true,
      handler(val) {
        this.loadPagingData();
        this.$emit("update:value", val);
      }
    }
  }
};
const _hoisted_1$8 = { class: "form-subform" };
const _hoisted_2$7 = ["onMouseover", "onMouseout"];
const _hoisted_3$5 = {
  key: 0,
  class: "form-subform-index"
};
const _hoisted_4$4 = {
  key: 1,
  class: "form-subform-remove"
};
const _hoisted_5$4 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-trash",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
const _hoisted_6$3 = { class: "form-subform-content" };
const _hoisted_7$2 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-plus",
  style: { "font-size": "12px", "margin": "5px" }
}, null, -1);
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tag = resolveComponent("a-tag");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_popconfirm = resolveComponent("a-popconfirm");
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_a_col = resolveComponent("a-col");
  const _component_a_pagination = resolveComponent("a-pagination");
  const _component_a_row = resolveComponent("a-row");
  return openBlock(), createElementBlock("div", _hoisted_1$8, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($props.paging ? $data.pagingLength : $data.subformData, (t, index2) => {
      return openBlock(), createElementBlock("div", {
        class: "form-subform-item",
        key: ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
        onMouseover: withModifiers(($event) => $options.handleMouseover(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2), ["stop"]),
        onMouseout: ($event) => $options.handleMouseout(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2),
        ref_for: true,
        ref: `formSubformItem_${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
      }, [
        $props.showControl ? (openBlock(), createElementBlock("div", _hoisted_3$5, [
          createVNode(_component_a_tag, { color: "processing" }, {
            default: withCtx(() => [
              createTextVNode("#" + toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)
            ]),
            _: 2
          }, 1024)
        ])) : createCommentVNode("", true),
        $props.showControl ? (openBlock(), createElementBlock("div", _hoisted_4$4, [
          !$props.printRead && $props.isDelete ? (openBlock(), createBlock(_component_a_popconfirm, {
            key: 0,
            disabled: $props.disableddata,
            title: _ctx.$t("fm.description.deleteConfirm"),
            onConfirm: ($event) => $options.handleRemove(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2)
          }, {
            default: withCtx(() => [
              createVNode(_component_a_button, {
                disabled: $props.disableddata,
                type: "danger",
                size: "small",
                shape: "circle"
              }, {
                default: withCtx(() => [
                  _hoisted_5$4
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 2
          }, 1032, ["disabled", "title", "onConfirm"])) : createCommentVNode("", true),
          $props.printRead || !$props.isDelete ? (openBlock(), createBlock(_component_a_tag, {
            key: 1,
            color: "processing"
          }, {
            default: withCtx(() => [
              createTextVNode("#" + toDisplayString$1(($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2 + 1), 1)
            ]),
            _: 2
          }, 1024)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_6$3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.list, (item) => {
            return openBlock(), createElementBlock(Fragment, null, [
              item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                config: $props.config,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "config", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                config: $props.config,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "config", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                config: $props.config,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "config", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                config: $props.config,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "config", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                config: $props.config,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "config", "is-dialog", "dialog-name", "group", "field-node"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                key: item.key,
                model: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                element: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                config: $props.config,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "config", "is-dialog", "dialog-name", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                key: item.key,
                models: $data.subformData[($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2],
                rules: $props.rules,
                widget: item,
                remote: $props.remote,
                blanks: $props.blanks,
                display: $data.displayFields,
                "sub-hide-fields": $data.subHideFields,
                "sub-disabled-fields": $data.subDisabledFields,
                edit: !$props.disableddata,
                "remote-option": $props.remoteOption,
                platform: $props.platform,
                preview: $props.preview,
                "container-key": $props.containerKey,
                "data-source-value": $props.dataSourceValue,
                "event-function": $props.eventFunction,
                "print-read": $props.printRead,
                "is-subform": true,
                "row-index": ($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2,
                "sub-name": $props.name,
                config: $props.config,
                "is-dialog": $props.isDialog,
                "dialog-name": $props.dialogName,
                "is-group": false,
                group: $props.group ? `${$props.group}.${$props.name}` : $props.name,
                "field-node": `${$props.fieldNode}.${($props.paging ? $props.pageSize * ($data.currentPage - 1) : 0) + index2}`
              }, createSlots({ _: 2 }, [
                renderList($props.blanks, (blank) => {
                  return {
                    name: blank.name,
                    fn: withCtx((scope) => [
                      renderSlot(_ctx.$slots, blank.name, {
                        model: scope.model
                      })
                    ])
                  };
                })
              ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "row-index", "sub-name", "config", "is-dialog", "dialog-name", "group", "field-node"]))
            ], 64);
          }), 256))
        ])
      ], 40, _hoisted_2$7);
    }), 128)),
    createVNode(_component_a_row, { class: "form-subform-action" }, {
      default: withCtx(() => [
        createVNode(_component_a_col, {
          md: $props.preview && $props.platform != "mobile" || !$props.preview ? 12 : 24,
          sm: 24
        }, {
          default: withCtx(() => [
            !$props.disableddata && $props.isAdd ? (openBlock(), createBlock(_component_a_button, {
              key: 0,
              type: "link",
              onClick: $options.handleAddRow
            }, {
              default: withCtx(() => [
                _hoisted_7$2,
                createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.add")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["md"]),
        createVNode(_component_a_col, {
          md: ($props.preview && $props.platform != "mobile" || !$props.preview) && !$props.disableddata ? 12 : 24,
          xs: 24,
          sm: 24
        }, {
          default: withCtx(() => [
            $props.paging && $data.subformData.length ? (openBlock(), createBlock(_component_a_pagination, {
              key: 0,
              style: { "float": "right", "padding-top": "5px", "white-space": "nowrap" },
              layout: "total, prev, pager, next",
              "page-size": $props.pageSize,
              current: $data.currentPage,
              "onUpdate:current": _cache[0] || (_cache[0] = ($event) => $data.currentPage = $event),
              total: $data.subformData.length,
              "pager-count": 5,
              onChange: $options.handlePageChange,
              "show-less-items": ""
            }, null, 8, ["page-size", "current", "total", "onChange"])) : createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["md"])
      ]),
      _: 1
    })
  ]);
}
var FmSubForm = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$f]]);
const _sfc_main$g = {
  name: "fm-group",
  components: {
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$1;
    })),
    GenerateFormItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateFormItem$1;
    })),
    GenerateInline: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenereteInline;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$1;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$1;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$1;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$1;
    }))
  },
  props: ["config", "value", "models", "rules", "element", "remote", "blanks", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "group", "fieldNode"],
  data() {
    var _a2;
    return {
      displayFields: {},
      groupModel: (_a2 = this.value) != null ? _a2 : {},
      groupDisabled: {}
    };
  },
  emits: ["update:value"],
  inject: ["generateComponentInstance", "deleteComponentInstance", "getFormComponent", "onFormHide", "onFormDisplay"],
  created() {
    this._generateModel(this.element.list);
  },
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode, this.$refs[`generate-group-${this.element.model}`].$parent);
    this.$nextTick(() => {
      setTimeout(() => {
        this.clearValidate();
      });
    });
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode);
  },
  provide() {
    return {
      "setGroupData": this.setGroupData
    };
  },
  methods: {
    setGroupData(value, field) {
      this.groupModel[field] = value;
    },
    _generateModel(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type == "grid") {
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          genList[i].columns.forEach((item) => {
            this._generateModel(item.list);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._generateModel(column.list);
            });
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "inline") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "card") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else {
          if (genList[i].type == "blank") {
            this.groupModel[genList[i].model] = genList[i].options.defaultType === "String" ? "" : genList[i].options.defaultType === "Object" ? {} : [];
          } else {
            this.groupModel[genList[i].model] = _.cloneDeep(genList[i].options.defaultValue);
          }
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          this.groupDisabled[genList[i].model] = !genList[i].options.disabled;
        }
      }
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${field}`);
      });
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${field}`);
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setDisabled(this.element.list, fields, disabled);
    },
    validate() {
      return new Promise((resolve, reject) => {
        let realFields = this._getAllRuleFields();
        this.getFormComponent().validate(realFields).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
    },
    clearValidate() {
      let realFields = this._getAllRuleFields();
      this.getFormComponent().clearValidate(realFields);
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setOptions(this.element.list, fields, options);
    },
    setData(value) {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            this.groupModel[item] = value[item];
          });
          resolve();
        });
      });
    },
    getValues() {
      return this.groupModel;
    },
    getValue(fieldName) {
      return this.groupModel[fieldName];
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.element.list, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.element.list, item.split("."), className, "remove");
      });
    },
    _setDisabled(genList, fields, disabled) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setDisabled(column.list, fields, disabled);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else if (genList[i].type === "card") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else {
          if (fields.indexOf(genList[i].model) >= 0) {
            genList[i].options.disabled = disabled;
          }
        }
      }
    },
    _setOptions(genList, fields, opts) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setOptions(column.list, fields, opts);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setOptions(genList[i].list, fields, opts);
        } else if (genList[i].type === "card") {
          this._setOptions(genList[i].list, fields, opts);
        }
        if (fields.indexOf(genList[i].model) >= 0) {
          Object.keys(opts).forEach((key) => {
            genList[i].options[key] = opts[key];
          });
        }
      }
    },
    _getAllRuleFields() {
      let realFields = [];
      Object.keys(this.groupModel).forEach((v) => {
        if (Array.isArray(this.groupModel[v])) {
          const currentArray = this.groupModel[v];
          currentArray.forEach((o, i) => {
            Object.keys(o).forEach((key) => {
              realFields.push(`${this.fieldNode}.${v}.${i}.${key}`);
            });
          });
        } else {
          realFields.push(`${this.fieldNode}.${v}`);
        }
      });
      return realFields.map((item) => item.split("."));
    }
  },
  watch: {
    groupModel: {
      deep: true,
      handler(val) {
        this.$emit("update:value", val);
      }
    },
    value: {
      deep: true,
      handler(val) {
        this.groupModel = val;
      }
    }
  }
};
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  return openBlock(), createElementBlock("div", {
    style: normalizeStyle({
      width: $props.element.options.width
    }),
    ref: `generate-group-${$props.element.model}`
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.list, (item) => {
      return openBlock(), createElementBlock(Fragment, null, [
        item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode,
          config: $props.config
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node", "config"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode,
          config: $props.config
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node", "config"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode,
          config: $props.config
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node", "config"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode,
          config: $props.config
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node", "config"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode,
          config: $props.config
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node", "config"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
          key: item.key,
          model: $data.groupModel,
          rules: $props.rules,
          element: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode,
          config: $props.config
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node", "config"])) : (openBlock(), createBlock(_component_generate_form_item, {
          key: item.key,
          models: $data.groupModel,
          rules: $props.rules,
          widget: item,
          remote: $props.remote,
          blanks: $props.blanks,
          display: $data.displayFields,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          platform: $props.platform,
          preview: $props.preview,
          "container-key": $props.containerKey,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "print-read": $props.printRead,
          "is-group": true,
          "is-subform": false,
          group: $props.group ? $props.group + "." + $props.element.model : $props.element.model,
          "field-node": $props.fieldNode,
          config: $props.config
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "group", "field-node", "config"]))
      ], 64);
    }), 256))
  ], 4);
}
var FmGroup = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$e]]);
const _sfc_main$f = {
  name: "generate-element-item",
  components: {
    FmUpload,
    FmFormTable,
    FmFileUpload,
    Editor: _sfc_main$Z,
    FmSubForm,
    FmGroup
  },
  props: ["config", "widget", "modelValue", "models", "remote", "isTable", "blanks", "disabled", "edit", "remoteOption", "rules", "platform", "preview", "dataSourceValue", "eventFunction", "rowIndex", "tableName", "containerKey", "printRead", "isMobile", "isSubform", "subName", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  emits: ["on-table-change", "update:modelValue", "update:widget"],
  setup() {
    const useInjectFormItemContext = inject("useInjectFormItemContext");
    const formItemContext = useInjectFormItemContext ? useInjectFormItemContext() : null;
    return {
      formItemContext
    };
  },
  data() {
    var _a2, _b;
    return {
      dataModel: this.modelValue,
      dataModels: this.models,
      key: new Date().getTime(),
      modelName: this.widget.model,
      dataOnly: (_b = (_a2 = this.widget.options) == null ? void 0 : _a2.data) == null ? void 0 : _b.map((item) => ({ ...item, title: item.label })),
      remoteOptions: [],
      dynamicEvents: this.handleOnDynamicEvent(),
      generateDisabled: void 0
    };
  },
  computed: {
    elementDisabled() {
      if (typeof this.generateDisabled === "boolean") {
        return !this.edit || this.generateDisabled;
      } else {
        return !this.edit || this.widget.options.disabled;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "eventScriptConfig"],
  created() {
    if (this.widget.options.remote && (Object.keys(this.widget.options).indexOf("remoteType") >= 0 ? this.widget.options.remoteType == "func" : true) && this.remote[this.widget.options.remoteFunc]) {
      this.remote[this.widget.options.remoteFunc]((data2) => {
        this.loadOptions(data2);
      });
    }
    if (this.widget.options.remote && this.widget.options.remoteType == "option" && this.remoteOption[this.widget.options.remoteOption]) {
      this.loadOptions(this.remoteOption[this.widget.options.remoteOption]);
    }
    if (this.widget.options.remote && this.widget.options.remoteType == "datasource" && this.dataSourceValue) {
      let options = this.getDataSourceOptions();
      options && options.value && this.loadOptions(options.value);
    }
    if ((this.widget.type === "imgupload" || this.widget.type === "fileupload") && this.widget.options.isQiniu) {
      this.loadUploadConfig();
    }
    if (this.widget.type == "component") {
      const _pthis = this;
      this.$options.components[`component-${this.widget.key}-${this.key}`] = {
        template: `${this.widget.options.template}`,
        props: ["modelValue"],
        emits: ["update:modelValue"],
        data: () => ({
          dataModel: this.modelValue
        }),
        watch: {
          dataModel(val) {
            if (this.ui == "antd") {
              EventBus.$emit("on-field-change", this.$attrs.id, val);
            } else {
              this.$emit("update:modelValue", val);
            }
          },
          modelValue(val) {
            this.dataModel = val;
          }
        },
        methods: {
          triggerEvent(eventName, arg) {
            if (_pthis.eventScriptConfig()) {
              let currentEventScript = _pthis.eventScriptConfig().find((item) => item.name == eventName);
              if (currentEventScript) {
                if (_pthis.isTable && _pthis.tableName) {
                  _pthis.eventFunction[currentEventScript.key]({
                    field: _pthis.widget.model,
                    table: _pthis.tableName,
                    rowIndex: _pthis.rowIndex,
                    dialog: _pthis.isDialog ? _pthis.dialogName : null,
                    currentRef: this,
                    group: _pthis.group,
                    fieldNode: _pthis.fieldNode,
                    $eventArgs: arg
                  });
                } else if (_pthis.isSubform && _pthis.subName) {
                  _pthis.eventFunction[currentEventScript.key]({
                    field: _pthis.widget.model,
                    subform: _pthis.subName,
                    rowIndex: _pthis.rowIndex,
                    dialog: _pthis.isDialog ? _pthis.dialogName : null,
                    currentRef: this,
                    group: _pthis.group,
                    fieldNode: _pthis.fieldNode,
                    $eventArgs: arg
                  });
                } else if (_pthis.isDialog && _pthis.dialogName) {
                  _pthis.eventFunction[currentEventScript.key]({
                    field: _pthis.widget.model,
                    dialog: _pthis.dialogName,
                    currentRef: this,
                    group: _pthis.group,
                    fieldNode: _pthis.fieldNode,
                    $eventArgs: arg
                  });
                } else {
                  _pthis.eventFunction[currentEventScript.key]({
                    field: _pthis.widget.model,
                    currentRef: this,
                    group: _pthis.group,
                    fieldNode: _pthis.fieldNode,
                    $eventArgs: arg
                  });
                }
              }
            }
          }
        }
      };
    }
  },
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(
      this.fieldNode,
      this.$refs["fm-" + this.widget.model]
    );
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode);
    if (this.$options.components[`component-${this.widget.key}-${this.key}`]) {
      this.$options.components[`component-${this.widget.key}-${this.key}`] = null;
    }
  },
  methods: {
    handleOnDynamicEvent() {
      let currentEvents = {};
      for (let i in this.widget.events) {
        let funcKey = this.widget.events[i];
        funcKey && (currentEvents[i] = this.callbackDynamicFunc(funcKey));
      }
      return currentEvents;
    },
    callbackDynamicFunc(funcKey) {
      let callback = (...arg) => {
        if (this.isTable && this.tableName) {
          this.eventFunction[funcKey]({
            field: this.widget.model,
            table: this.tableName,
            rowIndex: this.rowIndex,
            dialog: this.isDialog ? this.dialogName : null,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            $eventArgs: arg
          });
        } else if (this.isSubform && this.subName) {
          this.eventFunction[funcKey]({
            field: this.widget.model,
            subform: this.subName,
            rowIndex: this.rowIndex,
            dialog: this.isDialog ? this.dialogName : null,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            $eventArgs: arg
          });
        } else if (this.isDialog && this.dialogName) {
          this.eventFunction[funcKey]({
            field: this.widget.model,
            dialog: this.dialogName,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            $eventArgs: arg
          });
        } else {
          this.eventFunction[funcKey]({
            field: this.widget.model,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            $eventArgs: arg
          });
        }
      };
      return callback;
    },
    loadOptions(data2) {
      if (!Array.isArray(data2))
        return;
      this.remoteOptions = data2.map((item) => {
        if (this.widget.options.props.children && this.widget.options.props.children.length && Object.keys(item).includes(this.widget.options.props.children)) {
          return {
            value: item[this.widget.options.props.value],
            label: item[this.widget.options.props.label],
            children: this.processRemoteProps(item[this.widget.options.props.children], this.widget.options.props)
          };
        } else {
          if (this.widget.type == "steps") {
            return {
              value: item[this.widget.options.props.title],
              label: item[this.widget.options.props.description]
            };
          } else if (this.widget.type == "transfer") {
            return {
              key: item[this.widget.options.props.key],
              title: item[this.widget.options.props.label],
              disabled: item[this.widget.options.props.disabled]
            };
          } else {
            return {
              value: item[this.widget.options.props.value],
              label: item[this.widget.options.props.label]
            };
          }
        }
      });
    },
    processRemoteProps(children, props2) {
      if (children && children.length) {
        return children.map((item) => {
          if (this.processRemoteProps(item[props2.children], props2).length) {
            return {
              value: item[props2.value],
              label: item[props2.label],
              children: this.processRemoteProps(item[props2.children], props2)
            };
          } else {
            return {
              value: item[props2.value],
              label: item[props2.label]
            };
          }
        });
      } else {
        return [];
      }
    },
    loadUploadConfig() {
      if (this.widget.options.tokenType === "func") {
        !this.widget.options.token && this.remote[this.widget.options.tokenFunc]((data2) => {
          this.widget.options.token = data2;
        });
      } else {
        if (this.dataSourceValue) {
          let token = this.getDataSourceOptions("tokenDataSource");
          token && token.value && (this.widget.options.token = token.value);
        }
      }
    },
    handleOnClick() {
      this.execFunction("onClick", {});
    },
    handleOnFocus() {
      this.execFunction("onFocus", {});
    },
    handleOnBlur() {
      this.execFunction("onBlur", {});
    },
    handleOnUploadSelect(file) {
      return this.execFunction("onSelect", { file });
    },
    handleOnUploadSuccess(file) {
      this.execFunction("onUploadSuccess", { file });
    },
    handleOnUploadError(file) {
      this.execFunction("onUploadError", { file });
    },
    handleOnUploadProgress(file) {
      this.execFunction("onUploadProgress", { file });
    },
    handleOnUploadRemove(file) {
      this.execFunction("onRemove", { file });
    },
    execFunction(method, arg) {
      if (this.widget.events && this.widget.events[method]) {
        let funcKey = this.widget.events[method];
        if (this.isTable && this.tableName) {
          return this.eventFunction[funcKey]({
            field: this.widget.model,
            table: this.tableName,
            rowIndex: this.rowIndex,
            dialog: this.isDialog ? this.dialogName : null,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            ...arg
          });
        } else if (this.isSubform && this.subName) {
          return this.eventFunction[funcKey]({
            field: this.widget.model,
            subform: this.subName,
            rowIndex: this.rowIndex,
            dialog: this.isDialog ? this.dialogName : null,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            ...arg
          });
        } else if (this.isDialog && this.dialogName) {
          return this.eventFunction[funcKey]({
            field: this.widget.model,
            dialog: this.subName,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            ...arg
          });
        } else {
          return this.eventFunction[funcKey]({
            field: this.widget.model,
            currentRef: this.$refs["fm-" + this.widget.model],
            group: this.group,
            fieldNode: this.fieldNode,
            ...arg
          });
        }
      }
    },
    getCascaderText(value, options, texts = []) {
      if (value.length >= 1) {
        let currentOpt = options == null ? void 0 : options.find((opt) => opt.value == value[0]);
        if (currentOpt) {
          texts.push(currentOpt.label);
        }
        value.splice(0, 1);
        return this.getCascaderText(value, currentOpt == null ? void 0 : currentOpt.children, texts);
      } else if (value.length == 0) {
        return texts;
      }
    },
    getTreeText(value, options) {
      for (let i = 0; i < options.length; i++) {
        let currentOpt = options[i];
        if (currentOpt.value == value) {
          return currentOpt.label;
        }
        if (currentOpt.children && currentOpt.children.length > 0) {
          let res = this.getTreeText(value, currentOpt.children);
          if (res == "-") {
            continue;
          } else {
            return res;
          }
        }
      }
      return "-";
    },
    getDataSourceOptions(remoteName = "remoteDataSource") {
      let key = this.group ? this.group + "." + this.widget.model + "." + this.widget.options[remoteName] : this.widget.model + "." + this.widget.options[remoteName];
      return this.dataSourceValue.find((item) => item.key === key);
    },
    disabledElement(disabled) {
      this.generateDisabled = disabled;
    }
  },
  watch: {
    modelValue(val) {
      this.dataModel = val;
    },
    dataModel(val, oldValue) {
      this.$emit("update:modelValue", val);
      setTimeout(() => {
        this.formItemContext && this.formItemContext.onFieldChange();
      });
    },
    "remoteOption": {
      deep: true,
      handler: function(val) {
        if (Object.keys(this.remoteOption).indexOf(this.widget.options.remoteOption) >= 0 && this.widget.options.remote && this.widget.options.remoteType == "option") {
          this.loadOptions(this.remoteOption[this.widget.options.remoteOption]);
        }
      }
    },
    "dataSourceValue": {
      deep: true,
      handler: function(val) {
        if (this.dataSourceValue) {
          let options = this.getDataSourceOptions();
          options && options.value && this.loadOptions(options.value);
        }
        if ((this.widget.type === "imgupload" || this.widget.type === "fileupload") && this.widget.options.isQiniu) {
          this.loadUploadConfig();
        }
      }
    }
  }
};
const _hoisted_1$7 = { key: 0 };
const _hoisted_2$6 = { key: 0 };
const _hoisted_3$4 = { key: 0 };
const _hoisted_4$3 = ["innerHTML"];
const _hoisted_5$3 = ["innerHTML"];
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b, _c, _d, _e;
  const _component_a_input_password = resolveComponent("a-input-password");
  const _component_a_input = resolveComponent("a-input");
  const _component_a_textarea = resolveComponent("a-textarea");
  const _component_a_input_number = resolveComponent("a-input-number");
  const _component_a_radio = resolveComponent("a-radio");
  const _component_a_radio_group = resolveComponent("a-radio-group");
  const _component_a_checkbox = resolveComponent("a-checkbox");
  const _component_a_checkbox_group = resolveComponent("a-checkbox-group");
  const _component_a_time_picker = resolveComponent("a-time-picker");
  const _component_a_time_range_picker = resolveComponent("a-time-range-picker");
  const _component_a_date_picker = resolveComponent("a-date-picker");
  const _component_a_range_picker = resolveComponent("a-range-picker");
  const _component_a_rate = resolveComponent("a-rate");
  const _component_a_select_option = resolveComponent("a-select-option");
  const _component_a_select = resolveComponent("a-select");
  const _component_a_switch = resolveComponent("a-switch");
  const _component_a_slider = resolveComponent("a-slider");
  const _component_fm_upload = resolveComponent("fm-upload");
  const _component_Editor = resolveComponent("Editor");
  const _component_a_cascader = resolveComponent("a-cascader");
  const _component_a_tree_select = resolveComponent("a-tree-select");
  const _component_fm_form_table = resolveComponent("fm-form-table");
  const _component_fm_sub_form = resolveComponent("fm-sub-form");
  const _component_fm_group = resolveComponent("fm-group");
  const _component_fm_file_upload = resolveComponent("fm-file-upload");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_step = resolveComponent("a-step");
  const _component_a_steps = resolveComponent("a-steps");
  const _component_a_pagination = resolveComponent("a-pagination");
  const _component_a_transfer = resolveComponent("a-transfer");
  return openBlock(), createElementBlock("span", {
    class: normalizeClass({ "print-read-label": $props.printRead })
  }, [
    $props.widget.type == "blank" ? (openBlock(), createElementBlock("div", {
      key: 0,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width })
    }, [
      renderSlot(_ctx.$slots, $props.widget.model, { model: $data.dataModels })
    ], 4)) : createCommentVNode("", true),
    $props.widget.type == "component" ? (openBlock(), createElementBlock("div", {
      key: 1,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width })
    }, [
      (openBlock(), createBlock(resolveDynamicComponent(`component-${$props.widget.key}-${$data.key}`), {
        key: $data.key,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.dataModel = $event),
        ref: "fm-" + $props.widget.model
      }, null, 8, ["modelValue"]))
    ], 4)) : createCommentVNode("", true),
    $props.widget.type == "custom" ? (openBlock(), createElementBlock("div", {
      key: 2,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width })
    }, [
      (openBlock(), createBlock(resolveDynamicComponent($props.widget.el), mergeProps({
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.dataModel = $event),
        width: $props.widget.options.width,
        height: $props.widget.options.height,
        size: $props.config.size,
        placeholder: $props.widget.options.placeholder,
        readonly: $props.widget.options.readonly,
        disabled: $options.elementDisabled,
        editable: $props.widget.options.editable,
        clearable: $props.widget.options.clearable,
        ref: "fm-" + $props.widget.model,
        "print-read": $props.printRead
      }, { ...$props.widget.options.customProps, ...$props.widget.options.extendProps }, toHandlers($data.dynamicEvents)), null, 16, ["modelValue", "width", "height", "size", "placeholder", "readonly", "disabled", "editable", "clearable", "print-read"]))
    ], 4)) : createCommentVNode("", true),
    $props.widget.type == "input" ? (openBlock(), createElementBlock(Fragment, { key: 3 }, [
      $props.printRead ? (openBlock(), createElementBlock("span", _hoisted_1$7, toDisplayString$1($data.dataModel), 1)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        $props.widget.options.showPassword ? (openBlock(), createBlock(_component_a_input_password, mergeProps({
          key: 0,
          type: $props.widget.options.dataTypeCheck ? $props.widget.options.dataType : "text",
          value: $data.dataModel,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event) => $data.dataModel = $event),
          disabled: $options.elementDisabled,
          placeholder: $props.widget.options.placeholder,
          style: { width: $props.isTable ? "100%" : $props.widget.options.width },
          ref: "fm-" + $props.widget.model,
          size: $props.config.size,
          "allow-clear": $props.widget.options.clearable
        }, $props.widget.options.customProps, {
          onFocus: $options.handleOnFocus,
          onBlur: $options.handleOnBlur,
          autocomplete: "off"
        }), null, 16, ["type", "value", "disabled", "placeholder", "style", "size", "allow-clear", "onFocus", "onBlur"])) : (openBlock(), createBlock(_component_a_input, mergeProps({
          key: 1,
          type: $props.widget.options.dataTypeCheck ? $props.widget.options.dataType : "text",
          value: $data.dataModel,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event) => $data.dataModel = $event),
          disabled: $options.elementDisabled,
          placeholder: $props.widget.options.placeholder,
          style: { width: $props.isTable ? "100%" : $props.widget.options.width },
          ref: "fm-" + $props.widget.model,
          size: $props.config.size,
          "allow-clear": $props.widget.options.clearable,
          maxlength: Number($props.widget.options.maxlength || Infinity),
          "show-count": $props.widget.options.showWordLimit
        }, $props.widget.options.customProps, {
          onFocus: $options.handleOnFocus,
          onBlur: $options.handleOnBlur,
          autocomplete: "off"
        }), null, 16, ["type", "value", "disabled", "placeholder", "style", "size", "allow-clear", "maxlength", "show-count", "onFocus", "onBlur"]))
      ], 64))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "textarea" ? (openBlock(), createElementBlock(Fragment, { key: 4 }, [
      $props.printRead ? (openBlock(), createElementBlock("pre", _hoisted_2$6, toDisplayString$1($data.dataModel), 1)) : (openBlock(), createBlock(_component_a_textarea, mergeProps({
        key: 1,
        type: "textarea",
        rows: $props.widget.options.rows,
        value: $data.dataModel,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        placeholder: $props.widget.options.placeholder,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        ref: "fm-" + $props.widget.model,
        "allow-clear": $props.widget.options.clearable,
        size: $props.config.size,
        maxlength: Number($props.widget.options.maxlength),
        "show-count": $props.widget.options.showWordLimit,
        autoSize: $props.widget.options.autosize
      }, $props.widget.options.customProps, {
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur
      }), null, 16, ["rows", "value", "disabled", "placeholder", "style", "allow-clear", "size", "maxlength", "show-count", "autoSize", "onFocus", "onBlur"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "number" ? (openBlock(), createElementBlock(Fragment, { key: 5 }, [
      $props.printRead ? (openBlock(), createElementBlock("span", _hoisted_3$4, toDisplayString$1($data.dataModel.toFixed($props.widget.options.precision)), 1)) : (openBlock(), createBlock(_component_a_input_number, mergeProps({
        key: 1,
        value: $data.dataModel,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event) => $data.dataModel = $event),
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        step: $props.widget.options.step,
        disabled: $options.elementDisabled,
        min: $props.widget.options.min,
        max: $props.widget.options.max,
        "controls-position": $props.widget.options.controlsPosition,
        precision: $props.widget.options.precision,
        controls: $props.widget.options.controls,
        ref: "fm-" + $props.widget.model,
        size: $props.config.size
      }, $props.widget.options.customProps, {
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur
      }), null, 16, ["value", "style", "step", "disabled", "min", "max", "controls-position", "precision", "controls", "size", "onFocus", "onBlur"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "radio" ? (openBlock(), createElementBlock(Fragment, { key: 6 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1($data.remoteOptions.find((item) => item.value == $data.dataModel) && $data.remoteOptions.find((item) => item.value == $data.dataModel).label), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($props.widget.options.showLabel ? $props.widget.options.options.find((item) => item.value == $data.dataModel) && $props.widget.options.options.find((item) => item.value == $data.dataModel).label : $data.dataModel), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_a_radio_group, mergeProps({
        key: 1,
        value: $data.dataModel,
        "onUpdate:value": _cache[6] || (_cache[6] = ($event) => $data.dataModel = $event),
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        disabled: $options.elementDisabled,
        size: $props.config.size,
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options, (item, index2) => {
            return openBlock(), createBlock(_component_a_radio, {
              style: normalizeStyle({ display: $props.widget.options.inline ? "inline-block" : "block" }),
              value: item.value,
              key: index2
            }, {
              default: withCtx(() => [
                $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createTextVNode(toDisplayString$1(item.label), 1)
                ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString$1($props.widget.options.showLabel ? item.label : item.value), 1)
                ], 64))
              ]),
              _: 2
            }, 1032, ["style", "value"]);
          }), 128))
        ]),
        _: 1
      }, 16, ["value", "style", "disabled", "size"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "checkbox" ? (openBlock(), createElementBlock(Fragment, { key: 7 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1($data.dataModel.map(
            (dm) => $data.remoteOptions.find((item) => item.value == dm) && $data.remoteOptions.find((item) => item.value == dm).label
          ).join("\u3001")), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($props.widget.options.showLabel ? $data.dataModel.map((dm) => $props.widget.options.options.find((item) => item.value == dm) && $props.widget.options.options.find((item) => item.value == dm).label).join("\u3001") : $data.dataModel.join("\u3001")), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_a_checkbox_group, mergeProps({
        key: 1,
        value: $data.dataModel,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event) => $data.dataModel = $event),
        style: {
          width: $props.isTable ? "100%" : $props.widget.options.width,
          display: "flex",
          "flex-wrap": "wrap",
          "flex-direction": $props.widget.options.inline ? "row" : "column"
        },
        disabled: $options.elementDisabled,
        size: $props.config.size,
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options, (item, index2) => {
            return openBlock(), createBlock(_component_a_checkbox, {
              style: {
                "line-height": "30px"
              },
              value: item.value,
              key: index2
            }, {
              default: withCtx(() => [
                $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  createTextVNode(toDisplayString$1(item.label), 1)
                ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString$1($props.widget.options.showLabel ? item.label : item.value), 1)
                ], 64))
              ]),
              _: 2
            }, 1032, ["value"]);
          }), 128))
        ]),
        _: 1
      }, 16, ["value", "style", "disabled", "size"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "time" ? (openBlock(), createElementBlock(Fragment, { key: 8 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        !$props.widget.options.isRange ? (openBlock(), createBlock(_component_a_time_picker, mergeProps({
          key: 0,
          value: $data.dataModel,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event) => $data.dataModel = $event),
          placeholder: $props.widget.options.placeholder,
          "start-placeholder": $props.widget.options.startPlaceholder,
          "end-placeholder": $props.widget.options.endPlaceholder,
          readonly: $props.widget.options.readonly,
          disabled: $options.elementDisabled,
          inputReadOnly: !$props.widget.options.editable,
          clearable: $props.widget.options.clearable,
          arrowControl: $props.widget.options.arrowControl,
          "value-format": $props.widget.options.format,
          format: $props.widget.options.format,
          style: { width: $props.isTable ? "100%" : $props.widget.options.width },
          ref: "fm-" + $props.widget.model,
          size: $props.config.size,
          onFocus: $options.handleOnFocus,
          onBlur: $options.handleOnBlur,
          popupClassName: "fm-popup-index"
        }, $props.widget.options.customProps), null, 16, ["value", "placeholder", "start-placeholder", "end-placeholder", "readonly", "disabled", "inputReadOnly", "clearable", "arrowControl", "value-format", "format", "style", "size", "onFocus", "onBlur"])) : (openBlock(), createBlock(_component_a_time_range_picker, mergeProps({
          key: 1,
          value: $data.dataModel,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event) => $data.dataModel = $event),
          placeholder: [$props.widget.options.startPlaceholder, $props.widget.options.endPlaceholder],
          readonly: $props.widget.options.readonly,
          disabled: $options.elementDisabled,
          inputReadOnly: !$props.widget.options.editable,
          clearable: $props.widget.options.clearable,
          arrowControl: $props.widget.options.arrowControl,
          "value-format": $props.widget.options.format,
          format: $props.widget.options.format,
          style: { width: $props.isTable ? "100%" : $props.widget.options.width },
          ref: "fm-" + $props.widget.model,
          size: $props.config.size,
          onFocus: $options.handleOnFocus,
          onBlur: $options.handleOnBlur,
          popupClassName: "fm-popup-index"
        }, $props.widget.options.customProps), null, 16, ["value", "placeholder", "readonly", "disabled", "inputReadOnly", "clearable", "arrowControl", "value-format", "format", "style", "size", "onFocus", "onBlur"]))
      ], 64))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "date" ? (openBlock(), createElementBlock(Fragment, { key: 9 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($props.widget.options.type == "dates" ? $data.dataModel.join("\u3001") : typeof $data.dataModel == "object" ? $data.dataModel.join(" ~ ") : $data.dataModel), 1)
      ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        $props.widget.options.type != "dates" && $props.widget.options.type != "daterange" && $props.widget.options.type != "datetimerange" && $props.widget.options.type != "monthrange" ? (openBlock(), createBlock(_component_a_date_picker, mergeProps({
          key: 0,
          value: $data.dataModel,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event) => $data.dataModel = $event),
          picker: $props.widget.options.type == "datetime" ? "date" : $props.widget.options.type,
          placeholder: $props.widget.options.placeholder,
          "start-placeholder": $props.widget.options.startPlaceholder,
          "end-placeholder": $props.widget.options.endPlaceholder,
          readonly: $props.widget.options.readonly,
          disabled: $options.elementDisabled,
          inputReadOnly: !$props.widget.options.editable,
          clearable: $props.widget.options.clearable,
          "value-format": $props.widget.options.timestamp ? "timestamp" : $props.widget.options.format,
          format: $props.widget.options.format,
          style: { width: $props.isTable ? "100%" : $props.widget.options.width },
          ref: "fm-" + $props.widget.model,
          size: $props.config.size,
          onFocus: $options.handleOnFocus,
          onBlur: $options.handleOnBlur,
          "show-time": $props.widget.options.type == "datetime",
          popupClassName: "fm-popup-index"
        }, $props.widget.options.customProps), null, 16, ["value", "picker", "placeholder", "start-placeholder", "end-placeholder", "readonly", "disabled", "inputReadOnly", "clearable", "value-format", "format", "style", "size", "onFocus", "onBlur", "show-time"])) : createCommentVNode("", true),
        $props.widget.options.type == "daterange" || $props.widget.options.type == "datetimerange" || $props.widget.options.type == "monthrange" ? (openBlock(), createBlock(_component_a_range_picker, mergeProps({
          key: 1,
          value: $data.dataModel,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event) => $data.dataModel = $event),
          placeholder: [$props.widget.options.startPlaceholder, $props.widget.options.endPlaceholder],
          readonly: $props.widget.options.readonly,
          disabled: $options.elementDisabled,
          inputReadOnly: !$props.widget.options.editable,
          clearable: $props.widget.options.clearable,
          "value-format": $props.widget.options.format,
          format: $props.widget.options.format,
          style: { width: $props.isTable ? "100%" : $props.widget.options.width },
          ref: "fm-" + $props.widget.model,
          size: $props.config.size,
          onFocus: $options.handleOnFocus,
          onBlur: $options.handleOnBlur,
          "show-time": $props.widget.options.type == "datetimerange",
          picker: $props.widget.options.type == "monthrange" ? "month" : "date",
          popupClassName: "fm-popup-index"
        }, $props.widget.options.customProps), null, 16, ["value", "placeholder", "readonly", "disabled", "inputReadOnly", "clearable", "value-format", "format", "style", "size", "onFocus", "onBlur", "show-time", "picker"])) : createCommentVNode("", true)
      ], 64))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "rate" ? (openBlock(), createElementBlock(Fragment, { key: 10 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_a_rate, mergeProps({
        key: 1,
        value: $data.dataModel,
        "onUpdate:value": _cache[12] || (_cache[12] = ($event) => $data.dataModel = $event),
        max: $props.widget.options.max,
        count: $props.widget.options.max,
        disabled: $options.elementDisabled,
        "allow-half": $props.widget.options.allowHalf,
        "show-score": $props.widget.options.showScore,
        ref: "fm-" + $props.widget.model,
        size: $props.config.size,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width }
      }, $props.widget.options.customProps), null, 16, ["value", "max", "count", "disabled", "allow-half", "show-score", "size", "style"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "color" ? (openBlock(), createElementBlock("div", {
      key: 11,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width, color: "#999" })
    }, " Not currently supported. ", 4)) : createCommentVNode("", true),
    $props.widget.type == "select" ? (openBlock(), createElementBlock(Fragment, { key: 12 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1(typeof $data.dataModel == "object" ? $data.dataModel.map((dm) => $data.remoteOptions.find((item) => item.value == dm) && $data.remoteOptions.find((item) => item.value == dm).label).join("\u3001") : $data.remoteOptions.find((item) => item.value == $data.dataModel) && $data.remoteOptions.find((item) => item.value == $data.dataModel).label), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($props.widget.options.showLabel ? typeof $data.dataModel == "object" ? $data.dataModel.map((dm) => $props.widget.options.options.find((item) => item.value == dm) && $props.widget.options.options.find((item) => item.value == dm).label).join("\u3001") : $props.widget.options.options.find((item) => item.value == $data.dataModel) && $props.widget.options.options.find((item) => item.value == $data.dataModel).label : typeof $data.dataModel == "object" ? $data.dataModel.join("\u3001") : $data.dataModel), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_a_select, mergeProps({
        key: 1,
        value: $data.dataModel,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        mode: $props.widget.options.multiple ? "multiple" : "default",
        "allow-clear": $props.widget.options.clearable,
        placeholder: $props.widget.options.placeholder,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        "show-search": $props.widget.options.filterable,
        "option-filter-prop": "label",
        ref: "fm-" + $props.widget.model,
        size: $props.config.size,
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur,
        popupClassName: "fm-select-dropdown"
      }, $props.widget.options.customProps), {
        default: withCtx(() => [
          (openBlock(true), createElementBlock(Fragment, null, renderList($props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options, (item) => {
            return openBlock(), createBlock(_component_a_select_option, {
              key: item.value,
              value: item.value,
              label: $props.widget.options.showLabel || $props.widget.options.remote ? item.label : item.value
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString$1($props.widget.options.showLabel || $props.widget.options.remote ? item.label : item.value), 1)
              ]),
              _: 2
            }, 1032, ["value", "label"]);
          }), 128))
        ]),
        _: 1
      }, 16, ["value", "disabled", "mode", "allow-clear", "placeholder", "style", "show-search", "size", "onFocus", "onBlur"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "switch" ? (openBlock(), createElementBlock(Fragment, { key: 13 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_a_switch, {
        key: 1,
        checked: $data.dataModel,
        "onUpdate:checked": _cache[14] || (_cache[14] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        ref: "fm-" + $props.widget.model,
        size: $props.config.size
      }, null, 8, ["checked", "disabled", "size"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "slider" ? (openBlock(), createElementBlock(Fragment, { key: 14 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        createTextVNode(toDisplayString$1($data.dataModel), 1)
      ], 64)) : (openBlock(), createBlock(_component_a_slider, mergeProps({
        key: 1,
        value: $data.dataModel,
        "onUpdate:value": _cache[15] || (_cache[15] = ($event) => $data.dataModel = $event),
        min: $props.widget.options.min,
        max: $props.widget.options.max,
        disabled: $options.elementDisabled,
        step: $props.widget.options.step,
        "show-input": $props.widget.options.showInput,
        range: $props.widget.options.range,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        ref: "fm-" + $props.widget.model,
        size: $props.config.size
      }, $props.widget.options.customProps), null, 16, ["value", "min", "max", "disabled", "step", "show-input", "range", "style", "size"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "imgupload" ? (openBlock(), createBlock(_component_fm_upload, {
      key: 15,
      modelValue: $data.dataModel,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => $data.dataModel = $event),
      disabled: $options.elementDisabled,
      readonly: $props.widget.options.readonly || $props.printRead,
      style: normalizeStyle({ "width": $props.isTable ? "100%" : $props.widget.options.width }),
      width: $props.widget.options.size.width,
      height: $props.widget.options.size.height,
      token: $props.widget.options.token,
      domain: $props.widget.options.domain,
      multiple: $props.widget.options.multiple,
      limit: $props.widget.options.limit,
      "is-qiniu": $props.widget.options.isQiniu,
      "is-delete": $props.widget.options.isDelete,
      min: $props.widget.options.min,
      "is-edit": $props.widget.options.isEdit,
      action: $props.widget.options.action,
      ui: "antd",
      headers: $props.widget.options.headers || [],
      ref: "fm-" + $props.widget.model,
      withCredentials: $props.widget.options.withCredentials,
      onOnUploadSuccess: $options.handleOnUploadSuccess,
      onOnUploadError: $options.handleOnUploadError,
      onOnUploadRemove: $options.handleOnUploadRemove,
      onOnUploadProgress: $options.handleOnUploadProgress,
      "on-select": $options.handleOnUploadSelect,
      "print-read": $props.printRead,
      size: $props.config.size
    }, null, 8, ["modelValue", "disabled", "readonly", "style", "width", "height", "token", "domain", "multiple", "limit", "is-qiniu", "is-delete", "min", "is-edit", "action", "headers", "withCredentials", "onOnUploadSuccess", "onOnUploadError", "onOnUploadRemove", "onOnUploadProgress", "on-select", "print-read", "size"])) : createCommentVNode("", true),
    $props.widget.type == "editor" ? (openBlock(), createElementBlock(Fragment, { key: 16 }, [
      $props.printRead ? (openBlock(), createElementBlock("div", {
        key: 0,
        innerHTML: $data.dataModel,
        class: "ql-editor"
      }, null, 8, _hoisted_4$3)) : (openBlock(), createBlock(_component_Editor, {
        key: 1,
        modelValue: $data.dataModel,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => $data.dataModel = $event),
        "custom-style": { width: $props.isTable ? "100%" : $props.widget.options.width, cursor: $options.elementDisabled ? "no-drop" : "", backgroundColor: $options.elementDisabled ? "#F5F7FA" : "" },
        toolbar: $props.widget.options.customToolbar,
        disabled: $options.elementDisabled,
        ref: "fm-" + $props.widget.model
      }, null, 8, ["modelValue", "custom-style", "toolbar", "disabled"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "cascader" ? (openBlock(), createElementBlock(Fragment, { key: 17 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1($props.widget.options.multiple ? $data.dataModel.map((dm) => $options.getCascaderText([...dm], $data.remoteOptions).join(" / ")).join("\u3001") : $options.getCascaderText([...$data.dataModel], $data.remoteOptions).join(" / ")), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($props.widget.options.multiple ? $data.dataModel.map((dm) => $options.getCascaderText([...dm], $props.widget.options.options).join(" / ")).join("\u3001") : $options.getCascaderText([...$data.dataModel], $props.widget.options.options).join(" / ")), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_a_cascader, mergeProps({
        key: 1,
        value: $data.dataModel,
        "onUpdate:value": _cache[18] || (_cache[18] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        "allow-clear": $props.widget.options.clearable,
        placeholder: $props.widget.options.placeholder,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        options: $props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options,
        ref: "fm-" + $props.widget.model,
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur,
        showSearch: $props.widget.options.filterable,
        "change-on-select": $props.widget.options.checkStrictly,
        popupClassName: "fm-popup-index",
        multiple: $props.widget.options.multiple,
        size: $props.config.size
      }, $props.widget.options.customProps), null, 16, ["value", "disabled", "allow-clear", "placeholder", "style", "options", "onFocus", "onBlur", "showSearch", "change-on-select", "multiple", "size"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "treeselect" ? (openBlock(), createElementBlock(Fragment, { key: 18 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1(typeof $data.dataModel == "object" ? $data.dataModel.map((dm) => $options.getTreeText(dm, $data.remoteOptions)).join("\u3001") : $options.getTreeText($data.dataModel, $data.remoteOptions)), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1(typeof $data.dataModel == "object" ? $data.dataModel.map((dm) => $options.getTreeText(dm, $props.widget.options.options)).join("\u3001") : $options.getTreeText($data.dataModel, $props.widget.options.options)), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_a_tree_select, mergeProps({
        key: 1,
        value: $data.dataModel,
        "onUpdate:value": _cache[19] || (_cache[19] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        "allow-clear": $props.widget.options.clearable,
        placeholder: $props.widget.options.placeholder,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        "tree-data": $props.widget.options.remote ? $data.remoteOptions : $props.widget.options.options,
        ref: "fm-" + $props.widget.model,
        onFocus: $options.handleOnFocus,
        onBlur: $options.handleOnBlur,
        multiple: $props.widget.options.multiple,
        showSearch: $props.widget.options.filterable,
        popupClassName: "fm-popup-index",
        size: $props.config.size
      }, $props.widget.options.customProps), null, 16, ["value", "disabled", "allow-clear", "placeholder", "style", "tree-data", "onFocus", "onBlur", "multiple", "showSearch", "size"]))
    ], 64)) : createCommentVNode("", true),
    $props.widget.type == "text" ? (openBlock(), createElementBlock("span", {
      key: 19,
      ref: "fm-" + $props.widget.model,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width || "100%", display: "inline-block" })
    }, toDisplayString$1($data.dataModel), 5)) : createCommentVNode("", true),
    $props.widget.type == "html" ? (openBlock(), createElementBlock("span", {
      key: 20,
      innerHTML: $data.dataModel,
      ref: "fm-" + $props.widget.model,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width || "100%", display: "inline-block" })
    }, null, 12, _hoisted_5$3)) : createCommentVNode("", true),
    $props.widget.type == "table" ? (openBlock(), createBlock(_component_fm_form_table, {
      key: 21,
      value: $data.dataModel,
      "onUpdate:value": _cache[20] || (_cache[20] = ($event) => $data.dataModel = $event),
      columns: $props.widget.tableColumns,
      models: $data.dataModels,
      remote: $props.remote,
      blanks: $props.blanks,
      disableddata: $options.elementDisabled || $props.printRead,
      rules: $props.rules,
      name: $props.widget.model,
      "remote-option": $props.remoteOption,
      ref: "fm-" + $props.widget.model,
      preview: $props.preview,
      platform: $props.platform,
      "data-source-value": $props.dataSourceValue,
      "event-function": $props.eventFunction,
      widget: $props.widget,
      "container-key": $props.containerKey,
      "print-read": $props.printRead,
      paging: $props.widget.options.paging,
      "page-size": $props.widget.options.pageSize,
      config: $props.config,
      "is-add": (_a2 = $props.widget.options.isAdd) != null ? _a2 : true,
      "is-delete": (_b = $props.widget.options.isDelete) != null ? _b : true,
      "show-control": (_c = $props.widget.options.showControl) != null ? _c : true,
      "is-dialog": $props.isDialog,
      "dialog-name": $props.dialogName,
      "is-group": $props.isGroup,
      group: $props.group,
      "field-node": $props.fieldNode
    }, createSlots({ _: 2 }, [
      renderList($props.blanks, (blank) => {
        return {
          name: blank.name,
          fn: withCtx((scope) => [
            renderSlot(_ctx.$slots, blank.name, {
              model: scope.model
            })
          ])
        };
      })
    ]), 1032, ["value", "columns", "models", "remote", "blanks", "disableddata", "rules", "name", "remote-option", "preview", "platform", "data-source-value", "event-function", "widget", "container-key", "print-read", "paging", "page-size", "config", "is-add", "is-delete", "show-control", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : createCommentVNode("", true),
    $props.widget.type == "subform" ? (openBlock(), createBlock(_component_fm_sub_form, {
      key: 22,
      value: $data.dataModel,
      "onUpdate:value": _cache[21] || (_cache[21] = ($event) => $data.dataModel = $event),
      list: $props.widget.list,
      models: $data.dataModels,
      remote: $props.remote,
      blanks: $props.blanks,
      disableddata: $options.elementDisabled || $props.printRead,
      rules: $props.rules,
      name: $props.widget.model,
      "remote-option": $props.remoteOption,
      ref: "fm-" + $props.widget.model,
      preview: $props.preview,
      platform: $props.platform,
      "data-source-value": $props.dataSourceValue,
      "event-function": $props.eventFunction,
      widget: $props.widget,
      "print-read": $props.printRead,
      paging: $props.widget.options.paging,
      "page-size": $props.widget.options.pageSize,
      config: $props.config,
      "container-key": $props.containerKey,
      "show-control": $props.widget.options.showControl,
      "is-delete": (_d = $props.widget.options.isDelete) != null ? _d : true,
      "is-add": (_e = $props.widget.options.isAdd) != null ? _e : true,
      "is-dialog": $props.isDialog,
      "dialog-name": $props.dialogName,
      "is-group": $props.isGroup,
      group: $props.group,
      "field-node": $props.fieldNode
    }, createSlots({ _: 2 }, [
      renderList($props.blanks, (blank) => {
        return {
          name: blank.name,
          fn: withCtx((scope) => [
            renderSlot(_ctx.$slots, blank.name, {
              model: scope.model
            })
          ])
        };
      })
    ]), 1032, ["value", "list", "models", "remote", "blanks", "disableddata", "rules", "name", "remote-option", "preview", "platform", "data-source-value", "event-function", "widget", "print-read", "paging", "page-size", "config", "container-key", "show-control", "is-delete", "is-add", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : createCommentVNode("", true),
    $props.widget.type == "group" ? (openBlock(), createBlock(_component_fm_group, {
      key: 23,
      value: $data.dataModel,
      "onUpdate:value": _cache[22] || (_cache[22] = ($event) => $data.dataModel = $event),
      rules: $props.rules,
      element: $props.widget,
      remote: $props.remote,
      blanks: $props.blanks,
      edit: !$options.elementDisabled,
      "remote-option": $props.remoteOption,
      platform: $props.platform,
      preview: $props.preview,
      "container-key": $props.containerKey,
      "data-source-value": $props.dataSourceValue,
      "event-function": $props.eventFunction,
      "print-read": $props.printRead,
      ref: "fm-" + $props.widget.model,
      "is-group": $props.isGroup,
      group: $props.group,
      "field-node": $props.fieldNode,
      config: $props.config
    }, createSlots({ _: 2 }, [
      renderList($props.blanks, (blank) => {
        return {
          name: blank.name,
          fn: withCtx((scope) => [
            renderSlot(_ctx.$slots, blank.name, {
              model: scope.model
            })
          ])
        };
      })
    ]), 1032, ["value", "rules", "element", "remote", "blanks", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "is-group", "group", "field-node", "config"])) : createCommentVNode("", true),
    $props.widget.type == "fileupload" ? (openBlock(), createBlock(_component_fm_file_upload, {
      key: 24,
      modelValue: $data.dataModel,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => $data.dataModel = $event),
      disabled: $options.elementDisabled,
      style: normalizeStyle({ "width": $props.isTable ? "100%" : $props.widget.options.width }),
      token: $props.widget.options.token,
      domain: $props.widget.options.domain,
      multiple: $props.widget.options.multiple,
      limit: $props.widget.options.limit,
      "is-qiniu": $props.widget.options.isQiniu,
      min: $props.widget.options.min,
      action: $props.widget.options.action,
      ui: "antd",
      headers: $props.widget.options.headers || [],
      ref: "fm-" + $props.widget.model,
      withCredentials: $props.widget.options.withCredentials,
      "print-read": $props.printRead,
      onOnUploadSuccess: $options.handleOnUploadSuccess,
      onOnUploadError: $options.handleOnUploadError,
      onOnUploadRemove: $options.handleOnUploadRemove,
      onOnUploadProgress: $options.handleOnUploadProgress,
      "on-select": $options.handleOnUploadSelect,
      size: $props.config.size
    }, null, 8, ["modelValue", "disabled", "style", "token", "domain", "multiple", "limit", "is-qiniu", "min", "action", "headers", "withCredentials", "print-read", "onOnUploadSuccess", "onOnUploadError", "onOnUploadRemove", "onOnUploadProgress", "on-select", "size"])) : createCommentVNode("", true),
    $props.widget.type == "button" ? (openBlock(), createBlock(_component_a_button, mergeProps({
      key: 25,
      disabled: $options.elementDisabled,
      size: $props.widget.options.buttonSize,
      type: $props.widget.options.buttonType == "text" ? "link" : $props.widget.options.buttonType || "default",
      shape: $props.widget.options.buttonCircle ? "circle" : $props.widget.options.buttonRound ? "round" : null,
      ghost: $props.widget.options.buttonPlain,
      style: { width: $props.widget.options.width },
      ref: "fm-" + $props.widget.model,
      onClick: $options.handleOnClick
    }, $props.widget.options.customProps), {
      default: withCtx(() => [
        createTextVNode(toDisplayString$1($props.widget.options.buttonName), 1)
      ]),
      _: 1
    }, 16, ["disabled", "size", "type", "shape", "ghost", "style", "onClick"])) : createCommentVNode("", true),
    $props.widget.type == "link" ? (openBlock(), createElementBlock("div", {
      key: 26,
      style: normalizeStyle({ width: $props.isTable ? "100%" : $props.widget.options.width, color: "#999" })
    }, [
      createVNode(_component_a_button, mergeProps({
        type: "link",
        danger: $props.widget.options.linkType == "danger",
        disabled: $options.elementDisabled,
        href: $props.widget.options.href,
        target: $props.widget.options.blank ? "_blank" : "_self",
        ref: "fm-" + $props.widget.model,
        onClick: $options.handleOnClick,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width }
      }, $props.widget.options.customProps), {
        default: withCtx(() => [
          createTextVNode(toDisplayString$1($props.widget.options.linkName), 1)
        ]),
        _: 1
      }, 16, ["danger", "disabled", "href", "target", "onClick", "style"])
    ], 4)) : createCommentVNode("", true),
    $props.widget.type == "steps" ? (openBlock(), createBlock(_component_a_steps, mergeProps({
      key: 27,
      current: $data.dataModel,
      ref: "fm-" + $props.widget.model,
      space: $props.widget.options.space,
      direction: $props.widget.options.direction,
      status: $props.widget.options.processStatus,
      style: { "line-height": "normal" }
    }, $props.widget.options.customProps), {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.widget.options.remote ? $data.remoteOptions : $props.widget.options.steps, (item, index2) => {
          return openBlock(), createBlock(_component_a_step, {
            key: index2,
            title: $props.widget.options.remote ? item.value : item.title,
            description: $props.widget.options.remote ? item.label : item.description
          }, null, 8, ["title", "description"]);
        }), 128))
      ]),
      _: 1
    }, 16, ["current", "space", "direction", "status"])) : createCommentVNode("", true),
    $props.widget.type == "pagination" ? (openBlock(), createBlock(_component_a_pagination, mergeProps({
      key: 28,
      current: $data.dataModel,
      "onUpdate:current": _cache[24] || (_cache[24] = ($event) => $data.dataModel = $event),
      "page-size": $props.widget.options.pageSize,
      "pager-count": $props.widget.options.pagerCount,
      disabled: $props.widget.options.disabled,
      background: $props.widget.options.background,
      total: $props.widget.options.total,
      "show-total": (total) => `${_ctx.$t("fm.config.widget.total")} ${total}`,
      "show-less-items": "",
      "show-size-changer": false,
      size: $props.widget.options.background ? "" : "small",
      ref: "fm-" + $props.widget.model
    }, $props.widget.options.customProps), null, 16, ["current", "page-size", "pager-count", "disabled", "background", "total", "show-total", "size"])) : createCommentVNode("", true),
    $props.widget.type == "transfer" ? (openBlock(), createElementBlock(Fragment, { key: 29 }, [
      $props.printRead ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
        $props.widget.options.remote ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createTextVNode(toDisplayString$1($data.dataModel.map((dm) => {
            var _a3;
            return (_a3 = $data.remoteOptions.find((item) => item.key == dm)) == null ? void 0 : _a3.title;
          }).join("\u3001")), 1)
        ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          createTextVNode(toDisplayString$1($data.dataModel.map((dm) => {
            var _a3;
            return (_a3 = $props.widget.options.data.find((item) => item.key == dm)) == null ? void 0 : _a3.label;
          }).join("\u3001")), 1)
        ], 64))
      ], 64)) : (openBlock(), createBlock(_component_a_transfer, mergeProps({
        key: 1,
        "target-keys": $data.dataModel,
        "onUpdate:targetKeys": _cache[25] || (_cache[25] = ($event) => $data.dataModel = $event),
        disabled: $options.elementDisabled,
        "data-source": $props.widget.options.remote ? $data.remoteOptions : $data.dataOnly,
        render: (item) => `${item.title}`,
        showSearch: $props.widget.options.filterable,
        titles: $props.widget.options.titles,
        style: { width: $props.isTable ? "100%" : $props.widget.options.width },
        ref: "fm-" + $props.widget.model
      }, $props.widget.options.customProps), null, 16, ["target-keys", "disabled", "data-source", "render", "showSearch", "titles", "style"]))
    ], 64)) : createCommentVNode("", true)
  ], 2);
}
var GenerateElementItem = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$d]]);
var GenerateElementItem$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateElementItem
}, Symbol.toStringTag, { value: "Module" }));
var GenerateFormItem_vue_vue_type_style_index_0_lang = "";
const __default__$1 = {
  components: {
    GenerateElementItem
  },
  props: [
    "config",
    "widget",
    "models",
    "rules",
    "remote",
    "blanks",
    "display",
    "edit",
    "remoteOption",
    "platform",
    "preview",
    "containerKey",
    "dataSourceValue",
    "eventFunction",
    "printRead",
    "isSubform",
    "rowIndex",
    "subName",
    "subHideFields",
    "subDisabledFields",
    "isDialog",
    "dialogName",
    "group",
    "fieldNode",
    "isGroup",
    "isTable",
    "isMobile",
    "tableName"
  ],
  data() {
    return {
      dataModel: this.models[this.widget.model],
      dataModels: this.models
    };
  },
  computed: {
    labelWidth() {
      return this.widget.options.hideLabel ? "0px" : this.widget.options.isLabelWidth ? this.widget.options.labelWidth + "px" : this.config.labelWidth + "px";
    },
    ruleProp() {
      let currentProp = this.widget.model;
      if (this.group) {
        currentProp = this.group + "." + currentProp;
      }
      return currentProp;
    },
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model) || this.formHideFields.includes(this.group ? this.group + "." + this.widget.model : this.widget.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: {
    setSubformData: {
      default: () => {
      }
    },
    setDialogData: {
      default: () => {
      }
    },
    setGroupData: {
      default: () => {
      }
    },
    setTableData: {
      default: () => {
      }
    },
    getFormComponent: {
      default: () => {
        return null;
      }
    },
    onChange: {
      default: () => {
      }
    },
    formHideFields: {
      default: []
    }
  },
  methods: {},
  watch: {
    dataModel: {
      deep: true,
      handler(val, oldValue) {
        var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
        if (this.isTable) {
          this.setTableData(val, this.rowIndex, this.widget.model);
        } else if (this.isSubform) {
          this.setSubformData(val, this.rowIndex, this.widget.model);
        } else if (this.isDialog) {
          this.setDialogData(val, this.widget.model);
        } else if (this.isGroup) {
          this.setGroupData(val, this.widget.model);
        } else {
          this.onChange(val, this.widget.model);
        }
        if (this.widget.events && this.widget.events.onChange && ((_a2 = this.$refs) == null ? void 0 : _a2["generateElementItem"])) {
          let funcKey = this.widget.events.onChange;
          if (this.isTable) {
            this.eventFunction[funcKey]({
              value: val,
              field: this.widget.model,
              rowIndex: this.rowIndex,
              table: this.tableName,
              dialog: this.isDialog ? this.dialogName : null,
              currentRef: (_d = (_c = (_b = this.$refs) == null ? void 0 : _b["generateElementItem"]) == null ? void 0 : _c.$refs) == null ? void 0 : _d[`fm-${this.widget.model}`],
              group: this.group,
              fieldNode: this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model
            });
          } else if (this.isSubform) {
            this.eventFunction[funcKey]({
              value: val,
              field: this.widget.model,
              rowIndex: this.rowIndex,
              subform: this.subName,
              dialog: this.isDialog ? this.dialogName : null,
              currentRef: (_g = (_f = (_e = this.$refs) == null ? void 0 : _e["generateElementItem"]) == null ? void 0 : _f.$refs) == null ? void 0 : _g[`fm-${this.widget.model}`],
              group: this.group,
              fieldNode: this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model
            });
          } else if (this.isDialog) {
            this.eventFunction[funcKey]({
              value: val,
              field: this.widget.model,
              dialog: this.dialogName,
              currentRef: (_j = (_i = (_h = this.$refs) == null ? void 0 : _h["generateElementItem"]) == null ? void 0 : _i.$refs) == null ? void 0 : _j[`fm-${this.widget.model}`],
              group: this.group,
              fieldNode: this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model
            });
          } else {
            this.eventFunction[funcKey]({
              value: val,
              field: this.widget.model,
              currentRef: (_m = (_l = (_k = this.$refs) == null ? void 0 : _k["generateElementItem"]) == null ? void 0 : _l.$refs) == null ? void 0 : _m[`fm-${this.widget.model}`],
              group: this.group,
              fieldNode: this.fieldNode ? this.fieldNode + "." + this.widget.model : this.widget.model
            });
          }
        }
      }
    },
    models: {
      deep: true,
      handler(val) {
        this.dataModels = val;
        this.dataModel = val[this.widget.model];
      }
    }
  }
};
const __injectCSSVars__$1 = () => {
  useCssVars((_ctx) => ({
    "37b16e80": _ctx.labelWidth
  }));
};
const __setup__$1 = __default__$1.setup;
__default__$1.setup = __setup__$1 ? (props2, ctx) => {
  __injectCSSVars__$1();
  return __setup__$1(props2, ctx);
} : __injectCSSVars__$1;
const _sfc_main$e = __default__$1;
const _hoisted_1$6 = ["data-id"];
const _hoisted_2$5 = ["innerHTML"];
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2;
  const _component_generate_element_item = resolveComponent("generate-element-item");
  const _component_a_form_item = resolveComponent("a-form-item");
  const _component_a_divider = resolveComponent("a-divider");
  const _component_a_alert = resolveComponent("a-alert");
  return $props.widget.key ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: "fm-form-item",
    "data-id": $props.widget.model
  }, [
    $props.widget.type != "divider" && $props.widget.type != "alert" && $options.elementDisplay ? (openBlock(), createBlock(_component_a_form_item, {
      name: $props.fieldNode ? [...$props.fieldNode.split("."), $props.widget.model] : $props.widget.model,
      rules: $props.rules[$options.ruleProp],
      class: normalizeClass({
        [$props.widget.options && $props.widget.options.customClass]: $props.widget.options && $props.widget.options.customClass ? true : false,
        "no-label-form-item": $props.widget.options.isLabelWidth && $props.widget.options.labelWidth == 0,
        "no-label-left": $props.widget.name === "",
        "fm-label-wrap": $props.widget.options.labelWrap
      }),
      label: $props.widget.options.hideLabel || $props.isTable && !$props.isMobile ? "" : $props.widget.name,
      key: $props.widget.key,
      required: $props.widget.options.required,
      ref: "generateFormItem",
      colon: ((_a2 = $props.config) == null ? void 0 : _a2.labelSuffix) ? true : false,
      validateFirst: ""
    }, {
      default: withCtx(() => [
        $props.widget.options.tip ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "fm-item-tooltip",
          innerHTML: $props.widget.options.tip.replace(/\n/g, "<br/>")
        }, null, 8, _hoisted_2$5)) : createCommentVNode("", true),
        (openBlock(), createBlock(_component_generate_element_item, {
          blanks: $props.blanks,
          "is-table": $props.isTable,
          "table-name": $props.tableName,
          widget: $props.widget,
          models: $data.dataModels,
          remote: $props.remote,
          edit: $props.edit,
          "remote-option": $props.remoteOption,
          key: $props.widget.key,
          rules: $props.rules,
          modelValue: $data.dataModel,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.dataModel = $event),
          platform: $props.platform,
          preview: $props.preview,
          "data-source-value": $props.dataSourceValue,
          "event-function": $props.eventFunction,
          "container-key": $props.containerKey,
          "print-read": $props.printRead,
          config: $props.config,
          "is-subform": $props.isSubform,
          "row-index": $props.rowIndex,
          "sub-name": $props.subName,
          "is-dialog": $props.isDialog,
          "dialog-name": $props.dialogName,
          ref: "generateElementItem",
          "is-group": $props.isGroup,
          group: $props.group,
          "field-node": $props.fieldNode ? $props.fieldNode + "." + $props.widget.model : $props.widget.model
        }, createSlots({ _: 2 }, [
          renderList($props.blanks, (blank) => {
            return {
              name: blank.name,
              fn: withCtx((scope) => [
                renderSlot(_ctx.$slots, blank.name, {
                  model: scope.model
                })
              ])
            };
          })
        ]), 1032, ["blanks", "is-table", "table-name", "widget", "models", "remote", "edit", "remote-option", "rules", "modelValue", "platform", "preview", "data-source-value", "event-function", "container-key", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
      ]),
      _: 3
    }, 8, ["name", "rules", "class", "label", "required", "colon"])) : createCommentVNode("", true),
    $props.widget.type == "divider" && $options.elementDisplay ? (openBlock(), createBlock(_component_a_form_item, {
      key: 1,
      wrapperCol: { span: 0, offset: 0 }
    }, {
      default: withCtx(() => [
        createVNode(_component_a_divider, mergeProps({
          orientation: $props.widget.options.contentPosition
        }, $props.widget.options.customProps), {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1($props.widget.name), 1)
          ]),
          _: 1
        }, 16, ["orientation"])
      ]),
      _: 1
    })) : createCommentVNode("", true),
    $props.widget.type == "alert" && $options.elementDisplay ? (openBlock(), createBlock(_component_a_form_item, {
      key: 2,
      wrapperCol: { span: 0, offset: 0 }
    }, {
      default: withCtx(() => [
        createVNode(_component_a_alert, mergeProps({
          message: $props.widget.options.title,
          type: $props.widget.options.type,
          description: $props.widget.options.description,
          closable: $props.widget.options.closable,
          center: $props.widget.options.center,
          "show-icon": $props.widget.options.showIcon,
          effect: $props.widget.options.effect,
          style: { width: $props.widget.options.width }
        }, $props.widget.options.customProps, {
          onClose: _cache[1] || (_cache[1] = ($event) => $props.display[$props.widget.model] = false)
        }), null, 16, ["message", "type", "description", "closable", "center", "show-icon", "effect", "style"])
      ]),
      _: 1
    })) : createCommentVNode("", true)
  ], 8, _hoisted_1$6)) : createCommentVNode("", true);
}
var GenerateFormItem = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$c]]);
var GenerateFormItem$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateFormItem
}, Symbol.toStringTag, { value: "Module" }));
var GenereteInline_vue_vue_type_style_index_0_lang = "";
const _sfc_main$d = {
  name: "generate-inline",
  components: {
    GenerateFormItem
  },
  props: ["config", "element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  data() {
    return {
      dataModels: this.model
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {},
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = this.model;
      }
    }
  }
};
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_form_item = resolveComponent("generate-form-item");
  return $options.elementDisplay ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["fm-inline-container", {
      [$props.element.options && $props.element.options.customClass]: $props.element.options && $props.element.options.customClass ? true : false
    }])
  }, [
    (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.list, (item) => {
      return openBlock(), createBlock(_component_generate_form_item, {
        key: item.key,
        models: $data.dataModels,
        rules: $props.rules,
        widget: item,
        remote: $props.remote,
        blanks: $props.blanks,
        display: $props.display,
        "sub-hide-fields": $props.subHideFields,
        "sub-disabled-fields": $props.subDisabledFields,
        edit: $props.edit,
        "remote-option": $props.remoteOption,
        platform: $props.platform,
        preview: $props.preview,
        "container-key": $props.containerKey,
        "data-source-value": $props.dataSourceValue,
        "event-function": $props.eventFunction,
        "print-read": $props.printRead,
        config: $props.config,
        "is-subform": $props.isSubform,
        "row-index": $props.rowIndex,
        "sub-name": $props.subName,
        "is-dialog": $props.isDialog,
        "dialog-name": $props.dialogName,
        style: normalizeStyle({ "margin-right": $props.element.options.spaceSize + "px" }),
        "is-group": $props.isGroup,
        group: $props.group,
        "field-node": $props.fieldNode
      }, createSlots({ _: 2 }, [
        renderList($props.blanks, (blank) => {
          return {
            name: blank.name,
            fn: withCtx((scope) => [
              renderSlot(_ctx.$slots, blank.name, {
                model: scope.model
              })
            ])
          };
        })
      ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "style", "is-group", "group", "field-node"]);
    }), 128))
  ], 2)) : createCommentVNode("", true);
}
var GenerateInline = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$b]]);
var GenereteInline = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateInline
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$c = {
  name: "generate-col-item",
  components: {
    GenerateFormItem,
    GenerateInline,
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$1;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$1;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$1;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$1;
    }))
  },
  props: ["config", "element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "group", "fieldNode", "isGroup"],
  data() {
    return {
      dataModels: this.model,
      hideCols: []
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {
    getColXS(options) {
      if (this.preview) {
        if (this.platform == "pc") {
          return options.md;
        }
        if (this.platform == "pad") {
          return options.sm;
        }
        if (this.platform == "mobile") {
          return options.xs;
        }
      } else {
        return options.xs;
      }
    },
    getColSM(options) {
      if (this.preview) {
        if (this.platform == "pc") {
          return options.md;
        }
        if (this.platform == "pad") {
          return options.sm;
        }
        if (this.platform == "mobile") {
          return options.xs;
        }
      } else {
        return options.sm;
      }
    },
    getColMD(options) {
      if (this.preview) {
        if (this.platform == "pc") {
          return options.md;
        }
        if (this.platform == "pad") {
          return options.sm;
        }
        if (this.platform == "mobile") {
          return options.xs;
        }
      } else {
        return options.md;
      }
    },
    hideCol(index2) {
      !this.hideCols.includes(index2) && this.hideCols.push(index2);
    },
    displayCol(index2) {
      if (this.hideCols.includes(index2)) {
        this.hideCols.splice(this.hideCols.indexOf(index2), 1);
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = val;
      }
    }
  }
};
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item", true);
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_a_col = resolveComponent("a-col");
  const _component_a_row = resolveComponent("a-row");
  return $options.elementDisplay ? (openBlock(), createBlock(_component_a_row, {
    key: 0,
    class: normalizeClass({
      [$props.element.options && $props.element.options.customClass]: $props.element.options && $props.element.options.customClass ? true : false
    }),
    type: $props.element.options.flex ? "flex" : "",
    gutter: $props.element.options.gutter || 0,
    justify: $props.element.options.justify,
    align: $props.element.options.align
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.columns, (item, index2) => {
        return openBlock(), createElementBlock(Fragment, { key: index2 }, [
          !$data.hideCols.includes(index2) ? (openBlock(), createBlock(_component_a_col, {
            key: 0,
            xs: item.options ? $options.getColXS(item.options) : item.span,
            sm: item.options ? $options.getColXS(item.options) : item.span,
            md: item.options ? $options.getColSM(item.options) : item.span,
            lg: item.options ? $options.getColMD(item.options) : item.span,
            offset: item.options ? item.options.offset : 0,
            push: item.options ? item.options.push : 0,
            pull: item.options ? item.options.pull : 0,
            class: normalizeClass({
              [item.options && item.options.customClass]: item.options && item.options.customClass ? true : false
            })
          }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(item.list, (col) => {
                return openBlock(), createElementBlock(Fragment, null, [
                  col.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    config: $props.config,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    config: $props.config,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    config: $props.config,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    config: $props.config,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    config: $props.config,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : col.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                    key: col.key,
                    model: $data.dataModels,
                    rules: $props.rules,
                    element: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    config: $props.config,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                    key: col.key,
                    models: $data.dataModels,
                    rules: $props.rules,
                    widget: col,
                    remote: $props.remote,
                    blanks: $props.blanks,
                    display: $props.display,
                    "sub-hide-fields": $props.subHideFields,
                    "sub-disabled-fields": $props.subDisabledFields,
                    edit: $props.edit,
                    "remote-option": $props.remoteOption,
                    platform: $props.platform,
                    preview: $props.preview,
                    "container-key": $props.containerKey,
                    "data-source-value": $props.dataSourceValue,
                    "event-function": $props.eventFunction,
                    "print-read": $props.printRead,
                    config: $props.config,
                    "is-subform": $props.isSubform,
                    "row-index": $props.rowIndex,
                    "sub-name": $props.subName,
                    "is-dialog": $props.isDialog,
                    "dialog-name": $props.dialogName,
                    "is-group": $props.isGroup,
                    group: $props.group,
                    "field-node": $props.fieldNode
                  }, createSlots({ _: 2 }, [
                    renderList($props.blanks, (blank) => {
                      return {
                        name: blank.name,
                        fn: withCtx((scope) => [
                          renderSlot(_ctx.$slots, blank.name, {
                            model: scope.model
                          })
                        ])
                      };
                    })
                  ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
                ], 64);
              }), 256))
            ]),
            _: 2
          }, 1032, ["xs", "sm", "md", "lg", "offset", "push", "pull", "class"])) : createCommentVNode("", true)
        ], 64);
      }), 128))
    ]),
    _: 3
  }, 8, ["class", "type", "gutter", "justify", "align"])) : createCommentVNode("", true);
}
var GenerateColItem = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$a]]);
var GenerateColItem$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateColItem
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$b = {
  name: "generate-tab-item",
  components: {
    GenerateFormItem,
    GenerateInline,
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$1;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$1;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$1;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$1;
    }))
  },
  props: ["config", "element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "isGroup", "group", "fieldNode"],
  data() {
    return {
      dataModels: this.model,
      tabActive: this.element.tabs.length ? this.element.tabs[0].name : ""
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {
    activateTab(label) {
      const currentTab = this.element.tabs.find((item) => item.label == label);
      if (currentTab) {
        this.tabActive = currentTab.name;
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = this.model;
      }
    }
  }
};
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_tab_item = resolveComponent("generate-tab-item", true);
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_a_tab_pane = resolveComponent("a-tab-pane");
  const _component_a_tabs = resolveComponent("a-tabs");
  return $options.elementDisplay ? (openBlock(), createBlock(_component_a_tabs, {
    key: 0,
    activeKey: $data.tabActive,
    "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event) => $data.tabActive = $event),
    type: $props.element.options.type ? "card" : "line",
    "tab-position": $props.element.options.tabPosition,
    class: normalizeClass({
      [$props.element.options.customClass]: $props.element.options.customClass ? true : false
    }),
    style: { "margin-bottom": "18px" }
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.tabs, (item) => {
        return openBlock(), createBlock(_component_a_tab_pane, {
          key: item.name,
          tab: item.label,
          name: item.name
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(item.list, (tab) => {
              return openBlock(), createElementBlock(Fragment, null, [
                tab.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                  key: tab.key,
                  models: $data.dataModels,
                  rules: $props.rules,
                  widget: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
              ], 64);
            }), 256))
          ]),
          _: 2
        }, 1032, ["tab", "name"]);
      }), 128))
    ]),
    _: 3
  }, 8, ["activeKey", "type", "tab-position", "class"])) : createCommentVNode("", true);
}
var GenerateTabItem = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$9]]);
var GenerateTabItem$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateTabItem
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$a = {
  name: "generate-report",
  components: {
    GenerateFormItem,
    GenerateInline,
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$1;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$1;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$1;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$1;
    }))
  },
  props: ["config", "element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "isGroup", "group", "fieldNode"],
  data() {
    return {
      dataModels: this.model
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {},
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = this.model;
      }
    }
  }
};
const _hoisted_1$5 = { class: "fm-report-table__wrapper" };
const _hoisted_2$4 = ["colspan", "rowspan"];
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_report = resolveComponent("generate-report", true);
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    $options.elementDisplay ? (openBlock(), createElementBlock("table", {
      key: 0,
      class: normalizeClass(["fm-report-table__table", {
        [$props.element.options && $props.element.options.customClass]: $props.element.options && $props.element.options.customClass ? true : false
      }]),
      style: normalizeStyle({
        "border-top-width": $props.element.options.borderWidth + "px",
        "border-top-color": $props.element.options.borderColor,
        "border-left-width": $props.element.options.borderWidth + "px",
        "border-left-color": $props.element.options.borderColor,
        "width": $props.element.options.width || "auto"
      })
    }, [
      createElementVNode("tr", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.headerRow, (th, i) => {
          return openBlock(), createElementBlock("th", {
            key: i,
            style: normalizeStyle({
              "width": th.options.width,
              "height": 0,
              "padding": 0
            })
          }, null, 4);
        }), 128))
      ]),
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.rows, (row, rIndex) => {
        return openBlock(), createElementBlock("tr", { key: rIndex }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(row.columns, (column, i) => {
            return openBlock(), createElementBlock(Fragment, {
              key: rIndex + "-" + i
            }, [
              !column.options.invisible ? (openBlock(), createElementBlock("td", {
                key: 0,
                style: normalizeStyle({
                  "border-right-width": $props.element.options.borderWidth + "px",
                  "border-right-color": $props.element.options.borderColor,
                  "border-bottom-width": $props.element.options.borderWidth + "px",
                  "border-bottom-color": $props.element.options.borderColor,
                  "width": column.options.width,
                  "height": column.options.height || "40px",
                  "min-height": "40px"
                }),
                colspan: column.options.colspan,
                rowspan: column.options.rowspan,
                class: normalizeClass(["fm-report-table__td", {
                  [column.options.customClass]: column.options.customClass ? true : false
                }]),
                valign: "top"
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(column.list, (columnElement) => {
                  return openBlock(), createElementBlock(Fragment, null, [
                    columnElement.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                      key: columnElement.key,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      config: $props.config,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                      key: columnElement.key,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      config: $props.config,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                      key: columnElement.key,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      config: $props.config,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                      key: columnElement.key,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      config: $props.config,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                      key: columnElement.key,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      config: $props.config,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : columnElement.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                      key: columnElement.key,
                      model: $data.dataModels,
                      rules: $props.rules,
                      element: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      config: $props.config,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                      key: columnElement.key,
                      models: $data.dataModels,
                      rules: $props.rules,
                      widget: columnElement,
                      remote: $props.remote,
                      blanks: $props.blanks,
                      display: $props.display,
                      "sub-hide-fields": $props.subHideFields,
                      "sub-disabled-fields": $props.subDisabledFields,
                      edit: $props.edit,
                      "remote-option": $props.remoteOption,
                      platform: $props.platform,
                      preview: $props.preview,
                      "container-key": $props.containerKey,
                      "data-source-value": $props.dataSourceValue,
                      "event-function": $props.eventFunction,
                      "print-read": $props.printRead,
                      config: $props.config,
                      "is-subform": $props.isSubform,
                      "row-index": $props.rowIndex,
                      "sub-name": $props.subName,
                      "is-dialog": $props.isDialog,
                      "dialog-name": $props.dialogName,
                      "is-group": $props.isGroup,
                      group: $props.group,
                      "field-node": $props.fieldNode
                    }, createSlots({ _: 2 }, [
                      renderList($props.blanks, (blank) => {
                        return {
                          name: blank.name,
                          fn: withCtx((scope) => [
                            renderSlot(_ctx.$slots, blank.name, {
                              model: scope.model
                            })
                          ])
                        };
                      })
                    ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
                  ], 64);
                }), 256))
              ], 14, _hoisted_2$4)) : createCommentVNode("", true)
            ], 64);
          }), 128))
        ]);
      }), 128))
    ], 6)) : createCommentVNode("", true)
  ]);
}
var GenerateReport = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$8]]);
var GenerateReport$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateReport
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$9 = {
  name: "generate-collapse",
  components: {
    GenerateFormItem,
    GenerateInline,
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$1;
    })),
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$1;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$1;
    })),
    GenerateCard: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCard$1;
    }))
  },
  props: ["config", "element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "isGroup", "group", "fieldNode"],
  data() {
    return {
      dataModels: this.model,
      tabActive: this.element.tabs.length ? [this.element.tabs[0].name] : ""
    };
  },
  computed: {
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  methods: {
    activateCollapse(title) {
      if (typeof title === "string") {
        const currentCollapse = this.element.tabs.find((item) => item.title == title);
        if (currentCollapse) {
          this.tabActive = currentCollapse.name;
        }
      }
      if (typeof title === "object" && Array.isArray(title)) {
        const collapses = title.map((item) => {
          const current = this.element.tabs.find((iitem) => iitem.title == item);
          if (current) {
            return current.name;
          }
          return "";
        });
        this.tabActive = collapses;
      }
    }
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = this.model;
      }
    }
  }
};
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse", true);
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_a_collapse_panel = resolveComponent("a-collapse-panel");
  const _component_a_collapse = resolveComponent("a-collapse");
  return $options.elementDisplay ? (openBlock(), createBlock(_component_a_collapse, {
    key: 0,
    activeKey: $data.tabActive,
    "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event) => $data.tabActive = $event),
    accordion: $props.element.options.accordion,
    class: normalizeClass({
      [$props.element.options.customClass]: $props.element.options.customClass ? true : false
    }),
    style: { "margin-bottom": "18px" }
  }, {
    default: withCtx(() => [
      (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.tabs, (item) => {
        return openBlock(), createBlock(_component_a_collapse_panel, {
          key: item.name,
          header: item.title
        }, {
          default: withCtx(() => [
            (openBlock(true), createElementBlock(Fragment, null, renderList(item.list, (tab) => {
              return openBlock(), createElementBlock(Fragment, null, [
                tab.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : tab.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
                  key: tab.key,
                  model: $data.dataModels,
                  rules: $props.rules,
                  element: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
                  key: tab.key,
                  models: $data.dataModels,
                  rules: $props.rules,
                  widget: tab,
                  remote: $props.remote,
                  blanks: $props.blanks,
                  display: $props.display,
                  "sub-hide-fields": $props.subHideFields,
                  "sub-disabled-fields": $props.subDisabledFields,
                  edit: $props.edit,
                  "remote-option": $props.remoteOption,
                  platform: $props.platform,
                  preview: $props.preview,
                  "container-key": $props.containerKey,
                  "data-source-value": $props.dataSourceValue,
                  "event-function": $props.eventFunction,
                  "print-read": $props.printRead,
                  config: $props.config,
                  "is-subform": $props.isSubform,
                  "row-index": $props.rowIndex,
                  "sub-name": $props.subName,
                  "is-dialog": $props.isDialog,
                  "dialog-name": $props.dialogName,
                  "is-group": $props.isGroup,
                  group: $props.group,
                  "field-node": $props.fieldNode
                }, createSlots({ _: 2 }, [
                  renderList($props.blanks, (blank) => {
                    return {
                      name: blank.name,
                      fn: withCtx((scope) => [
                        renderSlot(_ctx.$slots, blank.name, {
                          model: scope.model
                        })
                      ])
                    };
                  })
                ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
              ], 64);
            }), 256))
          ]),
          _: 2
        }, 1032, ["header"]);
      }), 128))
    ]),
    _: 3
  }, 8, ["activeKey", "accordion", "class"])) : createCommentVNode("", true);
}
var GenerateCollapse = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$7]]);
var GenerateCollapse$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateCollapse
}, Symbol.toStringTag, { value: "Module" }));
var GenerateCard_vue_vue_type_style_index_0_lang = "";
const __default__ = {
  name: "generate-card",
  components: {
    GenerateFormItem,
    GenerateInline,
    GenerateReport: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateReport$1;
    })),
    GenerateTabItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateTabItem$1;
    })),
    GenerateCollapse: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateCollapse$1;
    })),
    GenerateColItem: defineAsyncComponent(() => Promise.resolve().then(function() {
      return GenerateColItem$1;
    }))
  },
  props: ["config", "element", "model", "rules", "remote", "blanks", "display", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "isSubform", "rowIndex", "subName", "subHideFields", "subDisabledFields", "isDialog", "dialogName", "isGroup", "group", "fieldNode"],
  data() {
    return {
      dataModels: this.model
    };
  },
  inject: ["generateComponentInstance", "deleteComponentInstance", "formHideFields"],
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model, this);
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.fieldNode ? `${this.fieldNode}.${this.element.model}` : this.element.model);
  },
  computed: {
    padding() {
      return this.element.options.padding || "20px";
    },
    elementDisplay() {
      if (this.formHideFields.includes(this.fieldNode ? this.fieldNode + "." + this.element.model : this.element.model) || this.formHideFields.includes(this.group ? this.group + "." + this.element.model : this.element.model)) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {},
  watch: {
    model: {
      deep: true,
      handler(val) {
        this.dataModels = val;
      }
    }
  }
};
const __injectCSSVars__ = () => {
  useCssVars((_ctx) => ({
    "ac642196": _ctx.padding
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props2, ctx) => {
  __injectCSSVars__();
  return __setup__(props2, ctx);
} : __injectCSSVars__;
const _sfc_main$8 = __default__;
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b;
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_card = resolveComponent("generate-card", true);
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_a_card = resolveComponent("a-card");
  return $options.elementDisplay ? (openBlock(), createBlock(_component_a_card, {
    key: 0,
    bordered: $props.element.options.bordered,
    hoverable: $props.element.options.shadow === "hover",
    title: $props.element.options.showHeader ? $props.element.options.title : "",
    style: normalizeStyle({
      width: $props.element.options.width
    }),
    class: normalizeClass({
      [(_a2 = $props.element.options) == null ? void 0 : _a2.customClass]: ((_b = $props.element.options) == null ? void 0 : _b.customClass) ? true : false
    })
  }, {
    default: withCtx(() => [
      createElementVNode("div", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.list, (item) => {
          return openBlock(), createElementBlock(Fragment, null, [
            item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              config: $props.config,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              config: $props.config,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              config: $props.config,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              config: $props.config,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              config: $props.config,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
              key: item.key,
              model: $data.dataModels,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              config: $props.config,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
              key: item.key,
              models: $data.dataModels,
              rules: $props.rules,
              widget: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $props.display,
              "sub-hide-fields": $props.subHideFields,
              "sub-disabled-fields": $props.subDisabledFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              config: $props.config,
              "is-subform": $props.isSubform,
              "row-index": $props.rowIndex,
              "sub-name": $props.subName,
              "is-dialog": $props.isDialog,
              "dialog-name": $props.dialogName,
              "is-group": $props.isGroup,
              group: $props.group,
              "field-node": $props.fieldNode
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "sub-hide-fields", "sub-disabled-fields", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "is-subform", "row-index", "sub-name", "is-dialog", "dialog-name", "is-group", "group", "field-node"]))
          ], 64);
        }), 256))
      ])
    ]),
    _: 3
  }, 8, ["bordered", "hoverable", "title", "style", "class"])) : createCommentVNode("", true);
}
var GenerateCard = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$6]]);
var GenerateCard$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": GenerateCard
}, Symbol.toStringTag, { value: "Module" }));
var GenerateDialog_vue_vue_type_style_index_0_lang = "";
const _sfc_main$7 = {
  name: "generate-dialog",
  components: {
    GenerateColItem,
    GenerateFormItem,
    GenerateInline,
    GenerateReport,
    GenerateTabItem,
    GenerateCollapse,
    GenerateCard
  },
  props: ["config", "models", "rules", "element", "remote", "blanks", "edit", "remoteOption", "platform", "preview", "containerKey", "dataSourceValue", "eventFunction", "printRead", "group", "fieldNode"],
  data() {
    return {
      visible: this.element.options.visible,
      displayFields: {},
      dialogModel: {},
      dialogDisabled: {},
      activeElement: ""
    };
  },
  emits: ["update:models"],
  inject: ["generateComponentInstance", "deleteComponentInstance", "getFormComponent", "onFormHide", "onFormDisplay"],
  created() {
    this._generateModel(this.element.list);
  },
  mounted() {
    this.generateComponentInstance && this.generateComponentInstance(this.element.model, this.$refs[`generate-dialog-${this.element.model}`].$parent);
    this.$nextTick(() => {
      var _a2;
      (_a2 = window.document.querySelector(".fm-generate-ant-dialog")) == null ? void 0 : _a2.removeAttribute("tabindex");
      setTimeout(() => {
        this.clearValidate();
      });
    });
  },
  beforeUnmount() {
    this.deleteComponentInstance && this.deleteComponentInstance(this.element.model);
  },
  provide() {
    return {
      "setDialogData": this.setDialogData
    };
  },
  methods: {
    setDialogData(value, field) {
      this.dialogModel[field] = value;
    },
    _generateModel(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type == "grid") {
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          genList[i].columns.forEach((item) => {
            this._generateModel(item.list);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._generateModel(column.list);
            });
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "inline") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "card") {
          this._generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else {
          if (genList[i].type == "blank") {
            this.dialogModel[genList[i].model] = genList[i].options.defaultType === "String" ? "" : genList[i].options.defaultType === "Object" ? {} : [];
          } else {
            this.dialogModel[genList[i].model] = _.cloneDeep(genList[i].options.defaultValue);
          }
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          this.dialogDisabled[genList[i].model] = !genList[i].options.disabled;
        }
      }
    },
    open() {
      this.activeElement = document.activeElement;
      document.activeElement && document.activeElement.blur();
      this.visible = true;
    },
    close() {
      if (this.activeElement) {
        this.activeElement.focus();
        this.activeElement = "";
      }
      this.visible = false;
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormHide(`${this.fieldNode}.${field}`);
      });
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        this.onFormDisplay(`${this.fieldNode}.${field}`);
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setDisabled(this.element.list, fields, disabled);
    },
    validate() {
      return new Promise((resolve, reject) => {
        let realFields = this._getAllRuleFields();
        this.getFormComponent().validate(realFields).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
    },
    clearValidate() {
      let realFields = this._getAllRuleFields();
      this.getFormComponent().clearValidate(realFields);
    },
    handleCancel() {
      if (this.element && this.element.events && this.element.events.onCancel) {
        let funcKey = this.element.events.onCancel;
        this.eventFunction[funcKey]({ field: this.element.model, currentRef: this });
      }
    },
    handleConfirm() {
      if (this.element && this.element.events && this.element.events.onConfirm) {
        let funcKey = this.element.events.onConfirm;
        this.eventFunction[funcKey]({ field: this.element.model, currentRef: this });
      }
    },
    confirmLoading(status) {
      this.element.options.confirmLoading = status;
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      this._setOptions(this.element.list, fields, options);
    },
    setData(value) {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            this.dialogModel[item] = value[item];
          });
          resolve();
        });
      });
    },
    getValues() {
      return this.dialogModel;
    },
    getValue(fieldName) {
      return this.dialogModel[fieldName];
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.element.list, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.element.list, item.split("."), className, "remove");
      });
    },
    _setDisabled(genList, fields, disabled) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setDisabled(column.list, fields, disabled);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else if (genList[i].type === "card") {
          this._setDisabled(genList[i].list, fields, disabled);
        } else {
          if (fields.indexOf(genList[i].model) >= 0) {
            genList[i].options.disabled = disabled;
          }
        }
      }
    },
    _setOptions(genList, fields, opts) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setOptions(item.list, fields, opts);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setOptions(column.list, fields, opts);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setOptions(genList[i].list, fields, opts);
        } else if (genList[i].type === "card") {
          this._setOptions(genList[i].list, fields, opts);
        }
        if (fields.indexOf(genList[i].model) >= 0) {
          Object.keys(opts).forEach((key) => {
            genList[i].options[key] = opts[key];
          });
        }
      }
    },
    _getAllRuleFields() {
      let realFields = [];
      Object.keys(this.dialogModel).forEach((v) => {
        if (Array.isArray(this.dialogModel[v])) {
          const currentArray = this.dialogModel[v];
          currentArray.forEach((o, i) => {
            Object.keys(o).forEach((key) => {
              realFields.push(`${this.element.model}.${v}.${i}.${key}`);
            });
          });
        } else {
          realFields.push(`${this.element.model}.${v}`);
        }
      });
      return realFields.map((item) => item.split("."));
    }
  },
  watch: {
    dialogModel: {
      deep: true,
      handler(val) {
        this.$emit("update:models", {
          ...this.models,
          [this.element.model]: val
        });
      }
    },
    models: {
      deep: true,
      handler(val) {
        this.dialogModel = this.models[this.element.model];
      }
    }
  }
};
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b;
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_a_button = resolveComponent("a-button");
  const _component_a_modal = resolveComponent("a-modal");
  return openBlock(), createBlock(_component_a_modal, {
    open: $data.visible,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event) => $data.visible = $event),
    title: $props.element.options.title,
    width: $props.element.options.width || "50%",
    "mask-closable": false,
    closable: $props.element.options.showClose,
    "destroy-on-close": "",
    ref: `generate-dialog-${$props.element.model}`,
    style: normalizeStyle({
      top: $props.element.options.top || "15vh"
    }),
    "z-index": 3e3,
    "wrap-class-name": "fm-generate-ant-dialog " + (!$props.element.options.showCancel && !$props.element.options.showOk ? "no-footer " : "") + ($props.element.options.center ? "center " : "") + (((_a2 = $props.element.options) == null ? void 0 : _a2.customClass) ? (_b = $props.element.options) == null ? void 0 : _b.customClass : "")
  }, {
    footer: withCtx(() => [
      createElementVNode("div", null, [
        $props.element.options.showCancel ? (openBlock(), createBlock(_component_a_button, {
          key: "back",
          onClick: $options.handleCancel
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1($props.element.options.cancelText), 1)
          ]),
          _: 1
        }, 8, ["onClick"])) : createCommentVNode("", true),
        $props.element.options.showOk ? (openBlock(), createBlock(_component_a_button, {
          key: "submit",
          type: "primary",
          loading: $props.element.options.confirmLoading,
          onClick: $options.handleConfirm
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1($props.element.options.okText), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"])) : createCommentVNode("", true)
      ])
    ]),
    default: withCtx(() => [
      createElementVNode("div", null, [
        (openBlock(true), createElementBlock(Fragment, null, renderList($props.element.list, (item) => {
          return openBlock(), createElementBlock(Fragment, null, [
            item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              config: $props.config,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "config", "group", "field-node"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              config: $props.config,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "config", "group", "field-node"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              config: $props.config,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "config", "group", "field-node"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              config: $props.config,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "config", "group", "field-node"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              config: $props.config,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "config", "group", "field-node"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
              key: item.key,
              model: $data.dialogModel,
              rules: $props.rules,
              element: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              config: $props.config,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "config", "group", "field-node"])) : (openBlock(), createBlock(_component_generate_form_item, {
              key: item.key,
              models: $data.dialogModel,
              rules: $props.rules,
              widget: item,
              remote: $props.remote,
              blanks: $props.blanks,
              display: $data.displayFields,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $props.containerKey,
              "data-source-value": $props.dataSourceValue,
              "event-function": $props.eventFunction,
              "print-read": $props.printRead,
              "is-dialog": true,
              "dialog-name": $props.element.model,
              config: $props.config,
              group: $props.element.model,
              "field-node": $props.element.model
            }, createSlots({ _: 2 }, [
              renderList($props.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "dialog-name", "config", "group", "field-node"]))
          ], 64);
        }), 256))
      ])
    ]),
    _: 3
  }, 8, ["open", "title", "width", "closable", "style", "wrap-class-name"]);
}
var GenerateDialog = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$5]]);
const _sfc_main$6 = {
  name: "fm-generate-antd-form",
  components: {
    GenerateFormItem,
    GenerateColItem,
    GenerateTabItem,
    GenerateReport,
    GenerateInline,
    GenerateCollapse,
    GenerateDialog,
    GenerateCard
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        "list": [],
        "config": {
          "labelWidth": 100,
          "labelPosition": "right",
          "size": "small",
          "customClass": "",
          "ui": "element",
          "layout": "horizontal"
        }
      })
    },
    remote: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    edit: {
      type: Boolean,
      default: true
    },
    remoteOption: {
      type: Object,
      default: () => ({})
    },
    preview: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      default: "pc"
    },
    printRead: {
      type: Boolean,
      default: false
    }
  },
  emits: ["on-change"],
  data() {
    return {
      formData: {},
      models: {},
      rules: {},
      blanks: [],
      displayFields: {},
      dataBindFields: {},
      generateShow: false,
      resetModels: {},
      formKey: Math.random().toString(36).slice(-8),
      formStyleKey: Math.random().toString(36).slice(-8),
      formValue: this.value,
      formShow: false,
      formRef: Math.random().toString(36).slice(-8) + "Form",
      containerKey: Math.random().toString(36).slice(-8),
      dataSourceValue: [],
      eventFunction: {},
      instanceObject: {},
      dataSourceInterface: [],
      formHideFields: []
    };
  },
  created() {
    this._initForm();
  },
  mounted() {
    this.$nextTick(() => {
      this.eventFunction.mounted && this.eventFunction["mounted"]();
    });
  },
  beforeUnmount() {
    let head = ".fm-" + this.formStyleKey + " ";
    clearStyleSheets(head);
  },
  provide() {
    return {
      "generateComponentInstance": this.generateComponentInstance,
      "deleteComponentInstance": this.deleteComponentInstance,
      "eventScriptConfig": this.getEventScriptConfig,
      "getFormComponent": this.getFormComponent,
      "onChange": this._changeFormValue,
      "onFormDisabled": this.disabled,
      "formHideFields": this.formHideFields,
      "onFormHide": this.hide,
      "onFormDisplay": this.display
    };
  },
  methods: {
    getFormComponent() {
      return this.$refs[this.formRef];
    },
    handleValidate(name, error) {
    },
    _changeFormValue(value, field) {
      this.models[field] = value;
      this.$emit("on-change", field, value, this.models);
    },
    _initForm() {
      this.formShow = false;
      this.formData = _.cloneDeep(this.data);
      this.models = {};
      this.rules = {};
      this.blanks = [];
      this.displayFields = {};
      this.dataBindFields = {};
      this.resetModels = {};
      this.dataSourceValue = [];
      this.eventFunction = [];
      this.dataSourceInterface = [];
      if (Object.keys(this.data).length) {
        this.generateModel(this.formData.list);
      } else {
        this.generateModel([]);
      }
      this.resetModels = _.cloneDeep(this.models);
      this.models = { ...this.models };
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.formShow = true;
          if (this.formData.config && this.formData.config.styleSheets) {
            let head = ".fm-" + this.formStyleKey + " ";
            updateStyleSheets(splitStyleSheets(this.formData.config.styleSheets), head);
          }
          this.loadDataSource();
          this.loadEvents();
          this.$nextTick(() => {
            this.eventFunction["refresh"] && this.eventFunction["refresh"]();
            resolve();
          });
        });
      });
    },
    getEventScriptConfig() {
      var _a2, _b, _c;
      return (_c = (_b = (_a2 = this.data) == null ? void 0 : _a2.config) == null ? void 0 : _b.eventScript) != null ? _c : [];
    },
    loadEvents() {
      if (this.formData.config && this.formData.config.eventScript) {
        for (let i = 0; i < this.formData.config.eventScript.length; i++) {
          let currentScript = this.formData.config.eventScript[i];
          if (currentScript.type === "rule") {
            const AsyncFunction = Object.getPrototypeOf(async function() {
            }).constructor;
            this.eventFunction[currentScript.key] = new AsyncFunction(ruleToFunction(currentScript.rules)).bind(this);
          } else {
            this.eventFunction[currentScript.key] = Function(currentScript.func).bind(this);
          }
        }
      }
    },
    triggerEvent(eventName, args) {
      if (this.formData.config && this.formData.config.eventScript) {
        let eventScript = this.formData.config.eventScript.find((item) => item.name == eventName);
        if (eventScript) {
          return this.eventFunction[eventScript.key](args);
        }
      }
    },
    loadDataSource() {
      var _a2, _b;
      for (let i = 0; i < this.dataSourceInterface.length; i++) {
        let curRequest = this.dataSourceInterface[i];
        let requestObj = this.formData.config.dataSource.find((item) => item.key == curRequest.key);
        if (requestObj && requestObj.auto)
          requestObj.name && this.sendRequest(requestObj.name, curRequest.args).then((data2) => {
            curRequest.fields.forEach((field) => {
              let curKey = field + "." + curRequest.key;
              let sourceValue = this.dataSourceValue.find((item) => item.key === curKey);
              if (sourceValue) {
                sourceValue.value = data2;
              } else {
                this.dataSourceValue.push({
                  key: curKey,
                  value: data2
                });
              }
            });
          });
      }
      if (((_b = (_a2 = this.formData.config) == null ? void 0 : _a2.dataSource) == null ? void 0 : _b.length) > 0) {
        for (let i = 0; i < this.formData.config.dataSource.length; i++) {
          let currentDataSource = this.formData.config.dataSource[i];
          if (currentDataSource.auto && this.dataSourceInterface.findIndex((item) => item.key == currentDataSource.key) < 0) {
            this.sendRequest(currentDataSource.name, {});
          }
        }
      }
    },
    refreshFieldDataSource(field, args) {
      let curRequest = this.dataSourceInterface.find((item) => item.fields.includes(field));
      return new Promise((resolve, reject) => {
        var _a2;
        if (curRequest) {
          let requestName = (_a2 = this.formData.config.dataSource.find((item) => item.key == curRequest.key)) == null ? void 0 : _a2.name;
          requestName && this.sendRequest(requestName, { ...curRequest.args, ...args }).then((data2) => {
            let curKey = field + "." + curRequest.key;
            let sourceValue = this.dataSourceValue.find((item) => item.key === curKey);
            if (sourceValue) {
              sourceValue.value = data2;
            } else {
              this.dataSourceValue.push({
                key: curKey,
                value: data2
              });
            }
            resolve(data2);
          }).catch(() => {
            reject();
          });
        } else {
          resolve();
        }
      });
    },
    getFieldDataSource(field) {
      let curRequest = this.dataSourceInterface.find((item) => item.fields.includes(field));
      if (curRequest) {
        let curKey = field + "." + curRequest.key;
        let sourceValue = this.dataSourceValue.find((item) => item.key === curKey);
        if (sourceValue) {
          return sourceValue.value;
        }
      }
      return null;
    },
    sendRequest(name, args = {}) {
      return new Promise((resolve, reject) => {
        let currentDataSource = this.formData.config.dataSource.find((item) => item.name === name);
        if (currentDataSource) {
          let options = {
            method: currentDataSource.method,
            url: currentDataSource.url
          };
          let optionsHeaders = {};
          Object.keys(currentDataSource.headers).forEach((key) => {
            if (isExpression(currentDataSource.headers[key])) {
              optionsHeaders[key] = executeExpression(extractExpression(currentDataSource.headers[key]), args, this);
            } else {
              optionsHeaders[key] = currentDataSource.headers[key];
            }
          });
          Object.keys(optionsHeaders).length && (options["headers"] = optionsHeaders);
          let optionsParams = {};
          Object.keys(currentDataSource.params).forEach((key) => {
            if (isExpression(currentDataSource.params[key])) {
              optionsParams[key] = executeExpression(extractExpression(currentDataSource.params[key]), args, this);
            } else {
              optionsParams[key] = currentDataSource.params[key];
            }
          });
          if (options.method === "POST" || options.method === "PUT") {
            options["data"] = optionsParams;
          } else {
            options["params"] = optionsParams;
          }
          if (currentDataSource.requestFunc) {
            const requestDynamicFunc = Function("config", "args", currentDataSource.requestFunc).bind(this);
            options = requestDynamicFunc(options, args);
          }
          axios(options).then((res) => {
            let data2 = res;
            if (currentDataSource.responseFunc) {
              const dynamicFunc = Function("res", "args", currentDataSource.responseFunc).bind(this);
              data2 = dynamicFunc(res.data, args);
              resolve(data2);
            } else {
              resolve(res.data);
            }
          }).catch((error) => {
            if (currentDataSource.errorFunc) {
              const errorDynamicFunc = Function("error", currentDataSource.errorFunc).bind(this);
              errorDynamicFunc(error);
            }
            reject(error);
          });
        }
      });
    },
    generateSubformModel(subName, genList, dataBindFields) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].options.hidden) {
          this.formHideFields.push(`${subName}.${genList[i].model}`);
        }
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this.generateSubformModel(subName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this.generateSubformModel(subName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this.generateSubformModel(subName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this.generateSubformModel(subName, column.list, dataBindFields);
            });
          });
        } else if (genList[i].type === "inline") {
          this.generateSubformModel(subName, genList[i].list, dataBindFields);
        } else if (genList[i].type === "card") {
          this.generateSubformModel(subName, genList[i].list, dataBindFields);
        } else {
          if (genList[i].type === "blank") {
            this.blanks.push({
              name: genList[i].model
            });
          }
          if (genList[i].options.dataBind) {
            if (["subform", "group", "table"].includes(genList[i].type)) {
              dataBindFields[genList[i].model] = {};
            } else {
              dataBindFields[genList[i].model] = true;
            }
          }
          genList[i].tableColumns && genList[i].tableColumns.length && genList[i].tableColumns.forEach((item) => {
            if (item.type === "blank") {
              this.blanks.push({
                name: item.model
              });
            }
            if (item.options.dataBind && genList[i].options.dataBind) {
              dataBindFields[genList[i].model][item.model] = true;
            }
            if (item.options.hidden) {
              this.formHideFields.push(`${subName}.${genList[i].model}.${item.model}`);
            }
            this._generateRules(`${subName}.${genList[i].model}.${item.model}`, item.rules);
            this._generateDataSource(item, `${subName}.${genList[i].model}.${item.model}`);
          });
          if (genList[i].type == "subform") {
            this.generateSubformModel(`${subName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "group") {
            this.generateGroupModel(`${subName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          this._generateRules(`${subName}.${genList[i].model}`, genList[i].rules);
          this._generateDataSource(genList[i], `${subName}.${genList[i].model}`);
        }
      }
    },
    generateDialogModel(dialogName, genList, dataBindFields) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].options.hidden) {
          this.formHideFields.push(`${dialogName}.${genList[i].model}`);
        }
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this.generateDialogModel(dialogName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this.generateDialogModel(dialogName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this.generateDialogModel(dialogName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this.generateDialogModel(dialogName, column.list, dataBindFields);
            });
          });
        } else if (genList[i].type === "inline") {
          this.generateDialogModel(dialogName, genList[i].list, dataBindFields);
        } else if (genList[i].type === "card") {
          this.generateDialogModel(dialogName, genList[i].list, dataBindFields);
        } else {
          if (genList[i].type === "blank") {
            this.blanks.push({
              name: genList[i].model
            });
          }
          if (genList[i].options.dataBind) {
            if (["subform", "group", "table"].includes(genList[i].type)) {
              dataBindFields[genList[i].model] = {};
            } else {
              dataBindFields[genList[i].model] = true;
            }
          }
          if (genList[i].type == "subform") {
            this.generateSubformModel(`${dialogName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "group") {
            this.generateGroupModel(`${dialogName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          genList[i].tableColumns && genList[i].tableColumns.length && genList[i].tableColumns.forEach((item) => {
            if (item.type === "blank") {
              this.blanks.push({
                name: item.model
              });
            }
            if (item.options.dataBind && genList[i].options.dataBind) {
              dataBindFields[genList[i].model][item.model] = true;
            }
            if (item.options.hidden) {
              this.formHideFields.push(`${dialogName}.${genList[i].model}.${item.model}`);
            }
            this._generateRules(`${dialogName}.${genList[i].model}.${item.model}`, item.rules);
            this._generateDataSource(item, `${dialogName}.${genList[i].model}.${item.model}`);
          });
          this._generateRules(`${dialogName}.${genList[i].model}`, genList[i].rules);
          this._generateDataSource(genList[i], `${dialogName}.${genList[i].model}`);
        }
      }
    },
    generateGroupModel(groupName, genList, dataBindFields) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].options.hidden) {
          this.formHideFields.push(`${groupName}.${genList[i].model}`);
        }
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this.generateGroupModel(groupName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this.generateGroupModel(groupName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this.generateGroupModel(groupName, item.list, dataBindFields);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this.generateGroupModel(groupName, column.list, dataBindFields);
            });
          });
        } else if (genList[i].type === "inline") {
          this.generateGroupModel(groupName, genList[i].list, dataBindFields);
        } else if (genList[i].type === "card") {
          this.generateGroupModel(groupName, genList[i].list, dataBindFields);
        } else {
          if (genList[i].type === "blank") {
            this.blanks.push({
              name: genList[i].model
            });
          }
          if (genList[i].options.dataBind) {
            if (["subform", "group", "table"].includes(genList[i].type)) {
              dataBindFields[genList[i].model] = {};
            } else {
              dataBindFields[genList[i].model] = true;
            }
          }
          if (genList[i].type == "subform") {
            this.generateSubformModel(`${groupName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "group") {
            this.generateGroupModel(`${groupName}.${genList[i].model}`, genList[i].list, dataBindFields[genList[i].model] || {});
          }
          genList[i].tableColumns && genList[i].tableColumns.length && genList[i].tableColumns.forEach((item) => {
            if (item.type === "blank") {
              this.blanks.push({
                name: item.model
              });
            }
            if (item.options.dataBind && genList[i].options.dataBind) {
              dataBindFields[genList[i].model][item.model] = true;
            }
            if (item.options.hidden) {
              this.formHideFields.push(`${groupName}.${genList[i].model}.${item.model}`);
            }
            this._generateRules(`${groupName}.${genList[i].model}.${item.model}`, item.rules);
            this._generateDataSource(item, `${groupName}.${genList[i].model}.${item.model}`);
          });
          this._generateRules(`${groupName}.${genList[i].model}`, genList[i].rules);
          this._generateDataSource(genList[i], `${groupName}.${genList[i].model}`);
        }
      }
    },
    generateModel(genList) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].options.hidden) {
          this.formHideFields.push(genList[i].model);
        }
        if (genList[i].type === "grid") {
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
          genList[i].columns.forEach((item) => {
            this.generateModel(item.list);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this.generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this.generateModel(item.list);
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this.generateModel(column.list);
            });
          });
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "inline") {
          this.generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else if (genList[i].type === "card") {
          this.generateModel(genList[i].list);
          this.displayFields[genList[i].model] = !genList[i].options.hidden;
        } else {
          if (Object.keys(this.formValue).indexOf(genList[i].model) >= 0) {
            this.models[genList[i].model] = this.formValue[genList[i].model];
            this.displayFields[genList[i].model] = !genList[i].options.hidden;
            if (genList[i].type === "blank") {
              this.blanks.push({
                name: genList[i].model
              });
            }
          } else {
            if (genList[i].type === "blank") {
              this.models[genList[i].model] = genList[i].options.defaultType === "String" ? "" : genList[i].options.defaultType === "Object" ? {} : [];
              this.displayFields[genList[i].model] = !genList[i].options.hidden;
              this.blanks.push({
                name: genList[i].model
              });
            } else {
              this.models[genList[i].model] = _.cloneDeep(genList[i].options.defaultValue);
              this.displayFields[genList[i].model] = !genList[i].options.hidden;
            }
          }
          if ((Object.keys(genList[i].options).indexOf("dataBind") < 0 || genList[i].options.dataBind) && genList[i].key && genList[i].model) {
            if (["subform", "table", "dialog", "group"].includes(genList[i].type)) {
              this.dataBindFields[genList[i].model] = {};
            } else {
              this.dataBindFields[genList[i].model] = true;
            }
          }
          if (genList[i].type == "subform") {
            this.generateSubformModel(genList[i].model, genList[i].list, this.dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "dialog") {
            this.generateDialogModel(genList[i].model, genList[i].list, this.dataBindFields[genList[i].model] || {});
          }
          if (genList[i].type == "group") {
            this.generateGroupModel(genList[i].model, genList[i].list, this.dataBindFields[genList[i].model] || {});
          }
          genList[i].tableColumns && genList[i].tableColumns.length && genList[i].tableColumns.forEach((item) => {
            if (item.type === "blank") {
              this.blanks.push({
                name: item.model
              });
            }
            if (item.options.dataBind && genList[i].options.dataBind) {
              this.dataBindFields[genList[i].model][item.model] = true;
            }
            if (item.options.hidden) {
              this.formHideFields.push(`${genList[i].model}.${item.model}`);
            }
            this._generateRules(`${genList[i].model}.${item.model}`, item.rules);
            this._generateDataSource(item, `${genList[i].model}.${item.model}`);
          });
          this._generateRules(genList[i].model, genList[i].rules);
          this._generateDataSource(genList[i], genList[i].model);
        }
      }
    },
    _generateDataSource(element, model2) {
      if (element.options.remoteType === "datasource" && element.options.remoteDataSource) {
        this._setDataSourceInterface(model2, element.options.remoteArgs, element.options.remoteDataSource);
      }
      if ((element.type == "imgupload" || element.type == "fileupload") && element.options.tokenType == "datasource" && element.options.tokenDataSource) {
        this._setDataSourceInterface(model2, element.options.remoteArgs, element.options.tokenDataSource);
      }
    },
    _generateRules(model, rules) {
      if (this.rules[model]) {
        this.rules[model] = [
          ...this.rules[model],
          ...rules ? rules.map((im) => {
            if (im.pattern) {
              return { ...im, pattern: eval(im.pattern) };
            } else if (im.func) {
              const validatorFunc = Function("rule", "value", "callback", im.func).bind(this);
              return { ...im, validator: validatorFunc };
            } else {
              return { ...im };
            }
          }) : []
        ];
      } else {
        this.rules[model] = [
          ...rules ? rules.map((im) => {
            if (im.pattern) {
              return { ...im, pattern: eval(im.pattern) };
            } else if (im.func) {
              const validatorFunc = Function("rule", "value", "callback", im.func).bind(this);
              return { ...im, validator: validatorFunc };
            } else {
              return { ...im };
            }
          }) : []
        ];
      }
    },
    _setDataSourceInterface(field, args, key) {
      let argsObj;
      if (typeof args == "string") {
        argsObj = new Function('"use strict";return (' + (args || "{}") + ")")();
      } else {
        argsObj = args;
      }
      let findCurInterfaceIndex = this.dataSourceInterface.findIndex((item) => item.key == key && _.isEqual(item.args, argsObj));
      if (findCurInterfaceIndex >= 0) {
        this.dataSourceInterface[findCurInterfaceIndex].fields.push(field);
      } else {
        this.dataSourceInterface.push({
          key,
          args: argsObj,
          fields: [field]
        });
      }
    },
    _setSubDisabled(genList, fields, disabled) {
      for (let i = 0; i < genList.length; i++) {
        if (genList[i].type === "grid") {
          genList[i].columns.forEach((item) => {
            this._setSubDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "tabs") {
          genList[i].tabs.forEach((item) => {
            this._setSubDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "collapse") {
          genList[i].tabs.forEach((item) => {
            this._setSubDisabled(item.list, fields, disabled);
          });
        } else if (genList[i].type === "report") {
          genList[i].rows.forEach((row) => {
            row.columns.forEach((column) => {
              this._setSubDisabled(column.list, fields, disabled);
            });
          });
        } else if (genList[i].type === "inline") {
          this._setSubDisabled(genList[i].list, fields, disabled);
        } else if (genList[i].type === "card") {
          this._setSubDisabled(genList[i].list, fields, disabled);
        } else {
          if (fields.length === 1) {
            if (genList[i].model === fields[0]) {
              genList[i].options.disabled = disabled;
            }
          } else {
            if (genList[i].model !== fields[0])
              continue;
            let newFields = [...fields];
            newFields.splice(0, 1);
            if (genList[i].type === "table") {
              this._setSubDisabled(genList[i].tableColumns, newFields, disabled);
            }
            if (genList[i].type === "subform") {
              this._setSubDisabled(genList[i].list, newFields, disabled);
            }
            if (genList[i].type === "group") {
              this._setSubDisabled(genList[i].list, newFields, disabled);
            }
            if (genList[i].type === "dialog") {
              this._setSubDisabled(genList[i].list, newFields, disabled);
            }
          }
        }
      }
    },
    _setSubOptions(genList, fields, opts) {
      for (let i = 0; i < genList.length; i++) {
        if (fields.length === 1) {
          if (genList[i].model === fields[0]) {
            Object.keys(opts).forEach((key) => {
              genList[i].options[key] = opts[key];
            });
          } else {
            if (genList[i].type === "grid") {
              genList[i].columns.forEach((item) => {
                this._setSubOptions(item.list, fields, opts);
              });
            } else if (genList[i].type === "tabs") {
              genList[i].tabs.forEach((item) => {
                this._setSubOptions(item.list, fields, opts);
              });
            } else if (genList[i].type === "collapse") {
              genList[i].tabs.forEach((item) => {
                this._setSubOptions(item.list, fields, opts);
              });
            } else if (genList[i].type === "report") {
              genList[i].rows.forEach((row) => {
                row.columns.forEach((column) => {
                  this._setSubOptions(column.list, fields, opts);
                });
              });
            } else if (genList[i].type === "inline") {
              this._setSubOptions(genList[i].list, fields, opts);
            } else if (genList[i].type === "card") {
              this._setSubOptions(genList[i].list, fields, opts);
            }
          }
        } else {
          if (genList[i].type === "grid") {
            genList[i].columns.forEach((item) => {
              this._setSubOptions(item.list, fields, opts);
            });
          } else if (genList[i].type === "tabs") {
            genList[i].tabs.forEach((item) => {
              this._setSubOptions(item.list, fields, opts);
            });
          } else if (genList[i].type === "collapse") {
            genList[i].tabs.forEach((item) => {
              this._setSubOptions(item.list, fields, opts);
            });
          } else if (genList[i].type === "report") {
            genList[i].rows.forEach((row) => {
              row.columns.forEach((column) => {
                this._setSubOptions(column.list, fields, opts);
              });
            });
          } else if (genList[i].type === "inline") {
            this._setSubOptions(genList[i].list, fields, opts);
          } else if (genList[i].type === "card") {
            this._setSubOptions(genList[i].list, fields, opts);
          } else {
            if (genList[i].model !== fields[0])
              continue;
            let newFields = [...fields];
            newFields.splice(0, 1);
            if (genList[i].type === "table") {
              this._setSubOptions(genList[i].tableColumns, newFields, opts);
            }
            if (genList[i].type === "subform") {
              this._setSubOptions(genList[i].list, newFields, opts);
            }
            if (genList[i].type === "group") {
              this._setSubOptions(genList[i].list, newFields, opts);
            }
            if (genList[i].type === "dialog") {
              this._setSubOptions(genList[i].list, newFields, opts);
            }
          }
        }
      }
    },
    _getSubOptions(genList, fields) {
      for (let i = 0; i < genList.length; i++) {
        if (fields.length === 1) {
          if (genList[i].model === fields[0]) {
            return genList[i].options;
          } else {
            if (genList[i].type === "grid") {
              for (const item of genList[i].columns) {
                const options = this._getSubOptions(item.list, fields);
                if (options)
                  return options;
              }
            } else if (genList[i].type === "tabs") {
              for (const item of genList[i].tabs) {
                const options = this._getSubOptions(item.list, fields);
                if (options)
                  return options;
              }
            } else if (genList[i].type === "collapse") {
              for (const item of genList[i].tabs) {
                const options = this._getSubOptions(item.list, fields);
                if (options)
                  return options;
              }
            } else if (genList[i].type === "report") {
              for (const row of genList[i].rows) {
                for (const column of row.columns) {
                  const options = this._getSubOptions(column.list, fields);
                  if (options)
                    return options;
                }
              }
            } else if (genList[i].type === "inline") {
              const options = this._getSubOptions(genList[i].list, fields);
              if (options)
                return options;
            } else if (genList[i].type === "card") {
              const options = this._getSubOptions(genList[i].list, fields);
              if (options)
                return options;
            }
          }
        } else {
          if (genList[i].type === "grid") {
            for (const item of genList[i].columns) {
              const options = this._getSubOptions(item.list, fields);
              if (options)
                return options;
            }
          } else if (genList[i].type === "tabs") {
            for (const item of genList[i].tabs) {
              const options = this._getSubOptions(item.list, fields);
              if (options)
                return options;
            }
          } else if (genList[i].type === "collapse") {
            for (const item of genList[i].tabs) {
              const options = this._getSubOptions(item.list, fields);
              if (options)
                return options;
            }
          } else if (genList[i].type === "report") {
            for (const row of genList[i].rows) {
              for (const column of row.columns) {
                const options = this._getSubOptions(column.list, fields);
                if (options)
                  return options;
              }
            }
          } else if (genList[i].type === "inline") {
            const options = this._getSubOptions(genList[i].list, fields);
            if (options)
              return options;
          } else if (genList[i].type === "card") {
            const options = this._getSubOptions(genList[i].list, fields);
            if (options)
              return options;
          } else {
            if (genList[i].model !== fields[0])
              continue;
            let newFields = [...fields];
            newFields.splice(0, 1);
            if (genList[i].type === "table") {
              const options = this._getSubOptions(genList[i].tableColumns, newFields);
              if (options)
                return options;
            }
            if (genList[i].type === "subform") {
              const options = this._getSubOptions(genList[i].list, newFields);
              if (options)
                return options;
            }
            if (genList[i].type === "group") {
              const options = this._getSubOptions(genList[i].list, newFields);
              if (options)
                return options;
            }
            if (genList[i].type === "dialog") {
              const options = this._getSubOptions(genList[i].list, newFields);
              if (options)
                return options;
            }
          }
        }
      }
      return null;
    },
    validate(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      return new Promise((resolve, reject) => {
        this.$refs[this.formRef].validate(fields).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      });
    },
    clearValidate(fields) {
      this.$refs[this.formRef].clearValidate(fields);
    },
    getData(isValidate = true) {
      return new Promise((resolve, reject) => {
        if (isValidate) {
          this.$refs[this.formRef].validate().then(() => {
            resolve(getBindModels(this.models, this.dataBindFields));
          }).catch(() => {
            reject(new Error(this.$t("fm.message.validError")).message);
          });
        } else {
          resolve(getBindModels(this.models, this.dataBindFields));
        }
      });
    },
    reset() {
      return new Promise((resolve) => {
        this.setData(_.cloneDeep(this.resetModels)).then(() => {
          setTimeout(() => {
            this.$refs[this.formRef].clearValidate();
            resolve();
          }, 10);
        });
      });
    },
    onInputChange(value, field) {
      this.$emit("on-change", field, value, this.models);
    },
    display(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        if (this.formHideFields.includes(field)) {
          let index2 = this.formHideFields.findIndex((item) => item == field);
          this.formHideFields.splice(index2, 1);
        }
      });
    },
    hide(fields) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        if (!this.formHideFields.includes(field)) {
          this.formHideFields.push(field);
        }
      });
    },
    disabled(fields, disabled) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        var _a2;
        let currentComponent = this.instanceObject[item];
        if (currentComponent) {
          if (Array.isArray(currentComponent)) {
            currentComponent.forEach((cc) => {
              var _a3;
              (_a3 = cc.$parent) == null ? void 0 : _a3.disabledElement(disabled);
            });
          } else {
            (_a2 = currentComponent.$parent) == null ? void 0 : _a2.disabledElement(disabled);
          }
        } else {
          this._setSubDisabled(this.formData.list, item.split("."), disabled);
        }
      });
    },
    addClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.formData.list, item.split("."), className, "add");
      });
    },
    removeClassName(fields, className) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        updateClassName(this.formData.list, item.split("."), className, "remove");
      });
    },
    async refresh() {
      await this._initForm();
    },
    setData(value) {
      const _setNestedValue = (currentObj, keys, value2) => {
        const key = keys.shift();
        if (keys.length === 0) {
          currentObj[key] = value2;
        } else {
          if (key in currentObj) {
            if (Array.isArray(currentObj[key])) {
              if (Number.isNaN(Number(keys[0]))) {
                currentObj[key].forEach((cur) => {
                  _setNestedValue(cur, [...keys], value2);
                });
              } else {
                const indexKey = keys.shift();
                currentObj[key].length > Number(indexKey) && _setNestedValue(currentObj[key][Number(indexKey)], [...keys], value2);
              }
            } else {
              _setNestedValue(currentObj[key], [...keys], value2);
            }
          }
        }
      };
      return new Promise((resolve) => {
        this.$nextTick(() => {
          Object.keys(value).forEach((item) => {
            _setNestedValue(this.models, item.split("."), value[item]);
          });
          resolve();
        });
      });
    },
    getComponent(name) {
      if (this.instanceObject[name]) {
        return this.instanceObject[name];
      } else {
        consoleError("No component instance found with " + name);
        return null;
      }
    },
    getValues() {
      return _.cloneDeep(this.models);
    },
    getValue(fieldName) {
      const resModels = _.cloneDeep(this.models);
      let fieldArray = fieldName.split(".");
      const _getFieldRes = (res, array) => {
        if (array.length === 1) {
          return res[array[0]];
        } else {
          let newRes = res[array[0]];
          let newFields = [...array];
          newFields.splice(0, 1);
          return _getFieldRes(newRes, newFields);
        }
      };
      return _getFieldRes(resModels, fieldArray);
    },
    setRules(field, rules2) {
      this.rules[field] = [...rules2];
      this.$nextTick(() => {
        var _a2;
        if ((field == null ? void 0 : field.split(".").length) > 1) {
          const tableRowLength = (_a2 = this.getValue(field.split(".")[0])) == null ? void 0 : _a2.length;
          if (tableRowLength) {
            for (let i = 0; i < tableRowLength; i++) {
              setTimeout(() => {
                this.$refs[this.formRef].validate([[field.split(".")[0], i, field.split(".")[1]]]);
              });
            }
          }
        } else {
          setTimeout(() => {
            this.$refs[this.formRef].validate([field]);
          });
        }
      });
    },
    setOptions(fields, options) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((item) => {
        this._setSubOptions(this.formData.list, item.split("."), options);
      });
    },
    getOptions(field, key) {
      const result = this._getSubOptions(this.formData.list, field.split("."));
      if (key && result && result[key]) {
        return result[key];
      } else {
        return result;
      }
    },
    generateComponentInstance(key, instance2) {
      if (this.instanceObject[key]) {
        if (Array.isArray(this.instanceObject[key])) {
          this.instanceObject[key] = [...this.instanceObject[key], instance2];
        } else {
          this.instanceObject[key] = [this.instanceObject[key], instance2];
        }
      } else {
        this.instanceObject[key] = instance2;
      }
    },
    deleteComponentInstance(key) {
      if (this.instanceObject[key]) {
        delete this.instanceObject[key];
      }
    },
    setOptionData(fields, data2) {
      if (typeof fields === "string") {
        fields = [fields];
      }
      fields.forEach((field) => {
        var _a2;
        const curRef = this.instanceObject[field];
        (_a2 = curRef == null ? void 0 : curRef.$parent) == null ? void 0 : _a2.loadOptions(data2);
      });
    },
    exportPDF() {
      if (this.printRead) {
        return exportPDF(document.querySelector(".fm-" + this.formStyleKey));
      } else {
        return Promise.reject();
      }
    },
    openDialog(dialogField) {
      const dialogComponent = this.getComponent(dialogField);
      if (dialogComponent) {
        dialogComponent.open();
      }
    },
    closeDialog(dialogField) {
      const dialogComponent = this.getComponent(dialogField);
      if (dialogComponent) {
        dialogComponent.close();
      }
    }
  }
};
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b, _c, _d, _e, _f;
  const _component_generate_col_item = resolveComponent("generate-col-item");
  const _component_generate_tab_item = resolveComponent("generate-tab-item");
  const _component_generate_collapse = resolveComponent("generate-collapse");
  const _component_generate_report = resolveComponent("generate-report");
  const _component_generate_card = resolveComponent("generate-card");
  const _component_generate_inline = resolveComponent("generate-inline");
  const _component_generate_dialog = resolveComponent("generate-dialog");
  const _component_generate_form_item = resolveComponent("generate-form-item");
  const _component_a_form = resolveComponent("a-form");
  return openBlock(), createElementBlock("div", {
    style: normalizeStyle({ width: $data.formData.config && $data.formData.config.width }),
    class: normalizeClass(["fm-form", {
      ["fm-" + $data.formStyleKey]: true,
      "is-print": $props.printRead
    }])
  }, [
    $data.formShow ? (openBlock(), createBlock(_component_a_form, {
      ref: $data.formRef,
      model: $data.models,
      rules: $data.rules,
      key: $data.formKey,
      class: normalizeClass({
        [(_a2 = $data.formData.config) == null ? void 0 : _a2.customClass]: ((_b = $data.formData.config) == null ? void 0 : _b.customClass) ? true : false,
        "no-label-form": ((_c = $data.formData.config) == null ? void 0 : _c.labelWidth) == 0
      }),
      "label-align": ((_d = $data.formData.config) == null ? void 0 : _d.labelPosition) != "top" ? (_e = $data.formData.config) == null ? void 0 : _e.labelPosition : "left",
      layout: ((_f = $data.formData.config) == null ? void 0 : _f.labelPosition) == "top" ? "vertical" : "horizontal",
      validateOnRuleChange: "",
      scrollToFirstError: "",
      onValidate: $options.handleValidate
    }, {
      default: withCtx(() => [
        (openBlock(true), createElementBlock(Fragment, null, renderList($data.formData.list, (item) => {
          return openBlock(), createElementBlock(Fragment, {
            key: item.key
          }, [
            item.type == "grid" ? (openBlock(), createBlock(_component_generate_col_item, {
              key: 0,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              config: $data.formData.config,
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config"])) : item.type == "tabs" ? (openBlock(), createBlock(_component_generate_tab_item, {
              key: 1,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              config: $data.formData.config,
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config"])) : item.type == "collapse" ? (openBlock(), createBlock(_component_generate_collapse, {
              key: 2,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              config: $data.formData.config,
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config"])) : item.type == "report" ? (openBlock(), createBlock(_component_generate_report, {
              key: 3,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              config: $data.formData.config,
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config"])) : item.type == "card" ? (openBlock(), createBlock(_component_generate_card, {
              key: 4,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              config: $data.formData.config,
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config"])) : item.type == "inline" ? (openBlock(), createBlock(_component_generate_inline, {
              key: 5,
              model: $data.models,
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              config: $data.formData.config,
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["model", "rules", "element", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config"])) : item.type == "dialog" ? (openBlock(), createBlock(_component_generate_dialog, {
              key: 6,
              models: $data.models,
              "onUpdate:models": _cache[0] || (_cache[0] = ($event) => $data.models = $event),
              rules: $data.rules,
              element: item,
              remote: $props.remote,
              blanks: $data.blanks,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              config: $data.formData.config,
              "form-component": _ctx.$refs[$data.formRef],
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["models", "rules", "element", "remote", "blanks", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config", "form-component"])) : (openBlock(), createBlock(_component_generate_form_item, {
              key: 7,
              models: $data.models,
              rules: $data.rules,
              widget: item,
              remote: $props.remote,
              blanks: $data.blanks,
              display: $data.displayFields,
              onInputChange: $options.onInputChange,
              edit: $props.edit,
              "remote-option": $props.remoteOption,
              platform: $props.platform,
              preview: $props.preview,
              "container-key": $data.containerKey,
              "data-source-value": $data.dataSourceValue,
              "event-function": $data.eventFunction,
              "print-read": $props.printRead,
              config: $data.formData.config,
              group: "",
              "field-node": ""
            }, createSlots({ _: 2 }, [
              renderList($data.blanks, (blank) => {
                return {
                  name: blank.name,
                  fn: withCtx((scope) => [
                    renderSlot(_ctx.$slots, blank.name, {
                      model: scope.model
                    })
                  ])
                };
              })
            ]), 1032, ["models", "rules", "widget", "remote", "blanks", "display", "onInputChange", "edit", "remote-option", "platform", "preview", "container-key", "data-source-value", "event-function", "print-read", "config"]))
          ], 64);
        }), 128))
      ]),
      _: 3
    }, 8, ["model", "rules", "class", "label-align", "layout", "onValidate"])) : createCommentVNode("", true)
  ], 6);
}
var GenerateAntdForm = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$4]]);
const request = axios.create({
  withCredentials: false
});
request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(new Error(error).message);
  }
);
request.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(new Error(error).message);
  }
);
var PreviewPdf_vue_vue_type_style_index_0_lang = "";
const _sfc_main$5 = {
  components: {
    CusDialog
  },
  data() {
    return {
      previewVisible: false,
      iframeSrc: ""
    };
  },
  methods: {
    open(pdfBlob) {
      var pdfUrl = URL.createObjectURL(pdfBlob);
      this.iframeSrc = pdfUrl;
      this.previewVisible = true;
    }
  }
};
const _hoisted_1$4 = ["src"];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cus_dialog = resolveComponent("cus-dialog");
  return openBlock(), createBlock(_component_cus_dialog, {
    visible: $data.previewVisible,
    onOnClose: _cache[0] || (_cache[0] = ($event) => $data.previewVisible = false),
    ref: "pdfPreview",
    form: "",
    title: _ctx.$t("fm.actions.pdfPreview"),
    action: false,
    "custom-class": "fm-generate-preview-pdf",
    "close-on-press-escape": false,
    fullscreen: false,
    width: "1200px"
  }, {
    default: withCtx(() => [
      createElementVNode("iframe", {
        src: $data.iframeSrc,
        frameborder: "0",
        width: "100%",
        height: "600px",
        style: { "margin-bottom": "-6px" }
      }, null, 8, _hoisted_1$4)
    ]),
    _: 1
  }, 8, ["visible", "title"]);
}
var PreviewPdf = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$3]]);
var PreviewDialog_vue_vue_type_style_index_0_lang = "";
const _sfc_main$4 = {
  components: {
    CusDialog,
    GenerateForm,
    AntdGenerateForm: GenerateAntdForm,
    PreviewPdf
  },
  props: {},
  inject: {
    themeAlgorithm: {
      default: null
    },
    useAntdForm: {
      default: false
    }
  },
  emits: ["get-data-success"],
  data() {
    return {
      previewVisible: false,
      formEdit: true,
      previewForm: {},
      widgetModels: {},
      platform: "pc",
      printRead: false,
      showQrcode: false,
      exportLoading: false
    };
  },
  methods: {
    generateQrcode(url) {
      if (!window.QRCode) {
        consoleError("QRCode is not defined");
        return false;
      }
      setTimeout(() => {
        this.showQrcode = true;
        var qrcode = new QRCode(document.getElementById("fmpreviewqrcode"), {
          width: 120,
          height: 120
        });
        qrcode.makeCode(url);
      }, 500);
    },
    preview(data2, platform) {
      this.previewForm = data2;
      this.formEdit = this.previewVisible = true;
      this.printRead = false;
      this.showQrcode = false;
      this.platform = platform;
      this.$nextTick(() => {
        var _a2;
        (_a2 = window.document.getElementsByClassName("fm-generate-preview-container")) == null ? void 0 : _a2[0].removeAttribute("tabindex");
      });
    },
    handleTest() {
      const $form = this.previewForm.config.ui == "element" || !this.previewForm.config.ui ? this.$refs.generateForm : this.$refs.generateAntForm;
      $form.getData().then((data2) => {
        this.$emit("get-data-success", data2);
        this.$refs.widgetPreview.end();
      }).catch((e) => {
        ElMessage({
          message: e,
          type: "error"
        });
        this.$refs.widgetPreview.end();
      });
    },
    handleReset() {
      const $form = this.previewForm.config.ui == "element" || !this.previewForm.config.ui ? this.$refs.generateForm : this.$refs.generateAntForm;
      $form.reset();
    },
    handleExportWord() {
      var rules2 = "", ss = document.styleSheets;
      for (var i = 0; i < ss.length; ++i) {
        for (var x = 0; x < ss[i].cssRules.length; ++x) {
          rules2 += ss[i].cssRules[x].cssText;
        }
      }
      var header = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
      <head><meta charset='utf-8'><title>Export HTML to Word Document with JavaScript</title>
      <style>${rules2}</style>
      </head><body>`;
      var footer = "</body></html>";
      var html = header + document.getElementById("export-id").innerHTML + footer;
      var blob = new Blob(["\uFEFF", html], {
        type: "application/msword"
      });
      var url = "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);
      let filename = filename ? filename + ".doc" : "document.doc";
      var downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();
      }
      document.body.removeChild(downloadLink);
    },
    handlePrint() {
      this.printRead = true;
      this.$nextTick(() => {
        window.print();
      });
    },
    handleExportPDF() {
      const tempPrint = this.printRead;
      this.exportLoading = true;
      setTimeout(() => {
        this.printRead = true;
        this.$nextTick(() => {
          const $form = this.previewForm.config.ui == "element" || !this.previewForm.config.ui ? this.$refs.generateForm : this.$refs.generateAntForm;
          $form.exportPDF().then((data2) => {
            this.$refs.pdfPreview.open(data2);
          }).finally(() => {
            this.exportLoading = false;
            this.printRead = tempPrint;
          });
        });
      }, 200);
    }
  }
};
const _hoisted_1$3 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-pc" }, null, -1);
const _hoisted_2$3 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-pad" }, null, -1);
const _hoisted_3$3 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-mobile" }, null, -1);
const _hoisted_4$2 = { style: { "position": "absolute", "top": "80px", "left": "50%", "margin-left": "220px" } };
const _hoisted_5$2 = { style: { "line-height": "20px", "margin-bottom": "10px" } };
const _hoisted_6$2 = /* @__PURE__ */ createElementVNode("div", { id: "fmpreviewqrcode" }, null, -1);
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio_button = resolveComponent("el-radio-button");
  const _component_el_radio_group = resolveComponent("el-radio-group");
  const _component_generate_form = resolveComponent("generate-form");
  const _component_antd_generate_form = resolveComponent("antd-generate-form");
  const _component_a_config_provider = resolveComponent("a-config-provider");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  const _component_el_card = resolveComponent("el-card");
  const _component_el_button = resolveComponent("el-button");
  const _component_cus_dialog = resolveComponent("cus-dialog");
  const _component_PreviewPdf = resolveComponent("PreviewPdf");
  const _directive_loading = resolveDirective("loading");
  return openBlock(), createElementBlock(Fragment, null, [
    createVNode(_component_cus_dialog, {
      visible: $data.previewVisible,
      onOnClose: _cache[6] || (_cache[6] = ($event) => $data.previewVisible = false),
      ref: "widgetPreview",
      form: "",
      title: _ctx.$t("fm.actions.preview"),
      fullscreen: "",
      "custom-class": "fm-generate-preview-container",
      "close-on-press-escape": false
    }, {
      action: withCtx(() => [
        createVNode(_component_el_button, {
          size: "large",
          type: "primary",
          onClick: $options.handleTest
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.getData")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        createVNode(_component_el_button, {
          size: "large",
          onClick: $options.handleReset
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.reset")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        $data.formEdit ? (openBlock(), createBlock(_component_el_button, {
          key: 0,
          size: "large",
          onClick: _cache[1] || (_cache[1] = ($event) => $data.formEdit = false),
          disabled: $data.printRead
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.disabledEdit")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])) : (openBlock(), createBlock(_component_el_button, {
          key: 1,
          size: "large",
          onClick: _cache[2] || (_cache[2] = ($event) => $data.formEdit = true),
          disabled: $data.printRead
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.enabledEdit")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])),
        !$data.printRead ? (openBlock(), createBlock(_component_el_button, {
          key: 2,
          size: "large",
          onClick: _cache[3] || (_cache[3] = ($event) => $data.printRead = true)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.printReadMode")), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true),
        $data.printRead ? (openBlock(), createBlock(_component_el_button, {
          key: 3,
          size: "large",
          onClick: _cache[4] || (_cache[4] = ($event) => $data.printRead = false)
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.editMode")), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true),
        createVNode(_component_el_button, {
          size: "large",
          onClick: $options.handlePrint
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.print")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        createVNode(_component_el_button, {
          size: "large",
          onClick: $options.handleExportPDF,
          loading: $data.exportLoading
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.exportPDF")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"]),
        createVNode(_component_el_button, {
          size: "large",
          onClick: _cache[5] || (_cache[5] = ($event) => $data.previewVisible = false),
          type: "info",
          plain: ""
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.close")), 1)
          ]),
          _: 1
        })
      ]),
      default: withCtx(() => [
        createVNode(_component_el_radio_group, {
          modelValue: $data.platform,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.platform = $event),
          size: "small",
          class: "platform-controller"
        }, {
          default: withCtx(() => [
            createVNode(_component_el_radio_button, {
              label: "pc",
              value: "pc"
            }, {
              default: withCtx(() => [
                _hoisted_1$3
              ]),
              _: 1
            }),
            createVNode(_component_el_radio_button, {
              label: "pad",
              value: "pad"
            }, {
              default: withCtx(() => [
                _hoisted_2$3
              ]),
              _: 1
            }),
            createVNode(_component_el_radio_button, {
              label: "mobile",
              value: "mobile"
            }, {
              default: withCtx(() => [
                _hoisted_3$3
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        withDirectives((openBlock(), createElementBlock("div", {
          class: normalizeClass(["fm-generate-preview", `${$data.platform}`])
        }, [
          createVNode(_component_el_scrollbar, null, {
            default: withCtx(() => [
              $data.previewVisible && ($data.previewForm.config.ui == "element" || !$data.previewForm.config.ui) ? (openBlock(), createBlock(_component_generate_form, {
                key: 0,
                preview: "",
                "print-read": $data.printRead,
                platform: $data.platform,
                id: "export-id",
                edit: $data.formEdit,
                insite: "true",
                data: $data.previewForm,
                value: $data.widgetModels,
                ref: "generateForm"
              }, {
                blank: withCtx(() => []),
                _: 1
              }, 8, ["print-read", "platform", "edit", "data", "value"])) : createCommentVNode("", true),
              $options.useAntdForm ? (openBlock(), createBlock(_component_a_config_provider, {
                key: 1,
                theme: { algorithm: $options.themeAlgorithm }
              }, {
                default: withCtx(() => [
                  $data.previewVisible && $data.previewForm.config.ui == "antd" ? (openBlock(), createBlock(_component_antd_generate_form, {
                    key: 0,
                    preview: "",
                    "print-read": $data.printRead,
                    platform: $data.platform,
                    edit: $data.formEdit,
                    insite: "true",
                    data: $data.previewForm,
                    value: $data.widgetModels,
                    ref: "generateAntForm"
                  }, {
                    blank: withCtx(() => []),
                    _: 1
                  }, 8, ["print-read", "platform", "edit", "data", "value"])) : createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["theme"])) : createCommentVNode("", true)
            ]),
            _: 1
          }),
          withDirectives(createElementVNode("div", _hoisted_4$2, [
            createVNode(_component_el_card, {
              shadow: "never",
              "body-style": {
                padding: "15px"
              }
            }, {
              default: withCtx(() => [
                createElementVNode("div", _hoisted_5$2, toDisplayString$1(_ctx.$t("fm.description.qrcodePreview")), 1),
                _hoisted_6$2
              ]),
              _: 1
            })
          ], 512), [
            [vShow, $data.platform === "mobile" && $data.showQrcode]
          ])
        ], 2)), [
          [_directive_loading, $data.exportLoading]
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    createVNode(_component_PreviewPdf, { ref: "pdfPreview" }, null, 512)
  ], 64);
}
var PreviewDialog = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$2]]);
var index_vue_vue_type_style_index_0_lang = "";
const _hoisted_1$2 = { class: "image-slot" };
const _hoisted_2$2 = { style: { "padding": "10px", "overflow": "hidden", "text-overflow": "ellipsis", "white-space": "nowrap" } };
const _hoisted_3$2 = { key: 0 };
const _hoisted_4$1 = { key: 1 };
const _hoisted_5$1 = { class: "action-cover" };
const _hoisted_6$1 = { class: "import-json-code" };
const _hoisted_7$1 = { style: { "margin-top": "30px", "text-align": "center" } };
const _sfc_main$3 = {
  __name: "index",
  props: {
    libraryList: {
      type: Array,
      defalut: () => []
    }
  },
  emits: ["load-json"],
  setup(__props, { emit: __emit }) {
    const activeName = ref("library");
    const jsonEg = ref(`{
  "list": [],
  "config": {
    "labelWidth": 100,
    "labelPosition": "right",
    "size": "small",
    "customClass": "",
    "ui": "element",
    "layout": "horizontal",
    "width": "100%",
    "hideLabel": false,
    "hideErrorMessage": false
  }
}`);
    const uploadLoading = ref(false);
    const jsonCodeEditor = ref(null);
    const props2 = __props;
    const emit2 = __emit;
    const submit = () => {
      emit2("load-json", jsonEg.value);
    };
    const loadJson = (json) => {
      emit2("load-json", json);
    };
    const uploadJsonFile = () => {
      let input = document.createElement("input");
      input.type = "file";
      input.accept = ".json";
      input.onchange = (event) => {
        uploadLoading.value = true;
        let file = event.target.files[0];
        if (file.type === "application/json") {
          let fileReader = new FileReader();
          fileReader.onload = () => {
            let fc = fileReader.result;
            jsonEg.value = fc;
            jsonCodeEditor.value.setValue(fc);
            uploadLoading.value = false;
          };
          fileReader.readAsText(file, "UTF-8");
        } else {
          uploadLoading.value = false;
          ElMessage.error("File Type Error!");
        }
      };
      input.click();
    };
    return (_ctx, _cache) => {
      const _component_el_image = resolveComponent("el-image");
      const _component_el_button = resolveComponent("el-button");
      const _component_el_card = resolveComponent("el-card");
      const _component_el_space = resolveComponent("el-space");
      const _component_el_empty = resolveComponent("el-empty");
      const _component_el_scrollbar = resolveComponent("el-scrollbar");
      const _component_el_tab_pane = resolveComponent("el-tab-pane");
      const _component_el_alert = resolveComponent("el-alert");
      const _component_el_tabs = resolveComponent("el-tabs");
      return openBlock(), createBlock(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => activeName.value = $event),
        class: "import-json-container"
      }, {
        default: withCtx(() => [
          createVNode(_component_el_tab_pane, {
            label: _ctx.$t("fm.importjson.name"),
            name: "library"
          }, {
            default: withCtx(() => [
              createVNode(_component_el_scrollbar, {
                height: "560px",
                always: "",
                class: "import-json-library-container"
              }, {
                default: withCtx(() => {
                  var _a2;
                  return [
                    ((_a2 = props2.libraryList) == null ? void 0 : _a2.length) ? (openBlock(), createBlock(_component_el_space, {
                      key: 0,
                      wrap: "",
                      size: 20
                    }, {
                      default: withCtx(() => [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(props2.libraryList, (item) => {
                          return openBlock(), createBlock(_component_el_card, {
                            class: "import-json-card",
                            key: item.title,
                            shadow: "hover",
                            "body-style": { padding: "0px", width: "218px" }
                          }, {
                            default: withCtx(() => [
                              createVNode(_component_el_image, {
                                style: { "width": "218px", "height": "218px" },
                                src: item.url,
                                fit: "contain"
                              }, {
                                error: withCtx(() => [
                                  createElementVNode("div", _hoisted_1$2, toDisplayString$1(_ctx.$t("fm.importjson.noimage")), 1)
                                ]),
                                _: 2
                              }, 1032, ["src"]),
                              createElementVNode("div", _hoisted_2$2, [
                                _ctx.$i18n.locale == "zh-cn" ? (openBlock(), createElementBlock("span", _hoisted_3$2, toDisplayString$1(item.title), 1)) : (openBlock(), createElementBlock("span", _hoisted_4$1, toDisplayString$1(item.enTitle), 1))
                              ]),
                              createElementVNode("div", _hoisted_5$1, [
                                createVNode(_component_el_button, {
                                  type: "primary",
                                  round: "",
                                  onClick: ($event) => loadJson(item.json)
                                }, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString$1(_ctx.$t("fm.importjson.loadjson")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024);
                        }), 128))
                      ]),
                      _: 1
                    })) : (openBlock(), createBlock(_component_el_empty, {
                      key: 1,
                      description: _ctx.$t("fm.importjson.nojson")
                    }, null, 8, ["description"]))
                  ];
                }),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["label"]),
          createVNode(_component_el_tab_pane, {
            label: "JSON",
            name: "json"
          }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_6$1, [
                createVNode(_component_el_alert, {
                  type: "info",
                  title: _ctx.$t("fm.description.uploadJsonInfo")
                }, null, 8, ["title"]),
                createVNode(CodeEditor, {
                  height: "450px",
                  mode: "json",
                  modelValue: jsonEg.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => jsonEg.value = $event),
                  ref_key: "jsonCodeEditor",
                  ref: jsonCodeEditor,
                  wrap: ""
                }, null, 8, ["modelValue"]),
                createElementVNode("div", _hoisted_7$1, [
                  createVNode(_component_el_button, {
                    type: "primary",
                    onClick: uploadJsonFile,
                    loading: uploadLoading.value
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.importFile")), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  createVNode(_component_el_button, {
                    type: "primary",
                    onClick: submit
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.confirm")), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
};
const _sfc_main$2 = {
  __name: "dialog",
  emits: ["load-json"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const visible = ref(false);
    const libraryList = ref([]);
    const emit2 = __emit;
    const open2 = (list) => {
      visible.value = true;
      libraryList.value = list;
    };
    const handleClose = () => {
      visible.value = false;
    };
    const handleLoadJson = (json) => {
      emit2("load-json", json);
      visible.value = false;
    };
    __expose({
      open: open2
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(CusDialog, {
        visible: visible.value,
        onOnClose: handleClose,
        width: "1000px",
        form: "",
        title: _ctx.$t("fm.actions.import"),
        action: false
      }, {
        default: withCtx(() => [
          createVNode(_sfc_main$3, {
            "library-list": libraryList.value,
            onLoadJson: handleLoadJson
          }, null, 8, ["library-list"])
        ]),
        _: 1
      }, 8, ["visible", "title"]);
    };
  }
};
var Outline_vue_vue_type_style_index_0_lang = "";
const _sfc_main$1 = {
  props: ["data", "show"],
  data() {
    return {
      filterText: "",
      defaultProps: {
        children: "children",
        label: "label",
        disabled: "disabled"
      },
      treeData: [],
      currentKey: ""
    };
  },
  emits: ["select"],
  mounted() {
    this.treeData = this.loadNode(this.data);
    this.loadTreeWidthStyle();
  },
  methods: {
    filterNode(value, data2) {
      if (!value)
        return true;
      return data2.label.includes(value);
    },
    loadNode(list) {
      var _a2;
      let currentNode = [];
      for (let i = 0; i < list.length; i++) {
        if (!list[i].type)
          continue;
        currentNode.push({
          id: list[i].key,
          label: (list[i].icon ? `<i class="iconfont fm-iconfont ${list[i].icon}"></i>&nbsp;` : "") + `<span class="custom-tree-node-type">${list[i].type ? this.$t("fm.components.fields." + list[i].type) : "undefined"}</span>` + (list[i].model ? `&nbsp;{ <span class="custom-tree-node-model">${list[i].model}</span> }` : ""),
          children: [],
          dataBind: (_a2 = list[i].options) == null ? void 0 : _a2.dataBind
        });
        if (list[i].type == "grid") {
          currentNode[i].children = this.loadNode(list[i].columns);
        }
        if (list[i].type == "col") {
          currentNode[i].children = this.loadNode(list[i].list);
        }
        if (list[i].type == "report") {
          let reportList = [];
          for (let r = 0; r < list[i].rows.length; r++) {
            for (let c = 0; c < list[i].rows[r].columns.length; c++) {
              let td = list[i].rows[r].columns[c];
              if (!td.options.invisible) {
                reportList.push(td);
              }
            }
          }
          currentNode[i].children = this.loadNode(reportList);
        }
        if (list[i].type == "td") {
          currentNode[i].children = this.loadNode(list[i].list);
        }
        if (list[i].type == "tabs") {
          for (let t = 0; t < list[i].tabs.length; t++) {
            currentNode[i].children.push({
              label: list[i].tabs[t].label,
              children: [],
              disabled: true
            });
            currentNode[i].children[t].children = this.loadNode(list[i].tabs[t].list);
          }
        }
        if (list[i].type == "collapse") {
          for (let t = 0; t < list[i].tabs.length; t++) {
            currentNode[i].children.push({
              label: list[i].tabs[t].title,
              children: [],
              disabled: true
            });
            currentNode[i].children[t].children = this.loadNode(list[i].tabs[t].list);
          }
        }
        if (list[i].type == "inline") {
          currentNode[i].children = this.loadNode(list[i].list);
        }
        if (list[i].type == "table") {
          currentNode[i].children = this.loadNode(list[i].tableColumns);
        }
        if (list[i].type == "subform") {
          currentNode[i].children = this.loadNode(list[i].list);
        }
        if (list[i].type == "dialog") {
          currentNode[i].children = this.loadNode(list[i].list);
        }
        if (list[i].type == "card") {
          currentNode[i].children = this.loadNode(list[i].list);
        }
        if (list[i].type == "group") {
          currentNode[i].children = this.loadNode(list[i].list);
        }
      }
      return currentNode;
    },
    loadTreeWidthStyle() {
      if (!this.show)
        return;
      document.querySelector(".fm-outline-content .el-scrollbar__view").removeAttribute("style");
      let realWidth = document.querySelector(".fm-outline-content .el-scrollbar__wrap").scrollWidth;
      document.querySelector(".fm-outline-content .el-scrollbar__view").setAttribute("style", `width: ${realWidth <= 250 ? realWidth : realWidth + 5}px`);
    },
    onNodeClick(data2, node) {
      var _a2;
      if (data2.id) {
        this.$emit("select", data2.id);
        this.currentKey = data2.id;
      } else {
        (_a2 = this.$refs.treeRef) == null ? void 0 : _a2.setCurrentKey(this.currentKey);
      }
    },
    setCurrentKey(key, isScrollTo) {
      var _a2;
      this.currentKey = key;
      (_a2 = this.$refs.treeRef) == null ? void 0 : _a2.setCurrentKey(key);
      setTimeout(() => {
        isScrollTo && this.scrollTo();
      }, 200);
    },
    scrollTo() {
      var _a2;
      let y = (_a2 = document.querySelector(".fm-outline-content .is-current")) == null ? void 0 : _a2.offsetTop;
      let containerHeight = document.querySelector(".fm-outline-content").offsetHeight;
      let containerTop = document.querySelector(".fm-outline-content").getBoundingClientRect().top;
      let scorllTop = document.querySelector(".fm-outline-content .el-scrollbar__view").getBoundingClientRect().top;
      let top = scorllTop - containerTop;
      if (y > -top + containerHeight || y < -top) {
        this.$refs.scrollRef.setScrollTop(y);
      }
    }
  },
  watch: {
    filterText(val) {
      this.$refs.treeRef.filter(val);
    },
    data: {
      deep: true,
      handler(val) {
        this.treeData = this.loadNode(val);
        this.loadTreeWidthStyle();
        this.$nextTick(() => {
          var _a2;
          (_a2 = this.$refs.treeRef) == null ? void 0 : _a2.setCurrentKey(this.currentKey);
          this.$refs.treeRef.filter(this.filterText);
        });
      }
    }
  }
};
const _hoisted_1$1 = { class: "fm-outline-header" };
const _hoisted_2$1 = { class: "fm-outline-content" };
const _hoisted_3$1 = ["innerHTML"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = resolveComponent("el-input");
  const _component_el_tree = resolveComponent("el-tree");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  return openBlock(), createElementBlock(Fragment, null, [
    createElementVNode("div", _hoisted_1$1, [
      createVNode(_component_el_input, {
        modelValue: $data.filterText,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.filterText = $event),
        placeholder: "Filter node",
        clearable: ""
      }, null, 8, ["modelValue"])
    ]),
    createElementVNode("div", _hoisted_2$1, [
      createVNode(_component_el_scrollbar, { ref: "scrollRef" }, {
        default: withCtx(() => [
          createVNode(_component_el_tree, {
            ref: "treeRef",
            class: "filter-tree",
            data: $data.treeData,
            props: $data.defaultProps,
            "default-expand-all": "",
            "highlight-current": "",
            "expand-on-click-node": false,
            "filter-node-method": $options.filterNode,
            indent: 16,
            "node-key": "id",
            onNodeClick: $options.onNodeClick,
            "check-on-click-node": ""
          }, {
            default: withCtx(({ node }) => {
              var _a2;
              return [
                createElementVNode("div", {
                  class: normalizeClass(["custom-tree-node", { "is-bind": (_a2 = node.data) == null ? void 0 : _a2.dataBind }])
                }, [
                  createElementVNode("span", {
                    innerHTML: node.label
                  }, null, 8, _hoisted_3$1)
                ], 2)
              ];
            }),
            _: 1
          }, 8, ["data", "props", "filter-node-method", "onNodeClick"])
        ]),
        _: 1
      }, 512)
    ])
  ], 64);
}
var Outline = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
const findChildren = (stack, data2, key, value) => {
  var _a2, _b, _c;
  let findItem = data2.find((item) => item[key] == value);
  if (findItem) {
    stack.push({
      type: findItem.type,
      key: findItem.key,
      model: findItem.model
    });
  } else {
    for (let i = 0; i < data2.length; i++) {
      const item = data2[i];
      if (item.type === "grid") {
        for (let j = 0; j < item.columns.length; j++) {
          if ((_a2 = item.columns[j].list) == null ? void 0 : _a2.length) {
            stack.push({
              type: item.type,
              key: item.key,
              model: item.model
            });
            let res = findChildren([...stack], item.columns[j].list, key, value);
            if (res.length > stack.length) {
              return res;
            }
            stack.pop();
          }
        }
      }
      if (item.type === "table") {
        if (item.tableColumns.length) {
          stack.push({
            type: item.type,
            key: item.key,
            model: item.model
          });
          let res = findChildren([...stack], item.tableColumns, key, value);
          if (res.length > stack.length) {
            return res;
          }
          stack.pop();
        }
      }
      if (item.type === "subform" || item.type === "inline" || item.type === "dialog" || item.type === "card" || item.type === "group") {
        if (item.list.length) {
          stack.push({
            type: item.type,
            key: item.key,
            model: item.model
          });
          let res = findChildren([...stack], item.list, key, value);
          if (res.length > stack.length) {
            return res;
          }
          stack.pop();
        }
      }
      if (item.type === "tabs" || item.type === "collapse") {
        for (let j = 0; j < item.tabs.length; j++) {
          if ((_b = item.tabs[j].list) == null ? void 0 : _b.length) {
            stack.push({
              type: item.type,
              key: item.key,
              model: item.model
            });
            let res = findChildren([...stack], item.tabs[j].list, key, value);
            if (res.length > stack.length) {
              return res;
            }
            stack.pop();
          }
        }
      }
      if (item.type === "report") {
        for (let r = 0; r < item.rows.length; r++) {
          for (let c = 0; c < item.rows[r].columns.length; c++) {
            if ((_c = item.rows[r].columns[c].list) == null ? void 0 : _c.length) {
              stack.push({
                type: item.type,
                key: item.key,
                model: item.model
              });
              let res = findChildren([...stack], item.rows[r].columns[c].list, key, value);
              if (res.length > stack.length) {
                return res;
              }
              stack.pop();
            }
          }
        }
      }
    }
  }
  return stack;
};
const findModelNode = (data2, key, value) => {
  let res = [];
  let array = findChildren([], data2, key, value);
  for (let i = 0; i < array.length; i++) {
    if (array[i].type !== "grid" && array[i].type !== "inline" && array[i].type !== "card" && array[i].type !== "tabs" && array[i].type !== "collapse" && array[i].type !== "report" || array.length === i + 1) {
      res.push(array[i].model);
    }
  }
  return res;
};
const findModelNodeString = (data2, key, value) => {
  let res = findModelNode(data2, key, value);
  if (res.length > 1) {
    res.pop();
    return res.join(".") + ".";
  } else {
    return "";
  }
};
const getModels = (list, group = "") => {
  let currentNode = [];
  for (let i = 0; i < list.length; i++) {
    if (list[i].type === "grid") {
      list[i].columns.forEach((item) => {
        currentNode = currentNode.concat(getModels(item.list, group));
      });
    } else if (list[i].type === "tabs") {
      list[i].tabs.forEach((item) => {
        currentNode = currentNode.concat(getModels(item.list, group));
      });
    } else if (list[i].type === "collapse") {
      list[i].tabs.forEach((item) => {
        currentNode = currentNode.concat(getModels(item.list, group));
      });
    } else if (list[i].type === "report") {
      list[i].rows.forEach((row) => {
        row.columns.forEach((column) => {
          currentNode = currentNode.concat(getModels(column.list, group));
        });
      });
    } else if (list[i].type === "inline") {
      currentNode = currentNode.concat(getModels(list[i].list, group));
    } else if (list[i].type === "card") {
      currentNode = currentNode.concat(getModels(list[i].list, group));
    } else {
      if (list[i].options.dataBind) {
        let children = [];
        let curGroup = group ? group + "." + list[i].model : list[i].model;
        if (list[i].type === "table") {
          children = getModels(list[i].tableColumns, curGroup);
        }
        if (list[i].type === "subform") {
          children = getModels(list[i].list, curGroup);
        }
        if (list[i].type === "dialog") {
          children = getModels(list[i].list, curGroup);
        }
        if (list[i].type === "group") {
          children = getModels(list[i].list, curGroup);
        }
        currentNode.push({
          id: group ? group + "." + list[i].model : list[i].model,
          name: list[i].name,
          type: list[i].type,
          icon: list[i].icon,
          children
        });
      }
    }
  }
  return currentNode;
};
var Container_vue_vue_type_style_index_0_lang = "";
const _sfc_main = {
  name: "fm-making-form",
  components: {
    Draggable: draggableComponent,
    WidgetConfig,
    FormConfig,
    WidgetForm,
    CusDialog,
    CodeEditor,
    PreviewDialog,
    ImportJsonDialog: _sfc_main$2,
    Outline
  },
  props: {
    preview: {
      type: Boolean,
      default: false
    },
    generateCode: {
      type: Boolean,
      default: false
    },
    generateJson: {
      type: Boolean,
      default: false
    },
    upload: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    basicFields: {
      type: Array,
      default: () => ["input", "textarea", "number", "radio", "checkbox", "time", "date", "rate", "color", "select", "switch", "slider", "text", "html", "button", "link", "cascader", "treeselect", "steps", "transfer", "pagination"]
    },
    advanceFields: {
      type: Array,
      default: () => ["blank", "component", "fileupload", "imgupload", "editor"]
    },
    layoutFields: {
      type: Array,
      default: () => ["grid", "report", "tabs", "collapse", "inline", "card", "divider", "alert"]
    },
    collectionFields: {
      type: Array,
      default: () => ["table", "subform", "dialog", "group"]
    },
    customFields: {
      type: Array,
      default: () => []
    },
    globalConfig: {
      type: Object,
      default: () => ({})
    },
    fieldConfig: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ""
    },
    cache: {
      type: Boolean,
      default: false
    },
    jsonTemplates: {
      type: Array,
      default: () => []
    },
    initFromTemplate: {
      type: Boolean,
      default: false
    },
    fieldModels: {
      type: Array,
      default: () => []
    },
    panel: {
      type: String,
      default: "field"
    },
    zIndex: {
      type: Number,
      default: 2e3
    },
    useAntdForm: {
      type: Boolean,
      default: false
    }
  },
  emits: ["ready", "preview"],
  data() {
    return {
      version: window.FormMaking_OPTIONS["version"],
      basicComponents,
      layoutComponents,
      advanceComponents,
      collectionComponents,
      customComponents: [],
      resetJson: false,
      widgetForm: {
        list: [],
        config: {
          labelWidth: 100,
          labelPosition: "left",
          size: "default",
          customClass: "",
          ui: "element",
          layout: "horizontal",
          width: "100%",
          hideLabel: false,
          hideErrorMessage: false
        }
      },
      configTab: "form",
      widgetFormSelect: null,
      previewVisible: false,
      jsonVisible: false,
      codeVisible: false,
      uploadVisible: false,
      blank: "",
      htmlTemplate: "",
      jsonTemplate: "",
      vueTemplate: "",
      uploadEditor: null,
      jsonCopyValue: "",
      jsonClipboard: null,
      codeCopyValue: "",
      codeClipboard: null,
      codeActiveName: "vue",
      undo: false,
      redo: false,
      formKey: Math.random().toString(36).slice(-8),
      styleSheetsArray: [],
      dataSourceArray: [],
      eventScriptArray: [],
      platform: "pc",
      activeFields: ["basic", "advance", "layout", "custom", "collection"],
      activeLeft: this.panel,
      isScrollTo: true,
      jsonTitle: this.$t("fm.actions.json"),
      modelNode: "",
      rightHide: false,
      leftHide: false,
      fullscreen: false
    };
  },
  created() {
    this._loadComponents();
  },
  provide() {
    return {
      "changeConfigTab": this.changeConfigTab,
      "getModelNode": this.getModelNode,
      "isMobile": this.isMobile,
      "getFormModels": this.getFormModels,
      "getFormFields": this.getFormFields,
      "getDataSourceArray": this.getDataSourceArray,
      "useAntdForm": this.useAntdForm
    };
  },
  mounted() {
    const _this = this;
    historyManager.clear().then(() => {
      var _a2;
      this.widgetForm.config.eventScript = [
        { key: "mounted", name: "mounted", func: "" },
        { key: "refresh", name: "refresh", func: "" }
      ];
      this.widgetForm.config = {
        ...this.widgetForm.config,
        ...this.globalConfig
      };
      this.platform = this.widgetForm.config.platform || "pc";
      this.initConfig();
      this.cache && this.setJSON((_a2 = localStorage.getItem("fmjson" + this.name)) != null ? _a2 : this.widgetForm);
      this.$emit("ready");
      EventBus.$on("on-history-add-" + this.formKey, () => {
        historyManager.add(this.widgetForm, this.widgetFormSelect && this.widgetFormSelect.key ? this.widgetFormSelect.key : "").then(() => {
          _this.undo = true;
          _this.redo = false;
        });
        this.saveJsonCache();
      });
      window.onbeforeunload = (e) => {
        this.saveJsonCache();
      };
      if (this.initFromTemplate) {
        this.handleUpload();
      }
    });
  },
  beforeUnmount() {
    EventBus.$off("on-history-add-" + this.formKey);
    this.saveJsonCache();
  },
  methods: {
    generatePreviewQrcode(url) {
      this.$refs.previewDialog.generateQrcode(url);
    },
    handleRightToggle() {
      if (this.rightHide) {
        removeClass$1(this.$refs["widgetConfigContainer"].$el, "hide-status");
        this.rightHide = false;
      } else {
        addClass$1(this.$refs["widgetConfigContainer"].$el, "hide-status");
        this.rightHide = true;
      }
    },
    handleLeftToggle() {
      if (this.leftHide) {
        removeClass$1(this.$refs["widgetLeftPanel"].$el, "hide-status");
        this.leftHide = false;
      } else {
        addClass$1(this.$refs["widgetLeftPanel"].$el, "hide-status");
        this.leftHide = true;
      }
    },
    saveJsonCache() {
      this.cache && localStorage.setItem("fmjson" + this.name, JSON.stringify(this.widgetForm));
    },
    removeJsonCache() {
      localStorage.setItem("fmjson" + this.name, JSON.stringify(this.widgetForm));
    },
    initConfig() {
      this.platform = this.widgetForm.config.platform || "pc";
      this.onStyleUpdate(splitStyleSheets(this.widgetForm.config.styleSheets || ""));
      this.onDataSourceUpdate(this.widgetForm.config.dataSource || []);
      this.onEventScriptUpdate(this.widgetForm.config.eventScript || []);
    },
    handleGoGithub() {
      window.location.href = "https://github.com/GavinZhuLei/vue-form-making";
    },
    handleConfigSelect(value) {
      this.configTab = value;
    },
    handleMoveEnd(evt) {
    },
    handleMoveStart({ oldIndex: oldIndex2 }) {
    },
    handleMove() {
      return true;
    },
    handlePreview() {
      this.$emit("preview", _.cloneDeep(this.widgetForm));
      this.$refs.previewDialog.preview(_.cloneDeep(this.widgetForm), this.platform);
    },
    preivewGetData(data2) {
      this.jsonTitle = this.$t("fm.actions.getData");
      this.jsonVisible = true;
      this.jsonTemplate = data2;
      this.$nextTick(() => {
        this.jsonClipboard = new ClipboardJS(document.getElementsByClassName("json-btn")[0]);
        this.jsonClipboard.on("success", (e) => {
          ElMessage({
            message: this.$t("fm.message.copySuccess"),
            type: "success"
          });
        });
        this.jsonCopyValue = JSON.stringify(data2);
      });
    },
    handleGenerateJson() {
      this.jsonTitle = this.$t("fm.actions.json");
      this.jsonVisible = true;
      this.jsonTemplate = this.widgetForm;
      this.$nextTick(() => {
        this.jsonClipboard = new ClipboardJS(document.getElementsByClassName("json-btn")[0]);
        this.jsonClipboard.on("success", (e) => {
          ElMessage({
            message: this.$t("fm.message.copySuccess"),
            type: "success"
          });
          e.clearSelection();
        });
        this.jsonCopyValue = JSON.stringify(this.widgetForm);
      });
    },
    handleGenerateCode() {
      this.codeVisible = true;
      this.htmlTemplate = generateCode(JSON.stringify(this.widgetForm), "html", this.widgetForm.config.ui);
      this.vueTemplate = generateCode(JSON.stringify(this.widgetForm), "vue", this.widgetForm.config.ui);
      this.$nextTick(() => {
        this.codeClipboard = new ClipboardJS(document.getElementsByClassName("code-btn")[0]);
        this.codeClipboard.on("success", (e) => {
          ElMessage({
            message: this.$t("fm.message.copySuccess"),
            type: "success"
          });
        });
        this.codeCopyValue = this.codeActiveName == "vue" ? this.vueTemplate : this.htmlTemplate;
      });
    },
    handleUpload() {
      this.$refs.importJsonDialog.open(this.jsonTemplates);
    },
    handleLoadJson(json) {
      try {
        this.setJSON(json);
      } catch (e) {
        ElMessage({
          message: e.message,
          type: "error"
        });
      }
    },
    handleClear() {
      this.widgetForm = {
        ...this.widgetForm,
        list: []
      };
      this.widgetFormSelect = {};
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    clear() {
      this.handleClear();
    },
    getJSON() {
      return this.widgetForm;
    },
    getHtml(type = "html", ui = "element") {
      return generateCode(JSON.stringify(this.widgetForm), type, ui);
    },
    setJSON(json) {
      if (typeof json === "string") {
        json = JSON.parse(json);
      }
      this.widgetForm = _.cloneDeep({
        ...json,
        list: json.list.map((item) => UpgradeData(item))
      });
      if (json.list.length > 0) {
        this.widgetFormSelect = this.widgetForm.list[0];
      } else {
        this.widgetFormSelect = {};
      }
      this.initConfig();
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handleInput(val) {
      this.blank = val;
    },
    handleField(item) {
      EventBus.$emit("on-field-add-" + this.formKey, item);
    },
    handleUndo() {
      if (this.undo) {
        historyManager.updateLatest(this.widgetForm, this.widgetFormSelect && this.widgetFormSelect.key ? this.widgetFormSelect.key : "").then(() => {
          historyManager.undo().then((data2) => {
            this.widgetForm = { ...data2.data };
            this.widgetFormSelect = this._findWidgetItem(this.widgetForm.list, data2.key);
            this.undo = data2.undo;
            this.redo = data2.redo;
            this.initConfig();
          });
        });
      }
    },
    handleRedo() {
      if (this.redo) {
        historyManager.redo().then((data2) => {
          this.widgetForm = { ...data2.data };
          this.widgetFormSelect = this._findWidgetItem(this.widgetForm.list, data2.key);
          this.undo = data2.undo;
          this.redo = data2.redo;
          this.initConfig();
        });
      }
    },
    handleFullScreen() {
      this.fullscreen = true;
    },
    handleExitFullScreen() {
      this.fullscreen = false;
    },
    _findWidgetItem(list, key, type = "key") {
      const index2 = list.findIndex((item) => item[type] == key);
      if (index2 >= 0) {
        return list[index2];
      } else {
        for (let m = 0; m < list.length; m++) {
          const item = list[m];
          if (item.type === "grid") {
            let findItem = this._findWidgetItem(item.columns, key, type);
            if (findItem.key) {
              return findItem;
            }
            for (let i = 0; i < item.columns.length; i++) {
              let findItem2 = this._findWidgetItem(item.columns[i].list, key, type);
              if (findItem2.key) {
                return findItem2;
              }
            }
          }
          if (item.type === "table") {
            let findItem = this._findWidgetItem(item.tableColumns, key, type);
            if (findItem.key) {
              return findItem;
            }
          }
          if (item.type === "subform") {
            let findItem = this._findWidgetItem(item.list, key, type);
            if (findItem.key) {
              return findItem;
            }
          }
          if (item.type === "tabs") {
            for (let i = 0; i < item.tabs.length; i++) {
              let findItem = this._findWidgetItem(item.tabs[i].list, key, type);
              if (findItem.key) {
                return findItem;
              }
            }
          }
          if (item.type === "collapse") {
            for (let i = 0; i < item.tabs.length; i++) {
              let findItem = this._findWidgetItem(item.tabs[i].list, key, type);
              if (findItem.key) {
                return findItem;
              }
            }
          }
          if (item.type === "report") {
            for (let r = 0; r < item.rows.length; r++) {
              let findItem = this._findWidgetItem(item.rows[r].columns, key, type);
              if (findItem.key) {
                return findItem;
              }
              for (let c = 0; c < item.rows[r].columns.length; c++) {
                let findItem2 = this._findWidgetItem(item.rows[r].columns[c].list, key, type);
                if (findItem2.key) {
                  return findItem2;
                }
              }
            }
          }
          if (item.type === "inline") {
            let findItem = this._findWidgetItem(item.list, key, type);
            if (findItem.key) {
              return findItem;
            }
          }
          if (item.type === "dialog") {
            let findItem = this._findWidgetItem(item.list, key, type);
            if (findItem.key) {
              return findItem;
            }
          }
          if (item.type === "card") {
            let findItem = this._findWidgetItem(item.list, key, type);
            if (findItem.key) {
              return findItem;
            }
          }
          if (item.type === "group") {
            let findItem = this._findWidgetItem(item.list, key, type);
            if (findItem.key) {
              return findItem;
            }
          }
        }
        return {};
      }
    },
    _loadComponents() {
      this.basicComponents = this.basicComponents.map((item) => {
        return {
          ...item,
          name: this.$t(`fm.components.fields.${item.type}`),
          options: (() => {
            let newField = this.fieldConfig.find((o) => o.type == item.type);
            if (newField) {
              return { ...item.options, ...newField.options };
            } else {
              return { ...item.options };
            }
          })()
        };
      });
      this.advanceComponents = this.advanceComponents.map((item) => {
        return {
          ...item,
          name: this.$t(`fm.components.fields.${item.type}`),
          options: (() => {
            let newField = this.fieldConfig.find((o) => o.type == item.type);
            if (newField) {
              return { ...item.options, ...newField.options };
            } else {
              return { ...item.options };
            }
          })()
        };
      });
      this.layoutComponents = this.layoutComponents.map((item) => {
        return {
          ...item,
          name: this.$t(`fm.components.fields.${item.type}`),
          options: (() => {
            let newField = this.fieldConfig.find((o) => o.type == item.type);
            if (newField) {
              return { ...item.options, ...newField.options };
            } else {
              return { ...item.options };
            }
          })()
        };
      });
      this.collectionComponents = this.collectionComponents.map((item) => {
        return {
          ...item,
          name: this.$t(`fm.components.fields.${item.type}`),
          options: (() => {
            let newField = this.fieldConfig.find((o) => o.type == item.type);
            if (newField) {
              return { ...item.options, ...newField.options };
            } else {
              return { ...item.options };
            }
          })()
        };
      });
      this.customComponents = this.customFields.map((item) => {
        return {
          ...item,
          type: "custom",
          options: (() => {
            let newField = this.fieldConfig.find((o) => o.type == item.type);
            if (newField) {
              return { ...item.options, ...newField.options };
            } else {
              return { ...item.options };
            }
          })()
        };
      });
    },
    onStyleUpdate(sheets) {
      let head = ".fm-" + this.formKey + " ";
      updateStyleSheets(sheets, head);
      this.styleSheetsArray = splitSheetName(sheets);
    },
    onDataSourceUpdate(dataSource) {
      this.dataSourceArray = dataSource.map((item) => ({
        value: item.key,
        label: item.name,
        args: item.args ? Object.fromEntries(item.args.map((o) => [o, ""])) : {}
      }));
    },
    onEventScriptUpdate(eventScript) {
      this.eventScriptArray = eventScript.map((item) => ({
        value: item.key,
        label: item.name
      }));
    },
    onEventScriptConfirm(eventObj) {
      this.$refs.widgetConfig.setEvent(eventObj);
      this.$nextTick(() => {
        EventBus.$emit("on-history-add-" + this.formKey);
      });
    },
    handlePlatform(platform) {
      this.widgetForm.config.platform = this.platform = platform;
    },
    handleExport() {
      const fileName = new Date().getTime() + "." + this.codeActiveName;
      const fileData = this.codeActiveName == "vue" ? this.vueTemplate : this.htmlTemplate;
      this._exportFile(fileData, fileName);
    },
    handleExportJSON() {
      this._exportFile(JSON.stringify(this.jsonTemplate), new Date().getTime() + ".json");
    },
    handleEventAdd(name) {
      this.$refs.formConfig.editScript(name);
    },
    handleEventEdit({ eventName, functionKey }) {
      this.$refs.formConfig.editScript(eventName, functionKey);
    },
    handleEventRemove(eventName) {
      this.widgetFormSelect.events[eventName] = "";
    },
    _exportFile(data2, fileName) {
      let blob = new Blob([data2], {
        type: "application/octet-stream"
      });
      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        let downloadLink = document.createElement("a");
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = fileName;
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    },
    setSelect(field) {
      let selectWidget = this._findWidgetItem(this.widgetForm.list, field, "model");
      if (selectWidget) {
        this.widgetFormSelect = selectWidget;
      }
    },
    changeConfigTab(tab) {
      this.configTab = tab;
    },
    onSelectWidget(key) {
      let selectWidget = this._findWidgetItem(this.widgetForm.list, key, "key");
      if (selectWidget) {
        this.isScrollTo = false;
        this.widgetFormSelect = selectWidget;
      }
      setTimeout(() => {
        this.$refs.widgetForm.scrollTo();
      }, 200);
    },
    getModelNode() {
      return this.modelNode;
    },
    isMobile() {
      return this.platform === "mobile";
    },
    getFormModels() {
      return getModels(this.widgetForm.list);
    },
    getFormFields() {
      return this._getFormFields(this.widgetForm.list);
    },
    _getFormFields(list, group = "", parent = "") {
      var _a2, _b, _c;
      let currentNode = [];
      for (let i = 0; i < list.length; i++) {
        if (!list[i].type)
          continue;
        const curLabel = parent ? [parent, `<${this.$t("fm.components.fields." + list[i].type)}>${(_a2 = list[i].model) != null ? _a2 : ""}`].join(" / ") : `<${this.$t("fm.components.fields." + list[i].type)}>${(_b = list[i].model) != null ? _b : ""}`;
        currentNode.push({
          id: list[i].model ? group ? group + "." + list[i].model : list[i].model : list[i].key,
          label: curLabel,
          icon: list[i].icon,
          type: list[i].type,
          model: list[i].model,
          children: [],
          dataBind: (_c = list[i].options) == null ? void 0 : _c.dataBind,
          options: list[i].options,
          disabled: (list[i].model ? false : true) || ["grid", "report", "tabs", "collapse", "inline", "card", "divider", "alert"].includes(list[i].type),
          hideDisabled: list[i].model ? false : true,
          setdataDisabled: (list[i].model ? false : true) || ["grid", "report", "tabs", "collapse", "inline", "card", "divider", "alert", "button", "link"].includes(list[i].type),
          remoteOptionDisabled: !(list[i].options.remote && list[i].options.remoteType == "datasource"),
          dialogDisabled: list[i].type !== "dialog"
        });
        if (list[i].type == "grid") {
          currentNode[i].children = this._getFormFields(list[i].columns, group, curLabel);
        }
        if (list[i].type == "col") {
          currentNode[i].children = this._getFormFields(list[i].list, group, curLabel);
        }
        if (list[i].type == "report") {
          let reportList = [];
          for (let r = 0; r < list[i].rows.length; r++) {
            for (let c = 0; c < list[i].rows[r].columns.length; c++) {
              let td = list[i].rows[r].columns[c];
              if (!td.options.invisible) {
                reportList.push(td);
              }
            }
          }
          currentNode[i].children = this._getFormFields(reportList, group, curLabel);
        }
        if (list[i].type == "td") {
          currentNode[i].children = this._getFormFields(list[i].list, group, curLabel);
        }
        if (list[i].type == "tabs") {
          for (let t = 0; t < list[i].tabs.length; t++) {
            currentNode[i].children.push({
              label: list[i].tabs[t].label,
              children: [],
              disabled: true,
              id: Math.random().toString(36).slice(-8),
              setdataDisabled: true,
              remoteOptionDisabled: true,
              dialogDisabled: true
            });
            currentNode[i].children[t].children = this._getFormFields(list[i].tabs[t].list, group, curLabel);
          }
        }
        if (list[i].type == "collapse") {
          for (let t = 0; t < list[i].tabs.length; t++) {
            currentNode[i].children.push({
              label: list[i].tabs[t].title,
              children: [],
              disabled: true,
              id: Math.random().toString(36).slice(-8),
              setdataDisabled: true,
              remoteOptionDisabled: true,
              dialogDisabled: true
            });
            currentNode[i].children[t].children = this._getFormFields(list[i].tabs[t].list, group, curLabel);
          }
        }
        if (list[i].type == "inline") {
          currentNode[i].children = this._getFormFields(list[i].list, group, curLabel);
        }
        if (list[i].type == "table") {
          let curGroup = group ? group + "." + list[i].model : list[i].model;
          currentNode[i].children = this._getFormFields(list[i].tableColumns, curGroup, curLabel);
        }
        if (list[i].type == "subform") {
          let curGroup = group ? group + "." + list[i].model : list[i].model;
          currentNode[i].children = this._getFormFields(list[i].list, curGroup, curLabel);
        }
        if (list[i].type == "dialog") {
          let curGroup = group ? group + "." + list[i].model : list[i].model;
          currentNode[i].children = this._getFormFields(list[i].list, curGroup, curLabel);
        }
        if (list[i].type == "card") {
          currentNode[i].children = this._getFormFields(list[i].list, group, curLabel);
        }
        if (list[i].type == "group") {
          let curGroup = group ? group + "." + list[i].model : list[i].model;
          currentNode[i].children = this._getFormFields(list[i].list, curGroup, curLabel);
        }
      }
      return currentNode;
    },
    getDataSourceArray() {
      return _.cloneDeep(this.dataSourceArray);
    }
  },
  watch: {
    "$i18n.locale": function(val) {
      this._loadComponents();
    },
    codeActiveName(val) {
      this.codeCopyValue = this.codeActiveName == "vue" ? this.vueTemplate : this.htmlTemplate;
    },
    widgetFormSelect(val) {
      var _a2;
      val.key && ((_a2 = this.$refs.outlineRef) == null ? void 0 : _a2.setCurrentKey(val.key, this.isScrollTo));
      this.isScrollTo = true;
      this.modelNode = findModelNodeString(this.widgetForm.list, "key", val.key);
    },
    activeLeft(val) {
      var _a2, _b;
      if (val == "outline") {
        ((_a2 = this.widgetFormSelect) == null ? void 0 : _a2.key) && ((_b = this.$refs.outlineRef) == null ? void 0 : _b.setCurrentKey(this.widgetFormSelect.key, this.isScrollTo));
      }
    }
  }
};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("span", null, [
  /* @__PURE__ */ createTextVNode("\xA0\xA0"),
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-yuanshuju-zujianku" }),
  /* @__PURE__ */ createTextVNode("\xA0\xA0")
], -1);
const _hoisted_2 = { class: "components-list" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = /* @__PURE__ */ createElementVNode("span", null, [
  /* @__PURE__ */ createTextVNode("\xA0\xA0"),
  /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-fuhao-dagangshu" }),
  /* @__PURE__ */ createTextVNode("\xA0\xA0")
], -1);
const _hoisted_10 = { class: "btn-bar-plat" };
const _hoisted_11 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-pc" }, null, -1);
const _hoisted_12 = [
  _hoisted_11
];
const _hoisted_13 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-pad" }, null, -1);
const _hoisted_14 = [
  _hoisted_13
];
const _hoisted_15 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-mobile" }, null, -1);
const _hoisted_16 = [
  _hoisted_15
];
const _hoisted_17 = /* @__PURE__ */ createElementVNode("div", { class: "btn-diviler" }, null, -1);
const _hoisted_18 = { class: "btn-bar-action" };
const _hoisted_19 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-007caozuo_chexiao" }, null, -1);
const _hoisted_20 = [
  _hoisted_19
];
const _hoisted_21 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-8zhongzuo" }, null, -1);
const _hoisted_22 = [
  _hoisted_21
];
const _hoisted_23 = /* @__PURE__ */ createElementVNode("div", { class: "btn-diviler" }, null, -1);
const _hoisted_24 = { class: "btn-bar-action" };
const _hoisted_25 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-quanping_o" }, null, -1);
const _hoisted_26 = [
  _hoisted_25
];
const _hoisted_27 = /* @__PURE__ */ createElementVNode("i", { class: "fm-iconfont icon-quxiaoquanping_o" }, null, -1);
const _hoisted_28 = [
  _hoisted_27
];
const _hoisted_29 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-daoru",
  style: { "font-size": "16px", "font-weight": "600", "margin": "5px" }
}, null, -1);
const _hoisted_30 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-icon_yulan",
  style: { "font-size": "16px", "font-weight": "600", "margin": "5px" }
}, null, -1);
const _hoisted_31 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-qingkong",
  style: { "font-size": "16px", "font-weight": "600", "margin": "5px" }
}, null, -1);
const _hoisted_32 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-json1",
  style: { "font-size": "16px", "font-weight": "600", "margin": "5px" }
}, null, -1);
const _hoisted_33 = /* @__PURE__ */ createElementVNode("i", {
  class: "fm-iconfont icon-daimakuai",
  style: { "font-size": "16px", "font-weight": "600", "margin": "5px" }
}, null, -1);
const _hoisted_34 = /* @__PURE__ */ createElementVNode("a", {
  target: "_blank",
  href: "https://form.making.link"
}, "FormMaking", -1);
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = resolveComponent("el-tooltip");
  const _component_draggable = resolveComponent("draggable");
  const _component_el_collapse_item = resolveComponent("el-collapse-item");
  const _component_el_collapse = resolveComponent("el-collapse");
  const _component_el_scrollbar = resolveComponent("el-scrollbar");
  const _component_el_tab_pane = resolveComponent("el-tab-pane");
  const _component_outline = resolveComponent("outline");
  const _component_el_tabs = resolveComponent("el-tabs");
  const _component_el_aside = resolveComponent("el-aside");
  const _component_el_button = resolveComponent("el-button");
  const _component_el_header = resolveComponent("el-header");
  const _component_widget_form = resolveComponent("widget-form");
  const _component_el_main = resolveComponent("el-main");
  const _component_el_container = resolveComponent("el-container");
  const _component_widget_config = resolveComponent("widget-config");
  const _component_form_config = resolveComponent("form-config");
  const _component_preview_dialog = resolveComponent("preview-dialog");
  const _component_import_json_dialog = resolveComponent("import-json-dialog");
  const _component_code_editor = resolveComponent("code-editor");
  const _component_cus_dialog = resolveComponent("cus-dialog");
  const _component_el_footer = resolveComponent("el-footer");
  return openBlock(), createBlock(_component_el_container, {
    class: normalizeClass(["fm2-container fm-form", {
      ["fm-" + $data.formKey]: true,
      "is-fullscreen": $data.fullscreen
    }]),
    style: normalizeStyle({ "z-index": $props.zIndex })
  }, {
    default: withCtx(() => [
      createVNode(_component_el_main, { class: "fm2-main" }, {
        default: withCtx(() => [
          createVNode(_component_el_container, null, {
            default: withCtx(() => [
              createVNode(_component_el_aside, {
                width: "250px",
                class: "widget-left-panel",
                ref: "widgetLeftPanel"
              }, {
                default: withCtx(() => [
                  withDirectives(createVNode(_component_el_tabs, {
                    modelValue: $data.activeLeft,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $data.activeLeft = $event),
                    class: "left-tabs"
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_tab_pane, { name: "field" }, {
                        label: withCtx(() => [
                          createVNode(_component_el_tooltip, {
                            content: _ctx.$t("fm.actions.components"),
                            placement: "bottom-start"
                          }, {
                            default: withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]),
                        default: withCtx(() => [
                          createVNode(_component_el_scrollbar, null, {
                            default: withCtx(() => [
                              createElementVNode("div", _hoisted_2, [
                                createVNode(_component_el_collapse, {
                                  modelValue: $data.activeFields,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $data.activeFields = $event)
                                }, {
                                  default: withCtx(() => [
                                    $props.layoutFields.length ? (openBlock(), createBlock(_component_el_collapse_item, {
                                      key: 0,
                                      name: "layout",
                                      title: _ctx.$t("fm.components.layout.title")
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_draggable, {
                                          tag: "ul",
                                          list: $data.layoutComponents,
                                          group: { name: "people", pull: "clone", put: false },
                                          sort: false,
                                          "ghost-class": "ghost",
                                          onEnd: $options.handleMoveEnd,
                                          onStart: $options.handleMoveStart,
                                          move: $options.handleMove,
                                          "item-key": "name"
                                        }, {
                                          item: withCtx(({ element }) => [
                                            $props.layoutFields.indexOf(element.type) >= 0 ? (openBlock(), createElementBlock("li", {
                                              key: 0,
                                              onClick: ($event) => $options.handleField(element),
                                              class: "form-edit-widget-label no-put"
                                            }, [
                                              createElementVNode("a", null, [
                                                createElementVNode("i", {
                                                  class: normalizeClass(["icon iconfont fm-iconfont", element.icon])
                                                }, null, 2),
                                                createElementVNode("span", null, toDisplayString$1(element.name), 1)
                                              ])
                                            ], 8, _hoisted_3)) : createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["list", "onEnd", "onStart", "move"])
                                      ]),
                                      _: 1
                                    }, 8, ["title"])) : createCommentVNode("", true),
                                    $props.collectionFields.length ? (openBlock(), createBlock(_component_el_collapse_item, {
                                      key: 1,
                                      name: "collection",
                                      title: _ctx.$t("fm.components.collection.title")
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_draggable, {
                                          tag: "ul",
                                          list: $data.collectionComponents,
                                          group: { name: "people", pull: "clone", put: false },
                                          sort: false,
                                          "ghost-class": "ghost",
                                          onEnd: $options.handleMoveEnd,
                                          onStart: $options.handleMoveStart,
                                          move: $options.handleMove,
                                          "item-key": "name"
                                        }, {
                                          item: withCtx(({ element }) => [
                                            $props.collectionFields.indexOf(element.type) >= 0 ? (openBlock(), createElementBlock("li", {
                                              key: 0,
                                              onClick: ($event) => $options.handleField(element),
                                              class: normalizeClass(["form-edit-widget-label", {
                                                "no-put": true,
                                                "subform-put": element.type == "table" || element.type == "subform",
                                                "dialog-put": element.type == "dialog"
                                              }])
                                            }, [
                                              createElementVNode("a", null, [
                                                createElementVNode("i", {
                                                  class: normalizeClass(["icon iconfont fm-iconfont", element.icon])
                                                }, null, 2),
                                                createElementVNode("span", null, toDisplayString$1(element.name), 1)
                                              ])
                                            ], 10, _hoisted_4)) : createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["list", "onEnd", "onStart", "move"])
                                      ]),
                                      _: 1
                                    }, 8, ["title"])) : createCommentVNode("", true),
                                    $props.basicFields.length ? (openBlock(), createBlock(_component_el_collapse_item, {
                                      key: 2,
                                      name: "basic",
                                      title: _ctx.$t("fm.components.basic.title")
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_draggable, {
                                          tag: "ul",
                                          list: $data.basicComponents,
                                          group: { name: "people", pull: "clone", put: false },
                                          sort: false,
                                          "ghost-class": "ghost",
                                          onEnd: $options.handleMoveEnd,
                                          onStart: $options.handleMoveStart,
                                          move: $options.handleMove,
                                          "item-key": "name"
                                        }, {
                                          item: withCtx(({ element }) => [
                                            $props.basicFields.indexOf(element.type) >= 0 ? (openBlock(), createElementBlock("li", {
                                              key: 0,
                                              onClick: ($event) => $options.handleField(element),
                                              class: normalizeClass(["form-edit-widget-label", { "no-put": element.type == "divider" }])
                                            }, [
                                              createElementVNode("a", null, [
                                                createElementVNode("i", {
                                                  class: normalizeClass(["icon iconfont fm-iconfont", element.icon])
                                                }, null, 2),
                                                createElementVNode("span", null, toDisplayString$1(element.name), 1)
                                              ])
                                            ], 10, _hoisted_5)) : createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["list", "onEnd", "onStart", "move"])
                                      ]),
                                      _: 1
                                    }, 8, ["title"])) : createCommentVNode("", true),
                                    $props.advanceFields.length ? (openBlock(), createBlock(_component_el_collapse_item, {
                                      key: 3,
                                      name: "advance",
                                      title: _ctx.$t("fm.components.advance.title")
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_draggable, {
                                          tag: "ul",
                                          list: $data.advanceComponents,
                                          group: { name: "people", pull: "clone", put: false },
                                          sort: false,
                                          "ghost-class": "ghost",
                                          onEnd: $options.handleMoveEnd,
                                          onStart: $options.handleMoveStart,
                                          move: $options.handleMove,
                                          "item-key": "name"
                                        }, {
                                          item: withCtx(({ element }) => [
                                            $props.advanceFields.indexOf(element.type) >= 0 ? (openBlock(), createElementBlock("li", {
                                              key: 0,
                                              onClick: ($event) => $options.handleField(element),
                                              class: normalizeClass(["form-edit-widget-label", {
                                                "no-put": element.type == "table" || element.type == "subform" || element.type == "dialog" || element.type == "group",
                                                "subform-put": element.type == "table" || element.type == "subform",
                                                "dialog-put": element.type == "dialog"
                                              }])
                                            }, [
                                              createElementVNode("a", null, [
                                                createElementVNode("i", {
                                                  class: normalizeClass(["icon iconfont fm-iconfont", element.icon])
                                                }, null, 2),
                                                createElementVNode("span", null, toDisplayString$1(element.name), 1)
                                              ])
                                            ], 10, _hoisted_6)) : createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 8, ["list", "onEnd", "onStart", "move"])
                                      ]),
                                      _: 1
                                    }, 8, ["title"])) : createCommentVNode("", true),
                                    $props.customFields.length ? (openBlock(), createBlock(_component_el_collapse_item, {
                                      key: 4,
                                      name: "custom",
                                      title: _ctx.$t("fm.components.custom.title")
                                    }, {
                                      default: withCtx(() => [
                                        createVNode(_component_draggable, {
                                          tag: "ul",
                                          list: $data.customComponents,
                                          group: { name: "people", pull: "clone", put: false },
                                          sort: false,
                                          "ghost-class": "ghost",
                                          onEnd: $options.handleMoveEnd,
                                          onStart: $options.handleMoveStart,
                                          move: $options.handleMove,
                                          "item-key": "name"
                                        }, {
                                          item: withCtx(({ element }) => [
                                            createElementVNode("li", {
                                              onClick: ($event) => $options.handleField(element),
                                              class: "form-edit-widget-label"
                                            }, [
                                              createElementVNode("a", null, [
                                                createElementVNode("i", {
                                                  class: normalizeClass(["icon iconfont fm-iconfont custom", element.icon ? "" : "icon-extend"])
                                                }, [
                                                  element.icon ? (openBlock(), createElementBlock("span", {
                                                    key: 0,
                                                    innerHTML: element.icon
                                                  }, null, 8, _hoisted_8)) : createCommentVNode("", true)
                                                ], 2),
                                                createElementVNode("span", null, toDisplayString$1(element.name), 1)
                                              ])
                                            ], 8, _hoisted_7)
                                          ]),
                                          _: 1
                                        }, 8, ["list", "onEnd", "onStart", "move"])
                                      ]),
                                      _: 1
                                    }, 8, ["title"])) : createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      createVNode(_component_el_tab_pane, { name: "outline" }, {
                        label: withCtx(() => [
                          createVNode(_component_el_tooltip, {
                            content: _ctx.$t("fm.actions.outline"),
                            placement: "bottom"
                          }, {
                            default: withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]),
                        default: withCtx(() => [
                          createVNode(_component_outline, {
                            ref: "outlineRef",
                            show: $data.activeLeft == "outline",
                            data: $data.widgetForm.list,
                            onSelect: $options.onSelectWidget
                          }, null, 8, ["show", "data", "onSelect"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]), [
                    [vShow, !$data.leftHide]
                  ]),
                  createElementVNode("div", {
                    class: "container-left-arrow",
                    onClick: _cache[2] || (_cache[2] = (...args) => $options.handleLeftToggle && $options.handleLeftToggle(...args))
                  })
                ]),
                _: 1
              }, 512),
              createVNode(_component_el_container, {
                class: "center-container",
                direction: "vertical"
              }, {
                default: withCtx(() => [
                  createVNode(_component_el_header, {
                    class: "btn-bar",
                    style: { "height": "45px" }
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_10, [
                        createElementVNode("a", {
                          class: normalizeClass({ "active": $data.platform == "pc" }),
                          onClick: _cache[3] || (_cache[3] = ($event) => $options.handlePlatform("pc"))
                        }, _hoisted_12, 2),
                        createElementVNode("a", {
                          class: normalizeClass({ "active": $data.platform == "pad" }),
                          onClick: _cache[4] || (_cache[4] = ($event) => $options.handlePlatform("pad"))
                        }, _hoisted_14, 2),
                        createElementVNode("a", {
                          class: normalizeClass({ "active": $data.platform == "mobile" }),
                          onClick: _cache[5] || (_cache[5] = ($event) => $options.handlePlatform("mobile"))
                        }, _hoisted_16, 2)
                      ]),
                      _hoisted_17,
                      createElementVNode("div", _hoisted_18, [
                        createVNode(_component_el_tooltip, {
                          content: _ctx.$t("fm.actions.undo"),
                          placement: "bottom"
                        }, {
                          default: withCtx(() => [
                            createElementVNode("a", {
                              onClick: _cache[6] || (_cache[6] = (...args) => $options.handleUndo && $options.handleUndo(...args)),
                              class: normalizeClass({ "disabled": !$data.undo })
                            }, _hoisted_20, 2)
                          ]),
                          _: 1
                        }, 8, ["content"]),
                        createVNode(_component_el_tooltip, {
                          content: _ctx.$t("fm.actions.redo"),
                          placement: "bottom"
                        }, {
                          default: withCtx(() => [
                            createElementVNode("a", {
                              onClick: _cache[7] || (_cache[7] = (...args) => $options.handleRedo && $options.handleRedo(...args)),
                              class: normalizeClass({ "disabled": !$data.redo })
                            }, _hoisted_22, 2)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _hoisted_23,
                      createElementVNode("div", _hoisted_24, [
                        !$data.fullscreen ? (openBlock(), createBlock(_component_el_tooltip, {
                          key: 0,
                          content: _ctx.$t("fm.actions.fullScreen"),
                          placement: "bottom"
                        }, {
                          default: withCtx(() => [
                            createElementVNode("a", {
                              onClick: _cache[8] || (_cache[8] = (...args) => $options.handleFullScreen && $options.handleFullScreen(...args))
                            }, _hoisted_26)
                          ]),
                          _: 1
                        }, 8, ["content"])) : (openBlock(), createBlock(_component_el_tooltip, {
                          key: 1,
                          content: _ctx.$t("fm.actions.exitFullScreen"),
                          placement: "bottom"
                        }, {
                          default: withCtx(() => [
                            createElementVNode("a", {
                              onClick: _cache[9] || (_cache[9] = (...args) => $options.handleExitFullScreen && $options.handleExitFullScreen(...args))
                            }, _hoisted_28)
                          ]),
                          _: 1
                        }, 8, ["content"]))
                      ]),
                      renderSlot(_ctx.$slots, "action"),
                      $props.upload ? (openBlock(), createBlock(_component_el_button, {
                        key: 0,
                        link: "",
                        type: "primary",
                        size: "default",
                        onClick: $options.handleUpload
                      }, {
                        default: withCtx(() => [
                          _hoisted_29,
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.import")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])) : createCommentVNode("", true),
                      $props.preview ? (openBlock(), createBlock(_component_el_button, {
                        key: 1,
                        link: "",
                        type: "primary",
                        size: "default",
                        onClick: $options.handlePreview
                      }, {
                        default: withCtx(() => [
                          _hoisted_30,
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.preview")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])) : createCommentVNode("", true),
                      $props.clearable ? (openBlock(), createBlock(_component_el_button, {
                        key: 2,
                        link: "",
                        type: "primary",
                        size: "default",
                        onClick: $options.handleClear
                      }, {
                        default: withCtx(() => [
                          _hoisted_31,
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.clear")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])) : createCommentVNode("", true),
                      $props.generateJson ? (openBlock(), createBlock(_component_el_button, {
                        key: 3,
                        link: "",
                        type: "primary",
                        size: "default",
                        onClick: $options.handleGenerateJson
                      }, {
                        default: withCtx(() => [
                          _hoisted_32,
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.json")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])) : createCommentVNode("", true),
                      $props.generateCode ? (openBlock(), createBlock(_component_el_button, {
                        key: 4,
                        link: "",
                        type: "primary",
                        size: "default",
                        onClick: $options.handleGenerateCode
                      }, {
                        default: withCtx(() => [
                          _hoisted_33,
                          createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.code")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])) : createCommentVNode("", true)
                    ]),
                    _: 3
                  }),
                  createVNode(_component_el_main, {
                    class: normalizeClass({ "widget-empty": $data.widgetForm.list.length == 0 })
                  }, {
                    default: withCtx(() => [
                      !$data.resetJson ? (openBlock(), createBlock(_component_widget_form, {
                        key: 0,
                        ref: "widgetForm",
                        data: $data.widgetForm,
                        select: $data.widgetFormSelect,
                        "onUpdate:select": _cache[10] || (_cache[10] = ($event) => $data.widgetFormSelect = $event),
                        platform: $data.platform,
                        "form-key": $data.formKey
                      }, null, 8, ["data", "select", "platform", "form-key"])) : createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 3
              }),
              createVNode(_component_el_aside, {
                class: "widget-config-container",
                ref: "widgetConfigContainer"
              }, {
                default: withCtx(() => [
                  withDirectives(createVNode(_component_el_container, null, {
                    default: withCtx(() => [
                      createVNode(_component_el_header, { height: "45px" }, {
                        default: withCtx(() => [
                          createElementVNode("div", {
                            class: normalizeClass(["config-tab", { active: $data.configTab == "widget" }]),
                            onClick: _cache[11] || (_cache[11] = ($event) => $options.handleConfigSelect("widget"))
                          }, toDisplayString$1(_ctx.$t("fm.config.widget.title")), 3),
                          createElementVNode("div", {
                            class: normalizeClass(["config-tab", { active: $data.configTab == "form" }]),
                            onClick: _cache[12] || (_cache[12] = ($event) => $options.handleConfigSelect("form"))
                          }, toDisplayString$1(_ctx.$t("fm.config.form.title")), 3)
                        ]),
                        _: 1
                      }),
                      createVNode(_component_el_main, { class: "config-content" }, {
                        default: withCtx(() => [
                          withDirectives((openBlock(), createBlock(_component_widget_config, {
                            ref: "widgetConfig",
                            platform: $data.platform,
                            sheets: $data.styleSheetsArray,
                            datasources: $data.dataSourceArray,
                            eventscripts: $data.eventScriptArray,
                            data: $data.widgetFormSelect,
                            key: $data.widgetFormSelect ? $data.widgetFormSelect.key : 0,
                            onOnEventAdd: $options.handleEventAdd,
                            onOnEventEdit: $options.handleEventEdit,
                            onOnEventRemove: $options.handleEventRemove,
                            "form-key": $data.formKey,
                            "field-models": $props.fieldModels
                          }, {
                            widgetconfig: withCtx(({ type, customProps, data: data2 }) => [
                              renderSlot(_ctx.$slots, "widgetconfig", {
                                type,
                                customProps,
                                data: data2
                              })
                            ]),
                            _: 3
                          }, 8, ["platform", "sheets", "datasources", "eventscripts", "data", "onOnEventAdd", "onOnEventEdit", "onOnEventRemove", "form-key", "field-models"])), [
                            [vShow, $data.configTab == "widget"]
                          ]),
                          withDirectives(createVNode(_component_form_config, {
                            ref: "formConfig",
                            sheets: $data.styleSheetsArray,
                            data: $data.widgetForm.config,
                            onOnStyleUpdate: $options.onStyleUpdate,
                            onOnDatasourceUpdate: $options.onDataSourceUpdate,
                            onOnEventscriptUpdate: $options.onEventScriptUpdate,
                            onOnEventscriptConfirm: $options.onEventScriptConfirm,
                            "form-key": $data.formKey
                          }, null, 8, ["sheets", "data", "onOnStyleUpdate", "onOnDatasourceUpdate", "onOnEventscriptUpdate", "onOnEventscriptConfirm", "form-key"]), [
                            [vShow, $data.configTab == "form"]
                          ])
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  }, 512), [
                    [vShow, !$data.rightHide]
                  ]),
                  createElementVNode("div", {
                    class: "container-right-arrow",
                    onClick: _cache[13] || (_cache[13] = (...args) => $options.handleRightToggle && $options.handleRightToggle(...args))
                  })
                ]),
                _: 3
              }, 512),
              createVNode(_component_preview_dialog, {
                ref: "previewDialog",
                onGetDataSuccess: $options.preivewGetData
              }, null, 8, ["onGetDataSuccess"]),
              createVNode(_component_import_json_dialog, {
                ref: "importJsonDialog",
                onLoadJson: $options.handleLoadJson
              }, null, 8, ["onLoadJson"]),
              createVNode(_component_cus_dialog, {
                visible: $data.jsonVisible,
                onOnClose: _cache[15] || (_cache[15] = ($event) => $data.jsonVisible = false),
                ref: "jsonPreview",
                width: "800px",
                form: "",
                title: $data.jsonTitle
              }, {
                action: withCtx(() => [
                  createVNode(_component_el_button, {
                    type: "primary",
                    class: "json-btn",
                    "data-clipboard-text": $data.jsonCopyValue
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.copyData")), 1)
                    ]),
                    _: 1
                  }, 8, ["data-clipboard-text"]),
                  createVNode(_component_el_button, {
                    type: "primary",
                    onClick: $options.handleExportJSON
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.export")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: withCtx(() => [
                  createVNode(_component_code_editor, {
                    height: "400px",
                    mode: "json",
                    modelValue: $data.jsonTemplate,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => $data.jsonTemplate = $event),
                    wrap: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["visible", "title"]),
              createVNode(_component_cus_dialog, {
                visible: $data.codeVisible,
                onOnClose: _cache[19] || (_cache[19] = ($event) => $data.codeVisible = false),
                ref: "codePreview",
                width: "800px",
                form: "",
                title: _ctx.$t("fm.actions.code")
              }, {
                action: withCtx(() => [
                  createVNode(_component_el_button, {
                    type: "primary",
                    class: "code-btn",
                    "data-clipboard-text": $data.codeCopyValue
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.copyData")), 1)
                    ]),
                    _: 1
                  }, 8, ["data-clipboard-text"]),
                  createVNode(_component_el_button, {
                    type: "primary",
                    onClick: $options.handleExport
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString$1(_ctx.$t("fm.actions.export")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: withCtx(() => [
                  createVNode(_component_el_tabs, {
                    type: "border-card",
                    style: { "box-shadow": "none" },
                    modelValue: $data.codeActiveName,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => $data.codeActiveName = $event)
                  }, {
                    default: withCtx(() => [
                      createVNode(_component_el_tab_pane, {
                        label: "Vue Component",
                        name: "vue"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_code_editor, {
                            height: "450px",
                            mode: "html",
                            modelValue: $data.vueTemplate,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => $data.vueTemplate = $event)
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      createVNode(_component_el_tab_pane, {
                        label: "HTML",
                        name: "html"
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_code_editor, {
                            height: "450px",
                            mode: "html",
                            modelValue: $data.htmlTemplate,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => $data.htmlTemplate = $event)
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["visible", "title"])
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      createVNode(_component_el_footer, {
        height: "30px",
        style: { "font-weight": "600" }
      }, {
        default: withCtx(() => [
          createTextVNode("Powered by "),
          _hoisted_34,
          createTextVNode(" " + toDisplayString$1($data.version ? ` - V${$data.version}` : ""), 1)
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["class", "style"]);
}
var MakingForm = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
var enUS = {
  fm: {
    components: {
      fields: {
        input: "Input",
        textarea: "Textarea",
        number: "Number",
        radio: "Radio",
        checkbox: "Checkbox",
        time: "Time",
        date: "Date",
        rate: "Rate",
        color: "Color",
        select: "Select",
        switch: "Switch",
        slider: "Slider",
        text: "Text",
        blank: "Custom",
        fileupload: "File",
        imgupload: "Image",
        editor: "Editor",
        cascader: "Cascader",
        table: "Sub-Form",
        grid: "Grid",
        tabs: "Tabs",
        divider: "Divider",
        html: "HTML",
        component: "Component",
        report: "Table",
        button: "Button",
        link: "Link",
        inline: "Inline",
        steps: "Steps",
        transfer: "Transfer",
        treeselect: "TreeSelect",
        alert: "Alert",
        subform: "Sub-Form +",
        custom: "Custom",
        col: "Col",
        td: "TD",
        collapse: "Collapse",
        pagination: "Pagination",
        dialog: "Dialog",
        card: "Card",
        group: "Group",
        th: "TH"
      },
      basic: {
        title: "Basic Field"
      },
      advance: {
        title: "Advance Field"
      },
      layout: {
        title: "Layout"
      },
      custom: {
        title: "Custom Field"
      },
      collection: {
        title: "Collection"
      }
    },
    description: {
      containerEmpty: "You can drag and drop or click the item from the left  to add widgets",
      configEmpty: "Please add a field",
      tableEmpty: "Drag the field here",
      uploadJsonInfo: "There is the format of JSON below, you can overwrite it with you own JSON code",
      deleteConfirm: "Are you sure to delete this?",
      qrcodePreview: "Preview QR code"
    },
    message: {
      copySuccess: "Copy Successed",
      validError: "Form data validation failed",
      noPut: "Don't support adding this field",
      errorTip: "Custom error tips",
      notSupport: "Not supported by current browser"
    },
    actions: {
      import: "Import",
      clear: "Clear",
      preview: "Preview",
      json: "JSON",
      code: "Code",
      getData: "Get data",
      reset: "Reset",
      copyData: "Copy",
      cancel: "Cancel",
      confirm: "Confirm",
      addOption: "Add option",
      addColumn: "Add column",
      addTab: "Add tab",
      addCollapse: "Add collapse",
      upload: "Upload",
      add: "Add",
      undo: "Undo",
      redo: "Redo",
      enabledEdit: "Enabled edit",
      disabledEdit: "Disabled edit",
      clearSelect: "Reset selection",
      close: "Close",
      export: "Export",
      print: "Print",
      printReadMode: "Print read mode",
      editMode: "edit mode",
      components: "Component library",
      outline: "Outline tree",
      importFile: "Import file",
      fullScreen: "Full Screen",
      exitFullScreen: "Exit Full Screen",
      exportPDF: "Export PDF",
      pdfPreview: "PDF Preview"
    },
    config: {
      form: {
        title: "Form Attribute",
        labelPosition: {
          title: "Label Position",
          left: "Left",
          right: "Right",
          top: "Top"
        },
        labelWidth: "Label Width",
        size: "Size",
        customClass: "Custom Class",
        width: "Form Width",
        styleSheets: "Style Sheets",
        labelSuffix: "Label Suffix"
      },
      widget: {
        widgetType: "Type",
        title: "Component Attribute",
        model: "ID",
        name: "Name",
        width: "Width",
        height: "Height",
        size: "Size",
        labelWidth: "Label Width",
        labelWrap: "Label Wrap",
        custom: "Custom",
        placeholder: "Placeholder",
        layout: "Layout",
        block: "Block",
        inline: "Inline",
        contentPosition: "Content Position",
        center: "Center",
        showInput: "Display Input Box",
        min: "Minimum",
        max: "Maximum",
        step: "Step",
        precision: "Precision",
        controls: "Enable the control buttons",
        controlsPosition: "Position of the control buttons",
        multiple: "Multiple",
        filterable: "Searchable",
        allowHalf: "Allow Half",
        showAlpha: "Support transparency options",
        showLabel: "Show lable",
        option: "Option",
        staticData: "Static Data",
        remoteData: "Dynamic Data",
        remoteFunc: "Function",
        remoteAssigned: "Assigned Variable",
        value: "Value",
        label: "Label",
        childrenOption: "Children",
        defaultValue: "Default Value",
        showType: "Display type",
        isRange: "Range Time",
        isTimestamp: "Get time stamp",
        startPlaceholder: "Placeholder of start time",
        endPlaceholder: "Placeholder of end time",
        format: "Format",
        limit: "Maximum Upload Count",
        isQiniu: "Upload with Qiniu Cloud",
        tokenFunc: "Get QiNiu token",
        imageAction: "Picture upload address",
        tip: "Text Prompt",
        action: "Request URL",
        headers: "Request headers",
        defaultType: "Data Type",
        string: "String",
        object: "Object",
        array: "Array",
        number: "Number",
        boolean: "Boolean",
        integer: "Integer",
        float: "Float",
        url: "URL",
        email: "E-mail",
        hex: "Hexadecimal",
        gutter: "Grid Spacing",
        columnOption: "Column Configuration",
        flex: "Flex Layout",
        responsive: "Responsive Layout",
        span: "Grid spans",
        responsiveSpan: "Responsive columns",
        offset: "Offset",
        push: "Push",
        pull: "Pull",
        justify: "Horizontal Arrangement",
        justifyStart: "Start",
        justifyEnd: "End",
        justifyCenter: "Center",
        justifySpaceAround: "Space Around",
        justifySpaceBetween: "Space Between",
        align: "Vertical Arrangement",
        alignTop: "Top",
        alignMiddle: "Middle",
        alignBottom: "Bottom",
        type: "Type",
        default: "Default",
        card: "Tabs",
        borderCard: "Border-Card",
        tabPosition: "Tab Position",
        top: "Top",
        left: "Left",
        right: "Right",
        bottom: "Bottom",
        tabOption: "Tab Options",
        tabName: "Tab Name",
        collapseOptions: "Collapse Options",
        collapseTitle: "Title",
        accordion: "Accordion Mode",
        customClass: "Custom Class",
        attribute: "Attribute Action",
        dataBind: "Data Binding",
        hidden: "Hidden",
        readonly: "Read Only",
        disabled: "Disabled",
        editable: "Text box is editable",
        clearable: "Show Clear Button",
        arrowControl: "Use the arrow for time selection",
        isDelete: "Deletable",
        isEdit: "Editable",
        isAdd: "Addible",
        showPassword: "Show Password",
        showScore: "Show Score",
        validate: "Validation",
        required: "Required",
        patternPlaceholder: "Fill in the regular expressions",
        newOption: "New Option",
        tab: "Tab",
        collapse: "Collapse",
        validatorRequired: " required",
        validatorType: " invaild format",
        validatorPattern: " unmatched pattern",
        customTemplates: "Custom templates",
        setting: "Setting",
        hideLabel: "Hide Label",
        borderWidth: "Border Width",
        borderColor: "Border Color",
        buttonName: "Button Name",
        buttonSize: "Button Size",
        buttonType: "Button Type",
        buttonPlain: "Determine whether it's a plain button",
        buttonRound: "Determine whether it's a round button",
        buttonCircle: "Determine whether it's a circle button",
        linkType: "Link Type",
        linkName: "Link Name",
        underline: "whether the component has underline",
        isBlank: "Whether to open in a new window",
        withCredentials: "Using credentials",
        customValidation: "Custom validation rules",
        paging: "Paging",
        pageSize: "Page size",
        checkStrictly: "Optional any node",
        extendPropsConfig: "Extended property configuration",
        steps: "Step options",
        space: "Spacing fo each step",
        direction: "Display direction",
        processStatus: "Status of current step",
        finishStatus: "Status of end step",
        alignCenter: "Center title and description",
        simple: "Simple theme",
        titles: "Titles",
        otitle: "Title",
        description: "Description",
        effect: "Effect",
        closable: "Closable",
        showIcon: "Show icon",
        spaceSize: "Space size",
        showControl: "Show Control",
        pagerCount: "Pager Count",
        total: "Total",
        background: "Background",
        fixedColumn: "Fixed column",
        fixedColumnSelect: "Select fixed position.",
        showDialog: "Visible",
        showClose: "Show Close",
        showCancel: "Show Cancel button",
        cancelText: "Button text",
        showOk: "show Confirm button",
        okText: "Button text",
        confirmLoading: "loading",
        marginTop: "Magin Top",
        maxlength: "Max length",
        showWordLimit: "Show word count",
        rows: "Rows",
        autosize: "Autosize",
        padding: "Padding",
        showHeader: "Show Header",
        bordered: "Bordered",
        shadow: "Shadow",
        virtualTable: "Virtual Table"
      }
    },
    upload: {
      preview: "preview",
      edit: "replace",
      delete: "delete"
    },
    tooltip: {
      trash: "trash",
      clone: "clone",
      addrow: "add row",
      addcolumn: "add column",
      mergedown: "merge down",
      mergeright: "merge right",
      deleterow: "delete current row",
      deletecolumn: "delete current column",
      cellsetting: "cell setting",
      insertcolumnleft: "insert column left",
      insertcolumnright: "insert column right",
      insertrowbefore: "insert row before",
      insertrowafter: "insert row after",
      splitcolumns: "split into columns",
      splitrows: "split into rows",
      setcolwidth: "set column width",
      copy: "Copy"
    },
    datasource: {
      name: "Data Source",
      config: {
        title: "Data source settings",
        add: "Add data source",
        save: "Save",
        cancel: "Cancel",
        test: "Request Test"
      },
      edit: {
        name: "Name",
        url: "Url",
        method: "Method",
        headers: "Headers",
        params: "Params",
        auto: "Whether the form is initialized to send the request",
        response: "Data processing",
        annotation: "The response data res is returned directly by default, and the data can be processed below",
        add: "Add",
        willRequest: "Before sending the request:",
        responseSuccess: "When requesting response data:",
        requestError: "When an error occurs in the request:"
      },
      message: {
        repeat: "Data source name cannot be repeated",
        settingError: "Data source setting error",
        saveSuccess: "Saved successfully",
        saveError: "There is unsaved data, please save it first",
        confirmRemove: "Are you sure you want to delete the data source"
      }
    },
    eventscript: {
      name: "Action Panel",
      config: {
        title: "Action Settings",
        name: "Function Name",
        add: "Add action",
        save: "Save",
        confirm: "OK",
        cancel: "Cancel",
        create: "New action",
        code: "Edit code",
        rules: "Visual configuration",
        js: "JS",
        notSave: "Discard Changes"
      },
      message: {
        repeat: "Function name cannot be repeated",
        saveSuccess: "Save successfully",
        saveError: "There are unsaved data, please save first",
        confirmRemove: "Are you sure you want to delete this Function",
        saveConfirm: "You have unsaved changes, save and proceed?"
      }
    },
    importjson: {
      name: "Template Library",
      noimage: "No preview image ",
      loadjson: "Load Template",
      nojson: "No Template"
    },
    rules: {
      actions: {
        add: "Add",
        hide: "Hide form fields",
        display: "Display form fields",
        disabled: "Set form fields to enable/disable",
        refresh: "Reload form",
        reset: "Reset form data",
        setData: "Set form data",
        validate: "Validate form fields",
        sendRequest: "Send Request",
        refreshFieldDataSource: "Refresh request data",
        getFieldDataSource: "Get field data source data",
        openDialog: "Open Dialog",
        closeDialog: "Close Dialog",
        triggerEvent: "Call action method",
        js: "JS"
      },
      message: {
        confirmDelete: "Are you sure you want to delete this action?",
        editFx: "Click to edit expression",
        condition: "Execute conditional expression"
      },
      label: {
        field: "Target field",
        disabled: "Diabled",
        enabled: "Enabled",
        values: "Data settings",
        string: "String",
        number: "Number",
        boolean: "Boolean",
        fx: "Expression",
        condition: "Condition",
        datasource: "Data source",
        datasourceArgs: "Parameters",
        responseVariable: "Request result",
        localVariable: "Result",
        validateFail: "Validate failed",
        validateFailContinue: "Continue executing action",
        validateFailSuspend: "Interrupt execution action",
        functionName: "Function",
        functionParams: "Parameters"
      }
    },
    formula: {
      header: "Expression =",
      field: "Form fields",
      event: "Variable",
      argsData: {
        name: "Event parameters",
        field: "field",
        value: "value",
        variable: "Internal variables"
      },
      input: {
        value: "static",
        fx: "fx",
        fxPlaceholder: "Click to edit expression",
        valuePlaceholder: "Please enter"
      }
    }
  }
};
var zhCN = {
  fm: {
    components: {
      fields: {
        input: "\u5355\u884C\u6587\u672C",
        textarea: "\u591A\u884C\u6587\u672C",
        number: "\u8BA1\u6570\u5668",
        radio: "\u5355\u9009\u6846\u7EC4",
        checkbox: "\u591A\u9009\u6846\u7EC4",
        time: "\u65F6\u95F4\u9009\u62E9\u5668",
        date: "\u65E5\u671F\u9009\u62E9\u5668",
        rate: "\u8BC4\u5206",
        color: "\u989C\u8272\u9009\u62E9\u5668",
        select: "\u4E0B\u62C9\u9009\u62E9\u6846",
        switch: "\u5F00\u5173",
        slider: "\u6ED1\u5757",
        text: "\u6587\u5B57",
        blank: "\u81EA\u5B9A\u4E49\u533A\u57DF",
        fileupload: "\u6587\u4EF6",
        imgupload: "\u56FE\u7247",
        editor: "\u7F16\u8F91\u5668",
        cascader: "\u7EA7\u8054\u9009\u62E9\u5668",
        table: "\u5B50\u8868\u5355",
        grid: "\u6805\u683C\u5E03\u5C40",
        tabs: "\u6807\u7B7E\u9875",
        divider: "\u5206\u5272\u7EBF",
        html: "HTML",
        component: "\u81EA\u5B9A\u4E49\u7EC4\u4EF6",
        report: "\u8868\u683C\u5E03\u5C40",
        button: "\u6309\u94AE",
        link: "\u6587\u5B57\u94FE\u63A5",
        inline: "\u884C\u5185\u5E03\u5C40",
        steps: "\u6B65\u9AA4\u6761",
        transfer: "\u7A7F\u68AD\u6846",
        treeselect: "\u6811\u9009\u62E9",
        alert: "\u63D0\u793A",
        subform: "\u5B50\u8868\u5355+",
        custom: "\u81EA\u5B9A\u4E49",
        col: "\u6805\u683C\u5217",
        td: "\u5355\u5143\u683C",
        collapse: "\u6298\u53E0\u9762\u677F",
        pagination: "\u5206\u9875",
        dialog: "\u5BF9\u8BDD\u6846",
        card: "\u5361\u7247",
        group: "\u5206\u7EC4",
        th: "\u8868\u5934"
      },
      basic: {
        title: "\u57FA\u7840\u5B57\u6BB5"
      },
      advance: {
        title: "\u9AD8\u7EA7\u5B57\u6BB5"
      },
      layout: {
        title: "\u5E03\u5C40\u5B57\u6BB5"
      },
      custom: {
        title: "\u81EA\u5B9A\u4E49\u5B57\u6BB5"
      },
      collection: {
        title: "\u5BB9\u5668\u5B57\u6BB5"
      }
    },
    description: {
      containerEmpty: "\u4ECE\u5DE6\u4FA7\u62D6\u62FD\u6216\u70B9\u51FB\u6765\u6DFB\u52A0\u5B57\u6BB5",
      configEmpty: "\u8BF7\u6DFB\u52A0\u5B57\u6BB5",
      tableEmpty: "\u5C06\u5B57\u6BB5\u62D6\u62FD\u5230\u6B64\u5904",
      uploadJsonInfo: "JSON\u683C\u5F0F\u5982\u4E0B\uFF0C\u76F4\u63A5\u590D\u5236\u751F\u6210\u7684json\u8986\u76D6\u6B64\u5904\u4EE3\u7801\u70B9\u51FB\u786E\u5B9A\u5373\u53EF",
      deleteConfirm: "\u4F60\u786E\u5B9A\u5220\u9664\u8BE5\u884C\u6570\u636E\u5417\uFF1F",
      qrcodePreview: "\u624B\u673A\u9884\u89C8\u4E8C\u7EF4\u7801"
    },
    message: {
      copySuccess: "\u590D\u5236\u6210\u529F",
      validError: "\u8868\u5355\u6570\u636E\u6821\u9A8C\u5931\u8D25",
      noPut: "\u4E0D\u652F\u6301\u6DFB\u52A0\u6B64\u5B57\u6BB5",
      errorTip: "\u81EA\u5B9A\u4E49\u9519\u8BEF\u63D0\u793A",
      notSupport: "\u5F53\u524D\u6D4F\u89C8\u5668\u4E0D\u652F\u6301"
    },
    actions: {
      import: "\u5BFC\u5165\u6A21\u677F",
      clear: "\u6E05\u7A7A",
      preview: "\u9884\u89C8",
      json: "\u751F\u6210JSON",
      code: "\u751F\u6210\u4EE3\u7801",
      getData: "\u83B7\u53D6\u6570\u636E",
      reset: "\u91CD\u7F6E",
      copyData: "\u590D\u5236",
      cancel: "\u53D6 \u6D88",
      confirm: "\u786E \u5B9A",
      addOption: "\u6DFB\u52A0\u9009\u9879",
      addColumn: "\u6DFB\u52A0\u5217",
      addTab: "\u6DFB\u52A0\u6807\u7B7E",
      addCollapse: "\u6DFB\u52A0\u9762\u677F",
      upload: "\u70B9\u51FB\u4E0A\u4F20",
      add: "\u6DFB\u52A0",
      undo: "\u64A4\u9500",
      redo: "\u91CD\u505A",
      enabledEdit: "\u542F\u7528\u7F16\u8F91",
      disabledEdit: "\u7981\u7528\u7F16\u8F91",
      clearSelect: "\u91CD\u7F6E\u9009\u62E9",
      close: "\u5173\u95ED",
      export: "\u5BFC\u51FA",
      print: "\u6253\u5370",
      printReadMode: "\u6253\u5370\u9605\u8BFB\u6A21\u5F0F",
      editMode: "\u7F16\u8F91\u6A21\u5F0F",
      components: "\u7EC4\u4EF6\u5E93",
      outline: "\u5927\u7EB2\u6811",
      importFile: "\u5BFC\u5165\u6587\u4EF6",
      fullScreen: "\u5168\u5C4F",
      exitFullScreen: "\u9000\u51FA\u5168\u5C4F",
      exportPDF: "\u5BFC\u51FA PDF",
      pdfPreview: "PDF \u9884\u89C8"
    },
    config: {
      form: {
        title: "\u8868\u5355\u5C5E\u6027",
        labelPosition: {
          title: "\u6807\u7B7E\u5BF9\u9F50\u65B9\u5F0F",
          left: "\u5DE6\u5BF9\u9F50",
          right: "\u53F3\u5BF9\u9F50",
          top: "\u9876\u90E8\u5BF9\u9F50"
        },
        labelWidth: "\u8868\u5355\u6807\u7B7E\u5BBD\u5EA6",
        size: "\u7EC4\u4EF6\u5C3A\u5BF8",
        customClass: "\u81EA\u5B9A\u4E49Class",
        width: "\u8868\u5355\u5BBD\u5EA6",
        styleSheets: "\u8868\u5355\u6837\u5F0F\u8868",
        labelSuffix: "\u8868\u5355\u6807\u7B7E\u540E\u7F00"
      },
      widget: {
        widgetType: "\u7C7B\u578B",
        title: "\u5B57\u6BB5\u5C5E\u6027",
        model: "\u5B57\u6BB5\u6807\u8BC6",
        name: "\u6807\u9898",
        width: "\u5BBD\u5EA6",
        height: "\u9AD8\u5EA6",
        size: "\u5927\u5C0F",
        labelWidth: "\u6807\u7B7E\u5BBD\u5EA6",
        labelWrap: "\u6807\u7B7E\u6362\u884C",
        custom: "\u81EA\u5B9A\u4E49",
        placeholder: "\u5360\u4F4D\u5185\u5BB9",
        layout: "\u5E03\u5C40\u65B9\u5F0F",
        block: "\u5757\u7EA7",
        inline: "\u884C\u5185",
        contentPosition: "\u6587\u6848\u4F4D\u7F6E",
        center: "\u5C45\u4E2D",
        showInput: "\u663E\u793A\u8F93\u5165\u6846",
        min: "\u6700\u5C0F\u503C",
        max: "\u6700\u5927\u503C",
        step: "\u6B65\u957F",
        precision: "\u7CBE\u5EA6",
        controls: "\u662F\u5426\u4F7F\u7528\u63A7\u5236\u6309\u94AE",
        controlsPosition: "\u63A7\u5236\u6309\u94AE\u4F4D\u7F6E	",
        multiple: "\u662F\u5426\u591A\u9009",
        filterable: "\u662F\u5426\u53EF\u641C\u7D22",
        allowHalf: "\u5141\u8BB8\u534A\u9009",
        showAlpha: "\u652F\u6301\u900F\u660E\u5EA6\u9009\u62E9",
        showLabel: "\u662F\u5426\u663E\u793A\u6807\u7B7E",
        option: "\u9009\u9879",
        staticData: "\u9759\u6001\u6570\u636E",
        remoteData: "\u52A8\u6001\u6570\u636E",
        remoteFunc: "\u65B9\u6CD5\u51FD\u6570",
        remoteAssigned: "\u8D4B\u503C\u53D8\u91CF",
        value: "\u503C",
        label: "\u6807\u7B7E",
        childrenOption: "\u5B50\u9009\u9879",
        defaultValue: "\u9ED8\u8BA4\u503C",
        showType: "\u663E\u793A\u7C7B\u578B",
        isRange: "\u662F\u5426\u4E3A\u8303\u56F4\u9009\u62E9",
        isTimestamp: "\u662F\u5426\u83B7\u53D6\u65F6\u95F4\u6233",
        startPlaceholder: "\u5F00\u59CB\u65F6\u95F4\u5360\u4F4D\u5185\u5BB9",
        endPlaceholder: "\u7ED3\u675F\u65F6\u95F4\u5360\u4F4D\u5185\u5BB9",
        format: "\u683C\u5F0F",
        limit: "\u6700\u5927\u4E0A\u4F20\u6570",
        isQiniu: "\u4F7F\u7528\u4E03\u725B\u4E0A\u4F20",
        tokenFunc: "\u83B7\u53D6\u4E03\u725BToken",
        imageAction: "\u56FE\u7247\u4E0A\u4F20\u5730\u5740",
        tip: "\u63D0\u793A\u8BF4\u660E\u6587\u5B57",
        action: "\u4E0A\u4F20\u5730\u5740",
        headers: "\u8BBE\u7F6E\u4E0A\u4F20\u7684\u8BF7\u6C42\u5934\u90E8",
        defaultType: "\u7ED1\u5B9A\u6570\u636E\u7C7B\u578B",
        string: "\u5B57\u7B26\u4E32",
        object: "\u5BF9\u8C61",
        array: "\u6570\u7EC4",
        number: "\u6570\u5B57",
        boolean: "\u5E03\u5C14\u503C",
        integer: "\u6574\u6570",
        float: "\u6D6E\u70B9\u6570",
        url: "URL\u5730\u5740",
        email: "\u90AE\u7BB1\u5730\u5740",
        hex: "\u5341\u516D\u8FDB\u5236",
        flex: "Flex\u5E03\u5C40",
        responsive: "\u54CD\u5E94\u5F0F\u5E03\u5C40",
        gutter: "\u6805\u683C\u95F4\u9694",
        columnOption: "\u5217\u914D\u7F6E\u9879",
        span: "\u6805\u683C\u5360\u636E\u7684\u5217\u6570",
        responsiveSpan: "\u54CD\u5E94\u5F0F\u6805\u683C\u6570",
        offset: "\u6805\u683C\u5DE6\u4FA7\u7684\u95F4\u9694\u683C\u6570",
        push: "\u6805\u683C\u5411\u53F3\u79FB\u52A8\u683C\u6570",
        pull: "\u6805\u683C\u5411\u5DE6\u79FB\u52A8\u683C\u6570",
        justify: "\u6C34\u5E73\u6392\u5217\u65B9\u5F0F",
        justifyStart: "\u5DE6\u5BF9\u9F50",
        justifyEnd: "\u53F3\u5BF9\u9F50",
        justifyCenter: "\u5C45\u4E2D",
        justifySpaceAround: "\u4E24\u4FA7\u95F4\u9694\u76F8\u7B49",
        justifySpaceBetween: "\u4E24\u7AEF\u5BF9\u9F50",
        align: "\u5782\u76F4\u6392\u5217\u65B9\u5F0F",
        alignTop: "\u9876\u90E8\u5BF9\u9F50",
        alignMiddle: "\u5C45\u4E2D",
        alignBottom: "\u5E95\u90E8\u5BF9\u9F50",
        type: "\u98CE\u683C\u7C7B\u578B",
        default: "\u9ED8\u8BA4",
        card: "\u9009\u9879\u5361",
        borderCard: "\u5361\u7247\u5316",
        tabPosition: "\u9009\u9879\u5361\u4F4D\u7F6E",
        top: "\u9876\u90E8",
        left: "\u5DE6\u4FA7",
        right: "\u53F3\u4FA7",
        bottom: "\u5E95\u90E8",
        tabOption: "\u6807\u7B7E\u914D\u7F6E\u9879",
        tabName: "\u6807\u7B7E\u540D\u79F0",
        collapseOptions: "\u9762\u677F\u9009\u9879",
        collapseTitle: "\u9762\u677F\u6807\u9898",
        accordion: "\u624B\u98CE\u7434\u6A21\u5F0F",
        customClass: "\u81EA\u5B9A\u4E49Class",
        attribute: "\u64CD\u4F5C\u5C5E\u6027",
        dataBind: "\u6570\u636E\u7ED1\u5B9A",
        hidden: "\u9690\u85CF",
        readonly: "\u5B8C\u5168\u53EA\u8BFB",
        disabled: "\u7981\u7528",
        editable: "\u6587\u672C\u6846\u53EF\u8F93\u5165",
        clearable: "\u663E\u793A\u6E05\u9664\u6309\u94AE",
        arrowControl: "\u4F7F\u7528\u7BAD\u5934\u8FDB\u884C\u65F6\u95F4\u9009\u62E9",
        isDelete: "\u53EF\u5220\u9664",
        isEdit: "\u53EF\u7F16\u8F91",
        isAdd: "\u53EF\u6DFB\u52A0",
        showPassword: "\u663E\u793A\u5BC6\u7801",
        showScore: "\u663E\u793A\u5206\u6570",
        validate: "\u6821\u9A8C",
        required: "\u5FC5\u586B",
        patternPlaceholder: "\u586B\u5199\u6B63\u5219\u8868\u8FBE\u5F0F",
        newOption: "\u65B0\u9009\u9879",
        tab: "\u6807\u7B7E\u9875",
        collapse: "\u6298\u53E0\u9762\u677F",
        validatorRequired: "\u5FC5\u987B\u586B\u5199",
        validatorType: "\u683C\u5F0F\u4E0D\u6B63\u786E",
        validatorPattern: "\u683C\u5F0F\u4E0D\u5339\u914D",
        customTemplates: "\u81EA\u5B9A\u4E49\u6A21\u677F",
        setting: "\u8BBE\u7F6E",
        hideLabel: "\u9690\u85CF\u6807\u7B7E",
        borderWidth: "\u8868\u683C\u8FB9\u6846\u5BBD\u5EA6",
        borderColor: "\u8868\u683C\u8FB9\u6846\u989C\u8272",
        buttonName: "\u6309\u94AE\u540D\u79F0",
        buttonSize: "\u5C3A\u5BF8",
        buttonType: "\u6309\u94AE\u7C7B\u578B",
        buttonPlain: "\u662F\u5426\u6734\u7D20\u6309\u94AE",
        buttonRound: "\u662F\u5426\u5706\u89D2\u6309\u94AE",
        buttonCircle: "\u662F\u5426\u5706\u5F62\u6309\u94AE",
        linkType: "\u94FE\u63A5\u7C7B\u578B",
        linkName: "\u94FE\u63A5\u540D\u79F0",
        underline: "\u662F\u5426\u4E0B\u5212\u7EBF",
        isBlank: "\u662F\u5426\u5728\u65B0\u7A97\u53E3\u4E2D\u6253\u5F00",
        withCredentials: "\u8DE8\u57DF\u8BF7\u6C42\u662F\u5426\u63D0\u4F9B\u51ED\u636E\u4FE1\u606F",
        customValidation: "\u81EA\u5B9A\u4E49\u6821\u9A8C\u89C4\u5219",
        paging: "\u662F\u5426\u5206\u9875",
        pageSize: "\u6BCF\u9875\u663E\u793A\u6570\u76EE",
        checkStrictly: "\u53EF\u9009\u4EFB\u610F\u8282\u70B9",
        extendPropsConfig: "\u6269\u5C55\u5C5E\u6027\u914D\u7F6E",
        space: "Step\u95F4\u8DDD",
        direction: "\u663E\u793A\u65B9\u5411",
        processStatus: "\u5F53\u524D\u6B65\u9AA4\u7684\u72B6\u6001",
        finishStatus: "\u7ED3\u675F\u6B65\u9AA4\u72B6\u6001",
        alignCenter: "\u5C45\u4E2D\u5BF9\u9F50",
        simple: "\u7B80\u6D01\u98CE\u683C",
        titles: "\u5217\u8868\u6807\u9898",
        otitle: "\u6807\u9898",
        description: "\u63CF\u8FF0",
        effect: "\u4E3B\u9898\u6837\u5F0F",
        closable: "\u53EF\u5173\u95ED",
        showIcon: "\u663E\u793A\u7C7B\u578B\u56FE\u7247",
        spaceSize: "\u95F4\u9694\u5927\u5C0F",
        showControl: "\u5C55\u793A\u63A7\u5236\u6309\u94AE",
        pagerCount: "\u9875\u7801\u6309\u94AE\u6570\u91CF",
        total: "\u603B\u6761\u76EE\u6570",
        background: "\u6309\u94AE\u80CC\u666F\u8272",
        fixedColumn: "\u56FA\u5B9A\u5217",
        fixedColumnSelect: "\u9009\u62E9\u56FA\u5B9A\u4F4D\u7F6E",
        showDialog: "\u663E\u793A\u5BF9\u8BDD\u6846",
        showClose: "\u663E\u793A\u5173\u95ED\u6309\u94AE",
        showCancel: "\u663E\u793A\u53D6\u6D88\u6309\u94AE",
        cancelText: "\u53D6\u6D88\u6309\u94AE\u6587\u5B57",
        showOk: "\u663E\u793A\u786E\u8BA4\u6309\u94AE",
        okText: "\u786E\u8BA4\u6309\u94AE\u6587\u5B57",
        confirmLoading: "loading",
        marginTop: "\u9876\u90E8\u8DDD\u79BB",
        maxlength: "\u6700\u5927\u8F93\u5165\u957F\u5EA6",
        showWordLimit: "\u663E\u793A\u8F93\u5165\u5B57\u6570\u7EDF\u8BA1",
        rows: "\u8F93\u5165\u6846\u884C\u6570",
        autosize: "\u9AD8\u5EA6\u81EA\u9002\u5E94",
        padding: "\u5185\u8FB9\u8DDD",
        showHeader: "\u663E\u793A\u6807\u9898\u533A\u57DF",
        bordered: "\u662F\u5426\u6709\u8FB9\u6846",
        shadow: "\u9634\u5F71\u663E\u793A",
        virtualTable: "\u865A\u62DF\u8868\u683C"
      }
    },
    upload: {
      preview: "\u9884\u89C8",
      edit: "\u66FF\u6362",
      delete: "\u5220\u9664"
    },
    tooltip: {
      trash: "\u5220\u9664",
      clone: "\u514B\u9686",
      addrow: "\u63D2\u5165\u884C",
      addcolumn: "\u63D2\u5165\u5217",
      mergedown: "\u5411\u4E0B\u5408\u5E76",
      mergeright: "\u5411\u53F3\u5408\u5E76",
      deleterow: "\u5220\u9664\u5F53\u524D\u884C",
      deletecolumn: "\u5220\u9664\u5F53\u524D\u5217",
      cellsetting: "\u8868\u683C\u8BBE\u7F6E",
      insertcolumnleft: "\u5DE6\u63D2\u5165\u5217",
      insertcolumnright: "\u53F3\u63D2\u5165\u5217",
      insertrowbefore: "\u4E0A\u63D2\u5165\u884C",
      insertrowafter: "\u4E0B\u63D2\u5165\u884C",
      splitcolumns: "\u62C6\u5206\u6210\u5217",
      splitrows: "\u62C6\u5206\u6210\u884C",
      setcolwidth: "\u8BBE\u7F6E\u5217\u5BBD",
      copy: "\u590D\u5236"
    },
    datasource: {
      name: "\u6570\u636E\u6E90",
      config: {
        title: "\u6570\u636E\u6E90\u8BBE\u7F6E",
        add: "\u6DFB\u52A0\u6570\u636E\u6E90",
        save: "\u4FDD\u5B58",
        cancel: "\u53D6\u6D88",
        test: "\u8BF7\u6C42\u6D4B\u8BD5"
      },
      edit: {
        name: "\u540D\u79F0",
        url: "\u8BF7\u6C42\u5730\u5740",
        method: "\u8BF7\u6C42\u65B9\u6CD5",
        headers: "\u8BF7\u6C42\u5934\u90E8",
        params: "\u8BF7\u6C42\u53C2\u6570",
        auto: "\u662F\u5426\u8868\u5355\u521D\u59CB\u5316\u53D1\u9001\u8BF7\u6C42",
        response: "\u6570\u636E\u5904\u7406",
        annotation: "\u9ED8\u8BA4\u76F4\u63A5\u8FD4\u56DE\u54CD\u5E94\u6570\u636E res\uFF0C\u53EF\u4EE5\u5728\u4E0B\u65B9\u5BF9\u6570\u636E\u8FDB\u884C\u5904\u7406",
        add: "\u6DFB\u52A0",
        willRequest: "\u8BF7\u6C42\u53D1\u9001\u524D\uFF1A",
        responseSuccess: "\u8BF7\u6C42\u8FD4\u56DE\u54CD\u5E94\u6570\u636E\u65F6\uFF1A",
        requestError: "\u8BF7\u6C42\u53D1\u751F\u9519\u8BEF\u65F6\uFF1A"
      },
      message: {
        repeat: "\u6570\u636E\u6E90\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
        settingError: "\u6570\u636E\u6E90\u8BBE\u7F6E\u9519\u8BEF",
        saveSuccess: "\u4FDD\u5B58\u6210\u529F",
        saveError: "\u5B58\u5728\u672A\u4FDD\u5B58\u7684\u6570\u636E\uFF0C\u8BF7\u5148\u4FDD\u5B58",
        confirmRemove: "\u786E\u5B9A\u8981\u5220\u9664\u6570\u636E\u6E90"
      }
    },
    eventscript: {
      name: "\u52A8\u4F5C\u9762\u677F",
      config: {
        title: "\u52A8\u4F5C\u8BBE\u7F6E",
        name: "\u65B9\u6CD5\u540D\u79F0",
        add: "\u6DFB\u52A0\u52A8\u4F5C\u65B9\u6CD5",
        save: "\u4FDD\u5B58",
        confirm: "\u786E\u5B9A",
        cancel: "\u53D6\u6D88",
        create: "\u65B0\u5EFA\u52A8\u4F5C",
        code: "\u7F16\u8F91\u4EE3\u7801",
        rules: "\u53EF\u89C6\u5316\u914D\u7F6E",
        js: "\u81EA\u5B9A\u4E49JS",
        notSave: "\u4E0D\u4FDD\u5B58"
      },
      message: {
        repeat: "\u65B9\u6CD5\u540D\u79F0\u4E0D\u80FD\u91CD\u590D",
        saveSuccess: "\u4FDD\u5B58\u6210\u529F",
        saveError: "\u5B58\u5728\u672A\u4FDD\u5B58\u7684\u6570\u636E\uFF0C\u8BF7\u5148\u4FDD\u5B58",
        confirmRemove: "\u786E\u5B9A\u8981\u5220\u9664\u8BE5\u65B9\u6CD5",
        saveConfirm: "\u662F\u5426\u8981\u4FDD\u5B58\u5F53\u524D\u4FEE\u6539\uFF1F\u5982\u679C\u4E0D\u4FDD\u5B58\uFF0C\u6570\u636E\u5C06\u4E22\u5931\uFF01"
      }
    },
    importjson: {
      name: "\u6A21\u677F\u5E93",
      noimage: "\u6682\u65E0\u9884\u89C8\u56FE",
      loadjson: "\u52A0\u8F7D\u6A21\u677F",
      nojson: "\u6682\u65E0\u6A21\u677F"
    },
    rules: {
      actions: {
        add: "\u6DFB\u52A0\u52A8\u4F5C",
        hide: "\u9690\u85CF\u8868\u5355\u5B57\u6BB5",
        display: "\u663E\u793A\u8868\u5355\u5B57\u6BB5",
        disabled: "\u8BBE\u7F6E\u8868\u5355\u5B57\u6BB5\u542F\u7528/\u7981\u7528",
        refresh: "\u91CD\u65B0\u52A0\u8F7D\u8868\u5355",
        reset: "\u91CD\u7F6E\u8868\u5355\u6570\u636E",
        setData: "\u8BBE\u7F6E\u8868\u5355\u6570\u636E",
        validate: "\u6821\u9A8C\u8868\u5355\u5B57\u6BB5",
        sendRequest: "\u53D1\u9001\u8BF7\u6C42",
        refreshFieldDataSource: "\u5237\u65B0\u8BF7\u6C42\u6570\u636E",
        getFieldDataSource: "\u83B7\u53D6\u5B57\u6BB5\u6570\u636E\u6E90\u6570\u636E",
        openDialog: "\u6253\u5F00\u5BF9\u8BDD\u6846",
        closeDialog: "\u5173\u95ED\u5BF9\u8BDD\u6846",
        triggerEvent: "\u8C03\u7528\u52A8\u4F5C\u65B9\u6CD5",
        js: "\u81EA\u5B9A\u4E49JS"
      },
      message: {
        confirmDelete: "\u786E\u5B9A\u8981\u5220\u9664\u8BE5\u52A8\u4F5C\u5417\uFF1F",
        editFx: "\u70B9\u51FB\u7F16\u8F91\u8868\u8FBE\u5F0F",
        condition: "\u6267\u884C\u6761\u4EF6\u8868\u8FBE\u5F0F"
      },
      label: {
        field: "\u76EE\u6807\u5B57\u6BB5",
        disabled: "\u7981\u7528",
        enabled: "\u542F\u7528",
        values: "\u6570\u636E\u8BBE\u7F6E",
        string: "\u5B57\u7B26\u4E32",
        number: "\u6570\u503C",
        boolean: "\u5E03\u5C14\u503C",
        fx: "\u8868\u8FBE\u5F0F",
        condition: "\u6267\u884C\u6761\u4EF6",
        datasource: "\u6570\u636E\u6E90",
        datasourceArgs: "\u6570\u636E\u6E90\u53C2\u6570",
        responseVariable: "\u8BF7\u6C42\u7ED3\u679C\u53D8\u91CF",
        localVariable: "\u7ED3\u679C\u53D8\u91CF",
        validateFail: "\u6821\u9A8C\u5931\u8D25",
        validateFailContinue: "\u7EE7\u7EED\u6267\u884C\u52A8\u4F5C",
        validateFailSuspend: "\u4E2D\u65AD\u6267\u884C\u52A8\u4F5C",
        functionName: "\u76EE\u6807\u65B9\u6CD5",
        functionParams: "\u65B9\u6CD5\u53C2\u6570"
      }
    },
    formula: {
      header: "\u8868\u8FBE\u5F0F =",
      field: "\u8868\u5355\u5B57\u6BB5",
      event: "\u53D8\u91CF",
      argsData: {
        name: "\u4E8B\u4EF6\u53C2\u6570",
        field: "\u5F53\u524D\u5B57\u6BB5\u6807\u8BC6",
        value: "\u5F53\u524D\u5B57\u6BB5\u7684\u503C",
        variable: "\u5185\u90E8\u53D8\u91CF"
      },
      input: {
        value: "\u9759\u6001\u503C",
        fx: "\u8868\u8FBE\u5F0F",
        fxPlaceholder: "\u70B9\u51FB\u7F16\u8F91\u8868\u8FBE\u5F0F",
        valuePlaceholder: "\u8BF7\u8F93\u5165"
      }
    }
  }
};
var iconfont = "";
var cover = "";
var index$1 = "";
var editor = "";
var scrollbar = "";
var vars = "";
var print = "";
const expire = 253402271999e3;
const version = "3.7.1";
const displayVersion = () => {
  // Function(`
  //   window.console && console.log('%cFormMaking %cV${version}  https://form.making.link', 'color: #1890ff;font-weight: 500;font-size: 20px;font-family: Source Sans Pro,Helvetica Neue,Arial,sans-serif;', 'color: #ccc;');
  // `)();
};
const loadLang = function(app, locale, i18n) {
  if (i18n) {
    i18n.global.setLocaleMessage("zh-cn", { ...i18n.global.getLocaleMessage("zh-cn"), ...zhCN });
    i18n.global.setLocaleMessage("en", { ...i18n.global.getLocaleMessage("en"), ...enUS });
    if (i18n.mode === "legacy") {
      i18n.global.locale = locale;
    } else {
      i18n.global.locale.value = locale;
    }
  } else {
    const i18n2 = createI18n({
      locale,
      fallbackLocale: locale,
      messages: {
        "en": enUS,
        "zh-cn": zhCN
      }
    });
    app.use(i18n2);
  }
};
const loadOptions = (opts) => {
  window.FormMaking_OPTIONS = {
    ...opts,
    aceurl: opts.aceurl || "https://form.making.link/public/lib/ace",
    key: "/#\u2014\u2014\u2014\u2014#/",
    version
  };
};
MakingForm.install = function(app, opts = {
  locale: "en"
}) {
  loadLang(app, opts.locale, opts.i18n);
  if (expire >= new Date().getTime()) {
    app.component(MakingForm.name, MakingForm);
  }
  displayVersion();
  loadOptions(opts);
  return app;
};
GenerateForm.install = function(app, opts = {
  locale: "en"
}) {
  loadLang(app, opts.locale, opts.i18n);
  if (expire >= new Date().getTime()) {
    app.component(GenerateForm.name, GenerateForm);
  }
  displayVersion();
  loadOptions(opts);
};
GenerateAntdForm.install = function(app, opts = {
  locale: "en"
}) {
  loadLang(app, opts.locale, opts.i18n);
  if (expire >= new Date().getTime()) {
    app.component(GenerateForm.name, GenerateForm);
  }
  displayVersion();
  loadOptions(opts);
};
const components = [
  MakingForm,
  GenerateForm,
  GenerateAntdForm
];
const install = function(app, opts = {
  locale: "en",
  i18n: null,
  components: []
}) {
  opts = {
    key: "/#\u2014\u2014\u2014\u2014#/",
    locale: "en",
    i18n: null,
    components: [],
    ...opts
  };
  loadLang(app, opts.locale, opts.i18n);
  if (expire >= new Date().getTime()) {
    components.forEach((component) => {
      app.component(component.name, component);
    });
    opts.components && opts.components.forEach((item) => {
      app.component(item.name, item.component);
    });
  }
  displayVersion();
  loadOptions(opts);
};
var index = {
  install,
  MakingForm,
  GenerateForm,
  GenerateAntdForm
};
export { GenerateAntdForm, GenerateForm, MakingForm, index as default, install };
